var c1 = {
  "chain": "ETH",
  "chainId": 1,
  "ens": {
    "registry": "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
  },
  "explorers": [{
    "name": "etherscan",
    "url": "https://etherscan.io",
    "standard": "EIP3091"
  }, {
    "name": "blockscout",
    "url": "https://eth.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }, {
    "name": "dexguru",
    "url": "https://ethereum.dex.guru",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne",
      "width": 83,
      "height": 82,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/ethereum/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://ethereum.org",
  "name": "Ethereum Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1,
  "redFlags": [],
  "rpc": ["https://1.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.infura.io/v3/${INFURA_API_KEY}", "wss://mainnet.infura.io/ws/v3/${INFURA_API_KEY}", "https://eth-mainnet.g.alchemy.com/v2/${ALCHEMY_API_KEY}", "https://api.mycryptoapi.com/eth", "https://cloudflare-eth.com", "https://ethereum-rpc.publicnode.com", "wss://ethereum-rpc.publicnode.com", "https://mainnet.gateway.tenderly.co", "wss://mainnet.gateway.tenderly.co", "https://rpc.blocknative.com/boost", "https://rpc.flashbots.net", "https://rpc.flashbots.net/fast", "https://rpc.mevblocker.io", "https://rpc.mevblocker.io/fast", "https://rpc.mevblocker.io/noreverts", "https://rpc.mevblocker.io/fullprivacy", "https://eth.drpc.org", "wss://eth.drpc.org"],
  "shortName": "eth",
  "slip44": 60,
  "slug": "ethereum",
  "testnet": false
};

var c2 = {
  "chain": "EXP",
  "chainId": 2,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://expanse.tech",
  "name": "Expanse Network",
  "nativeCurrency": {
    "name": "Expanse Network Ether",
    "symbol": "EXP",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://2.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node.expanse.tech"],
  "shortName": "exp",
  "slip44": 40,
  "slug": "expanse-network",
  "testnet": false
};

var c3 = {
  "chain": "ETH",
  "chainId": 3,
  "ens": {
    "registry": "0x112234455c3a32fd11230c42e7bccd4a84e02010"
  },
  "explorers": [{
    "name": "etherscan",
    "url": "https://ropsten.etherscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["http://fauceth.komputing.org?chain=3&address=${ADDRESS}", "https://faucet.ropsten.be?${ADDRESS}"],
  "features": [],
  "infoURL": "https://github.com/ethereum/ropsten",
  "name": "Ropsten",
  "nativeCurrency": {
    "name": "Ropsten Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 3,
  "redFlags": [],
  "rpc": ["https://3.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://ropsten.infura.io/v3/${INFURA_API_KEY}", "wss://ropsten.infura.io/ws/v3/${INFURA_API_KEY}"],
  "shortName": "rop",
  "slip44": 1,
  "slug": "ropsten",
  "status": "deprecated",
  "testnet": false,
  "title": "Ethereum Testnet Ropsten"
};

var c4 = {
  "chain": "ETH",
  "chainId": 4,
  "ens": {
    "registry": "0xe7410170f87102df0055eb195163a03b7f2bff4a"
  },
  "explorers": [{
    "name": "etherscan-rinkeby",
    "url": "https://rinkeby.etherscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["http://fauceth.komputing.org?chain=4&address=${ADDRESS}", "https://faucet.rinkeby.io"],
  "features": [],
  "infoURL": "https://www.rinkeby.io",
  "name": "Rinkeby",
  "nativeCurrency": {
    "name": "Rinkeby Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 4,
  "redFlags": [],
  "rpc": ["https://4.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rinkeby.infura.io/v3/${INFURA_API_KEY}", "wss://rinkeby.infura.io/ws/v3/${INFURA_API_KEY}"],
  "shortName": "rin",
  "slip44": 1,
  "slug": "rinkeby",
  "status": "deprecated",
  "testnet": true,
  "title": "Ethereum Testnet Rinkeby"
};

var c5 = {
  "chain": "ETH",
  "chainId": 5,
  "ens": {
    "registry": "0x112234455c3a32fd11230c42e7bccd4a84e02010"
  },
  "explorers": [{
    "name": "etherscan-goerli",
    "url": "https://goerli.etherscan.io",
    "standard": "EIP3091"
  }, {
    "name": "blockscout-goerli",
    "url": "https://eth-goerli.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": ["http://fauceth.komputing.org?chain=5&address=${ADDRESS}", "https://goerli-faucet.slock.it?address=${ADDRESS}", "https://faucet.goerli.mudit.blog"],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/ethereum/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://goerli.net/#about",
  "name": "Goerli",
  "nativeCurrency": {
    "name": "Goerli Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 5,
  "redFlags": [],
  "rpc": ["https://5.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://goerli.infura.io/v3/${INFURA_API_KEY}", "wss://goerli.infura.io/v3/${INFURA_API_KEY}", "https://rpc.goerli.mudit.blog/", "https://ethereum-goerli-rpc.publicnode.com", "wss://ethereum-goerli-rpc.publicnode.com", "https://goerli.gateway.tenderly.co", "wss://goerli.gateway.tenderly.co"],
  "shortName": "gor",
  "slip44": 1,
  "slug": "goerli",
  "status": "deprecated",
  "testnet": true,
  "title": "Ethereum Testnet Goerli"
};

var c6 = {
  "chain": "ETC",
  "chainId": 6,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmawMDPsaj3kBTZErCYQ3tshv5RrMAN3smWNs72m943Fyj",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://ethereumclassic.org/development/testnets",
  "name": "Kotti Testnet",
  "nativeCurrency": {
    "name": "Kotti Ether",
    "symbol": "KOT",
    "decimals": 18
  },
  "networkId": 6,
  "rpc": [],
  "shortName": "kot",
  "slip44": 1,
  "slug": "kotti-testnet",
  "status": "deprecated",
  "testnet": true,
  "title": "Ethereum Classic Kotti Testnet"
};

var c7 = {
  "chain": "TCH",
  "chainId": 7,
  "explorers": [{
    "name": "Thaichain Explorer",
    "url": "https://exp.thaichain.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://thaichain.io",
  "name": "ThaiChain",
  "nativeCurrency": {
    "name": "ThaiChain Ether",
    "symbol": "TCH",
    "decimals": 18
  },
  "networkId": 7,
  "rpc": ["https://7.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.dome.cloud", "https://rpc.thaichain.org"],
  "shortName": "tch",
  "slug": "thaichain",
  "testnet": false
};

var c8 = {
  "chain": "UBQ",
  "chainId": 8,
  "explorers": [{
    "name": "ubiqscan",
    "url": "https://ubiqscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://ubiqsmart.com",
  "name": "Ubiq",
  "nativeCurrency": {
    "name": "Ubiq Ether",
    "symbol": "UBQ",
    "decimals": 18
  },
  "networkId": 8,
  "rpc": ["https://8.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.octano.dev", "https://pyrus2.ubiqscan.io"],
  "shortName": "ubq",
  "slip44": 108,
  "slug": "ubiq",
  "testnet": false
};

var c9 = {
  "chain": "UBQ",
  "chainId": 9,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://ethersocial.org",
  "name": "Ubiq Network Testnet",
  "nativeCurrency": {
    "name": "Ubiq Testnet Ether",
    "symbol": "TUBQ",
    "decimals": 18
  },
  "networkId": 2,
  "rpc": [],
  "shortName": "tubq",
  "slip44": 1,
  "slug": "ubiq-network-testnet",
  "testnet": true
};

var c10 = {
  "chain": "ETH",
  "chainId": 10,
  "explorers": [{
    "name": "etherscan",
    "url": "https://optimistic.etherscan.io",
    "standard": "EIP3091"
  }, {
    "name": "blockscout",
    "url": "https://optimism.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }, {
    "name": "dexguru",
    "url": "https://optimism.dex.guru",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne",
      "width": 83,
      "height": 82,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/optimism/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://optimism.io",
  "name": "OP Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 10,
  "redFlags": [],
  "rpc": ["https://10.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://optimism-mainnet.infura.io/v3/${INFURA_API_KEY}", "https://mainnet.optimism.io", "https://optimism.publicnode.com", "wss://optimism.publicnode.com", "https://optimism.gateway.tenderly.co", "wss://optimism.gateway.tenderly.co", "https://optimism-rpc.publicnode.com", "wss://optimism-rpc.publicnode.com", "https://optimism.drpc.org", "wss://optimism.drpc.org"],
  "shortName": "oeth",
  "slug": "optimism",
  "testnet": false
};

var c11 = {
  "chain": "META",
  "chainId": 11,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://metadium.com",
  "name": "Metadium Mainnet",
  "nativeCurrency": {
    "name": "Metadium Mainnet Ether",
    "symbol": "META",
    "decimals": 18
  },
  "networkId": 11,
  "rpc": ["https://11.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.metadium.com/prod"],
  "shortName": "meta",
  "slip44": 916,
  "slug": "metadium",
  "testnet": false
};

var c12 = {
  "chain": "META",
  "chainId": 12,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://metadium.com",
  "name": "Metadium Testnet",
  "nativeCurrency": {
    "name": "Metadium Testnet Ether",
    "symbol": "KAL",
    "decimals": 18
  },
  "networkId": 12,
  "rpc": ["https://12.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.metadium.com/dev"],
  "shortName": "kal",
  "slip44": 1,
  "slug": "metadium-testnet",
  "testnet": true
};

var c13 = {
  "chain": "DIODE",
  "chainId": 13,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://diode.io/staging",
  "name": "Diode Testnet Staging",
  "nativeCurrency": {
    "name": "Staging Diodes",
    "symbol": "sDIODE",
    "decimals": 18
  },
  "networkId": 13,
  "rpc": ["https://13.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://staging.diode.io:8443/", "wss://staging.diode.io:8443/ws"],
  "shortName": "dstg",
  "slip44": 1,
  "slug": "diode-testnet-staging",
  "testnet": true
};

var c14 = {
  "chain": "FLR",
  "chainId": 14,
  "explorers": [{
    "name": "blockscout",
    "url": "https://flare-explorer.flare.network",
    "standard": "EIP3091"
  }, {
    "name": "flarescan",
    "url": "https://mainnet.flarescan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmbT52cCx4h1rcz6nXGfUPFdRyw1VfFMU8kKpY7YCtvUjs",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://flare.network",
  "name": "Flare Mainnet",
  "nativeCurrency": {
    "name": "Flare",
    "symbol": "FLR",
    "decimals": 18
  },
  "networkId": 14,
  "rpc": ["https://14.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://flare-api.flare.network/ext/C/rpc", "https://flare-bundler.etherspot.io", "https://rpc.ankr.com/flare", "https://01-gravelines-003-01.rpc.tatum.io/ext/bc/C/rpc", "https://01-vinthill-003-02.rpc.tatum.io/ext/bc/C/rpc", "https://rpc.ftso.au/flare", "https://flare.enosys.global/ext/C/rpc", "https://flare.solidifi.app/ext/C/rpc"],
  "shortName": "flr",
  "slug": "flare",
  "testnet": false
};

var c15 = {
  "chain": "DIODE",
  "chainId": 15,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://diode.io/prenet",
  "name": "Diode Prenet",
  "nativeCurrency": {
    "name": "Diodes",
    "symbol": "DIODE",
    "decimals": 18
  },
  "networkId": 15,
  "rpc": ["https://15.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://prenet.diode.io:8443/", "wss://prenet.diode.io:8443/ws"],
  "shortName": "diode",
  "slug": "diode-prenet",
  "testnet": false
};

var c16 = {
  "chain": "SGB",
  "chainId": 16,
  "explorers": [{
    "name": "blockscout",
    "url": "https://coston-explorer.flare.network",
    "standard": "EIP3091"
  }, {
    "name": "flarescan",
    "url": "https://coston.testnet.flarescan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.flare.network"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmV5PVhxaT3ePRHYsH3aryEHin2c49W18xW3Xg4o171iYE",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://flare.network",
  "name": "Songbird Testnet Coston",
  "nativeCurrency": {
    "name": "Coston Flare",
    "symbol": "CFLR",
    "decimals": 18
  },
  "networkId": 16,
  "rpc": ["https://16.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://coston-api.flare.network/ext/C/rpc", "https://01-gravelines-004-01.rpc.tatum.io/ext/bc/C/rpc", "https://02-chicago-004-02.rpc.tatum.io/ext/bc/C/rpc", "https://02-tokyo-004-03.rpc.tatum.io/ext/bc/C/rpc", "https://coston.enosys.global/ext/C/rpc"],
  "shortName": "cflr",
  "slip44": 1,
  "slug": "songbird-testnet-coston",
  "testnet": true
};

var c17 = {
  "chain": "TCH",
  "chainId": 17,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://exp.thaifi.com",
  "name": "ThaiChain 2.0 ThaiFi",
  "nativeCurrency": {
    "name": "Thaifi Ether",
    "symbol": "TFI",
    "decimals": 18
  },
  "networkId": 17,
  "rpc": ["https://17.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.thaifi.com"],
  "shortName": "tfi",
  "slug": "thaichain-2-0-thaifi",
  "testnet": false
};

var c18 = {
  "chain": "TST",
  "chainId": 18,
  "explorers": [{
    "name": "thundercore-blockscout-testnet",
    "url": "https://explorer-testnet.thundercore.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet-testnet.thundercore.com"],
  "infoURL": "https://thundercore.com",
  "name": "ThunderCore Testnet",
  "nativeCurrency": {
    "name": "ThunderCore Testnet Token",
    "symbol": "TST",
    "decimals": 18
  },
  "networkId": 18,
  "rpc": ["https://18.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.thundercore.com", "https://thundercore-testnet.drpc.org", "wss://thundercore-testnet.drpc.org"],
  "shortName": "TST",
  "slip44": 1,
  "slug": "thundercore-testnet",
  "testnet": true
};

var c19 = {
  "chain": "SGB",
  "chainId": 19,
  "explorers": [{
    "name": "blockscout",
    "url": "https://songbird-explorer.flare.network",
    "standard": "EIP3091"
  }, {
    "name": "flarescan",
    "url": "https://songbird.flarescan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmdpaH9pEFDXB4tUPxcqAHfB3Sfx3BQufz6EAzBWhHH6Ka",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://flare.network",
  "name": "Songbird Canary-Network",
  "nativeCurrency": {
    "name": "Songbird",
    "symbol": "SGB",
    "decimals": 18
  },
  "networkId": 19,
  "rpc": ["https://19.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://songbird-api.flare.network/ext/C/rpc", "https://01-gravelines-006-01.rpc.tatum.io/ext/bc/C/rpc", "https://01-vinthill-006-02.rpc.tatum.io/ext/bc/C/rpc", "https://02-tokyo-006-03.rpc.tatum.io/ext/bc/C/rpc", "https://rpc.ftso.au/songbird", "https://songbird.enosys.global/ext/C/rpc", "https://songbird.solidifi.app/ext/C/rpc"],
  "shortName": "sgb",
  "slug": "songbird-canary-network",
  "testnet": false
};

var c20 = {
  "chain": "ETH",
  "chainId": 20,
  "explorers": [{
    "name": "elastos esc explorer",
    "url": "https://esc.elastos.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.elastos.org/",
  "name": "Elastos Smart Chain",
  "nativeCurrency": {
    "name": "Elastos",
    "symbol": "ELA",
    "decimals": 18
  },
  "networkId": 20,
  "rpc": ["https://20.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.elastos.io/eth"],
  "shortName": "esc",
  "slug": "elastos-smart-chain",
  "testnet": false
};

var c21 = {
  "chain": "ETH",
  "chainId": 21,
  "explorers": [{
    "name": "elastos esc explorer",
    "url": "https://esc-testnet.elastos.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://esc-faucet.elastos.io/"],
  "infoURL": "https://www.elastos.org/",
  "name": "Elastos Smart Chain Testnet",
  "nativeCurrency": {
    "name": "Elastos",
    "symbol": "tELA",
    "decimals": 18
  },
  "networkId": 21,
  "rpc": ["https://21.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api-testnet.elastos.io/eth"],
  "shortName": "esct",
  "slug": "elastos-smart-chain-testnet",
  "testnet": true
};

var c22 = {
  "chain": "ETH",
  "chainId": 22,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.elastos.org/",
  "name": "ELA-DID-Sidechain Mainnet",
  "nativeCurrency": {
    "name": "Elastos",
    "symbol": "ELA",
    "decimals": 18
  },
  "networkId": 22,
  "rpc": [],
  "shortName": "eladid",
  "slug": "ela-did-sidechain",
  "testnet": false
};

var c23 = {
  "chain": "ETH",
  "chainId": 23,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://elaeth.io/",
  "name": "ELA-DID-Sidechain Testnet",
  "nativeCurrency": {
    "name": "Elastos",
    "symbol": "tELA",
    "decimals": 18
  },
  "networkId": 23,
  "rpc": [],
  "shortName": "eladidt",
  "slip44": 1,
  "slug": "ela-did-sidechain-testnet",
  "testnet": true
};

var c24 = {
  "chain": "KAI",
  "chainId": 24,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmXoHaZXJevc59GuzEgBhwRSH6kio1agMRvL8bD93pARRV",
    "width": 297,
    "height": 297,
    "format": "png"
  },
  "infoURL": "https://kardiachain.io",
  "name": "KardiaChain Mainnet",
  "nativeCurrency": {
    "name": "KardiaChain",
    "symbol": "KAI",
    "decimals": 18
  },
  "networkId": 0,
  "redFlags": ["reusedChainId"],
  "rpc": ["https://24.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.kardiachain.io"],
  "shortName": "kardiachain",
  "slug": "kardiachain",
  "testnet": false
};

var c25 = {
  "chain": "CRO",
  "chainId": 25,
  "explorers": [{
    "name": "Cronos Explorer",
    "url": "https://explorer.cronos.org",
    "standard": "none"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "infoURL": "https://cronos.org/",
  "name": "Cronos Mainnet",
  "nativeCurrency": {
    "name": "Cronos",
    "symbol": "CRO",
    "decimals": 18
  },
  "networkId": 25,
  "rpc": ["https://25.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm.cronos.org", "https://cronos-evm-rpc.publicnode.com", "wss://cronos-evm-rpc.publicnode.com", "https://cronos.drpc.org", "wss://cronos.drpc.org"],
  "shortName": "cro",
  "slug": "cronos",
  "testnet": false
};

var c26 = {
  "chain": "genesis",
  "chainId": 26,
  "explorers": [{
    "name": "Genesis L1 testnet explorer",
    "url": "https://testnet.genesisl1.org",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.genesisl1.com",
  "name": "Genesis L1 testnet",
  "nativeCurrency": {
    "name": "L1 testcoin",
    "symbol": "L1test",
    "decimals": 18
  },
  "networkId": 26,
  "rpc": ["https://26.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testrpc.genesisl1.org"],
  "shortName": "L1test",
  "slip44": 1,
  "slug": "genesis-l1-testnet",
  "testnet": true
};

var c27 = {
  "chain": "SHIB",
  "chainId": 27,
  "explorers": [{
    "name": "Shiba Explorer",
    "url": "https://exp.shibchain.org",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://shibchain.org",
  "name": "ShibaChain",
  "nativeCurrency": {
    "name": "SHIBA INU COIN",
    "symbol": "SHIB",
    "decimals": 18
  },
  "networkId": 27,
  "rpc": ["https://27.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.shibchain.org"],
  "shortName": "shib",
  "slug": "shibachain",
  "testnet": false
};

var c28 = {
  "chain": "ETH",
  "chainId": 28,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://blockexplorer.rinkeby.boba.network",
    "standard": "none"
  }],
  "faucets": [],
  "features": [],
  "infoURL": "https://boba.network",
  "name": "Boba Network Rinkeby Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 28,
  "parent": {
    "type": "L2",
    "chain": "eip155-4",
    "bridges": [{
      "url": "https://gateway.rinkeby.boba.network"
    }]
  },
  "redFlags": [],
  "rpc": ["https://28.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rinkeby.boba.network/"],
  "shortName": "BobaRinkeby",
  "slip44": 1,
  "slug": "boba-network-rinkeby-testnet",
  "status": "deprecated",
  "testnet": true
};

var c29 = {
  "chain": "genesis",
  "chainId": 29,
  "explorers": [{
    "name": "Genesis L1 blockchain explorer",
    "url": "https://explorer.genesisl1.org",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.genesisl1.com",
  "name": "Genesis L1",
  "nativeCurrency": {
    "name": "L1 coin",
    "symbol": "L1",
    "decimals": 18
  },
  "networkId": 29,
  "rpc": ["https://29.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.genesisl1.org"],
  "shortName": "L1",
  "slug": "genesis-l1",
  "testnet": false
};

var c30 = {
  "chain": "Rootstock",
  "chainId": 30,
  "explorers": [{
    "name": "blockscout",
    "url": "https://rootstock.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }, {
    "name": "Rootstock Explorer",
    "url": "https://explorer.rsk.co",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreigidzbf22dnpmmlfxv6u7oifq6ln33j4n57ox4ipiproalufrheym",
    "width": 3000,
    "height": 3325,
    "format": "png"
  },
  "infoURL": "https://rootstock.io",
  "name": "Rootstock Mainnet",
  "nativeCurrency": {
    "name": "Smart Bitcoin",
    "symbol": "RBTC",
    "decimals": 18
  },
  "networkId": 30,
  "rpc": ["https://30.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://public-node.rsk.co", "https://mycrypto.rsk.co"],
  "shortName": "rsk",
  "slip44": 137,
  "slug": "rootstock",
  "testnet": false
};

var c31 = {
  "chain": "Rootstock",
  "chainId": 31,
  "explorers": [{
    "name": "RSK Testnet Explorer",
    "url": "https://explorer.testnet.rsk.co",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.rsk.co/"],
  "icon": {
    "url": "ipfs://bafkreigidzbf22dnpmmlfxv6u7oifq6ln33j4n57ox4ipiproalufrheym",
    "width": 3000,
    "height": 3325,
    "format": "png"
  },
  "infoURL": "https://rootstock.io",
  "name": "Rootstock Testnet",
  "nativeCurrency": {
    "name": "Testnet Smart Bitcoin",
    "symbol": "tRBTC",
    "decimals": 18
  },
  "networkId": 31,
  "rpc": ["https://31.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://public-node.testnet.rsk.co", "https://mycrypto.testnet.rsk.co"],
  "shortName": "trsk",
  "slip44": 1,
  "slug": "rootstock-testnet",
  "testnet": true
};

var c32 = {
  "chain": "GooD",
  "chainId": 32,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.goodata.org",
  "name": "GoodData Testnet",
  "nativeCurrency": {
    "name": "GoodData Testnet Ether",
    "symbol": "GooD",
    "decimals": 18
  },
  "networkId": 32,
  "rpc": ["https://32.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://test2.goodata.io"],
  "shortName": "GooDT",
  "slip44": 1,
  "slug": "gooddata-testnet",
  "testnet": true
};

var c33 = {
  "chain": "GooD",
  "chainId": 33,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.goodata.org",
  "name": "GoodData Mainnet",
  "nativeCurrency": {
    "name": "GoodData Mainnet Ether",
    "symbol": "GooD",
    "decimals": 18
  },
  "networkId": 33,
  "rpc": ["https://33.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.goodata.io"],
  "shortName": "GooD",
  "slug": "gooddata",
  "testnet": false
};

var c34 = {
  "chain": "SCAI",
  "chainId": 34,
  "explorers": [{
    "name": "SecureChain Mainnet",
    "url": "https://explorer.securechain.ai",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qme2Z8VFYjhHGfLQPBnfseNpEdRfmTDy7VXqrdH4AHETJf",
    "width": 150,
    "height": 150,
    "format": "png"
  },
  "infoURL": "https://securechain.ai",
  "name": "SecureChain Mainnet",
  "nativeCurrency": {
    "name": "SecureChain",
    "symbol": "SCAI",
    "decimals": 18
  },
  "networkId": 34,
  "redFlags": ["reusedChainId"],
  "rpc": ["https://34.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.scai.network"],
  "shortName": "scai",
  "slug": "securechain",
  "testnet": false
};

var c35 = {
  "chain": "TBWG",
  "chainId": 35,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://tbwg.io",
  "name": "TBWG Chain",
  "nativeCurrency": {
    "name": "TBWG Ether",
    "symbol": "TBG",
    "decimals": 18
  },
  "networkId": 35,
  "rpc": ["https://35.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.tbwg.io"],
  "shortName": "tbwg",
  "slug": "tbwg-chain",
  "testnet": false
};

var c36 = {
  "chain": "Dxchain",
  "chainId": 36,
  "explorers": [{
    "name": "dxscan",
    "url": "https://dxscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYBup5bWoBfkaHntbcgW8Ji7ncad7f53deJ4Q55z4PNQs",
    "width": 128,
    "height": 128,
    "format": "png"
  },
  "infoURL": "https://www.dxchain.com/",
  "name": "Dxchain Mainnet",
  "nativeCurrency": {
    "name": "Dxchain",
    "symbol": "DX",
    "decimals": 18
  },
  "networkId": 36,
  "rpc": ["https://36.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.dxchain.com"],
  "shortName": "dx",
  "slug": "dxchain",
  "testnet": false
};

var c37 = {
  "chain": "XPLA",
  "chainId": 37,
  "explorers": [{
    "name": "XPLA Explorer",
    "url": "https://explorer.xpla.io/mainnet",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmf4GoxfpeA5VGqu7KP5eyv1WKaCpNDbvMxq1MjQBwFWxq",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://xpla.io",
  "name": "Xpla Mainnet",
  "nativeCurrency": {
    "name": "XPLA",
    "symbol": "XPLA",
    "decimals": 18
  },
  "networkId": 37,
  "redFlags": ["reusedChainId"],
  "rpc": ["https://37.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dimension-evm-rpc.xpla.dev"],
  "shortName": "xpla",
  "slug": "xpla",
  "testnet": false
};

var c38 = {
  "chain": "VAL",
  "chainId": 38,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://valorbit.com",
  "name": "Valorbit",
  "nativeCurrency": {
    "name": "Valorbit",
    "symbol": "VAL",
    "decimals": 18
  },
  "networkId": 38,
  "rpc": ["https://38.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.valorbit.com/v2"],
  "shortName": "val",
  "slip44": 538,
  "slug": "valorbit",
  "testnet": false
};

var c39 = {
  "chain": "u2u",
  "chainId": 39,
  "explorers": [{
    "name": "U2U Explorer",
    "url": "https://u2uscan.xyz",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmcW64RgqQVHnNbVFyfaMNKt7dJvFqEbfEHZmeyeK8dpEa",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmcW64RgqQVHnNbVFyfaMNKt7dJvFqEbfEHZmeyeK8dpEa",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://uniultra.xyz",
  "name": "U2U Solaris Mainnet",
  "nativeCurrency": {
    "name": "Unicorn Ultra",
    "symbol": "U2U",
    "decimals": 18
  },
  "networkId": 39,
  "rpc": ["https://39.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mainnet.uniultra.xyz"],
  "shortName": "u2u",
  "slug": "u2u-solaris",
  "testnet": false
};

var c40 = {
  "chain": "TLOS",
  "chainId": 40,
  "explorers": [{
    "name": "teloscan",
    "url": "https://teloscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmdkgQDtDedsNNth3ZVgWfwRZPCePLA13MtLvV4CEYSuTR/TLOS.png",
    "width": 228,
    "height": 228,
    "format": "png"
  },
  "infoURL": "https://telos.net",
  "name": "Telos EVM Mainnet",
  "nativeCurrency": {
    "name": "Telos",
    "symbol": "TLOS",
    "decimals": 18
  },
  "networkId": 40,
  "redFlags": [],
  "rpc": ["https://40.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.telos.net/evm", "https://telos.drpc.org", "wss://telos.drpc.org"],
  "shortName": "TelosEVM",
  "slug": "telos-evm",
  "testnet": false
};

var c41 = {
  "chain": "TLOS",
  "chainId": 41,
  "explorers": [{
    "name": "teloscan",
    "url": "https://testnet.teloscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://app.telos.net/testnet/developers"],
  "features": [],
  "icon": {
    "url": "ipfs://QmdkgQDtDedsNNth3ZVgWfwRZPCePLA13MtLvV4CEYSuTR/TLOS.png",
    "width": 228,
    "height": 228,
    "format": "png"
  },
  "infoURL": "https://telos.net",
  "name": "Telos EVM Testnet",
  "nativeCurrency": {
    "name": "Telos",
    "symbol": "TLOS",
    "decimals": 18
  },
  "networkId": 41,
  "redFlags": [],
  "rpc": ["https://41.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.telos.net/evm", "https://telos-testnet.drpc.org", "wss://telos-testnet.drpc.org"],
  "shortName": "TelosEVMTestnet",
  "slip44": 1,
  "slug": "telos-evm-testnet",
  "testnet": true
};

var c42 = {
  "chain": "LUKSO",
  "chainId": 42,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://explorer.execution.mainnet.lukso.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://Qmeg9sFF5tAGi6MCx7YjtVHW6a23zqvHRK1xwzSdp9iE7z",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://lukso.network",
  "name": "LUKSO Mainnet",
  "nativeCurrency": {
    "name": "LUKSO",
    "symbol": "LYX",
    "decimals": 18
  },
  "networkId": 42,
  "redFlags": ["reusedChainId"],
  "rpc": ["https://42.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.mainnet.lukso.network", "wss://ws-rpc.mainnet.lukso.network"],
  "shortName": "lukso",
  "slug": "lukso",
  "testnet": false
};

var c43 = {
  "chain": "pangolin",
  "chainId": 43,
  "explorers": [{
    "name": "subscan",
    "url": "https://pangolin.subscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://docs.darwinia.network/pangolin-testnet-1e9ac8b09e874e8abd6a7f18c096ca6a"],
  "infoURL": "https://darwinia.network/",
  "name": "Darwinia Pangolin Testnet",
  "nativeCurrency": {
    "name": "Pangolin Network Native Token",
    "symbol": "PRING",
    "decimals": 18
  },
  "networkId": 43,
  "rpc": ["https://43.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://pangolin-rpc.darwinia.network"],
  "shortName": "pangolin",
  "slip44": 1,
  "slug": "darwinia-pangolin-testnet",
  "testnet": true
};

var c44 = {
  "chain": "crab",
  "chainId": 44,
  "explorers": [{
    "name": "subscan",
    "url": "https://crab.subscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://crab.network/",
  "name": "Crab Network",
  "nativeCurrency": {
    "name": "Crab Network Native Token",
    "symbol": "CRAB",
    "decimals": 18
  },
  "networkId": 44,
  "rpc": ["https://44.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://crab-rpc.darwinia.network", "https://crab-rpc.darwiniacommunitydao.xyz"],
  "shortName": "crab",
  "slug": "crab-network",
  "testnet": false
};

var c45 = {
  "chain": "pangoro",
  "chainId": 45,
  "explorers": [{
    "name": "subscan",
    "url": "https://pangoro.subscan.io",
    "standard": "none"
  }],
  "faucets": ["https://docs.darwinia.network/pangoro-testnet-70cfec5dc9ca42759959ba3803edaec2"],
  "infoURL": "https://darwinia.network/",
  "name": "Darwinia Pangoro Testnet",
  "nativeCurrency": {
    "name": "Pangoro Network Native Token",
    "symbol": "ORING",
    "decimals": 18
  },
  "networkId": 45,
  "rpc": ["https://45.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://pangoro-rpc.darwinia.network"],
  "shortName": "pangoro",
  "slip44": 1,
  "slug": "darwinia-pangoro-testnet",
  "testnet": true
};

var c46 = {
  "chain": "darwinia",
  "chainId": 46,
  "explorers": [{
    "name": "subscan",
    "url": "https://darwinia.subscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://darwinia.network/",
  "name": "Darwinia Network",
  "nativeCurrency": {
    "name": "Darwinia Network Native Token",
    "symbol": "RING",
    "decimals": 18
  },
  "networkId": 46,
  "rpc": ["https://46.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.darwinia.network", "https://darwinia-rpc.darwiniacommunitydao.xyz", "https://darwinia-rpc.dwellir.com"],
  "shortName": "darwinia",
  "slug": "darwinia-network",
  "testnet": false
};

var c47 = {
  "chain": "XPLA",
  "chainId": 47,
  "explorers": [{
    "name": "XPLA Explorer",
    "url": "https://explorer.xpla.io/testnet",
    "standard": "none"
  }],
  "faucets": ["https://faucet.xpla.io/"],
  "features": [],
  "icon": {
    "url": "ipfs://QmbvEAKZfgJckEziU3mpCwz6jqMeWRcLgd8TNsWA7g8sD9/xpla.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://xpla.io/",
  "name": "Xpla Testnet",
  "nativeCurrency": {
    "name": "XPLA",
    "symbol": "XPLA",
    "decimals": 18
  },
  "networkId": 47,
  "redFlags": ["reusedChainId"],
  "rpc": ["https://47.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://cube-evm-rpc.xpla.dev"],
  "shortName": "xpla-test",
  "slug": "xpla-testnet",
  "testnet": true
};

var c48 = {
  "chain": "ETMP",
  "chainId": 48,
  "explorers": [{
    "name": "etmpscan",
    "url": "https://etmscan.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmT7DTqT1V2y42pRpt3sj9ifijfmbtkHN7D2vTfAUAS622",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmT7DTqT1V2y42pRpt3sj9ifijfmbtkHN7D2vTfAUAS622",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://etm.network",
  "name": "Ennothem Mainnet Proterozoic",
  "nativeCurrency": {
    "name": "Ennothem",
    "symbol": "ETMP",
    "decimals": 18
  },
  "networkId": 48,
  "rpc": ["https://48.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.etm.network"],
  "shortName": "etmp",
  "slug": "ennothem-proterozoic",
  "testnet": false
};

var c49 = {
  "chain": "ETMP",
  "chainId": 49,
  "explorers": [{
    "name": "etmp",
    "url": "https://pioneer.etmscan.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmT7DTqT1V2y42pRpt3sj9ifijfmbtkHN7D2vTfAUAS622",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://etm.network",
  "name": "Ennothem Testnet Pioneer",
  "nativeCurrency": {
    "name": "Ennothem",
    "symbol": "ETMP",
    "decimals": 18
  },
  "networkId": 49,
  "rpc": ["https://49.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.pioneer.etm.network"],
  "shortName": "etmpTest",
  "slip44": 1,
  "slug": "ennothem-testnet-pioneer",
  "testnet": true
};

var c50 = {
  "chain": "XDC",
  "chainId": 50,
  "explorers": [{
    "name": "xdcscan",
    "url": "https://xdcscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmPzVFs16GwaD8LAcGFLCNXzEK8BHFKNXeM3nmBpnq9xy3",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }, {
    "name": "blocksscan",
    "url": "https://xdc.blocksscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmPzVFs16GwaD8LAcGFLCNXzEK8BHFKNXeM3nmBpnq9xy3",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeRq7pabiJE2n1xU3Y5Mb4TZSX9kQ74x7a3P2Z4PqcMRX",
    "width": 1450,
    "height": 1450,
    "format": "png"
  },
  "infoURL": "https://xinfin.org",
  "name": "XDC Network",
  "nativeCurrency": {
    "name": "XinFin",
    "symbol": "XDC",
    "decimals": 18
  },
  "networkId": 50,
  "rpc": ["https://50.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://erpc.xinfin.network", "https://rpc.xinfin.network", "https://rpc1.xinfin.network", "https://rpc-xdc.icecreamswap.com"],
  "shortName": "xdc",
  "slug": "xdc-network",
  "testnet": false
};

var c51 = {
  "chain": "XDC",
  "chainId": 51,
  "explorers": [{
    "name": "xdcscan",
    "url": "https://apothem.xinfinscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmPzVFs16GwaD8LAcGFLCNXzEK8BHFKNXeM3nmBpnq9xy3",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }, {
    "name": "blocksscan",
    "url": "https://apothem.blocksscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmPzVFs16GwaD8LAcGFLCNXzEK8BHFKNXeM3nmBpnq9xy3",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.apothem.network"],
  "features": [],
  "icon": {
    "url": "ipfs://QmeRq7pabiJE2n1xU3Y5Mb4TZSX9kQ74x7a3P2Z4PqcMRX",
    "width": 1450,
    "height": 1450,
    "format": "png"
  },
  "infoURL": "https://xinfin.org",
  "name": "XDC Apothem Network",
  "nativeCurrency": {
    "name": "XinFin",
    "symbol": "TXDC",
    "decimals": 18
  },
  "networkId": 51,
  "redFlags": [],
  "rpc": ["https://51.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://apothem.xdcrpc.com", "https://rpc.apothem.network", "https://erpc.apothem.network"],
  "shortName": "txdc",
  "slug": "xdc-apothem-network",
  "testnet": false
};

var c52 = {
  "chain": "CSC",
  "chainId": 52,
  "explorers": [{
    "name": "coinexscan",
    "url": "https://www.coinex.net",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.coinex.org/",
  "name": "CoinEx Smart Chain Mainnet",
  "nativeCurrency": {
    "name": "CoinEx Chain Native Token",
    "symbol": "cet",
    "decimals": 18
  },
  "networkId": 52,
  "rpc": ["https://52.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.coinex.net"],
  "shortName": "cet",
  "slug": "coinex-smart-chain",
  "testnet": false
};

var c53 = {
  "chain": "CSC",
  "chainId": 53,
  "explorers": [{
    "name": "coinexscan",
    "url": "https://testnet.coinex.net",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.coinex.org/",
  "name": "CoinEx Smart Chain Testnet",
  "nativeCurrency": {
    "name": "CoinEx Chain Test Native Token",
    "symbol": "cett",
    "decimals": 18
  },
  "networkId": 53,
  "rpc": ["https://53.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.coinex.net/"],
  "shortName": "tcet",
  "slip44": 1,
  "slug": "coinex-smart-chain-testnet",
  "testnet": true
};

var c54 = {
  "chain": "OPENPIECE",
  "chainId": 54,
  "explorers": [{
    "name": "Belly Scan",
    "url": "https://bellyscan.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVTahJkdSH3HPYsJMK2GmqfWZjLyxE7cXy1aHEnHU3vp2",
    "width": 250,
    "height": 250,
    "format": "png"
  },
  "infoURL": "https://cryptopiece.online",
  "name": "Openpiece Mainnet",
  "nativeCurrency": {
    "name": "Belly",
    "symbol": "BELLY",
    "decimals": 18
  },
  "networkId": 54,
  "rpc": ["https://54.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.openpiece.io"],
  "shortName": "OP",
  "slug": "openpiece",
  "testnet": false
};

var c55 = {
  "chain": "ZYX",
  "chainId": 55,
  "explorers": [{
    "name": "zyxscan",
    "url": "https://zyxscan.com",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://zyx.network/",
  "name": "Zyx Mainnet",
  "nativeCurrency": {
    "name": "Zyx",
    "symbol": "ZYX",
    "decimals": 18
  },
  "networkId": 55,
  "rpc": ["https://55.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-1.zyx.network/", "https://rpc-2.zyx.network/", "https://rpc-3.zyx.network/", "https://rpc-4.zyx.network/", "https://rpc-5.zyx.network/", "https://rpc-6.zyx.network/"],
  "shortName": "ZYX",
  "slug": "zyx",
  "testnet": false
};

var c56 = {
  "chain": "BSC",
  "chainId": 56,
  "explorers": [{
    "name": "bscscan",
    "url": "https://bscscan.com",
    "standard": "EIP3091"
  }, {
    "name": "dexguru",
    "url": "https://bnb.dex.guru",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne",
      "width": 83,
      "height": 82,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/binance-coin/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://www.bnbchain.org/en",
  "name": "BNB Smart Chain Mainnet",
  "nativeCurrency": {
    "name": "BNB Chain Native Token",
    "symbol": "BNB",
    "decimals": 18
  },
  "networkId": 56,
  "redFlags": [],
  "rpc": ["https://56.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://bsc-dataseed1.bnbchain.org", "https://bsc-dataseed2.bnbchain.org", "https://bsc-dataseed3.bnbchain.org", "https://bsc-dataseed4.bnbchain.org", "https://bsc-dataseed1.defibit.io", "https://bsc-dataseed2.defibit.io", "https://bsc-dataseed3.defibit.io", "https://bsc-dataseed4.defibit.io", "https://bsc-dataseed1.ninicoin.io", "https://bsc-dataseed2.ninicoin.io", "https://bsc-dataseed3.ninicoin.io", "https://bsc-dataseed4.ninicoin.io", "https://bsc-rpc.publicnode.com", "wss://bsc-rpc.publicnode.com", "wss://bsc-ws-node.nariox.org"],
  "shortName": "bnb",
  "slip44": 714,
  "slug": "binance",
  "testnet": false
};

var c57 = {
  "chain": "SYS",
  "chainId": 57,
  "explorers": [{
    "name": "Syscoin Block Explorer",
    "url": "https://explorer.syscoin.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.syscoin.org"],
  "infoURL": "https://www.syscoin.org",
  "name": "Syscoin Mainnet",
  "nativeCurrency": {
    "name": "Syscoin",
    "symbol": "SYS",
    "decimals": 18
  },
  "networkId": 57,
  "rpc": ["https://57.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.syscoin.org", "https://rpc.ankr.com/syscoin/${ANKR_API_KEY}", "https://syscoin.public-rpc.com", "wss://rpc.syscoin.org/wss", "https://syscoin-evm.publicnode.com", "wss://syscoin-evm.publicnode.com"],
  "shortName": "sys",
  "slug": "syscoin",
  "testnet": false
};

var c58 = {
  "chain": "Ontology",
  "chainId": 58,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer.ont.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreigmvn6spvbiirtutowpq6jmetevbxoof5plzixjoerbeswy4htfb4",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://ont.io/",
  "name": "Ontology Mainnet",
  "nativeCurrency": {
    "name": "ONG",
    "symbol": "ONG",
    "decimals": 18
  },
  "networkId": 58,
  "rpc": ["https://58.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://dappnode1.ont.io:20339", "http://dappnode2.ont.io:20339", "http://dappnode3.ont.io:20339", "http://dappnode4.ont.io:20339", "https://dappnode1.ont.io:10339", "https://dappnode2.ont.io:10339", "https://dappnode3.ont.io:10339", "https://dappnode4.ont.io:10339"],
  "shortName": "OntologyMainnet",
  "slug": "ontology",
  "testnet": false
};

var c59 = {
  "chain": "EOS",
  "chainId": 59,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://eosargentina.io",
  "name": "EOS EVM Legacy",
  "nativeCurrency": {
    "name": "EOS",
    "symbol": "EOS",
    "decimals": 18
  },
  "networkId": 59,
  "rpc": ["https://59.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.eosargentina.io"],
  "shortName": "eos-legacy",
  "slug": "eos-evm-legacy",
  "status": "deprecated",
  "testnet": false
};

var c60 = {
  "chain": "GO",
  "chainId": 60,
  "explorers": [{
    "name": "GoChain Explorer",
    "url": "https://explorer.gochain.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://gochain.io",
  "name": "GoChain",
  "nativeCurrency": {
    "name": "GoChain Ether",
    "symbol": "GO",
    "decimals": 18
  },
  "networkId": 60,
  "rpc": ["https://60.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.gochain.io"],
  "shortName": "go",
  "slip44": 6060,
  "slug": "gochain",
  "testnet": false
};

var c61 = {
  "chain": "ETC",
  "chainId": 61,
  "explorers": [{
    "name": "etcnetworkinfo-blockscout-ethereum-classic",
    "url": "https://explorer-blockscout.etc-network.info",
    "standard": "none"
  }, {
    "name": "etcnetworkinfo-alethio-ethereum-classic",
    "url": "https://explorer-alethio.etc-network.info",
    "standard": "none"
  }, {
    "name": "etcnetworkinfo-expedition-ethereum-classic",
    "url": "https://explorer-expedition.etc-network.info",
    "standard": "none"
  }, {
    "name": "hebeblock-ethereum-classic",
    "url": "https://etcerscan.com",
    "standard": "EIP3091"
  }, {
    "name": "oklink-ethereum-classic",
    "url": "https://www.oklink.com/etc",
    "standard": "EIP3091"
  }, {
    "name": "tokenview-ethereum-classic",
    "url": "https://etc.tokenview.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://Qme7PT7gidTzRuf3T2JdxQ64JeZPgFH7yNBB8mYoMPbpTe",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://ethereumclassic.org",
  "name": "Ethereum Classic",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETC",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://61.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://etc.rivet.link", "https://besu-at.etc-network.info", "https://besu-de.etc-network.info", "https://geth-at.etc-network.info", "https://geth-de.etc-network.info", "https://etc.etcdesktop.com", "https://rpc.etcinscribe.com", "https://etc.mytokenpocket.vip"],
  "shortName": "etc",
  "slip44": 61,
  "slug": "ethereum-classic",
  "status": "active",
  "testnet": false,
  "title": "Ethereum Classic Mainnet"
};

var c62 = {
  "chain": "ETC",
  "chainId": 62,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmawMDPsaj3kBTZErCYQ3tshv5RrMAN3smWNs72m943Fyj",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://ethereumclassic.org/development/testnets",
  "name": "Morden Testnet",
  "nativeCurrency": {
    "name": "Morden Ether",
    "symbol": "TETC",
    "decimals": 18
  },
  "networkId": 2,
  "rpc": [],
  "shortName": "tetc",
  "slip44": 1,
  "slug": "morden-testnet",
  "status": "deprecated",
  "testnet": true,
  "title": "Ethereum Classic Morden Testnet"
};

var c63 = {
  "chain": "ETC",
  "chainId": 63,
  "explorers": [{
    "name": "blockscout-mordor",
    "url": "https://etc-mordor.blockscout.com",
    "standard": "EIP3091"
  }, {
    "name": "etcnetworkinfo-expedition-mordor",
    "url": "https://explorer-expedition.etc-network.info/?network=Ethereum+Classic+at+etc-network.info+GETH+Mordor",
    "standard": "none"
  }],
  "faucets": ["https://easy.hebeswap.com/#/faucet", "https://faucet.mordortest.net"],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://QmawMDPsaj3kBTZErCYQ3tshv5RrMAN3smWNs72m943Fyj",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://ethereumclassic.org/development/testnets",
  "name": "Mordor Testnet",
  "nativeCurrency": {
    "name": "Mordor Ether",
    "symbol": "METC",
    "decimals": 18
  },
  "networkId": 7,
  "rpc": ["https://63.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.mordor.etccooperative.org", "https://geth-mordor.etc-network.info"],
  "shortName": "metc",
  "slip44": 1,
  "slug": "mordor-testnet",
  "status": "active",
  "testnet": true,
  "title": "Ethereum Classic Mordor Testnet"
};

var c64 = {
  "chain": "ELLA",
  "chainId": 64,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://ellaism.org",
  "name": "Ellaism",
  "nativeCurrency": {
    "name": "Ellaism Ether",
    "symbol": "ELLA",
    "decimals": 18
  },
  "networkId": 64,
  "rpc": ["https://64.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://jsonrpc.ellaism.org"],
  "shortName": "ellaism",
  "slip44": 163,
  "slug": "ellaism",
  "testnet": false
};

var c65 = {
  "chain": "okexchain",
  "chainId": 65,
  "explorers": [{
    "name": "OKLink",
    "url": "https://www.oklink.com/okexchain-test",
    "standard": "EIP3091"
  }],
  "faucets": ["https://www.okex.com/drawdex"],
  "infoURL": "https://www.okex.com/okexchain",
  "name": "OKExChain Testnet",
  "nativeCurrency": {
    "name": "OKExChain Global Utility Token in testnet",
    "symbol": "OKT",
    "decimals": 18
  },
  "networkId": 65,
  "rpc": ["https://65.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://exchaintestrpc.okex.org"],
  "shortName": "tokt",
  "slip44": 1,
  "slug": "okexchain-testnet",
  "testnet": true
};

var c66 = {
  "chain": "okxchain",
  "chainId": 66,
  "explorers": [{
    "name": "OKLink",
    "url": "https://www.oklink.com/en/okc",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.okex.com/okc",
  "name": "OKXChain Mainnet",
  "nativeCurrency": {
    "name": "OKXChain Global Utility Token",
    "symbol": "OKT",
    "decimals": 18
  },
  "networkId": 66,
  "rpc": ["https://66.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://exchainrpc.okex.org", "https://okc-mainnet.gateway.pokt.network/v1/lb/6275309bea1b320039c893ff"],
  "shortName": "okt",
  "slug": "okxchain",
  "testnet": false
};

var c67 = {
  "chain": "DBM",
  "chainId": 67,
  "explorers": [],
  "faucets": [],
  "infoURL": "http://test.dbmbp.com",
  "name": "DBChain Testnet",
  "nativeCurrency": {
    "name": "DBChain Testnet",
    "symbol": "DBM",
    "decimals": 18
  },
  "networkId": 67,
  "rpc": ["https://67.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://test-rpc.dbmbp.com"],
  "shortName": "dbm",
  "slip44": 1,
  "slug": "dbchain-testnet",
  "testnet": true
};

var c68 = {
  "chain": "SOTER",
  "chainId": 68,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.soterone.com",
  "name": "SoterOne Mainnet",
  "nativeCurrency": {
    "name": "SoterOne Mainnet Ether",
    "symbol": "SOTER",
    "decimals": 18
  },
  "networkId": 68,
  "rpc": ["https://68.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.soter.one"],
  "shortName": "SO1",
  "slug": "soterone",
  "testnet": false
};

var c69 = {
  "chain": "ETH",
  "chainId": 69,
  "explorers": [{
    "name": "etherscan",
    "url": "https://kovan-optimistic.etherscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["http://fauceth.komputing.org?chain=69&address=${ADDRESS}"],
  "infoURL": "https://optimism.io",
  "name": "Optimism Kovan",
  "nativeCurrency": {
    "name": "Kovan Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 69,
  "rpc": ["https://69.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://kovan.optimism.io/"],
  "shortName": "okov",
  "slip44": 1,
  "slug": "optimism-kovan",
  "testnet": true,
  "title": "Optimism Testnet Kovan"
};

var c70 = {
  "chain": "HSC",
  "chainId": 70,
  "explorers": [{
    "name": "hooscan",
    "url": "https://www.hooscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.hoosmartchain.com",
  "name": "Hoo Smart Chain",
  "nativeCurrency": {
    "name": "Hoo Smart Chain Native Token",
    "symbol": "HOO",
    "decimals": 18
  },
  "networkId": 70,
  "rpc": ["https://70.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://http-mainnet.hoosmartchain.com", "https://http-mainnet2.hoosmartchain.com", "wss://ws-mainnet.hoosmartchain.com", "wss://ws-mainnet2.hoosmartchain.com"],
  "shortName": "hsc",
  "slip44": 1170,
  "slug": "hoo-smart-chain",
  "testnet": false
};

var c71 = {
  "chain": "Conflux",
  "chainId": 71,
  "explorers": [{
    "name": "Conflux Scan",
    "url": "https://evmtestnet.confluxscan.net",
    "standard": "none"
  }],
  "faucets": ["https://faucet.confluxnetwork.org"],
  "icon": {
    "url": "ipfs://bafkreifj7n24u2dslfijfihwqvpdeigt5aj3k3sxv6s35lv75sxsfr3ojy",
    "width": 460,
    "height": 576,
    "format": "png"
  },
  "infoURL": "https://confluxnetwork.org",
  "name": "Conflux eSpace (Testnet)",
  "nativeCurrency": {
    "name": "CFX",
    "symbol": "CFX",
    "decimals": 18
  },
  "networkId": 71,
  "rpc": ["https://71.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evmtestnet.confluxrpc.com"],
  "shortName": "cfxtest",
  "slug": "conflux-espace-testnet",
  "testnet": true
};

var c72 = {
  "chain": "DxChain",
  "chainId": 72,
  "explorers": [],
  "faucets": ["https://faucet.dxscan.io"],
  "infoURL": "https://testnet.dxscan.io/",
  "name": "DxChain Testnet",
  "nativeCurrency": {
    "name": "DxChain Testnet",
    "symbol": "DX",
    "decimals": 18
  },
  "networkId": 72,
  "rpc": ["https://72.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-http.dxchain.com"],
  "shortName": "dxc",
  "slip44": 1,
  "slug": "dxchain-testnet",
  "testnet": true
};

var c73 = {
  "chain": "FNCY",
  "chainId": 73,
  "explorers": [{
    "name": "fncy scan",
    "url": "https://fncyscan.fncy.world",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmfXCh6UnaEHn3Evz7RFJ3p2ggJBRm9hunDHegeoquGuhD",
      "width": 256,
      "height": 256,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet-testnet.fncy.world"],
  "icon": {
    "url": "ipfs://QmfXCh6UnaEHn3Evz7RFJ3p2ggJBRm9hunDHegeoquGuhD",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://fncyscan.fncy.world",
  "name": "FNCY",
  "nativeCurrency": {
    "name": "FNCY",
    "symbol": "FNCY",
    "decimals": 18
  },
  "networkId": 73,
  "rpc": ["https://73.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://fncy-seed1.fncy.world"],
  "shortName": "FNCY",
  "slug": "fncy",
  "testnet": true
};

var c74 = {
  "chain": "IDChain",
  "chainId": 74,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer.idchain.one",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZVwsY6HPXScKqZCA9SWNrr4jrQAHkPhVhMWi6Fj1DsrJ",
    "width": 162,
    "height": 129,
    "format": "png"
  },
  "infoURL": "https://idchain.one/begin/",
  "name": "IDChain Mainnet",
  "nativeCurrency": {
    "name": "EIDI",
    "symbol": "EIDI",
    "decimals": 18
  },
  "networkId": 74,
  "rpc": ["https://74.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://idchain.one/rpc/", "wss://idchain.one/ws/"],
  "shortName": "idchain",
  "slug": "idchain",
  "testnet": false
};

var c75 = {
  "chain": "DSC",
  "chainId": 75,
  "explorers": [{
    "name": "DSC Explorer Mainnet",
    "url": "https://explorer.decimalchain.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmSgzwKnJJjys3Uq2aVVdwJ3NffLj3CXMVCph9uByTBegc",
      "width": 256,
      "height": 256,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmSgzwKnJJjys3Uq2aVVdwJ3NffLj3CXMVCph9uByTBegc",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://decimalchain.com",
  "name": "Decimal Smart Chain Mainnet",
  "nativeCurrency": {
    "name": "Decimal",
    "symbol": "DEL",
    "decimals": 18
  },
  "networkId": 75,
  "rpc": ["https://75.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node.decimalchain.com/web3/", "https://node1-mainnet.decimalchain.com/web3/", "https://node2-mainnet.decimalchain.com/web3/", "https://node3-mainnet.decimalchain.com/web3/", "https://node4-mainnet.decimalchain.com/web3/"],
  "shortName": "DSC",
  "slug": "decimal-smart-chain",
  "testnet": false
};

var c76 = {
  "chain": "MIX",
  "chainId": 76,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://mix-blockchain.org",
  "name": "Mix",
  "nativeCurrency": {
    "name": "Mix Ether",
    "symbol": "MIX",
    "decimals": 18
  },
  "networkId": 76,
  "rpc": ["https://76.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc2.mix-blockchain.org:8647"],
  "shortName": "mix",
  "slip44": 76,
  "slug": "mix",
  "testnet": false
};

var c77 = {
  "chain": "POA",
  "chainId": 77,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscout.com/poa/sokol",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "infoURL": "https://poa.network",
  "name": "POA Network Sokol",
  "nativeCurrency": {
    "name": "POA Sokol Ether",
    "symbol": "SPOA",
    "decimals": 18
  },
  "networkId": 77,
  "rpc": ["https://77.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sokol.poa.network", "wss://sokol.poa.network/wss", "ws://sokol.poa.network:8546"],
  "shortName": "spoa",
  "slug": "poa-network-sokol",
  "testnet": false
};

var c78 = {
  "chain": "PC",
  "chainId": 78,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://primusmoney.com",
  "name": "PrimusChain mainnet",
  "nativeCurrency": {
    "name": "Primus Ether",
    "symbol": "PETH",
    "decimals": 18
  },
  "networkId": 78,
  "rpc": ["https://78.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://ethnode.primusmoney.com/mainnet"],
  "shortName": "primuschain",
  "slug": "primuschain",
  "testnet": false
};

var c79 = {
  "chain": "Zenith",
  "chainId": 79,
  "explorers": [{
    "name": "zenith scan",
    "url": "https://scan.zenithchain.co",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.zenithchain.co/",
  "name": "Zenith Mainnet",
  "nativeCurrency": {
    "name": "ZENITH",
    "symbol": "ZENITH",
    "decimals": 18
  },
  "networkId": 79,
  "rpc": ["https://79.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dataserver-us-1.zenithchain.co/", "https://dataserver-asia-3.zenithchain.co/", "https://dataserver-asia-4.zenithchain.co/", "https://dataserver-asia-2.zenithchain.co/", "https://dataserver-asia-5.zenithchain.co/", "https://dataserver-asia-6.zenithchain.co/", "https://dataserver-asia-7.zenithchain.co/"],
  "shortName": "zenith",
  "slug": "zenith",
  "testnet": false
};

var c80 = {
  "chain": "GeneChain",
  "chainId": 80,
  "explorers": [{
    "name": "GeneChain Scan",
    "url": "https://scan.genechain.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://scan.genechain.io/",
  "name": "GeneChain",
  "nativeCurrency": {
    "name": "RNA",
    "symbol": "RNA",
    "decimals": 18
  },
  "networkId": 80,
  "rpc": ["https://80.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.genechain.io"],
  "shortName": "GeneChain",
  "slug": "genechain",
  "testnet": false
};

var c81 = {
  "chain": "JOC",
  "chainId": 81,
  "explorers": [{
    "name": "Block Explorer",
    "url": "https://explorer.japanopenchain.org",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreidhsiuqrct42bel76zhi3rx35k4lnk6aqgde27nvvxcz563ttfefy",
      "width": 2000,
      "height": 2000,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreidhsiuqrct42bel76zhi3rx35k4lnk6aqgde27nvvxcz563ttfefy",
    "width": 2000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://www.japanopenchain.org/",
  "name": "Japan Open Chain Mainnet",
  "nativeCurrency": {
    "name": "Japan Open Chain Token",
    "symbol": "JOC",
    "decimals": 18
  },
  "networkId": 81,
  "redFlags": ["reusedChainId"],
  "rpc": ["https://81.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-1.japanopenchain.org:8545", "https://rpc-2.japanopenchain.org:8545"],
  "shortName": "joc",
  "slug": "japan-open-chain",
  "testnet": false
};

var c82 = {
  "chain": "METER",
  "chainId": 82,
  "explorers": [{
    "name": "Meter Mainnet Scan",
    "url": "https://scan.meter.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.meter.io"],
  "infoURL": "https://www.meter.io",
  "name": "Meter Mainnet",
  "nativeCurrency": {
    "name": "Meter",
    "symbol": "MTR",
    "decimals": 18
  },
  "networkId": 82,
  "rpc": ["https://82.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.meter.io"],
  "shortName": "Meter",
  "slug": "meter",
  "testnet": false
};

var c83 = {
  "chain": "METER Testnet",
  "chainId": 83,
  "explorers": [{
    "name": "Meter Testnet Scan",
    "url": "https://scan-warringstakes.meter.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet-warringstakes.meter.io"],
  "infoURL": "https://www.meter.io",
  "name": "Meter Testnet",
  "nativeCurrency": {
    "name": "Meter",
    "symbol": "MTR",
    "decimals": 18
  },
  "networkId": 83,
  "rpc": ["https://83.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpctest.meter.io"],
  "shortName": "MeterTest",
  "slip44": 1,
  "slug": "meter-testnet",
  "testnet": true
};

var c84 = {
  "chain": "LNQ",
  "chainId": 84,
  "explorers": [{
    "name": "Linqto Devnet Explorer",
    "url": "https://explorer.linqto-dev.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://linqto.com",
  "name": "Linqto Devnet",
  "nativeCurrency": {
    "name": "XRP",
    "symbol": "XRP",
    "decimals": 18
  },
  "networkId": 84,
  "rpc": ["https://84.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://linqto-dev.com"],
  "shortName": "linqto-devnet",
  "slug": "linqto-devnet",
  "testnet": false
};

var c85 = {
  "chain": "GTTEST",
  "chainId": 85,
  "explorers": [{
    "name": "GateScan",
    "url": "https://www.gatescan.org/testnet",
    "standard": "EIP3091"
  }],
  "faucets": ["https://www.gatescan.org/testnet/faucet"],
  "infoURL": "https://www.gatechain.io",
  "name": "GateChain Testnet",
  "nativeCurrency": {
    "name": "GateToken",
    "symbol": "GT",
    "decimals": 18
  },
  "networkId": 85,
  "rpc": ["https://85.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.gatenode.cc"],
  "shortName": "gttest",
  "slip44": 1,
  "slug": "gatechain-testnet",
  "testnet": true
};

var c86 = {
  "chain": "GT",
  "chainId": 86,
  "explorers": [{
    "name": "GateScan",
    "url": "https://www.gatescan.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://www.gatescan.org/faucet"],
  "infoURL": "https://www.gatechain.io",
  "name": "GateChain Mainnet",
  "nativeCurrency": {
    "name": "GateToken",
    "symbol": "GT",
    "decimals": 18
  },
  "networkId": 86,
  "rpc": ["https://86.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm.gatenode.cc"],
  "shortName": "gt",
  "slug": "gatechain",
  "testnet": false
};

var c87 = {
  "chain": "NNW",
  "chainId": 87,
  "explorers": [{
    "name": "novanetwork",
    "url": "https://explorer.novanetwork.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmTTamJ55YGQwMboq4aqf3JjTEy5WDtjo4GBRQ5VdsWA6U",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://novanetwork.io",
  "name": "Nova Network",
  "nativeCurrency": {
    "name": "Supernova",
    "symbol": "SNT",
    "decimals": 18
  },
  "networkId": 87,
  "rpc": ["https://87.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://connect.novanetwork.io", "https://0x57.redjackstudio.com", "https://rpc.novanetwork.io:9070"],
  "shortName": "nnw",
  "slug": "nova-network",
  "testnet": false
};

var c88 = {
  "chain": "Viction",
  "chainId": 88,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://viction.xyz",
  "name": "Viction",
  "nativeCurrency": {
    "name": "Viction",
    "symbol": "VIC",
    "decimals": 18
  },
  "networkId": 88,
  "rpc": ["https://88.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.viction.xyz"],
  "shortName": "vic",
  "slip44": 889,
  "slug": "viction",
  "testnet": false
};

var c89 = {
  "chain": "Viction",
  "chainId": 89,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://viction.xyz",
  "name": "Viction Testnet",
  "nativeCurrency": {
    "name": "Viction",
    "symbol": "VIC",
    "decimals": 18
  },
  "networkId": 89,
  "rpc": ["https://89.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.viction.xyz"],
  "shortName": "vict",
  "slip44": 1,
  "slug": "viction-testnet",
  "testnet": true
};

var c90 = {
  "chain": "GAR",
  "chainId": 90,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer.garizon.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc",
      "width": 1024,
      "height": 613,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc",
    "width": 1024,
    "height": 613,
    "format": "png"
  },
  "infoURL": "https://garizon.com",
  "name": "Garizon Stage0",
  "nativeCurrency": {
    "name": "Garizon",
    "symbol": "GAR",
    "decimals": 18
  },
  "networkId": 90,
  "rpc": ["https://90.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://s0.garizon.net/rpc"],
  "shortName": "gar-s0",
  "slug": "garizon-stage0",
  "testnet": false
};

var c91 = {
  "chain": "GAR",
  "chainId": 91,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer.garizon.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc",
      "width": 1024,
      "height": 613,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc",
    "width": 1024,
    "height": 613,
    "format": "png"
  },
  "infoURL": "https://garizon.com",
  "name": "Garizon Stage1",
  "nativeCurrency": {
    "name": "Garizon",
    "symbol": "GAR",
    "decimals": 18
  },
  "networkId": 91,
  "parent": {
    "type": "shard",
    "chain": "eip155-90"
  },
  "rpc": ["https://91.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://s1.garizon.net/rpc"],
  "shortName": "gar-s1",
  "slug": "garizon-stage1",
  "testnet": false
};

var c92 = {
  "chain": "GAR",
  "chainId": 92,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer.garizon.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc",
      "width": 1024,
      "height": 613,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc",
    "width": 1024,
    "height": 613,
    "format": "png"
  },
  "infoURL": "https://garizon.com",
  "name": "Garizon Stage2",
  "nativeCurrency": {
    "name": "Garizon",
    "symbol": "GAR",
    "decimals": 18
  },
  "networkId": 92,
  "parent": {
    "type": "shard",
    "chain": "eip155-90"
  },
  "rpc": ["https://92.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://s2.garizon.net/rpc"],
  "shortName": "gar-s2",
  "slug": "garizon-stage2",
  "testnet": false
};

var c93 = {
  "chain": "GAR",
  "chainId": 93,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer.garizon.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc",
      "width": 1024,
      "height": 613,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc",
    "width": 1024,
    "height": 613,
    "format": "png"
  },
  "infoURL": "https://garizon.com",
  "name": "Garizon Stage3",
  "nativeCurrency": {
    "name": "Garizon",
    "symbol": "GAR",
    "decimals": 18
  },
  "networkId": 93,
  "parent": {
    "type": "shard",
    "chain": "eip155-90"
  },
  "rpc": ["https://93.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://s3.garizon.net/rpc"],
  "shortName": "gar-s3",
  "slug": "garizon-stage3",
  "testnet": false
};

var c94 = {
  "chain": "SDLT",
  "chainId": 94,
  "explorers": [{
    "name": "SwissDLT Explorer",
    "url": "https://explorer.swissdlt.ch",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreig7x5z4j6vh2r3pugmjnob3tmlksaekhqcgsorqzvs55o6v7ehqd4",
      "width": 682,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreig7x5z4j6vh2r3pugmjnob3tmlksaekhqcgsorqzvs55o6v7ehqd4",
    "width": 682,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://bcts.ch",
  "name": "SwissDLT",
  "nativeCurrency": {
    "name": "BCTS",
    "symbol": "BCTS",
    "decimals": 18
  },
  "networkId": 94,
  "rpc": ["https://94.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.swissdlt.ch"],
  "shortName": "sdlt",
  "slug": "swissdlt",
  "testnet": false
};

var c95 = {
  "chain": "CADL",
  "chainId": 95,
  "explorers": [{
    "name": "CamDL Block Explorer",
    "url": "https://explorer.camdl.gov.kh",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.camdl.gov.kh/"],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://QmW5Fpb2Ywnfqcj4ibvpbKvPv5Mo5eseWdYZnnUvLkj2Hp",
    "width": 1453,
    "height": 1453,
    "format": "png"
  },
  "infoURL": "https://camdl.gov.kh/",
  "name": "CamDL Mainnet",
  "nativeCurrency": {
    "name": "CADL",
    "symbol": "CADL",
    "decimals": 18
  },
  "networkId": 95,
  "redFlags": ["reusedChainId"],
  "rpc": ["https://95.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc1.camdl.gov.kh/"],
  "shortName": "camdl",
  "slug": "camdl",
  "status": "active",
  "testnet": false
};

var c96 = {
  "chain": "BKC",
  "chainId": 96,
  "explorers": [{
    "name": "Bitkub Chain Explorer",
    "url": "https://bkcscan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmYFYwyquipwc9gURQGcEd4iAq7pq15chQrJ3zJJe9HuFT",
      "width": 1000,
      "height": 1000,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYFYwyquipwc9gURQGcEd4iAq7pq15chQrJ3zJJe9HuFT",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://www.bitkubchain.com/",
  "name": "Bitkub Chain",
  "nativeCurrency": {
    "name": "Bitkub Coin",
    "symbol": "KUB",
    "decimals": 18
  },
  "networkId": 96,
  "redFlags": ["reusedChainId"],
  "rpc": ["https://96.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.bitkubchain.io", "wss://wss.bitkubchain.io"],
  "shortName": "bkc",
  "slug": "bitkub-chain",
  "testnet": false
};

var c97 = {
  "chain": "BSC",
  "chainId": 97,
  "explorers": [{
    "name": "bscscan-testnet",
    "url": "https://testnet.bscscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://testnet.bnbchain.org/faucet-smart"],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/binance-coin/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://www.bnbchain.org/en",
  "name": "BNB Smart Chain Testnet",
  "nativeCurrency": {
    "name": "BNB Chain Native Token",
    "symbol": "tBNB",
    "decimals": 18
  },
  "networkId": 97,
  "redFlags": [],
  "rpc": ["https://97.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://data-seed-prebsc-1-s1.bnbchain.org:8545", "https://data-seed-prebsc-2-s1.bnbchain.org:8545", "https://data-seed-prebsc-1-s2.bnbchain.org:8545", "https://data-seed-prebsc-2-s2.bnbchain.org:8545", "https://data-seed-prebsc-1-s3.bnbchain.org:8545", "https://data-seed-prebsc-2-s3.bnbchain.org:8545", "https://bsc-testnet-rpc.publicnode.com", "wss://bsc-testnet-rpc.publicnode.com"],
  "shortName": "bnbt",
  "slip44": 1,
  "slug": "binance-testnet",
  "testnet": true
};

var c98 = {
  "chain": "SIXNET",
  "chainId": 98,
  "explorers": [{
    "name": "SIX Scan",
    "url": "https://sixscan.io/sixnet",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmP93z696v8Hetu13peY2oEHDXq8Bj5CqaDRwpVkpnM15A",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmP93z696v8Hetu13peY2oEHDXq8Bj5CqaDRwpVkpnM15A",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://six.network/",
  "name": "Six Protocol",
  "nativeCurrency": {
    "name": "SIX evm token",
    "symbol": "SIX",
    "decimals": 18
  },
  "networkId": 98,
  "rpc": ["https://98.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sixnet-rpc-evm.sixprotocol.net"],
  "shortName": "six",
  "slug": "six-protocol",
  "testnet": false
};

var c99 = {
  "chain": "POA",
  "chainId": 99,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscout.com/poa/core",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "infoURL": "https://poa.network",
  "name": "POA Network Core",
  "nativeCurrency": {
    "name": "POA Network Core Ether",
    "symbol": "POA",
    "decimals": 18
  },
  "networkId": 99,
  "rpc": ["https://99.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://core.poa.network"],
  "shortName": "poa",
  "slip44": 178,
  "slug": "poa-network-core",
  "testnet": false
};

var c100 = {
  "chain": "GNO",
  "chainId": 100,
  "explorers": [{
    "name": "blockscout",
    "url": "https://gnosis.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }, {
    "name": "gnosisscan",
    "url": "https://gnosisscan.io",
    "standard": "EIP3091"
  }, {
    "name": "dexguru",
    "url": "https://gnosis.dex.guru",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne",
      "width": 83,
      "height": 82,
      "format": "svg"
    }
  }],
  "faucets": ["https://gnosisfaucet.com", "https://stakely.io/faucet/gnosis-chain-xdai", "https://faucet.prussia.dev/xdai"],
  "icon": {
    "url": "ipfs://bafybeidk4swpgdyqmpz6shd5onvpaujvwiwthrhypufnwr6xh3dausz2dm",
    "width": 1800,
    "height": 1800,
    "format": "png"
  },
  "infoURL": "https://docs.gnosischain.com",
  "name": "Gnosis",
  "nativeCurrency": {
    "name": "xDAI",
    "symbol": "XDAI",
    "decimals": 18
  },
  "networkId": 100,
  "rpc": ["https://100.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.gnosischain.com", "https://rpc.gnosis.gateway.fm", "https://rpc.ankr.com/gnosis", "https://gnosischain-rpc.gateway.pokt.network", "https://gnosis-mainnet.public.blastapi.io", "https://gnosis.api.onfinality.io/public", "https://gnosis.blockpi.network/v1/rpc/public", "https://web3endpoints.com/gnosischain-mainnet", "https://gnosis.oat.farm", "wss://rpc.gnosischain.com/wss", "https://gnosis-rpc.publicnode.com", "wss://gnosis-rpc.publicnode.com"],
  "shortName": "gno",
  "slip44": 700,
  "slug": "gnosis",
  "testnet": false
};

var c101 = {
  "chain": "ETI",
  "chainId": 101,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://einc.io",
  "name": "EtherInc",
  "nativeCurrency": {
    "name": "EtherInc Ether",
    "symbol": "ETI",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://101.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.einc.io/jsonrpc/mainnet"],
  "shortName": "eti",
  "slip44": 464,
  "slug": "etherinc",
  "testnet": false
};

var c102 = {
  "chain": "Web3Games",
  "chainId": 102,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmUc57w3UTHiWapNW9oQb1dP57ymtdemTTbpvGkjVHBRCo",
    "width": 192,
    "height": 192,
    "format": "png"
  },
  "infoURL": "https://web3games.org/",
  "name": "Web3Games Testnet",
  "nativeCurrency": {
    "name": "Web3Games",
    "symbol": "W3G",
    "decimals": 18
  },
  "networkId": 102,
  "rpc": ["https://102.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc-0.web3games.org/evm", "https://testnet-rpc-1.web3games.org/evm", "https://testnet-rpc-2.web3games.org/evm"],
  "shortName": "tw3g",
  "slip44": 1,
  "slug": "web3games-testnet",
  "testnet": true
};

var c103 = {
  "chain": "Worldland",
  "chainId": 103,
  "explorers": [{
    "name": "Worldland Explorer",
    "url": "https://scan.worldland.foundation",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYZNTfK3byhgLsTjXP8vPubVHRz2CWsBrTJxZrQmKq6JZ",
    "width": 3509,
    "height": 2482,
    "format": "png"
  },
  "infoURL": "https://worldland.foundation",
  "name": "Worldland Mainnet",
  "nativeCurrency": {
    "name": "Worldland",
    "symbol": "WLC",
    "decimals": 18
  },
  "networkId": 103,
  "rpc": ["https://103.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://seoul.worldland.foundation"],
  "shortName": "WLC",
  "slug": "worldland",
  "testnet": false
};

var c104 = {
  "chain": "tKLC",
  "chainId": 104,
  "explorers": [{
    "name": "kaibascan",
    "url": "https://kaibascan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafybeihbsw3ky7yf6llpww6fabo4dicotcgwjpefscoxrppstjx25dvtea",
      "width": 932,
      "height": 932,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeihbsw3ky7yf6llpww6fabo4dicotcgwjpefscoxrppstjx25dvtea",
    "width": 932,
    "height": 932,
    "format": "png"
  },
  "infoURL": "https://kaibadefi.com",
  "name": "Kaiba Lightning Chain Testnet",
  "nativeCurrency": {
    "name": "Kaiba Testnet Token",
    "symbol": "tKAIBA",
    "decimals": 18
  },
  "networkId": 104,
  "rpc": ["https://104.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://klc.live/"],
  "shortName": "tklc",
  "slip44": 1,
  "slug": "kaiba-lightning-chain-testnet",
  "testnet": true
};

var c105 = {
  "chain": "Web3Games",
  "chainId": 105,
  "explorers": [{
    "name": "Web3Games Explorer",
    "url": "https://explorer-devnet.web3games.org",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmUc57w3UTHiWapNW9oQb1dP57ymtdemTTbpvGkjVHBRCo",
    "width": 192,
    "height": 192,
    "format": "png"
  },
  "infoURL": "https://web3games.org/",
  "name": "Web3Games Devnet",
  "nativeCurrency": {
    "name": "Web3Games",
    "symbol": "W3G",
    "decimals": 18
  },
  "networkId": 105,
  "rpc": ["https://105.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnet.web3games.org/evm"],
  "shortName": "dw3g",
  "slug": "web3games-devnet",
  "testnet": false
};

var c106 = {
  "chain": "Velas",
  "chainId": 106,
  "explorers": [{
    "name": "Velas Explorer",
    "url": "https://evmexplorer.velas.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNXiCXJxEeBd7ZYGYjPSMTSdbDd2nfodLC677gUfk9ku5",
    "width": 924,
    "height": 800,
    "format": "png"
  },
  "infoURL": "https://velas.com",
  "name": "Velas EVM Mainnet",
  "nativeCurrency": {
    "name": "Velas",
    "symbol": "VLX",
    "decimals": 18
  },
  "networkId": 106,
  "rpc": ["https://106.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evmexplorer.velas.com/rpc", "https://explorer.velas.com/rpc"],
  "shortName": "vlx",
  "slug": "velas-evm",
  "testnet": false
};

var c107 = {
  "chain": "NTN",
  "chainId": 107,
  "explorers": [{
    "name": "nebulatestnet",
    "url": "https://explorer.novanetwork.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.novanetwork.io"],
  "icon": {
    "url": "ipfs://QmeFaJtQqTKKuXQR7ysS53bLFPasFBcZw445cvYJ2HGeTo",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://novanetwork.io",
  "name": "Nebula Testnet",
  "nativeCurrency": {
    "name": "Nebula X",
    "symbol": "NBX",
    "decimals": 18
  },
  "networkId": 107,
  "rpc": ["https://107.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.rpc.novanetwork.io"],
  "shortName": "ntn",
  "slip44": 1,
  "slug": "nebula-testnet",
  "testnet": true
};

var c108 = {
  "chain": "TT",
  "chainId": 108,
  "explorers": [{
    "name": "thundercore-viewblock",
    "url": "https://viewblock.io/thundercore",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://thundercore.com",
  "name": "ThunderCore Mainnet",
  "nativeCurrency": {
    "name": "ThunderCore Token",
    "symbol": "TT",
    "decimals": 18
  },
  "networkId": 108,
  "rpc": ["https://108.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.thundercore.com", "https://mainnet-rpc.thundertoken.net", "https://mainnet-rpc.thundercore.io"],
  "shortName": "TT",
  "slip44": 1001,
  "slug": "thundercore",
  "testnet": false
};

var c109 = {
  "chain": "Shibarium",
  "chainId": 109,
  "explorers": [{
    "name": "shibariumscan",
    "url": "https://www.shibariumscan.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYNVkoZgRjDBQzJz6kog9mA2yPzQFW2oSKvhnkwuBhLQE",
    "width": 2000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://shibariumecosystem.com",
  "name": "Shibarium",
  "nativeCurrency": {
    "name": "BONE Shibarium",
    "symbol": "BONE",
    "decimals": 18
  },
  "networkId": 109,
  "rpc": ["https://109.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://www.shibrpc.com"],
  "shortName": "shibariumecosystem",
  "slug": "shibarium",
  "testnet": false
};

var c110 = {
  "chain": "XPR",
  "chainId": 110,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://protonchain.com",
  "name": "Proton Testnet",
  "nativeCurrency": {
    "name": "Proton",
    "symbol": "XPR",
    "decimals": 4
  },
  "networkId": 110,
  "rpc": ["https://110.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://protontestnet.greymass.com/"],
  "shortName": "xpr",
  "slip44": 1,
  "slug": "proton-testnet",
  "testnet": true
};

var c111 = {
  "chain": "ETL",
  "chainId": 111,
  "explorers": [],
  "faucets": ["https://etherlite.org/faucets"],
  "icon": {
    "url": "ipfs://QmbNAai1KnBnw4SPQKgrf6vBddifPCQTg2PePry1bmmZYy",
    "width": 88,
    "height": 88,
    "format": "png"
  },
  "infoURL": "https://etherlite.org",
  "name": "EtherLite Chain",
  "nativeCurrency": {
    "name": "EtherLite",
    "symbol": "ETL",
    "decimals": 18
  },
  "networkId": 111,
  "rpc": ["https://111.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.etherlite.org"],
  "shortName": "ETL",
  "slug": "etherlite-chain",
  "testnet": false
};

var c112 = {
  "chain": "Coinbit",
  "chainId": 112,
  "explorers": [{
    "name": "blockscout",
    "url": "https://coinbit-explorer.chain.sbcrypto.app",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdaQRUbAXJGfHeJ8jaB8WVh8CCmHExq8VjvAfXpLWWQEo",
    "width": 760,
    "height": 760,
    "format": "png"
  },
  "infoURL": "https://crypto.stockbit.com/",
  "name": "Coinbit Mainnet",
  "nativeCurrency": {
    "name": "Gas IDR",
    "symbol": "GIDR",
    "decimals": 18
  },
  "networkId": 112,
  "rpc": ["https://112.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://coinbit-rpc-mainnet.chain.sbcrypto.app"],
  "shortName": "coinbit",
  "slug": "coinbit",
  "testnet": false
};

var c113 = {
  "chain": "Dehvo",
  "chainId": 113,
  "explorers": [{
    "name": "Dehvo Explorer",
    "url": "https://explorer.dehvo.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://buy.dehvo.com"],
  "infoURL": "https://dehvo.com",
  "name": "Dehvo",
  "nativeCurrency": {
    "name": "Dehvo",
    "symbol": "Deh",
    "decimals": 18
  },
  "networkId": 113,
  "rpc": ["https://113.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://connect.dehvo.com", "https://rpc.dehvo.com", "https://rpc1.dehvo.com", "https://rpc2.dehvo.com"],
  "shortName": "deh",
  "slip44": 714,
  "slug": "dehvo",
  "testnet": false
};

var c114 = {
  "chain": "FLR",
  "chainId": 114,
  "explorers": [{
    "name": "blockscout",
    "url": "https://coston2-explorer.flare.network",
    "standard": "EIP3091"
  }, {
    "name": "flarescan",
    "url": "https://coston2.testnet.flarescan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.flare.network"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmSmXY36oXCLmTp1u3Z2MSrBstBFVFyQv3aGKLKf1hxB6u",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://flare.network",
  "name": "Flare Testnet Coston2",
  "nativeCurrency": {
    "name": "Coston2 Flare",
    "symbol": "C2FLR",
    "decimals": 18
  },
  "networkId": 114,
  "rpc": ["https://114.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://coston2-api.flare.network/ext/C/rpc", "https://flaretestnet-bundler.etherspot.io", "https://01-gravelines-005-01.rpc.tatum.io/ext/bc/C/rpc", "https://02-chicago-005-02.rpc.tatum.io/ext/bc/C/rpc", "https://02-tokyo-005-03.rpc.tatum.io/ext/bc/C/rpc", "https://coston2.enosys.global/ext/C/rpc"],
  "shortName": "c2flr",
  "slip44": 1,
  "slug": "flare-testnet-coston2",
  "testnet": true
};

var c115 = {
  "chain": "DeBank",
  "chainId": 115,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmW9pBps8WHRRWmyXhjLZrjZJUe8F48hUu7z98bu2RVsjN",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://debank.com",
  "name": "DeBank Testnet(Deprecated)",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 115,
  "rpc": [],
  "shortName": "debank-testnet",
  "slip44": 1,
  "slug": "debank-testnet-deprecated",
  "status": "deprecated",
  "testnet": true
};

var c116 = {
  "chain": "DeBank",
  "chainId": 116,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmW9pBps8WHRRWmyXhjLZrjZJUe8F48hUu7z98bu2RVsjN",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://debank.com",
  "name": "DeBank Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 116,
  "rpc": [],
  "shortName": "debank-mainnet",
  "slug": "debank",
  "status": "deprecated",
  "testnet": false
};

var c117 = {
  "chain": "Uptick",
  "chainId": 117,
  "explorers": [{
    "name": "Uptick Explorer",
    "url": "https://evm-explorer.uptick.network",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmRGJ6PqYHDTWuUQ6xfnK8S82NzRXiMjTnSGat9qtLuaLP",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRGJ6PqYHDTWuUQ6xfnK8S82NzRXiMjTnSGat9qtLuaLP",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://www.uptick.network",
  "name": "Uptick Mainnet",
  "nativeCurrency": {
    "name": "Uptick",
    "symbol": "UPTICK",
    "decimals": 18
  },
  "networkId": 117,
  "rpc": ["https://117.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://json-rpc.uptick.network"],
  "shortName": "auptick",
  "slug": "uptick",
  "testnet": false
};

var c118 = {
  "chain": "Arcology",
  "chainId": 118,
  "explorers": [{
    "name": "arcology",
    "url": "https://testnet.arcology.network/explorer",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRD7itMvaZutfBjyA7V9xkMGDtsZiJSagPwd3ijqka8kE",
    "width": 288,
    "height": 288,
    "format": "png"
  },
  "infoURL": "https://arcology.network/",
  "name": "Arcology Testnet",
  "nativeCurrency": {
    "name": "Arcology Coin",
    "symbol": "Acol",
    "decimals": 18
  },
  "networkId": 118,
  "rpc": ["https://118.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.arcology.network/rpc"],
  "shortName": "arcology",
  "slip44": 1,
  "slug": "arcology-testnet",
  "testnet": true
};

var c119 = {
  "chain": "ENULS",
  "chainId": 119,
  "explorers": [{
    "name": "enulsscan",
    "url": "https://evmscan.nuls.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYz8LK5WkUN8UwqKfWUjnyLuYqQZWihT7J766YXft4TSy",
      "width": 26,
      "height": 41,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYz8LK5WkUN8UwqKfWUjnyLuYqQZWihT7J766YXft4TSy",
    "width": 26,
    "height": 41,
    "format": "svg"
  },
  "infoURL": "https://nuls.io",
  "name": "ENULS Mainnet",
  "nativeCurrency": {
    "name": "NULS",
    "symbol": "NULS",
    "decimals": 18
  },
  "networkId": 119,
  "rpc": ["https://119.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evmapi.nuls.io", "https://evmapi2.nuls.io"],
  "shortName": "enuls",
  "slug": "enuls",
  "testnet": false
};

var c120 = {
  "chain": "ENULS",
  "chainId": 120,
  "explorers": [{
    "name": "enulsscan",
    "url": "https://beta.evmscan.nuls.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYz8LK5WkUN8UwqKfWUjnyLuYqQZWihT7J766YXft4TSy",
      "width": 26,
      "height": 41,
      "format": "svg"
    }
  }],
  "faucets": ["http://faucet.nuls.io"],
  "icon": {
    "url": "ipfs://QmYz8LK5WkUN8UwqKfWUjnyLuYqQZWihT7J766YXft4TSy",
    "width": 26,
    "height": 41,
    "format": "svg"
  },
  "infoURL": "https://nuls.io",
  "name": "ENULS Testnet",
  "nativeCurrency": {
    "name": "NULS",
    "symbol": "NULS",
    "decimals": 18
  },
  "networkId": 120,
  "rpc": ["https://120.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://beta.evmapi.nuls.io", "https://beta.evmapi2.nuls.io"],
  "shortName": "enulst",
  "slip44": 1,
  "slug": "enuls-testnet",
  "testnet": true
};

var c121 = {
  "chain": "REAL",
  "chainId": 121,
  "explorers": [{
    "name": "realscan",
    "url": "https://rclscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.rclsidechain.com/",
  "name": "Realchain Mainnet",
  "nativeCurrency": {
    "name": "Realchain",
    "symbol": "REAL",
    "decimals": 18
  },
  "networkId": 121,
  "rpc": ["https://121.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rcl-dataseed1.rclsidechain.com", "https://rcl-dataseed2.rclsidechain.com", "https://rcl-dataseed3.rclsidechain.com", "https://rcl-dataseed4.rclsidechain.com", "wss://rcl-dataseed1.rclsidechain.com/v1/", "wss://rcl-dataseed2.rclsidechain.com/v1/", "wss://rcl-dataseed3.rclsidechain.com/v1/", "wss://rcl-dataseed4.rclsidechain.com/v1/"],
  "shortName": "REAL",
  "slip44": 714,
  "slug": "realchain",
  "testnet": false
};

var c122 = {
  "chain": "FUSE",
  "chainId": 122,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.fuse.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmQg8aqyeaMfHvjzFDtZkb8dUNRYhFezPp8UYVc1HnLpRW/green.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://fuse.io/",
  "name": "Fuse Mainnet",
  "nativeCurrency": {
    "name": "Fuse",
    "symbol": "FUSE",
    "decimals": 18
  },
  "networkId": 122,
  "redFlags": [],
  "rpc": ["https://122.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.fuse.io", "https://fuse.drpc.org", "wss://fuse.drpc.org"],
  "shortName": "fuse",
  "slug": "fuse",
  "testnet": false
};

var c123 = {
  "chain": "fuse",
  "chainId": 123,
  "explorers": [],
  "faucets": ["https://get.fusespark.io"],
  "features": [],
  "icon": {
    "url": "ipfs://QmQg8aqyeaMfHvjzFDtZkb8dUNRYhFezPp8UYVc1HnLpRW/green.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://docs.fuse.io/general/fuse-network-blockchain/fuse-testnet",
  "name": "Fuse Sparknet",
  "nativeCurrency": {
    "name": "Spark",
    "symbol": "SPARK",
    "decimals": 18
  },
  "networkId": 123,
  "redFlags": [],
  "rpc": ["https://123.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.fusespark.io"],
  "shortName": "spark",
  "slug": "fuse-sparknet",
  "testnet": true
};

var c124 = {
  "chain": "DWU",
  "chainId": 124,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://decentralized-web.tech/dw_chain.php",
  "name": "Decentralized Web Mainnet",
  "nativeCurrency": {
    "name": "Decentralized Web Utility",
    "symbol": "DWU",
    "decimals": 18
  },
  "networkId": 124,
  "rpc": ["https://124.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://decentralized-web.tech/dw_rpc.php"],
  "shortName": "dwu",
  "slug": "decentralized-web",
  "testnet": false
};

var c125 = {
  "chain": "OYchain",
  "chainId": 125,
  "explorers": [{
    "name": "OYchain Testnet Explorer",
    "url": "https://explorer.testnet.oychain.io",
    "standard": "none"
  }],
  "faucets": ["https://faucet.oychain.io"],
  "infoURL": "https://www.oychain.io",
  "name": "OYchain Testnet",
  "nativeCurrency": {
    "name": "OYchain Token",
    "symbol": "OY",
    "decimals": 18
  },
  "networkId": 125,
  "rpc": ["https://125.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.oychain.io"],
  "shortName": "OYchainTestnet",
  "slip44": 1,
  "slug": "oychain-testnet",
  "testnet": true
};

var c126 = {
  "chain": "OYchain",
  "chainId": 126,
  "explorers": [{
    "name": "OYchain Mainnet Explorer",
    "url": "https://explorer.oychain.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmXW5T2MaGHznXUmQEXoyJjcdmX7dhLbj5fnqvZZKqeKzA",
    "width": 677,
    "height": 237,
    "format": "png"
  },
  "infoURL": "https://www.oychain.io",
  "name": "OYchain Mainnet",
  "nativeCurrency": {
    "name": "OYchain Token",
    "symbol": "OY",
    "decimals": 18
  },
  "networkId": 126,
  "rpc": ["https://126.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.mainnet.oychain.io"],
  "shortName": "OYchainMainnet",
  "slip44": 126,
  "slug": "oychain",
  "testnet": false
};

var c127 = {
  "chain": "FETH",
  "chainId": 127,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.factory127.com",
  "name": "Factory 127 Mainnet",
  "nativeCurrency": {
    "name": "Factory 127 Token",
    "symbol": "FETH",
    "decimals": 18
  },
  "networkId": 127,
  "rpc": [],
  "shortName": "feth",
  "slip44": 127,
  "slug": "factory-127",
  "testnet": false
};

var c128 = {
  "chain": "Heco",
  "chainId": 128,
  "explorers": [{
    "name": "hecoinfo",
    "url": "https://hecoinfo.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.hecochain.com",
  "name": "Huobi ECO Chain Mainnet",
  "nativeCurrency": {
    "name": "Huobi ECO Chain Native Token",
    "symbol": "HT",
    "decimals": 18
  },
  "networkId": 128,
  "rpc": ["https://128.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://http-mainnet.hecochain.com", "wss://ws-mainnet.hecochain.com"],
  "shortName": "heco",
  "slip44": 1010,
  "slug": "huobi-eco-chain",
  "testnet": false
};

var c129 = {
  "chain": "INNOVATOR",
  "chainId": 129,
  "explorers": [{
    "name": "Innovator Explorer",
    "url": "https://evm.innovatorchain.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmVJBGeFYZXMQqicNdzctMfvPN5CrtRrfZBTw3CEpkCBsS",
    "width": 1500,
    "height": 1500,
    "format": "png"
  },
  "infoURL": "https://innovatorchain.com",
  "name": "Innovator Chain",
  "nativeCurrency": {
    "name": "INOV8",
    "symbol": "INOV8",
    "decimals": 18
  },
  "networkId": 129,
  "rpc": ["https://129.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.innovatorchain.com"],
  "shortName": "Innovator",
  "slug": "innovator-chain",
  "testnet": false
};

var c131 = {
  "chain": "tGRAM",
  "chainId": 131,
  "explorers": [{
    "name": "blockscout",
    "url": "https://tokioscan-v2.engram.tech",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreidn7dolavrzgqxthydb6rt5iwuzm6cvkxqirzh2szarjspsdp4kyu",
      "width": 400,
      "height": 400,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreidn7dolavrzgqxthydb6rt5iwuzm6cvkxqirzh2szarjspsdp4kyu",
    "width": 400,
    "height": 400,
    "format": "svg"
  },
  "infoURL": "https://engramnet.io",
  "name": "Engram Testnet",
  "nativeCurrency": {
    "name": "Engram Tokio Testnet",
    "symbol": "tGRAM",
    "decimals": 18
  },
  "networkId": 131,
  "rpc": ["https://131.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://tokioswift.engram.tech", "https://tokio-archive.engram.tech"],
  "shortName": "tgram",
  "slug": "engram-testnet",
  "testnet": true
};

var c134 = {
  "chain": "Bellecour",
  "chainId": 134,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscout.bellecour.iex.ec",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmUYKpVmZL4aS3TEZLG5wbrRJ6exxLiwm1rejfGYYNicfb",
    "width": 155,
    "height": 155,
    "format": "png"
  },
  "infoURL": "https://iex.ec",
  "name": "iExec Sidechain",
  "nativeCurrency": {
    "name": "xRLC",
    "symbol": "xRLC",
    "decimals": 18
  },
  "networkId": 134,
  "rpc": ["https://134.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://bellecour.iex.ec"],
  "shortName": "rlc",
  "slug": "iexec-sidechain",
  "testnet": false
};

var c135 = {
  "chain": "Alyx Chain Testnet",
  "chainId": 135,
  "explorers": [{
    "name": "alyx testnet scan",
    "url": "https://testnet.alyxscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.alyxchain.com"],
  "icon": {
    "url": "ipfs://bafkreifd43fcvh77mdcwjrpzpnlhthounc6b4u645kukqpqhduaveatf6i",
    "width": 2481,
    "height": 2481,
    "format": "png"
  },
  "infoURL": "https://www.alyxchain.com",
  "name": "Alyx Chain Testnet",
  "nativeCurrency": {
    "name": "Alyx Testnet Native Token",
    "symbol": "ALYX",
    "decimals": 18
  },
  "networkId": 135,
  "rpc": ["https://135.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.alyxchain.com"],
  "shortName": "AlyxTestnet",
  "slip44": 1,
  "slug": "alyx-chain-testnet",
  "testnet": true
};

var c136 = {
  "chain": "Deamchain",
  "chainId": 136,
  "explorers": [{
    "name": "Deamchain Block Explorer",
    "url": "https://scan.deamchain.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmXvHWmjfXKdZMSz7x82NR4SjEqigKdJELVHbnzUPkj17F",
      "width": 512,
      "height": 512,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmXvHWmjfXKdZMSz7x82NR4SjEqigKdJELVHbnzUPkj17F",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://deamchain.com",
  "name": "Deamchain Mainnet",
  "nativeCurrency": {
    "name": "Deamchain Native Token",
    "symbol": "DEAM",
    "decimals": 18
  },
  "networkId": 136,
  "rpc": ["https://136.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.deamchain.com"],
  "shortName": "deam",
  "slug": "deamchain",
  "testnet": false
};

var c137 = {
  "chain": "Polygon",
  "chainId": 137,
  "explorers": [{
    "name": "polygonscan",
    "url": "https://polygonscan.com",
    "standard": "EIP3091"
  }, {
    "name": "dexguru",
    "url": "https://polygon.dex.guru",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne",
      "width": 83,
      "height": 82,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/polygon/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://polygon.technology/",
  "name": "Polygon Mainnet",
  "nativeCurrency": {
    "name": "MATIC",
    "symbol": "MATIC",
    "decimals": 18
  },
  "networkId": 137,
  "redFlags": [],
  "rpc": ["https://137.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://polygon-mainnet.infura.io/v3/${INFURA_API_KEY}", "https://polygon-mainnet.g.alchemy.com/v2/${ALCHEMY_API_KEY}", "https://polygon-rpc.com/", "https://rpc-mainnet.matic.network", "https://matic-mainnet.chainstacklabs.com", "https://rpc-mainnet.maticvigil.com", "https://rpc-mainnet.matic.quiknode.pro", "https://matic-mainnet-full-rpc.bwarelabs.com", "https://polygon-bor-rpc.publicnode.com", "wss://polygon-bor-rpc.publicnode.com", "https://polygon.gateway.tenderly.co", "wss://polygon.gateway.tenderly.co", "https://polygon.drpc.org", "wss://polygon.drpc.org"],
  "shortName": "matic",
  "slip44": 966,
  "slug": "polygon",
  "testnet": false
};

var c138 = {
  "chain": "dfiometa",
  "chainId": 138,
  "ens": {
    "registry": "0x57f1887a8BF19b14fC0dF6Fd9B2acc9Af147eA85"
  },
  "explorers": [{
    "name": "Blockscout Explorer",
    "url": "https://blockscout.defi-oracle.io",
    "standard": "none"
  }, {
    "name": "Quorum Explorer",
    "url": "https://explorer.defi-oracle.io",
    "standard": "none"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmYrMRnjQJcNkYq9AvZ2FQ9kzYj9szzP4YDmyNA1ybd8xE",
    "width": 1000,
    "height": 1043,
    "format": "png"
  },
  "infoURL": "https://info.defi-oracle.io/",
  "name": "Defi Oracle Meta Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://138.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.defi-oracle.io", "wss://wss.defi-oracle.io"],
  "shortName": "dfio-meta-main",
  "slip44": 60,
  "slug": "defi-oracle-meta",
  "testnet": false
};

var c139 = {
  "chain": "WOOP",
  "chainId": 139,
  "explorers": [{
    "name": "wikiwoop",
    "url": "https://explorer.wikiwoop.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://Qma7LpnkGjAN1dwL6VTXUYqzySNxjLg4br7J8UE4yZWYec",
    "width": 310,
    "height": 310,
    "format": "png"
  },
  "infoURL": "https://wikiwoop.com",
  "name": "WoopChain Mainnet",
  "nativeCurrency": {
    "name": "WoopCoin",
    "symbol": "WOOC",
    "decimals": 18
  },
  "networkId": 139,
  "rpc": ["https://139.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.woop.ai/rpc"],
  "shortName": "woop",
  "slug": "woopchain",
  "testnet": false
};

var c141 = {
  "chain": "OPENPIECE",
  "chainId": 141,
  "explorers": [{
    "name": "Belly Scan",
    "url": "https://testnet.bellyscan.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVTahJkdSH3HPYsJMK2GmqfWZjLyxE7cXy1aHEnHU3vp2",
    "width": 250,
    "height": 250,
    "format": "png"
  },
  "infoURL": "https://cryptopiece.online",
  "name": "Openpiece Testnet",
  "nativeCurrency": {
    "name": "Belly",
    "symbol": "BELLY",
    "decimals": 18
  },
  "networkId": 141,
  "rpc": ["https://141.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.openpiece.io"],
  "shortName": "OPtest",
  "slip44": 1,
  "slug": "openpiece-testnet",
  "testnet": true
};

var c142 = {
  "chain": "DAX",
  "chainId": 142,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://prodax.io/",
  "name": "DAX CHAIN",
  "nativeCurrency": {
    "name": "Prodax",
    "symbol": "DAX",
    "decimals": 18
  },
  "networkId": 142,
  "rpc": ["https://142.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.prodax.io"],
  "shortName": "dax",
  "slug": "dax-chain",
  "testnet": false
};

var c144 = {
  "chain": "PHI",
  "chainId": 144,
  "explorers": [{
    "name": "Phiscan",
    "url": "https://phiscan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreid6pm3mic7izp3a6zlfwhhe7etd276bjfsq2xash6a4s2vmcdf65a",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreid6pm3mic7izp3a6zlfwhhe7etd276bjfsq2xash6a4s2vmcdf65a",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://phi.network",
  "name": "PHI Network v2",
  "nativeCurrency": {
    "name": "PHI",
    "symbol": "Φ",
    "decimals": 18
  },
  "networkId": 144,
  "rpc": ["https://144.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://connect.phi.network"],
  "shortName": "PHI",
  "slug": "phi-network-v2",
  "testnet": false
};

var c145 = {
  "chain": "SETH",
  "chainId": 145,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.soraai.bot",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt",
    "width": 1000,
    "height": 1628,
    "format": "png"
  },
  "infoURL": "https://soraai.bot",
  "name": "SoraAI Testnet",
  "nativeCurrency": {
    "name": "SoraETH",
    "symbol": "SETH",
    "decimals": 18
  },
  "networkId": 145,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.soraai.bot"
    }]
  },
  "rpc": ["https://145.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.soraai.bot"],
  "shortName": "SETH",
  "slip44": 1,
  "slug": "soraai-testnet",
  "testnet": true
};

var c148 = {
  "chain": "ShimmerEVM",
  "chainId": 148,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer.evm.shimmer.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreibky2sy6qhi6arktayvologkrgu5kudpgdxfkx4uosbvmstz7v4di",
      "width": 720,
      "height": 720,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreibky2sy6qhi6arktayvologkrgu5kudpgdxfkx4uosbvmstz7v4di",
    "width": 720,
    "height": 720,
    "format": "png"
  },
  "infoURL": "https://shimmer.network",
  "name": "ShimmerEVM",
  "nativeCurrency": {
    "name": "SMR",
    "symbol": "SMR",
    "decimals": 18
  },
  "networkId": 148,
  "rpc": ["https://148.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://json-rpc.evm.shimmer.network"],
  "shortName": "shimmerevm",
  "slug": "shimmerevm",
  "testnet": false,
  "title": "ShimmerEVM"
};

var c150 = {
  "chain": "FIVENET",
  "chainId": 150,
  "explorers": [{
    "name": "SIX Scan fivenet",
    "url": "https://sixscan.io/fivenet",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmP93z696v8Hetu13peY2oEHDXq8Bj5CqaDRwpVkpnM15A",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.sixprotocol.net"],
  "icon": {
    "url": "ipfs://QmP93z696v8Hetu13peY2oEHDXq8Bj5CqaDRwpVkpnM15A",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://six.network/",
  "name": "Six Protocol Testnet",
  "nativeCurrency": {
    "name": "SIX testnet evm token",
    "symbol": "tSIX",
    "decimals": 18
  },
  "networkId": 150,
  "rpc": ["https://150.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-evm.fivenet.sixprotocol.net"],
  "shortName": "sixt",
  "slug": "six-protocol-testnet",
  "testnet": true
};

var c151 = {
  "chain": "RBN",
  "chainId": 151,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://redbelly.network",
  "name": "Redbelly Network Mainnet",
  "nativeCurrency": {
    "name": "Redbelly Network Coin",
    "symbol": "RBNT",
    "decimals": 18
  },
  "networkId": 151,
  "rpc": [],
  "shortName": "rbn",
  "slug": "redbelly-network",
  "status": "incubating",
  "testnet": false
};

var c152 = {
  "chain": "RBN",
  "chainId": 152,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://redbelly.network",
  "name": "Redbelly Network Devnet",
  "nativeCurrency": {
    "name": "Redbelly Network Coin",
    "symbol": "RBNT",
    "decimals": 18
  },
  "networkId": 152,
  "rpc": [],
  "shortName": "rbn-devnet",
  "slug": "redbelly-network-devnet",
  "status": "incubating",
  "testnet": false
};

var c153 = {
  "chain": "RBN",
  "chainId": 153,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://redbelly.network",
  "name": "Redbelly Network Testnet",
  "nativeCurrency": {
    "name": "Redbelly Network Coin",
    "symbol": "RBNT",
    "decimals": 18
  },
  "networkId": 153,
  "rpc": [],
  "shortName": "rbn-testnet",
  "slip44": 1,
  "slug": "redbelly-network-testnet",
  "status": "incubating",
  "testnet": true
};

var c154 = {
  "chain": "RBN",
  "chainId": 154,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://redbelly.network",
  "name": "Redbelly Network TGE",
  "nativeCurrency": {
    "name": "Redbelly Network Coin",
    "symbol": "RBNT",
    "decimals": 18
  },
  "networkId": 154,
  "rpc": [],
  "shortName": "rbn-tge",
  "slug": "redbelly-network-tge",
  "testnet": false
};

var c155 = {
  "chain": "TENET",
  "chainId": 155,
  "explorers": [{
    "name": "TenetScan Testnet",
    "url": "https://testnet.tenetscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://Qmc1gqjWTzNo4pyFSGtQuCu7kRSZZBUVybtTjHn2nNEEPA",
      "width": 640,
      "height": 640,
      "format": "svg"
    }
  }],
  "faucets": ["https://faucet.testnet.tenet.org"],
  "icon": {
    "url": "ipfs://Qmc1gqjWTzNo4pyFSGtQuCu7kRSZZBUVybtTjHn2nNEEPA",
    "width": 640,
    "height": 640,
    "format": "svg"
  },
  "infoURL": "https://tenet.org/",
  "name": "Tenet Testnet",
  "nativeCurrency": {
    "name": "TENET",
    "symbol": "TENET",
    "decimals": 18
  },
  "networkId": 155,
  "rpc": ["https://155.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.tenet.org"],
  "shortName": "tenet-testnet",
  "slip44": 1,
  "slug": "tenet-testnet",
  "testnet": true,
  "title": "Tenet Testnet"
};

var c156 = {
  "chain": "OEBt",
  "chainId": 156,
  "explorers": [{
    "name": "OEScan explorer",
    "url": "https://testnet.oescan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmdoQUfYqtkWMfjtoPv2KWDY4MxDDSsyWgwXtCx6jfkezz",
    "width": 155,
    "height": 177,
    "format": "png"
  },
  "infoURL": "https://www.oeblock.com/",
  "name": "OEBlock Testnet",
  "nativeCurrency": {
    "name": "OEBlock",
    "symbol": "OEB",
    "decimals": 18
  },
  "networkId": 156,
  "rpc": ["https://156.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.oeblock.com"],
  "shortName": "obe",
  "slip44": 1,
  "slug": "oeblock-testnet",
  "testnet": true
};

var c157 = {
  "chain": "Puppynet Shibarium",
  "chainId": 157,
  "explorers": [{
    "name": "puppyscan",
    "url": "https://puppyscan.shib.io",
    "standard": "none"
  }],
  "faucets": ["https://beta.shibariumtech.com/faucet"],
  "icon": {
    "url": "ipfs://QmYNVkoZgRjDBQzJz6kog9mA2yPzQFW2oSKvhnkwuBhLQE",
    "width": 2000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://shibariumecosystem.com",
  "name": "Puppynet Shibarium",
  "nativeCurrency": {
    "name": "BONE",
    "symbol": "BONE",
    "decimals": 18
  },
  "networkId": 157,
  "rpc": ["https://157.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://puppynet.shibrpc.com"],
  "shortName": "puppynet",
  "slug": "puppynet-shibarium",
  "testnet": false
};

var c158 = {
  "chain": "RBA",
  "chainId": 158,
  "explorers": [{
    "name": "Rbascan Explorer",
    "url": "https://rbascan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmTk1uhB9nvnvXifvwEPGFcdgsXRt4EXNjovUGyUmfFRcB",
    "width": 4000,
    "height": 4000,
    "format": "png"
  },
  "infoURL": "https://www.roburna.com/",
  "name": "Roburna Mainnet",
  "nativeCurrency": {
    "name": "Roburna",
    "symbol": "RBA",
    "decimals": 18
  },
  "networkId": 158,
  "rpc": ["https://158.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dataseed.roburna.com"],
  "shortName": "rba",
  "slug": "roburna",
  "testnet": false
};

var c159 = {
  "chain": "RBAT",
  "chainId": 159,
  "explorers": [{
    "name": "Rbascan Testnet Explorer",
    "url": "https://testnet.rbascan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmTk1uhB9nvnvXifvwEPGFcdgsXRt4EXNjovUGyUmfFRcB",
    "width": 4000,
    "height": 4000,
    "format": "png"
  },
  "infoURL": "https://www.roburna.com/",
  "name": "Roburna Testnet",
  "nativeCurrency": {
    "name": "Roburna",
    "symbol": "RBAT",
    "decimals": 18
  },
  "networkId": 159,
  "rpc": ["https://159.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://preseed-testnet-1.roburna.com"],
  "shortName": "rbat",
  "slug": "roburna-testnet",
  "testnet": true
};

var c160 = {
  "chain": "Eva",
  "chainId": 160,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://amax.network",
  "name": "Armonia Eva Chain Mainnet",
  "nativeCurrency": {
    "name": "Armonia Multichain Native Token",
    "symbol": "AMAX",
    "decimals": 18
  },
  "networkId": 160,
  "rpc": ["https://160.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evascan.io/api/eth-rpc/"],
  "shortName": "eva",
  "slug": "armonia-eva-chain",
  "status": "incubating",
  "testnet": false
};

var c161 = {
  "chain": "Wall-e",
  "chainId": 161,
  "explorers": [{
    "name": "blockscout - evascan",
    "url": "https://testnet.evascan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://amax.network",
  "name": "Armonia Eva Chain Testnet",
  "nativeCurrency": {
    "name": "Armonia Multichain Native Token",
    "symbol": "AMAX",
    "decimals": 18
  },
  "networkId": 161,
  "rpc": ["https://161.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.evascan.io/api/eth-rpc/"],
  "shortName": "wall-e",
  "slip44": 1,
  "slug": "armonia-eva-chain-testnet",
  "testnet": true
};

var c162 = {
  "chain": "PHT",
  "chainId": 162,
  "explorers": [],
  "faucets": ["https://discuss.lightstreams.network/t/request-test-tokens"],
  "infoURL": "https://explorer.sirius.lightstreams.io",
  "name": "Lightstreams Testnet",
  "nativeCurrency": {
    "name": "Lightstreams PHT",
    "symbol": "PHT",
    "decimals": 18
  },
  "networkId": 162,
  "rpc": ["https://162.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node.sirius.lightstreams.io"],
  "shortName": "tpht",
  "slip44": 1,
  "slug": "lightstreams-testnet",
  "testnet": true
};

var c163 = {
  "chain": "PHT",
  "chainId": 163,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://explorer.lightstreams.io",
  "name": "Lightstreams Mainnet",
  "nativeCurrency": {
    "name": "Lightstreams PHT",
    "symbol": "PHT",
    "decimals": 18
  },
  "networkId": 163,
  "rpc": ["https://163.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node.mainnet.lightstreams.io"],
  "shortName": "pht",
  "slug": "lightstreams",
  "testnet": false
};

var c165 = {
  "chain": "Omni",
  "chainId": 165,
  "explorers": [{
    "name": "Omni Explorer",
    "url": "https://testnet.explorer.omni.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }],
  "infoURL": "https://docs.omni.network/",
  "name": "Omni Testnet",
  "nativeCurrency": {
    "name": "Omni",
    "symbol": "OMNI",
    "decimals": 18
  },
  "networkId": 165,
  "rpc": ["https://165.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.omni.network"],
  "shortName": "omni_testnet",
  "slip44": 1,
  "slug": "omni-testnet",
  "testnet": true
};

var c166 = {
  "chain": "Omni",
  "chainId": 166,
  "explorers": [],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }],
  "infoURL": "https://docs.omni.network/",
  "name": "Omni",
  "nativeCurrency": {
    "name": "Omni",
    "symbol": "OMNI",
    "decimals": 18
  },
  "networkId": 166,
  "rpc": [],
  "shortName": "omni",
  "slip44": 1,
  "slug": "omni",
  "status": "incubating",
  "testnet": false
};

var c167 = {
  "chain": "ATOSHI",
  "chainId": 167,
  "explorers": [{
    "name": "atoshiscan",
    "url": "https://scan.atoverse.info",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmfFK6B4MFLrpSS46aLf7hjpt28poHFeTGEKEuH248Tbyj",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://atoshi.org",
  "name": "Atoshi Testnet",
  "nativeCurrency": {
    "name": "ATOSHI",
    "symbol": "ATOS",
    "decimals": 18
  },
  "networkId": 167,
  "rpc": ["https://167.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node.atoshi.io/"],
  "shortName": "atoshi",
  "slip44": 1,
  "slug": "atoshi-testnet",
  "testnet": true
};

var c168 = {
  "chain": "AIOZ",
  "chainId": 168,
  "explorers": [{
    "name": "AIOZ Network Explorer",
    "url": "https://explorer.aioz.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRAGPFhvQiXgoJkui7WHajpKctGFrJNhHqzYdwcWt5V3Z",
    "width": 1024,
    "height": 1024,
    "format": "png"
  },
  "infoURL": "https://aioz.network",
  "name": "AIOZ Network",
  "nativeCurrency": {
    "name": "AIOZ",
    "symbol": "AIOZ",
    "decimals": 18
  },
  "networkId": 168,
  "rpc": ["https://168.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eth-dataseed.aioz.network"],
  "shortName": "aioz",
  "slip44": 60,
  "slug": "aioz-network",
  "testnet": false
};

var c169 = {
  "chain": "Manta Pacific",
  "chainId": 169,
  "explorers": [{
    "name": "manta-pacific Explorer",
    "url": "https://pacific-explorer.manta.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmTckcVTViRZ3NqT36MTt8AvgBSmudrbgU3pi8AaNtthoV",
    "width": 834,
    "height": 834,
    "format": "png"
  },
  "infoURL": "https://pacific-info.manta.network",
  "name": "Manta Pacific Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 169,
  "rpc": ["https://169.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://pacific-rpc.manta.network/http", "https://manta-pacific.drpc.org", "wss://manta-pacific.drpc.org"],
  "shortName": "manta",
  "slug": "manta-pacific",
  "testnet": false
};

var c170 = {
  "chain": "ETH",
  "chainId": 170,
  "explorers": [],
  "faucets": ["https://faucet-testnet.hscscan.com/"],
  "infoURL": "https://www.hoosmartchain.com",
  "name": "HOO Smart Chain Testnet",
  "nativeCurrency": {
    "name": "HOO",
    "symbol": "HOO",
    "decimals": 18
  },
  "networkId": 170,
  "rpc": ["https://170.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://http-testnet.hoosmartchain.com"],
  "shortName": "hoosmartchain",
  "slip44": 1,
  "slug": "hoo-smart-chain-testnet",
  "testnet": true
};

var c172 = {
  "chain": "Resil",
  "chainId": 172,
  "explorers": [],
  "faucets": ["https://faucet.latam-blockchain.com"],
  "infoURL": "https://latam-blockchain.com",
  "name": "Latam-Blockchain Resil Testnet",
  "nativeCurrency": {
    "name": "Latam-Blockchain Resil Test Native Token",
    "symbol": "usd",
    "decimals": 18
  },
  "networkId": 172,
  "rpc": ["https://172.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.latam-blockchain.com", "wss://ws.latam-blockchain.com"],
  "shortName": "resil",
  "slip44": 1,
  "slug": "latam-blockchain-resil-testnet",
  "testnet": true
};

var c180 = {
  "chain": "AME",
  "chainId": 180,
  "explorers": [{
    "name": "AME Scan",
    "url": "https://amescan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://amechain.io/",
  "name": "AME Chain Mainnet",
  "nativeCurrency": {
    "name": "AME",
    "symbol": "AME",
    "decimals": 18
  },
  "networkId": 180,
  "rpc": ["https://180.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node1.amechain.io/"],
  "shortName": "ame",
  "slug": "ame-chain",
  "testnet": false
};

var c186 = {
  "chain": "Seele",
  "chainId": 186,
  "explorers": [{
    "name": "seeleview",
    "url": "https://seeleview.net",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://seelen.pro/",
  "name": "Seele Mainnet",
  "nativeCurrency": {
    "name": "Seele",
    "symbol": "Seele",
    "decimals": 18
  },
  "networkId": 186,
  "rpc": ["https://186.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.seelen.pro/"],
  "shortName": "Seele",
  "slug": "seele",
  "testnet": false
};

var c188 = {
  "chain": "BMC",
  "chainId": 188,
  "explorers": [{
    "name": "Blockmeta",
    "url": "https://bmc.blockmeta.com",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://bmc.bytom.io/",
  "name": "BMC Mainnet",
  "nativeCurrency": {
    "name": "BTM",
    "symbol": "BTM",
    "decimals": 18
  },
  "networkId": 188,
  "rpc": ["https://188.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.bmcchain.com/"],
  "shortName": "BMC",
  "slug": "bmc",
  "testnet": false
};

var c189 = {
  "chain": "BMC",
  "chainId": 189,
  "explorers": [{
    "name": "Blockmeta",
    "url": "https://bmctestnet.blockmeta.com",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://bmc.bytom.io/",
  "name": "BMC Testnet",
  "nativeCurrency": {
    "name": "BTM",
    "symbol": "BTM",
    "decimals": 18
  },
  "networkId": 189,
  "rpc": ["https://189.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.bmcchain.com"],
  "shortName": "BMCT",
  "slip44": 1,
  "slug": "bmc-testnet",
  "testnet": true
};

var c191 = {
  "chain": "FFG",
  "chainId": 191,
  "explorers": [],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreihsas2rwakc7lllmtb4pcgwutlel2woibmqmhd4aiin342zgtpmwy",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://filefilego.com",
  "name": "FileFileGo",
  "nativeCurrency": {
    "name": "FFG",
    "symbol": "FFG",
    "decimals": 18
  },
  "networkId": 191,
  "rpc": ["https://191.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.filefilego.com/rpc"],
  "shortName": "ffg",
  "slug": "filefilego",
  "testnet": false
};

var c193 = {
  "chain": "CEM",
  "chainId": 193,
  "explorers": [{
    "name": "cemscan",
    "url": "https://cemscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://cemblockchain.com/",
  "name": "Crypto Emergency",
  "nativeCurrency": {
    "name": "Crypto Emergency",
    "symbol": "CEM",
    "decimals": 18
  },
  "networkId": 193,
  "rpc": ["https://193.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://cemchain.com"],
  "shortName": "cem",
  "slug": "crypto-emergency",
  "testnet": false
};

var c195 = {
  "chain": "X1",
  "chainId": 195,
  "explorers": [{
    "name": "OKLink",
    "url": "https://www.oklink.com/x1-test",
    "standard": "EIP3091"
  }],
  "faucets": ["https://www.okx.com/x1/faucet"],
  "features": [],
  "infoURL": "https://www.okx.com/x1",
  "name": "X1 Testnet",
  "nativeCurrency": {
    "name": "X1 Global Utility Token in testnet",
    "symbol": "OKB",
    "decimals": 18
  },
  "networkId": 195,
  "rpc": ["https://195.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testrpc.x1.tech", "https://x1testrpc.okx.com"],
  "shortName": "tokb",
  "slip44": 1,
  "slug": "x1-testnet",
  "status": "active",
  "testnet": true
};

var c196 = {
  "chain": "X1",
  "chainId": 196,
  "explorers": [],
  "faucets": [],
  "features": [],
  "infoURL": "https://www.okx.com/x1",
  "name": "X1 Mainnet",
  "nativeCurrency": {
    "name": "X1 Global Utility Token",
    "symbol": "OKB",
    "decimals": 18
  },
  "networkId": 196,
  "rpc": [],
  "shortName": "okb",
  "slug": "x1",
  "status": "incubating",
  "testnet": false
};

var c197 = {
  "chain": "NEUTR",
  "chainId": 197,
  "explorers": [{
    "name": "blockscout",
    "url": "https://testnet.neutrinoschain.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://neutrinoschain.com/faucet"],
  "infoURL": "https://docs.neutrinoschain.com",
  "name": "Neutrinos TestNet",
  "nativeCurrency": {
    "name": "Neutrinos",
    "symbol": "NEUTR",
    "decimals": 18
  },
  "networkId": 197,
  "rpc": ["https://197.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.neutrinoschain.com"],
  "shortName": "NEUTR",
  "slip44": 1,
  "slug": "neutrinos-testnet",
  "testnet": true
};

var c198 = {
  "chain": "Bit",
  "chainId": 198,
  "explorers": [{
    "name": "Bitchain Scan",
    "url": "https://explorer.bitchain.biz",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.bitchain.biz/",
  "name": "Bitchain Mainnet",
  "nativeCurrency": {
    "name": "Bitcoin",
    "symbol": "BTC",
    "decimals": 18
  },
  "networkId": 198,
  "rpc": ["https://198.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.bitchain.biz/"],
  "shortName": "bit",
  "slug": "bitchain",
  "testnet": false
};

var c199 = {
  "chain": "BTTC",
  "chainId": 199,
  "explorers": [{
    "name": "BitTorrent Chain Explorer",
    "url": "https://bttcscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://bt.io",
  "name": "BitTorrent Chain Mainnet",
  "nativeCurrency": {
    "name": "BitTorrent",
    "symbol": "BTT",
    "decimals": 18
  },
  "networkId": 199,
  "rpc": ["https://199.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.bt.io", "https://bittorrent.drpc.org", "wss://bittorrent.drpc.org"],
  "shortName": "BTT",
  "slug": "bittorrent-chain",
  "testnet": false
};

var c200 = {
  "chain": "AOX",
  "chainId": 200,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscout.com/xdai/arbitrum",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://xdaichain.com",
  "name": "Arbitrum on xDai",
  "nativeCurrency": {
    "name": "xDAI",
    "symbol": "xDAI",
    "decimals": 18
  },
  "networkId": 200,
  "parent": {
    "type": "L2",
    "chain": "eip155-100"
  },
  "rpc": ["https://200.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://arbitrum.xdaichain.com/"],
  "shortName": "aox",
  "slug": "arbitrum-on-xdai",
  "testnet": false
};

var c201 = {
  "chain": "MOAC",
  "chainId": 201,
  "explorers": [{
    "name": "moac testnet explorer",
    "url": "https://testnet.moac.io",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://moac.io",
  "name": "MOAC testnet",
  "nativeCurrency": {
    "name": "MOAC",
    "symbol": "mc",
    "decimals": 18
  },
  "networkId": 201,
  "rpc": ["https://201.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://gateway.moac.io/testnet"],
  "shortName": "moactest",
  "slip44": 1,
  "slug": "moac-testnet",
  "testnet": true
};

var c204 = {
  "chain": "opBNB",
  "chainId": 204,
  "explorers": [{
    "name": "opbnbscan",
    "url": "https://mainnet.opbnbscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeib75gwytvblyvjpfminitr3i6mpat3a624udfsqsl5nysf5vuuvie",
    "width": 96,
    "height": 96,
    "format": "png"
  },
  "infoURL": "https://opbnb.bnbchain.org/en",
  "name": "opBNB Mainnet",
  "nativeCurrency": {
    "name": "BNB Chain Native Token",
    "symbol": "BNB",
    "decimals": 18
  },
  "networkId": 204,
  "rpc": ["https://204.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://opbnb-mainnet-rpc.bnbchain.org", "https://opbnb-mainnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3", "wss://opbnb-mainnet.nodereal.io/ws/v1/64a9df0874fb4a93b9d0a3849de012d3", "https://opbnb-mainnet.nodereal.io/v1/e9a36765eb8a40b9bd12e680a1fd2bc5", "wss://opbnb-mainnet.nodereal.io/ws/v1/e9a36765eb8a40b9bd12e680a1fd2bc5", "https://opbnb-rpc.publicnode.com", "wss://opbnb-rpc.publicnode.com", "https://opbnb.drpc.org", "wss://opbnb.drpc.org"],
  "shortName": "obnb",
  "slip44": 714,
  "slug": "opbnb",
  "testnet": false
};

var c206 = {
  "chain": "VinuChain Testnet",
  "chainId": 206,
  "explorers": [{
    "name": "VinuScan Testnet",
    "url": "https://testnet.vinuscan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreiayq7a5qncxzlilfnvpgzt4pwfxbof2qrqr2nyd2suztfummpty4i",
      "width": 2000,
      "height": 2000,
      "format": "jpg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreidtie4srt52ry67wd3dpxhklmug2ozrawvf3jdlljveinp3frutra",
    "width": 2000,
    "height": 392,
    "format": "png"
  },
  "infoURL": "https://vitainu.org",
  "name": "VinuChain Testnet",
  "nativeCurrency": {
    "name": "VinuChain",
    "symbol": "VC",
    "decimals": 18
  },
  "networkId": 206,
  "rpc": ["https://206.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://vinufoundation-rpc.com"],
  "shortName": "VCTEST",
  "slip44": 1,
  "slug": "vinuchain-testnet",
  "testnet": true
};

var c207 = {
  "chain": "VinuChain",
  "chainId": 207,
  "explorers": [{
    "name": "VinuScan",
    "url": "https://vinuscan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreiayq7a5qncxzlilfnvpgzt4pwfxbof2qrqr2nyd2suztfummpty4i",
      "width": 2000,
      "height": 2000,
      "format": "jpg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeiderli6uaaxk7eboyf7g4abnybgrkbglmqbkmf25z57ode7zdzmvy",
    "width": 613,
    "height": 613,
    "format": "png"
  },
  "infoURL": "https://vitainu.org",
  "name": "VinuChain Network",
  "nativeCurrency": {
    "name": "VinuChain",
    "symbol": "VC",
    "decimals": 18
  },
  "networkId": 207,
  "rpc": ["https://207.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://vinuchain-rpc.com"],
  "shortName": "VC",
  "slug": "vinuchain-network",
  "testnet": false
};

var c208 = {
  "chain": "utx",
  "chainId": 208,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://structx.io",
  "name": "Structx Mainnet",
  "nativeCurrency": {
    "name": "Notes",
    "symbol": "utx",
    "decimals": 18
  },
  "networkId": 208,
  "rpc": ["https://208.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.structx.io"],
  "shortName": "utx",
  "slug": "structx",
  "testnet": false
};

var c210 = {
  "chain": "BTN",
  "chainId": 210,
  "explorers": [{
    "name": "Bitnet Explorer",
    "url": "https://btnscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmS9h3nFiCzaBLnBNw8Wot4U7vvEVK45EQfi8nxH4nvrmz",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://bitnet.money",
  "name": "Bitnet",
  "nativeCurrency": {
    "name": "Bitnet",
    "symbol": "BTN",
    "decimals": 18
  },
  "networkId": 210,
  "rpc": ["https://210.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.bitnet.money", "https://rpc.btnscan.com"],
  "shortName": "BTN",
  "slug": "bitnet",
  "testnet": false
};

var c211 = {
  "chain": "EDI",
  "chainId": 211,
  "explorers": [],
  "faucets": ["http://faucet.freight.sh"],
  "infoURL": "https://freighttrust.com",
  "name": "Freight Trust Network",
  "nativeCurrency": {
    "name": "Freight Trust Native",
    "symbol": "0xF",
    "decimals": 18
  },
  "networkId": 0,
  "rpc": ["https://211.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://13.57.207.168:3435", "https://app.freighttrust.net/ftn/${API_KEY}"],
  "shortName": "EDI",
  "slug": "freight-trust-network",
  "testnet": false
};

var c212 = {
  "chain": "MAPO",
  "chainId": 212,
  "explorers": [{
    "name": "maposcan",
    "url": "https://testnet.maposcan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.mapprotocol.io"],
  "infoURL": "https://mapprotocol.io/",
  "name": "MAPO Makalu",
  "nativeCurrency": {
    "name": "Makalu MAPO",
    "symbol": "MAPO",
    "decimals": 18
  },
  "networkId": 212,
  "rpc": ["https://212.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.maplabs.io"],
  "shortName": "makalu",
  "slug": "mapo-makalu",
  "testnet": true,
  "title": "MAPO Testnet Makalu"
};

var c214 = {
  "chain": "Shinarium",
  "chainId": 214,
  "explorers": [{
    "name": "shinascan",
    "url": "https://shinascan.shinarium.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeiadbavrwcial76vs5ovhyykyaobteltuhliqcthdairbja4klwzhu",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://shinarium.org",
  "name": "Shinarium Mainnet",
  "nativeCurrency": {
    "name": "Shina Inu",
    "symbol": "SHI",
    "decimals": 18
  },
  "networkId": 214,
  "rpc": ["https://214.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.shinarium.org"],
  "shortName": "shinarium",
  "slug": "shinarium",
  "testnet": false
};

var c217 = {
  "chain": "SIN2",
  "chainId": 217,
  "explorers": [{
    "name": "siriusnet explorer",
    "url": "https://scan.siriusnet.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeicxuxdzrzpwsil4owqmn7wpwka2rqsohpfqmukg57pifzyxr5om2q",
    "width": 100,
    "height": 100,
    "format": "png"
  },
  "infoURL": "https://siriusnet.io",
  "name": "SiriusNet V2",
  "nativeCurrency": {
    "name": "MCD",
    "symbol": "MCD",
    "decimals": 18
  },
  "networkId": 217,
  "rpc": ["https://217.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc2.siriusnet.io"],
  "shortName": "SIN2",
  "slug": "siriusnet-v2",
  "testnet": false
};

var c218 = {
  "chain": "SOTER",
  "chainId": 218,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.soterone.com",
  "name": "SoterOne Mainnet old",
  "nativeCurrency": {
    "name": "SoterOne Mainnet Ether",
    "symbol": "SOTER",
    "decimals": 18
  },
  "networkId": 218,
  "rpc": ["https://218.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.soter.one"],
  "shortName": "SO1-old",
  "slug": "soterone-old",
  "status": "deprecated",
  "testnet": false
};

var c220 = {
  "chain": "Flag",
  "chainId": 220,
  "explorers": [{
    "name": "flagscan",
    "url": "https://scan.flagscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmXo2p1i4zsbTNEu41EjjrhdmbKFDGHEHeADXZ3x2fgNKE/1682003789585.jpeg",
    "width": 200,
    "height": 200,
    "format": "jpeg"
  },
  "infoURL": "https://flagblockchain.com/",
  "name": "Flag Mainnet",
  "nativeCurrency": {
    "name": "Flag",
    "symbol": "Flag",
    "decimals": 18
  },
  "networkId": 220,
  "redFlags": [],
  "rpc": ["https://220.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.flagscan.io/"],
  "shortName": "Flag",
  "slug": "flag",
  "testnet": false
};

var c222 = {
  "chain": "ASK",
  "chainId": 222,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://permission.io/",
  "name": "Permission",
  "nativeCurrency": {
    "name": "ASK",
    "symbol": "ASK",
    "decimals": 18
  },
  "networkId": 2221,
  "rpc": ["https://222.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://blockchain-api-mainnet.permission.io/rpc"],
  "shortName": "ASK",
  "slip44": 2221,
  "slug": "permission",
  "status": "deprecated",
  "testnet": false
};

var c224 = {
  "chain": "VRD",
  "chainId": 224,
  "explorers": [{
    "name": "Viridis Testnet",
    "url": "https://testnet.vrd.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.vrd.network"],
  "icon": {
    "url": "ipfs://QmPdxcJwPogfZdec7UAqxeatRxrivEktpP1ftJBTeJQTdR",
    "width": 3000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://viridis.network",
  "name": "Viridis Testnet",
  "nativeCurrency": {
    "name": "Viridis Token",
    "symbol": "VRD",
    "decimals": 18
  },
  "networkId": 224,
  "rpc": ["https://224.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.vrd.network"],
  "shortName": "VRD-Testnet",
  "slug": "viridis-testnet",
  "testnet": true
};

var c225 = {
  "chain": "LA",
  "chainId": 225,
  "explorers": [{
    "name": "blockscout",
    "url": "https://scan.lachain.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQxGA6rhuCQDXUueVcNvFRhMEWisyTmnF57TqL7h6k6cZ",
    "width": 1280,
    "height": 1280,
    "format": "png"
  },
  "infoURL": "https://lachain.io",
  "name": "LACHAIN Mainnet",
  "nativeCurrency": {
    "name": "LA",
    "symbol": "LA",
    "decimals": 18
  },
  "networkId": 225,
  "rpc": ["https://225.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mainnet.lachain.io"],
  "shortName": "LA",
  "slug": "lachain",
  "testnet": false
};

var c226 = {
  "chain": "TLA",
  "chainId": 226,
  "explorers": [{
    "name": "blockscout",
    "url": "https://scan-test.lachain.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQxGA6rhuCQDXUueVcNvFRhMEWisyTmnF57TqL7h6k6cZ",
    "width": 1280,
    "height": 1280,
    "format": "png"
  },
  "infoURL": "https://lachain.io",
  "name": "LACHAIN Testnet",
  "nativeCurrency": {
    "name": "TLA",
    "symbol": "TLA",
    "decimals": 18
  },
  "networkId": 226,
  "rpc": ["https://226.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.lachain.io"],
  "shortName": "TLA",
  "slip44": 1,
  "slug": "lachain-testnet",
  "testnet": true
};

var c230 = {
  "chain": "SDX",
  "chainId": 230,
  "explorers": [{
    "name": "SwapDEX",
    "url": "https://evm.swapdex.network",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://swapdex.network/",
  "name": "SwapDEX",
  "nativeCurrency": {
    "name": "SwapDEX",
    "symbol": "SDX",
    "decimals": 18
  },
  "networkId": 230,
  "rpc": ["https://230.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.swapdex.network", "wss://ss.swapdex.network"],
  "shortName": "SDX",
  "slug": "swapdex",
  "testnet": false
};

var c234 = {
  "chain": "Jumbo",
  "chainId": 234,
  "explorers": [{
    "name": "ProtoJumbo",
    "url": "https://protojumbo.jumbochain.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://protojumbo.jumbochain.org/faucet-smart"],
  "features": [{
    "name": "EIP155"
  }],
  "infoURL": "https://jumbochain.org",
  "name": "ProtoJumbo Testnet",
  "nativeCurrency": {
    "name": "JNFTC",
    "symbol": "JNFTC",
    "decimals": 18
  },
  "networkId": 234,
  "rpc": ["https://234.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnode.jumbochain.org"],
  "shortName": "ProtoJumbo",
  "slip44": 1,
  "slug": "protojumbo-testnet",
  "testnet": true
};

var c236 = {
  "chain": "Deamchain",
  "chainId": 236,
  "explorers": [{
    "name": "Deamchain Testnet Explorer",
    "url": "https://testnet-scan.deamchain.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmXvHWmjfXKdZMSz7x82NR4SjEqigKdJELVHbnzUPkj17F",
      "width": 512,
      "height": 512,
      "format": "svg"
    }
  }],
  "faucets": ["https://faucet.deamchain.com"],
  "icon": {
    "url": "ipfs://QmXvHWmjfXKdZMSz7x82NR4SjEqigKdJELVHbnzUPkj17F",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://deamchain.com",
  "name": "Deamchain Testnet",
  "nativeCurrency": {
    "name": "Deamchain Native Token",
    "symbol": "DEAM",
    "decimals": 18
  },
  "networkId": 236,
  "rpc": ["https://236.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.deamchain.com"],
  "shortName": "deamtest",
  "slip44": 1,
  "slug": "deamchain-testnet",
  "testnet": true
};

var c238 = {
  "chain": "ETH",
  "chainId": 238,
  "explorers": [{
    "name": "Blast Mainnet",
    "url": "https://scan.blastblockchain.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdHpjiepU2Q4bt4kR48tKHPgaQW57Sb6UVFgLh4MCyg6U",
    "width": 595,
    "height": 582,
    "format": "png"
  },
  "infoURL": "https://docs.blastblockchain.com",
  "name": "Blast Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 238,
  "rpc": ["https://238.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.blastblockchain.com"],
  "shortName": "blast",
  "slug": "blast",
  "testnet": false
};

var c242 = {
  "chain": "Plinga",
  "chainId": 242,
  "explorers": [{
    "name": "plgscan",
    "url": "https://www.plgscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeibpvlod5nyev6wyuvp6pbestmgvru3ovbadsul32odpno26xwld6y",
    "width": 1039,
    "height": 1022,
    "format": "svg"
  },
  "infoURL": "https://www.plinga.technology/",
  "name": "Plinga Mainnet",
  "nativeCurrency": {
    "name": "Plinga",
    "symbol": "PLINGA",
    "decimals": 18
  },
  "networkId": 242,
  "rpc": ["https://242.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpcurl.mainnet.plgchain.com", "https://rpcurl.plgchain.blockchain.evmnode.online", "https://rpcurl.mainnet.plgchain.plinga.technology"],
  "shortName": "plgchain",
  "slug": "plinga",
  "testnet": false
};

var c246 = {
  "chain": "Energy Web Chain",
  "chainId": 246,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.energyweb.org",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://energyweb.org",
  "name": "Energy Web Chain",
  "nativeCurrency": {
    "name": "Energy Web Token",
    "symbol": "EWT",
    "decimals": 18
  },
  "networkId": 246,
  "rpc": ["https://246.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.energyweb.org", "wss://rpc.energyweb.org/ws"],
  "shortName": "ewt",
  "slip44": 246,
  "slug": "energy-web-chain",
  "testnet": false
};

var c248 = {
  "chain": "Oasys",
  "chainId": 248,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.oasys.games",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmYcGHTPheBwLv9zoJfQAJ7NB6MCtXe2zV7XqPyiTJg3WP/Oasys_Large%20Logo%20Black.png",
    "width": 1250,
    "height": 1250,
    "format": ".png"
  },
  "infoURL": "https://oasys.games",
  "name": "Oasys Mainnet",
  "nativeCurrency": {
    "name": "OAS",
    "symbol": "OAS",
    "decimals": 18
  },
  "networkId": 248,
  "redFlags": [],
  "rpc": ["https://248.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.mainnet.oasys.games"],
  "shortName": "OAS",
  "slug": "oasys",
  "testnet": false
};

var c250 = {
  "chain": "FTM",
  "chainId": 250,
  "explorers": [{
    "name": "ftmscan",
    "url": "https://ftmscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRqbK449Fo9sJ3xMpkPbg6uV1weQj4yVV1xNMP9cdPmjf",
      "width": 73,
      "height": 73,
      "format": "png"
    }
  }, {
    "name": "dexguru",
    "url": "https://fantom.dex.guru",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne",
      "width": 83,
      "height": 82,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/fantom/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://fantom.foundation",
  "name": "Fantom Opera",
  "nativeCurrency": {
    "name": "Fantom",
    "symbol": "FTM",
    "decimals": 18
  },
  "networkId": 250,
  "redFlags": [],
  "rpc": ["https://250.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.ftm.tools", "https://fantom-rpc.publicnode.com", "wss://fantom-rpc.publicnode.com", "https://fantom.drpc.org", "wss://fantom.drpc.org"],
  "shortName": "ftm",
  "slug": "fantom",
  "testnet": false
};

var c252 = {
  "chain": "FRAX",
  "chainId": 252,
  "explorers": [{
    "name": "fraxscan",
    "url": "https://fraxscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmQLJk5G7zF8ZDxSxkRcpHqEqcifrJEhGmEKC6zwyPXWAw/fraxchain.png",
    "width": 512,
    "height": 512,
    "format": "PNG"
  },
  "infoURL": "https://mainnet.frax.com",
  "name": "Fraxtal",
  "nativeCurrency": {
    "name": "Frax Ether",
    "symbol": "frxETH",
    "decimals": 18
  },
  "networkId": 252,
  "redFlags": [],
  "rpc": ["https://252.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.frax.com"],
  "shortName": "fraxtal",
  "slug": "fraxtal",
  "status": "active",
  "testnet": false
};

var c255 = {
  "chain": "ETH",
  "chainId": 255,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscout.kroma.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmVpV2WET6ZrqnvvPfE9hCwoE2y5ygbPuniuugpaRoxrho",
    "width": 320,
    "height": 320,
    "format": "svg"
  },
  "infoURL": "https://kroma.network",
  "name": "Kroma",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 255,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://kroma.network/bridge"
    }]
  },
  "redFlags": [],
  "rpc": ["https://255.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.kroma.network", "https://1rpc.io/kroma"],
  "shortName": "kroma",
  "slug": "kroma",
  "testnet": false
};

var c256 = {
  "chain": "Heco",
  "chainId": 256,
  "explorers": [],
  "faucets": ["https://scan-testnet.hecochain.com/faucet"],
  "infoURL": "https://testnet.hecoinfo.com",
  "name": "Huobi ECO Chain Testnet",
  "nativeCurrency": {
    "name": "Huobi ECO Chain Test Native Token",
    "symbol": "htt",
    "decimals": 18
  },
  "networkId": 256,
  "rpc": ["https://256.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://http-testnet.hecochain.com", "wss://ws-testnet.hecochain.com"],
  "shortName": "hecot",
  "slug": "huobi-eco-chain-testnet",
  "testnet": true
};

var c258 = {
  "chain": "Setheum",
  "chainId": 258,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://setheum.xyz",
  "name": "Setheum",
  "nativeCurrency": {
    "name": "Setheum",
    "symbol": "SETM",
    "decimals": 18
  },
  "networkId": 258,
  "rpc": [],
  "shortName": "setm",
  "slug": "setheum",
  "testnet": false
};

var c259 = {
  "chain": "Neonlink",
  "chainId": 259,
  "explorers": [{
    "name": "Neon Blockchain Explorer",
    "url": "https://scan.neonlink.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmX3hBv8WyvVfYjh1gmgDfJCpJBvKk4TYG9wFX9sC8WAjz",
      "width": 512,
      "height": 512,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmX3hBv8WyvVfYjh1gmgDfJCpJBvKk4TYG9wFX9sC8WAjz",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://neonlink.io",
  "name": "Neonlink Mainnet",
  "nativeCurrency": {
    "name": "Neonlink Native Token",
    "symbol": "NEON",
    "decimals": 18
  },
  "networkId": 259,
  "rpc": ["https://259.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.neonlink.io"],
  "shortName": "neon",
  "slug": "neonlink",
  "testnet": false
};

var c262 = {
  "chain": "SUR",
  "chainId": 262,
  "explorers": [{
    "name": "Surnet Explorer",
    "url": "https://explorer.surnet.org",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmbUcDQHCvheYQrWk9WFJRMW5fTJQmtZqkoGUed4bhCM7T",
      "width": 3000,
      "height": 3000,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmbUcDQHCvheYQrWk9WFJRMW5fTJQmtZqkoGUed4bhCM7T",
    "width": 3000,
    "height": 3000,
    "format": "png"
  },
  "infoURL": "https://surnet.org",
  "name": "SUR Blockchain Network",
  "nativeCurrency": {
    "name": "Suren",
    "symbol": "SRN",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://262.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sur.nilin.org"],
  "shortName": "SUR",
  "slug": "sur-blockchain-network",
  "testnet": false
};

var c266 = {
  "chain": "NEURA",
  "chainId": 266,
  "explorers": [],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmWdpK5WFKrosaCSpJRCvU7uXeKk2qVeCckTxh6Zw2JrK8",
    "width": 600,
    "height": 600,
    "format": "png"
  },
  "infoURL": "https://www.neuraprotocol.io/",
  "name": "Neura",
  "nativeCurrency": {
    "name": "Ankr",
    "symbol": "ANKR",
    "decimals": 18
  },
  "networkId": 266,
  "rpc": [],
  "shortName": "neura",
  "slug": "neura",
  "status": "incubating",
  "testnet": false,
  "title": "Neura Mainnet"
};

var c267 = {
  "chain": "NEURA",
  "chainId": 267,
  "explorers": [],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmWdpK5WFKrosaCSpJRCvU7uXeKk2qVeCckTxh6Zw2JrK8",
    "width": 600,
    "height": 600,
    "format": "png"
  },
  "infoURL": "https://www.neuraprotocol.io/",
  "name": "Neura Testnet",
  "nativeCurrency": {
    "name": "Testnet Ankr",
    "symbol": "ANKR",
    "decimals": 18
  },
  "networkId": 267,
  "rpc": [],
  "shortName": "tneura",
  "slip44": 1,
  "slug": "neura-testnet",
  "status": "incubating",
  "testnet": true,
  "title": "Neura Testnet"
};

var c268 = {
  "chain": "NEURA",
  "chainId": 268,
  "explorers": [],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmWdpK5WFKrosaCSpJRCvU7uXeKk2qVeCckTxh6Zw2JrK8",
    "width": 600,
    "height": 600,
    "format": "png"
  },
  "infoURL": "https://www.neuraprotocol.io/",
  "name": "Neura Devnet",
  "nativeCurrency": {
    "name": "Devnet Ankr",
    "symbol": "ANKR",
    "decimals": 18
  },
  "networkId": 268,
  "rpc": [],
  "shortName": "dneura",
  "slip44": 1,
  "slug": "neura-devnet",
  "status": "incubating",
  "testnet": false,
  "title": "Neura Devnet"
};

var c269 = {
  "chain": "HPB",
  "chainId": 269,
  "explorers": [{
    "name": "hscan",
    "url": "https://hscan.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://myhpbwallet.com/"],
  "infoURL": "https://hpb.io",
  "name": "High Performance Blockchain",
  "nativeCurrency": {
    "name": "High Performance Blockchain Ether",
    "symbol": "HPB",
    "decimals": 18
  },
  "networkId": 269,
  "rpc": ["https://269.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://hpbnode.com", "wss://ws.hpbnode.com"],
  "shortName": "hpb",
  "slip44": 269,
  "slug": "high-performance-blockchain",
  "testnet": false
};

var c271 = {
  "chain": "EGON",
  "chainId": 271,
  "explorers": [{
    "name": "EgonCoin Mainnet",
    "url": "https://egonscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNZiMmzMQYjyGtNSghtzLg4UooYhDgMQsa677DAP5KsBg",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://egonscan.com",
  "name": "EgonCoin Mainnet",
  "nativeCurrency": {
    "name": "EgonCoin",
    "symbol": "EGON",
    "decimals": 18
  },
  "networkId": 271,
  "rpc": ["https://271.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.egonscan.com"],
  "shortName": "EGONm",
  "slug": "egoncoin",
  "testnet": false
};

var c274 = {
  "chain": "LaChain",
  "chainId": 274,
  "explorers": [{
    "name": "LaChain Explorer",
    "url": "https://explorer.lachain.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmQxGA6rhuCQDXUueVcNvFRhMEWisyTmnF57TqL7h6k6cZ",
    "width": 1280,
    "height": 1280,
    "format": "png"
  },
  "name": "LaChain",
  "nativeCurrency": {
    "name": "LaCoin",
    "symbol": "LAC",
    "decimals": 18
  },
  "networkId": 274,
  "rpc": ["https://274.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc1.mainnet.lachain.network", "https://rpc2.mainnet.lachain.network", "https://lachain.rpc-nodes.cedalio.dev"],
  "shortName": "lachain",
  "slug": "lachain-lachain",
  "testnet": false
};

var c279 = {
  "chain": "BPX",
  "chainId": 279,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreiatcu42wbjlo24mr35jou4awvsqpaqys6iv4kxgkjhno3haovsiaq",
    "width": 140,
    "height": 140,
    "format": "svg"
  },
  "infoURL": "https://bpxchain.cc",
  "name": "BPX Blockchain",
  "nativeCurrency": {
    "name": "BPX",
    "symbol": "BPX",
    "decimals": 18
  },
  "networkId": 279,
  "rpc": ["https://279.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.mainnet.bpxchain.cc", "https://bpx-dataseed.infinex.cc"],
  "shortName": "bpx",
  "slug": "bpx-blockchain",
  "testnet": false
};

var c280 = {
  "chain": "ETH",
  "chainId": 280,
  "explorers": [{
    "name": "zkSync Era Block Explorer",
    "url": "https://goerli.explorer.zksync.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRkhUD6J3B9WhT4hEWLrcFVTrBhx3CQgNC783aJsrwxSN",
      "width": 512,
      "height": 512,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmRkhUD6J3B9WhT4hEWLrcFVTrBhx3CQgNC783aJsrwxSN",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://zksync.io/",
  "name": "zkSync Era Goerli Testnet (deprecated)",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 280,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.zksync.io/"
    }]
  },
  "redFlags": [],
  "rpc": ["https://280.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.era.zksync.dev"],
  "shortName": "zksync-goerli",
  "slip44": 1,
  "slug": "zksync-era-goerli-testnet-deprecated",
  "status": "deprecated",
  "testnet": true
};

var c282 = {
  "chain": "CronosZkEVMTestnet",
  "chainId": 282,
  "explorers": [{
    "name": "Cronos zkEVM Testnet Explorer",
    "url": "https://zkevm-t0.cronos.org/explorer",
    "standard": "none"
  }],
  "faucets": ["https://zkevm-t0.cronos.org/faucet"],
  "infoURL": "https://docs.cronos.org/cronos-zkevm-chain/introduction-to-cronos-zkevm-chain-testnet",
  "name": "Cronos zkEVM Testnet",
  "nativeCurrency": {
    "name": "Cronos zkEVM Test Coin",
    "symbol": "TCRO",
    "decimals": 18
  },
  "networkId": 282,
  "rpc": ["https://282.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-zkevm-t0.cronos.org"],
  "shortName": "zktcro",
  "slip44": 1,
  "slug": "cronos-zkevm-testnet",
  "testnet": true
};

var c288 = {
  "chain": "ETH",
  "chainId": 288,
  "explorers": [{
    "name": "Bobascan",
    "url": "https://bobascan.com",
    "standard": "none"
  }, {
    "name": "Blockscout",
    "url": "https://blockexplorer.boba.network",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://boba.network",
  "name": "Boba Network",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 288,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://gateway.boba.network"
    }]
  },
  "rpc": ["https://288.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.boba.network", "https://replica.boba.network", "https://boba-ethereum.gateway.tenderly.co", "https://gateway.tenderly.co/public/boba-ethereum", "wss://boba-ethereum.gateway.tenderly.co/", "wss://gateway.tenderly.co/public/boba-ethereum", "https://boba-eth.drpc.org", "wss://boba-eth.drpc.org"],
  "shortName": "Boba",
  "slug": "boba-network",
  "testnet": false
};

var c291 = {
  "chain": "ETH",
  "chainId": 291,
  "explorers": [{
    "name": "orderlyscout",
    "url": "https://explorer.orderly.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmSpwp3RAVhZsErAQrCQxEmjnGqJQMigarzZbfqr9Ktakb",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "name": "Orderly Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 291,
  "rpc": ["https://291.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.orderly.network", "https://l2-orderly-mainnet-0.t.conduit.xyz"],
  "shortName": "orderly",
  "slug": "orderly",
  "testnet": false
};

var c295 = {
  "chain": "Hedera",
  "chainId": 295,
  "explorers": [{
    "name": "HashScan",
    "url": "https://hashscan.io/mainnet",
    "standard": "EIP3091"
  }, {
    "name": "Arkhia Explorer",
    "url": "https://explorer.arkhia.io",
    "standard": "none"
  }, {
    "name": "DragonGlass",
    "url": "https://app.dragonglass.me",
    "standard": "none"
  }, {
    "name": "Hedera Explorer",
    "url": "https://hederaexplorer.io",
    "standard": "none"
  }, {
    "name": "Ledger Works Explore",
    "url": "https://explore.lworks.io",
    "standard": "none"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmQikzhvZKyMmbZJd7BVLZb2YTBDMgNDnaMCAErsVjsfuz",
    "width": 1500,
    "height": 1500,
    "format": "png"
  },
  "infoURL": "https://hedera.com",
  "name": "Hedera Mainnet",
  "nativeCurrency": {
    "name": "hbar",
    "symbol": "HBAR",
    "decimals": 18
  },
  "networkId": 295,
  "rpc": ["https://295.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.hashio.io/api"],
  "shortName": "hedera-mainnet",
  "slip44": 3030,
  "slug": "hedera",
  "testnet": false
};

var c296 = {
  "chain": "Hedera",
  "chainId": 296,
  "explorers": [{
    "name": "HashScan",
    "url": "https://hashscan.io/testnet",
    "standard": "EIP3091"
  }, {
    "name": "Arkhia Explorer",
    "url": "https://explorer.arkhia.io",
    "standard": "none"
  }, {
    "name": "DragonGlass",
    "url": "https://app.dragonglass.me",
    "standard": "none"
  }, {
    "name": "Hedera Explorer",
    "url": "https://hederaexplorer.io",
    "standard": "none"
  }, {
    "name": "Ledger Works Explore",
    "url": "https://explore.lworks.io",
    "standard": "none"
  }],
  "faucets": ["https://portal.hedera.com"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmQikzhvZKyMmbZJd7BVLZb2YTBDMgNDnaMCAErsVjsfuz",
    "width": 1500,
    "height": 1500,
    "format": "png"
  },
  "infoURL": "https://hedera.com",
  "name": "Hedera Testnet",
  "nativeCurrency": {
    "name": "hbar",
    "symbol": "HBAR",
    "decimals": 18
  },
  "networkId": 296,
  "rpc": ["https://296.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.hashio.io/api"],
  "shortName": "hedera-testnet",
  "slip44": 1,
  "slug": "hedera-testnet",
  "testnet": true
};

var c297 = {
  "chain": "Hedera",
  "chainId": 297,
  "explorers": [{
    "name": "HashScan",
    "url": "https://hashscan.io/previewnet",
    "standard": "EIP3091"
  }],
  "faucets": ["https://portal.hedera.com"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmQikzhvZKyMmbZJd7BVLZb2YTBDMgNDnaMCAErsVjsfuz",
    "width": 1500,
    "height": 1500,
    "format": "png"
  },
  "infoURL": "https://hedera.com",
  "name": "Hedera Previewnet",
  "nativeCurrency": {
    "name": "hbar",
    "symbol": "HBAR",
    "decimals": 18
  },
  "networkId": 297,
  "rpc": ["https://297.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://previewnet.hashio.io/api"],
  "shortName": "hedera-previewnet",
  "slip44": 3030,
  "slug": "hedera-previewnet",
  "testnet": false
};

var c298 = {
  "chain": "Hedera",
  "chainId": 298,
  "explorers": [],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmQikzhvZKyMmbZJd7BVLZb2YTBDMgNDnaMCAErsVjsfuz",
    "width": 1500,
    "height": 1500,
    "format": "png"
  },
  "infoURL": "https://hedera.com",
  "name": "Hedera Localnet",
  "nativeCurrency": {
    "name": "hbar",
    "symbol": "HBAR",
    "decimals": 18
  },
  "networkId": 298,
  "rpc": [],
  "shortName": "hedera-localnet",
  "slip44": 3030,
  "slug": "hedera-localnet",
  "testnet": false
};

var c300 = {
  "chain": "ETH",
  "chainId": 300,
  "explorers": [{
    "name": "zkSync Block Explorer",
    "url": "https://sepolia.explorer.zksync.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRkhUD6J3B9WhT4hEWLrcFVTrBhx3CQgNC783aJsrwxSN",
      "width": 512,
      "height": 512,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRkhUD6J3B9WhT4hEWLrcFVTrBhx3CQgNC783aJsrwxSN",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://zksync.io/",
  "name": "zkSync Sepolia Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 300,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.zksync.io/"
    }]
  },
  "redFlags": ["reusedChainId"],
  "rpc": ["https://300.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sepolia.era.zksync.dev", "https://zksync-sepolia.drpc.org", "wss://zksync-sepolia.drpc.org"],
  "shortName": "zksync-sepolia",
  "slip44": 1,
  "slug": "zksync-sepolia-testnet",
  "testnet": true
};

var c301 = {
  "chain": "Bobaopera",
  "chainId": 301,
  "explorers": [{
    "name": "Bobaopera block explorer",
    "url": "https://blockexplorer.bobaopera.boba.network",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://boba.network",
  "name": "Bobaopera",
  "nativeCurrency": {
    "name": "Boba Token",
    "symbol": "BOBA",
    "decimals": 18
  },
  "networkId": 301,
  "rpc": ["https://301.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://bobaopera.boba.network", "wss://wss.bobaopera.boba.network", "https://replica.bobaopera.boba.network", "wss://replica-wss.bobaopera.boba.network"],
  "shortName": "Bobaopera",
  "slug": "bobaopera",
  "testnet": false
};

var c303 = {
  "chain": "NCN",
  "chainId": 303,
  "explorers": [{
    "name": "neuroscan",
    "url": "https://testnet.ncnscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://www.neurochain.ai",
  "name": "Neurochain Testnet",
  "nativeCurrency": {
    "name": "Neurochain",
    "symbol": "tNCN",
    "decimals": 18
  },
  "networkId": 303,
  "rpc": ["https://303.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://nc-rpc-test1.neurochain.io"],
  "shortName": "ncnt",
  "slip44": 1,
  "slug": "neurochain-testnet",
  "testnet": true
};

var c305 = {
  "chain": "ZKSats",
  "chainId": 305,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.zksats.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmaopiJuCSxRKZJHDkCu9w77x2HEmbNb3QeLC1SUavehEE",
      "width": 3072,
      "height": 3072,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmaopiJuCSxRKZJHDkCu9w77x2HEmbNb3QeLC1SUavehEE",
    "width": 3072,
    "height": 3072,
    "format": "png"
  },
  "infoURL": "https://zksats.io",
  "name": "ZKSats Mainnet",
  "nativeCurrency": {
    "name": "BTC",
    "symbol": "BTC",
    "decimals": 18
  },
  "networkId": 305,
  "rpc": ["https://305.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.zksats.io"],
  "shortName": "ZKSats-Mainnet",
  "slug": "zksats",
  "testnet": false,
  "title": "ZKSats Mainnet"
};

var c307 = {
  "chain": "Lovely",
  "chainId": 307,
  "explorers": [{
    "name": "Lovely Network Testnet",
    "url": "https://tscan.lovely.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.lovely.network"],
  "icon": {
    "url": "ipfs://QmPB7uW7Wj8zWWdeuPnUHPJ5FhaiTL76tv4ZQ4oKWEpb1g",
    "width": 897,
    "height": 824,
    "format": "png"
  },
  "infoURL": "https://lovely.network",
  "name": "Lovely Network Testnet",
  "nativeCurrency": {
    "name": "Lovely",
    "symbol": "LOVELY",
    "decimals": 18
  },
  "networkId": 307,
  "rpc": ["https://307.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://trpc.lovely.network"],
  "shortName": "LOVELY-Testnet",
  "slug": "lovely-network-testnet",
  "testnet": true
};

var c308 = {
  "chain": "FTH",
  "chainId": 308,
  "explorers": [{
    "name": "furthscan",
    "url": "http://furthscan.com",
    "standard": "EIP3091"
  }, {
    "name": "Furthscan Network Explorer",
    "url": "http://furthscan.com/",
    "standard": "standard",
    "icon": {
      "url": "ipfs://QmaZCiLBHGvQptmspWseHHs6L9iCHGKZbqVTqZ7Cf557Vg",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmaZCiLBHGvQptmspWseHHs6L9iCHGKZbqVTqZ7Cf557Vg",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "http://furthscan.com/",
  "name": "Furtheon Network",
  "nativeCurrency": {
    "name": "Furtheon",
    "symbol": "FTH",
    "decimals": 18
  },
  "networkId": 308,
  "redFlags": [],
  "rpc": ["https://308.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.furtheon.org/", "https://rpc.furtheon.org"],
  "shortName": "FTH",
  "slug": "furtheon-network",
  "testnet": false
};

var c309 = {
  "chain": "WYZ",
  "chainId": 309,
  "explorers": [{
    "name": "wyzth",
    "url": "http://24.199.108.65:4000",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmT5UMzAftM4mHCtk4pWX4sqyJCki88APbqECywrhJp91Q",
      "width": 324,
      "height": 82,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://QmeDfLgA5heAAXsU8kf5J23Y8up4uHN27uRBEAJFPMJEu7",
    "width": 48,
    "height": 48,
    "format": "png"
  },
  "infoURL": "https://wyzth.org/",
  "name": "Wyzth Testnet",
  "nativeCurrency": {
    "name": "Wyzth",
    "symbol": "WYZ",
    "decimals": 18
  },
  "networkId": 309,
  "rpc": ["https://309.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet3.wyzthchain.org/"],
  "shortName": "wyz",
  "slip44": 1,
  "slug": "wyzth-testnet",
  "testnet": true
};

var c311 = {
  "chain": "OMAX Chain",
  "chainId": 311,
  "explorers": [{
    "name": "Omax Chain Explorer",
    "url": "https://omaxray.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://Qmd7omPxrehSuxHHPMYd5Nr7nfrtjKdRJQEhDLfTb87w8G",
      "width": 500,
      "height": 500,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.omaxray.com/"],
  "icon": {
    "url": "ipfs://Qmd7omPxrehSuxHHPMYd5Nr7nfrtjKdRJQEhDLfTb87w8G",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://www.omaxcoin.com/",
  "name": "Omax Mainnet",
  "nativeCurrency": {
    "name": "OMAX COIN",
    "symbol": "OMAX",
    "decimals": 18
  },
  "networkId": 311,
  "rpc": ["https://311.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainapi.omaxray.com"],
  "shortName": "omax",
  "slug": "omax",
  "testnet": false
};

var c313 = {
  "chain": "NCN",
  "chainId": 313,
  "explorers": [{
    "name": "neuroscan",
    "url": "https://ncnscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://www.neurochain.ai",
  "name": "Neurochain Mainnet",
  "nativeCurrency": {
    "name": "Neurochain",
    "symbol": "NCN",
    "decimals": 18
  },
  "networkId": 313,
  "rpc": ["https://313.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://nc-rpc-prd1.neurochain.io", "https://nc-rpc-prd2.neurochain.io"],
  "shortName": "ncn",
  "slug": "neurochain",
  "testnet": false
};

var c314 = {
  "chain": "FIL",
  "chainId": 314,
  "explorers": [{
    "name": "Filfox",
    "url": "https://filfox.info/en",
    "standard": "none"
  }, {
    "name": "Beryx",
    "url": "https://beryx.zondax.ch",
    "standard": "none"
  }, {
    "name": "Glif Explorer",
    "url": "https://explorer.glif.io",
    "standard": "EIP3091"
  }, {
    "name": "Dev.storage",
    "url": "https://dev.storage",
    "standard": "none"
  }, {
    "name": "Filscan",
    "url": "https://filscan.io",
    "standard": "none"
  }, {
    "name": "Filscout",
    "url": "https://filscout.io/en",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmS9r9XQkMHVomWcSBNDkKkz9n87h9bH9ssabeiKZtANoU",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://filecoin.io",
  "name": "Filecoin - Mainnet",
  "nativeCurrency": {
    "name": "filecoin",
    "symbol": "FIL",
    "decimals": 18
  },
  "networkId": 314,
  "rpc": ["https://314.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.node.glif.io/", "https://rpc.ankr.com/filecoin", "https://filecoin-mainnet.chainstacklabs.com/rpc/v1", "https://filfox.info/rpc/v1", "https://filecoin.drpc.org", "wss://filecoin.drpc.org"],
  "shortName": "filecoin",
  "slip44": 461,
  "slug": "filecoin",
  "testnet": false
};

var c321 = {
  "chain": "KCC",
  "chainId": 321,
  "explorers": [{
    "name": "KCC Explorer",
    "url": "https://explorer.kcc.io/en",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://kcc.io",
  "name": "KCC Mainnet",
  "nativeCurrency": {
    "name": "KuCoin Token",
    "symbol": "KCS",
    "decimals": 18
  },
  "networkId": 321,
  "rpc": ["https://321.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mainnet.kcc.network", "https://kcc.mytokenpocket.vip", "https://public-rpc.blockpi.io/http/kcc"],
  "shortName": "kcs",
  "slip44": 641,
  "slug": "kcc",
  "testnet": false
};

var c322 = {
  "chain": "KCC",
  "chainId": 322,
  "explorers": [{
    "name": "kcc-scan-testnet",
    "url": "https://scan-testnet.kcc.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet-testnet.kcc.network"],
  "infoURL": "https://scan-testnet.kcc.network",
  "name": "KCC Testnet",
  "nativeCurrency": {
    "name": "KuCoin Testnet Token",
    "symbol": "tKCS",
    "decimals": 18
  },
  "networkId": 322,
  "rpc": ["https://322.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.kcc.network"],
  "shortName": "kcst",
  "slip44": 1,
  "slug": "kcc-testnet",
  "testnet": true
};

var c323 = {
  "chain": "CVM",
  "chainId": 323,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://explorer.cosvm.net",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "infoURL": "https://cosvm.network",
  "name": "Cosvm Mainnet",
  "nativeCurrency": {
    "name": "Cosvm",
    "symbol": "CVM",
    "decimals": 18
  },
  "networkId": 323,
  "rpc": ["https://323.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.cosvm.net"],
  "shortName": "cvm",
  "slug": "cosvm",
  "testnet": false
};

var c324 = {
  "chain": "ETH",
  "chainId": 324,
  "explorers": [{
    "name": "zkSync Era Block Explorer",
    "url": "https://explorer.zksync.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRkhUD6J3B9WhT4hEWLrcFVTrBhx3CQgNC783aJsrwxSN",
      "width": 512,
      "height": 512,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRkhUD6J3B9WhT4hEWLrcFVTrBhx3CQgNC783aJsrwxSN",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://zksync.io/",
  "name": "zkSync Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 324,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.zksync.io/"
    }]
  },
  "rpc": ["https://324.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.era.zksync.io", "https://zksync.drpc.org", "wss://zksync.drpc.org"],
  "shortName": "zksync",
  "slug": "zksync",
  "testnet": false
};

var c333 = {
  "chain": "Web3Q",
  "chainId": 333,
  "explorers": [{
    "name": "w3q-mainnet",
    "url": "https://explorer.mainnet.web3q.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://web3q.io/home.w3q/",
  "name": "Web3Q Mainnet",
  "nativeCurrency": {
    "name": "Web3Q",
    "symbol": "W3Q",
    "decimals": 18
  },
  "networkId": 333,
  "rpc": ["https://333.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.web3q.io:8545"],
  "shortName": "w3q",
  "slug": "web3q",
  "testnet": false
};

var c335 = {
  "chain": "DFK",
  "chainId": 335,
  "explorers": [{
    "name": "ethernal",
    "url": "https://explorer-test.dfkchain.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt",
      "width": 1000,
      "height": 1628,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQB48m15TzhUFrmu56QCRQjkrkgUaKfgCmKE8o3RzmuPJ",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://defikingdoms.com",
  "name": "DFK Chain Test",
  "nativeCurrency": {
    "name": "Jewel",
    "symbol": "JEWEL",
    "decimals": 18
  },
  "networkId": 335,
  "rpc": ["https://335.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain-testnet/rpc"],
  "shortName": "DFKTEST",
  "slip44": 1,
  "slug": "dfk-chain-test",
  "testnet": true
};

var c336 = {
  "chain": "SDN",
  "chainId": 336,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscout.com/shiden",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }, {
    "name": "subscan",
    "url": "https://shiden.subscan.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://Qma2GfW5nQHuA7nGqdEfwaXPL63G9oTwRTQKaGTfjNtM2W",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQySjAoWHgk3ou1yvBi2TrTcgH6KhfGiU7GcrLzrAeRkE",
    "width": 250,
    "height": 250,
    "format": "png"
  },
  "infoURL": "https://shiden.astar.network/",
  "name": "Shiden",
  "nativeCurrency": {
    "name": "Shiden",
    "symbol": "SDN",
    "decimals": 18
  },
  "networkId": 336,
  "rpc": ["https://336.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://shiden.api.onfinality.io/public", "https://shiden-rpc.dwellir.com", "https://shiden.public.blastapi.io", "wss://shiden.api.onfinality.io/public-ws", "wss://shiden.public.blastapi.io", "wss://shiden-rpc.dwellir.com"],
  "shortName": "sdn",
  "slug": "shiden",
  "testnet": false
};

var c338 = {
  "chain": "CRO",
  "chainId": 338,
  "explorers": [{
    "name": "Cronos Testnet Explorer",
    "url": "https://explorer.cronos.org/testnet",
    "standard": "none"
  }],
  "faucets": ["https://cronos.org/faucet"],
  "infoURL": "https://cronos.org",
  "name": "Cronos Testnet",
  "nativeCurrency": {
    "name": "Cronos Test Coin",
    "symbol": "TCRO",
    "decimals": 18
  },
  "networkId": 338,
  "rpc": ["https://338.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm-t3.cronos.org", "https://cronos-testnet.drpc.org", "wss://cronos-testnet.drpc.org"],
  "shortName": "tcro",
  "slip44": 1,
  "slug": "cronos-testnet",
  "testnet": true
};

var c361 = {
  "chain": "Theta",
  "chainId": 361,
  "explorers": [{
    "name": "Theta Mainnet Explorer",
    "url": "https://explorer.thetatoken.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.thetatoken.org/",
  "name": "Theta Mainnet",
  "nativeCurrency": {
    "name": "Theta Fuel",
    "symbol": "TFUEL",
    "decimals": 18
  },
  "networkId": 361,
  "rpc": ["https://361.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eth-rpc-api.thetatoken.org/rpc"],
  "shortName": "theta-mainnet",
  "slug": "theta",
  "testnet": false
};

var c363 = {
  "chain": "Theta",
  "chainId": 363,
  "explorers": [{
    "name": "Theta Sapphire Testnet Explorer",
    "url": "https://guardian-testnet-sapphire-explorer.thetatoken.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.thetatoken.org/",
  "name": "Theta Sapphire Testnet",
  "nativeCurrency": {
    "name": "Theta Fuel",
    "symbol": "TFUEL",
    "decimals": 18
  },
  "networkId": 363,
  "rpc": ["https://363.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eth-rpc-api-sapphire.thetatoken.org/rpc"],
  "shortName": "theta-sapphire",
  "slip44": 1,
  "slug": "theta-sapphire-testnet",
  "testnet": true
};

var c364 = {
  "chain": "Theta",
  "chainId": 364,
  "explorers": [{
    "name": "Theta Amber Testnet Explorer",
    "url": "https://guardian-testnet-amber-explorer.thetatoken.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.thetatoken.org/",
  "name": "Theta Amber Testnet",
  "nativeCurrency": {
    "name": "Theta Fuel",
    "symbol": "TFUEL",
    "decimals": 18
  },
  "networkId": 364,
  "rpc": ["https://364.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eth-rpc-api-amber.thetatoken.org/rpc"],
  "shortName": "theta-amber",
  "slip44": 1,
  "slug": "theta-amber-testnet",
  "testnet": true
};

var c365 = {
  "chain": "Theta",
  "chainId": 365,
  "explorers": [{
    "name": "Theta Testnet Explorer",
    "url": "https://testnet-explorer.thetatoken.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.thetatoken.org/",
  "name": "Theta Testnet",
  "nativeCurrency": {
    "name": "Theta Fuel",
    "symbol": "TFUEL",
    "decimals": 18
  },
  "networkId": 365,
  "rpc": ["https://365.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eth-rpc-api-testnet.thetatoken.org/rpc"],
  "shortName": "theta-testnet",
  "slip44": 1,
  "slug": "theta-testnet",
  "testnet": true
};

var c369 = {
  "chain": "PLS",
  "chainId": 369,
  "ens": {
    "registry": "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
  },
  "explorers": [{
    "name": "blockscout",
    "url": "https://scan.pulsechain.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }, {
    "name": "otterscan",
    "url": "https://otter.pulsechain.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://pulsechain.com/",
  "name": "PulseChain",
  "nativeCurrency": {
    "name": "Pulse",
    "symbol": "PLS",
    "decimals": 18
  },
  "networkId": 369,
  "redFlags": [],
  "rpc": ["https://369.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evex.cloud/pulserpc", "https://rpc.pulsechain.com", "wss://rpc.pulsechain.com", "https://pulsechain-rpc.publicnode.com", "wss://pulsechain-rpc.publicnode.com", "https://rpc-pulsechain.g4mm4.io", "wss://rpc-pulsechain.g4mm4.io"],
  "shortName": "pls",
  "slip44": 60,
  "slug": "pulsechain",
  "status": "active",
  "testnet": false
};

var c371 = {
  "chain": "tCNT",
  "chainId": 371,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer-testnet.theconsta.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmfQ1yae6uvXgBSwnwJM4Mtp8ctH66tM6mB1Hsgu4XvsC9",
    "width": 2000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "http://theconsta.com",
  "name": "Consta Testnet",
  "nativeCurrency": {
    "name": "tCNT",
    "symbol": "tCNT",
    "decimals": 18
  },
  "networkId": 371,
  "rpc": ["https://371.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.theconsta.com"],
  "shortName": "tCNT",
  "slip44": 1,
  "slug": "consta-testnet",
  "testnet": true
};

var c380 = {
  "chain": "FIL",
  "chainId": 380,
  "explorers": [{
    "name": "ZKAmoeba Test Explorer",
    "url": "https://testnetexplorer.zkamoeba.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRTChjmiwh9HrGsLh9qECsH7WHQAhqT5Ww8S34s8ME2Cp",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRTChjmiwh9HrGsLh9qECsH7WHQAhqT5Ww8S34s8ME2Cp",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://testnet.zkamoeba.com",
  "name": "ZKAmoeba Testnet",
  "nativeCurrency": {
    "name": "filecoin",
    "symbol": "FIL",
    "decimals": 18
  },
  "networkId": 380,
  "parent": {
    "type": "L2",
    "chain": "eip155-314",
    "bridges": [{
      "url": "https://testnet.zkamoeba.com/en/bridge"
    }]
  },
  "rpc": ["https://380.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.zkamoeba.com:4050/", "https://rpc1.testnet.zkamoeba.com:4050/"],
  "shortName": "zkamoeba-test",
  "slug": "zkamoeba-testnet",
  "testnet": true
};

var c381 = {
  "chain": "FIL",
  "chainId": 381,
  "explorers": [{
    "name": "ZKAmoeba Explorer",
    "url": "https://explorer.zkamoeba.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRTChjmiwh9HrGsLh9qECsH7WHQAhqT5Ww8S34s8ME2Cp",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRTChjmiwh9HrGsLh9qECsH7WHQAhqT5Ww8S34s8ME2Cp",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://www.zkamoeba.com",
  "name": "ZKAmoeba Mainnet",
  "nativeCurrency": {
    "name": "filecoin",
    "symbol": "FIL",
    "decimals": 18
  },
  "networkId": 381,
  "parent": {
    "type": "L2",
    "chain": "eip155-314",
    "bridges": [{
      "url": "https://www.zkamoeba.com/en/bridge"
    }]
  },
  "rpc": ["https://381.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.mainnet.zkamoeba.com/rpc"],
  "shortName": "zkamoeba",
  "slug": "zkamoeba",
  "testnet": false
};

var c385 = {
  "chain": "CRO",
  "chainId": 385,
  "explorers": [],
  "faucets": ["https://pipa.lisinski.online"],
  "infoURL": "https://lisinski.online",
  "name": "Lisinski",
  "nativeCurrency": {
    "name": "Lisinski Ether",
    "symbol": "LISINS",
    "decimals": 18
  },
  "networkId": 385,
  "rpc": ["https://385.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-bitfalls1.lisinski.online"],
  "shortName": "lisinski",
  "slug": "lisinski",
  "testnet": false
};

var c395 = {
  "chain": "CADL",
  "chainId": 395,
  "explorers": [{
    "name": "CamDL Testnet Explorer",
    "url": "https://explorer.testnet.camdl.gov.kh",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.testnet.camdl.gov.kh/"],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://QmW5Fpb2Ywnfqcj4ibvpbKvPv5Mo5eseWdYZnnUvLkj2Hp",
    "width": 1453,
    "height": 1453,
    "format": "png"
  },
  "infoURL": "https://camdl.gov.kh/",
  "name": "CamDL Testnet",
  "nativeCurrency": {
    "name": "CADL",
    "symbol": "CADL",
    "decimals": 18
  },
  "networkId": 395,
  "rpc": ["https://395.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc1.testnet.camdl.gov.kh/"],
  "shortName": "camdl-testnet",
  "slug": "camdl-testnet",
  "status": "active",
  "testnet": true
};

var c397 = {
  "chain": "NEAR",
  "chainId": 397,
  "explorers": [{
    "name": "Near Blocks",
    "url": "https://nearblocks.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreiayxzdbu3e5ahri3ooieg6k6pjxrwkrkc2x5cnyadqeu5zbmaummq",
    "width": 639,
    "height": 639,
    "format": "png"
  },
  "infoURL": "https://near.org/",
  "name": "Near Mainnet",
  "nativeCurrency": {
    "name": "NEAR",
    "symbol": "NEAR",
    "decimals": 18
  },
  "networkId": 397,
  "rpc": [],
  "shortName": "near",
  "slug": "near",
  "testnet": false
};

var c398 = {
  "chain": "NEAR",
  "chainId": 398,
  "explorers": [{
    "name": "Near blocks",
    "url": "https://testnet.nearblocks.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreiayxzdbu3e5ahri3ooieg6k6pjxrwkrkc2x5cnyadqeu5zbmaummq",
    "width": 639,
    "height": 639,
    "format": "png"
  },
  "infoURL": "https://aurora.dev",
  "name": "Near Testnet",
  "nativeCurrency": {
    "name": "Testnet NEAR",
    "symbol": "NEAR",
    "decimals": 18
  },
  "networkId": 398,
  "rpc": [],
  "shortName": "near-testnet",
  "slug": "near-testnet",
  "testnet": true
};

var c399 = {
  "chain": "Nativ3",
  "chainId": 399,
  "explorers": [{
    "name": "N3scan",
    "url": "https://scan.nativ3.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVzJDndPui6qBSeJWe5kMLA56C3KpVhqqqk9xvVKE1DGb",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://nativ3.network",
  "name": "Nativ3 Mainnet",
  "nativeCurrency": {
    "name": "USNT",
    "symbol": "USNT",
    "decimals": 18
  },
  "networkId": 399,
  "parent": {
    "type": "L2",
    "chain": "eip155-42161",
    "bridges": [{
      "url": "https://bridge.nativ3.network"
    }]
  },
  "rpc": ["https://399.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.nativ3.network", "wss://ws.nativ3.network"],
  "shortName": "N3",
  "slug": "nativ3",
  "testnet": false
};

var c400 = {
  "chain": "HPN",
  "chainId": 400,
  "explorers": [{
    "name": "blockscout",
    "url": "https://testnet.hyperonchain.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmWxhyxXTEsWH98v7M3ck4ZL1qQoUaHG4HgtgxzD2KJQ5m",
      "width": 540,
      "height": 541,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.hyperonchain.com"],
  "icon": {
    "url": "ipfs://QmWxhyxXTEsWH98v7M3ck4ZL1qQoUaHG4HgtgxzD2KJQ5m",
    "width": 540,
    "height": 541,
    "format": "png"
  },
  "infoURL": "https://docs.hyperonchain.com",
  "name": "HyperonChain TestNet",
  "nativeCurrency": {
    "name": "HyperonChain",
    "symbol": "HPN",
    "decimals": 18
  },
  "networkId": 400,
  "rpc": ["https://400.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.hyperonchain.com"],
  "shortName": "hpn",
  "slip44": 1,
  "slug": "hyperonchain-testnet",
  "testnet": true
};

var c401 = {
  "chain": "OZONE",
  "chainId": 401,
  "explorers": [{
    "name": "OZONE Scan",
    "url": "https://testnet.ozonescan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmbM4weV8Bk6c9yNhosYntkVw39SNZtCHYGgWyXTxkevZ8",
    "width": 1600,
    "height": 1600,
    "format": "png"
  },
  "infoURL": "https://ozonechain.io",
  "name": "Ozone Chain Testnet",
  "nativeCurrency": {
    "name": "OZONE",
    "symbol": "OZO",
    "decimals": 18
  },
  "networkId": 401,
  "rpc": ["https://401.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node1.testnet.ozonechain.io"],
  "shortName": "ozo_tst",
  "slip44": 1,
  "slug": "ozone-chain-testnet",
  "testnet": true
};

var c408 = {
  "chain": "OmegaNetwork",
  "chainId": 408,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://bafkreig676zxfhwhcx5bvvvjxedx6ftr2wq4iiznrwm3c6ozrprbc4oxwm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "name": "Omega Mainnet",
  "nativeCurrency": {
    "name": "Omega Network Coin",
    "symbol": "OMN",
    "decimals": 18
  },
  "networkId": 408,
  "redFlags": [],
  "rpc": ["https://408.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.omtch.com"],
  "shortName": "OmegaNetwork",
  "slug": "omega",
  "testnet": false
};

var c411 = {
  "chain": "PC",
  "chainId": 411,
  "explorers": [{
    "name": "pepechain explorer",
    "url": "https://explorer.pepe-chain.vip",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreibjsc3gww3moti27za2hpyq552aevux3yv5y2ntdklksyr4v4uavy",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://pepe-chain.vip",
  "name": "Pepe Chain Mainnet",
  "nativeCurrency": {
    "name": "Pepe",
    "symbol": "PEPE",
    "decimals": 18
  },
  "networkId": 411,
  "rpc": ["https://411.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.pepe-chain.vip"],
  "shortName": "pepe",
  "slug": "pepe-chain",
  "status": "active",
  "testnet": false
};

var c416 = {
  "chain": "SX",
  "chainId": 416,
  "explorers": [{
    "name": "SX Network Explorer",
    "url": "https://explorer.sx.technology",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmSXLXqyr2H6Ja5XrmznXbWTEvF2gFaL8RXNXgyLmDHjAF",
    "width": 896,
    "height": 690,
    "format": "png"
  },
  "infoURL": "https://www.sx.technology",
  "name": "SX Network Mainnet",
  "nativeCurrency": {
    "name": "SX Network",
    "symbol": "SX",
    "decimals": 18
  },
  "networkId": 416,
  "rpc": ["https://416.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.sx.technology"],
  "shortName": "SX",
  "slug": "sx-network",
  "testnet": false
};

var c418 = {
  "chain": "LaTestnet",
  "chainId": 418,
  "explorers": [{
    "name": "LaTestnet Explorer",
    "url": "https://testexplorer.lachain.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.lachain.network"],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://QmQxGA6rhuCQDXUueVcNvFRhMEWisyTmnF57TqL7h6k6cZ",
    "width": 1280,
    "height": 1280,
    "format": "png"
  },
  "name": "LaTestnet",
  "nativeCurrency": {
    "name": "Test LaCoin",
    "symbol": "TLA",
    "decimals": 18
  },
  "networkId": 418,
  "rpc": ["https://418.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.lachain.network", "https://lachain-testnet.rpc-nodes.cedalio.dev"],
  "shortName": "latestnet",
  "slug": "latestnet",
  "testnet": true
};

var c420 = {
  "chain": "ETH",
  "chainId": 420,
  "explorers": [{
    "name": "blockscout",
    "url": "https://optimism-goerli.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/optimism/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://optimism.io",
  "name": "Optimism Goerli Testnet",
  "nativeCurrency": {
    "name": "Goerli Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 420,
  "redFlags": [],
  "rpc": ["https://420.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://goerli.optimism.io", "https://optimism-goerli-rpc.publicnode.com", "wss://optimism-goerli-rpc.publicnode.com", "https://optimism-goerli.gateway.tenderly.co", "wss://optimism-goerli.gateway.tenderly.co", "https://optimism-testnet.drpc.org", "wss://optimism-testnet.drpc.org"],
  "shortName": "ogor",
  "slip44": 1,
  "slug": "optimism-goerli",
  "status": "deprecated",
  "testnet": true
};

var c422 = {
  "chain": "VRD",
  "chainId": 422,
  "explorers": [{
    "name": "Viridis Mainnet",
    "url": "https://explorer.vrd.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPdxcJwPogfZdec7UAqxeatRxrivEktpP1ftJBTeJQTdR",
    "width": 3000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://viridis.network",
  "name": "Viridis Mainnet",
  "nativeCurrency": {
    "name": "Viridis Token",
    "symbol": "VRD",
    "decimals": 18
  },
  "networkId": 422,
  "rpc": ["https://422.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.vrd.network"],
  "shortName": "vrd",
  "slug": "viridis",
  "testnet": false
};

var c424 = {
  "chain": "ETH",
  "chainId": 424,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.publicgoods.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmUVJ7MLCEAfq3pHVPFLscqRMiyAY5biVgTkeDQCmAhHNS",
    "width": 574,
    "height": 574,
    "format": "svg"
  },
  "infoURL": "https://publicgoods.network/",
  "name": "PGN (Public Goods Network)",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 424,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.publicgoods.network"
    }]
  },
  "rpc": ["https://424.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.publicgoods.network"],
  "shortName": "PGN",
  "slug": "pgn-public-goods-network",
  "testnet": false
};

var c427 = {
  "chain": "ZeethChain",
  "chainId": 427,
  "explorers": [{
    "name": "Zeeth Explorer",
    "url": "https://explorer.zeeth.io",
    "standard": "none"
  }],
  "faucets": [],
  "name": "Zeeth Chain",
  "nativeCurrency": {
    "name": "Zeeth Token",
    "symbol": "ZTH",
    "decimals": 18
  },
  "networkId": 427,
  "rpc": ["https://427.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.zeeth.io"],
  "shortName": "zeeth",
  "slug": "zeeth-chain",
  "testnet": false
};

var c428 = {
  "chain": "Geso Verse",
  "chainId": 428,
  "explorers": [{
    "name": "Geso Verse Explorer",
    "url": "https://explorer.verse.gesoten.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmb7oJY9zd9sTzxNNQNTVZQz2hkd1aA94mWm4cvXfJ9QxV",
    "width": 1280,
    "height": 1280,
    "format": "png"
  },
  "infoURL": "https://gesoten.com/",
  "name": "Geso Verse",
  "nativeCurrency": {
    "name": "OAS",
    "symbol": "OAS",
    "decimals": 18
  },
  "networkId": 428,
  "rpc": ["https://428.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.verse.gesoten.com/"],
  "shortName": "GSV",
  "slug": "geso-verse",
  "testnet": false
};

var c434 = {
  "chain": "BYC",
  "chainId": 434,
  "explorers": [{
    "name": "Boyaa explorer",
    "url": "https://explorer.mainnet.boyaa.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeiapootrvggtigdlvgvk6srfseplpuowsqq3zpyup4j5yj5moxuala",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://boyaa.network",
  "name": "Boyaa Mainnet",
  "nativeCurrency": {
    "name": "Boyaa mainnet native coin",
    "symbol": "BYC",
    "decimals": 18
  },
  "networkId": 434,
  "rpc": ["https://434.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm-rpc.mainnet.boyaa.network"],
  "shortName": "BYC",
  "slug": "boyaa",
  "testnet": false
};

var c443 = {
  "chain": "ETH",
  "chainId": 443,
  "explorers": [{
    "name": "Ten Sepolia Rollup Explorer",
    "url": "https://tenscan.io",
    "standard": "none"
  }],
  "faucets": [],
  "features": [],
  "infoURL": "https://ten.xyz",
  "name": "Ten Testnet",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 443,
  "parent": {
    "type": "L2",
    "chain": "eip155-5",
    "bridges": [{
      "url": "https://bridge.ten.xyz"
    }]
  },
  "redFlags": [],
  "rpc": ["https://443.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.ten.xyz/v1/", "https://testnet.ten.xyz"],
  "shortName": "ten-testnet",
  "slip44": 1,
  "slug": "ten-testnet",
  "testnet": true,
  "title": "Ten Sepolia Rollup Testnet"
};

var c444 = {
  "chain": "ETH",
  "chainId": 444,
  "explorers": [{
    "name": "Synapse Chain Sepolia",
    "url": "https://sepolia.synapsescan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmX2Z71QszaZvpMppdNWeCLqmeWk8NA6KMDLMqAt5VRyVi/synapse.webp",
    "width": 720,
    "height": 720,
    "format": "webp"
  },
  "infoURL": "https://synapseprotocol.com",
  "name": "Synapse Chain Testnet",
  "nativeCurrency": {
    "name": "Sepolia ETH",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 444,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": [{
      "url": "https://docs.synapseprotocol.com/synapse-chain/using-synapse-chain/bridging-to-synapse-chain"
    }]
  },
  "redFlags": ["reusedChainId"],
  "rpc": ["https://444.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sepolia.synapseprotocol.com"],
  "shortName": "synapse-sepolia",
  "slip44": 1,
  "slug": "synapse-chain-testnet",
  "status": "active",
  "testnet": true
};

var c456 = {
  "chain": "ARZIO",
  "chainId": 456,
  "explorers": [{
    "name": "ARZIO Scan",
    "url": "https://scan.arzio.co",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmUwqGWGjjQweTprn5LBirAwRjYnteTiFLCVpSNHrfMmSL",
    "width": 150,
    "height": 150,
    "format": "png"
  },
  "infoURL": "https://chain.arzio.co",
  "name": "ARZIO Chain",
  "nativeCurrency": {
    "name": "ARZIO",
    "symbol": "AZO",
    "decimals": 18
  },
  "networkId": 456,
  "rpc": ["https://456.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://chain-rpc.arzio.co"],
  "shortName": "arzio",
  "slug": "arzio-chain",
  "testnet": false
};

var c462 = {
  "chain": "Areon",
  "chainId": 462,
  "explorers": [{
    "name": "AreonScan",
    "url": "https://areonscan.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreihs2nrnizpcuzjmuu2yi7wrtwd7qlqje46qnil5bnntfbfkb2roea",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://areon.network",
  "name": "Areon Network Testnet",
  "nativeCurrency": {
    "name": "Areon",
    "symbol": "TAREA",
    "decimals": 18
  },
  "networkId": 462,
  "rpc": ["https://462.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.areon.network", "https://testnet-rpc2.areon.network", "https://testnet-rpc3.areon.network", "https://testnet-rpc4.areon.network", "https://testnet-rpc5.areon.network"],
  "shortName": "tarea",
  "slip44": 1,
  "slug": "areon-network-testnet",
  "testnet": true
};

var c463 = {
  "chain": "Areon",
  "chainId": 463,
  "explorers": [{
    "name": "AreonScan",
    "url": "https://areonscan.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreihs2nrnizpcuzjmuu2yi7wrtwd7qlqje46qnil5bnntfbfkb2roea",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://areon.network",
  "name": "Areon Network Mainnet",
  "nativeCurrency": {
    "name": "Areon",
    "symbol": "AREA",
    "decimals": 18
  },
  "networkId": 463,
  "rpc": ["https://463.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.areon.network", "https://mainnet-rpc2.areon.network", "https://mainnet-rpc3.areon.network", "https://mainnet-rpc4.areon.network", "https://mainnet-rpc5.areon.network"],
  "shortName": "area",
  "slug": "areon-network",
  "testnet": false
};

var c499 = {
  "chain": "RUPX",
  "chainId": 499,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.rupaya.io",
  "name": "Rupaya",
  "nativeCurrency": {
    "name": "Rupaya",
    "symbol": "RUPX",
    "decimals": 18
  },
  "networkId": 499,
  "rpc": [],
  "shortName": "rupx",
  "slip44": 499,
  "slug": "rupaya",
  "testnet": false
};

var c500 = {
  "chain": "CAM",
  "chainId": 500,
  "explorers": [{
    "name": "blockexplorer",
    "url": "https://suite.camino.network/explorer",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmSEoUonisawfCvT3osysuZzbqUEHugtgNraePKWL8PKYa",
    "width": 768,
    "height": 768,
    "format": "png"
  },
  "infoURL": "https://camino.network/",
  "name": "Camino C-Chain",
  "nativeCurrency": {
    "name": "Camino",
    "symbol": "CAM",
    "decimals": 18
  },
  "networkId": 1000,
  "rpc": ["https://500.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.camino.network/ext/bc/C/rpc"],
  "shortName": "Camino",
  "slug": "camino-c-chain",
  "testnet": false
};

var c501 = {
  "chain": "CAM",
  "chainId": 501,
  "explorers": [{
    "name": "blockexplorer",
    "url": "https://suite.camino.network/explorer",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmSEoUonisawfCvT3osysuZzbqUEHugtgNraePKWL8PKYa",
    "width": 768,
    "height": 768,
    "format": "png"
  },
  "infoURL": "https://camino.network/",
  "name": "Columbus Test Network",
  "nativeCurrency": {
    "name": "Camino",
    "symbol": "CAM",
    "decimals": 18
  },
  "networkId": 1001,
  "rpc": ["https://501.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://columbus.camino.network/ext/bc/C/rpc"],
  "shortName": "Columbus",
  "slip44": 1,
  "slug": "columbus-test-network",
  "testnet": true
};

var c510 = {
  "chain": "Syndicate",
  "chainId": 510,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeSvQcD3XvLFAiMLoQSPbGK9JxVfbCWPBUTMLhhhzYPqX",
    "width": 16000,
    "height": 16000,
    "format": "png"
  },
  "infoURL": "https://syndicate.io",
  "name": "Syndicate Chain",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 510,
  "rpc": ["https://510.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mainnet.syndicate.io"],
  "shortName": "syndicate-chain-mainnet",
  "slug": "syndicate-chain",
  "status": "incubating",
  "testnet": false,
  "title": "Syndicate Chain"
};

var c512 = {
  "chain": "AAC",
  "chainId": 512,
  "explorers": [{
    "name": "aacscan",
    "url": "https://scan.acuteangle.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRUrz4dULaoaMpnqd8qXT7ehwz3aaqnYKY4ePsy7isGaF",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://www.acuteangle.com/",
  "name": "Double-A Chain Mainnet",
  "nativeCurrency": {
    "name": "Acuteangle Native Token",
    "symbol": "AAC",
    "decimals": 18
  },
  "networkId": 512,
  "rpc": ["https://512.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.acuteangle.com"],
  "shortName": "aac",
  "slip44": 1512,
  "slug": "double-a-chain",
  "testnet": false
};

var c513 = {
  "chain": "AAC",
  "chainId": 513,
  "explorers": [{
    "name": "aacscan-testnet",
    "url": "https://scan-testnet.acuteangle.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://scan-testnet.acuteangle.com/faucet"],
  "icon": {
    "url": "ipfs://QmRUrz4dULaoaMpnqd8qXT7ehwz3aaqnYKY4ePsy7isGaF",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://www.acuteangle.com/",
  "name": "Double-A Chain Testnet",
  "nativeCurrency": {
    "name": "Acuteangle Native Token",
    "symbol": "AAC",
    "decimals": 18
  },
  "networkId": 513,
  "rpc": ["https://513.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.acuteangle.com"],
  "shortName": "aact",
  "slip44": 1,
  "slug": "double-a-chain-testnet",
  "testnet": true
};

var c516 = {
  "chain": "GearZero",
  "chainId": 516,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://token.gearzero.ca/mainnet",
  "name": "Gear Zero Network Mainnet",
  "nativeCurrency": {
    "name": "Gear Zero Network Native Token",
    "symbol": "GZN",
    "decimals": 18
  },
  "networkId": 516,
  "rpc": ["https://516.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://gzn.linksme.info"],
  "shortName": "gz-mainnet",
  "slip44": 516,
  "slug": "gear-zero-network",
  "testnet": false
};

var c520 = {
  "chain": "XSC",
  "chainId": 520,
  "explorers": [{
    "name": "xscscan",
    "url": "https://xscscan.pub",
    "standard": "EIP3091"
  }],
  "faucets": ["https://xsc.pub/faucet"],
  "icon": {
    "url": "ipfs://QmNmAFgQKkjofaBR5mhB5ygE1Gna36YBVsGkgZQxrwW85s",
    "width": 98,
    "height": 96,
    "format": "png"
  },
  "infoURL": "https://xsc.pub/",
  "name": "XT Smart Chain Mainnet",
  "nativeCurrency": {
    "name": "XT Smart Chain Native Token",
    "symbol": "XT",
    "decimals": 18
  },
  "networkId": 1024,
  "rpc": ["https://520.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://datarpc1.xsc.pub", "https://datarpc2.xsc.pub", "https://datarpc3.xsc.pub"],
  "shortName": "xt",
  "slug": "xt-smart-chain",
  "testnet": false
};

var c529 = {
  "chain": "FIRE",
  "chainId": 529,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYjuztyURb3Fc6ZTLgCbwQa64CcVoigF5j9cafzuSbqgf",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://thefirechain.com",
  "name": "Firechain Mainnet",
  "nativeCurrency": {
    "name": "Firechain",
    "symbol": "FIRE",
    "decimals": 18
  },
  "networkId": 529,
  "rpc": ["https://529.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mainnet.thefirechain.com"],
  "shortName": "fire",
  "slug": "firechain",
  "status": "incubating",
  "testnet": false
};

var c530 = {
  "chain": "Fxcore",
  "chainId": 530,
  "explorers": [{
    "name": "FunctionX Explorer",
    "url": "https://fx-evm.functionx.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmauD5hzc5q1VgEU1nT4AGLCeV79CB8GgfnXXeeLmBZVHf",
    "width": 36,
    "height": 36,
    "format": "png"
  },
  "infoURL": "https://functionx.io/",
  "name": "F(x)Core Mainnet Network",
  "nativeCurrency": {
    "name": "Function X",
    "symbol": "FX",
    "decimals": 18
  },
  "networkId": 530,
  "rpc": ["https://530.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://fx-json-web3.functionx.io:8545"],
  "shortName": "FxCore",
  "slug": "f-x-core-network",
  "testnet": false
};

var c534 = {
  "chain": "Candle",
  "chainId": 534,
  "explorers": [{
    "name": "candleexplorer",
    "url": "https://candleexplorer.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://candlelabs.org/",
  "name": "Candle",
  "nativeCurrency": {
    "name": "CANDLE",
    "symbol": "CNDL",
    "decimals": 18
  },
  "networkId": 534,
  "rpc": ["https://534.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://candle-rpc.com/", "https://rpc.cndlchain.com"],
  "shortName": "CNDL",
  "slip44": 674,
  "slug": "candle",
  "testnet": false
};

var c537 = {
  "chain": "OpTrust",
  "chainId": 537,
  "explorers": [{
    "name": "OpTrust explorer",
    "url": "https://scan.optrust.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmYktPMo4tdQhMA9nRJBVckjzHcFLbpHbTVNSpGUUPEP8J",
      "width": 500,
      "height": 500,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYktPMo4tdQhMA9nRJBVckjzHcFLbpHbTVNSpGUUPEP8J",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://optrust.io",
  "name": "OpTrust Mainnet",
  "nativeCurrency": {
    "name": "BSC",
    "symbol": "BNB",
    "decimals": 18
  },
  "networkId": 537,
  "rpc": ["https://537.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.optrust.io"],
  "shortName": "optrust",
  "slug": "optrust",
  "testnet": false
};

var c542 = {
  "chain": "PAW",
  "chainId": 542,
  "explorers": [{
    "name": "PAWCHAIN Testnet",
    "url": "https://pawscan.io",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://pawchainx.com/",
  "name": "PAWCHAIN Testnet",
  "nativeCurrency": {
    "name": "PAW",
    "symbol": "PAW",
    "decimals": 18
  },
  "networkId": 542,
  "rpc": ["https://542.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://pawchainx.com/"],
  "shortName": "PAW",
  "slip44": 1,
  "slug": "pawchain-testnet",
  "testnet": true
};

var c555 = {
  "chain": "VELA1",
  "chainId": 555,
  "explorers": [{
    "name": "Vela1 Chain Mainnet Explorer",
    "url": "https://exp.velaverse.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://velaverse.io",
  "name": "Vela1 Chain Mainnet",
  "nativeCurrency": {
    "name": "CLASS COIN",
    "symbol": "CLASS",
    "decimals": 18
  },
  "networkId": 555,
  "rpc": ["https://555.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.velaverse.io"],
  "shortName": "CLASS",
  "slug": "vela1-chain",
  "testnet": false
};

var c558 = {
  "chain": "TAO",
  "chainId": 558,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://tao.network",
  "name": "Tao Network",
  "nativeCurrency": {
    "name": "Tao",
    "symbol": "TAO",
    "decimals": 18
  },
  "networkId": 558,
  "rpc": ["https://558.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.tao.network", "http://rpc.testnet.tao.network:8545", "https://rpc.tao.network", "wss://rpc.tao.network"],
  "shortName": "tao",
  "slug": "tao-network",
  "testnet": true
};

var c568 = {
  "chain": "DC",
  "chainId": 568,
  "explorers": [{
    "name": "dogechain testnet explorer",
    "url": "https://explorer-testnet.dogechain.dog",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.dogechain.dog"],
  "icon": {
    "url": "ipfs://QmNS6B6L8FfgGSMTEi2SxD3bK5cdmKPNtQKcYaJeRWrkHs",
    "width": 732,
    "height": 732,
    "format": "png"
  },
  "infoURL": "https://dogechain.dog",
  "name": "Dogechain Testnet",
  "nativeCurrency": {
    "name": "Dogecoin",
    "symbol": "DOGE",
    "decimals": 18
  },
  "networkId": 568,
  "rpc": ["https://568.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.dogechain.dog"],
  "shortName": "dct",
  "slip44": 1,
  "slug": "dogechain-testnet",
  "testnet": true
};

var c570 = {
  "chain": "SYS",
  "chainId": 570,
  "explorers": [{
    "name": "Rollux Explorer",
    "url": "https://explorer.rollux.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://rollux.id/faucetapp"],
  "infoURL": "https://rollux.com",
  "name": "Rollux Mainnet",
  "nativeCurrency": {
    "name": "Syscoin",
    "symbol": "SYS",
    "decimals": 18
  },
  "networkId": 570,
  "rpc": ["https://570.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.rollux.com", "wss://rpc.rollux.com/wss", "https://rollux.rpc.syscoin.org", "wss://rollux.rpc.syscoin.org/wss"],
  "shortName": "sys-rollux",
  "slug": "rollux",
  "testnet": false
};

var c571 = {
  "chain": "MTC",
  "chainId": 571,
  "explorers": [{
    "name": "MetaExplorer",
    "url": "https://explorer.metatime.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmUH2Ph2hW4upvevEAGCaSo7nd8nthqMx5RrHcrnNZ9Y3g",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://metatime.com/en",
  "name": "MetaChain Mainnet",
  "nativeCurrency": {
    "name": "Metatime Coin",
    "symbol": "MTC",
    "decimals": 18
  },
  "networkId": 571,
  "rpc": ["https://571.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.metatime.com"],
  "shortName": "metatime",
  "slip44": 571,
  "slug": "metachain",
  "testnet": false
};

var c588 = {
  "chain": "ETH",
  "chainId": 588,
  "explorers": [{
    "name": "blockscout",
    "url": "https://stardust-explorer.metis.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.metis.io",
  "name": "Metis Stardust Testnet",
  "nativeCurrency": {
    "name": "tMetis",
    "symbol": "METIS",
    "decimals": 18
  },
  "networkId": 588,
  "parent": {
    "type": "L2",
    "chain": "eip155-4",
    "bridges": [{
      "url": "https://bridge.metis.io"
    }]
  },
  "rpc": ["https://588.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://stardust.metis.io/?owner=588"],
  "shortName": "metis-stardust",
  "slip44": 1,
  "slug": "metis-stardust-testnet",
  "status": "deprecated",
  "testnet": true
};

var c592 = {
  "chain": "ASTR",
  "chainId": 592,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscout.com/astar",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }, {
    "name": "subscan",
    "url": "https://astar.subscan.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://Qma2GfW5nQHuA7nGqdEfwaXPL63G9oTwRTQKaGTfjNtM2W",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://Qmdvmx3p6gXBCLUMU1qivscaTNkT6h3URdhUTZCHLwKudg",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://astar.network/",
  "name": "Astar",
  "nativeCurrency": {
    "name": "Astar",
    "symbol": "ASTR",
    "decimals": 18
  },
  "networkId": 592,
  "redFlags": [],
  "rpc": ["https://592.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm.astar.network", "https://rpc.astar.network:8545"],
  "shortName": "astr",
  "slug": "astar",
  "testnet": false
};

var c595 = {
  "chain": "mACA",
  "chainId": 595,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscout.mandala.aca-staging.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://acala.network",
  "name": "Acala Mandala Testnet TC9",
  "nativeCurrency": {
    "name": "Acala Mandala Token",
    "symbol": "mACA",
    "decimals": 18
  },
  "networkId": 595,
  "rpc": ["https://595.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eth-rpc-tc9.aca-staging.network", "wss://eth-rpc-tc9.aca-staging.network"],
  "shortName": "maca",
  "slip44": 1,
  "slug": "acala-mandala-testnet-tc9",
  "testnet": true
};

var c596 = {
  "chain": "KAR",
  "chainId": 596,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscout.karura-testnet.aca-staging.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://karura.network",
  "name": "Karura Network Testnet",
  "nativeCurrency": {
    "name": "Karura Token",
    "symbol": "KAR",
    "decimals": 18
  },
  "networkId": 596,
  "rpc": ["https://596.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eth-rpc-karura-testnet.aca-staging.network", "wss://eth-rpc-karura-testnet.aca-staging.network"],
  "shortName": "tkar",
  "slip44": 1,
  "slug": "karura-network-testnet",
  "testnet": true
};

var c597 = {
  "chain": "ACA",
  "chainId": 597,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscout.acala-dev.aca-dev.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://acala.network",
  "name": "Acala Network Testnet",
  "nativeCurrency": {
    "name": "Acala Token",
    "symbol": "ACA",
    "decimals": 18
  },
  "networkId": 597,
  "rpc": ["https://597.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eth-rpc-acala-testnet.aca-staging.network", "wss://eth-rpc-acala-testnet.aca-staging.network"],
  "shortName": "taca",
  "slip44": 1,
  "slug": "acala-network-testnet",
  "testnet": true
};

var c599 = {
  "chain": "ETH",
  "chainId": 599,
  "explorers": [{
    "name": "blockscout",
    "url": "https://goerli.explorer.metisdevops.link",
    "standard": "EIP3091"
  }],
  "faucets": ["https://goerli.faucet.metisdevops.link"],
  "features": [],
  "icon": {
    "url": "ipfs://QmbWKNucbMtrMPPkHG5ZmVmvNUo8CzqHHcrpk1C2BVQsEG/2022_H-Brand_Stacked_WhiteGreen.svg",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://www.metis.io",
  "name": "Metis Goerli Testnet",
  "nativeCurrency": {
    "name": "Goerli Metis",
    "symbol": "METIS",
    "decimals": 18
  },
  "networkId": 599,
  "parent": {
    "type": "L2",
    "chain": "eip155-4",
    "bridges": [{
      "url": "https://testnet-bridge.metis.io"
    }]
  },
  "redFlags": [],
  "rpc": ["https://599.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://goerli.gateway.metisdevops.link"],
  "shortName": "metis-goerli",
  "slip44": 1,
  "slug": "metis-goerli-testnet",
  "status": "deprecated",
  "testnet": true
};

var c600 = {
  "chain": "MeshTestChain",
  "chainId": 600,
  "explorers": [],
  "faucets": [],
  "name": "Meshnyan testnet",
  "nativeCurrency": {
    "name": "Meshnyan Testnet Native Token",
    "symbol": "MESHT",
    "decimals": 18
  },
  "networkId": 600,
  "rpc": [],
  "shortName": "mesh-chain-testnet",
  "slip44": 1,
  "slug": "meshnyan-testnet",
  "testnet": true
};

var c601 = {
  "chain": "VINE",
  "chainId": 601,
  "explorers": [{
    "name": "Vine Explorer",
    "url": "https://vne.network/rose",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmTPbbhH4CkQiQWm4JUh3J9o5w79vXjFZaMBW4DKNuSVU3",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": ["https://vne.network/rose"],
  "icon": {
    "url": "ipfs://QmTPbbhH4CkQiQWm4JUh3J9o5w79vXjFZaMBW4DKNuSVU3",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://www.peer.inc",
  "name": "Vine Testnet",
  "nativeCurrency": {
    "name": "VINE",
    "symbol": "VNE",
    "decimals": 18
  },
  "networkId": 601,
  "rpc": ["https://601.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.vne.network"],
  "shortName": "VINE",
  "slug": "vine-testnet",
  "testnet": true
};

var c612 = {
  "chain": "EIOB",
  "chainId": 612,
  "explorers": [{
    "name": "EIOB Explorer",
    "url": "https://explorer.eiob.xyz",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmfJLG2mXgSqKx2V3A2jzTwt4vkozvQTTXkRy3os27wEVm",
    "width": 48,
    "height": 48,
    "format": "png"
  },
  "name": "EIOB Mainnet",
  "nativeCurrency": {
    "name": "EIOB",
    "symbol": "EIOB",
    "decimals": 18
  },
  "networkId": 612,
  "rpc": ["https://612.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.eiob.xyz"],
  "shortName": "eiob",
  "slug": "eiob",
  "testnet": false
};

var c614 = {
  "chain": "GLQ Blockchain",
  "chainId": 614,
  "explorers": [{
    "name": "GLQ Explorer",
    "url": "https://explorer.graphlinq.io",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://graphlinq.io",
  "name": "Graphlinq Blockchain Mainnet",
  "nativeCurrency": {
    "name": "GLQ",
    "symbol": "GLQ",
    "decimals": 18
  },
  "networkId": 614,
  "rpc": ["https://614.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://glq-dataseed.graphlinq.io"],
  "shortName": "glq",
  "slug": "graphlinq-blockchain",
  "testnet": false
};

var c634 = {
  "chain": "Avocado",
  "chainId": 634,
  "explorers": [{
    "name": "avoscan",
    "url": "https://avoscan.co",
    "standard": "none",
    "icon": {
      "url": "ipfs://Qma9rJSgy32UL1iXtXKFZQJA6FjkcUcDU4HR6y13Wu1vjn",
      "width": 600,
      "height": 600,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qma9rJSgy32UL1iXtXKFZQJA6FjkcUcDU4HR6y13Wu1vjn",
    "width": 600,
    "height": 600,
    "format": "png"
  },
  "infoURL": "https://avocado.instadapp.io",
  "name": "Avocado",
  "nativeCurrency": {
    "name": "USDC",
    "symbol": "USDC",
    "decimals": 18
  },
  "networkId": 634,
  "rpc": ["https://634.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.avocado.instadapp.io"],
  "shortName": "avocado",
  "slug": "avocado",
  "testnet": false
};

var c646 = {
  "chain": "FlowEVM",
  "chainId": 646,
  "explorers": [{
    "name": "Flow Diver",
    "url": "https://previewnet.flowdiver.io",
    "standard": "none"
  }],
  "faucets": ["https://previewnet-faucet.onflow.org"],
  "icon": {
    "url": "ipfs://QmQFugEvsfU3ARjjJ7YRLJwSxMfTk54WWzrofekTRBKFaC",
    "width": 2000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://developers.flow.com/evm/about",
  "name": "FlowEVM PreviewNet",
  "nativeCurrency": {
    "name": "FLOW",
    "symbol": "FLOW",
    "decimals": 18
  },
  "networkId": 646,
  "rpc": ["https://646.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://previewnet.evm.nodes.onflow.org"],
  "shortName": "flowevm-preview",
  "slug": "flowevm-previewnet",
  "testnet": false
};

var c647 = {
  "chain": "SX",
  "chainId": 647,
  "explorers": [{
    "name": "SX Network Toronto Explorer",
    "url": "https://explorer.toronto.sx.technology",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.toronto.sx.technology"],
  "icon": {
    "url": "ipfs://QmSXLXqyr2H6Ja5XrmznXbWTEvF2gFaL8RXNXgyLmDHjAF",
    "width": 896,
    "height": 690,
    "format": "png"
  },
  "infoURL": "https://www.sx.technology",
  "name": "SX Network Testnet",
  "nativeCurrency": {
    "name": "SX Network",
    "symbol": "SX",
    "decimals": 18
  },
  "networkId": 647,
  "rpc": ["https://647.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.toronto.sx.technology"],
  "shortName": "SX-Testnet",
  "slip44": 1,
  "slug": "sx-network-testnet",
  "testnet": true
};

var c648 = {
  "chain": "ACE",
  "chainId": 648,
  "explorers": [{
    "name": "Endurance Scan",
    "url": "https://explorer.endurance.fusionist.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://ace.fusionist.io/",
  "name": "Endurance Smart Chain Mainnet",
  "nativeCurrency": {
    "name": "Endurance Chain Native Token",
    "symbol": "ACE",
    "decimals": 18
  },
  "networkId": 648,
  "rpc": ["https://648.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-endurance.fusionist.io/"],
  "shortName": "ace",
  "slug": "endurance-smart-chain",
  "testnet": false
};

var c653 = {
  "chain": "Kalichain",
  "chainId": 653,
  "explorers": [{
    "name": "kalichain explorer",
    "url": "https://explorer.kalichain.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreieox7v337p3jfhd37dz74mq6mn3uk5i5475rmzpirmyp6ydcfzzqi",
    "width": 350,
    "height": 350,
    "format": "png"
  },
  "infoURL": "https://kalichain.com",
  "name": "Kalichain Testnet",
  "nativeCurrency": {
    "name": "kalis",
    "symbol": "KALIS",
    "decimals": 18
  },
  "networkId": 653,
  "rpc": ["https://653.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.kalichain.com"],
  "shortName": "kalichain",
  "slug": "kalichain-testnet",
  "testnet": true
};

var c654 = {
  "chain": "Kalichain",
  "chainId": 654,
  "explorers": [{
    "name": "kalichain explorer",
    "url": "https://explorer.kalichain.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreieox7v337p3jfhd37dz74mq6mn3uk5i5475rmzpirmyp6ydcfzzqi",
    "width": 350,
    "height": 350,
    "format": "png"
  },
  "infoURL": "https://kalichain.com",
  "name": "Kalichain",
  "nativeCurrency": {
    "name": "kalis",
    "symbol": "KALIS",
    "decimals": 18
  },
  "networkId": 654,
  "rpc": ["https://654.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.kalichain.com"],
  "shortName": "kalichainMainnet",
  "slug": "kalichain",
  "testnet": false
};

var c666 = {
  "chain": "PixieChain",
  "chainId": 666,
  "explorers": [],
  "faucets": ["https://chain.pixie.xyz/faucet"],
  "infoURL": "https://scan-testnet.chain.pixie.xyz",
  "name": "Pixie Chain Testnet",
  "nativeCurrency": {
    "name": "Pixie Chain Testnet Native Token",
    "symbol": "PCTT",
    "decimals": 18
  },
  "networkId": 666,
  "rpc": ["https://666.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://http-testnet.chain.pixie.xyz", "wss://ws-testnet.chain.pixie.xyz"],
  "shortName": "pixie-chain-testnet",
  "slip44": 1,
  "slug": "pixie-chain-testnet",
  "testnet": true
};

var c667 = {
  "chain": "LAOS",
  "chainId": 667,
  "explorers": [{
    "name": "blockscout",
    "url": "https://arrakis.gorengine.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmZ4YYcvhcaeotMPaGXC5Vab7JFaVkka37V8TiTJpT7Mak",
      "width": 586,
      "height": 558,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZ4YYcvhcaeotMPaGXC5Vab7JFaVkka37V8TiTJpT7Mak",
    "width": 586,
    "height": 558,
    "format": "png"
  },
  "infoURL": "https://www.laosfoundation.io/",
  "name": "LAOS Arrakis",
  "nativeCurrency": {
    "name": "LAOS",
    "symbol": "LAOS",
    "decimals": 18
  },
  "networkId": 667,
  "rpc": ["https://667.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://arrakis.gorengine.com/own", "wss://arrakis.gorengine.com/own"],
  "shortName": "laos",
  "slug": "laos-arrakis",
  "testnet": true,
  "title": "LAOS Testnet Arrakis"
};

var c668 = {
  "chain": "JuncaChain",
  "chainId": 668,
  "explorers": [{
    "name": "JuncaScan",
    "url": "https://scan.juncachain.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://junca-cash.world",
  "name": "JuncaChain",
  "nativeCurrency": {
    "name": "JuncaChain Native Token",
    "symbol": "JGC",
    "decimals": 18
  },
  "networkId": 668,
  "rpc": ["https://668.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.juncachain.com"],
  "shortName": "junca",
  "slug": "juncachain",
  "testnet": false
};

var c669 = {
  "chain": "JuncaChain testnet",
  "chainId": 669,
  "explorers": [{
    "name": "JuncaScan",
    "url": "https://scan-testnet.juncachain.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet-testnet.juncachain.com"],
  "infoURL": "https://junca-cash.world",
  "name": "JuncaChain testnet",
  "nativeCurrency": {
    "name": "JuncaChain Testnet Native Token",
    "symbol": "JGCT",
    "decimals": 18
  },
  "networkId": 669,
  "rpc": ["https://669.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.juncachain.com", "wss://ws-testnet.juncachain.com"],
  "shortName": "juncat",
  "slip44": 1,
  "slug": "juncachain-testnet",
  "testnet": true
};

var c686 = {
  "chain": "KAR",
  "chainId": 686,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscout.karura.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://acala.network/karura",
  "name": "Karura Network",
  "nativeCurrency": {
    "name": "Karura Token",
    "symbol": "KAR",
    "decimals": 18
  },
  "networkId": 686,
  "rpc": ["https://686.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eth-rpc-karura.aca-api.network", "wss://eth-rpc-karura.aca-api.network"],
  "shortName": "kar",
  "slip44": 686,
  "slug": "karura-network",
  "testnet": false
};

var c700 = {
  "chain": "SNS",
  "chainId": 700,
  "explorers": [{
    "name": "starscan",
    "url": "https://avastar.info",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://info.avastar.cc",
  "name": "Star Social Testnet",
  "nativeCurrency": {
    "name": "Social",
    "symbol": "SNS",
    "decimals": 18
  },
  "networkId": 700,
  "rpc": ["https://700.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://avastar.cc/ext/bc/C/rpc"],
  "shortName": "SNS",
  "slip44": 1,
  "slug": "star-social-testnet",
  "testnet": true
};

var c707 = {
  "chain": "BCS",
  "chainId": 707,
  "explorers": [{
    "name": "BlockChain Station Explorer",
    "url": "https://explorer.bcsdev.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://blockchainstation.io",
  "name": "BlockChain Station Mainnet",
  "nativeCurrency": {
    "name": "BCS Token",
    "symbol": "BCS",
    "decimals": 18
  },
  "networkId": 707,
  "rpc": ["https://707.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mainnet.bcsdev.io", "wss://rpc-ws-mainnet.bcsdev.io"],
  "shortName": "bcs",
  "slug": "blockchain-station",
  "testnet": false
};

var c708 = {
  "chain": "BCS",
  "chainId": 708,
  "explorers": [{
    "name": "BlockChain Station Explorer",
    "url": "https://testnet.bcsdev.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.bcsdev.io"],
  "infoURL": "https://blockchainstation.io",
  "name": "BlockChain Station Testnet",
  "nativeCurrency": {
    "name": "BCS Testnet Token",
    "symbol": "tBCS",
    "decimals": 18
  },
  "networkId": 708,
  "rpc": ["https://708.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.bcsdev.io", "wss://rpc-ws-testnet.bcsdev.io"],
  "shortName": "tbcs",
  "slip44": 1,
  "slug": "blockchain-station-testnet",
  "testnet": true
};

var c710 = {
  "chain": "HIGHBURY",
  "chainId": 710,
  "explorers": [{
    "name": "Furya EVM Explorer",
    "url": "https://explorer.furya.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreiby27m6esbsjthmknckq5ktsaaj2z6hylzljbsmvx4fgezdra3q4m",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreiby27m6esbsjthmknckq5ktsaaj2z6hylzljbsmvx4fgezdra3q4m",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://www.fury.black",
  "name": "Highbury",
  "nativeCurrency": {
    "name": "Fury",
    "symbol": "FURY",
    "decimals": 18
  },
  "networkId": 710,
  "rpc": ["https://710.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://highbury.furya.io", "https://rest.furya.io"],
  "shortName": "fury",
  "slug": "highbury",
  "testnet": false
};

var c713 = {
  "chain": "VRC",
  "chainId": 713,
  "explorers": [{
    "name": "vrcscan",
    "url": "https://vrcscan.com",
    "standard": "EIP3091"
  }, {
    "name": "dxbscan",
    "url": "https://dxb.vrcscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmasMkZJ6m7y77fgY6SooNnrH3Y4a3vVYNDWe9T3KusxeU",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://vrccoin.com",
  "name": "Vrcscan Mainnet",
  "nativeCurrency": {
    "name": "VRC Chain",
    "symbol": "VRC",
    "decimals": 18
  },
  "networkId": 713,
  "rpc": ["https://713.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mainnet-5.vrcscan.com", "https://rpc-mainnet-6.vrcscan.com", "https://rpc-mainnet-7.vrcscan.com", "https://rpc-mainnet-8.vrcscan.com"],
  "shortName": "vrc",
  "slug": "vrcscan",
  "testnet": false
};

var c719 = {
  "chain": "Shibarium",
  "chainId": 719,
  "explorers": [{
    "name": "shibscan",
    "url": "https://puppyscan.shib.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYNVkoZgRjDBQzJz6kog9mA2yPzQFW2oSKvhnkwuBhLQE",
    "width": 2000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://beta.shibariumtech.com",
  "name": "Shibarium Beta",
  "nativeCurrency": {
    "name": "BONE",
    "symbol": "BONE",
    "decimals": 18
  },
  "networkId": 719,
  "rpc": ["https://719.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://puppynet.shibrpc.com"],
  "shortName": "shibarium",
  "slug": "shibarium-beta",
  "testnet": false
};

var c721 = {
  "chain": "LYC",
  "chainId": 721,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.lycanchain.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmc8hsCbUUjnJDnXrDhFh4V1xk1gJwZbUyNJ39p72javji",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://lycanchain.com",
  "name": "Lycan Chain",
  "nativeCurrency": {
    "name": "Lycan",
    "symbol": "LYC",
    "decimals": 18
  },
  "networkId": 721,
  "rpc": ["https://721.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.lycanchain.com/"],
  "shortName": "LYC",
  "slug": "lycan-chain",
  "testnet": false
};

var c727 = {
  "chain": "BLU",
  "chainId": 727,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.blucrates.com",
  "name": "Blucrates",
  "nativeCurrency": {
    "name": "Blucrates",
    "symbol": "BLU",
    "decimals": 18
  },
  "networkId": 727,
  "rpc": ["https://727.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://data.bluchain.pro"],
  "shortName": "blu",
  "slip44": 727,
  "slug": "blucrates",
  "testnet": false
};

var c730 = {
  "chain": "Lovely",
  "chainId": 730,
  "explorers": [{
    "name": "Lovely Network Mainnet",
    "url": "https://scan.lovely.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPB7uW7Wj8zWWdeuPnUHPJ5FhaiTL76tv4ZQ4oKWEpb1g",
    "width": 897,
    "height": 824,
    "format": "png"
  },
  "infoURL": "https://lovely.network",
  "name": "Lovely Network Mainnet",
  "nativeCurrency": {
    "name": "Lovely",
    "symbol": "LOVELY",
    "decimals": 18
  },
  "networkId": 730,
  "rpc": ["https://730.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.lovely.network"],
  "shortName": "LOVELY",
  "slug": "lovely-network",
  "testnet": false
};

var c740 = {
  "chain": "Canto Tesnet",
  "chainId": 740,
  "explorers": [{
    "name": "Canto Tesnet Explorer (Neobase)",
    "url": "https://testnet-explorer.canto.neobase.one",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://canto.io",
  "name": "Canto Testnet",
  "nativeCurrency": {
    "name": "Canto",
    "symbol": "CANTO",
    "decimals": 18
  },
  "networkId": 740,
  "rpc": ["https://740.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eth.plexnode.wtf/"],
  "shortName": "tcanto",
  "slip44": 1,
  "slug": "canto-testnet",
  "status": "deprecated",
  "testnet": true
};

var c741 = {
  "chain": "VSCT",
  "chainId": 741,
  "explorers": [{
    "name": "ventionscan",
    "url": "https://testnet.ventionscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.vention.network"],
  "icon": {
    "url": "ipfs://QmcNepHmbmHW1BZYM3MFqJW4awwhmDqhUPRXXmRnXwg1U4",
    "width": 250,
    "height": 250,
    "format": "png"
  },
  "infoURL": "https://testnet.ventionscan.io",
  "name": "Vention Smart Chain Testnet",
  "nativeCurrency": {
    "name": "VNT",
    "symbol": "VNT",
    "decimals": 18
  },
  "networkId": 741,
  "rpc": ["https://741.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node-testnet.vention.network"],
  "shortName": "vsct",
  "slip44": 1,
  "slug": "vention-smart-chain-testnet",
  "testnet": true
};

var c742 = {
  "chain": "SPAY",
  "chainId": 742,
  "explorers": [{
    "name": "Script Explorer",
    "url": "https://explorer.script.tv",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://token.script.tv",
  "name": "Script Testnet",
  "nativeCurrency": {
    "name": "Script",
    "symbol": "SPAY",
    "decimals": 18
  },
  "networkId": 742,
  "rpc": ["https://742.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testeth-rpc-api.script.tv/rpc"],
  "shortName": "SPAY",
  "slip44": 1,
  "slug": "script-testnet",
  "testnet": true
};

var c747 = {
  "chain": "FlowEVM",
  "chainId": 747,
  "explorers": [{
    "name": "Flow Diver",
    "url": "https://flowdiver.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQFugEvsfU3ARjjJ7YRLJwSxMfTk54WWzrofekTRBKFaC",
    "width": 2000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://developers.flow.com/evm/about",
  "name": "FlowEVM Mainnet",
  "nativeCurrency": {
    "name": "FLOW",
    "symbol": "FLOW",
    "decimals": 18
  },
  "networkId": 747,
  "rpc": ["https://747.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.evm.nodes.onflow.org"],
  "shortName": "flowevm-mainnet",
  "slug": "flowevm",
  "testnet": false
};

var c766 = {
  "chain": "QOM",
  "chainId": 766,
  "explorers": [{
    "name": "QL1 Mainnet Explorer",
    "url": "https://mainnet.qom.one",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRc1kJ7AgcDL1BSoMYudatWHTrz27K6WNTwGifQb5V17D",
      "width": 518,
      "height": 518,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRc1kJ7AgcDL1BSoMYudatWHTrz27K6WNTwGifQb5V17D",
    "width": 518,
    "height": 518,
    "format": "png"
  },
  "infoURL": "https://qom.one",
  "name": "QL1",
  "nativeCurrency": {
    "name": "Shiba Predator",
    "symbol": "QOM",
    "decimals": 18
  },
  "networkId": 766,
  "rpc": ["https://766.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.qom.one"],
  "shortName": "qom",
  "slug": "ql1",
  "status": "incubating",
  "testnet": false
};

var c776 = {
  "chain": "OpenChain Testnet",
  "chainId": 776,
  "explorers": [{
    "name": "OPEN CHAIN TESTNET",
    "url": "https://testnet.openchain.info",
    "standard": "none"
  }],
  "faucets": ["https://faucet.openchain.info/"],
  "infoURL": "https://testnet.openchain.info/",
  "name": "OpenChain Testnet",
  "nativeCurrency": {
    "name": "Openchain Testnet",
    "symbol": "TOPC",
    "decimals": 18
  },
  "networkId": 776,
  "rpc": [],
  "shortName": "opc",
  "slip44": 1,
  "slug": "openchain-testnet",
  "testnet": true
};

var c777 = {
  "chain": "cheapETH",
  "chainId": 777,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://cheapeth.org/",
  "name": "cheapETH",
  "nativeCurrency": {
    "name": "cTH",
    "symbol": "cTH",
    "decimals": 18
  },
  "networkId": 777,
  "rpc": ["https://777.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node.cheapeth.org/rpc"],
  "shortName": "cth",
  "slug": "cheapeth",
  "testnet": false
};

var c786 = {
  "chain": "MAAL",
  "chainId": 786,
  "explorers": [{
    "name": "maalscan",
    "url": "https://maalscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreiexfqfe2x4impvwhra3xxa5eb25gv25zi3kkaoatdnld7wbxdzf2a",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://www.maalchain.com/",
  "name": "MAAL Chain",
  "nativeCurrency": {
    "name": "MAAL",
    "symbol": "MAAL",
    "decimals": 18
  },
  "networkId": 786,
  "rpc": ["https://786.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node1-mainnet.maalscan.io/", "https://node2-mainnet.maalscan.io/", "https://node3-mainnet.maalscan.io/"],
  "shortName": "maal",
  "slug": "maal-chain",
  "testnet": false
};

var c787 = {
  "chain": "ACA",
  "chainId": 787,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscout.acala.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://acala.network",
  "name": "Acala Network",
  "nativeCurrency": {
    "name": "Acala Token",
    "symbol": "ACA",
    "decimals": 18
  },
  "networkId": 787,
  "rpc": ["https://787.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eth-rpc-acala.aca-api.network", "wss://eth-rpc-acala.aca-api.network"],
  "shortName": "aca",
  "slip44": 787,
  "slug": "acala-network",
  "testnet": false
};

var c788 = {
  "chain": "Aerochain",
  "chainId": 788,
  "explorers": [{
    "name": "aeroscan",
    "url": "https://testnet.aeroscan.id",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.aerochain.id/"],
  "infoURL": "https://aerochaincoin.org/",
  "name": "Aerochain Testnet",
  "nativeCurrency": {
    "name": "Aerochain Testnet",
    "symbol": "TAero",
    "decimals": 18
  },
  "networkId": 788,
  "rpc": ["https://788.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.aerochain.id/"],
  "shortName": "taero",
  "slip44": 1,
  "slug": "aerochain-testnet",
  "testnet": true
};

var c789 = {
  "chain": "ETH",
  "chainId": 789,
  "explorers": [{
    "name": "patexscan",
    "url": "https://patexscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmTNTSNn3t5WpSEzQmUYbkxYkBKaH6QahyVdVrRKyPHChr",
      "width": 800,
      "height": 800,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmTNTSNn3t5WpSEzQmUYbkxYkBKaH6QahyVdVrRKyPHChr",
    "width": 800,
    "height": 800,
    "format": "png"
  },
  "infoURL": "https://patex.io/",
  "name": "Patex",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 789,
  "rpc": ["https://789.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.patex.io/"],
  "shortName": "peth",
  "slug": "patex",
  "testnet": false
};

var c799 = {
  "chain": "Rupaya Testnet",
  "chainId": 799,
  "explorers": [{
    "name": "rupayascan",
    "url": "https://scan.testnet.rupaya.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.testnet.rupaya.io"],
  "infoURL": "https://www.rupaya.io",
  "name": "Rupaya Testnet",
  "nativeCurrency": {
    "name": "Test Rupaya",
    "symbol": "TRUPX",
    "decimals": 18
  },
  "networkId": 799,
  "rpc": ["https://799.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.rupaya.io"],
  "shortName": "RupayaTestnet",
  "slip44": 1,
  "slug": "rupaya-testnet",
  "testnet": true
};

var c800 = {
  "chain": "Lucid",
  "chainId": 800,
  "explorers": [{
    "name": "Lucid Explorer",
    "url": "https://explorer.lucidcoin.io",
    "standard": "none"
  }],
  "faucets": ["https://faucet.lucidcoin.io"],
  "icon": {
    "url": "ipfs://bafybeigxiyyxll4vst5cjjh732mr6zhsnligxubaldyiul2xdvvi6ibktu",
    "width": 800,
    "height": 800,
    "format": "png"
  },
  "infoURL": "https://lucidcoin.io",
  "name": "Lucid Blockchain",
  "nativeCurrency": {
    "name": "LUCID",
    "symbol": "LUCID",
    "decimals": 18
  },
  "networkId": 800,
  "rpc": ["https://800.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.lucidcoin.io"],
  "shortName": "LUCID",
  "slug": "lucid-blockchain",
  "testnet": false
};

var c803 = {
  "chain": "Haic",
  "chainId": 803,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.haichain.io/",
  "name": "Haic",
  "nativeCurrency": {
    "name": "Haicoin",
    "symbol": "HAIC",
    "decimals": 18
  },
  "networkId": 803,
  "rpc": ["https://803.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://orig.haichain.io/"],
  "shortName": "haic",
  "slug": "haic",
  "testnet": false
};

var c808 = {
  "chain": "PF",
  "chainId": 808,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeMa6aw3ebUKJdGgbzDgcVtggzp7cQdfSrmzMYmnt5ywc",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://portalfantasy.io",
  "name": "Portal Fantasy Chain Test",
  "nativeCurrency": {
    "name": "Portal Fantasy Token",
    "symbol": "PFT",
    "decimals": 18
  },
  "networkId": 808,
  "rpc": ["https://808.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/portal-fantasy/testnet/rpc"],
  "shortName": "PFTEST",
  "slip44": 1,
  "slug": "portal-fantasy-chain-test",
  "testnet": true
};

var c810 = {
  "chain": "haven1",
  "chainId": 810,
  "explorers": [{
    "name": "Haven1 Explorer",
    "url": "https://testnet-explorer.haven1.org",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreih4jq33lz2mjwvu62hmo2ptt277et5l6oqi5ejuyxv2dir2iohsai",
      "width": 128,
      "height": 128,
      "format": "png"
    }
  }],
  "faucets": ["https://www.haven1.org/faucet"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreih4jq33lz2mjwvu62hmo2ptt277et5l6oqi5ejuyxv2dir2iohsai",
    "width": 128,
    "height": 128,
    "format": "png"
  },
  "infoURL": "https://www.haven1.org",
  "name": "Haven1 Testnet",
  "nativeCurrency": {
    "name": "Haven1",
    "symbol": "H1",
    "decimals": 18
  },
  "networkId": 810,
  "rpc": ["https://810.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.haven1.org"],
  "shortName": "h1",
  "slug": "haven1-testnet",
  "testnet": true
};

var c813 = {
  "chain": "MEER",
  "chainId": 813,
  "explorers": [{
    "name": "meerscan",
    "url": "https://qng.qitmeer.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }, {
    "name": "meerscan",
    "url": "https://qng.meerscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://github.com/Qitmeer",
  "name": "Qitmeer Network Mainnet",
  "nativeCurrency": {
    "name": "Qitmeer",
    "symbol": "MEER",
    "decimals": 18
  },
  "networkId": 813,
  "rpc": ["https://813.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm-dataseed1.meerscan.io", "https://evm-dataseed2.meerscan.io", "https://evm-dataseed3.meerscan.io", "https://evm-dataseed.meerscan.com", "https://qng.rpc.qitmeer.io", "https://mainnet.meerlabs.com", "https://rpc.dimai.ai", "https://rpc.woowow.io"],
  "shortName": "meer",
  "slip44": 813,
  "slug": "qitmeer-network",
  "testnet": false
};

var c814 = {
  "chain": "Firechain",
  "chainId": 814,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYjuztyURb3Fc6ZTLgCbwQa64CcVoigF5j9cafzuSbqgf",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://docs.thefirechain.com/",
  "name": "Firechain zkEVM",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 814,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://zkevm-bridge-rpc.thefirechain.com"
    }]
  },
  "rpc": ["https://814.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-zkevm.thefirechain.com"],
  "shortName": "firechan-zkEVM",
  "slug": "firechain-zkevm",
  "testnet": false,
  "title": "Firechain zkEVM"
};

var c818 = {
  "chain": "BOC",
  "chainId": 818,
  "explorers": [{
    "name": "BeOne Chain Mainnet",
    "url": "https://beonescan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmbVLQnaMDu86bPyKgCvTGhFBeYwjr15hQnrCcsp1EkAGL",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://beonechain.com",
  "name": "BeOne Chain Mainnet",
  "nativeCurrency": {
    "name": "BeOne Chain Mainnet",
    "symbol": "BOC",
    "decimals": 18
  },
  "networkId": 818,
  "rpc": ["https://818.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dataseed1.beonechain.com", "https://dataseed2.beonechain.com", "https://dataseed-us1.beonechain.com", "https://dataseed-us2.beonechain.com", "https://dataseed-uk1.beonechain.com", "https://dataseed-uk2.beonechain.com"],
  "shortName": "BOC",
  "slip44": 8181,
  "slug": "beone-chain",
  "testnet": false
};

var c820 = {
  "chain": "CLO",
  "chainId": 820,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://callisto.network",
  "name": "Callisto Mainnet",
  "nativeCurrency": {
    "name": "Callisto",
    "symbol": "CLO",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://820.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.callisto.network/"],
  "shortName": "clo",
  "slip44": 820,
  "slug": "callisto",
  "testnet": false
};

var c821 = {
  "chain": "CLO",
  "chainId": 821,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://callisto.network",
  "name": "Callisto Testnet Deprecated",
  "nativeCurrency": {
    "name": "Callisto Testnet Ether",
    "symbol": "TCLO",
    "decimals": 18
  },
  "networkId": 2,
  "rpc": [],
  "shortName": "tclo",
  "slip44": 1,
  "slug": "callisto-testnet-deprecated",
  "status": "deprecated",
  "testnet": true
};

var c822 = {
  "chain": "Runic",
  "chainId": 822,
  "explorers": [{
    "name": "RunicScan",
    "url": "https://scan.runic.build",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmW3RZKwBq12F7jVV2pn6T9WzwU5rosLYkVqoRQckfKvXo",
      "width": 340,
      "height": 340,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.runic.build"],
  "icon": {
    "url": "ipfs://QmW3RZKwBq12F7jVV2pn6T9WzwU5rosLYkVqoRQckfKvXo",
    "width": 340,
    "height": 340,
    "format": "png"
  },
  "infoURL": "https://runic.build",
  "name": "Runic Chain Testnet",
  "nativeCurrency": {
    "name": "Bitcoin",
    "symbol": "rBTC",
    "decimals": 18
  },
  "networkId": 822,
  "rpc": ["https://822.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.runic.build"],
  "shortName": "runic-testnet",
  "slug": "runic-chain-testnet",
  "status": "active",
  "testnet": true
};

var c831 = {
  "chain": "CDT Blockchain",
  "chainId": 831,
  "explorers": [{
    "name": "CDT Explorer",
    "url": "https://explorer.checkdot.io",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://checkdot.io",
  "name": "CheckDot Blockchain Devnet",
  "nativeCurrency": {
    "name": "CDT",
    "symbol": "CDT",
    "decimals": 18
  },
  "networkId": 831,
  "rpc": ["https://831.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnet.checkdot.io"],
  "shortName": "cdt",
  "slug": "checkdot-blockchain-devnet",
  "testnet": false
};

var c841 = {
  "chain": "Tara",
  "chainId": 841,
  "explorers": [{
    "name": "Taraxa Explorer",
    "url": "https://explorer.mainnet.taraxa.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQhdktNyBeXmCaVuQpi1B4yXheSUKrJA17L4wpECKzG5D",
    "width": 310,
    "height": 310,
    "format": "png"
  },
  "infoURL": "https://taraxa.io",
  "name": "Taraxa Mainnet",
  "nativeCurrency": {
    "name": "Tara",
    "symbol": "TARA",
    "decimals": 18
  },
  "networkId": 841,
  "rpc": ["https://841.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.mainnet.taraxa.io/"],
  "shortName": "tara",
  "slug": "taraxa",
  "testnet": false
};

var c842 = {
  "chain": "Tara",
  "chainId": 842,
  "explorers": [{
    "name": "Taraxa Explorer",
    "url": "https://explorer.testnet.taraxa.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQhdktNyBeXmCaVuQpi1B4yXheSUKrJA17L4wpECKzG5D",
    "width": 310,
    "height": 310,
    "format": "png"
  },
  "infoURL": "https://taraxa.io",
  "name": "Taraxa Testnet",
  "nativeCurrency": {
    "name": "Tara",
    "symbol": "TARA",
    "decimals": 18
  },
  "networkId": 842,
  "rpc": ["https://842.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.taraxa.io/"],
  "shortName": "taratest",
  "slip44": 1,
  "slug": "taraxa-testnet",
  "testnet": true
};

var c859 = {
  "chain": "ZeethChainDev",
  "chainId": 859,
  "explorers": [{
    "name": "Zeeth Explorer Dev",
    "url": "https://explorer.dev.zeeth.io",
    "standard": "none"
  }],
  "faucets": [],
  "name": "Zeeth Chain Dev",
  "nativeCurrency": {
    "name": "Zeeth Token",
    "symbol": "ZTH",
    "decimals": 18
  },
  "networkId": 859,
  "rpc": ["https://859.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.dev.zeeth.io"],
  "shortName": "zeethdev",
  "slug": "zeeth-chain-dev",
  "testnet": false
};

var c868 = {
  "chain": "FSC",
  "chainId": 868,
  "explorers": [{
    "name": "FSCScan",
    "url": "https://explorer.fantasiachain.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://fantasiachain.com/",
  "name": "Fantasia Chain Mainnet",
  "nativeCurrency": {
    "name": "FST",
    "symbol": "FST",
    "decimals": 18
  },
  "networkId": 868,
  "rpc": ["https://868.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-data1.fantasiachain.com/", "https://mainnet-data2.fantasiachain.com/", "https://mainnet-data3.fantasiachain.com/"],
  "shortName": "FSCMainnet",
  "slug": "fantasia-chain",
  "testnet": false
};

var c876 = {
  "chain": "Bandai Namco Research Verse",
  "chainId": 876,
  "explorers": [{
    "name": "Bandai Namco Research Verse Explorer",
    "url": "https://explorer.main.oasvrs.bnken.net",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreifhetalm3vpvjrg5u5d2momkcgvkz6rhltur5co3rslltbxzpr6yq",
    "width": 2048,
    "height": 2048,
    "format": "png"
  },
  "infoURL": "https://www.bandainamco-mirai.com/en/",
  "name": "Bandai Namco Research Verse Mainnet",
  "nativeCurrency": {
    "name": "OAS",
    "symbol": "OAS",
    "decimals": 18
  },
  "networkId": 876,
  "parent": {
    "type": "L2",
    "chain": "eip155-248"
  },
  "rpc": ["https://876.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.main.oasvrs.bnken.net"],
  "shortName": "BNKEN",
  "slug": "bandai-namco-research-verse",
  "testnet": false
};

var c877 = {
  "chain": "DXT",
  "chainId": 877,
  "explorers": [{
    "name": "dxtscan",
    "url": "https://dxtscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.dexit.network"],
  "infoURL": "https://dexit.network",
  "name": "Dexit Network",
  "nativeCurrency": {
    "name": "Dexit network",
    "symbol": "DXT",
    "decimals": 18
  },
  "networkId": 877,
  "rpc": ["https://877.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dxt.dexit.network"],
  "shortName": "DXT",
  "slug": "dexit-network",
  "testnet": false
};

var c880 = {
  "chain": "ambroschain",
  "chainId": 880,
  "explorers": [{
    "name": "Ambros Chain Explorer",
    "url": "https://ambrosscan.com",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://ambros.network",
  "name": "Ambros Chain Mainnet",
  "nativeCurrency": {
    "name": "AMBROS",
    "symbol": "AMBROS",
    "decimals": 18
  },
  "networkId": 880,
  "rpc": ["https://880.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.ambros.network"],
  "shortName": "ambros",
  "slug": "ambros-chain",
  "testnet": false
};

var c881 = {
  "chain": "Hypr",
  "chainId": 881,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://bafybeie6wdqkhub4p346rixkvft3l2bxa3kzo4q6dh5c5vgq6oejwlhu4a/",
    "width": 3600,
    "height": 3600,
    "format": "PNG"
  },
  "infoURL": "https://www.hypr.network",
  "name": "Hypr Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 881,
  "parent": {
    "type": "OP Stack",
    "chain": "OP",
    "bridges": []
  },
  "redFlags": [],
  "rpc": ["https://881.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.hypr.network"],
  "shortName": "ether",
  "slug": "hypr",
  "testnet": false
};

var c882 = {
  "chain": "Hypr",
  "chainId": 882,
  "explorers": [{
    "name": "Explorer",
    "url": "https://explorer-testnet.hypr.network",
    "standard": "OP Stack EVM"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://bafybeie6wdqkhub4p346rixkvft3l2bxa3kzo4q6dh5c5vgq6oejwlhu4a/",
    "width": 3600,
    "height": 3600,
    "format": "ONG"
  },
  "name": "Hypr Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 882,
  "redFlags": [],
  "rpc": ["https://882.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.hypr.network"],
  "shortName": "eth",
  "slug": "hypr-testnet",
  "testnet": true,
  "title": "https://explorer-testnet.hypr.network"
};

var c888 = {
  "chain": "WAN",
  "chainId": 888,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.wanscan.org",
  "name": "Wanchain",
  "nativeCurrency": {
    "name": "Wancoin",
    "symbol": "WAN",
    "decimals": 18
  },
  "networkId": 888,
  "rpc": ["https://888.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://gwan-ssl.wandevs.org:56891/"],
  "shortName": "wan",
  "slip44": 5718350,
  "slug": "wanchain",
  "testnet": false
};

var c898 = {
  "chain": "MAXI",
  "chainId": 898,
  "explorers": [{
    "name": "Maxi Chain Testnet Explorer",
    "url": "https://testnet.maxi.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.maxi.network"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmXMLcCaNPMyWCEYX2MZDJHNvj5cpj2cR5dRQtedBRNypT",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://maxi.network",
  "name": "MAXI Chain Testnet",
  "nativeCurrency": {
    "name": "MAXICOIN",
    "symbol": "MAXI",
    "decimals": 18
  },
  "networkId": 898,
  "rpc": ["https://898.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.maxi.network"],
  "shortName": "maxi-testnet",
  "slug": "maxi-chain-testnet",
  "testnet": true
};

var c900 = {
  "chain": "GAR",
  "chainId": 900,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer-testnet.garizon.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc",
      "width": 1024,
      "height": 613,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet-testnet.garizon.com"],
  "icon": {
    "url": "ipfs://QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc",
    "width": 1024,
    "height": 613,
    "format": "png"
  },
  "infoURL": "https://garizon.com",
  "name": "Garizon Testnet Stage0",
  "nativeCurrency": {
    "name": "Garizon",
    "symbol": "GAR",
    "decimals": 18
  },
  "networkId": 900,
  "rpc": ["https://900.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://s0-testnet.garizon.net/rpc"],
  "shortName": "gar-test-s0",
  "slug": "garizon-testnet-stage0",
  "testnet": true
};

var c901 = {
  "chain": "GAR",
  "chainId": 901,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer-testnet.garizon.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc",
      "width": 1024,
      "height": 613,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet-testnet.garizon.com"],
  "icon": {
    "url": "ipfs://QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc",
    "width": 1024,
    "height": 613,
    "format": "png"
  },
  "infoURL": "https://garizon.com",
  "name": "Garizon Testnet Stage1",
  "nativeCurrency": {
    "name": "Garizon",
    "symbol": "GAR",
    "decimals": 18
  },
  "networkId": 901,
  "parent": {
    "type": "shard",
    "chain": "eip155-900"
  },
  "rpc": ["https://901.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://s1-testnet.garizon.net/rpc"],
  "shortName": "gar-test-s1",
  "slip44": 1,
  "slug": "garizon-testnet-stage1",
  "testnet": true
};

var c902 = {
  "chain": "GAR",
  "chainId": 902,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer-testnet.garizon.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc",
      "width": 1024,
      "height": 613,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet-testnet.garizon.com"],
  "icon": {
    "url": "ipfs://QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc",
    "width": 1024,
    "height": 613,
    "format": "png"
  },
  "infoURL": "https://garizon.com",
  "name": "Garizon Testnet Stage2",
  "nativeCurrency": {
    "name": "Garizon",
    "symbol": "GAR",
    "decimals": 18
  },
  "networkId": 902,
  "parent": {
    "type": "shard",
    "chain": "eip155-900"
  },
  "rpc": ["https://902.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://s2-testnet.garizon.net/rpc"],
  "shortName": "gar-test-s2",
  "slip44": 1,
  "slug": "garizon-testnet-stage2",
  "testnet": true
};

var c903 = {
  "chain": "GAR",
  "chainId": 903,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer-testnet.garizon.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc",
      "width": 1024,
      "height": 613,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet-testnet.garizon.com"],
  "icon": {
    "url": "ipfs://QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc",
    "width": 1024,
    "height": 613,
    "format": "png"
  },
  "infoURL": "https://garizon.com",
  "name": "Garizon Testnet Stage3",
  "nativeCurrency": {
    "name": "Garizon",
    "symbol": "GAR",
    "decimals": 18
  },
  "networkId": 903,
  "parent": {
    "type": "shard",
    "chain": "eip155-900"
  },
  "rpc": ["https://903.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://s3-testnet.garizon.net/rpc"],
  "shortName": "gar-test-s3",
  "slip44": 1,
  "slug": "garizon-testnet-stage3",
  "testnet": true
};

var c909 = {
  "chain": "PF",
  "chainId": 909,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeMa6aw3ebUKJdGgbzDgcVtggzp7cQdfSrmzMYmnt5ywc",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://portalfantasy.io",
  "name": "Portal Fantasy Chain",
  "nativeCurrency": {
    "name": "Portal Fantasy Token",
    "symbol": "PFT",
    "decimals": 18
  },
  "networkId": 909,
  "rpc": [],
  "shortName": "PF",
  "slug": "portal-fantasy-chain",
  "status": "incubating",
  "testnet": false
};

var c910 = {
  "chain": "DBONE",
  "chainId": 910,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://decentrabone.com",
  "name": "DecentraBone Layer1 Testnet",
  "nativeCurrency": {
    "name": "DecentraBone",
    "symbol": "DBONE",
    "decimals": 18
  },
  "networkId": 910,
  "rpc": ["https://910.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://layer1test.decentrabone.com"],
  "shortName": "DBONE",
  "slip44": 1,
  "slug": "decentrabone-layer1-testnet",
  "testnet": true
};

var c911 = {
  "chain": "TAPROOT CHAIN",
  "chainId": 911,
  "explorers": [{
    "name": "TAPROOT Scan",
    "url": "https://scan.taprootchain.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmeucqvcreQk8nnSRUiHo3QTvLoYYB7shJTKXj5Tk6BtWi",
      "width": 100,
      "height": 100,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeucqvcreQk8nnSRUiHo3QTvLoYYB7shJTKXj5Tk6BtWi",
    "width": 100,
    "height": 100,
    "format": "png"
  },
  "infoURL": "https://taprootchain.io",
  "name": "TAPROOT Mainnet",
  "nativeCurrency": {
    "name": "TBTC",
    "symbol": "TBTC",
    "decimals": 18
  },
  "networkId": 911,
  "rpc": ["https://911.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.taprootchain.io"],
  "shortName": "TAPROOT-Mainnet",
  "slug": "taproot",
  "testnet": false,
  "title": "TAPROOT Mainnet"
};

var c917 = {
  "chain": "FIRE",
  "chainId": 917,
  "explorers": [{
    "name": "FireScan",
    "url": "https://rinia.firescan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.thefirechain.com"],
  "icon": {
    "url": "ipfs://QmRnnw2gtbU9TWJMLJ6tks7SN6HQV5rRugeoyN6csTYHt1",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://thefirechain.com",
  "name": "Rinia Testnet",
  "nativeCurrency": {
    "name": "Firechain",
    "symbol": "FIRE",
    "decimals": 18
  },
  "networkId": 917,
  "rpc": ["https://917.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rinia-rpc1.thefirechain.com"],
  "shortName": "tfire",
  "slip44": 1,
  "slug": "rinia-testnet",
  "testnet": true
};

var c919 = {
  "chain": "ETH",
  "chainId": 919,
  "explorers": [{
    "name": "modescout",
    "url": "https://sepolia.explorer.mode.network",
    "standard": "none"
  }],
  "faucets": ["https://sepoliafaucet.com/"],
  "icon": {
    "url": "ipfs://bafkreidi5y7afj5z4xrz7uz5rkg2mcsv2p2n4ui4g7q4k4ecdz65i2agou",
    "width": 2160,
    "height": 2160,
    "format": "png"
  },
  "infoURL": "https://docs.mode.network/",
  "name": "Mode Testnet",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 919,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": [{
      "url": "https://bridge.mode.network/"
    }]
  },
  "rpc": ["https://919.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sepolia.mode.network"],
  "shortName": "modesep",
  "slip44": 1,
  "slug": "mode-testnet",
  "testnet": true
};

var c927 = {
  "chain": "Yidark",
  "chainId": 927,
  "explorers": [{
    "name": "Yidarkscan",
    "url": "https://yidarkscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdbFGqrpiLQGtAeUAyeS2NBvACfgrchEF466ni5q36fuZ",
    "width": 401,
    "height": 401,
    "format": "png"
  },
  "infoURL": "https://yidarkscan.com",
  "name": "Yidark Chain Mainnet",
  "nativeCurrency": {
    "name": "Yidark",
    "symbol": "YDK",
    "decimals": 18
  },
  "networkId": 927,
  "rpc": ["https://927.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.yidark.io"],
  "shortName": "ydk",
  "slug": "yidark-chain",
  "testnet": false
};

var c940 = {
  "chain": "tPLS",
  "chainId": 940,
  "explorers": [],
  "faucets": ["https://faucet.v2.testnet.pulsechain.com/"],
  "infoURL": "https://pulsechain.com/",
  "name": "PulseChain Testnet",
  "nativeCurrency": {
    "name": "Test Pulse",
    "symbol": "tPLS",
    "decimals": 18
  },
  "networkId": 940,
  "rpc": ["https://940.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.v2.testnet.pulsechain.com/", "wss://rpc.v2.testnet.pulsechain.com/"],
  "shortName": "tpls",
  "slip44": 1,
  "slug": "pulsechain-testnet",
  "status": "deprecated",
  "testnet": true
};

var c941 = {
  "chain": "t2bPLS",
  "chainId": 941,
  "explorers": [],
  "faucets": ["https://faucet.v2b.testnet.pulsechain.com/"],
  "infoURL": "https://pulsechain.com/",
  "name": "PulseChain Testnet v2b",
  "nativeCurrency": {
    "name": "Test Pulse",
    "symbol": "tPLS",
    "decimals": 18
  },
  "networkId": 941,
  "rpc": ["https://941.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.v2b.testnet.pulsechain.com/", "wss://rpc.v2b.testnet.pulsechain.com/"],
  "shortName": "t2bpls",
  "slip44": 1,
  "slug": "pulsechain-testnet-v2b",
  "status": "deprecated",
  "testnet": true
};

var c942 = {
  "chain": "t3PLS",
  "chainId": 942,
  "explorers": [],
  "faucets": ["https://faucet.v3.testnet.pulsechain.com/"],
  "infoURL": "https://pulsechain.com/",
  "name": "PulseChain Testnet v3",
  "nativeCurrency": {
    "name": "Test Pulse",
    "symbol": "tPLS",
    "decimals": 18
  },
  "networkId": 942,
  "rpc": ["https://942.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.v3.testnet.pulsechain.com/", "wss://rpc.v3.testnet.pulsechain.com/"],
  "shortName": "t3pls",
  "slip44": 1,
  "slug": "pulsechain-testnet-v3",
  "status": "deprecated",
  "testnet": true
};

var c943 = {
  "chain": "t4PLS",
  "chainId": 943,
  "ens": {
    "registry": "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
  },
  "explorers": [{
    "name": "blockscout",
    "url": "https://otter-testnet-pulsechain.g4mm4.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.v4.testnet.pulsechain.com/"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://Qmckj9B9F3jWDk9bv9HwoPmfjrx2Ju8J2BQSNoPFdYGduj",
    "width": 433,
    "height": 402,
    "format": "png"
  },
  "infoURL": "https://pulsechain.com",
  "name": "PulseChain Testnet v4",
  "nativeCurrency": {
    "name": "Test Pulse",
    "symbol": "tPLS",
    "decimals": 18
  },
  "networkId": 943,
  "rpc": ["https://943.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.v4.testnet.pulsechain.com", "wss://rpc.v4.testnet.pulsechain.com", "https://pulsechain-testnet-rpc.publicnode.com", "wss://pulsechain-testnet-rpc.publicnode.com", "https://rpc-testnet-pulsechain.g4mm4.io", "wss://rpc-testnet-pulsechain.g4mm4.io"],
  "shortName": "t4pls",
  "slip44": 1,
  "slug": "pulsechain-testnet-v4",
  "status": "active",
  "testnet": true
};

var c956 = {
  "chain": "munode",
  "chainId": 956,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://munode.dev/",
  "name": "muNode Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 956,
  "rpc": [],
  "shortName": "munode",
  "slip44": 1,
  "slug": "munode-testnet",
  "testnet": true
};

var c957 = {
  "chain": "Lyra",
  "chainId": 957,
  "explorers": [{
    "name": "Lyra Explorer",
    "url": "https://explorer.lyra.finance",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreifrvwcwcgs2luampufdbdgohuxue5rep3u4p4owmwskob7hzpcfdq",
      "width": 2640,
      "height": 2640,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreifrvwcwcgs2luampufdbdgohuxue5rep3u4p4owmwskob7hzpcfdq",
    "width": 2640,
    "height": 2640,
    "format": "png"
  },
  "infoURL": "https://lyra.finance",
  "name": "Lyra Chain",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 957,
  "rpc": ["https://957.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.lyra.finance"],
  "shortName": "lyra",
  "slug": "lyra-chain",
  "testnet": false
};

var c963 = {
  "chain": "BTC20",
  "chainId": 963,
  "explorers": [{
    "name": "blockscout",
    "url": "https://scan.bitcoincode.technology",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmRUzDpn3xqPYnjLuZvFs2Attio9VxGRUprXEjcNQDcpe5",
    "width": 375,
    "height": 456,
    "format": "png"
  },
  "infoURL": "https://bitcoincode.technology",
  "name": "BTC20 Smart Chain",
  "nativeCurrency": {
    "name": "BTCC",
    "symbol": "BTCC",
    "decimals": 18
  },
  "networkId": 963,
  "rpc": ["https://963.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.bitcoincode.technology/"],
  "shortName": "btc20",
  "slug": "btc20-smart-chain",
  "testnet": false
};

var c970 = {
  "chain": "Oort Mainnet",
  "chainId": 970,
  "explorers": [{
    "name": "Oort Mainnet Explorer",
    "url": "https://mainnet-scan.oortech.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreidrbvklkb52sgmg7cmy42fhf7vqpig7qj7bnrq24ijdwywkzr2tfy",
      "width": 1440,
      "height": 1440,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreidrbvklkb52sgmg7cmy42fhf7vqpig7qj7bnrq24ijdwywkzr2tfy",
    "width": 1440,
    "height": 1440,
    "format": "png"
  },
  "infoURL": "https://oortech.com",
  "name": "Oort Mainnet",
  "nativeCurrency": {
    "name": "Oort",
    "symbol": "OORT",
    "decimals": 18
  },
  "networkId": 970,
  "rpc": ["https://970.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.oortech.com"],
  "shortName": "ccn",
  "slug": "oort",
  "testnet": false
};

var c971 = {
  "chain": "Huygens",
  "chainId": 971,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZ1jbxFZcuotj3eZ6iKFrg9ZXnaV8AK6sGRa7ELrceWyD",
    "width": 1043,
    "height": 1079,
    "format": "png"
  },
  "infoURL": "https://oortech.com",
  "name": "Oort Huygens",
  "nativeCurrency": {
    "name": "Oort",
    "symbol": "CCN",
    "decimals": 18
  },
  "networkId": 971,
  "rpc": [],
  "shortName": "Huygens",
  "slug": "oort-huygens",
  "testnet": false
};

var c972 = {
  "chain": "Ascraeus",
  "chainId": 972,
  "explorers": [{
    "name": "Oort Ascraeus Explorer",
    "url": "https://ascraeus-scan.oortech.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreidrbvklkb52sgmg7cmy42fhf7vqpig7qj7bnrq24ijdwywkzr2tfy",
      "width": 1440,
      "height": 1440,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreidrbvklkb52sgmg7cmy42fhf7vqpig7qj7bnrq24ijdwywkzr2tfy",
    "width": 1440,
    "height": 1440,
    "format": "png"
  },
  "infoURL": "https://oortech.com",
  "name": "Oort Ascraeus",
  "nativeCurrency": {
    "name": "Oort",
    "symbol": "CCNA",
    "decimals": 18
  },
  "networkId": 972,
  "rpc": ["https://972.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://ascraeus-rpc.oortech.com"],
  "shortName": "Ascraeus",
  "slug": "oort-ascraeus",
  "testnet": false,
  "title": "Oort Ascraeus"
};

var c977 = {
  "chain": "YETI",
  "chainId": 977,
  "explorers": [],
  "faucets": ["https://faucet.nepalblockchain.network"],
  "infoURL": "https://nepalblockchain.network",
  "name": "Nepal Blockchain Network",
  "nativeCurrency": {
    "name": "Nepal Blockchain Network Ether",
    "symbol": "YETI",
    "decimals": 18
  },
  "networkId": 977,
  "rpc": ["https://977.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.nepalblockchain.dev", "https://api.nepalblockchain.network"],
  "shortName": "yeti",
  "slug": "nepal-blockchain-network",
  "testnet": false
};

var c980 = {
  "chain": "TOP",
  "chainId": 980,
  "explorers": [{
    "name": "topscan.dev",
    "url": "https://www.topscan.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYikaM849eZrL8pGNeVhEHVTKWpxdGMvCY5oFBfZ2ndhd",
    "width": 800,
    "height": 800,
    "format": "png"
  },
  "infoURL": "https://www.topnetwork.org/",
  "name": "TOP Mainnet EVM",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 0,
  "rpc": ["https://980.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://ethapi.topnetwork.org"],
  "shortName": "top_evm",
  "slug": "top-evm",
  "testnet": false
};

var c985 = {
  "chain": "MEMO",
  "chainId": 985,
  "explorers": [{
    "name": "Memo Mainnet Explorer",
    "url": "https://scan.metamemo.one:8080",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreig52paynhccs4o5ew6f7mk3xoqu2bqtitmfvlgnwarh2pm33gbdrq",
      "width": 128,
      "height": 128,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.metamemo.one/"],
  "icon": {
    "url": "ipfs://bafkreig52paynhccs4o5ew6f7mk3xoqu2bqtitmfvlgnwarh2pm33gbdrq",
    "width": 128,
    "height": 128,
    "format": "png"
  },
  "name": "Memo Smart Chain Mainnet",
  "nativeCurrency": {
    "name": "Memo",
    "symbol": "CMEMO",
    "decimals": 18
  },
  "networkId": 985,
  "rpc": ["https://985.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://chain.metamemo.one:8501", "wss://chain.metamemo.one:16801"],
  "shortName": "memochain",
  "slug": "memo-smart-chain",
  "testnet": false
};

var c987 = {
  "chain": "Avalanche",
  "chainId": 987,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Orange Testnet",
  "nativeCurrency": {
    "name": "Orange Testnet Token",
    "symbol": "JUICE",
    "decimals": 18
  },
  "networkId": 987,
  "redFlags": [],
  "rpc": ["https://987.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/orangetest/testnet/rpc"],
  "shortName": "Orange Testnet",
  "slug": "orange-testnet",
  "testnet": true
};

var c989 = {
  "chain": "TOP",
  "chainId": 989,
  "explorers": [{
    "name": "topscan.dev",
    "url": "https://www.topscan.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYikaM849eZrL8pGNeVhEHVTKWpxdGMvCY5oFBfZ2ndhd",
    "width": 800,
    "height": 800,
    "format": "png"
  },
  "infoURL": "https://www.topnetwork.org/",
  "name": "TOP Mainnet",
  "nativeCurrency": {
    "name": "TOP",
    "symbol": "TOP",
    "decimals": 6
  },
  "networkId": 0,
  "rpc": [],
  "shortName": "top",
  "slug": "top",
  "testnet": false
};

var c990 = {
  "chain": "$EL",
  "chainId": 990,
  "explorers": [{
    "name": "eLiberty Mainnet",
    "url": "https://explorer.eliberty.ngo",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.eliberty.ngo"],
  "icon": {
    "url": "ipfs://Qmcr8US1DZcK3ooiMtE8tEQPgep12abXzxPw1jCkgZhji9",
    "width": 150,
    "height": 150,
    "format": "png"
  },
  "infoURL": "https://eliberty.ngo",
  "name": "eLiberty Mainnet",
  "nativeCurrency": {
    "name": "eLiberty",
    "symbol": "$EL",
    "decimals": 18
  },
  "networkId": 990,
  "rpc": ["https://990.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.eliberty.ngo"],
  "shortName": "ELm",
  "slug": "eliberty",
  "testnet": false
};

var c997 = {
  "chain": "5ireChain",
  "chainId": 997,
  "explorers": [{
    "name": "5ireChain Explorer",
    "url": "https://explorer.5ire.network",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmaZDNDFLWESH4i3XqwEWfWBb1HPnQSNbDAr74nr2x8QAk",
      "width": 800,
      "height": 800,
      "format": "svg"
    }
  }],
  "faucets": ["https://explorer.5ire.network/faucet"],
  "icon": {
    "url": "ipfs://QmaZDNDFLWESH4i3XqwEWfWBb1HPnQSNbDAr74nr2x8QAk",
    "width": 800,
    "height": 800,
    "format": "svg"
  },
  "infoURL": "https://5ire.org",
  "name": "5ireChain Thunder",
  "nativeCurrency": {
    "name": "5ire Token",
    "symbol": "5ire",
    "decimals": 18
  },
  "networkId": 997,
  "rpc": ["https://997.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.5ire.network"],
  "shortName": "5ire",
  "slug": "5irechain-thunder",
  "testnet": true
};

var c998 = {
  "chain": "LN",
  "chainId": 998,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.luckynetwork.org",
    "standard": "none"
  }, {
    "name": "expedition",
    "url": "https://lnscan.org",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreidmvcd5i7touug55hj45mf2pgabxamy5fziva7mtx5n664s3yap6m",
    "width": 205,
    "height": 28,
    "format": "png"
  },
  "infoURL": "https://luckynetwork.org",
  "name": "Lucky Network",
  "nativeCurrency": {
    "name": "Lucky",
    "symbol": "L99",
    "decimals": 18
  },
  "networkId": 998,
  "rpc": ["https://998.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.luckynetwork.org", "wss://ws.lnscan.org", "https://rpc.lnscan.org"],
  "shortName": "ln",
  "slug": "lucky-network",
  "testnet": false
};

var c999 = {
  "chain": "ETH",
  "chainId": 999,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmZ6qaRwTPFEZUspwMUjaxC6KhmzcELdRQcQzS3P72Dzts/Vector.svg",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "name": "Zora Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "GETH",
    "decimals": 18
  },
  "networkId": 999,
  "redFlags": ["reusedChainId"],
  "rpc": ["https://999.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.rpc.zora.co/"],
  "shortName": "zora-testnet",
  "slug": "zora-testnet",
  "testnet": true
};

var c1000 = {
  "chain": "GTON",
  "chainId": 1000,
  "explorers": [{
    "name": "GTON Network Explorer",
    "url": "https://explorer.gton.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://gton.capital",
  "name": "GTON Mainnet",
  "nativeCurrency": {
    "name": "GCD",
    "symbol": "GCD",
    "decimals": 18
  },
  "networkId": 1000,
  "parent": {
    "type": "L2",
    "chain": "eip155-1"
  },
  "rpc": ["https://1000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.gton.network/"],
  "shortName": "gton",
  "slug": "gton",
  "testnet": false
};

var c1001 = {
  "chain": "KLAY",
  "chainId": 1001,
  "explorers": [{
    "name": "Klaytnscope",
    "url": "https://baobab.klaytnscope.com",
    "standard": "EIP3091"
  }, {
    "name": "Klaytnfinder",
    "url": "https://baobab.klaytnfinder.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://baobab.wallet.klaytn.com/access?next=faucet"],
  "features": [],
  "infoURL": "https://klaytn.foundation",
  "name": "Klaytn Testnet Baobab",
  "nativeCurrency": {
    "name": "KLAY",
    "symbol": "KLAY",
    "decimals": 18
  },
  "networkId": 1001,
  "redFlags": [],
  "rpc": ["https://1001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://public-en-baobab.klaytn.net", "https://api.baobab.klaytn.net:8651"],
  "shortName": "Baobab",
  "slip44": 1,
  "slug": "klaytn-testnet-baobab",
  "testnet": true
};

var c1003 = {
  "chain": "TET",
  "chainId": 1003,
  "explorers": [{
    "name": "Tectum explorer",
    "url": "https://explorer.tectum.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYvFVprVdAGJH4iHUCXGEmy7pq8MMfxEjM64SuXutz9qx",
      "width": 256,
      "height": 256,
      "format": "png"
    }
  }],
  "faucets": [],
  "infoURL": "https://softnote.com",
  "name": "Tectum Emission Token",
  "nativeCurrency": {
    "name": "Tectum",
    "symbol": "TET",
    "decimals": 8
  },
  "networkId": 1003,
  "rpc": ["https://1003.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.softnote.com/"],
  "shortName": "tet",
  "slug": "tectum-emission-token",
  "testnet": false
};

var c1004 = {
  "chain": "T-EKTA",
  "chainId": 1004,
  "explorers": [{
    "name": "test-ektascan",
    "url": "https://test.ektascan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmfMd564KUPK8eKZDwGCT71ZC2jMnUZqP6LCtLpup3rHH1",
      "width": 2100,
      "height": 2100,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmfMd564KUPK8eKZDwGCT71ZC2jMnUZqP6LCtLpup3rHH1",
    "width": 2100,
    "height": 2100,
    "format": "png"
  },
  "infoURL": "https://www.ekta.io",
  "name": "T-EKTA",
  "nativeCurrency": {
    "name": "T-EKTA",
    "symbol": "T-EKTA",
    "decimals": 18
  },
  "networkId": 1004,
  "rpc": ["https://1004.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://test.ekta.io:8545"],
  "shortName": "t-ekta",
  "slug": "t-ekta",
  "testnet": true,
  "title": "EKTA Testnet T-EKTA"
};

var c1007 = {
  "chain": "NEW",
  "chainId": 1007,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.newtonproject.org/",
  "name": "Newton Testnet",
  "nativeCurrency": {
    "name": "Newton",
    "symbol": "NEW",
    "decimals": 18
  },
  "networkId": 1007,
  "rpc": ["https://1007.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc1.newchain.newtonproject.org"],
  "shortName": "tnew",
  "slip44": 1,
  "slug": "newton-testnet",
  "testnet": true
};

var c1008 = {
  "chain": "EUN",
  "chainId": 1008,
  "explorers": [{
    "name": "eurusexplorer",
    "url": "https://explorer.eurus.network",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmaGd5L9jGPbfyGXBFhu9gjinWJ66YtNrXq8x6Q98Eep9e",
      "width": 471,
      "height": 471,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmaGd5L9jGPbfyGXBFhu9gjinWJ66YtNrXq8x6Q98Eep9e",
    "width": 471,
    "height": 471,
    "format": "svg"
  },
  "infoURL": "https://eurus.network",
  "name": "Eurus Mainnet",
  "nativeCurrency": {
    "name": "Eurus",
    "symbol": "EUN",
    "decimals": 18
  },
  "networkId": 1008,
  "rpc": ["https://1008.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.eurus.network/"],
  "shortName": "eun",
  "slug": "eurus",
  "testnet": false
};

var c1009 = {
  "chain": "Jumbo",
  "chainId": 1009,
  "explorers": [{
    "name": "Jumboscan",
    "url": "https://jumboscan.jumbochain.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }],
  "infoURL": "https://jumbochain.org",
  "name": "Jumbochain Mainnet",
  "nativeCurrency": {
    "name": "JNFTC",
    "symbol": "JNFTC",
    "decimals": 18
  },
  "networkId": 1009,
  "rpc": ["https://1009.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpcpriv.jumbochain.org"],
  "shortName": "Jumboscan",
  "slip44": 1,
  "slug": "jumbochain",
  "testnet": false
};

var c1010 = {
  "chain": "EVC",
  "chainId": 1010,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://evrice.com",
  "name": "Evrice Network",
  "nativeCurrency": {
    "name": "Evrice",
    "symbol": "EVC",
    "decimals": 18
  },
  "networkId": 1010,
  "rpc": ["https://1010.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://meta.evrice.com"],
  "shortName": "EVC",
  "slip44": 1020,
  "slug": "evrice-network",
  "testnet": false
};

var c1012 = {
  "chain": "NEW",
  "chainId": 1012,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.newtonproject.org/",
  "name": "Newton",
  "nativeCurrency": {
    "name": "Newton",
    "symbol": "NEW",
    "decimals": 18
  },
  "networkId": 1012,
  "rpc": ["https://1012.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://global.rpc.mainnet.newtonproject.org"],
  "shortName": "new",
  "slug": "newton",
  "testnet": false
};

var c1022 = {
  "chain": "Sakura",
  "chainId": 1022,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://clover.finance/sakura",
  "name": "Sakura",
  "nativeCurrency": {
    "name": "Sakura",
    "symbol": "SKU",
    "decimals": 18
  },
  "networkId": 1022,
  "rpc": [],
  "shortName": "sku",
  "slug": "sakura",
  "testnet": false
};

var c1023 = {
  "chain": "Clover",
  "chainId": 1023,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://clover.finance",
  "name": "Clover Testnet",
  "nativeCurrency": {
    "name": "Clover",
    "symbol": "CLV",
    "decimals": 18
  },
  "networkId": 1023,
  "rpc": [],
  "shortName": "tclv",
  "slip44": 1,
  "slug": "clover-testnet",
  "testnet": true
};

var c1024 = {
  "chain": "CLV",
  "chainId": 1024,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://clv.org",
  "name": "CLV Parachain",
  "nativeCurrency": {
    "name": "CLV",
    "symbol": "CLV",
    "decimals": 18
  },
  "networkId": 1024,
  "rpc": ["https://1024.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api-para.clover.finance"],
  "shortName": "clv",
  "slug": "clv-parachain",
  "testnet": false
};

var c1028 = {
  "chain": "BTTC",
  "chainId": 1028,
  "explorers": [{
    "name": "testbttcscan",
    "url": "https://testscan.bittorrentchain.io",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://bittorrentchain.io/",
  "name": "BitTorrent Chain Testnet",
  "nativeCurrency": {
    "name": "BitTorrent",
    "symbol": "BTT",
    "decimals": 18
  },
  "networkId": 1028,
  "rpc": ["https://1028.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testrpc.bittorrentchain.io/"],
  "shortName": "tbtt",
  "slip44": 1,
  "slug": "bittorrent-chain-testnet",
  "testnet": true
};

var c1030 = {
  "chain": "Conflux",
  "chainId": 1030,
  "explorers": [{
    "name": "Conflux Scan",
    "url": "https://evm.confluxscan.net",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreifj7n24u2dslfijfihwqvpdeigt5aj3k3sxv6s35lv75sxsfr3ojy",
    "width": 460,
    "height": 576,
    "format": "png"
  },
  "infoURL": "https://confluxnetwork.org",
  "name": "Conflux eSpace",
  "nativeCurrency": {
    "name": "CFX",
    "symbol": "CFX",
    "decimals": 18
  },
  "networkId": 1030,
  "rpc": ["https://1030.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm.confluxrpc.com"],
  "shortName": "cfx",
  "slug": "conflux-espace",
  "testnet": false
};

var c1031 = {
  "chain": "Proxy Network",
  "chainId": 1031,
  "explorers": [{
    "name": "proxy network testnet",
    "url": "http://testnet-explorer.theproxy.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://theproxy.network",
  "name": "Proxy Network Testnet",
  "nativeCurrency": {
    "name": "PRX",
    "symbol": "PRX",
    "decimals": 18
  },
  "networkId": 1031,
  "rpc": ["https://1031.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://128.199.94.183:8041"],
  "shortName": "prx",
  "slip44": 1,
  "slug": "proxy-network-testnet",
  "testnet": true
};

var c1038 = {
  "chain": "Bronos",
  "chainId": 1038,
  "explorers": [{
    "name": "Bronos Testnet Explorer",
    "url": "https://tbroscan.bronos.org",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafybeifkgtmhnq4sxu6jn22i7ass7aih6ubodr77k6ygtu4tjbvpmkw2ga",
      "width": 500,
      "height": 500,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.bronos.org"],
  "icon": {
    "url": "ipfs://bafybeifkgtmhnq4sxu6jn22i7ass7aih6ubodr77k6ygtu4tjbvpmkw2ga",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://bronos.org",
  "name": "Bronos Testnet",
  "nativeCurrency": {
    "name": "tBRO",
    "symbol": "tBRO",
    "decimals": 18
  },
  "networkId": 1038,
  "rpc": ["https://1038.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm-testnet.bronos.org"],
  "shortName": "bronos-testnet",
  "slip44": 1,
  "slug": "bronos-testnet",
  "testnet": true
};

var c1039 = {
  "chain": "Bronos",
  "chainId": 1039,
  "explorers": [{
    "name": "Bronos Explorer",
    "url": "https://broscan.bronos.org",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafybeifkgtmhnq4sxu6jn22i7ass7aih6ubodr77k6ygtu4tjbvpmkw2ga",
      "width": 500,
      "height": 500,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeifkgtmhnq4sxu6jn22i7ass7aih6ubodr77k6ygtu4tjbvpmkw2ga",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://bronos.org",
  "name": "Bronos Mainnet",
  "nativeCurrency": {
    "name": "BRO",
    "symbol": "BRO",
    "decimals": 18
  },
  "networkId": 1039,
  "rpc": [],
  "shortName": "bronos-mainnet",
  "slug": "bronos",
  "testnet": false
};

var c1071 = {
  "chain": "ShimmerEVM",
  "chainId": 1071,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer.evm.testnet.shimmer.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://evm-toolkit.evm.testnet.shimmer.network", "https://evm-faucet.testnet.shimmer.network"],
  "icon": {
    "url": "ipfs://bafkreibky2sy6qhi6arktayvologkrgu5kudpgdxfkx4uosbvmstz7v4di",
    "width": 720,
    "height": 720,
    "format": "png"
  },
  "infoURL": "https://shimmer.network",
  "name": "ShimmerEVM Testnet Deprecated",
  "nativeCurrency": {
    "name": "SMR",
    "symbol": "SMR",
    "decimals": 18
  },
  "networkId": 1071,
  "rpc": [],
  "shortName": "shimmerevm-testnet-deprecated",
  "slip44": 1,
  "slug": "shimmerevm-testnet-deprecated",
  "status": "deprecated",
  "testnet": true,
  "title": "ShimmerEVM Testnet Deprecated"
};

var c1072 = {
  "chain": "ShimmerEVM",
  "chainId": 1072,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer.evm.testnet.shimmer.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://evm-toolkit.evm.testnet.shimmer.network", "https://evm-faucet.testnet.shimmer.network"],
  "icon": {
    "url": "ipfs://bafkreibky2sy6qhi6arktayvologkrgu5kudpgdxfkx4uosbvmstz7v4di",
    "width": 720,
    "height": 720,
    "format": "png"
  },
  "infoURL": "https://shimmer.network",
  "name": "ShimmerEVM Testnet Deprecated 1072",
  "nativeCurrency": {
    "name": "SMR",
    "symbol": "SMR",
    "decimals": 6
  },
  "networkId": 1072,
  "rpc": [],
  "shortName": "shimmerevm-testnet-deprecated-1072",
  "slip44": 1,
  "slug": "shimmerevm-testnet-deprecated-1072",
  "status": "deprecated",
  "testnet": true,
  "title": "ShimmerEVM Testnet Deprecated 1072"
};

var c1073 = {
  "chain": "ShimmerEVM",
  "chainId": 1073,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer.evm.testnet.shimmer.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://evm-toolkit.evm.testnet.shimmer.network", "https://evm-faucet.testnet.shimmer.network"],
  "icon": {
    "url": "ipfs://bafkreibky2sy6qhi6arktayvologkrgu5kudpgdxfkx4uosbvmstz7v4di",
    "width": 720,
    "height": 720,
    "format": "png"
  },
  "infoURL": "https://shimmer.network",
  "name": "ShimmerEVM Testnet",
  "nativeCurrency": {
    "name": "SMR",
    "symbol": "SMR",
    "decimals": 6
  },
  "networkId": 1073,
  "rpc": ["https://1073.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://json-rpc.evm.testnet.shimmer.network"],
  "shortName": "shimmerevm-testnet",
  "slip44": 1,
  "slug": "shimmerevm-testnet",
  "testnet": true,
  "title": "ShimmerEVM Testnet"
};

var c1079 = {
  "chain": "Mintara",
  "chainId": 1079,
  "explorers": [{
    "name": "explorer",
    "url": "https://subnets-test.avax.network/mintara",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeie7jzlzlpz7c3a3oh4x5joej23dj2qf3cexmchjyc72hv3fblcaja",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://playthink.co.jp",
  "name": "Mintara Testnet",
  "nativeCurrency": {
    "name": "MINTARA",
    "symbol": "MNTR",
    "decimals": 18
  },
  "networkId": 1079,
  "rpc": ["https://1079.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/mintara/testnet/rpc"],
  "shortName": "mintara-testnet",
  "slip44": 1,
  "slug": "mintara-testnet",
  "testnet": true,
  "title": "Mintara Testnet"
};

var c1080 = {
  "chain": "Mintara",
  "chainId": 1080,
  "explorers": [{
    "name": "explorer",
    "url": "https://subnets.avax.network/mintara",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeie7jzlzlpz7c3a3oh4x5joej23dj2qf3cexmchjyc72hv3fblcaja",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://playthink.co.jp",
  "name": "Mintara Mainnet",
  "nativeCurrency": {
    "name": "MINTARA",
    "symbol": "MNTR",
    "decimals": 18
  },
  "networkId": 1080,
  "rpc": ["https://1080.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/mintara/mainnet/rpc"],
  "shortName": "mintara",
  "slug": "mintara",
  "testnet": false,
  "title": "Mintara Mainnet"
};

var c1088 = {
  "chain": "ETH",
  "chainId": 1088,
  "explorers": [{
    "name": "blockscout",
    "url": "https://andromeda-explorer.metis.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmbWKNucbMtrMPPkHG5ZmVmvNUo8CzqHHcrpk1C2BVQsEG/2022_H-Brand_Stacked_WhiteGreen.svg",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://www.metis.io",
  "name": "Metis Andromeda Mainnet",
  "nativeCurrency": {
    "name": "Metis",
    "symbol": "METIS",
    "decimals": 18
  },
  "networkId": 1088,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.metis.io"
    }]
  },
  "redFlags": [],
  "rpc": ["https://1088.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://andromeda.metis.io/?owner=1088", "https://metis.drpc.org", "wss://metis.drpc.org"],
  "shortName": "metis-andromeda",
  "slug": "metis-andromeda",
  "testnet": false
};

var c1089 = {
  "chain": "Humans",
  "chainId": 1089,
  "explorers": [{
    "name": "explorer.guru",
    "url": "https://humans.explorers.guru",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmU83haX3TNifDDjBx6RP6ByqES1Kg9VqeJC87X9ipKyCS",
      "width": 386,
      "height": 397,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmX6XuoQDTTjYqAmdNJiieLDZSwHHyUx44yQb4E3tmHmEA",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://humans.ai",
  "name": "Humans.ai Mainnet",
  "nativeCurrency": {
    "name": "HEART",
    "symbol": "HEART",
    "decimals": 18
  },
  "networkId": 1089,
  "rpc": ["https://1089.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://jsonrpc.humans.nodestake.top", "https://humans-mainnet-evm.itrocket.net", "https://humans-evm-rpc.staketab.org:443", "https://evm.humans.stakepool.dev.br", "https://mainnet-humans-evm.konsortech.xyz", "https://evm-rpc.mainnet.humans.zone", "https://json-rpc.humans.bh.rocks", "https://evm-rpc.humans.huginn.tech"],
  "shortName": "humans",
  "slug": "humans-ai",
  "testnet": false
};

var c1099 = {
  "chain": "MOAC",
  "chainId": 1099,
  "explorers": [{
    "name": "moac explorer",
    "url": "https://explorer.moac.io",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://moac.io",
  "name": "MOAC mainnet",
  "nativeCurrency": {
    "name": "MOAC",
    "symbol": "mc",
    "decimals": 18
  },
  "networkId": 1099,
  "rpc": [],
  "shortName": "moac",
  "slip44": 314,
  "slug": "moac",
  "testnet": false
};

var c1100 = {
  "chain": "Dymension",
  "chainId": 1100,
  "explorers": [{
    "name": "dym.fyi",
    "url": "https://dym.fyi",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreic4sjyqikz33xzpcctczvkiwfj44q5i3i7zslycnjiqmyx5ybc3fi",
    "width": 1200,
    "height": 1200,
    "format": "png"
  },
  "infoURL": "https://dymension.xyz",
  "name": "Dymension",
  "nativeCurrency": {
    "name": "DYM",
    "symbol": "DYM",
    "decimals": 18
  },
  "networkId": 1100,
  "rpc": ["https://1100.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dymension-evm.blockpi.network/v1/rpc/public", "https://dymension-evm-rpc.publicnode.com", "wss://dymension-evm-rpc.publicnode.com"],
  "shortName": "dymension",
  "slug": "dymension",
  "testnet": false
};

var c1101 = {
  "chain": "Polygon",
  "chainId": 1101,
  "explorers": [{
    "name": "blockscout",
    "url": "https://zkevm.polygonscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmNmJZkQgx9RcFLS3rvxQTVYcPfyAFPr667keHTUxB9PDv",
      "width": 122,
      "height": 135,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNmJZkQgx9RcFLS3rvxQTVYcPfyAFPr667keHTUxB9PDv",
    "width": 122,
    "height": 135,
    "format": "png"
  },
  "infoURL": "https://polygon.technology/polygon-zkevm",
  "name": "Polygon zkEVM",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1101,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.zkevm-rpc.com"
    }]
  },
  "rpc": ["https://1101.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://zkevm-rpc.com", "https://polygon-zkevm.drpc.org", "wss://polygon-zkevm.drpc.org"],
  "shortName": "zkevm",
  "slug": "polygon-zkevm",
  "testnet": false,
  "title": "Polygon zkEVM"
};

var c1107 = {
  "chain": "BLXQ",
  "chainId": 1107,
  "explorers": [{
    "name": "BLXq Explorer",
    "url": "https://explorer.blx.org",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmS9kDKr1rgcz5W55yCQVfFs1vRTCneaLHt1t9cBizpqpH",
      "width": 1000,
      "height": 1000,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmS9kDKr1rgcz5W55yCQVfFs1vRTCneaLHt1t9cBizpqpH",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://blx.org",
  "name": "BLXq Testnet",
  "nativeCurrency": {
    "name": "BLXQ",
    "symbol": "BLXQ",
    "decimals": 18
  },
  "networkId": 1107,
  "rpc": ["https://1107.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnetq1.blx.org"],
  "shortName": "tblxq",
  "slip44": 1,
  "slug": "blxq-testnet",
  "testnet": true
};

var c1108 = {
  "chain": "BLXQ",
  "chainId": 1108,
  "explorers": [{
    "name": "BLXq Explorer",
    "url": "https://explorer.blxq.org",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmS9kDKr1rgcz5W55yCQVfFs1vRTCneaLHt1t9cBizpqpH",
      "width": 1000,
      "height": 1000,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmS9kDKr1rgcz5W55yCQVfFs1vRTCneaLHt1t9cBizpqpH",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://blx.org",
  "name": "BLXq Mainnet",
  "nativeCurrency": {
    "name": "BLXQ",
    "symbol": "BLXQ",
    "decimals": 18
  },
  "networkId": 1108,
  "rpc": ["https://1108.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.blxq.org"],
  "shortName": "blxq",
  "slug": "blxq",
  "testnet": false
};

var c1111 = {
  "chain": "WEMIX",
  "chainId": 1111,
  "explorers": [{
    "name": "WEMIX Block Explorer",
    "url": "https://explorer.wemix.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://wemix.com",
  "name": "WEMIX3.0 Mainnet",
  "nativeCurrency": {
    "name": "WEMIX",
    "symbol": "WEMIX",
    "decimals": 18
  },
  "networkId": 1111,
  "rpc": ["https://1111.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.wemix.com", "wss://ws.wemix.com"],
  "shortName": "wemix",
  "slug": "wemix3-0",
  "testnet": false
};

var c1112 = {
  "chain": "TWEMIX",
  "chainId": 1112,
  "explorers": [{
    "name": "WEMIX Testnet Microscope",
    "url": "https://microscope.test.wemix.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://wallet.test.wemix.com/faucet"],
  "infoURL": "https://wemix.com",
  "name": "WEMIX3.0 Testnet",
  "nativeCurrency": {
    "name": "TestnetWEMIX",
    "symbol": "tWEMIX",
    "decimals": 18
  },
  "networkId": 1112,
  "rpc": ["https://1112.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.test.wemix.com", "wss://ws.test.wemix.com"],
  "shortName": "twemix",
  "slip44": 1,
  "slug": "wemix3-0-testnet",
  "testnet": true
};

var c1113 = {
  "chain": "BSQ",
  "chainId": 1113,
  "explorers": [{
    "name": "B2 Hub Habitat Testnet Explorer",
    "url": "https://habitat-hub-explorer.bsquared.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmPV6ASrQDEkEW3g3ni7p2rJMPeciRLpEpvrAc1QfzVkx9",
      "width": 640,
      "height": 640,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPV6ASrQDEkEW3g3ni7p2rJMPeciRLpEpvrAc1QfzVkx9",
    "width": 640,
    "height": 640,
    "format": "png"
  },
  "infoURL": "https://www.bsquared.network",
  "name": "B2 Hub Habitat Testnet",
  "nativeCurrency": {
    "name": "BSquared Token",
    "symbol": "BSQ",
    "decimals": 18
  },
  "networkId": 1113,
  "rpc": ["https://1113.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://habitat-hub-rpc.bsquared.network"],
  "shortName": "B2Hub-testnet",
  "slug": "b2-hub-habitat-testnet",
  "testnet": true
};

var c1115 = {
  "chain": "Core",
  "chainId": 1115,
  "explorers": [{
    "name": "Core Scan Testnet",
    "url": "https://scan.test.btcs.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmeTQaBCkpbsxNNWTpoNrMsnwnAEf1wYTcn7CiiZGfUXD2",
      "width": 200,
      "height": 217,
      "format": "png"
    }
  }],
  "faucets": ["https://scan.test.btcs.network/faucet"],
  "icon": {
    "url": "ipfs://QmeTQaBCkpbsxNNWTpoNrMsnwnAEf1wYTcn7CiiZGfUXD2",
    "width": 200,
    "height": 217,
    "format": "png"
  },
  "infoURL": "https://www.coredao.org",
  "name": "Core Blockchain Testnet",
  "nativeCurrency": {
    "name": "Core Blockchain Testnet Native Token",
    "symbol": "tCORE",
    "decimals": 18
  },
  "networkId": 1115,
  "rpc": ["https://1115.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.test.btcs.network/"],
  "shortName": "tcore",
  "slip44": 1,
  "slug": "core-blockchain-testnet",
  "testnet": true
};

var c1116 = {
  "chain": "Core",
  "chainId": 1116,
  "explorers": [{
    "name": "Core Scan",
    "url": "https://scan.coredao.org",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmeTQaBCkpbsxNNWTpoNrMsnwnAEf1wYTcn7CiiZGfUXD2",
      "width": 200,
      "height": 217,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeTQaBCkpbsxNNWTpoNrMsnwnAEf1wYTcn7CiiZGfUXD2",
    "width": 200,
    "height": 217,
    "format": "png"
  },
  "infoURL": "https://www.coredao.org",
  "name": "Core Blockchain Mainnet",
  "nativeCurrency": {
    "name": "Core Blockchain Native Token",
    "symbol": "CORE",
    "decimals": 18
  },
  "networkId": 1116,
  "rpc": ["https://1116.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.coredao.org/", "https://rpc-core.icecreamswap.com", "https://core.drpc.org", "wss://core.drpc.org"],
  "shortName": "core",
  "slug": "core-blockchain",
  "testnet": false
};

var c1117 = {
  "chain": "DOGS",
  "chainId": 1117,
  "explorers": [{
    "name": "Dogcoin",
    "url": "https://explorer.dogcoin.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.dogcoin.network"],
  "icon": {
    "url": "ipfs://QmZCadkExKThak3msvszZjo6UnAbUJKE61dAcg4TixuMC3",
    "width": 160,
    "height": 171,
    "format": "png"
  },
  "infoURL": "https://dogcoin.network",
  "name": "Dogcoin Mainnet",
  "nativeCurrency": {
    "name": "Dogcoin",
    "symbol": "DOGS",
    "decimals": 18
  },
  "networkId": 1117,
  "rpc": ["https://1117.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.dogcoin.me"],
  "shortName": "DOGSm",
  "slug": "dogcoin",
  "testnet": false
};

var c1123 = {
  "chain": "Habitat",
  "chainId": 1123,
  "explorers": [{
    "name": "blockscout",
    "url": "https://habitat-explorer.bsquared.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmPV6ASrQDEkEW3g3ni7p2rJMPeciRLpEpvrAc1QfzVkx9",
      "width": 640,
      "height": 640,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPV6ASrQDEkEW3g3ni7p2rJMPeciRLpEpvrAc1QfzVkx9",
    "width": 640,
    "height": 640,
    "format": "png"
  },
  "infoURL": "https://www.bsquared.network",
  "name": "B2 Habitat Testnet",
  "nativeCurrency": {
    "name": "Bitcoin",
    "symbol": "BTC",
    "decimals": 18
  },
  "networkId": 1123,
  "parent": {
    "type": "L2",
    "chain": "eip155-1113"
  },
  "rpc": ["https://1123.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://b2habitat-testnet.alt.technology", "https://habitat-rpc.bsquared.network", "https://habitat-rpc-public.bsquared.network"],
  "shortName": "B2-testnet",
  "slug": "b2-habitat-testnet",
  "testnet": true,
  "title": "B2 Habitat Testnet"
};

var c1130 = {
  "chain": "defichain-evm",
  "chainId": 1130,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdR3YL9F95ajwVwfxAGoEzYwm9w7JNsPSfUPjSaQogVjK",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://meta.defichain.com/",
  "name": "DeFiChain EVM Network Mainnet",
  "nativeCurrency": {
    "name": "DeFiChain",
    "symbol": "DFI",
    "decimals": 18
  },
  "networkId": 1130,
  "rpc": [],
  "shortName": "DFI",
  "slip44": 1130,
  "slug": "defichain-evm-network",
  "status": "incubating",
  "testnet": false
};

var c1131 = {
  "chain": "defichain-evm-testnet",
  "chainId": 1131,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdR3YL9F95ajwVwfxAGoEzYwm9w7JNsPSfUPjSaQogVjK",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://meta.defichain.com/",
  "name": "DeFiChain EVM Network Testnet",
  "nativeCurrency": {
    "name": "DeFiChain",
    "symbol": "DFI",
    "decimals": 18
  },
  "networkId": 1131,
  "rpc": [],
  "shortName": "DFI-T",
  "slip44": 1,
  "slug": "defichain-evm-network-testnet",
  "status": "incubating",
  "testnet": true
};

var c1133 = {
  "chain": "DFI",
  "chainId": 1133,
  "explorers": [{
    "name": "MetaScan",
    "url": "https://meta.defiscan.live",
    "standard": "EIP3091"
  }],
  "faucets": ["http://tc04.mydefichain.com/faucet"],
  "icon": {
    "url": "ipfs://QmdR3YL9F95ajwVwfxAGoEzYwm9w7JNsPSfUPjSaQogVjK",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://meta.defichain.com",
  "name": "DeFiMetaChain Changi Testnet",
  "nativeCurrency": {
    "name": "DeFiChain Token",
    "symbol": "DFI",
    "decimals": 18
  },
  "networkId": 1133,
  "rpc": ["https://1133.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dmc.mydefichain.com/changi", "https://testnet-dmc.mydefichain.com:20551"],
  "shortName": "changi",
  "slug": "defimetachain-changi-testnet",
  "testnet": true
};

var c1138 = {
  "chain": "AmStar",
  "chainId": 1138,
  "explorers": [{
    "name": "amstarscan-testnet",
    "url": "https://testnet.amstarscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmd4TMQdnYxaUZqnVddh5S37NGH72g2kkK38ccCEgdZz1C",
    "width": 599,
    "height": 563,
    "format": "png"
  },
  "infoURL": "https://sinso.io",
  "name": "AmStar Testnet",
  "nativeCurrency": {
    "name": "SINSO",
    "symbol": "SINSO",
    "decimals": 18
  },
  "networkId": 1138,
  "rpc": ["https://1138.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.amstarscan.com"],
  "shortName": "ASARt",
  "slip44": 1,
  "slug": "amstar-testnet",
  "testnet": true
};

var c1139 = {
  "chain": "MATH",
  "chainId": 1139,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://mathchain.org",
  "name": "MathChain",
  "nativeCurrency": {
    "name": "MathChain",
    "symbol": "MATH",
    "decimals": 18
  },
  "networkId": 1139,
  "rpc": ["https://1139.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mathchain-asia.maiziqianbao.net/rpc", "https://mathchain-us.maiziqianbao.net/rpc"],
  "shortName": "MATH",
  "slug": "mathchain",
  "testnet": false
};

var c1140 = {
  "chain": "MATH",
  "chainId": 1140,
  "explorers": [],
  "faucets": ["https://scan.boka.network/#/Galois/faucet"],
  "infoURL": "https://mathchain.org",
  "name": "MathChain Testnet",
  "nativeCurrency": {
    "name": "MathChain",
    "symbol": "MATH",
    "decimals": 18
  },
  "networkId": 1140,
  "rpc": ["https://1140.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://galois-hk.maiziqianbao.net/rpc"],
  "shortName": "tMATH",
  "slip44": 1,
  "slug": "mathchain-testnet",
  "testnet": true
};

var c1149 = {
  "chain": "Plexchain",
  "chainId": 1149,
  "explorers": [{
    "name": "Plexchain Explorer",
    "url": "https://explorer.plexfinance.us",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmcXzfMNSQ7SZzKemNquVoXyG5ergdqCGeLWjRYETGBTUM",
      "width": 256,
      "height": 256,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmcXzfMNSQ7SZzKemNquVoXyG5ergdqCGeLWjRYETGBTUM",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://plexfinance.us/",
  "name": "Symplexia Smart Chain",
  "nativeCurrency": {
    "name": "Plex Native Token",
    "symbol": "PLEX",
    "decimals": 18
  },
  "networkId": 1149,
  "rpc": ["https://1149.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://plex-rpc.plexfinance.us"],
  "shortName": "Plexchain",
  "slug": "symplexia-smart-chain",
  "testnet": false
};

var c1170 = {
  "chain": "Origin",
  "chainId": 1170,
  "explorers": [{
    "name": "Origin Explorer",
    "url": "https://evm-explorer.origin.uptick.network",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmRGJ6PqYHDTWuUQ6xfnK8S82NzRXiMjTnSGat9qtLuaLP",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRGJ6PqYHDTWuUQ6xfnK8S82NzRXiMjTnSGat9qtLuaLP",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://www.uptick.network",
  "name": "Origin Testnet",
  "nativeCurrency": {
    "name": "Origin",
    "symbol": "UOC",
    "decimals": 18
  },
  "networkId": 1170,
  "rpc": ["https://1170.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://json-rpc.origin.uptick.network"],
  "shortName": "auoc",
  "slip44": 1,
  "slug": "origin-testnet",
  "testnet": true
};

var c1177 = {
  "chain": "SHT",
  "chainId": 1177,
  "explorers": [{
    "name": "Smart Host Teknoloji TESTNET Explorer",
    "url": "https://s2.tl.web.tr:4000",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmTrLGHyQ1Le25Q7EgNSF5Qq8D2SocKvroDkLqurdBuSQQ",
      "width": 1655,
      "height": 1029,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmTrLGHyQ1Le25Q7EgNSF5Qq8D2SocKvroDkLqurdBuSQQ",
    "width": 1655,
    "height": 1029,
    "format": "png"
  },
  "infoURL": "https://smart-host.com.tr",
  "name": "Smart Host Teknoloji TESTNET",
  "nativeCurrency": {
    "name": "Smart Host Teknoloji TESTNET",
    "symbol": "tSHT",
    "decimals": 18
  },
  "networkId": 1177,
  "rpc": ["https://1177.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://s2.tl.web.tr:4041"],
  "shortName": "sht",
  "slip44": 1,
  "slug": "smart-host-teknoloji-testnet",
  "testnet": true
};

var c1197 = {
  "chain": "IORA",
  "chainId": 1197,
  "explorers": [{
    "name": "ioraexplorer",
    "url": "https://explorer.iorachain.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeiehps5cqdhqottu2efo4jeehwpkz5rbux3cjxd75rm6rjm4sgs2wi",
    "width": 250,
    "height": 250,
    "format": "png"
  },
  "infoURL": "https://iorachain.com",
  "name": "Iora Chain",
  "nativeCurrency": {
    "name": "Iora",
    "symbol": "IORA",
    "decimals": 18
  },
  "networkId": 1197,
  "rpc": ["https://1197.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dataseed.iorachain.com"],
  "shortName": "iora",
  "slug": "iora-chain",
  "testnet": false
};

var c1201 = {
  "chain": "Evanesco Testnet",
  "chainId": 1201,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://evanesco.org/",
  "name": "Evanesco Testnet",
  "nativeCurrency": {
    "name": "AVIS",
    "symbol": "AVIS",
    "decimals": 18
  },
  "networkId": 1201,
  "rpc": ["https://1201.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://seed5.evanesco.org:8547"],
  "shortName": "avis",
  "slip44": 1,
  "slug": "evanesco-testnet",
  "testnet": true
};

var c1202 = {
  "chain": "WTT",
  "chainId": 1202,
  "explorers": [{
    "name": "WTTScout",
    "url": "https://explorer.cadaut.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "http://www.cadaut.com",
  "name": "World Trade Technical Chain Mainnet",
  "nativeCurrency": {
    "name": "World Trade Token",
    "symbol": "WTT",
    "decimals": 18
  },
  "networkId": 2048,
  "rpc": ["https://1202.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.cadaut.com", "wss://rpc.cadaut.com/ws"],
  "shortName": "wtt",
  "slug": "world-trade-technical-chain",
  "testnet": false
};

var c1213 = {
  "chain": "POPCATEUM",
  "chainId": 1213,
  "explorers": [{
    "name": "popcateum explorer",
    "url": "https://explorer.popcateum.org",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://popcateum.org",
  "name": "Popcateum Mainnet",
  "nativeCurrency": {
    "name": "Popcat",
    "symbol": "POP",
    "decimals": 18
  },
  "networkId": 1213,
  "rpc": ["https://1213.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dataseed.popcateum.org"],
  "shortName": "popcat",
  "slug": "popcateum",
  "testnet": false
};

var c1214 = {
  "chain": "ENTER",
  "chainId": 1214,
  "explorers": [{
    "name": "Enter Explorer - Expenter",
    "url": "https://explorer.entercoin.net",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://Qmb2UYVc1MjLPi8vhszWRxqBJYoYkWQVxDJRSmtrgk6j2E",
      "width": 64,
      "height": 64,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmb2UYVc1MjLPi8vhszWRxqBJYoYkWQVxDJRSmtrgk6j2E",
    "width": 64,
    "height": 64,
    "format": "png"
  },
  "infoURL": "https://entercoin.net",
  "name": "EnterChain Mainnet",
  "nativeCurrency": {
    "name": "EnterCoin",
    "symbol": "ENTER",
    "decimals": 18
  },
  "networkId": 1214,
  "rpc": ["https://1214.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://tapi.entercoin.net/"],
  "shortName": "enter",
  "slug": "enterchain",
  "testnet": false
};

var c1220 = {
  "chain": "1220",
  "chainId": 1220,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmXo2p1i4zsbTNEu41EjjrhdmbKFDGHEHeADXZ3x2fgNKE/1682003789585.jpeg",
    "width": 3600,
    "height": 3600,
    "format": "jpeg"
  },
  "infoURL": "https://flagblockchain.com/",
  "name": "Flag Testnet",
  "nativeCurrency": {
    "name": "FLAG",
    "symbol": "FLAG",
    "decimals": 18
  },
  "networkId": 1220,
  "redFlags": [],
  "rpc": ["https://1220.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.flagscan.io"],
  "shortName": "Flag",
  "slug": "flag-testnet",
  "testnet": true
};

var c1224 = {
  "chain": "$HYB",
  "chainId": 1224,
  "explorers": [{
    "name": "Hybrid Testnet",
    "url": "https://alphatestnet.buildonhybrid.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdGfvH9qfvbMXYKosS1nHbw3q5UtFJky4hdMDmmKDTx8Y",
    "width": 250,
    "height": 250,
    "format": "png"
  },
  "infoURL": "https://buildonhybrid.com",
  "name": "Hybrid Testnet",
  "nativeCurrency": {
    "name": "Hybrid",
    "symbol": "$HYB",
    "decimals": 18
  },
  "networkId": 1224,
  "rpc": ["https://1224.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.buildonhybrid.com"],
  "shortName": "hyb",
  "slug": "hybrid-testnet",
  "testnet": true
};

var c1229 = {
  "chain": "EXZO",
  "chainId": 1229,
  "explorers": [{
    "name": "blockscout",
    "url": "https://exzoscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeYpc2JfEsHa2Bh11SKRx3sgDtMeg6T8KpXNLepBEKnbJ",
    "width": 128,
    "height": 128,
    "format": "png"
  },
  "infoURL": "https://exzo.network",
  "name": "Exzo Network Mainnet",
  "nativeCurrency": {
    "name": "Exzo",
    "symbol": "XZO",
    "decimals": 18
  },
  "networkId": 1229,
  "rpc": ["https://1229.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.exzo.technology"],
  "shortName": "xzo",
  "slug": "exzo-network",
  "testnet": false
};

var c1230 = {
  "chain": "Ultron",
  "chainId": 1230,
  "explorers": [{
    "name": "Ultron Testnet Explorer",
    "url": "https://explorer.ultron-dev.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmPC6odFVyAQrXJQaZJVFpEQfRNbzZ5BjDZ7KBKmXPaYDw",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPC6odFVyAQrXJQaZJVFpEQfRNbzZ5BjDZ7KBKmXPaYDw",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://ultron.foundation",
  "name": "Ultron Testnet",
  "nativeCurrency": {
    "name": "Ultron",
    "symbol": "ULX",
    "decimals": 18
  },
  "networkId": 1230,
  "rpc": ["https://1230.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://ultron-dev.io"],
  "shortName": "UltronTestnet",
  "slip44": 1,
  "slug": "ultron-testnet",
  "testnet": true
};

var c1231 = {
  "chain": "Ultron",
  "chainId": 1231,
  "explorers": [{
    "name": "Ultron Explorer",
    "url": "https://ulxscan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmPC6odFVyAQrXJQaZJVFpEQfRNbzZ5BjDZ7KBKmXPaYDw",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPC6odFVyAQrXJQaZJVFpEQfRNbzZ5BjDZ7KBKmXPaYDw",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://ultron.foundation",
  "name": "Ultron Mainnet",
  "nativeCurrency": {
    "name": "Ultron",
    "symbol": "ULX",
    "decimals": 18
  },
  "networkId": 1231,
  "rpc": ["https://1231.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://ultron-rpc.net"],
  "shortName": "UtronMainnet",
  "slug": "ultron",
  "testnet": false
};

var c1234 = {
  "chain": "STEP",
  "chainId": 1234,
  "explorers": [{
    "name": "StepScan",
    "url": "https://stepscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmVp9jyb3UFW71867yVtymmiRw7dPY4BTnsp3hEjr9tn8L",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVp9jyb3UFW71867yVtymmiRw7dPY4BTnsp3hEjr9tn8L",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://step.network",
  "name": "Step Network",
  "nativeCurrency": {
    "name": "FITFI",
    "symbol": "FITFI",
    "decimals": 18
  },
  "networkId": 1234,
  "parent": {
    "type": "L2",
    "chain": "eip155-43114",
    "bridges": [{
      "url": "https://bridge.step.network"
    }]
  },
  "rpc": ["https://1234.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.step.network"],
  "shortName": "step",
  "slug": "step-network",
  "testnet": false,
  "title": "Step Main Network"
};

var c1243 = {
  "chain": "ARC",
  "chainId": 1243,
  "explorers": [{
    "name": "archiescan",
    "url": "https://app.archiescan.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeiady63oqduls2pm4aaykzjhahblagokhnpsc5qeq5dmkxqelh7i2i",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://archiechain.io/",
  "name": "ARC Mainnet",
  "nativeCurrency": {
    "name": "ARC",
    "symbol": "ARC",
    "decimals": 18
  },
  "networkId": 1243,
  "rpc": ["https://1243.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-main-1.archiechain.io"],
  "shortName": "ARC",
  "slug": "arc",
  "testnet": false
};

var c1244 = {
  "chain": "ARC",
  "chainId": 1244,
  "explorers": [{
    "name": "archiescan",
    "url": "https://testnet.archiescan.io",
    "standard": "none"
  }],
  "faucets": ["https://faucet.archiechain.io"],
  "icon": {
    "url": "ipfs://bafybeiady63oqduls2pm4aaykzjhahblagokhnpsc5qeq5dmkxqelh7i2i",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://archiechain.io/",
  "name": "ARC Testnet",
  "nativeCurrency": {
    "name": "ARC",
    "symbol": "ARC",
    "decimals": 18
  },
  "networkId": 1244,
  "rpc": ["https://1244.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-test-1.archiechain.io"],
  "shortName": "TARC",
  "slip44": 1,
  "slug": "arc-testnet",
  "testnet": true
};

var c1246 = {
  "chain": "omplatform",
  "chainId": 1246,
  "explorers": [{
    "name": "OMSCAN - Expenter",
    "url": "https://omscan.omplatform.com",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://omplatform.com/",
  "name": "OM Platform Mainnet",
  "nativeCurrency": {
    "name": "OMCOIN",
    "symbol": "OM",
    "decimals": 18
  },
  "networkId": 1246,
  "rpc": ["https://1246.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-cnx.omplatform.com/"],
  "shortName": "om",
  "slug": "om-platform",
  "testnet": false
};

var c1248 = {
  "chain": "Dogether",
  "chainId": 1248,
  "explorers": [{
    "name": "DogetherExplorer",
    "url": "https://explorer.dogether.dog",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.dogether.dog/",
  "name": "Dogether Mainnet",
  "nativeCurrency": {
    "name": "Dogether",
    "symbol": "dogeth",
    "decimals": 18
  },
  "networkId": 1248,
  "rpc": ["https://1248.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.dogether.dog/"],
  "shortName": "Dogether",
  "slug": "dogether",
  "testnet": false
};

var c1252 = {
  "chain": "CICT",
  "chainId": 1252,
  "explorers": [{
    "name": "CICscan",
    "url": "https://testnet.cicscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmNekc5gpyrQkeDQcmfJLBrP5fa6GMarB13iy6aHVdQJDU",
      "width": 1024,
      "height": 768,
      "format": "png"
    }
  }],
  "faucets": ["https://cicfaucet.com"],
  "icon": {
    "url": "ipfs://QmNekc5gpyrQkeDQcmfJLBrP5fa6GMarB13iy6aHVdQJDU",
    "width": 1024,
    "height": 768,
    "format": "png"
  },
  "infoURL": "https://www.cicchain.net",
  "name": "CIC Chain Testnet",
  "nativeCurrency": {
    "name": "Crazy Internet Coin",
    "symbol": "CICT",
    "decimals": 18
  },
  "networkId": 1252,
  "rpc": ["https://1252.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testapi.cicscan.com"],
  "shortName": "CICT",
  "slip44": 1,
  "slug": "cic-chain-testnet",
  "testnet": true
};

var c1280 = {
  "chain": "HALO",
  "chainId": 1280,
  "explorers": [{
    "name": "HALOexplorer",
    "url": "https://browser.halo.land",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://halo.land/#/",
  "name": "HALO Mainnet",
  "nativeCurrency": {
    "name": "HALO",
    "symbol": "HO",
    "decimals": 18
  },
  "networkId": 1280,
  "rpc": ["https://1280.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://nodes.halo.land"],
  "shortName": "HO",
  "slug": "halo",
  "testnet": false
};

var c1284 = {
  "chain": "MOON",
  "chainId": 1284,
  "explorers": [{
    "name": "moonscan",
    "url": "https://moonbeam.moonscan.io",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://moonbeam.network/networks/moonbeam/",
  "name": "Moonbeam",
  "nativeCurrency": {
    "name": "Glimmer",
    "symbol": "GLMR",
    "decimals": 18
  },
  "networkId": 1284,
  "rpc": ["https://1284.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.api.moonbeam.network", "wss://wss.api.moonbeam.network", "https://moonbeam-rpc.publicnode.com", "wss://moonbeam-rpc.publicnode.com", "https://moonbeam.drpc.org", "wss://moonbeam.drpc.org"],
  "shortName": "mbeam",
  "slug": "moonbeam",
  "testnet": false
};

var c1285 = {
  "chain": "MOON",
  "chainId": 1285,
  "explorers": [{
    "name": "moonscan",
    "url": "https://moonriver.moonscan.io",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://moonbeam.network/networks/moonriver/",
  "name": "Moonriver",
  "nativeCurrency": {
    "name": "Moonriver",
    "symbol": "MOVR",
    "decimals": 18
  },
  "networkId": 1285,
  "rpc": ["https://1285.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.api.moonriver.moonbeam.network", "wss://wss.api.moonriver.moonbeam.network", "https://moonriver-rpc.publicnode.com", "wss://moonriver-rpc.publicnode.com", "https://moonriver.drpc.org", "wss://moonriver.drpc.org"],
  "shortName": "mriver",
  "slug": "moonriver",
  "testnet": false
};

var c1286 = {
  "chain": "MOON",
  "chainId": 1286,
  "explorers": [],
  "faucets": [],
  "name": "Moonrock old",
  "nativeCurrency": {
    "name": "Rocs",
    "symbol": "ROC",
    "decimals": 18
  },
  "networkId": 1286,
  "rpc": [],
  "shortName": "mrock-old",
  "slug": "moonrock-old",
  "status": "deprecated",
  "testnet": false
};

var c1287 = {
  "chain": "MOON",
  "chainId": 1287,
  "explorers": [{
    "name": "moonscan",
    "url": "https://moonbase.moonscan.io",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://docs.moonbeam.network/networks/testnet/",
  "name": "Moonbase Alpha",
  "nativeCurrency": {
    "name": "Dev",
    "symbol": "DEV",
    "decimals": 18
  },
  "networkId": 1287,
  "rpc": ["https://1287.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.api.moonbase.moonbeam.network", "wss://wss.api.moonbase.moonbeam.network", "https://moonbase-alpha.drpc.org", "wss://moonbase-alpha.drpc.org"],
  "shortName": "mbase",
  "slip44": 1,
  "slug": "moonbase-alpha",
  "testnet": true
};

var c1288 = {
  "chain": "MOON",
  "chainId": 1288,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://docs.moonbeam.network/learn/platform/networks/overview/",
  "name": "Moonrock",
  "nativeCurrency": {
    "name": "Rocs",
    "symbol": "ROC",
    "decimals": 18
  },
  "networkId": 1288,
  "rpc": ["https://1288.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.api.moonrock.moonbeam.network", "wss://wss.api.moonrock.moonbeam.network"],
  "shortName": "mrock",
  "slug": "moonrock",
  "testnet": false
};

var c1291 = {
  "chain": "SWTR",
  "chainId": 1291,
  "explorers": [{
    "name": "Swisstronik Scout",
    "url": "https://explorer-evm.testnet.swisstronik.com",
    "standard": "none"
  }],
  "faucets": ["https://faucet.testnet.swisstronik.com"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafybeihuintkoipxalwans23vhxajbwjnozpy34ww7ia7ds7nay3rpylzi",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://www.swisstronik.com",
  "name": "Swisstronik Testnet",
  "nativeCurrency": {
    "name": "Swisstronik",
    "symbol": "SWTR",
    "decimals": 18
  },
  "networkId": 1291,
  "rpc": ["https://1291.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://json-rpc.testnet.swisstronik.com"],
  "shortName": "swtr",
  "slip44": 1,
  "slug": "swisstronik-testnet",
  "testnet": true
};

var c1294 = {
  "chain": "Bobabeam",
  "chainId": 1294,
  "explorers": [{
    "name": "Bobabeam block explorer",
    "url": "https://blockexplorer.bobabeam.boba.network",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://boba.network",
  "name": "Bobabeam",
  "nativeCurrency": {
    "name": "Boba Token",
    "symbol": "BOBA",
    "decimals": 18
  },
  "networkId": 1294,
  "rpc": ["https://1294.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://bobabeam.boba.network", "wss://wss.bobabeam.boba.network", "https://replica.bobabeam.boba.network", "wss://replica-wss.bobabeam.boba.network"],
  "shortName": "Bobabeam",
  "slug": "bobabeam",
  "testnet": false
};

var c1297 = {
  "chain": "Bobabase Testnet",
  "chainId": 1297,
  "explorers": [{
    "name": "Bobabase block explorer",
    "url": "https://blockexplorer.bobabase.boba.network",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://boba.network",
  "name": "Bobabase Testnet",
  "nativeCurrency": {
    "name": "Boba Token",
    "symbol": "BOBA",
    "decimals": 18
  },
  "networkId": 1297,
  "rpc": ["https://1297.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://bobabase.boba.network", "wss://wss.bobabase.boba.network", "https://replica.bobabase.boba.network", "wss://replica-wss.bobabase.boba.network"],
  "shortName": "Bobabase",
  "slip44": 1,
  "slug": "bobabase-testnet",
  "testnet": true
};

var c1311 = {
  "chain": "DOS",
  "chainId": 1311,
  "explorers": [{
    "name": "dos-testnet",
    "url": "https://test.doscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "http://doschain.io/",
  "name": "Dos Fuji Subnet",
  "nativeCurrency": {
    "name": "Dos Native Token",
    "symbol": "DOS",
    "decimals": 18
  },
  "networkId": 1311,
  "rpc": ["https://1311.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://test.doschain.com/jsonrpc"],
  "shortName": "TDOS",
  "slug": "dos-fuji-subnet",
  "testnet": true
};

var c1314 = {
  "chain": "ALYX",
  "chainId": 1314,
  "explorers": [{
    "name": "alyxscan",
    "url": "https://www.alyxscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreifd43fcvh77mdcwjrpzpnlhthounc6b4u645kukqpqhduaveatf6i",
    "width": 2481,
    "height": 2481,
    "format": "png"
  },
  "infoURL": "https://www.alyxchain.com",
  "name": "Alyx Mainnet",
  "nativeCurrency": {
    "name": "Alyx Chain Native Token",
    "symbol": "ALYX",
    "decimals": 18
  },
  "networkId": 1314,
  "rpc": ["https://1314.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.alyxchain.com"],
  "shortName": "alyx",
  "slug": "alyx",
  "testnet": false
};

var c1319 = {
  "chain": "AIA",
  "chainId": 1319,
  "explorers": [{
    "name": "AIA Chain Explorer Mainnet",
    "url": "https://aiascan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmXbBMMhjTTGAGjmqMpJm3ufFrtdkfEXCFyXYgz7nnZzsy",
    "width": 160,
    "height": 160,
    "format": "png"
  },
  "infoURL": "https://aiachain.org/",
  "name": "AIA Mainnet",
  "nativeCurrency": {
    "name": "AIA Mainnet",
    "symbol": "AIA",
    "decimals": 18
  },
  "networkId": 1319,
  "rpc": ["https://1319.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://aia-dataseed1.aiachain.org", "https://aia-dataseed2.aiachain.org", "https://aia-dataseed3.aiachain.org", "https://aia-dataseed4.aiachain.org"],
  "shortName": "aia",
  "slug": "aia",
  "testnet": false
};

var c1320 = {
  "chain": "AIA",
  "chainId": 1320,
  "explorers": [{
    "name": "AIA Chain Explorer Testnet",
    "url": "https://testnet.aiascan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://aia-faucet-testnet.aiachain.org"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmXbBMMhjTTGAGjmqMpJm3ufFrtdkfEXCFyXYgz7nnZzsy",
    "width": 160,
    "height": 160,
    "format": "png"
  },
  "infoURL": "https://aiachain.org",
  "name": "AIA Testnet",
  "nativeCurrency": {
    "name": "AIA Testnet",
    "symbol": "AIA",
    "decimals": 18
  },
  "networkId": 1320,
  "rpc": ["https://1320.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://aia-dataseed1-testnet.aiachain.org"],
  "shortName": "aiatestnet",
  "slip44": 1,
  "slug": "aia-testnet",
  "testnet": true
};

var c1337 = {
  "chain": "ETH",
  "chainId": 1337,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/ethereum/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "name": "Localhost",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1337,
  "redFlags": [],
  "rpc": ["http://localhost:8545"],
  "shortName": "local",
  "slug": "localhost",
  "testnet": true
};

var c1338 = {
  "chain": "Elysium",
  "chainId": 1338,
  "explorers": [{
    "name": "Elysium testnet explorer",
    "url": "https://elysium-explorer.vulcanforged.com",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://elysiumscan.vulcanforged.com",
  "name": "Elysium Testnet",
  "nativeCurrency": {
    "name": "LAVA",
    "symbol": "LAVA",
    "decimals": 18
  },
  "networkId": 1338,
  "rpc": ["https://1338.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://elysium-test-rpc.vulcanforged.com"],
  "shortName": "ELST",
  "slip44": 1,
  "slug": "elysium-testnet",
  "testnet": true,
  "title": "An L1, carbon-neutral, tree-planting, metaverse dedicated blockchain created by VulcanForged"
};

var c1339 = {
  "chain": "Elysium",
  "chainId": 1339,
  "explorers": [{
    "name": "Elysium mainnet explorer",
    "url": "https://explorer.elysiumchain.tech",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://elysiumscan.vulcanforged.com",
  "name": "Elysium Mainnet",
  "nativeCurrency": {
    "name": "LAVA",
    "symbol": "LAVA",
    "decimals": 18
  },
  "networkId": 1339,
  "rpc": ["https://1339.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.elysiumchain.tech/"],
  "shortName": "ELSM",
  "slug": "elysium",
  "testnet": false,
  "title": "An L1, carbon-neutral, tree-planting, metaverse dedicated blockchain created by VulcanForged"
};

var c1343 = {
  "chain": "BLITZ",
  "chainId": 1343,
  "explorers": [{
    "name": "BLITZ Explorer",
    "url": "https://subnets-test.avax.network/blitz",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "infoURL": "https://blitz.gg",
  "name": "Blitz Subnet",
  "nativeCurrency": {
    "name": "BLITZ GAS",
    "symbol": "BGAS",
    "decimals": 18
  },
  "networkId": 1343,
  "rpc": ["https://1343.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/blitz/testnet/rpc"],
  "shortName": "blitz",
  "slug": "blitz-subnet",
  "testnet": true
};

var c1353 = {
  "chain": "CIC",
  "chainId": 1353,
  "explorers": [{
    "name": "CICscan",
    "url": "https://cicscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmNekc5gpyrQkeDQcmfJLBrP5fa6GMarB13iy6aHVdQJDU",
      "width": 1024,
      "height": 768,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNekc5gpyrQkeDQcmfJLBrP5fa6GMarB13iy6aHVdQJDU",
    "width": 1024,
    "height": 768,
    "format": "png"
  },
  "infoURL": "https://www.cicchain.net",
  "name": "CIC Chain Mainnet",
  "nativeCurrency": {
    "name": "Crazy Internet Coin",
    "symbol": "CIC",
    "decimals": 18
  },
  "networkId": 1353,
  "rpc": ["https://1353.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://xapi.cicscan.com"],
  "shortName": "CIC",
  "slug": "cic-chain",
  "testnet": false
};

var c1369 = {
  "chain": "ZAFIC",
  "chainId": 1369,
  "explorers": [{
    "name": "zafirium-explorer",
    "url": "https://explorer.zakumi.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZT1Wq3P4YbgKBSUmCtgbs5ijPF5d91BzaMPh7Aub8d8t",
    "width": 192,
    "height": 192,
    "format": "png"
  },
  "infoURL": "https://www.zakumi.io",
  "name": "Zafirium Mainnet",
  "nativeCurrency": {
    "name": "Zakumi Chain Native Token",
    "symbol": "ZAFIC",
    "decimals": 18
  },
  "networkId": 1369,
  "rpc": ["https://1369.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.zakumi.io"],
  "shortName": "zafic",
  "slug": "zafirium",
  "testnet": false
};

var c1379 = {
  "chain": "KLC",
  "chainId": 1379,
  "explorers": [{
    "name": "kalarscan",
    "url": "https://explorer.kalarchain.tech",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreidbzzv3lrwlzquhlpl4jcmr54sifhi5ufoek6olb5kjh3h3kvktdq",
      "width": 411,
      "height": 159,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreihfoy2kgf2rebaoicso7z5h7ju46z6gtr64mskkths3qbfkrtnkjm",
    "width": 190,
    "height": 170,
    "format": "png"
  },
  "infoURL": "https://kalarchain.tech",
  "name": "Kalar Chain",
  "nativeCurrency": {
    "name": "Kalar",
    "symbol": "KLC",
    "decimals": 18
  },
  "networkId": 1379,
  "rpc": ["https://1379.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-api.kalarchain.tech"],
  "shortName": "KLC",
  "slug": "kalar-chain",
  "testnet": false
};

var c1388 = {
  "chain": "AmStar",
  "chainId": 1388,
  "explorers": [{
    "name": "amstarscan",
    "url": "https://mainnet.amstarscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmd4TMQdnYxaUZqnVddh5S37NGH72g2kkK38ccCEgdZz1C",
    "width": 599,
    "height": 563,
    "format": "png"
  },
  "infoURL": "https://sinso.io",
  "name": "AmStar Mainnet",
  "nativeCurrency": {
    "name": "SINSO",
    "symbol": "SINSO",
    "decimals": 18
  },
  "networkId": 1388,
  "rpc": ["https://1388.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.amstarscan.com"],
  "shortName": "ASAR",
  "slug": "amstar",
  "testnet": false
};

var c1392 = {
  "chain": "Joseon",
  "chainId": 1392,
  "explorers": [{
    "name": "BlockExplorer",
    "url": "https://www.blockexplorer.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQjwcNRCLXU8JBtSkPLUnbWVrpoqbnZVffpJ9Bu8rG34e",
    "width": 148,
    "height": 148,
    "format": "svg"
  },
  "infoURL": "https://www.joseon.com/",
  "name": "Joseon Mainnet",
  "nativeCurrency": {
    "name": "Joseon Mun",
    "symbol": "JSM",
    "decimals": 18
  },
  "networkId": 1392,
  "rpc": ["https://1392.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.modchain.net/blockchain.joseon.com/rpc"],
  "shortName": "mun",
  "slug": "joseon",
  "testnet": false
};

var c1402 = {
  "chain": "Polygon",
  "chainId": 1402,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.public.zkevm-test.net",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://polygon.technology/solutions/polygon-zkevm/",
  "name": "Polygon zkEVM Testnet old",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1402,
  "rpc": [],
  "shortName": "zkevmtest",
  "slip44": 1,
  "slug": "polygon-zkevm-testnet-old",
  "status": "deprecated",
  "testnet": true,
  "title": "Polygon zkEVM Testnet"
};

var c1422 = {
  "chain": "Polygon",
  "chainId": 1422,
  "explorers": [{
    "name": "Polygon zkEVM explorer",
    "url": "https://explorer.public.zkevm-test.net",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://polygon.technology/solutions/polygon-zkevm/",
  "name": "Polygon zkEVM Testnet Pre Audit-Upgraded",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1422,
  "rpc": [],
  "shortName": "testnet-zkEVM-mango-pre-audit-upgraded",
  "slip44": 1,
  "slug": "polygon-zkevm-testnet-pre-audit-upgraded",
  "status": "deprecated",
  "testnet": true,
  "title": "Polygon zkEVM Testnet Pre Audit-Upgraded"
};

var c1433 = {
  "chain": "Rikeza",
  "chainId": 1433,
  "explorers": [{
    "name": "Rikeza Blockchain explorer",
    "url": "https://rikscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmfJ1Qxpzi6CSLeFeWY1Bwe435CpT5za5WfrLUE7vNzZfy",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://rikeza.io",
  "name": "Rikeza Network Mainnet",
  "nativeCurrency": {
    "name": "Rikeza",
    "symbol": "RIK",
    "decimals": 18
  },
  "networkId": 1433,
  "rpc": ["https://1433.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.rikscan.com"],
  "shortName": "RIK",
  "slug": "rikeza-network",
  "testnet": false,
  "title": "Rikeza Network Mainnet"
};

var c1440 = {
  "chain": "LAS",
  "chainId": 1440,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRidubY7BVwC737BQwGEttenP1npAXN7ZNryktE416uUW",
    "width": 500,
    "height": 500,
    "format": "jpg"
  },
  "infoURL": "https://dev.livingassets.io/",
  "name": "Living Assets Mainnet",
  "nativeCurrency": {
    "name": "LAS",
    "symbol": "LAS",
    "decimals": 18
  },
  "networkId": 1440,
  "rpc": ["https://1440.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://beta.mainnet.livingassets.io/rpc", "https://gamma.mainnet.livingassets.io/rpc"],
  "shortName": "LAS",
  "slug": "living-assets",
  "testnet": false
};

var c1442 = {
  "chain": "Polygon",
  "chainId": 1442,
  "explorers": [{
    "name": "Polygon zkEVM explorer",
    "url": "https://explorer.public.zkevm-test.net",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmNmJZkQgx9RcFLS3rvxQTVYcPfyAFPr667keHTUxB9PDv",
    "width": 122,
    "height": 135,
    "format": "png"
  },
  "infoURL": "https://polygon.technology/solutions/polygon-zkevm/",
  "name": "Polygon zkEVM Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1442,
  "redFlags": [],
  "rpc": ["https://1442.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.public.zkevm-test.net", "https://polygon-zkevm-testnet.drpc.org", "wss://polygon-zkevm-testnet.drpc.org"],
  "shortName": "testnet-zkEVM-mango",
  "slip44": 1,
  "slug": "polygon-zkevm-testnet",
  "testnet": true,
  "title": "Polygon zkEVM Testnet"
};

var c1452 = {
  "chain": "GIL",
  "chainId": 1452,
  "explorers": [{
    "name": "GIL Explorer",
    "url": "https://explorer.giltestnet.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeDXUAYgQxwaSJLsqWgTqnrJVwicgEyNf9199xAMyRkqA",
    "width": 243,
    "height": 243,
    "format": "svg"
  },
  "infoURL": "https://gaussgang.com/",
  "name": "GIL Testnet",
  "nativeCurrency": {
    "name": "GANG",
    "symbol": "GANG",
    "decimals": 18
  },
  "networkId": 1452,
  "rpc": ["https://1452.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.giltestnet.com"],
  "shortName": "gil",
  "slip44": 1,
  "slug": "gil-testnet",
  "testnet": true
};

var c1453 = {
  "chain": "MTC",
  "chainId": 1453,
  "explorers": [{
    "name": "MetaExplorer",
    "url": "https://istanbul-explorer.metachain.dev",
    "standard": "EIP3091"
  }],
  "faucets": ["https://istanbul-faucet.metachain.dev"],
  "icon": {
    "url": "ipfs://QmUH2Ph2hW4upvevEAGCaSo7nd8nthqMx5RrHcrnNZ9Y3g",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://metatime.com/en",
  "name": "MetaChain Istanbul",
  "nativeCurrency": {
    "name": "Metatime Coin",
    "symbol": "MTC",
    "decimals": 18
  },
  "networkId": 1453,
  "rpc": ["https://1453.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://istanbul-rpc.metachain.dev"],
  "shortName": "metatimeistanbul",
  "slip44": 1453,
  "slug": "metachain-istanbul",
  "testnet": true,
  "title": "MetaChain Testnet Istanbul"
};

var c1455 = {
  "chain": "Ctex Scan Blockchain",
  "chainId": 1455,
  "explorers": [{
    "name": "Ctex Scan Explorer",
    "url": "https://ctexscan.com",
    "standard": "none"
  }],
  "faucets": ["https://faucet.ctexscan.com"],
  "icon": {
    "url": "ipfs://bafkreid5evn4qovxo6msuekizv5zn7va62tea7w2zpdx5sskconebuhqle",
    "width": 800,
    "height": 800,
    "format": "png"
  },
  "infoURL": "https://ctextoken.io",
  "name": "Ctex Scan Blockchain",
  "nativeCurrency": {
    "name": "CTEX",
    "symbol": "CTEX",
    "decimals": 18
  },
  "networkId": 1455,
  "rpc": ["https://1455.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.ctexscan.com/"],
  "shortName": "CTEX",
  "slug": "ctex-scan-blockchain",
  "testnet": false
};

var c1490 = {
  "chain": "Vitruveo",
  "chainId": 1490,
  "explorers": [{
    "name": "Vitruveo Explorer",
    "url": "https://explorer.vitruveo.xyz",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreidjhjv7uu7if745ys7ari3ka75spm2hqyr5po66sbe7kqsfk7ahua",
      "width": 1000,
      "height": 1000,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://bafkreidjhjv7uu7if745ys7ari3ka75spm2hqyr5po66sbe7kqsfk7ahua",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://www.vitruveo.xyz",
  "name": "Vitruveo Mainnet",
  "nativeCurrency": {
    "name": "Vitruveo Coin",
    "symbol": "VTRU",
    "decimals": 18
  },
  "networkId": 1490,
  "rpc": ["https://1490.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.vitruveo.xyz"],
  "shortName": "vitruveo",
  "slug": "vitruveo",
  "testnet": false,
  "title": "Vitruveo is a blockchain for Creators"
};

var c1501 = {
  "chain": "ChainX",
  "chainId": 1501,
  "explorers": [{
    "name": "bevm canary scan",
    "url": "https://scan-canary.bevm.io",
    "standard": "none"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://cloudflare-ipfs.com/ipfs/bafkreibvwfrow3w6q5qj2mk6n7yx5oahxzgn3pnghdr76zsyxvc3l5hh7y",
    "width": 3600,
    "height": 3600,
    "format": "png"
  },
  "infoURL": "https://chainx.org",
  "name": "BEVM Canary",
  "nativeCurrency": {
    "name": "BTC",
    "symbol": "BTC",
    "decimals": 18
  },
  "networkId": 1501,
  "redFlags": [],
  "rpc": ["https://1501.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-canary-1.bevm.io/", "https://rpc-canary-2.bevm.io/"],
  "shortName": "chainx",
  "slug": "bevm-canary",
  "testnet": false
};

var c1506 = {
  "chain": "Sherpax Mainnet",
  "chainId": 1506,
  "explorers": [{
    "name": "Sherpax Mainnet Explorer",
    "url": "https://evm.sherpax.io",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://sherpax.io/",
  "name": "Sherpax Mainnet",
  "nativeCurrency": {
    "name": "KSX",
    "symbol": "KSX",
    "decimals": 18
  },
  "networkId": 1506,
  "rpc": ["https://1506.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.sherpax.io/rpc"],
  "shortName": "Sherpax",
  "slug": "sherpax",
  "testnet": false
};

var c1507 = {
  "chain": "Sherpax Testnet",
  "chainId": 1507,
  "explorers": [{
    "name": "Sherpax Testnet Explorer",
    "url": "https://evm-pre.sherpax.io",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://sherpax.io/",
  "name": "Sherpax Testnet",
  "nativeCurrency": {
    "name": "KSX",
    "symbol": "KSX",
    "decimals": 18
  },
  "networkId": 1507,
  "rpc": ["https://1507.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sherpax-testnet.chainx.org/rpc"],
  "shortName": "SherpaxTestnet",
  "slip44": 1,
  "slug": "sherpax-testnet",
  "testnet": true
};

var c1515 = {
  "chain": "BMC",
  "chainId": 1515,
  "explorers": [{
    "name": "Beagle Messaging Chain Explorer",
    "url": "https://eth.beagle.chat",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.beagle.chat/"],
  "infoURL": "https://beagle.chat/",
  "name": "Beagle Messaging Chain",
  "nativeCurrency": {
    "name": "Beagle",
    "symbol": "BG",
    "decimals": 18
  },
  "networkId": 1515,
  "rpc": ["https://1515.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://beagle.chat/eth"],
  "shortName": "beagle",
  "slug": "beagle-messaging-chain",
  "testnet": false
};

var c1559 = {
  "chain": "TENET",
  "chainId": 1559,
  "explorers": [{
    "name": "TenetScan Mainnet",
    "url": "https://tenetscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://Qmc1gqjWTzNo4pyFSGtQuCu7kRSZZBUVybtTjHn2nNEEPA",
      "width": 640,
      "height": 640,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmc1gqjWTzNo4pyFSGtQuCu7kRSZZBUVybtTjHn2nNEEPA",
    "width": 640,
    "height": 640,
    "format": "svg"
  },
  "infoURL": "https://tenet.org/",
  "name": "Tenet",
  "nativeCurrency": {
    "name": "TENET",
    "symbol": "TENET",
    "decimals": 18
  },
  "networkId": 1559,
  "rpc": ["https://1559.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.tenet.org", "https://tenet-evm.publicnode.com", "wss://tenet-evm.publicnode.com"],
  "shortName": "tenet",
  "slug": "tenet",
  "testnet": false,
  "title": "Tenet Mainnet"
};

var c1582 = {
  "chain": "gETH",
  "chainId": 1582,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://bafybeibfpls2ealp4e5fdeoxessfjjkldgjnrcx2erph7524pg7alskk6a/1f9cb.svg",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://bubstestnet.com",
  "name": "Bubs Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "gETH",
    "decimals": 18
  },
  "networkId": 1582,
  "redFlags": [],
  "rpc": [],
  "shortName": "Bubs",
  "slug": "bubs-testnet",
  "status": "deprecated",
  "testnet": true
};

var c1614 = {
  "chain": "Avalanche",
  "chainId": 1614,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0305I1 Testnet",
  "nativeCurrency": {
    "name": "QI0305I1 Testnet Token",
    "symbol": "PDC",
    "decimals": 18
  },
  "networkId": 1614,
  "redFlags": [],
  "rpc": ["https://1614.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0305I1 Testnet",
  "slug": "qi0305i1-testnet",
  "testnet": true
};

var c1617 = {
  "chain": "ETINS",
  "chainId": 1617,
  "explorers": [{
    "name": "Ethereum Inscription Explorer",
    "url": "https://explorer.etins.org",
    "standard": "none"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://www.etins.org",
  "name": "Ethereum Inscription Mainnet",
  "nativeCurrency": {
    "name": "Ethereum Inscription",
    "symbol": "ETINS",
    "decimals": 18
  },
  "networkId": 1617,
  "rpc": ["https://1617.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.etins.org"],
  "shortName": "etins",
  "slug": "ethereum-inscription",
  "testnet": false
};

var c1618 = {
  "chain": "Catechain",
  "chainId": 1618,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://catechain.com",
  "name": "Catecoin Chain Mainnet",
  "nativeCurrency": {
    "name": "Catecoin",
    "symbol": "CATE",
    "decimals": 18
  },
  "networkId": 1618,
  "rpc": ["https://1618.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://send.catechain.com"],
  "shortName": "cate",
  "slug": "catecoin-chain",
  "testnet": false
};

var c1620 = {
  "chain": "ATH",
  "chainId": 1620,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://atheios.org",
  "name": "Atheios",
  "nativeCurrency": {
    "name": "Atheios Ether",
    "symbol": "ATH",
    "decimals": 18
  },
  "networkId": 11235813,
  "rpc": ["https://1620.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.atheios.org/"],
  "shortName": "ath",
  "slip44": 1620,
  "slug": "atheios",
  "testnet": false
};

var c1657 = {
  "chain": "btachain",
  "chainId": 1657,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://bitcoinasset.io/",
  "name": "Btachain",
  "nativeCurrency": {
    "name": "Bitcoin Asset",
    "symbol": "BTA",
    "decimals": 18
  },
  "networkId": 1657,
  "rpc": ["https://1657.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dataseed1.btachain.com/"],
  "shortName": "bta",
  "slug": "btachain",
  "testnet": false
};

var c1662 = {
  "chain": "LQC",
  "chainId": 1662,
  "explorers": [{
    "name": "Liquichain Mainnet",
    "url": "https://mainnet.liquichain.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://liquichain.io/",
  "name": "Liquichain",
  "nativeCurrency": {
    "name": "Licoin",
    "symbol": "LCN",
    "decimals": 18
  },
  "networkId": 1662,
  "redFlags": ["reusedChainId"],
  "rpc": [],
  "shortName": "Liquichain",
  "slug": "liquichain",
  "testnet": false
};

var c1663 = {
  "chain": "Gobi",
  "chainId": 1663,
  "explorers": [{
    "name": "Gobi Testnet Block Explorer",
    "url": "https://gobi-explorer.horizen.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmSFMBk3rMyu45Sy9KQHjgArFj4HdywANNYrSosLMUdcti",
      "width": 1213,
      "height": 1213,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.horizen.io"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmSFMBk3rMyu45Sy9KQHjgArFj4HdywANNYrSosLMUdcti",
    "width": 1213,
    "height": 1213,
    "format": "png"
  },
  "infoURL": "https://horizen.io/",
  "name": "Horizen Gobi Testnet",
  "nativeCurrency": {
    "name": "Testnet Zen",
    "symbol": "tZEN",
    "decimals": 18
  },
  "networkId": 1663,
  "rpc": ["https://1663.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://gobi-rpc.horizenlabs.io/ethv1", "https://rpc.ankr.com/horizen_gobi_testnet"],
  "shortName": "Gobi",
  "slip44": 1,
  "slug": "horizen-gobi-testnet",
  "testnet": true
};

var c1686 = {
  "chain": "ETH",
  "chainId": 1686,
  "explorers": [{
    "name": "blockscout",
    "url": "https://testnet-explorer.mintchain.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmQsYisbKkCTKoKG2YSVs94UGuWWMiBspirH4Af4FyZeZz",
      "width": 80,
      "height": 80,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQsYisbKkCTKoKG2YSVs94UGuWWMiBspirH4Af4FyZeZz",
    "width": 80,
    "height": 80,
    "format": "png"
  },
  "infoURL": "https://www.mintchain.io",
  "name": "Mint Testnet",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1686,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://testnet-bridge.mintchain.io"
    }]
  },
  "rpc": ["https://1686.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.mintchain.io"],
  "shortName": "minttest",
  "slug": "mint-testnet",
  "testnet": true
};

var c1687 = {
  "chain": "ETH",
  "chainId": 1687,
  "explorers": [{
    "name": "blockscout",
    "url": "https://sepolia-testnet-explorer.mintchain.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmQsYisbKkCTKoKG2YSVs94UGuWWMiBspirH4Af4FyZeZz",
      "width": 80,
      "height": 80,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQsYisbKkCTKoKG2YSVs94UGuWWMiBspirH4Af4FyZeZz",
    "width": 80,
    "height": 80,
    "format": "png"
  },
  "infoURL": "https://www.mintchain.io",
  "name": "Mint Sepolia Testnet",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1687,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://sepolia-testnet-bridge.mintchain.io"
    }]
  },
  "rpc": ["https://1687.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sepolia-testnet-rpc.mintchain.io"],
  "shortName": "mintsepoliatest",
  "slug": "mint-sepolia-testnet",
  "testnet": true
};

var c1688 = {
  "chain": "LUDAN",
  "chainId": 1688,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreigzeanzqgxrzzep45t776ovbwi242poqxbryuu2go5eedeuwwcsay",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://www.ludan.org/",
  "name": "LUDAN Mainnet",
  "nativeCurrency": {
    "name": "LUDAN",
    "symbol": "LUDAN",
    "decimals": 18
  },
  "networkId": 1688,
  "rpc": ["https://1688.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.ludan.org/"],
  "shortName": "LUDAN",
  "slug": "ludan",
  "testnet": false
};

var c1701 = {
  "chain": "ETH",
  "chainId": 1701,
  "explorers": [{
    "name": "Anytype Explorer",
    "url": "https://explorer.anytype.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmaARJiAQUn4Z6wG8GLEry3kTeBB3k6RfHzSZU9SPhBgcG",
      "width": 200,
      "height": 200,
      "format": "png"
    }
  }],
  "faucets": ["https://evm.anytype.io/faucet"],
  "icon": {
    "url": "ipfs://QmaARJiAQUn4Z6wG8GLEry3kTeBB3k6RfHzSZU9SPhBgcG",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://evm.anytype.io",
  "name": "Anytype EVM Chain",
  "nativeCurrency": {
    "name": "ANY",
    "symbol": "ANY",
    "decimals": 18
  },
  "networkId": 1701,
  "rpc": ["https://1701.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://geth.anytype.io"],
  "shortName": "AnytypeChain",
  "slug": "anytype-evm-chain",
  "testnet": false
};

var c1707 = {
  "chain": "TBSI",
  "chainId": 1707,
  "explorers": [{
    "name": "blockscout",
    "url": "https://exp.blockchain.or.th",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://blockchain.or.th",
  "name": "TBSI Mainnet",
  "nativeCurrency": {
    "name": "Jinda",
    "symbol": "JINDA",
    "decimals": 18
  },
  "networkId": 1707,
  "rpc": ["https://1707.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.blockchain.or.th"],
  "shortName": "TBSI",
  "slug": "tbsi",
  "testnet": false,
  "title": "Thai Blockchain Service Infrastructure Mainnet"
};

var c1708 = {
  "chain": "TBSI",
  "chainId": 1708,
  "explorers": [{
    "name": "blockscout",
    "url": "https://exp.testnet.blockchain.or.th",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.blockchain.or.th"],
  "infoURL": "https://blockchain.or.th",
  "name": "TBSI Testnet",
  "nativeCurrency": {
    "name": "Jinda",
    "symbol": "JINDA",
    "decimals": 18
  },
  "networkId": 1708,
  "rpc": ["https://1708.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.blockchain.or.th"],
  "shortName": "tTBSI",
  "slip44": 1,
  "slug": "tbsi-testnet",
  "testnet": true,
  "title": "Thai Blockchain Service Infrastructure Testnet"
};

var c1717 = {
  "chain": "DRC",
  "chainId": 1717,
  "explorers": [{
    "name": "Doric Explorer",
    "url": "https://explorer.doric.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdFEozqneC8abhpfgtGpvfKpWVEbL8eMZjJKtUPuBTanK",
    "width": 988,
    "height": 901,
    "format": "png"
  },
  "infoURL": "https://doric.network",
  "name": "Doric Network",
  "nativeCurrency": {
    "name": "Doric Native Token",
    "symbol": "DRC",
    "decimals": 18
  },
  "networkId": 1717,
  "rpc": ["https://1717.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.doric.network"],
  "shortName": "DRC",
  "slug": "doric-network",
  "testnet": false
};

var c1718 = {
  "chain": "PLT",
  "chainId": 1718,
  "explorers": [{
    "name": "Palettescan",
    "url": "https://palettescan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmPCEGZD1p1keTT2YfPp725azx1r9Ci41hejeUuGL2whFA",
      "width": 800,
      "height": 800,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmPCEGZD1p1keTT2YfPp725azx1r9Ci41hejeUuGL2whFA",
    "width": 800,
    "height": 800,
    "format": "png"
  },
  "infoURL": "https://hashpalette.com/",
  "name": "Palette Chain Mainnet",
  "nativeCurrency": {
    "name": "Palette Token",
    "symbol": "PLT",
    "decimals": 18
  },
  "networkId": 1718,
  "rpc": ["https://1718.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://palette-rpc.com:22000"],
  "shortName": "PCM",
  "slug": "palette-chain",
  "testnet": false
};

var c1729 = {
  "chain": "Reya",
  "chainId": 1729,
  "explorers": [{
    "name": "Reya Network Explorer",
    "url": "https://explorer.reya.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://reya.network",
  "name": "Reya Network",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1729,
  "rpc": ["https://1729.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.reya.network", "wss://ws.reya.network"],
  "shortName": "reya",
  "slug": "reya-network",
  "testnet": false
};

var c1773 = {
  "chain": "mainnet",
  "chainId": 1773,
  "explorers": [{
    "name": "PartyExplorer",
    "url": "https://partyexplorer.co",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmerDBFoXvgev2xx9U71gAaAK4CtxaaQVaAPf9Qi6UF9MS",
      "width": 400,
      "height": 400,
      "format": "jpg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmerDBFoXvgev2xx9U71gAaAK4CtxaaQVaAPf9Qi6UF9MS",
    "width": 400,
    "height": 400,
    "format": "jpg"
  },
  "name": "PartyChain",
  "nativeCurrency": {
    "name": "Grams",
    "symbol": "GRAMS",
    "decimals": 18
  },
  "networkId": 1773,
  "rpc": ["https://1773.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://tea.mining4people.com/rpc", "http://172.104.194.36:8545"],
  "shortName": "TeaParty",
  "slug": "partychain",
  "status": "incubating",
  "testnet": false
};

var c1777 = {
  "chain": "Gauss",
  "chainId": 1777,
  "explorers": [{
    "name": "Gauss Explorer",
    "url": "https://explorer.gaussgang.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeDXUAYgQxwaSJLsqWgTqnrJVwicgEyNf9199xAMyRkqA",
    "width": 243,
    "height": 243,
    "format": "svg"
  },
  "infoURL": "https://gaussgang.com/",
  "name": "Gauss Mainnet",
  "nativeCurrency": {
    "name": "GANG",
    "symbol": "GANG",
    "decimals": 18
  },
  "networkId": 1777,
  "rpc": ["https://1777.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.gaussgang.com"],
  "shortName": "gauss",
  "slug": "gauss",
  "testnet": false
};

var c1804 = {
  "chain": "CRC",
  "chainId": 1804,
  "explorers": [{
    "name": "Lite Explorer",
    "url": "https://ethereum-pocr.github.io/explorer/kerleano",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRLwpq47tyEd3rfK4tKRhbTvyb3fc7PCutExnL1XAb37A",
      "width": 334,
      "height": 360,
      "format": "png"
    }
  }],
  "faucets": ["https://github.com/ethereum-pocr/kerleano/blob/main/docs/faucet.md"],
  "icon": {
    "url": "ipfs://QmRLwpq47tyEd3rfK4tKRhbTvyb3fc7PCutExnL1XAb37A",
    "width": 334,
    "height": 360,
    "format": "png"
  },
  "infoURL": "https://github.com/ethereum-pocr/kerleano",
  "name": "Kerleano",
  "nativeCurrency": {
    "name": "Climate awaReness Coin",
    "symbol": "CRC",
    "decimals": 18
  },
  "networkId": 1804,
  "rpc": ["https://1804.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://cacib-saturn-test.francecentral.cloudapp.azure.com", "wss://cacib-saturn-test.francecentral.cloudapp.azure.com:9443"],
  "shortName": "kerleano",
  "slip44": 1,
  "slug": "kerleano",
  "status": "active",
  "testnet": true,
  "title": "Proof of Climate awaReness testnet"
};

var c1807 = {
  "chain": "rAna",
  "chainId": 1807,
  "explorers": [{
    "name": "blockscout",
    "url": "https://rabbit.analogscan.com",
    "standard": "none"
  }],
  "faucets": ["https://analogfaucet.com"],
  "icon": {
    "url": "ipfs://QmdfbjjF3ZzN2jTkH9REgrA8jDS6A6c21n7rbWSVbSnvQc",
    "width": 310,
    "height": 251,
    "format": "svg"
  },
  "infoURL": "https://rabbit.analogscan.com",
  "name": "Rabbit Analog Testnet Chain",
  "nativeCurrency": {
    "name": "Rabbit Analog Test Chain Native Token ",
    "symbol": "rAna",
    "decimals": 18
  },
  "networkId": 1807,
  "rpc": ["https://1807.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rabbit.analog-rpc.com"],
  "shortName": "rAna",
  "slip44": 1,
  "slug": "rabbit-analog-testnet-chain",
  "testnet": true
};

var c1818 = {
  "chain": "Cube",
  "chainId": 1818,
  "explorers": [{
    "name": "cube-scan",
    "url": "https://cubescan.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmbENgHTymTUUArX5MZ2XXH69WGenirU3oamkRD448hYdz",
    "width": 282,
    "height": 250,
    "format": "png"
  },
  "infoURL": "https://www.cube.network",
  "name": "Cube Chain Mainnet",
  "nativeCurrency": {
    "name": "Cube Chain Native Token",
    "symbol": "CUBE",
    "decimals": 18
  },
  "networkId": 1818,
  "rpc": ["https://1818.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://http-mainnet.cube.network", "wss://ws-mainnet.cube.network", "https://http-mainnet-sg.cube.network", "wss://ws-mainnet-sg.cube.network", "https://http-mainnet-us.cube.network", "wss://ws-mainnet-us.cube.network"],
  "shortName": "cube",
  "slip44": 1818,
  "slug": "cube-chain",
  "testnet": false
};

var c1819 = {
  "chain": "Cube",
  "chainId": 1819,
  "explorers": [{
    "name": "cubetest-scan",
    "url": "https://testnet.cubescan.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.cube.network"],
  "icon": {
    "url": "ipfs://QmbENgHTymTUUArX5MZ2XXH69WGenirU3oamkRD448hYdz",
    "width": 282,
    "height": 250,
    "format": "png"
  },
  "infoURL": "https://www.cube.network",
  "name": "Cube Chain Testnet",
  "nativeCurrency": {
    "name": "Cube Chain Test Native Token",
    "symbol": "CUBET",
    "decimals": 18
  },
  "networkId": 1819,
  "rpc": ["https://1819.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://http-testnet.cube.network", "wss://ws-testnet.cube.network", "https://http-testnet-sg.cube.network", "wss://ws-testnet-sg.cube.network", "https://http-testnet-jp.cube.network", "wss://ws-testnet-jp.cube.network", "https://http-testnet-us.cube.network", "wss://ws-testnet-us.cube.network"],
  "shortName": "cubet",
  "slip44": 1,
  "slug": "cube-chain-testnet",
  "testnet": true
};

var c1821 = {
  "chain": "RUBY",
  "chainId": 1821,
  "explorers": [{
    "name": "RUBY Smart Chain MAINNET Explorer",
    "url": "https://rubyscan.net",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmXGJevyPHHKT28hDfsJ9Cq2DQ2bAavdie37MEwFQUVCQz",
      "width": 500,
      "height": 500,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmXGJevyPHHKT28hDfsJ9Cq2DQ2bAavdie37MEwFQUVCQz",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://rubychain.io",
  "name": "Ruby Smart Chain MAINNET",
  "nativeCurrency": {
    "name": "RUBY Smart Chain Native Token",
    "symbol": "RUBY",
    "decimals": 18
  },
  "networkId": 1821,
  "rpc": ["https://1821.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-data.rubychain.io/", "https://mainnet.rubychain.io/"],
  "shortName": "RUBY",
  "slip44": 1,
  "slug": "ruby-smart-chain",
  "testnet": false
};

var c1838 = {
  "chain": "Avalanche",
  "chainId": 1838,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Traderlands Testnet",
  "nativeCurrency": {
    "name": "Traderlands Testnet Token",
    "symbol": "TDL3",
    "decimals": 18
  },
  "networkId": 1838,
  "redFlags": [],
  "rpc": ["https://1838.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/traderland/testnet/rpc"],
  "shortName": "Traderlands Testnet",
  "slug": "traderlands-testnet",
  "testnet": true
};

var c1856 = {
  "chain": "TSF",
  "chainId": 1856,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://teslafunds.io",
  "name": "Teslafunds",
  "nativeCurrency": {
    "name": "Teslafunds Ether",
    "symbol": "TSF",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://1856.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://tsfapi.europool.me"],
  "shortName": "tsf",
  "slug": "teslafunds",
  "testnet": false
};

var c1875 = {
  "chain": "WBT",
  "chainId": 1875,
  "explorers": [{
    "name": "whitechain-explorer",
    "url": "https://explorer.whitechain.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNeELax6vjkR9WZVmtggk8cam9xHVABZ4WvQyqkGCJ5qf",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://whitechain.io",
  "name": "Whitechain",
  "nativeCurrency": {
    "name": "WhiteBIT Coin",
    "symbol": "WBT",
    "decimals": 18
  },
  "networkId": 1875,
  "rpc": ["https://1875.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.whitechain.io"],
  "shortName": "wbt",
  "slug": "whitechain",
  "testnet": false
};

var c1881 = {
  "chain": "Gitshock Cartenz",
  "chainId": 1881,
  "explorers": [{
    "name": "blockscout",
    "url": "https://scan.cartenz.works",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreifqpj5jkjazvh24muc7wv4r22tihzzl75cevgecxhvojm4ls6mzpq",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://gitshock.com",
  "name": "Gitshock Cartenz Testnet",
  "nativeCurrency": {
    "name": "Gitshock Cartenz",
    "symbol": "tGTFX",
    "decimals": 18
  },
  "networkId": 1881,
  "rpc": ["https://1881.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.cartenz.works"],
  "shortName": "gitshockchain",
  "slip44": 1,
  "slug": "gitshock-cartenz-testnet",
  "testnet": true
};

var c1890 = {
  "chain": "Lightlink Phoenix Mainnet",
  "chainId": 1890,
  "explorers": [{
    "name": "phoenix",
    "url": "https://phoenix.lightlink.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmXMDj6iAFn2ducQcUU1M87PMMdT2jfyL3Tp3Lz5uUD5Lv",
      "width": 200,
      "height": 200,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://QmXMDj6iAFn2ducQcUU1M87PMMdT2jfyL3Tp3Lz5uUD5Lv",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://lightlink.io",
  "name": "Lightlink Phoenix Mainnet",
  "nativeCurrency": {
    "name": "Ethereum",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1890,
  "rpc": ["https://1890.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://replicator.phoenix.lightlink.io/rpc/v1"],
  "shortName": "lightlink_phoenix",
  "slug": "lightlink-phoenix",
  "testnet": false
};

var c1891 = {
  "chain": "Lightlink Pegasus Testnet",
  "chainId": 1891,
  "explorers": [{
    "name": "pegasus",
    "url": "https://pegasus.lightlink.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmXMDj6iAFn2ducQcUU1M87PMMdT2jfyL3Tp3Lz5uUD5Lv",
      "width": 200,
      "height": 200,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.pegasus.lightlink.io/"],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://QmXMDj6iAFn2ducQcUU1M87PMMdT2jfyL3Tp3Lz5uUD5Lv",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://lightlink.io",
  "name": "Lightlink Pegasus Testnet",
  "nativeCurrency": {
    "name": "Ethereum",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1891,
  "rpc": ["https://1891.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://replicator.pegasus.lightlink.io/rpc/v1"],
  "shortName": "lightlink_pegasus",
  "slip44": 1,
  "slug": "lightlink-pegasus-testnet",
  "testnet": true
};

var c1898 = {
  "chain": "BON",
  "chainId": 1898,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer.boyanet.org:4001",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://boyanet.org",
  "name": "BON Network",
  "nativeCurrency": {
    "name": "BOYACoin",
    "symbol": "BOY",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://1898.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://rpc.boyanet.org:8545", "ws://rpc.boyanet.org:8546"],
  "shortName": "boya",
  "slug": "bon-network",
  "testnet": false
};

var c1904 = {
  "chain": "SCN",
  "chainId": 1904,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.sportschainnetwork.xyz",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdW7XfRgeyoaHXEvXp8MaVteonankR32CxhL3K5Yc2uQM",
    "width": 345,
    "height": 321,
    "format": "png"
  },
  "infoURL": "https://sportschainnetwork.xyz",
  "name": "Sports Chain Network",
  "nativeCurrency": {
    "name": "SCN",
    "symbol": "SCN",
    "decimals": 18
  },
  "networkId": 1904,
  "rpc": ["https://1904.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.sportschainnetwork.xyz/"],
  "shortName": "SCN",
  "slug": "sports-chain-network",
  "testnet": false
};

var c1907 = {
  "chain": "BITCI",
  "chainId": 1907,
  "explorers": [{
    "name": "Bitci Explorer",
    "url": "https://bitciexplorer.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmbxmfWw5sVMASz5EbR1DCgLfk8PnqpSJGQKpYuEUpoxqn",
    "width": 64,
    "height": 64,
    "format": "svg"
  },
  "infoURL": "https://www.bitcichain.com",
  "name": "Bitcichain Mainnet",
  "nativeCurrency": {
    "name": "Bitci",
    "symbol": "BITCI",
    "decimals": 18
  },
  "networkId": 1907,
  "rpc": ["https://1907.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.bitci.com"],
  "shortName": "bitci",
  "slug": "bitcichain",
  "testnet": false
};

var c1908 = {
  "chain": "TBITCI",
  "chainId": 1908,
  "explorers": [{
    "name": "Bitci Explorer Testnet",
    "url": "https://testnet.bitciexplorer.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.bitcichain.com"],
  "icon": {
    "url": "ipfs://QmbxmfWw5sVMASz5EbR1DCgLfk8PnqpSJGQKpYuEUpoxqn",
    "width": 64,
    "height": 64,
    "format": "svg"
  },
  "infoURL": "https://www.bitcichain.com",
  "name": "Bitcichain Testnet",
  "nativeCurrency": {
    "name": "Test Bitci",
    "symbol": "TBITCI",
    "decimals": 18
  },
  "networkId": 1908,
  "rpc": ["https://1908.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.bitcichain.com"],
  "shortName": "tbitci",
  "slip44": 1,
  "slug": "bitcichain-testnet",
  "testnet": true
};

var c1909 = {
  "chain": "MRK",
  "chainId": 1909,
  "explorers": [{
    "name": "blockscout",
    "url": "https://merklescan.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZocJpCSLoQqoYFkF1kn7uKDuAiFRNTK8P5PoVeiigDBU",
    "width": 114,
    "height": 132,
    "format": "png"
  },
  "infoURL": "https://merklescan.com",
  "name": "Merkle Scan",
  "nativeCurrency": {
    "name": "Merkle",
    "symbol": "MRK",
    "decimals": 18
  },
  "networkId": 1909,
  "rpc": ["https://1909.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://marklechain-rpc.merklescan.com"],
  "shortName": "MRK",
  "slug": "merkle-scan",
  "testnet": false
};

var c1911 = {
  "chain": "ETH",
  "chainId": 1911,
  "explorers": [{
    "name": "scalind",
    "url": "https://explorer.scalind.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmayuauUTSkYxbT1xi2AkkG5VLEMDhcMeZ18WZHiApPa9M",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://scalind.com",
  "name": "Scalind",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1911,
  "rpc": ["https://1911.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.scalind.com"],
  "shortName": "scal",
  "slug": "scalind",
  "testnet": false
};

var c1912 = {
  "chain": "RUBY",
  "chainId": 1912,
  "explorers": [{
    "name": "RUBY Smart Chain Testnet Explorer",
    "url": "https://testnet.rubyscan.net",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmXGJevyPHHKT28hDfsJ9Cq2DQ2bAavdie37MEwFQUVCQz",
      "width": 500,
      "height": 500,
      "format": "png"
    }
  }],
  "faucets": ["https://claim-faucet.rubychain.io/"],
  "icon": {
    "url": "ipfs://QmXGJevyPHHKT28hDfsJ9Cq2DQ2bAavdie37MEwFQUVCQz",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://rubychain.io",
  "name": "Ruby Smart Chain Testnet",
  "nativeCurrency": {
    "name": "RUBY Smart Chain Native Token",
    "symbol": "tRUBY",
    "decimals": 18
  },
  "networkId": 1912,
  "rpc": ["https://1912.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rchain.rubychain.io/"],
  "shortName": "tRUBY",
  "slip44": 1,
  "slug": "ruby-smart-chain-testnet",
  "testnet": true
};

var c1945 = {
  "chain": "onus",
  "chainId": 1945,
  "explorers": [{
    "name": "Onus explorer testnet",
    "url": "https://explorer-testnet.onuschain.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreiec34ik3glrm5jrzafdytvu4kxdsrxhqmagbe27fytdcuzkhoooay",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "infoURL": "https://onuschain.io",
  "name": "ONUS Chain Testnet",
  "nativeCurrency": {
    "name": "ONUS",
    "symbol": "ONUS",
    "decimals": 18
  },
  "networkId": 1945,
  "rpc": ["https://1945.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.onuschain.io"],
  "shortName": "onus-testnet",
  "slip44": 1,
  "slug": "onus-chain-testnet",
  "testnet": true,
  "title": "ONUS Chain Testnet"
};

var c1951 = {
  "chain": "D-Chain",
  "chainId": 1951,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmV2vhTqS9UyrX9Q6BSCbK4JrKBnS8ErHvstMjfb2oVWaj",
    "width": 700,
    "height": 495,
    "format": "png"
  },
  "name": "D-Chain Mainnet",
  "nativeCurrency": {
    "name": "DOINX",
    "symbol": "DOINX",
    "decimals": 18
  },
  "networkId": 1951,
  "rpc": ["https://1951.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.d-chain.network/ext/bc/2ZiR1Bro5E59siVuwdNuRFzqL95NkvkbzyLBdrsYR9BLSHV7H4/rpc"],
  "shortName": "dchain-mainnet",
  "slug": "d-chain",
  "testnet": false
};

var c1953 = {
  "chain": "tSEL",
  "chainId": 1953,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmbnLDuVc4JReFysyKvmpuqUtj9HCus6qoKD5nQ9QkokzK",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://selendra.org",
  "name": "Selendra Network Testnet",
  "nativeCurrency": {
    "name": "Selendra",
    "symbol": "tSEL",
    "decimals": 18
  },
  "networkId": 1953,
  "rpc": ["https://1953.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc0-testnet.selendra.org", "https://rpc1-testnet.selendra.org"],
  "shortName": "tSEL",
  "slug": "selendra-network-testnet",
  "testnet": true
};

var c1954 = {
  "chain": "Dexilla",
  "chainId": 1954,
  "explorers": [{
    "name": "dos-mainnet",
    "url": "https://exp.dexilla.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmUBveetVibvSEWQrjyxySgUphLuoMGSVLGmYnobt5FgEZ",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://dexilla.com",
  "name": "Dexilla Testnet",
  "nativeCurrency": {
    "name": "Dexilla Native Token",
    "symbol": "DXZ",
    "decimals": 18
  },
  "networkId": 1954,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": [{
      "url": "https://bridge.dexilla.com"
    }]
  },
  "rpc": ["https://1954.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.dexilla.com"],
  "shortName": "Dexilla",
  "slip44": 1,
  "slug": "dexilla-testnet",
  "testnet": true
};

var c1961 = {
  "chain": "SEL",
  "chainId": 1961,
  "explorers": [{
    "name": "Selendra Scan",
    "url": "https://scan.selendra.org",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmbnLDuVc4JReFysyKvmpuqUtj9HCus6qoKD5nQ9QkokzK",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://selendra.org",
  "name": "Selendra Network Mainnet",
  "nativeCurrency": {
    "name": "Selendra",
    "symbol": "SEL",
    "decimals": 18
  },
  "networkId": 1961,
  "rpc": ["https://1961.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc0.selendra.org", "https://rpc1.selendra.org"],
  "shortName": "SEL",
  "slug": "selendra-network",
  "testnet": false
};

var c1962 = {
  "chain": "Avalanche",
  "chainId": 1962,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser3295 Testnet",
  "nativeCurrency": {
    "name": "QaUser3295 Testnet Token",
    "symbol": "JXA",
    "decimals": 18
  },
  "networkId": 1962,
  "redFlags": [],
  "rpc": ["https://1962.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser3295 Testnet",
  "slug": "qauser3295-testnet",
  "testnet": true
};

var c1967 = {
  "chain": "MTC",
  "chainId": 1967,
  "explorers": [{
    "name": "metaexplorer-eleanor",
    "url": "https://explorer.metatime.com/eleanor",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.metatime.com/eleanor"],
  "infoURL": "https://eleanor.metatime.com",
  "name": "Eleanor",
  "nativeCurrency": {
    "name": "Eleanor Metacoin",
    "symbol": "MTC",
    "decimals": 18
  },
  "networkId": 1967,
  "rpc": ["https://1967.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.metatime.com/eleanor", "wss://ws.metatime.com/eleanor"],
  "shortName": "mtc",
  "slip44": 1,
  "slug": "eleanor",
  "testnet": true,
  "title": "Metatime Testnet Eleanor"
};

var c1969 = {
  "chain": "TSCS",
  "chainId": 1969,
  "explorers": [{
    "name": "blockscout",
    "url": "https://testnetscan.scschain.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://testnet.scschain.com"],
  "icon": {
    "url": "ipfs://QmW4C4QHLMhLeH5MsdVbauMc2Skb4ehzLKU3egLKKoux4D",
    "width": 130,
    "height": 130,
    "format": "png"
  },
  "infoURL": "https://testnet.scschain.com",
  "name": "Super Smart Chain Testnet",
  "nativeCurrency": {
    "name": "Super Chain Native Token",
    "symbol": "TSCS",
    "decimals": 18
  },
  "networkId": 1969,
  "rpc": ["https://1969.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnetrpc.scschain.com"],
  "shortName": "tscs",
  "slip44": 1,
  "slug": "super-smart-chain-testnet",
  "testnet": true
};

var c1970 = {
  "chain": "SCS",
  "chainId": 1970,
  "explorers": [{
    "name": "blockscout",
    "url": "https://scan.scschain.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmW4C4QHLMhLeH5MsdVbauMc2Skb4ehzLKU3egLKKoux4D",
    "width": 130,
    "height": 130,
    "format": "png"
  },
  "infoURL": "https://scschain.com",
  "name": "Super Smart Chain Mainnet",
  "nativeCurrency": {
    "name": "Super Chain Native Token",
    "symbol": "SCS",
    "decimals": 18
  },
  "networkId": 1970,
  "rpc": ["https://1970.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.scschain.com"],
  "shortName": "scs",
  "slug": "super-smart-chain",
  "testnet": false
};

var c1971 = {
  "chain": "ALTR",
  "chainId": 1971,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreigcquvoalec3ll2m26v4wsx5enlxwyn6nk2mgfqwncyqrgwivla5u",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://1971.network/",
  "name": "Atelier",
  "nativeCurrency": {
    "name": "ATLR",
    "symbol": "ATLR",
    "decimals": 18
  },
  "networkId": 1971,
  "rpc": ["https://1971.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://1971.network/atlr", "wss://1971.network/atlr"],
  "shortName": "atlr",
  "slip44": 1,
  "slug": "atelier",
  "testnet": true,
  "title": "Atelier Test Network"
};

var c1972 = {
  "chain": "REDEV2",
  "chainId": 1972,
  "explorers": [{
    "name": "RedeCoin Explorer",
    "url": "https://explorer3.redecoin.eu",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.redecoin.eu",
  "name": "RedeCoin",
  "nativeCurrency": {
    "name": "RedeCoin",
    "symbol": "REDEV2",
    "decimals": 18
  },
  "networkId": 1972,
  "rpc": ["https://1972.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc2.redecoin.eu"],
  "shortName": "rede",
  "slug": "redecoin",
  "testnet": false
};

var c1975 = {
  "chain": "onus",
  "chainId": 1975,
  "explorers": [{
    "name": "Onus explorer mainnet",
    "url": "https://explorer.onuschain.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreiec34ik3glrm5jrzafdytvu4kxdsrxhqmagbe27fytdcuzkhoooay",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "infoURL": "https://onuschain.io",
  "name": "ONUS Chain Mainnet",
  "nativeCurrency": {
    "name": "ONUS",
    "symbol": "ONUS",
    "decimals": 18
  },
  "networkId": 1975,
  "rpc": ["https://1975.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.onuschain.io", "wss://ws.onuschain.io"],
  "shortName": "onus-mainnet",
  "slug": "onus-chain",
  "testnet": false,
  "title": "ONUS Chain Mainnet"
};

var c1984 = {
  "chain": "EUN",
  "chainId": 1984,
  "explorers": [{
    "name": "testnetexplorer",
    "url": "https://testnetexplorer.eurus.network",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmaGd5L9jGPbfyGXBFhu9gjinWJ66YtNrXq8x6Q98Eep9e",
      "width": 471,
      "height": 471,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmaGd5L9jGPbfyGXBFhu9gjinWJ66YtNrXq8x6Q98Eep9e",
    "width": 471,
    "height": 471,
    "format": "svg"
  },
  "infoURL": "https://eurus.network",
  "name": "Eurus Testnet",
  "nativeCurrency": {
    "name": "Eurus",
    "symbol": "EUN",
    "decimals": 18
  },
  "networkId": 1984,
  "rpc": ["https://1984.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.eurus.network"],
  "shortName": "euntest",
  "slip44": 1,
  "slug": "eurus-testnet",
  "testnet": true
};

var c1985 = {
  "chain": "TUSHY",
  "chainId": 1985,
  "explorers": [{
    "name": "mainnetexplorer",
    "url": "http://explore.satosh.ie",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmRHT4o9ihiY6nVkkRdwZjdugbEAQiXrrov3GS9a3GTuL7",
      "width": 1024,
      "height": 1024,
      "format": "jpg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRHT4o9ihiY6nVkkRdwZjdugbEAQiXrrov3GS9a3GTuL7",
    "width": 1024,
    "height": 1024,
    "format": "jpg"
  },
  "infoURL": "https://satosh.ie",
  "name": "SatoshIE",
  "nativeCurrency": {
    "name": "Tushy Token",
    "symbol": "TUSHY",
    "decimals": 18
  },
  "networkId": 1985,
  "rpc": ["https://1985.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://rpc.satosh.ie"],
  "shortName": "satoshie",
  "slug": "satoshie",
  "testnet": false
};

var c1986 = {
  "chain": "TUSHY",
  "chainId": 1986,
  "explorers": [{
    "name": "testnetexplorer",
    "url": "http://explore-testnet.satosh.ie",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmRHT4o9ihiY6nVkkRdwZjdugbEAQiXrrov3GS9a3GTuL7",
      "width": 1024,
      "height": 1024,
      "format": "jpg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRHT4o9ihiY6nVkkRdwZjdugbEAQiXrrov3GS9a3GTuL7",
    "width": 1024,
    "height": 1024,
    "format": "jpg"
  },
  "infoURL": "https://satosh.ie",
  "name": "SatoshIE Testnet",
  "nativeCurrency": {
    "name": "Tushy Token",
    "symbol": "TUSHY",
    "decimals": 18
  },
  "networkId": 1986,
  "rpc": ["https://1986.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://testnet.satosh.ie"],
  "shortName": "satoshie_testnet",
  "slip44": 1,
  "slug": "satoshie-testnet",
  "testnet": true
};

var c1987 = {
  "chain": "EGEM",
  "chainId": 1987,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://egem.io",
  "name": "EtherGem",
  "nativeCurrency": {
    "name": "EtherGem Ether",
    "symbol": "EGEM",
    "decimals": 18
  },
  "networkId": 1987,
  "rpc": ["https://1987.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://jsonrpc.egem.io/custom"],
  "shortName": "egem",
  "slip44": 1987,
  "slug": "ethergem",
  "testnet": false
};

var c1992 = {
  "chain": "Hubblenet",
  "chainId": 1992,
  "explorers": [{
    "name": "routescan",
    "url": "https://explorer.hubble.exchange",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmU9t9fZaWiqpAZ9dw2ojTpJycnB8BxekLWVSCJikJVgjW",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://www.hubble.exchange",
  "name": "Hubble Exchange",
  "nativeCurrency": {
    "name": "USD Coin",
    "symbol": "USDC",
    "decimals": 18
  },
  "networkId": 1992,
  "rpc": ["https://1992.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.hubble.exchange", "wss://ws-rpc.hubble.exchange"],
  "shortName": "hubblenet",
  "slip44": 60,
  "slug": "hubble-exchange",
  "testnet": false
};

var c1994 = {
  "chain": "EKTA",
  "chainId": 1994,
  "explorers": [{
    "name": "ektascan",
    "url": "https://ektascan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmfMd564KUPK8eKZDwGCT71ZC2jMnUZqP6LCtLpup3rHH1",
      "width": 2100,
      "height": 2100,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmfMd564KUPK8eKZDwGCT71ZC2jMnUZqP6LCtLpup3rHH1",
    "width": 2100,
    "height": 2100,
    "format": "png"
  },
  "infoURL": "https://www.ekta.io",
  "name": "Ekta",
  "nativeCurrency": {
    "name": "EKTA",
    "symbol": "EKTA",
    "decimals": 18
  },
  "networkId": 1994,
  "rpc": ["https://1994.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://main.ekta.io"],
  "shortName": "ekta",
  "slug": "ekta",
  "testnet": false
};

var c1995 = {
  "chain": "edeXa TestNetwork",
  "chainId": 1995,
  "explorers": [{
    "name": "edexa-testnet",
    "url": "https://explorer.testnet.edexa.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.edexa.com/"],
  "icon": {
    "url": "ipfs://QmSgvmLpRsCiu2ySqyceA5xN4nwi7URJRNEZLffwEKXdoR",
    "width": 1028,
    "height": 1042,
    "format": "png"
  },
  "infoURL": "https://edexa.com/",
  "name": "edeXa Testnet",
  "nativeCurrency": {
    "name": "EDEXA",
    "symbol": "EDX",
    "decimals": 18
  },
  "networkId": 1995,
  "rpc": ["https://1995.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.edexa.com/rpc", "https://io-dataseed1.testnet.edexa.io-market.com/rpc"],
  "shortName": "edx",
  "slip44": 1,
  "slug": "edexa-testnet",
  "testnet": true
};

var c1998 = {
  "chain": "KYOTO",
  "chainId": 1998,
  "explorers": [{
    "name": "Kyotoscan",
    "url": "https://testnet.kyotoscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.kyotoprotocol.io"],
  "features": [{
    "name": "EIP155"
  }],
  "infoURL": "https://kyotoprotocol.io",
  "name": "Kyoto Testnet",
  "nativeCurrency": {
    "name": "Kyoto",
    "symbol": "KYOTO",
    "decimals": 18
  },
  "networkId": 1998,
  "rpc": ["https://1998.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.kyotoprotocol.io:8545"],
  "shortName": "kyoto-testnet",
  "slip44": 1,
  "slug": "kyoto-testnet",
  "testnet": true
};

var c2000 = {
  "chain": "DC",
  "chainId": 2000,
  "explorers": [{
    "name": "dogechain explorer",
    "url": "https://explorer.dogechain.dog",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNS6B6L8FfgGSMTEi2SxD3bK5cdmKPNtQKcYaJeRWrkHs",
    "width": 732,
    "height": 732,
    "format": "png"
  },
  "infoURL": "https://dogechain.dog",
  "name": "Dogechain Mainnet",
  "nativeCurrency": {
    "name": "Dogecoin",
    "symbol": "DOGE",
    "decimals": 18
  },
  "networkId": 2000,
  "rpc": ["https://2000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.dogechain.dog", "https://rpc01-sg.dogechain.dog", "https://rpc.ankr.com/dogechain"],
  "shortName": "dc",
  "slug": "dogechain",
  "testnet": false
};

var c2001 = {
  "chain": "milkAda",
  "chainId": 2001,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://explorer-mainnet-cardano-evm.c1.milkomeda.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdoUtvHDybu5ppYBZT8BMRp6AqByVSoQs8nFwKbaS55jd",
    "width": 367,
    "height": 367,
    "format": "svg"
  },
  "infoURL": "https://milkomeda.com",
  "name": "Milkomeda C1 Mainnet",
  "nativeCurrency": {
    "name": "milkAda",
    "symbol": "mADA",
    "decimals": 18
  },
  "networkId": 2001,
  "rpc": ["https://2001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mainnet-cardano-evm.c1.milkomeda.com", "wss://rpc-mainnet-cardano-evm.c1.milkomeda.com"],
  "shortName": "milkAda",
  "slug": "milkomeda-c1",
  "testnet": false
};

var c2002 = {
  "chain": "milkALGO",
  "chainId": 2002,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://explorer-mainnet-algorand-rollup.a1.milkomeda.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdoUtvHDybu5ppYBZT8BMRp6AqByVSoQs8nFwKbaS55jd",
    "width": 367,
    "height": 367,
    "format": "svg"
  },
  "infoURL": "https://milkomeda.com",
  "name": "Milkomeda A1 Mainnet",
  "nativeCurrency": {
    "name": "milkALGO",
    "symbol": "mALGO",
    "decimals": 18
  },
  "networkId": 2002,
  "rpc": ["https://2002.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mainnet-algorand-rollup.a1.milkomeda.com", "wss://rpc-mainnet-algorand-rollup.a1.milkomeda.com/ws"],
  "shortName": "milkALGO",
  "slug": "milkomeda-a1",
  "testnet": false
};

var c2008 = {
  "chain": "CloudWalk Testnet",
  "chainId": 2008,
  "explorers": [{
    "name": "CloudWalk Testnet Explorer",
    "url": "https://explorer.testnet.cloudwalk.io",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://cloudwalk.io",
  "name": "CloudWalk Testnet",
  "nativeCurrency": {
    "name": "CloudWalk Native Token",
    "symbol": "CWN",
    "decimals": 18
  },
  "networkId": 2008,
  "rpc": [],
  "shortName": "cloudwalk_testnet",
  "slip44": 1,
  "slug": "cloudwalk-testnet",
  "testnet": true
};

var c2009 = {
  "chain": "CloudWalk Mainnet",
  "chainId": 2009,
  "explorers": [{
    "name": "CloudWalk Mainnet Explorer",
    "url": "https://explorer.mainnet.cloudwalk.io",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://cloudwalk.io",
  "name": "CloudWalk Mainnet",
  "nativeCurrency": {
    "name": "CloudWalk Native Token",
    "symbol": "CWN",
    "decimals": 18
  },
  "networkId": 2009,
  "rpc": [],
  "shortName": "cloudwalk_mainnet",
  "slug": "cloudwalk",
  "testnet": false
};

var c2016 = {
  "chain": "NetZ",
  "chainId": 2016,
  "explorers": [{
    "name": "MainnetZ",
    "url": "https://explorer.mainnetz.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmT5gJ5weBiLT3GoYuF5yRTRLdPLCVZ3tXznfqW7M8fxgG",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://mainnetz.io",
  "name": "MainnetZ Mainnet",
  "nativeCurrency": {
    "name": "MainnetZ",
    "symbol": "NetZ",
    "decimals": 18
  },
  "networkId": 2016,
  "rpc": ["https://2016.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.mainnetz.io", "https://eu-rpc.mainnetz.io"],
  "shortName": "netz",
  "slug": "z-mainnet",
  "testnet": false
};

var c2018 = {
  "chain": "PublicMint",
  "chainId": 2018,
  "explorers": [{
    "name": "PublicMint Explorer",
    "url": "https://explorer.dev.publicmint.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://publicmint.com",
  "name": "PublicMint Devnet",
  "nativeCurrency": {
    "name": "USD",
    "symbol": "USD",
    "decimals": 18
  },
  "networkId": 2018,
  "rpc": ["https://2018.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.dev.publicmint.io:8545"],
  "shortName": "pmint_dev",
  "slip44": 60,
  "slug": "publicmint-devnet",
  "testnet": false,
  "title": "Public Mint Devnet"
};

var c2019 = {
  "chain": "PublicMint",
  "chainId": 2019,
  "explorers": [{
    "name": "PublicMint Explorer",
    "url": "https://explorer.tst.publicmint.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://publicmint.com",
  "name": "PublicMint Testnet",
  "nativeCurrency": {
    "name": "USD",
    "symbol": "USD",
    "decimals": 18
  },
  "networkId": 2019,
  "rpc": ["https://2019.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.tst.publicmint.io:8545"],
  "shortName": "pmint_test",
  "slip44": 1,
  "slug": "publicmint-testnet",
  "testnet": true,
  "title": "Public Mint Testnet"
};

var c2020 = {
  "chain": "PublicMint",
  "chainId": 2020,
  "explorers": [{
    "name": "PublicMint Explorer",
    "url": "https://explorer.publicmint.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://publicmint.com",
  "name": "PublicMint Mainnet",
  "nativeCurrency": {
    "name": "USD",
    "symbol": "USD",
    "decimals": 18
  },
  "networkId": 2020,
  "rpc": ["https://2020.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.publicmint.io:8545"],
  "shortName": "pmint",
  "slip44": 60,
  "slug": "publicmint",
  "testnet": false,
  "title": "Public Mint Mainnet"
};

var c2021 = {
  "chain": "EDG",
  "chainId": 2021,
  "explorers": [{
    "name": "Edgscan by Bharathcoorg",
    "url": "https://edgscan.live",
    "standard": "EIP3091"
  }, {
    "name": "Subscan",
    "url": "https://edgeware.subscan.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://Qma2GfW5nQHuA7nGqdEfwaXPL63G9oTwRTQKaGTfjNtM2W",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmS3ERgAKYTmV7bSWcUPSvrrCC9wHQYxtZqEQYx9Rw4RGA",
    "width": 352,
    "height": 304,
    "format": "png"
  },
  "infoURL": "https://edgeware.io",
  "name": "Edgeware EdgeEVM Mainnet",
  "nativeCurrency": {
    "name": "Edgeware",
    "symbol": "EDG",
    "decimals": 18
  },
  "networkId": 2021,
  "rpc": ["https://2021.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://edgeware-evm.jelliedowl.net", "https://mainnet2.edgewa.re/evm", "https://mainnet3.edgewa.re/evm", "https://mainnet4.edgewa.re/evm", "https://mainnet5.edgewa.re/evm", "wss://edgeware.jelliedowl.net", "wss://mainnet2.edgewa.re", "wss://mainnet3.edgewa.re", "wss://mainnet4.edgewa.re", "wss://mainnet5.edgewa.re"],
  "shortName": "edg",
  "slip44": 523,
  "slug": "edgeware-edgeevm",
  "testnet": false
};

var c2022 = {
  "chain": "EDG",
  "chainId": 2022,
  "explorers": [{
    "name": "Edgscan by Bharathcoorg",
    "url": "https://testnet.edgscan.live",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://edgeware.io/build",
  "name": "Beresheet BereEVM Testnet",
  "nativeCurrency": {
    "name": "Testnet EDG",
    "symbol": "tEDG",
    "decimals": 18
  },
  "networkId": 2022,
  "rpc": ["https://2022.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://beresheet-evm.jelliedowl.net", "wss://beresheet.jelliedowl.net"],
  "shortName": "edgt",
  "slip44": 1,
  "slug": "beresheet-bereevm-testnet",
  "testnet": true
};

var c2023 = {
  "chain": "Taycan",
  "chainId": 2023,
  "explorers": [{
    "name": "Taycan Explorer(Blockscout)",
    "url": "https://evmscan-test.hupayx.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreidvjcc73v747lqlyrhgbnkvkdepdvepo6baj6hmjsmjtvdyhmzzmq",
      "width": 1000,
      "height": 1206,
      "format": "png"
    }
  }, {
    "name": "Taycan Cosmos Explorer",
    "url": "https://cosmoscan-test.hupayx.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreidvjcc73v747lqlyrhgbnkvkdepdvepo6baj6hmjsmjtvdyhmzzmq",
      "width": 1000,
      "height": 1206,
      "format": "png"
    }
  }],
  "faucets": ["https://ttaycan-faucet.hupayx.io/"],
  "icon": {
    "url": "ipfs://bafkreidvjcc73v747lqlyrhgbnkvkdepdvepo6baj6hmjsmjtvdyhmzzmq",
    "width": 1000,
    "height": 1206,
    "format": "png"
  },
  "infoURL": "https://hupayx.io",
  "name": "Taycan Testnet",
  "nativeCurrency": {
    "name": "test-Shuffle",
    "symbol": "tSFL",
    "decimals": 18
  },
  "networkId": 2023,
  "rpc": ["https://2023.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://test-taycan.hupayx.io"],
  "shortName": "taycan-testnet",
  "slip44": 1,
  "slug": "taycan-testnet",
  "testnet": true
};

var c2024 = {
  "chain": "SWAN",
  "chainId": 2024,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://swanchain.io/",
  "name": "Swan Saturn Testnet",
  "nativeCurrency": {
    "name": "SWANETH",
    "symbol": "sETH",
    "decimals": 18
  },
  "networkId": 2024,
  "rpc": ["https://2024.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://saturn-rpc.swanchain.io"],
  "shortName": "swan",
  "slug": "swan-saturn-testnet",
  "testnet": true
};

var c2025 = {
  "chain": "Rangers",
  "chainId": 2025,
  "explorers": [{
    "name": "rangersscan",
    "url": "https://scan.rangersprotocol.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmXR5e5SDABWfQn6XT9uMsVYAo5Bv7vUv4jVs8DFqatZWG",
    "width": 2000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://rangersprotocol.com",
  "name": "Rangers Protocol Mainnet",
  "nativeCurrency": {
    "name": "Rangers Protocol Gas",
    "symbol": "RPG",
    "decimals": 18
  },
  "networkId": 2025,
  "rpc": ["https://2025.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.rangersprotocol.com/api/jsonrpc"],
  "shortName": "rpg",
  "slip44": 1008,
  "slug": "rangers-protocol",
  "testnet": false
};

var c2031 = {
  "chain": "CFG",
  "chainId": 2031,
  "explorers": [{
    "name": "subscan",
    "url": "https://centrifuge.subscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://Qma2GfW5nQHuA7nGqdEfwaXPL63G9oTwRTQKaGTfjNtM2W",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmedNc3WvTm66iNK2NYW6Fzu5tx5FgNa6HCBf3DTHpzQZ1",
    "width": 209,
    "height": 208,
    "format": "svg"
  },
  "infoURL": "https://centrifuge.io",
  "name": "Centrifuge",
  "nativeCurrency": {
    "name": "Centrifuge",
    "symbol": "CFG",
    "decimals": 18
  },
  "networkId": 2031,
  "rpc": ["https://2031.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://fullnode.centrifuge.io", "wss://fullnode.centrifuge.io", "https://centrifuge-parachain.api.onfinality.io/public", "wss://centrifuge-parachain.api.onfinality.io/public-ws", "https://centrifuge-rpc.dwellir.com", "wss://centrifuge-rpc.dwellir.com", "https://rpc-centrifuge.luckyfriday.io", "wss://rpc-centrifuge.luckyfriday.io"],
  "shortName": "cfg",
  "slug": "centrifuge",
  "testnet": false
};

var c2032 = {
  "chain": "CFG",
  "chainId": 2032,
  "explorers": [],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://centrifuge.io",
  "name": "Catalyst",
  "nativeCurrency": {
    "name": "Catalyst CFG",
    "symbol": "NCFG",
    "decimals": 18
  },
  "networkId": 2032,
  "rpc": ["wss://fullnode.catalyst.cntrfg.com"],
  "shortName": "ncfg",
  "slug": "catalyst",
  "testnet": false
};

var c2035 = {
  "chain": "PHA",
  "chainId": 2035,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://phala.network",
  "name": "Phala Network",
  "nativeCurrency": {
    "name": "Phala",
    "symbol": "PHA",
    "decimals": 18
  },
  "networkId": 2035,
  "rpc": [],
  "shortName": "pha",
  "slug": "phala-network",
  "testnet": false
};

var c2037 = {
  "chain": "KIWI",
  "chainId": 2037,
  "explorers": [{
    "name": "KIWI Explorer",
    "url": "https://subnets-test.avax.network/kiwi",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "name": "Kiwi Subnet",
  "nativeCurrency": {
    "name": "Shrapgas",
    "symbol": "SHRAP",
    "decimals": 18
  },
  "networkId": 2037,
  "rpc": ["https://2037.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/kiwi/testnet/rpc"],
  "shortName": "kiwi",
  "slip44": 1,
  "slug": "kiwi-subnet",
  "testnet": true
};

var c2038 = {
  "chain": "SHRAPNEL",
  "chainId": 2038,
  "explorers": [{
    "name": "SHRAPNEL Explorer",
    "url": "https://subnets-test.avax.network/shrapnel",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "infoURL": "https://www.shrapnel.com/",
  "name": "Shrapnel Testnet",
  "nativeCurrency": {
    "name": "SHRAPG",
    "symbol": "SHRAPG",
    "decimals": 18
  },
  "networkId": 2038,
  "rpc": ["https://2038.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/shrapnel/testnet/rpc"],
  "shortName": "shraptest",
  "slip44": 1,
  "slug": "shrapnel-testnet",
  "testnet": true
};

var c2043 = {
  "chain": "OTP",
  "chainId": 2043,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://parachain.origintrail.io",
  "name": "OriginTrail Parachain",
  "nativeCurrency": {
    "name": "OriginTrail Parachain Token",
    "symbol": "OTP",
    "decimals": 12
  },
  "networkId": 2043,
  "rpc": ["https://2043.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://astrosat.origintrail.network", "wss://parachain-rpc.origin-trail.network"],
  "shortName": "otp",
  "slug": "origintrail-parachain",
  "testnet": false
};

var c2044 = {
  "chain": "shrapnel",
  "chainId": 2044,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.shrapnel.com/",
  "name": "Shrapnel Subnet",
  "nativeCurrency": {
    "name": "Shrapnel Gas Token",
    "symbol": "SHRAPG",
    "decimals": 18
  },
  "networkId": 2044,
  "rpc": ["https://2044.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/shrapnel/mainnet/rpc"],
  "shortName": "Shrapnel",
  "slug": "shrapnel-subnet",
  "testnet": false
};

var c2047 = {
  "chain": "STOS",
  "chainId": 2047,
  "explorers": [{
    "name": "Stratos EVM Explorer (Blockscout)",
    "url": "https://web3-explorer-mesos.thestratos.org",
    "standard": "none"
  }, {
    "name": "Stratos Cosmos Explorer (BigDipper)",
    "url": "https://big-dipper-mesos.thestratos.org",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.thestratos.org",
  "name": "Stratos Testnet",
  "nativeCurrency": {
    "name": "STOS",
    "symbol": "STOS",
    "decimals": 18
  },
  "networkId": 2047,
  "rpc": ["https://2047.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://web3-rpc-mesos.thestratos.org"],
  "shortName": "stos-testnet",
  "slip44": 1,
  "slug": "stratos-testnet",
  "testnet": true
};

var c2048 = {
  "chain": "STOS",
  "chainId": 2048,
  "explorers": [{
    "name": "Stratos EVM Explorer (Blockscout)",
    "url": "https://web3-explorer.thestratos.org",
    "standard": "none"
  }, {
    "name": "Stratos Cosmos Explorer (BigDipper)",
    "url": "https://explorer.thestratos.org",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.thestratos.org",
  "name": "Stratos",
  "nativeCurrency": {
    "name": "STOS",
    "symbol": "STOS",
    "decimals": 18
  },
  "networkId": 2048,
  "rpc": ["https://2048.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://web3-rpc.thestratos.org"],
  "shortName": "stos-mainnet",
  "slug": "stratos",
  "testnet": false
};

var c2049 = {
  "chain": "MOVO",
  "chainId": 2049,
  "explorers": [{
    "name": "movoscan",
    "url": "https://movoscan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmdFJMdnTvu4adiMERMP7B5ZZDwgiPmU3kU1qrUFdvHmUY",
      "width": 800,
      "height": 800,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmSQGKhhBpMTM7vYpGdgMTDFyzaAN3PGG5AnmWy7KQPdSn",
    "width": 1200,
    "height": 1200,
    "format": "png"
  },
  "infoURL": "https://movo.uk",
  "name": "Movo Smart Chain Mainnet",
  "nativeCurrency": {
    "name": "Movo Smart Chain",
    "symbol": "MOVO",
    "decimals": 18
  },
  "networkId": 2049,
  "rpc": ["https://2049.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://msc-rpc.movoscan.com", "https://msc-rpc.movochain.org", "https://msc-rpc.movoswap.com"],
  "shortName": "movo",
  "slip44": 2050,
  "slug": "movo-smart-chain",
  "testnet": false
};

var c2077 = {
  "chain": "Qkacoin",
  "chainId": 2077,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.qkacoin.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://qkacoin.org",
  "name": "Quokkacoin Mainnet",
  "nativeCurrency": {
    "name": "Qkacoin",
    "symbol": "QKA",
    "decimals": 18
  },
  "networkId": 2077,
  "rpc": ["https://2077.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.qkacoin.org"],
  "shortName": "QKA",
  "slug": "quokkacoin",
  "testnet": false
};

var c2088 = {
  "chain": "AIR",
  "chainId": 2088,
  "explorers": [],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmSwqWxZ5HRdc25HMhEmVKxZkwSKapuuyGHb8kyrtuzxat",
    "width": 210,
    "height": 210,
    "format": "svg"
  },
  "infoURL": "https://centrifuge.io",
  "name": "Altair",
  "nativeCurrency": {
    "name": "Altair",
    "symbol": "AIR",
    "decimals": 18
  },
  "networkId": 2088,
  "rpc": ["wss://fullnode.altair.centrifuge.io", "wss://altair.api.onfinality.io/public-ws"],
  "shortName": "air",
  "slug": "altair",
  "testnet": false
};

var c2089 = {
  "chain": "algol",
  "chainId": 2089,
  "explorers": [],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://centrifuge.io",
  "name": "Algol",
  "nativeCurrency": {
    "name": "Algol",
    "symbol": "ALGL",
    "decimals": 18
  },
  "networkId": 2089,
  "rpc": ["wss://fullnode.algol.cntrfg.com"],
  "shortName": "algl",
  "slug": "algol",
  "status": "deprecated",
  "testnet": false
};

var c2100 = {
  "chain": "ECO",
  "chainId": 2100,
  "explorers": [{
    "name": "Ecoball Explorer",
    "url": "https://scan.ecoball.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://ecoball.org",
  "name": "Ecoball Mainnet",
  "nativeCurrency": {
    "name": "Ecoball Coin",
    "symbol": "ECO",
    "decimals": 18
  },
  "networkId": 2100,
  "rpc": ["https://2100.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.ecoball.org/ecoball/"],
  "shortName": "eco",
  "slug": "ecoball",
  "testnet": false
};

var c2101 = {
  "chain": "ECO",
  "chainId": 2101,
  "explorers": [{
    "name": "Ecoball Testnet Explorer",
    "url": "https://espuma-scan.ecoball.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://ecoball.org",
  "name": "Ecoball Testnet Espuma",
  "nativeCurrency": {
    "name": "Espuma Coin",
    "symbol": "ECO",
    "decimals": 18
  },
  "networkId": 2101,
  "rpc": ["https://2101.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.ecoball.org/espuma/"],
  "shortName": "esp",
  "slip44": 1,
  "slug": "ecoball-testnet-espuma",
  "testnet": true
};

var c2109 = {
  "chain": "EXN",
  "chainId": 2109,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.exosama.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmaQxfwpXYTomUd24PMx5tKjosupXcm99z1jL1XLq9LWBS",
    "width": 468,
    "height": 468,
    "format": "png"
  },
  "infoURL": "https://moonsama.com",
  "name": "Exosama Network",
  "nativeCurrency": {
    "name": "Sama Token",
    "symbol": "SAMA",
    "decimals": 18
  },
  "networkId": 2109,
  "rpc": ["https://2109.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.exosama.com", "wss://rpc.exosama.com"],
  "shortName": "exn",
  "slip44": 2109,
  "slug": "exosama-network",
  "testnet": false
};

var c2121 = {
  "chain": "Avalanche",
  "chainId": 2121,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "M TEST 1103-2",
  "nativeCurrency": {
    "name": "M TEST 1103-2 Token",
    "symbol": "RJI",
    "decimals": 18
  },
  "networkId": 2121,
  "redFlags": [],
  "rpc": ["https://2121.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/cb82eb40-2d0d-4188-905b-d50c4b09b40b"],
  "shortName": "M TEST 1103-2",
  "slug": "m-test-1103-2",
  "testnet": true
};

var c2122 = {
  "chain": "METAD",
  "chainId": 2122,
  "explorers": [{
    "name": "Metad Scan",
    "url": "https://scan.metaplayer.one",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmZyxS9BfRGYWWDtvrV6qtthCYV4TwdjLoH2sF6MkiTYFf",
      "width": 1280,
      "height": 1280,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZyxS9BfRGYWWDtvrV6qtthCYV4TwdjLoH2sF6MkiTYFf",
    "width": 1280,
    "height": 1280,
    "format": "png"
  },
  "infoURL": "https://docs.metaplayer.one/",
  "name": "Metaplayerone Mainnet",
  "nativeCurrency": {
    "name": "METAD",
    "symbol": "METAD",
    "decimals": 18
  },
  "networkId": 2122,
  "rpc": ["https://2122.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.metaplayer.one/"],
  "shortName": "Metad",
  "slug": "metaplayerone",
  "testnet": false
};

var c2124 = {
  "chain": "MP1 Dubai-Testnet",
  "chainId": 2124,
  "explorers": [{
    "name": "MP1Scan",
    "url": "https://dubai.mp1scan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://docs.metaplayer.one/",
  "name": "Metaplayerone Dubai Testnet",
  "nativeCurrency": {
    "name": "Metaunit",
    "symbol": "MEU",
    "decimals": 18
  },
  "networkId": 2124,
  "rpc": ["https://2124.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-dubai.mp1network.com/"],
  "shortName": "MEU",
  "slip44": 1,
  "slug": "metaplayerone-dubai-testnet",
  "testnet": true
};

var c2137 = {
  "chain": "BIGSB",
  "chainId": 2137,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://bigshortbets.com/",
  "name": "BigShortBets",
  "nativeCurrency": {
    "name": "USD Coin",
    "symbol": "USDC",
    "decimals": 18
  },
  "networkId": 2137,
  "rpc": ["https://2137.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://market.bigsb.io", "wss://market.bigsb.io"],
  "shortName": "bigsb",
  "slug": "bigshortbets",
  "testnet": false
};

var c2138 = {
  "chain": "dfiometatest",
  "chainId": 2138,
  "ens": {
    "registry": "0x57f1887a8BF19b14fC0dF6Fd9B2acc9Af147eA85"
  },
  "explorers": [{
    "name": "Quorum Explorer",
    "url": "https://public-2138.defi-oracle.io",
    "standard": "none"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmYrMRnjQJcNkYq9AvZ2FQ9kzYj9szzP4YDmyNA1ybd8xE",
    "width": 1000,
    "height": 1043,
    "format": "png"
  },
  "infoURL": "https://defi-oracle.io/",
  "name": "Defi Oracle Meta Testnet",
  "nativeCurrency": {
    "name": "testEther",
    "symbol": "tETH",
    "decimals": 18
  },
  "networkId": 21,
  "rpc": ["https://2138.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.public-2138.defi-oracle.io", "wss://rpc.public-2138.defi-oracle.io"],
  "shortName": "dfio-meta-test",
  "slip44": 1,
  "slug": "defi-oracle-meta-testnet",
  "testnet": true
};

var c2151 = {
  "chain": "ETH",
  "chainId": 2151,
  "explorers": [{
    "name": "BOASCAN",
    "url": "https://boascan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmW3CT4SHmso5dRJdsjR8GL1qmt79HkdAebCn2uNaWXFYh",
      "width": 256,
      "height": 257,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmW3CT4SHmso5dRJdsjR8GL1qmt79HkdAebCn2uNaWXFYh",
    "width": 256,
    "height": 257,
    "format": "png"
  },
  "infoURL": "https://docs.bosagora.org",
  "name": "BOSagora Mainnet",
  "nativeCurrency": {
    "name": "BOSAGORA",
    "symbol": "BOA",
    "decimals": 18
  },
  "networkId": 2151,
  "rpc": ["https://2151.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.bosagora.org", "https://rpc.bosagora.org"],
  "shortName": "boa",
  "slug": "bosagora",
  "testnet": false
};

var c2152 = {
  "chain": "Findora",
  "chainId": 2152,
  "explorers": [{
    "name": "findorascan",
    "url": "https://evm.findorascan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://findora.org/",
  "name": "Findora Mainnet",
  "nativeCurrency": {
    "name": "FRA",
    "symbol": "FRA",
    "decimals": 18
  },
  "networkId": 2152,
  "rpc": ["https://2152.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mainnet.findora.org"],
  "shortName": "fra",
  "slug": "findora",
  "testnet": false
};

var c2153 = {
  "chain": "Testnet-anvil",
  "chainId": 2153,
  "explorers": [{
    "name": "findorascan",
    "url": "https://testnet-anvil.evm.findorascan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://findora.org/",
  "name": "Findora Testnet",
  "nativeCurrency": {
    "name": "FRA",
    "symbol": "FRA",
    "decimals": 18
  },
  "networkId": 2153,
  "rpc": ["https://2153.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://prod-testnet.prod.findora.org:8545/"],
  "shortName": "findora-testnet",
  "slip44": 1,
  "slug": "findora-testnet",
  "testnet": true
};

var c2154 = {
  "chain": "Testnet-forge",
  "chainId": 2154,
  "explorers": [{
    "name": "findorascan",
    "url": "https://testnet-forge.evm.findorascan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://findora.org/",
  "name": "Findora Forge",
  "nativeCurrency": {
    "name": "FRA",
    "symbol": "FRA",
    "decimals": 18
  },
  "networkId": 2154,
  "rpc": ["https://2154.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://prod-forge.prod.findora.org:8545/"],
  "shortName": "findora-forge",
  "slip44": 1,
  "slug": "findora-forge",
  "testnet": true
};

var c2199 = {
  "chain": "MSN",
  "chainId": 2199,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.moonsama.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": ["https://multiverse.moonsama.com/faucet"],
  "icon": {
    "url": "ipfs://QmaQxfwpXYTomUd24PMx5tKjosupXcm99z1jL1XLq9LWBS",
    "width": 468,
    "height": 468,
    "format": "png"
  },
  "infoURL": "https://moonsama.com",
  "name": "Moonsama Network",
  "nativeCurrency": {
    "name": "Sama Token",
    "symbol": "SAMA",
    "decimals": 18
  },
  "networkId": 2199,
  "rpc": ["https://2199.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.moonsama.com", "wss://rpc.moonsama.com/ws"],
  "shortName": "msn",
  "slip44": 2199,
  "slug": "moonsama-network",
  "testnet": false
};

var c2202 = {
  "chain": "ABN",
  "chainId": 2202,
  "explorers": [{
    "name": "Antofy Mainnet",
    "url": "https://antofyscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.antofy.io"],
  "icon": {
    "url": "ipfs://QmdTfku81ohnG9ECU1Xswmeumt678cBhwHWuFYZ7i1Qsto",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://antofy.io",
  "name": "Antofy Mainnet",
  "nativeCurrency": {
    "name": "Antofy",
    "symbol": "ABN",
    "decimals": 18
  },
  "networkId": 2202,
  "rpc": ["https://2202.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.antofy.io"],
  "shortName": "ABNm",
  "slug": "antofy",
  "testnet": false
};

var c2203 = {
  "chain": "Bitcoin EVM",
  "chainId": 2203,
  "explorers": [{
    "name": "Explorer",
    "url": "https://explorer.bitcoinevm.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreic4aq265oaf6yze7ba5okefqh6vnqudyrz6ovukvbnrlhet36itle",
      "width": 200,
      "height": 200,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreic4aq265oaf6yze7ba5okefqh6vnqudyrz6ovukvbnrlhet36itle",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://bitcoinevm.com",
  "name": "Bitcoin EVM",
  "nativeCurrency": {
    "name": "Bitcoin",
    "symbol": "BTC",
    "decimals": 18
  },
  "networkId": 2203,
  "rpc": ["https://2203.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://connect.bitcoinevm.com"],
  "shortName": "BTC",
  "slug": "bitcoin-evm",
  "testnet": false
};

var c2213 = {
  "chain": "EVA",
  "chainId": 2213,
  "explorers": [{
    "name": "Evanesco Explorer",
    "url": "https://explorer.evanesco.org",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZbmGYdfbMRrWJore3c7hyD6q7B5pXHJqTSNjbZZUK6V8",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://evanesco.org/",
  "name": "Evanesco Mainnet",
  "nativeCurrency": {
    "name": "EVA",
    "symbol": "EVA",
    "decimals": 18
  },
  "networkId": 2213,
  "rpc": ["https://2213.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://seed4.evanesco.org:8546"],
  "shortName": "evanesco",
  "slug": "evanesco",
  "testnet": false
};

var c2221 = {
  "chain": "KAVA",
  "chainId": 2221,
  "explorers": [{
    "name": "Kava Testnet Explorer",
    "url": "http://testnet.kavascan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmdpRTk6oL1HRW9xC6cAc4Rnf9gs6zgdAcr4Z3HcLztusm",
      "width": 1186,
      "height": 360,
      "format": "svg"
    }
  }],
  "faucets": ["https://faucet.kava.io"],
  "icon": {
    "url": "ipfs://QmdpRTk6oL1HRW9xC6cAc4Rnf9gs6zgdAcr4Z3HcLztusm",
    "width": 1186,
    "height": 360,
    "format": "svg"
  },
  "infoURL": "https://www.kava.io",
  "name": "Kava Testnet",
  "nativeCurrency": {
    "name": "TKava",
    "symbol": "TKAVA",
    "decimals": 18
  },
  "networkId": 2221,
  "rpc": ["https://2221.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm.testnet.kava.io", "wss://wevm.testnet.kava.io", "https://kava-testnet.drpc.org", "wss://kava-testnet.drpc.org"],
  "shortName": "tkava",
  "slug": "kava-testnet",
  "testnet": true
};

var c2222 = {
  "chain": "KAVA",
  "chainId": 2222,
  "explorers": [{
    "name": "Kava EVM Explorer",
    "url": "https://kavascan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmdpRTk6oL1HRW9xC6cAc4Rnf9gs6zgdAcr4Z3HcLztusm",
      "width": 1186,
      "height": 360,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmdpRTk6oL1HRW9xC6cAc4Rnf9gs6zgdAcr4Z3HcLztusm",
    "width": 1186,
    "height": 360,
    "format": "svg"
  },
  "infoURL": "https://www.kava.io",
  "name": "Kava",
  "nativeCurrency": {
    "name": "Kava",
    "symbol": "KAVA",
    "decimals": 18
  },
  "networkId": 2222,
  "redFlags": [],
  "rpc": ["https://2222.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://kava-evm-rpc.publicnode.com", "wss://kava-evm-rpc.publicnode.com", "https://evm.kava.io", "wss://wevm.kava.io", "https://kava-rpc.gateway.pokt.network", "https://evm.kava-rpc.com", "wss://wevm.kava-rpc.com", "https://rpc.ankr.com/kava_evm", "https://kava.drpc.org", "wss://kava.drpc.org"],
  "shortName": "kava",
  "slug": "kava",
  "testnet": false
};

var c2223 = {
  "chain": "VChain",
  "chainId": 2223,
  "explorers": [{
    "name": "VChain Scan",
    "url": "https://scan.vcex.xyz",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://bo.vcex.xyz/",
  "name": "VChain Mainnet",
  "nativeCurrency": {
    "name": "VNDT",
    "symbol": "VNDT",
    "decimals": 18
  },
  "networkId": 2223,
  "rpc": ["https://2223.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://bc.vcex.xyz"],
  "shortName": "VChain",
  "slug": "vchain",
  "testnet": false
};

var c2241 = {
  "chain": "Krest",
  "chainId": 2241,
  "explorers": [{
    "name": "Polkadot.js",
    "url": "https://polkadot.js.org/apps/?rpc=wss://wss-krest.peaq.network#/explorer",
    "standard": "none"
  }, {
    "name": "Subscan",
    "url": "https://krest.subscan.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreid732273ib5at7krjdl2t7lteljlepwd3tvifqge7mu7g6naxavhe",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://www.peaq.network",
  "name": "Krest Network",
  "nativeCurrency": {
    "name": "Krest",
    "symbol": "KRST",
    "decimals": 18
  },
  "networkId": 2241,
  "rpc": ["https://2241.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://erpc-krest.peaq.network", "https://krest.unitedbloc.com"],
  "shortName": "KRST",
  "slug": "krest-network",
  "testnet": false
};

var c2300 = {
  "chain": "BOMB",
  "chainId": 2300,
  "explorers": [{
    "name": "bombscan",
    "url": "https://bombscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://Qmc44uSjfdNHdcxPTgZAL8eZ8TLe4UmSHibcvKQFyGJxTB",
      "width": 1024,
      "height": 1024,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmc44uSjfdNHdcxPTgZAL8eZ8TLe4UmSHibcvKQFyGJxTB",
    "width": 1024,
    "height": 1024,
    "format": "png"
  },
  "infoURL": "https://www.bombchain.com",
  "name": "BOMB Chain",
  "nativeCurrency": {
    "name": "BOMB Token",
    "symbol": "BOMB",
    "decimals": 18
  },
  "networkId": 2300,
  "rpc": ["https://2300.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.bombchain.com"],
  "shortName": "bomb",
  "slug": "bomb-chain",
  "testnet": false
};

var c2306 = {
  "chain": "ebro",
  "chainId": 2306,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.ebrochain.com",
  "name": "Ebro Network",
  "nativeCurrency": {
    "name": "Ebro",
    "symbol": "ebro",
    "decimals": 18
  },
  "networkId": 2306,
  "rpc": ["https://2306.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://greendinoswap.com"],
  "shortName": "ebro",
  "slug": "ebro-network",
  "testnet": false
};

var c2309 = {
  "chain": "Arevia",
  "chainId": 2309,
  "explorers": [],
  "faucets": [],
  "name": "Arevia",
  "nativeCurrency": {
    "name": "Arev",
    "symbol": "ARÉV",
    "decimals": 18
  },
  "networkId": 2309,
  "rpc": [],
  "shortName": "arevia",
  "slug": "arevia",
  "status": "incubating",
  "testnet": false
};

var c2323 = {
  "chain": "SOMA",
  "chainId": 2323,
  "explorers": [{
    "name": "SOMA Testnet Explorer",
    "url": "https://testnet.somascan.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmadSU2tcyvuzssDYGJ4rVLag43QLnKwcBerZR2zKLVU2N",
      "width": 500,
      "height": 500,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.somanetwork.io"],
  "icon": {
    "url": "ipfs://QmadSU2tcyvuzssDYGJ4rVLag43QLnKwcBerZR2zKLVU2N",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://somanetwork.io",
  "name": "SOMA Network Testnet",
  "nativeCurrency": {
    "name": "SMA",
    "symbol": "tSMA",
    "decimals": 18
  },
  "networkId": 2323,
  "rpc": ["https://2323.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://data-testnet-v1.somanetwork.io/", "https://testnet-au-server-2.somanetwork.io", "https://testnet-au-server-1.somanetwork.io", "https://testnet-sg-server-1.somanetwork.io", "https://testnet-sg-server-2.somanetwork.io"],
  "shortName": "sma",
  "slip44": 1,
  "slug": "soma-network-testnet",
  "testnet": true
};

var c2330 = {
  "chain": "mainnet",
  "chainId": 2330,
  "explorers": [{
    "name": "expedition",
    "url": "http://expedition.altcoinchain.org",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmYwHmGC9CRVcKo1LSesqxU31SDj9vk2iQxcFjQArzhix4",
      "width": 720,
      "height": 720,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYwHmGC9CRVcKo1LSesqxU31SDj9vk2iQxcFjQArzhix4",
    "width": 720,
    "height": 720,
    "format": "png"
  },
  "infoURL": "https://altcoinchain.org",
  "name": "Altcoinchain",
  "nativeCurrency": {
    "name": "Altcoin",
    "symbol": "ALT",
    "decimals": 18
  },
  "networkId": 2330,
  "rpc": ["https://2330.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc0.altcoinchain.org/rpc"],
  "shortName": "alt",
  "slug": "altcoinchain",
  "status": "active",
  "testnet": false
};

var c2331 = {
  "chain": "RSS3",
  "chainId": 2331,
  "explorers": [{
    "name": "RSS3 VSL Sepolia Testnet Scan",
    "url": "https://scan.testnet.rss3.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmTE6hnMTQaGU8Fm7nQbeTqQ5Ha3kyLKHR6QTd59prP2mC",
    "width": 200,
    "height": 200,
    "format": "svg"
  },
  "infoURL": "https://rss3.io",
  "name": "RSS3 VSL Sepolia Testnet",
  "nativeCurrency": {
    "name": "RSS3",
    "symbol": "RSS3",
    "decimals": 18
  },
  "networkId": 2331,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": [{
      "url": "https://explorer.testnet.rss3.io/bridge"
    }]
  },
  "rpc": ["https://2331.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.rss3.io"],
  "shortName": "rss3-testnet",
  "slug": "rss3-vsl-sepolia-testnet",
  "testnet": true
};

var c2332 = {
  "chain": "SOMA",
  "chainId": 2332,
  "explorers": [{
    "name": "SOMA Explorer Mainnet",
    "url": "https://somascan.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmadSU2tcyvuzssDYGJ4rVLag43QLnKwcBerZR2zKLVU2N",
      "width": 500,
      "height": 500,
      "format": "png"
    }
  }],
  "faucets": ["https://airdrop.somanetwork.io"],
  "icon": {
    "url": "ipfs://QmadSU2tcyvuzssDYGJ4rVLag43QLnKwcBerZR2zKLVU2N",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://somanetwork.io",
  "name": "SOMA Network Mainnet",
  "nativeCurrency": {
    "name": "Soma Native Token",
    "symbol": "SMA",
    "decimals": 18
  },
  "networkId": 2332,
  "rpc": ["https://2332.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://data-mainnet-v1.somanetwork.io/", "https://id-mainnet.somanetwork.io", "https://hk-mainnet.somanetwork.io", "https://sg-mainnet.somanetwork.io"],
  "shortName": "smam",
  "slug": "soma-network",
  "status": "incubating",
  "testnet": false
};

var c2340 = {
  "chain": "Atleta",
  "chainId": 2340,
  "explorers": [{
    "name": "Atleta Testnet Explorer",
    "url": "http://185.234.69.18/?rpc=wss%3A%2F%2Fatleta-testnet-rpc.quark.blue%3A9944#/explorer",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmV2JVr4FCcb6aRiUoA3wS5erLoxtLBLonQ1Nvz8fNuEcR",
      "width": 128,
      "height": 128,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.atleta.network"],
  "icon": {
    "url": "ipfs://QmV2JVr4FCcb6aRiUoA3wS5erLoxtLBLonQ1Nvz8fNuEcR",
    "width": 128,
    "height": 128,
    "format": "png"
  },
  "infoURL": "https://atleta.network",
  "name": "Atleta Testnet",
  "nativeCurrency": {
    "name": "Atla",
    "symbol": "ATLA",
    "decimals": 18
  },
  "networkId": 2340,
  "rpc": ["https://2340.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://atleta-testnet-rpc.quark.blue:9944"],
  "shortName": "atla",
  "slip44": 1,
  "slug": "atleta-testnet",
  "testnet": true
};

var c2342 = {
  "chain": "OMNIA",
  "chainId": 2342,
  "explorers": [{
    "name": "OmniaVerse Explorer",
    "url": "https://scan.omniaverse.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://www.omniaverse.io"],
  "icon": {
    "url": "ipfs://QmdNQMFxcjB9PAP1LZVqaQmyppV5QGTqXXmbBeQyaTUpMM",
    "width": 192,
    "height": 192,
    "format": "png"
  },
  "infoURL": "https://www.omniaverse.io",
  "name": "Omnia Chain",
  "nativeCurrency": {
    "name": "Omnia",
    "symbol": "OMNIA",
    "decimals": 18
  },
  "networkId": 2342,
  "rpc": ["https://2342.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.omniaverse.io"],
  "shortName": "omnia",
  "slug": "omnia-chain",
  "testnet": false
};

var c2357 = {
  "chain": "ETH",
  "chainId": 2357,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscout.sepolia-deprecated.kroma.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmVpV2WET6ZrqnvvPfE9hCwoE2y5ygbPuniuugpaRoxrho",
      "width": 320,
      "height": 320,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVpV2WET6ZrqnvvPfE9hCwoE2y5ygbPuniuugpaRoxrho",
    "width": 320,
    "height": 320,
    "format": "svg"
  },
  "infoURL": "https://kroma.network",
  "name": "(deprecated) Kroma Sepolia",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 2357,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": [{
      "url": "https://kroma.network/bridge"
    }]
  },
  "rpc": ["https://2357.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.sepolia-deprecated.kroma.network"],
  "shortName": "deprecated-kroma-sepolia",
  "slip44": 1,
  "slug": "deprecated-kroma-sepolia",
  "status": "deprecated",
  "testnet": true,
  "title": "(deprecated) Kroma Testnet Sepolia"
};

var c2358 = {
  "chain": "ETH",
  "chainId": 2358,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscout.sepolia.kroma.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmVpV2WET6ZrqnvvPfE9hCwoE2y5ygbPuniuugpaRoxrho",
      "width": 320,
      "height": 320,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVpV2WET6ZrqnvvPfE9hCwoE2y5ygbPuniuugpaRoxrho",
    "width": 320,
    "height": 320,
    "format": "svg"
  },
  "infoURL": "https://kroma.network",
  "name": "Kroma Sepolia",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 2358,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": [{
      "url": "https://kroma.network/bridge"
    }]
  },
  "rpc": ["https://2358.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.sepolia.kroma.network"],
  "shortName": "kroma-sepolia",
  "slip44": 1,
  "slug": "kroma-sepolia",
  "testnet": true,
  "title": "Kroma Testnet Sepolia"
};

var c2399 = {
  "chain": "BOMB",
  "chainId": 2399,
  "explorers": [{
    "name": "bombscan-testnet",
    "url": "https://explorer.bombchain-testnet.ankr.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://Qmc44uSjfdNHdcxPTgZAL8eZ8TLe4UmSHibcvKQFyGJxTB",
      "width": 1024,
      "height": 1024,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.bombchain-testnet.ankr.com/"],
  "icon": {
    "url": "ipfs://Qmc44uSjfdNHdcxPTgZAL8eZ8TLe4UmSHibcvKQFyGJxTB",
    "width": 1024,
    "height": 1024,
    "format": "png"
  },
  "infoURL": "https://www.bombmoney.com",
  "name": "BOMB Chain Testnet",
  "nativeCurrency": {
    "name": "BOMB Token",
    "symbol": "tBOMB",
    "decimals": 18
  },
  "networkId": 2399,
  "rpc": ["https://2399.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://bombchain-testnet.ankr.com/bas_full_rpc_1"],
  "shortName": "bombt",
  "slip44": 1,
  "slug": "bomb-chain-testnet",
  "testnet": true
};

var c2400 = {
  "chain": "TCG Verse",
  "chainId": 2400,
  "explorers": [{
    "name": "TCG Verse Explorer",
    "url": "https://explorer.tcgverse.xyz",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreidg4wpewve5mdxrofneqblydkrjl3oevtgpdf3fk3z3vjqam6ocoe",
    "width": 350,
    "height": 350,
    "format": "png"
  },
  "infoURL": "https://tcgverse.xyz/",
  "name": "TCG Verse Mainnet",
  "nativeCurrency": {
    "name": "OAS",
    "symbol": "OAS",
    "decimals": 18
  },
  "networkId": 2400,
  "parent": {
    "type": "L2",
    "chain": "eip155-248"
  },
  "rpc": ["https://2400.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.tcgverse.xyz"],
  "shortName": "TCGV",
  "slug": "tcg-verse",
  "testnet": false
};

var c2410 = {
  "chain": "Karak",
  "chainId": 2410,
  "explorers": [{
    "name": "Karak Mainnet Explorer",
    "url": "https://explorer.karak.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRvHRuhfQgDRyGgt6vCoHqjZW2Dir7siowYnBpR5BRSej",
    "width": 1080,
    "height": 1080,
    "format": "png"
  },
  "infoURL": "https://karak.network",
  "name": "Karak Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 2410,
  "parent": {
    "type": "L2",
    "chain": "eip155-1"
  },
  "rpc": ["https://2410.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.karak.network"],
  "shortName": "karak-mainnet",
  "slug": "karak",
  "testnet": false
};

var c2415 = {
  "chain": "XODEX",
  "chainId": 2415,
  "explorers": [{
    "name": "XODEX Explorer",
    "url": "https://explorer.xo-dex.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmXt49jPfHUmDF4n8TF7ks6txiPztx6qUHanWmHnCoEAhW",
      "width": 256,
      "height": 256,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmXt49jPfHUmDF4n8TF7ks6txiPztx6qUHanWmHnCoEAhW",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://xo-dex.com",
  "name": "XODEX",
  "nativeCurrency": {
    "name": "XODEX Native Token",
    "symbol": "XODEX",
    "decimals": 18
  },
  "networkId": 10,
  "rpc": ["https://2415.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.xo-dex.com/rpc", "https://xo-dex.io"],
  "shortName": "xodex",
  "slug": "xodex",
  "testnet": false
};

var c2425 = {
  "chain": "KOL",
  "chainId": 2425,
  "explorers": [{
    "name": "King Of Legends Devnet Explorer",
    "url": "https://devnet.kingscan.org",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmTZFXhYJboYE9fbaeje12iTF3QPLn6xgyFgrDVe2isDBH",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmTZFXhYJboYE9fbaeje12iTF3QPLn6xgyFgrDVe2isDBH",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://kingoflegends.net/",
  "name": "King Of Legends Devnet",
  "nativeCurrency": {
    "name": "King Of Legends",
    "symbol": "KOL",
    "decimals": 18
  },
  "networkId": 2425,
  "rpc": ["https://2425.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-devnet.kinggamer.org/"],
  "shortName": "kol",
  "slip44": 1,
  "slug": "king-of-legends-devnet",
  "testnet": false,
  "title": "King Of Legends Devnet"
};

var c2442 = {
  "chain": "Polygon",
  "chainId": 2442,
  "explorers": [{
    "name": "polygonscan",
    "url": "https://cardona-zkevm.polygonscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNmJZkQgx9RcFLS3rvxQTVYcPfyAFPr667keHTUxB9PDv",
    "width": 122,
    "height": 135,
    "format": "png"
  },
  "infoURL": "https://polygon.technology/polygon-zkevm",
  "name": "Polygon zkEVM Cardona Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 2442,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge-ui.cardona.zkevm-rpc.com"
    }]
  },
  "rpc": ["https://2442.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.cardona.zkevm-rpc.com"],
  "shortName": "zkevm-testnet-cardona",
  "slug": "polygon-zkevm-cardona-testnet",
  "testnet": true,
  "title": "Polygon zkEVM Cardona Testnet"
};

var c2458 = {
  "chain": "HYBRID",
  "chainId": 2458,
  "explorers": [{
    "name": "Hybrid Chain Explorer Testnet",
    "url": "https://testnet.hybridscan.ai",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmQDNdhPvCrrijEKC3G9Px5if2CHgdxq7Q2Pg66cy9xwbF",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet-testnet.hybridchain.ai"],
  "icon": {
    "url": "ipfs://QmQDNdhPvCrrijEKC3G9Px5if2CHgdxq7Q2Pg66cy9xwbF",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://hybridchain.ai",
  "name": "Hybrid Chain Network Testnet",
  "nativeCurrency": {
    "name": "Hybrid Chain Native Token",
    "symbol": "tHRC",
    "decimals": 18
  },
  "networkId": 2458,
  "rpc": ["https://2458.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.hybridchain.ai/"],
  "shortName": "thrc",
  "slip44": 1,
  "slug": "hybrid-chain-network-testnet",
  "testnet": true
};

var c2468 = {
  "chain": "HYBRID",
  "chainId": 2468,
  "explorers": [{
    "name": "Hybrid Chain Explorer Mainnet",
    "url": "https://hybridscan.ai",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmQDNdhPvCrrijEKC3G9Px5if2CHgdxq7Q2Pg66cy9xwbF",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet-testnet.hybridchain.ai"],
  "icon": {
    "url": "ipfs://QmQDNdhPvCrrijEKC3G9Px5if2CHgdxq7Q2Pg66cy9xwbF",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://hybridchain.ai",
  "name": "Hybrid Chain Network Mainnet",
  "nativeCurrency": {
    "name": "Hybrid Chain Native Token",
    "symbol": "HRC",
    "decimals": 18
  },
  "networkId": 2468,
  "rpc": ["https://2468.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://coredata-mainnet.hybridchain.ai/", "https://rpc-mainnet.hybridchain.ai"],
  "shortName": "hrc",
  "slug": "hybrid-chain-network",
  "testnet": true
};

var c2484 = {
  "chain": "u2u",
  "chainId": 2484,
  "explorers": [{
    "name": "U2U Explorer",
    "url": "https://testnet.u2uscan.xyz",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmcW64RgqQVHnNbVFyfaMNKt7dJvFqEbfEHZmeyeK8dpEa",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.uniultra.xyz"],
  "icon": {
    "url": "ipfs://QmcW64RgqQVHnNbVFyfaMNKt7dJvFqEbfEHZmeyeK8dpEa",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://uniultra.xyz",
  "name": "Unicorn Ultra Nebulas Testnet",
  "nativeCurrency": {
    "name": "Unicorn Ultra Nebulas Testnet",
    "symbol": "U2U",
    "decimals": 18
  },
  "networkId": 2484,
  "rpc": ["https://2484.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-nebulas-testnet.uniultra.xyz"],
  "shortName": "u2u_nebulas",
  "slip44": 1,
  "slug": "unicorn-ultra-nebulas-testnet",
  "testnet": true
};

var c2511 = {
  "chain": "Karak",
  "chainId": 2511,
  "explorers": [{
    "name": "Karak Goerli Explorer",
    "url": "https://goerli.scan.karak.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRvHRuhfQgDRyGgt6vCoHqjZW2Dir7siowYnBpR5BRSej",
    "width": 1080,
    "height": 1080,
    "format": "png"
  },
  "infoURL": "https://karak.network",
  "name": "Karak Goerli",
  "nativeCurrency": {
    "name": "Karak",
    "symbol": "KRK",
    "decimals": 18
  },
  "networkId": 2511,
  "parent": {
    "type": "L2",
    "chain": "eip155-5"
  },
  "rpc": ["https://2511.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://goerli.node1.karak.network"],
  "shortName": "karak-goerli",
  "slug": "karak-goerli",
  "status": "deprecated",
  "testnet": false
};

var c2522 = {
  "chain": "FRAX",
  "chainId": 2522,
  "explorers": [{
    "name": "fraxscan",
    "url": "https://holesky.fraxscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmQLJk5G7zF8ZDxSxkRcpHqEqcifrJEhGmEKC6zwyPXWAw/fraxchain.png",
    "width": 512,
    "height": 512,
    "format": "PNG"
  },
  "infoURL": "https://testnet.frax.com",
  "name": "Fraxtal Testnet",
  "nativeCurrency": {
    "name": "Frax Ether",
    "symbol": "frxETH",
    "decimals": 18
  },
  "networkId": 2522,
  "redFlags": [],
  "rpc": ["https://2522.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.frax.com"],
  "shortName": "fraxtal-testnet",
  "slip44": 1,
  "slug": "fraxtal-testnet",
  "status": "active",
  "testnet": true
};

var c2525 = {
  "chain": "inEVM",
  "chainId": 2525,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmU9KU1qgReJR7vyVxN5zwWB3nkhSs658ViArUjT7GCh4r",
    "width": 2000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://inevm.com",
  "name": "inEVM Mainnet",
  "nativeCurrency": {
    "name": "Injective",
    "symbol": "INJ",
    "decimals": 18
  },
  "networkId": 2525,
  "rpc": ["https://2525.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.rpc.inevm.com/http"],
  "shortName": "inevm",
  "slug": "inevm",
  "status": "active",
  "testnet": false
};

var c2559 = {
  "chain": "Kortho Chain",
  "chainId": 2559,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.kortho.io/",
  "name": "Kortho Mainnet",
  "nativeCurrency": {
    "name": "KorthoChain",
    "symbol": "KTO",
    "decimals": 11
  },
  "networkId": 2559,
  "rpc": ["https://2559.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://www.kortho-chain.com"],
  "shortName": "ktoc",
  "slug": "kortho",
  "testnet": false
};

var c2569 = {
  "chain": "TPC",
  "chainId": 2569,
  "explorers": [{
    "name": "tpcscan",
    "url": "https://tpcscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmQyTyJUnhD1dca35Vyj96pm3v3Xyw8xbG9m8HXHw3k2zR",
      "width": 578,
      "height": 701,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQyTyJUnhD1dca35Vyj96pm3v3Xyw8xbG9m8HXHw3k2zR",
    "width": 578,
    "height": 701,
    "format": "svg"
  },
  "infoURL": "https://techpay.io/",
  "name": "TechPay Mainnet",
  "nativeCurrency": {
    "name": "TechPay",
    "symbol": "TPC",
    "decimals": 18
  },
  "networkId": 2569,
  "rpc": ["https://2569.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.techpay.io/"],
  "shortName": "tpc",
  "slug": "techpay",
  "testnet": false
};

var c2606 = {
  "chain": "CRC",
  "chainId": 2606,
  "explorers": [{
    "name": "Lite Explorer",
    "url": "https://ethereum-pocr.github.io/explorer/pocrnet",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRLwpq47tyEd3rfK4tKRhbTvyb3fc7PCutExnL1XAb37A",
      "width": 334,
      "height": 360,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRLwpq47tyEd3rfK4tKRhbTvyb3fc7PCutExnL1XAb37A",
    "width": 334,
    "height": 360,
    "format": "png"
  },
  "infoURL": "https://github.com/ethereum-pocr/pocrnet",
  "name": "PoCRNet",
  "nativeCurrency": {
    "name": "Climate awaReness Coin",
    "symbol": "CRC",
    "decimals": 18
  },
  "networkId": 2606,
  "rpc": ["https://2606.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://pocrnet.westeurope.cloudapp.azure.com/http", "wss://pocrnet.westeurope.cloudapp.azure.com/ws"],
  "shortName": "pocrnet",
  "slug": "pocrnet",
  "status": "active",
  "testnet": false,
  "title": "Proof of Climate awaReness mainnet"
};

var c2611 = {
  "chain": "REDLC",
  "chainId": 2611,
  "explorers": [{
    "name": "REDLC Explorer",
    "url": "https://redlightscan.finance",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://redlight.finance/",
  "name": "Redlight Chain Mainnet",
  "nativeCurrency": {
    "name": "Redlight Coin",
    "symbol": "REDLC",
    "decimals": 18
  },
  "networkId": 2611,
  "rpc": ["https://2611.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dataseed2.redlightscan.finance"],
  "shortName": "REDLC",
  "slug": "redlight-chain",
  "testnet": false
};

var c2612 = {
  "chain": "EZC",
  "chainId": 2612,
  "explorers": [{
    "name": "ezchain",
    "url": "https://cchain-explorer.ezchain.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPKJbYCFjGmY9X2cA4b9YQjWYHQncmKnFtKyQh9rHkFTb",
    "width": 146,
    "height": 48,
    "format": "png"
  },
  "infoURL": "https://ezchain.com",
  "name": "EZChain C-Chain Mainnet",
  "nativeCurrency": {
    "name": "EZChain",
    "symbol": "EZC",
    "decimals": 18
  },
  "networkId": 2612,
  "rpc": ["https://2612.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.ezchain.com/ext/bc/C/rpc"],
  "shortName": "EZChain",
  "slug": "ezchain-c-chain",
  "testnet": false
};

var c2613 = {
  "chain": "EZC",
  "chainId": 2613,
  "explorers": [{
    "name": "ezchain",
    "url": "https://testnet-cchain-explorer.ezchain.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://testnet-faucet.ezchain.com"],
  "icon": {
    "url": "ipfs://QmPKJbYCFjGmY9X2cA4b9YQjWYHQncmKnFtKyQh9rHkFTb",
    "width": 146,
    "height": 48,
    "format": "png"
  },
  "infoURL": "https://ezchain.com",
  "name": "EZChain C-Chain Testnet",
  "nativeCurrency": {
    "name": "EZChain",
    "symbol": "EZC",
    "decimals": 18
  },
  "networkId": 2613,
  "rpc": ["https://2613.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-api.ezchain.com/ext/bc/C/rpc"],
  "shortName": "Fuji-EZChain",
  "slip44": 1,
  "slug": "ezchain-c-chain-testnet",
  "testnet": true
};

var c2625 = {
  "chain": "WBT",
  "chainId": 2625,
  "explorers": [{
    "name": "whitechain-testnet-explorer",
    "url": "https://testnet.whitechain.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://testnet.whitechain.io/faucet"],
  "icon": {
    "url": "ipfs://QmNeELax6vjkR9WZVmtggk8cam9xHVABZ4WvQyqkGCJ5qf",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://whitechain.io",
  "name": "Whitechain Testnet",
  "nativeCurrency": {
    "name": "WhiteBIT Coin",
    "symbol": "WBT",
    "decimals": 18
  },
  "networkId": 2625,
  "rpc": ["https://2625.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.whitechain.io"],
  "shortName": "twbt",
  "slip44": 1,
  "slug": "whitechain-testnet",
  "testnet": true
};

var c2662 = {
  "chain": "ETH",
  "chainId": 2662,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmTYgeN1E3GGXnMF2oa43v2ehX2bYqrHPrGQ9xbBMXy1we",
    "width": 1280,
    "height": 1280,
    "format": "png"
  },
  "infoURL": "https://apexlayer.xyz/",
  "name": "APEX",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 2662,
  "parent": {
    "type": "L2",
    "chain": "eip155-1"
  },
  "rpc": [],
  "shortName": "apexmainnet",
  "slug": "apex",
  "status": "incubating",
  "testnet": false
};

var c2710 = {
  "chain": "ETH",
  "chainId": 2710,
  "explorers": [{
    "name": "Morph Testnet Explorer",
    "url": "https://explorer-testnet.morphl2.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://morphl2.io",
  "name": "Morph Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 2710,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge-testnet.morphl2.io"
    }]
  },
  "rpc": ["https://2710.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.morphl2.io"],
  "shortName": "tmorph",
  "slip44": 1,
  "slug": "morph-testnet",
  "testnet": true
};

var c2718 = {
  "chain": "K-LAOS",
  "chainId": 2718,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscout.klaos.laosfoundation.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmW26eoxJeyUfikZ4DUT1Gfk78sBkvydEo8QzHa1BXjUUL",
      "width": 580,
      "height": 580,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmW26eoxJeyUfikZ4DUT1Gfk78sBkvydEo8QzHa1BXjUUL",
    "width": 580,
    "height": 580,
    "format": "png"
  },
  "infoURL": "https://www.laosfoundation.io/",
  "name": "K-LAOS",
  "nativeCurrency": {
    "name": "KLAOS",
    "symbol": "KLAOS",
    "decimals": 18
  },
  "networkId": 2718,
  "rpc": ["https://2718.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.klaos.laosfoundation.io", "wss://rpc.klaos.laosfoundation.io"],
  "shortName": "k-laos",
  "slug": "k-laos",
  "testnet": false,
  "title": "K-LAOS: LAOS on Kusama"
};

var c2730 = {
  "chain": "XR Sepolia",
  "chainId": 2730,
  "explorers": [{
    "name": "blockscout",
    "url": "https://xr-sepolia-testnet.explorer.caldera.xyz/",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRdBsZF2sgWitedT5qAtBZwrYwY1xecHN9u5fgddqA1eL/xr-sepolia.png",
      "width": 300,
      "height": 300,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmRdBsZF2sgWitedT5qAtBZwrYwY1xecHN9u5fgddqA1eL/xr-sepolia.png",
    "width": 300,
    "height": 300,
    "format": "png"
  },
  "infoURL": "https://xr-one.gitbook.io",
  "name": "XR Sepolia",
  "nativeCurrency": {
    "name": "tXR",
    "symbol": "tXR",
    "decimals": 18
  },
  "networkId": 2730,
  "parent": {
    "type": "L2",
    "chain": "eip155-421614",
    "bridges": []
  },
  "redFlags": [],
  "rpc": ["https://2730.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://xr-sepolia-testnet.rpc.caldera.xyz/http"],
  "shortName": "xr-sepolia",
  "slug": "xr-sepolia",
  "testnet": true
};

var c2731 = {
  "chain": "Elizabeth",
  "chainId": 2731,
  "explorers": [{
    "name": "Time Network Explorer",
    "url": "https://testnet-scanner.timenetwork.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreidoudwo453gr3hoxpreleguga73rm55yl6vuedxrfmhknljppqbiu",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreidoudwo453gr3hoxpreleguga73rm55yl6vuedxrfmhknljppqbiu",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://whitepaper.anttime.net/overview/anttime",
  "name": "Elizabeth Testnet",
  "nativeCurrency": {
    "name": "TIME",
    "symbol": "TIME",
    "decimals": 18
  },
  "networkId": 2731,
  "rpc": ["https://2731.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.timenetwork.io"],
  "shortName": "TIME",
  "slug": "elizabeth-testnet",
  "testnet": true
};

var c2828 = {
  "chain": "Avalanche",
  "chainId": 2828,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Cohan's Testnet 1",
  "nativeCurrency": {
    "name": "Cohan's Testnet 1 Token",
    "symbol": "FQC",
    "decimals": 18
  },
  "networkId": 2828,
  "redFlags": [],
  "rpc": ["https://2828.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/a6eec829-2c08-4264-b0d7-6d393997e9a6"],
  "shortName": "Cohan's Testnet 1",
  "slug": "cohan-s-testnet-1",
  "testnet": true
};

var c2888 = {
  "chain": "ETH",
  "chainId": 2888,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://testnet.bobascan.com",
    "standard": "none"
  }],
  "faucets": [],
  "features": [],
  "infoURL": "https://boba.network",
  "name": "Boba Network Goerli Testnet",
  "nativeCurrency": {
    "name": "Goerli Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 2888,
  "parent": {
    "type": "L2",
    "chain": "eip155-5",
    "bridges": [{
      "url": "https://gateway.boba.network"
    }]
  },
  "redFlags": [],
  "rpc": ["https://2888.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://goerli.boba.network/", "wss://wss.goerli.boba.network/"],
  "shortName": "BobaGoerli",
  "slip44": 1,
  "slug": "boba-network-goerli-testnet",
  "status": "deprecated",
  "testnet": true
};

var c2907 = {
  "chain": "ELUX",
  "chainId": 2907,
  "explorers": [{
    "name": "blockscout",
    "url": "https://eluxscan.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQC7LzzFj8kL71a1MXRgn3TSeRrgF1tTuVEzvWx5cQjv1",
    "width": 114,
    "height": 132,
    "format": "png"
  },
  "infoURL": "https://eluxscan.com",
  "name": "Elux Chain",
  "nativeCurrency": {
    "name": "Elux Chain",
    "symbol": "ELUX",
    "decimals": 18
  },
  "networkId": 2907,
  "rpc": ["https://2907.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.eluxscan.com"],
  "shortName": "ELUX",
  "slug": "elux-chain",
  "testnet": false
};

var c2911 = {
  "chain": "2911",
  "chainId": 2911,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.hychain.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmcSJmAfk3iay6uCGJxgUPd9pTsRxbtF4BrNnC5txE9cg8",
      "width": 400,
      "height": 400,
      "format": "jpg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmcSJmAfk3iay6uCGJxgUPd9pTsRxbtF4BrNnC5txE9cg8",
    "width": 400,
    "height": 400,
    "format": "jpg"
  },
  "infoURL": "https://www.hychain.com",
  "name": "HYCHAIN",
  "nativeCurrency": {
    "name": "TOPIA",
    "symbol": "TOPIA",
    "decimals": 18
  },
  "networkId": 2911,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.hychain.com"
    }]
  },
  "redFlags": [],
  "rpc": ["https://2911.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.hychain.com/http"],
  "shortName": "hychain",
  "slug": "hychain",
  "testnet": true
};

var c2941 = {
  "chain": "XEN",
  "chainId": 2941,
  "explorers": [{
    "name": "Xenon testnet Explorer",
    "url": "https://testnet.xenonchain.com",
    "standard": "none"
  }],
  "faucets": ["https://xfaucet.xenonchain.com"],
  "icon": {
    "url": "ipfs://QmNSoxDnj6MV8mPJWiuzzLbATcbk5op11NTwMTdzcr272F",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://xenonchain.com",
  "name": "Xenon Chain Testnet",
  "nativeCurrency": {
    "name": "Xenon Testnet",
    "symbol": "tXEN",
    "decimals": 18
  },
  "networkId": 2941,
  "rpc": ["https://2941.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-chain.xenonchain.com/", "https://testnet-dev.xenonchain.com/"],
  "shortName": "xenon",
  "slip44": 1,
  "slug": "xenon-chain-testnet",
  "testnet": true
};

var c2999 = {
  "chain": "BTY",
  "chainId": 2999,
  "explorers": [{
    "name": "BitYuan Block Chain Explorer",
    "url": "https://mainnet.bityuan.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmUmJVof2m5e4HUXb3GmijWUFsLUNhrQiwwQG3CqcXEtHt",
    "width": 91,
    "height": 24,
    "format": "png"
  },
  "infoURL": "https://www.bityuan.com",
  "name": "BitYuan Mainnet",
  "nativeCurrency": {
    "name": "BTY",
    "symbol": "BTY",
    "decimals": 18
  },
  "networkId": 2999,
  "rpc": ["https://2999.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.bityuan.com/eth"],
  "shortName": "bty",
  "slug": "bityuan",
  "testnet": false
};

var c3000 = {
  "chain": "CENNZnet",
  "chainId": 3000,
  "explorers": [],
  "faucets": ["https://app-faucet.centrality.me"],
  "icon": {
    "url": "ipfs://QmWhNm7tTi6SYbiumULDRk956hxgqaZSX77vcxBNn8fvnw",
    "width": 112,
    "height": 112,
    "format": "svg"
  },
  "infoURL": "https://cennz.net",
  "name": "CENNZnet Rata",
  "nativeCurrency": {
    "name": "CPAY",
    "symbol": "CPAY",
    "decimals": 18
  },
  "networkId": 3000,
  "rpc": [],
  "shortName": "cennz-r",
  "slug": "cennznet-rata",
  "testnet": false
};

var c3001 = {
  "chain": "CENNZnet",
  "chainId": 3001,
  "explorers": [{
    "name": "UNcover",
    "url": "https://www.uncoverexplorer.com/?network=Nikau",
    "standard": "none"
  }],
  "faucets": ["https://app-faucet.centrality.me"],
  "icon": {
    "url": "ipfs://QmWhNm7tTi6SYbiumULDRk956hxgqaZSX77vcxBNn8fvnw",
    "width": 112,
    "height": 112,
    "format": "svg"
  },
  "infoURL": "https://cennz.net",
  "name": "CENNZnet Nikau",
  "nativeCurrency": {
    "name": "CPAY",
    "symbol": "CPAY",
    "decimals": 18
  },
  "networkId": 3001,
  "rpc": ["https://3001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://nikau.centrality.me/public"],
  "shortName": "cennz-n",
  "slug": "cennznet-nikau",
  "testnet": false
};

var c3003 = {
  "chain": "CAU",
  "chainId": 3003,
  "explorers": [{
    "name": "canxium explorer",
    "url": "https://explorer.canxium.org",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmXHSbtVNCJVfe2CvRH7njdyf2SrX5u5bNTfvhqjLeFN2A",
    "width": 938,
    "height": 938,
    "format": "png"
  },
  "infoURL": "https://canxium.org",
  "name": "Canxium Mainnet",
  "nativeCurrency": {
    "name": "Canxium",
    "symbol": "CAU",
    "decimals": 18
  },
  "networkId": 3003,
  "rpc": ["https://3003.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.canxium.org"],
  "shortName": "cau",
  "slug": "canxium",
  "testnet": false
};

var c3011 = {
  "chain": "3ULL",
  "chainId": 3011,
  "explorers": [{
    "name": "PLAYA3ULL GAMES Explorer",
    "url": "https://3011.routescan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreib62bv2d65d7nidojgpkgatrt7smee2l4ov6i6ozqhpfaqsonxku4",
      "width": 512,
      "height": 443,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreib62bv2d65d7nidojgpkgatrt7smee2l4ov6i6ozqhpfaqsonxku4",
    "width": 512,
    "height": 443,
    "format": "png"
  },
  "infoURL": "https://playa3ull.games",
  "name": "PLAYA3ULL GAMES",
  "nativeCurrency": {
    "name": "3ULL",
    "symbol": "3ULL",
    "decimals": 18
  },
  "networkId": 3011,
  "rpc": ["https://3011.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.mainnet.playa3ull.games"],
  "shortName": "3ULL",
  "slug": "playa3ull-games",
  "testnet": false
};

var c3031 = {
  "chain": "ORL",
  "chainId": 3031,
  "explorers": [{
    "name": "Orlando (ORL) Explorer",
    "url": "https://orlscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmNsuuBBTHErnuFDcdyzaY8CKoVJtobsLJx2WQjaPjcp7g",
      "width": 512,
      "height": 528,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNsuuBBTHErnuFDcdyzaY8CKoVJtobsLJx2WQjaPjcp7g",
    "width": 512,
    "height": 528,
    "format": "png"
  },
  "infoURL": "https://orlchain.com",
  "name": "Orlando Chain",
  "nativeCurrency": {
    "name": "Orlando",
    "symbol": "ORL",
    "decimals": 18
  },
  "networkId": 3031,
  "rpc": ["https://3031.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.orlchain.com"],
  "shortName": "ORL",
  "slug": "orlando-chain",
  "testnet": true
};

var c3036 = {
  "chain": "Avalanche",
  "chainId": 3036,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Will's Testnet",
  "nativeCurrency": {
    "name": "Will's Testnet Token",
    "symbol": "QED",
    "decimals": 18
  },
  "networkId": 3036,
  "redFlags": [],
  "rpc": ["https://3036.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Will's Testnet",
  "slug": "will-s-testnet",
  "testnet": true
};

var c3068 = {
  "chain": "BFC",
  "chainId": 3068,
  "explorers": [{
    "name": "explorer-thebifrost",
    "url": "https://explorer.mainnet.bifrostnetwork.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYxniqbiFD7nXBNjN8boUhoXYEAW23YquArD2Rnkq8WHS",
    "width": 480,
    "height": 480,
    "format": "png"
  },
  "infoURL": "https://bifrostnetwork.com",
  "name": "Bifrost Mainnet",
  "nativeCurrency": {
    "name": "Bifrost",
    "symbol": "BFC",
    "decimals": 18
  },
  "networkId": 3068,
  "rpc": ["https://3068.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://public-01.mainnet.bifrostnetwork.com/rpc", "https://public-02.mainnet.bifrostnetwork.com/rpc"],
  "shortName": "bfc",
  "slug": "bifrost",
  "testnet": false,
  "title": "Bifrost Network Mainnet"
};

var c3084 = {
  "chain": "Avalanche",
  "chainId": 3084,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "XL Network Testnet",
  "nativeCurrency": {
    "name": "XL Network Testnet Token",
    "symbol": "XLN",
    "decimals": 18
  },
  "networkId": 3084,
  "redFlags": [],
  "rpc": ["https://3084.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/xlnetworkt/testnet/rpc"],
  "shortName": "XL Network Testnet",
  "slug": "xl-network-testnet",
  "testnet": true
};

var c3100 = {
  "chain": "EVMCC",
  "chainId": 3100,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://immu3.io",
  "name": "Immu3 EVM",
  "nativeCurrency": {
    "name": "IMMU",
    "symbol": "IMMU",
    "decimals": 18
  },
  "networkId": 3100,
  "rpc": ["https://3100.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://fraa-dancebox-3043-rpc.a.dancebox.tanssi.network", "wss://fraa-dancebox-3043-rpc.a.dancebox.tanssi.network"],
  "shortName": "Immu3",
  "slug": "immu3-evm",
  "testnet": false
};

var c3102 = {
  "chain": "VFIEVMCC",
  "chainId": 3102,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://vulture.finance",
  "name": "Vulture EVM Beta",
  "nativeCurrency": {
    "name": "VFI",
    "symbol": "VFI",
    "decimals": 18
  },
  "networkId": 3102,
  "rpc": ["https://3102.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://fraa-dancebox-3050-rpc.a.dancebox.tanssi.network", "wss://fraa-dancebox-3050-rpc.a.dancebox.tanssi.network"],
  "shortName": "VFI",
  "slug": "vulture-evm-beta",
  "testnet": false
};

var c3141 = {
  "chain": "FIL",
  "chainId": 3141,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmS9r9XQkMHVomWcSBNDkKkz9n87h9bH9ssabeiKZtANoU",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://filecoin.io",
  "name": "Filecoin - Hyperspace testnet",
  "nativeCurrency": {
    "name": "testnet filecoin",
    "symbol": "tFIL",
    "decimals": 18
  },
  "networkId": 3141,
  "rpc": [],
  "shortName": "filecoin-hyperspace",
  "slip44": 1,
  "slug": "filecoin-hyperspace-testnet",
  "status": "deprecated",
  "testnet": true
};

var c3269 = {
  "chain": "DUBX",
  "chainId": 3269,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://arabianchain.org",
  "name": "Dubxcoin network",
  "nativeCurrency": {
    "name": "Dubxcoin mainnet",
    "symbol": "DUBX",
    "decimals": 18
  },
  "networkId": 3269,
  "rpc": ["https://3269.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpcmain.arabianchain.org"],
  "shortName": "dubx",
  "slug": "dubxcoin-network",
  "testnet": false
};

var c3270 = {
  "chain": "TESTDUBX",
  "chainId": 3270,
  "explorers": [],
  "faucets": ["https://faucet.arabianchain.org/"],
  "infoURL": "https://arabianchain.org",
  "name": "Dubxcoin testnet",
  "nativeCurrency": {
    "name": "Dubxcoin testnet",
    "symbol": "TDUBX",
    "decimals": 18
  },
  "networkId": 3270,
  "rpc": ["https://3270.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpctestnet.arabianchain.org"],
  "shortName": "testdubx",
  "slip44": 1,
  "slug": "dubxcoin-testnet",
  "testnet": true
};

var c3306 = {
  "chain": "Debounce Network",
  "chainId": 3306,
  "explorers": [{
    "name": "Debounce Devnet Explorer",
    "url": "https://explorer.debounce.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeib5q4hez37s7b2fx4hqt2q4ji2tuudxjhfdgnp6q3d5mqm6wsxdfq",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://debounce.network",
  "name": "Debounce Subnet Testnet",
  "nativeCurrency": {
    "name": "Debounce Network",
    "symbol": "DB",
    "decimals": 18
  },
  "networkId": 3306,
  "rpc": ["https://3306.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dev-rpc.debounce.network"],
  "shortName": "debounce-devnet",
  "slip44": 1,
  "slug": "debounce-subnet-testnet",
  "testnet": true
};

var c3331 = {
  "chain": "Beach",
  "chainId": 3331,
  "explorers": [],
  "faucets": ["https://faucet.zcore.cash"],
  "icon": {
    "url": "ipfs://QmQnXu13ym8W1VA3QxocaNVXGAuEPmamSCkS7bBscVk1f4",
    "width": 1050,
    "height": 1050,
    "format": "png"
  },
  "infoURL": "https://zcore.cash",
  "name": "ZCore Testnet",
  "nativeCurrency": {
    "name": "ZCore",
    "symbol": "ZCR",
    "decimals": 18
  },
  "networkId": 3331,
  "rpc": ["https://3331.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.zcore.cash"],
  "shortName": "zcrbeach",
  "slip44": 1,
  "slug": "zcore-testnet",
  "testnet": true
};

var c3333 = {
  "chain": "Web3Q",
  "chainId": 3333,
  "explorers": [{
    "name": "w3q-testnet",
    "url": "https://explorer.testnet.web3q.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://testnet.web3q.io/home.w3q/",
  "name": "Web3Q Testnet",
  "nativeCurrency": {
    "name": "Web3Q",
    "symbol": "W3Q",
    "decimals": 18
  },
  "networkId": 3333,
  "rpc": ["https://3333.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.web3q.io:8545"],
  "shortName": "w3q-t",
  "slip44": 1,
  "slug": "web3q-testnet",
  "testnet": true
};

var c3334 = {
  "chain": "Web3Q",
  "chainId": 3334,
  "explorers": [{
    "name": "w3q-galileo",
    "url": "https://explorer.galileo.web3q.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://galileo.web3q.io/home.w3q/",
  "name": "Web3Q Galileo",
  "nativeCurrency": {
    "name": "Web3Q",
    "symbol": "W3Q",
    "decimals": 18
  },
  "networkId": 3334,
  "rpc": ["https://3334.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://galileo.web3q.io:8545"],
  "shortName": "w3q-g",
  "slug": "web3q-galileo",
  "testnet": false
};

var c3400 = {
  "chain": "PRB",
  "chainId": 3400,
  "explorers": [{
    "name": "Paribu Net Explorer",
    "url": "https://explorer.paribu.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVgc77jYo2zrxQjhYwT4KzvSrSZ1DBJraJVX57xAvP8MD",
    "width": 2362,
    "height": 2362,
    "format": "png"
  },
  "infoURL": "https://net.paribu.com",
  "name": "Paribu Net Mainnet",
  "nativeCurrency": {
    "name": "PRB",
    "symbol": "PRB",
    "decimals": 18
  },
  "networkId": 3400,
  "rpc": ["https://3400.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.paribu.network"],
  "shortName": "prb",
  "slug": "paribu-net",
  "testnet": false
};

var c3434 = {
  "chain": "SCAI",
  "chainId": 3434,
  "explorers": [{
    "name": "SecureChain",
    "url": "https://testnet.securechain.ai",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.securechain.ai"],
  "icon": {
    "url": "ipfs://Qme2Z8VFYjhHGfLQPBnfseNpEdRfmTDy7VXqrdH4AHETJf",
    "width": 150,
    "height": 150,
    "format": "png"
  },
  "infoURL": "https://securechain.ai",
  "name": "SecureChain Testnet",
  "nativeCurrency": {
    "name": "SCAI",
    "symbol": "SCAI",
    "decimals": 18
  },
  "networkId": 3434,
  "rpc": ["https://3434.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.securechain.ai"],
  "shortName": "SCAIt",
  "slip44": 1,
  "slug": "securechain-testnet",
  "testnet": true
};

var c3454 = {
  "chain": "Avalanche",
  "chainId": 3454,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Masa",
  "nativeCurrency": {
    "name": "Masa Token",
    "symbol": "MASA",
    "decimals": 18
  },
  "networkId": 3454,
  "redFlags": [],
  "rpc": ["https://3454.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/masa/mainnet/rpc"],
  "shortName": "Masa",
  "slug": "masa",
  "testnet": false
};

var c3500 = {
  "chain": "PRB",
  "chainId": 3500,
  "explorers": [{
    "name": "Paribu Net Testnet Explorer",
    "url": "https://testnet.paribuscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.paribuscan.com"],
  "icon": {
    "url": "ipfs://QmVgc77jYo2zrxQjhYwT4KzvSrSZ1DBJraJVX57xAvP8MD",
    "width": 2362,
    "height": 2362,
    "format": "png"
  },
  "infoURL": "https://net.paribu.com",
  "name": "Paribu Net Testnet",
  "nativeCurrency": {
    "name": "PRB",
    "symbol": "PRB",
    "decimals": 18
  },
  "networkId": 3500,
  "rpc": ["https://3500.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.paribuscan.com"],
  "shortName": "prbtestnet",
  "slip44": 1,
  "slug": "paribu-net-testnet",
  "testnet": true
};

var c3501 = {
  "chain": "JFIN",
  "chainId": 3501,
  "explorers": [{
    "name": "JFIN Chain Explorer",
    "url": "https://exp.jfinchain.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://jfinchain.com",
  "name": "JFIN Chain",
  "nativeCurrency": {
    "name": "JFIN Coin",
    "symbol": "JFIN",
    "decimals": 18
  },
  "networkId": 3501,
  "rpc": ["https://3501.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.jfinchain.com"],
  "shortName": "JFIN",
  "slug": "jfin-chain",
  "testnet": false
};

var c3601 = {
  "chain": "PandoProject",
  "chainId": 3601,
  "explorers": [{
    "name": "Pando Mainnet Explorer",
    "url": "https://explorer.pandoproject.org",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNduBtT5BNGDw7DjRwDvaZBb6gjxf46WD7BYhn4gauGc9",
    "width": 1000,
    "height": 1628,
    "format": "png"
  },
  "infoURL": "https://www.pandoproject.org/",
  "name": "PandoProject Mainnet",
  "nativeCurrency": {
    "name": "pando-token",
    "symbol": "PTX",
    "decimals": 18
  },
  "networkId": 3601,
  "rpc": ["https://3601.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eth-rpc-api.pandoproject.org/rpc"],
  "shortName": "pando-mainnet",
  "slug": "pandoproject",
  "testnet": false
};

var c3602 = {
  "chain": "PandoProject",
  "chainId": 3602,
  "explorers": [{
    "name": "Pando Testnet Explorer",
    "url": "https://testnet.explorer.pandoproject.org",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNduBtT5BNGDw7DjRwDvaZBb6gjxf46WD7BYhn4gauGc9",
    "width": 1000,
    "height": 1628,
    "format": "png"
  },
  "infoURL": "https://www.pandoproject.org/",
  "name": "PandoProject Testnet",
  "nativeCurrency": {
    "name": "pando-token",
    "symbol": "PTX",
    "decimals": 18
  },
  "networkId": 3602,
  "rpc": ["https://3602.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.ethrpc.pandoproject.org/rpc"],
  "shortName": "pando-testnet",
  "slip44": 1,
  "slug": "pandoproject-testnet",
  "testnet": true
};

var c3636 = {
  "chain": "BOTANIX",
  "chainId": 3636,
  "explorers": [{
    "name": "3xpl",
    "url": "https://3xpl.com/botanix",
    "standard": "EIP3091"
  }, {
    "name": "Blockscout",
    "url": "https://blockscout.botanixlabs.dev",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.botanixlabs.dev"],
  "icon": {
    "url": "ipfs://QmVE5s2pXiqdMnAcxhAmWkZYhpFB5CysypeLyPKzT4rGYe",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://botanixlabs.xyz",
  "name": "Botanix Testnet",
  "nativeCurrency": {
    "name": "Botanix",
    "symbol": "BTC",
    "decimals": 18
  },
  "networkId": 3636,
  "rpc": ["https://3636.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node.botanixlabs.dev"],
  "shortName": "BTNX",
  "slip44": 1,
  "slug": "botanix-testnet",
  "testnet": true
};

var c3637 = {
  "chain": "BTC",
  "chainId": 3637,
  "explorers": [{
    "name": "Botanix",
    "url": "https://btxtestchain.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.btxtestchain.com"],
  "icon": {
    "url": "ipfs://QmVE5s2pXiqdMnAcxhAmWkZYhpFB5CysypeLyPKzT4rGYe",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://btxtestchain.com",
  "name": "Botanix Mainnet",
  "nativeCurrency": {
    "name": "Botanix",
    "symbol": "BTC",
    "decimals": 18
  },
  "networkId": 3637,
  "rpc": ["https://3637.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.btxtestchain.com"],
  "shortName": "BTCm",
  "slug": "botanix",
  "testnet": true
};

var c3639 = {
  "chain": "iChain",
  "chainId": 3639,
  "explorers": [{
    "name": "iChainscan",
    "url": "https://ichainscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://islamicoin.finance",
  "name": "iChain Network",
  "nativeCurrency": {
    "name": "ISLAMICOIN",
    "symbol": "ISLAMI",
    "decimals": 18
  },
  "networkId": 3639,
  "rpc": ["https://3639.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.ichainscan.com"],
  "shortName": "ISLAMI",
  "slug": "ichain-network",
  "testnet": false
};

var c3666 = {
  "chain": "Jouleverse",
  "chainId": 3666,
  "explorers": [{
    "name": "jscan",
    "url": "https://jscan.jnsdao.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://jnsdao.com",
  "name": "Jouleverse Mainnet",
  "nativeCurrency": {
    "name": "J",
    "symbol": "J",
    "decimals": 18
  },
  "networkId": 3666,
  "rpc": ["https://3666.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.jnsdao.com:8503"],
  "shortName": "jouleverse",
  "slug": "jouleverse",
  "testnet": false
};

var c3690 = {
  "chain": "BTX",
  "chainId": 3690,
  "explorers": [{
    "name": "bittexscan",
    "url": "https://bittexscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://bittexscan.com",
  "name": "Bittex Mainnet",
  "nativeCurrency": {
    "name": "Bittex",
    "symbol": "BTX",
    "decimals": 18
  },
  "networkId": 3690,
  "rpc": ["https://3690.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc1.bittexscan.info", "https://rpc2.bittexscan.info"],
  "shortName": "btx",
  "slug": "bittex",
  "testnet": false
};

var c3693 = {
  "chain": "EMPIRE",
  "chainId": 3693,
  "explorers": [{
    "name": "Empire Explorer",
    "url": "https://explorer.empirenetwork.io",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.empirenetwork.io/",
  "name": "Empire Network",
  "nativeCurrency": {
    "name": "Empire",
    "symbol": "EMPIRE",
    "decimals": 18
  },
  "networkId": 3693,
  "rpc": ["https://3693.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.empirenetwork.io"],
  "shortName": "empire",
  "slug": "empire-network",
  "testnet": false
};

var c3698 = {
  "chain": "SPC",
  "chainId": 3698,
  "explorers": [{
    "name": "SenjePowers",
    "url": "https://testnet.senjepowersscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.senjepowersscan.com"],
  "icon": {
    "url": "ipfs://QmcpyTj4hUyHJZ2VmSdkXFpPpRcNKRP1VxMs7Cp1anymNy",
    "width": 504,
    "height": 495,
    "format": "png"
  },
  "infoURL": "https://senjepowersscan.com",
  "name": "SenjePowers Testnet",
  "nativeCurrency": {
    "name": "SenjePowers",
    "symbol": "SPC",
    "decimals": 18
  },
  "networkId": 3698,
  "rpc": ["https://3698.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.senjepowersscan.com"],
  "shortName": "SPCt",
  "slip44": 1,
  "slug": "senjepowers-testnet",
  "testnet": true
};

var c3699 = {
  "chain": "SPC",
  "chainId": 3699,
  "explorers": [{
    "name": "SenjePowers",
    "url": "https://senjepowersscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.senjepowersscan.com"],
  "icon": {
    "url": "ipfs://QmcpyTj4hUyHJZ2VmSdkXFpPpRcNKRP1VxMs7Cp1anymNy",
    "width": 504,
    "height": 495,
    "format": "png"
  },
  "infoURL": "https://senjepowersscan.com",
  "name": "SenjePowers Mainnet",
  "nativeCurrency": {
    "name": "SenjePowers",
    "symbol": "SPC",
    "decimals": 18
  },
  "networkId": 3699,
  "rpc": ["https://3699.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.senjepowersscan.com"],
  "shortName": "SPCm",
  "slug": "senjepowers",
  "testnet": false
};

var c3701 = {
  "chain": "XPLATest",
  "chainId": 3701,
  "explorers": [{
    "name": "XPLA Explorer",
    "url": "https://explorer.xpla.io",
    "standard": "none"
  }],
  "faucets": ["https://faucet.xpla.io"],
  "icon": {
    "url": "ipfs://Qmf4GoxfpeA5VGqu7KP5eyv1WKaCpNDbvMxq1MjQBwFWxq",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://xpla.io",
  "name": "Xpla Testnet",
  "nativeCurrency": {
    "name": "XPLA",
    "symbol": "XPLA",
    "decimals": 18
  },
  "networkId": 3701,
  "rpc": ["https://3701.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dimension-rpc.xpla.dev"],
  "shortName": "xplatest",
  "slip44": 1,
  "slug": "xpla-testnet-xplatest",
  "status": "deprecated",
  "testnet": true
};

var c3737 = {
  "chain": "Crossbell",
  "chainId": 3737,
  "explorers": [{
    "name": "Crossbell Explorer",
    "url": "https://scan.crossbell.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.crossbell.io"],
  "icon": {
    "url": "ipfs://QmS8zEetTb6pwdNpVjv5bz55BXiSMGP9BjTJmNcjcUT91t",
    "width": 408,
    "height": 408,
    "format": "svg"
  },
  "infoURL": "https://crossbell.io",
  "name": "Crossbell",
  "nativeCurrency": {
    "name": "Crossbell Token",
    "symbol": "CSB",
    "decimals": 18
  },
  "networkId": 3737,
  "rpc": ["https://3737.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.crossbell.io"],
  "shortName": "csb",
  "slug": "crossbell",
  "testnet": false
};

var c3776 = {
  "chain": "ETH",
  "chainId": 3776,
  "explorers": [{
    "name": "Blockscout Astar zkEVM explorer",
    "url": "https://astar-zkevm.explorer.startale.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmRySLe3su59dE5x5JPm2b1GeZfz6DR9qUzcbp3rt4SD3A",
    "width": 300,
    "height": 300,
    "format": "png"
  },
  "infoURL": "https://astar.network",
  "name": "Astar zkEVM",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 3776,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.gelato.network/bridge/astar-zkevm"
    }]
  },
  "redFlags": [],
  "rpc": ["https://3776.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.startale.com/astar-zkevm"],
  "shortName": "astarzk",
  "slug": "astar-zkevm",
  "testnet": false,
  "title": "Astar zkEVM Mainnet"
};

var c3797 = {
  "chain": "ALV",
  "chainId": 3797,
  "explorers": [{
    "name": "AlveyScan",
    "url": "https://alveyscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmTuY2Goyxpuy5GmA32EMYZBwxRcGsahiMFgfeBixSk7rb",
      "width": 2048,
      "height": 1538,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmTuY2Goyxpuy5GmA32EMYZBwxRcGsahiMFgfeBixSk7rb",
    "width": 2048,
    "height": 1538,
    "format": "png"
  },
  "infoURL": "https://alveychain.com/",
  "name": "AlveyChain Mainnet",
  "nativeCurrency": {
    "name": "AlveyCoin",
    "symbol": "ALV",
    "decimals": 18
  },
  "networkId": 3797,
  "rpc": ["https://3797.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://elves-core1.alvey.io", "https://elves-core2.alvey.io", "https://elves-core3.alvey.io"],
  "shortName": "alv",
  "slug": "alveychain",
  "testnet": false
};

var c3799 = {
  "chain": "Tangle Testnet",
  "chainId": 3799,
  "explorers": [{
    "name": "ttntscan",
    "url": "https://testnet-explorer.tangle.tools",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.tangle.tools"],
  "icon": {
    "url": "ipfs://QmbxMNBTeQgch8t9GpWdLiS2R3wPYCzVRaX5kCQ4o5QU3w",
    "width": 1600,
    "height": 1600,
    "format": "png"
  },
  "infoURL": "https://docs.tangle.tools",
  "name": "Tangle Testnet",
  "nativeCurrency": {
    "name": "Testnet Tangle Network Token",
    "symbol": "tTNT",
    "decimals": 18
  },
  "networkId": 3799,
  "rpc": ["https://3799.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.tangle.tools", "https://testnet-rpc-archive.tangle.tools", "wss://testnet-rpc.tangle.tools", "wss://testnet-rpc-archive.tangle.tools"],
  "shortName": "tTangle",
  "slug": "tangle-testnet",
  "testnet": true
};

var c3839 = {
  "chain": "3839",
  "chainId": 3839,
  "explorers": [{
    "name": "traderlands explorer",
    "url": "https://sepolia.arbiscan.io/",
    "standard": "standard",
    "icon": {
      "url": "ipfs://QmRQVgjLcoWAVTocuYegwumz8J8b2F3Le2WnQhwffRmWcg/traderlands%20logo.png",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmRQVgjLcoWAVTocuYegwumz8J8b2F3Le2WnQhwffRmWcg/traderlands%20logo.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://sepolia.arbiscan.io/",
  "name": "traderlands-sepolia",
  "nativeCurrency": {
    "name": "Traderlands",
    "symbol": "TRADE",
    "decimals": 18
  },
  "networkId": 3839,
  "redFlags": [],
  "rpc": ["https://3839.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://traderlands-sepolia.rpc.caldera.xyz/http"],
  "shortName": "Tradetest",
  "slug": "traderlands-sepolia",
  "testnet": true
};

var c3885 = {
  "chain": "Firechain",
  "chainId": 3885,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://docs.thefirechain.com/",
  "name": "Firechain zkEVM Ghostrider",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 3885,
  "rpc": ["https://3885.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-zkevm-ghostrider.thefirechain.com"],
  "shortName": "firechain-zkEVM-testnet",
  "slug": "firechain-zkevm-ghostrider",
  "testnet": true,
  "title": "Firechain zkEVM Testnet"
};

var c3888 = {
  "chain": "KLC",
  "chainId": 3888,
  "explorers": [{
    "name": "KalyScan",
    "url": "https://kalyscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmUaXcPewLuQtY5a7xPTzJyVdjkH487VfV7gSR8UXrbxQ3",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://kalychain.io",
  "name": "KalyChain Mainnet",
  "nativeCurrency": {
    "name": "KalyCoin",
    "symbol": "KLC",
    "decimals": 18
  },
  "networkId": 3888,
  "rpc": ["https://3888.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.kalychain.io/rpc"],
  "shortName": "kalymainnet",
  "slug": "kalychain",
  "testnet": false
};

var c3889 = {
  "chain": "KLC",
  "chainId": 3889,
  "explorers": [{
    "name": "KalyScan",
    "url": "https://testnet.kalyscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmUaXcPewLuQtY5a7xPTzJyVdjkH487VfV7gSR8UXrbxQ3",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://kalychain.io",
  "name": "KalyChain Testnet",
  "nativeCurrency": {
    "name": "KalyCoin",
    "symbol": "KLC",
    "decimals": 18
  },
  "networkId": 3889,
  "rpc": ["https://3889.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnetrpc.kalychain.io/rpc"],
  "shortName": "kalytestnet",
  "slip44": 1,
  "slug": "kalychain-testnet",
  "testnet": true
};

var c3912 = {
  "chain": "DRAC",
  "chainId": 3912,
  "explorers": [{
    "name": "DRAC_Network Scan",
    "url": "https://www.dracscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://www.dracscan.io/faucet"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmXbsQe7QsVFZJZdBmbZVvS6LgX9ZFoaTMBs9MiQXUzJTw",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://drac.io/",
  "name": "DRAC Network",
  "nativeCurrency": {
    "name": "DRAC",
    "symbol": "DRAC",
    "decimals": 18
  },
  "networkId": 3912,
  "rpc": ["https://3912.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://www.dracscan.com/rpc"],
  "shortName": "drac",
  "slug": "drac-network",
  "testnet": false
};

var c3939 = {
  "chain": "DOS",
  "chainId": 3939,
  "explorers": [{
    "name": "DOScan-Test",
    "url": "https://test.doscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmV2Nowzo81F6pi2qFcHePA4MwmmdMKBMUzBJUrxcymxx4",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmV2Nowzo81F6pi2qFcHePA4MwmmdMKBMUzBJUrxcymxx4",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "http://doschain.io/",
  "name": "DOS Tesnet",
  "nativeCurrency": {
    "name": "DOS",
    "symbol": "DOS",
    "decimals": 18
  },
  "networkId": 3939,
  "rpc": ["https://3939.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://test.doschain.com"],
  "shortName": "dost",
  "slip44": 1,
  "slug": "dos-tesnet",
  "testnet": true
};

var c3966 = {
  "chain": "DYNO",
  "chainId": 3966,
  "explorers": [{
    "name": "DYNO Explorer",
    "url": "https://dynoscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.dynoscan.io"],
  "infoURL": "https://dynoprotocol.com",
  "name": "DYNO Mainnet",
  "nativeCurrency": {
    "name": "DYNO Token",
    "symbol": "DYNO",
    "decimals": 18
  },
  "networkId": 3966,
  "rpc": ["https://3966.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.dynoprotocol.com"],
  "shortName": "dyno",
  "slug": "dyno",
  "testnet": false
};

var c3967 = {
  "chain": "DYNO",
  "chainId": 3967,
  "explorers": [{
    "name": "DYNO Explorer",
    "url": "https://testnet.dynoscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.dynoscan.io"],
  "infoURL": "https://dynoprotocol.com",
  "name": "DYNO Testnet",
  "nativeCurrency": {
    "name": "DYNO Token",
    "symbol": "tDYNO",
    "decimals": 18
  },
  "networkId": 3967,
  "rpc": ["https://3967.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://tapi.dynoprotocol.com"],
  "shortName": "tdyno",
  "slip44": 1,
  "slug": "dyno-testnet",
  "testnet": true
};

var c3993 = {
  "chain": "ETH",
  "chainId": 3993,
  "explorers": [{
    "name": "blockscout",
    "url": "https://exp-testnet.apexlayer.xyz",
    "standard": "EIP3091"
  }],
  "faucets": ["https://sepoliafaucet.com/"],
  "icon": {
    "url": "ipfs://qmxhs7fvjanzwm14vjpbnmklre32gsiy9chsarrnbtfa1n",
    "width": 1280,
    "height": 1280,
    "format": "png"
  },
  "infoURL": "https://docs.apexlayer.xyz/",
  "name": "APEX Testnet",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 3993,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": [{
      "url": "https://apexlayer.xyz/bridge"
    }]
  },
  "rpc": ["https://3993.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.apexlayer.xyz"],
  "shortName": "apexsep",
  "slip44": 1,
  "slug": "apex-testnet",
  "testnet": true
};

var c3999 = {
  "chain": "YCC",
  "chainId": 3999,
  "explorers": [{
    "name": "YuanChain Explorer",
    "url": "https://mainnet.yuan.org",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdbPhiB5W2gbHZGkYsN7i2VTKKP9casmAN2hRnpDaL9W4",
    "width": 96,
    "height": 96,
    "format": "png"
  },
  "infoURL": "https://www.yuan.org",
  "name": "YuanChain Mainnet",
  "nativeCurrency": {
    "name": "YCC",
    "symbol": "YCC",
    "decimals": 18
  },
  "networkId": 3999,
  "rpc": ["https://3999.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.yuan.org/eth"],
  "shortName": "ycc",
  "slug": "yuanchain",
  "testnet": false
};

var c4000 = {
  "chain": "OZONE",
  "chainId": 4000,
  "explorers": [{
    "name": "OZONE Scan",
    "url": "https://ozonescan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmbM4weV8Bk6c9yNhosYntkVw39SNZtCHYGgWyXTxkevZ8",
    "width": 1600,
    "height": 1600,
    "format": "png"
  },
  "infoURL": "https://ozonechain.io",
  "name": "Ozone Chain Mainnet",
  "nativeCurrency": {
    "name": "OZONE",
    "symbol": "OZO",
    "decimals": 18
  },
  "networkId": 4000,
  "rpc": ["https://4000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node1.ozonechain.io"],
  "shortName": "ozo",
  "slug": "ozone-chain",
  "testnet": false
};

var c4001 = {
  "chain": "PERIUM",
  "chainId": 4001,
  "explorers": [{
    "name": "Peperium Chain Explorer",
    "url": "https://scan-testnet.peperium.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://Qmag2hr5DQghRzKPN3oUFBkjWzqd5CndQzZeb5LfoiMCXf",
      "width": 160,
      "height": 160,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmag2hr5DQghRzKPN3oUFBkjWzqd5CndQzZeb5LfoiMCXf",
    "width": 160,
    "height": 160,
    "format": "png"
  },
  "infoURL": "https://peperium.io",
  "name": "Peperium Chain Testnet",
  "nativeCurrency": {
    "name": "Peperium Chain Testnet",
    "symbol": "PERIUM",
    "decimals": 18
  },
  "networkId": 4001,
  "rpc": ["https://4001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.peperium.io"],
  "shortName": "PERIUM",
  "slip44": 1,
  "slug": "peperium-chain-testnet",
  "testnet": true
};

var c4002 = {
  "chain": "FTM",
  "chainId": 4002,
  "explorers": [{
    "name": "ftmscan",
    "url": "https://testnet.ftmscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRqbK449Fo9sJ3xMpkPbg6uV1weQj4yVV1xNMP9cdPmjf",
      "width": 73,
      "height": 73,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.fantom.network"],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/fantom/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://docs.fantom.foundation/quick-start/short-guide#fantom-testnet",
  "name": "Fantom Testnet",
  "nativeCurrency": {
    "name": "Fantom",
    "symbol": "FTM",
    "decimals": 18
  },
  "networkId": 4002,
  "redFlags": [],
  "rpc": ["https://4002.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.fantom.network", "https://fantom-testnet-rpc.publicnode.com", "wss://fantom-testnet-rpc.publicnode.com", "https://fantom-testnet.drpc.org", "wss://fantom-testnet.drpc.org"],
  "shortName": "tftm",
  "slip44": 1,
  "slug": "fantom-testnet",
  "testnet": true
};

var c4003 = {
  "chain": "X1",
  "chainId": 4003,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://explorer.x1-fastnet.xen.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "infoURL": "https://docs.xen.network/go-x1/",
  "name": "X1 Fastnet",
  "nativeCurrency": {
    "name": "XN",
    "symbol": "XN",
    "decimals": 18
  },
  "networkId": 4003,
  "rpc": ["https://4003.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://x1-fastnet.xen.network"],
  "shortName": "x1-fastnet",
  "slip44": 1,
  "slug": "x1-fastnet",
  "testnet": false
};

var c4051 = {
  "chain": "Bobaopera Testnet",
  "chainId": 4051,
  "explorers": [{
    "name": "Bobaopera Testnet block explorer",
    "url": "https://blockexplorer.testnet.bobaopera.boba.network",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://boba.network",
  "name": "Bobaopera Testnet",
  "nativeCurrency": {
    "name": "Boba Token",
    "symbol": "BOBA",
    "decimals": 18
  },
  "networkId": 4051,
  "rpc": ["https://4051.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.bobaopera.boba.network", "wss://wss.testnet.bobaopera.boba.network", "https://replica.testnet.bobaopera.boba.network", "wss://replica-wss.testnet.bobaopera.boba.network"],
  "shortName": "BobaoperaTestnet",
  "slip44": 1,
  "slug": "bobaopera-testnet",
  "testnet": true
};

var c4061 = {
  "chain": "Nahmii",
  "chainId": 4061,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZhKXgoGpzvthr2eh8ZNgT75YvMtEBegdELAaMPPzf5QT",
    "width": 384,
    "height": 384,
    "format": "png"
  },
  "infoURL": "https://nahmii.io",
  "name": "Nahmii 3 Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 4061,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.nahmii.io"
    }]
  },
  "rpc": [],
  "shortName": "Nahmii3Mainnet",
  "slug": "nahmii-3",
  "status": "incubating",
  "testnet": false
};

var c4062 = {
  "chain": "Nahmii",
  "chainId": 4062,
  "explorers": [{
    "name": "Nahmii 3 Testnet Explorer",
    "url": "https://explorer.testnet.n3.nahmii.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmZhKXgoGpzvthr2eh8ZNgT75YvMtEBegdELAaMPPzf5QT",
      "width": 384,
      "height": 384,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZhKXgoGpzvthr2eh8ZNgT75YvMtEBegdELAaMPPzf5QT",
    "width": 384,
    "height": 384,
    "format": "png"
  },
  "infoURL": "https://nahmii.io",
  "name": "Nahmii 3 Testnet",
  "nativeCurrency": {
    "name": "Goerli Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 4062,
  "parent": {
    "type": "L2",
    "chain": "eip155-3",
    "bridges": [{
      "url": "https://bridge.testnet.n3.nahmii.io"
    }]
  },
  "rpc": ["https://4062.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://ngeth.testnet.n3.nahmii.io"],
  "shortName": "Nahmii3Testnet",
  "slip44": 1,
  "slug": "nahmii-3-testnet",
  "testnet": true
};

var c4078 = {
  "chain": "Muster",
  "chainId": 4078,
  "explorers": [{
    "name": "Musterscan",
    "url": "https://muster-explorer.alt.technology",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreiexm4aoscqo4d7dipicdgmfaemgzck2w7qhfp5mnoo7z2plcxleju",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "name": "Muster Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 4078,
  "parent": {
    "type": "L2",
    "chain": "eip155-42161",
    "bridges": []
  },
  "rpc": ["https://4078.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://muster.alt.technology"],
  "shortName": "muster",
  "slug": "muster",
  "testnet": false
};

var c4090 = {
  "chain": "Fastex Chain (Bahamut)",
  "chainId": 4090,
  "explorers": [{
    "name": "blockscout",
    "url": "https://oasis.ftnscan.com",
    "standard": "none"
  }],
  "faucets": ["https://faucet.oasis.fastexchain.com"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmSemioP83RXnDWwTZbet8VpwJxcFRboX4B3pcdhLZGodP",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://fastexchain.com",
  "name": "Fastex Chain (Bahamut) Oasis Testnet",
  "nativeCurrency": {
    "name": "FTN",
    "symbol": "FTN",
    "decimals": 18
  },
  "networkId": 4090,
  "rpc": ["https://4090.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc1.oasis.bahamutchain.com"],
  "shortName": "Oasis",
  "slip44": 1,
  "slug": "fastex-chain-bahamut-oasis-testnet",
  "testnet": true,
  "title": "Bahamut testnet Oasis"
};

var c4096 = {
  "chain": "BNI",
  "chainId": 4096,
  "explorers": [{
    "name": "Bitindi",
    "url": "https://testnet.bitindiscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.bitindi.org"],
  "features": [],
  "icon": {
    "url": "ipfs://QmRAFFPiLiSgjGTs9QaZdnR9fsDgyUdTejwSxcnPXo292s",
    "width": 60,
    "height": 72,
    "format": "png"
  },
  "infoURL": "https://bitindi.org",
  "name": "Bitindi Testnet",
  "nativeCurrency": {
    "name": "BNI",
    "symbol": "$BNI",
    "decimals": 18
  },
  "networkId": 4096,
  "redFlags": [],
  "rpc": ["https://4096.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.bitindi.org", "https://testnet-rpc.bitindi.org"],
  "shortName": "BNIt",
  "slip44": 1,
  "slug": "bitindi-testnet",
  "testnet": true
};

var c4099 = {
  "chain": "BNI",
  "chainId": 4099,
  "explorers": [{
    "name": "Bitindi",
    "url": "https://bitindiscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.bitindi.org"],
  "features": [],
  "icon": {
    "url": "ipfs://QmRAFFPiLiSgjGTs9QaZdnR9fsDgyUdTejwSxcnPXo292s",
    "width": 60,
    "height": 72,
    "format": "png"
  },
  "infoURL": "https://bitindi.org",
  "name": "Bitindi Mainnet",
  "nativeCurrency": {
    "name": "BNI",
    "symbol": "$BNI",
    "decimals": 18
  },
  "networkId": 4099,
  "redFlags": [],
  "rpc": ["https://4099.rpc.thirdweb.com/${THIRDWEB_API_KEY}", " https://rpc-mainnet.bitindi.org", "https://mainnet-rpc.bitindi.org"],
  "shortName": "BNIm",
  "slug": "bitindi",
  "testnet": false
};

var c4102 = {
  "chain": "AIOZ",
  "chainId": 4102,
  "explorers": [{
    "name": "AIOZ Network Testnet Explorer",
    "url": "https://testnet.explorer.aioz.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRAGPFhvQiXgoJkui7WHajpKctGFrJNhHqzYdwcWt5V3Z",
    "width": 1024,
    "height": 1024,
    "format": "png"
  },
  "infoURL": "https://aioz.network",
  "name": "AIOZ Network Testnet",
  "nativeCurrency": {
    "name": "testAIOZ",
    "symbol": "AIOZ",
    "decimals": 18
  },
  "networkId": 4102,
  "rpc": ["https://4102.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eth-ds.testnet.aioz.network"],
  "shortName": "aioz-testnet",
  "slip44": 1,
  "slug": "aioz-network-testnet",
  "testnet": true
};

var c4139 = {
  "chain": "Humans Testnet",
  "chainId": 4139,
  "explorers": [],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmX6XuoQDTTjYqAmdNJiieLDZSwHHyUx44yQb4E3tmHmEA",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://humans.ai",
  "name": "Humans.ai Testnet",
  "nativeCurrency": {
    "name": "HEART",
    "symbol": "HEART",
    "decimals": 18
  },
  "networkId": 4139,
  "rpc": ["https://4139.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm-rpc.testnet.humans.zone"],
  "shortName": "humans_testnet",
  "slip44": 1,
  "slug": "humans-ai-testnet",
  "testnet": true
};

var c4141 = {
  "chain": "TPBX",
  "chainId": 4141,
  "explorers": [{
    "name": "Tipboxcoin",
    "url": "https://testnet.tipboxcoin.net",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.tipboxcoin.net"],
  "icon": {
    "url": "ipfs://QmbiaHnR3fVVofZ7Xq2GYZxwHkLEy3Fh5qDtqnqXD6ACAh",
    "width": 192,
    "height": 192,
    "format": "png"
  },
  "infoURL": "https://tipboxcoin.net",
  "name": "Tipboxcoin Testnet",
  "nativeCurrency": {
    "name": "Tipboxcoin",
    "symbol": "TPBX",
    "decimals": 18
  },
  "networkId": 4141,
  "rpc": ["https://4141.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.tipboxcoin.net"],
  "shortName": "TPBXt",
  "slip44": 1,
  "slug": "tipboxcoin-testnet",
  "testnet": true
};

var c4145 = {
  "chain": "Avalanche",
  "chainId": 4145,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI1212I2",
  "nativeCurrency": {
    "name": "QI1212I2 Token",
    "symbol": "HSCX",
    "decimals": 18
  },
  "networkId": 4145,
  "redFlags": [],
  "rpc": ["https://4145.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI1212I2",
  "slug": "qi1212i2",
  "testnet": true
};

var c4157 = {
  "chain": "XFI",
  "chainId": 4157,
  "explorers": [{
    "name": "CrossFi Testnet Scan",
    "url": "https://scan.testnet.ms",
    "standard": "EIP3091"
  }, {
    "name": "Scan Testnet",
    "url": "https://scan.testnet.ms/",
    "standard": "EIP1559"
  }],
  "faucets": [],
  "features": [],
  "infoURL": "https://crossfi.org/",
  "name": "CrossFi Testnet",
  "nativeCurrency": {
    "name": "XFI",
    "symbol": "XFI",
    "decimals": 18
  },
  "networkId": 4157,
  "redFlags": [],
  "rpc": ["https://4157.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.ms/", "https://rpc.testnet.ms"],
  "shortName": "XFI",
  "slip44": 1,
  "slug": "crossfi-testnet",
  "testnet": true,
  "title": "https://scan.testnet.ms/"
};

var c4181 = {
  "chain": "PHI V1",
  "chainId": 4181,
  "explorers": [{
    "name": "PHI Explorer",
    "url": "https://explorer.phi.network",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreid6pm3mic7izp3a6zlfwhhe7etd276bjfsq2xash6a4s2vmcdf65a",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreid6pm3mic7izp3a6zlfwhhe7etd276bjfsq2xash6a4s2vmcdf65a",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://phi.network",
  "name": "PHI Network V1",
  "nativeCurrency": {
    "name": "PHI",
    "symbol": "Φ",
    "decimals": 18
  },
  "networkId": 4181,
  "rpc": ["https://4181.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc1.phi.network", "https://rpc2.phi.network"],
  "shortName": "PHIv1",
  "slug": "phi-network-v1",
  "testnet": false
};

var c4200 = {
  "chain": "Merlin",
  "chainId": 4200,
  "explorers": [{
    "name": "blockscout",
    "url": "https://scan.merlinchain.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmULpMFUvKSmJT8sWXS3WDnTm4EacgRbsEynDenpxcfrAj",
      "width": 400,
      "height": 400,
      "format": "jpg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmULpMFUvKSmJT8sWXS3WDnTm4EacgRbsEynDenpxcfrAj",
    "width": 400,
    "height": 400,
    "format": "jpg"
  },
  "infoURL": "https://merlinchain.io",
  "name": "Merlin Mainnet",
  "nativeCurrency": {
    "name": "BTC",
    "symbol": "BTC",
    "decimals": 18
  },
  "networkId": 4200,
  "rpc": ["https://4200.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.merlinchain.io"],
  "shortName": "Merlin-Mainnet",
  "slug": "merlin",
  "testnet": false,
  "title": "Merlin Mainnet"
};

var c4201 = {
  "chain": "LUKSO Testnet",
  "chainId": 4201,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://explorer.execution.testnet.lukso.network",
    "standard": "none"
  }],
  "faucets": ["https://faucet.testnet.lukso.network"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://Qmeg9sFF5tAGi6MCx7YjtVHW6a23zqvHRK1xwzSdp9iE7z",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://lukso.network",
  "name": "LUKSO Testnet",
  "nativeCurrency": {
    "name": "TestLYX",
    "symbol": "LYXt",
    "decimals": 18
  },
  "networkId": 4201,
  "rpc": ["https://4201.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.lukso.network", "wss://ws-rpc.testnet.lukso.network"],
  "shortName": "lukso-testnet",
  "slip44": 1,
  "slug": "lukso-testnet",
  "testnet": true
};

var c4202 = {
  "chain": "ETH",
  "chainId": 4202,
  "explorers": [{
    "name": "liskscout",
    "url": "https://sepolia-blockscout.lisk.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "infoURL": "https://lisk.com",
  "name": "Lisk Sepolia Testnet",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 4202,
  "rpc": ["https://4202.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.sepolia-api.lisk.com"],
  "shortName": "lisksep",
  "slip44": 134,
  "slug": "lisk-sepolia-testnet",
  "testnet": true
};

var c4242 = {
  "chain": "Nexi",
  "chainId": 4242,
  "explorers": [{
    "name": "nexiscan",
    "url": "https://www.nexiscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeifxqd7zel2m237kq5enavnh2s6cshaavswigogyvae2wevxy5k2ti",
    "width": 512,
    "height": 578,
    "format": "png"
  },
  "infoURL": "https://www.nexi.technology/",
  "name": "Nexi Mainnet",
  "nativeCurrency": {
    "name": "Nexi",
    "symbol": "NEXI",
    "decimals": 18
  },
  "networkId": 4242,
  "rpc": ["https://4242.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.chain.nexi.technology/", "https://chain.nexilix.com", "https://chain.nexi.evmnode.online"],
  "shortName": "nexi",
  "slip44": 2500,
  "slug": "nexi",
  "testnet": false
};

var c4243 = {
  "chain": "Nexi V2",
  "chainId": 4243,
  "explorers": [{
    "name": "nexiscan",
    "url": "https://www.nexiscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeifxqd7zel2m237kq5enavnh2s6cshaavswigogyvae2wevxy5k2ti",
    "width": 512,
    "height": 578,
    "format": "png"
  },
  "infoURL": "https://www.nexi.technology/",
  "name": "Nexi V2 Mainnet",
  "nativeCurrency": {
    "name": "NexiV2",
    "symbol": "NEXI",
    "decimals": 18
  },
  "networkId": 4243,
  "rpc": ["https://4243.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://chain.nexiv2.nexilix.com", "https://rpc.chainv1.nexi.technology"],
  "shortName": "NexiV2",
  "slip44": 2500,
  "slug": "nexi-v2",
  "testnet": false
};

var c4328 = {
  "chain": "Bobafuji Testnet",
  "chainId": 4328,
  "explorers": [{
    "name": "Bobafuji Testnet block explorer",
    "url": "https://blockexplorer.testnet.avax.boba.network",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://boba.network",
  "name": "Bobafuji Testnet",
  "nativeCurrency": {
    "name": "Boba Token",
    "symbol": "BOBA",
    "decimals": 18
  },
  "networkId": 4328,
  "parent": {
    "type": "L2",
    "chain": "eip155-5",
    "bridges": [{
      "url": "https://gateway.boba.network"
    }]
  },
  "rpc": ["https://4328.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.avax.boba.network", "wss://wss.testnet.avax.boba.network", "https://replica.testnet.avax.boba.network"],
  "shortName": "BobaFujiTestnet",
  "slip44": 1,
  "slug": "bobafuji-testnet",
  "testnet": true
};

var c4337 = {
  "chain": "BEAM",
  "chainId": 4337,
  "explorers": [{
    "name": "Beam Explorer",
    "url": "https://subnets.avax.network/beam",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.onbeam.com"],
  "features": [{
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmQJ21NWyGGDraicVEzS1Uqq1yXahM9NCuNZgnfYvtspdt",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://www.onbeam.com",
  "name": "Beam",
  "nativeCurrency": {
    "name": "Beam",
    "symbol": "BEAM",
    "decimals": 18
  },
  "networkId": 4337,
  "rpc": ["https://4337.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://build.onbeam.com/rpc", "wss://build.onbeam.com/ws", "https://subnets.avax.network/beam/mainnet/rpc", "wss://subnets.avax.network/beam/mainnet/ws"],
  "shortName": "beam",
  "slug": "beam",
  "testnet": false
};

var c4400 = {
  "chain": "CREDIT",
  "chainId": 4400,
  "explorers": [{
    "name": "Creditscan",
    "url": "https://scan.creditsmartchain.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreifbso3gd4wu5wxl27xyurxctmuae2jyuy37guqtzx23nga6ba4ag4",
      "width": 1000,
      "height": 1628,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreifbso3gd4wu5wxl27xyurxctmuae2jyuy37guqtzx23nga6ba4ag4",
    "width": 1000,
    "height": 1628,
    "format": "png"
  },
  "infoURL": "https://creditsmartchain.com",
  "name": "Credit Smart Chain Mainnet",
  "nativeCurrency": {
    "name": "Credit",
    "symbol": "CREDIT",
    "decimals": 18
  },
  "networkId": 4400,
  "rpc": ["https://4400.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.creditsmartchain.com"],
  "shortName": "CreditEdge",
  "slug": "credit-smart-chain",
  "testnet": false
};

var c4444 = {
  "chain": "mainnet",
  "chainId": 4444,
  "explorers": [{
    "name": "htmlcoin",
    "url": "https://explorer.htmlcoin.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmR1oDRSadPerfyWMhKHNP268vPKvpczt5zPawgFSZisz2",
      "width": 1000,
      "height": 1000,
      "format": "png"
    }
  }],
  "faucets": ["https://gruvin.me/htmlcoin"],
  "icon": {
    "url": "ipfs://QmR1oDRSadPerfyWMhKHNP268vPKvpczt5zPawgFSZisz2",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://htmlcoin.com",
  "name": "Htmlcoin Mainnet",
  "nativeCurrency": {
    "name": "Htmlcoin",
    "symbol": "HTML",
    "decimals": 8
  },
  "networkId": 4444,
  "rpc": ["https://4444.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://janus.htmlcoin.com/api/"],
  "shortName": "html",
  "slug": "htmlcoin",
  "status": "active",
  "testnet": false
};

var c4460 = {
  "chain": "ETH",
  "chainId": 4460,
  "explorers": [{
    "name": "basescout",
    "url": "https://explorerl2new-orderly-l2-4460-sepolia-8tc3sd7dvy.t.conduit.xyz",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmSpwp3RAVhZsErAQrCQxEmjnGqJQMigarzZbfqr9Ktakb",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "name": "Orderly Sepolia Testnet",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 4460,
  "rpc": ["https://4460.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://l2-orderly-l2-4460-sepolia-8tc3sd7dvy.t.conduit.xyz"],
  "shortName": "orderlyl2",
  "slip44": 1,
  "slug": "orderly-sepolia-testnet",
  "testnet": true
};

var c4544 = {
  "chain": "Emoney",
  "chainId": 4544,
  "explorers": [{
    "name": "EMoney ethscan",
    "url": "https://ethscan.emoney.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreigo4gtboztftjdnbvy2rb2ku2gxxbhm4iwutzgnzhvden3vcbsqui",
      "width": 472,
      "height": 462,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.emoney.network/faucet"],
  "icon": {
    "url": "ipfs://bafkreigo4gtboztftjdnbvy2rb2ku2gxxbhm4iwutzgnzhvden3vcbsqui",
    "width": 472,
    "height": 462,
    "format": "png"
  },
  "infoURL": "https://emoney.network/",
  "name": "Emoney Network Testnet",
  "nativeCurrency": {
    "name": "Emoney Network",
    "symbol": "EMYC",
    "decimals": 18
  },
  "networkId": 4544,
  "rpc": ["https://4544.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.emoney.network/"],
  "shortName": "emoney",
  "slip44": 118,
  "slug": "emoney-network-testnet",
  "testnet": true
};

var c4653 = {
  "chain": "Gold",
  "chainId": 4653,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmbvuHpn8Np5uTTbVNgv4JHCj2zfHBfmSoRcVNdWbcV5Vq",
    "width": 226,
    "height": 104,
    "format": "png"
  },
  "infoURL": "https://gold.dev",
  "name": "Gold Chain",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 4653,
  "rpc": ["https://4653.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://chain-rpc.gold.dev"],
  "shortName": "gold",
  "slug": "gold-chain",
  "status": "incubating",
  "testnet": false,
  "title": "Gold Chain"
};

var c4689 = {
  "chain": "iotex.io",
  "chainId": 4689,
  "explorers": [{
    "name": "iotexscan",
    "url": "https://iotexscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmQKHQrvtyUC5b5B76ke5GPTGXoGTVCubXS6gHgzCAswKo",
    "width": 250,
    "height": 250,
    "format": "png"
  },
  "infoURL": "https://iotex.io",
  "name": "IoTeX Network Mainnet",
  "nativeCurrency": {
    "name": "IoTeX",
    "symbol": "IOTX",
    "decimals": 18
  },
  "networkId": 4689,
  "redFlags": [],
  "rpc": ["https://4689.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.ankr.com/iotex", "https://babel-api.mainnet.iotex.io"],
  "shortName": "iotex-mainnet",
  "slug": "iotex-network",
  "testnet": false
};

var c4690 = {
  "chain": "iotex.io",
  "chainId": 4690,
  "explorers": [{
    "name": "testnet iotexscan",
    "url": "https://testnet.iotexscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.iotex.io/"],
  "features": [],
  "icon": {
    "url": "ipfs://QmQKHQrvtyUC5b5B76ke5GPTGXoGTVCubXS6gHgzCAswKo",
    "width": 250,
    "height": 250,
    "format": "png"
  },
  "infoURL": "https://iotex.io",
  "name": "IoTeX Network Testnet",
  "nativeCurrency": {
    "name": "IoTeX",
    "symbol": "IOTX",
    "decimals": 18
  },
  "networkId": 4690,
  "redFlags": [],
  "rpc": ["https://4690.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://babel-api.testnet.iotex.io"],
  "shortName": "iotex-testnet",
  "slip44": 1,
  "slug": "iotex-network-testnet",
  "testnet": true
};

var c4759 = {
  "chain": "MEVerse",
  "chainId": 4759,
  "explorers": [{
    "name": "MEVerse Chain Testnet Explorer",
    "url": "https://testnet.meversescan.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmPuQ6gaCfUtNdRuaEDbdhot2m2KCy2ZHCJUvZXJAtdeyJ",
      "width": 800,
      "height": 800,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPuQ6gaCfUtNdRuaEDbdhot2m2KCy2ZHCJUvZXJAtdeyJ",
    "width": 800,
    "height": 800,
    "format": "png"
  },
  "infoURL": "https://www.meverse.sg",
  "name": "MEVerse Chain Testnet",
  "nativeCurrency": {
    "name": "MEVerse",
    "symbol": "MEV",
    "decimals": 18
  },
  "networkId": 4759,
  "rpc": ["https://4759.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.meversetestnet.io"],
  "shortName": "TESTMEV",
  "slip44": 1,
  "slug": "meverse-chain-testnet",
  "testnet": true
};

var c4777 = {
  "chain": "TBXN",
  "chainId": 4777,
  "explorers": [{
    "name": "blockscout",
    "url": "https://testnet-explorer.blackfort.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmPasA8xykRtJDivB2bcKDiRCUNWDPtfUTTKVAcaF2wVxC",
    "width": 1968,
    "height": 1968,
    "format": "png"
  },
  "infoURL": "https://blackfort.exchange",
  "name": "BlackFort Exchange Network Testnet",
  "nativeCurrency": {
    "name": "BlackFort Testnet Token",
    "symbol": "TBXN",
    "decimals": 18
  },
  "networkId": 4777,
  "rpc": ["https://4777.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.blackfort.network/rpc"],
  "shortName": "TBXN",
  "slip44": 1,
  "slug": "blackfort-exchange-network-testnet",
  "testnet": true
};

var c4893 = {
  "chain": "GC",
  "chainId": 4893,
  "explorers": [{
    "name": "blockscout",
    "url": "https://gcscan.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPRHDsVNpRZ72GoQgDbpa3R4wKENmrXCRNuYJkxocFRDb",
    "width": 306,
    "height": 293,
    "format": "png"
  },
  "infoURL": "https://gcscan.io",
  "name": "Globel Chain",
  "nativeCurrency": {
    "name": "Globel Chain",
    "symbol": "GC",
    "decimals": 18
  },
  "networkId": 4893,
  "rpc": ["https://4893.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.gcscan.io"],
  "shortName": "GC",
  "slug": "globel-chain",
  "testnet": false
};

var c4905 = {
  "chain": "Avalanche",
  "chainId": 4905,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Jambon's Testnet",
  "nativeCurrency": {
    "name": "Jambon's Testnet Token",
    "symbol": "XFX",
    "decimals": 18
  },
  "networkId": 4905,
  "redFlags": [],
  "rpc": ["https://4905.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/f4ceb0cc-0d11-4d49-888e-d744e333488a"],
  "shortName": "Jambon's Testnet",
  "slug": "jambon-s-testnet",
  "testnet": true
};

var c4918 = {
  "chain": "XVM",
  "chainId": 4918,
  "explorers": [{
    "name": "Venidium EVM Testnet Explorer",
    "url": "https://evm-testnet.venidiumexplorer.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://venidium.io",
  "name": "Venidium Testnet",
  "nativeCurrency": {
    "name": "Venidium",
    "symbol": "XVM",
    "decimals": 18
  },
  "networkId": 4918,
  "rpc": ["https://4918.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-evm-testnet.venidium.io"],
  "shortName": "txvm",
  "slip44": 1,
  "slug": "venidium-testnet",
  "testnet": true
};

var c4919 = {
  "chain": "XVM",
  "chainId": 4919,
  "explorers": [{
    "name": "Venidium Explorer",
    "url": "https://evm.venidiumexplorer.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreiaplwlym5g27jm4mjhotfqq6al2cxp3fnkmzdusqjg7wnipq5wn2e",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://venidium.io",
  "name": "Venidium Mainnet",
  "nativeCurrency": {
    "name": "Venidium",
    "symbol": "XVM",
    "decimals": 18
  },
  "networkId": 4919,
  "rpc": ["https://4919.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.venidium.io"],
  "shortName": "xvm",
  "slug": "venidium",
  "testnet": false
};

var c4999 = {
  "chain": "BXN",
  "chainId": 4999,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.blackfort.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmPasA8xykRtJDivB2bcKDiRCUNWDPtfUTTKVAcaF2wVxC",
    "width": 1968,
    "height": 1968,
    "format": "png"
  },
  "infoURL": "https://blackfort.exchange",
  "name": "BlackFort Exchange Network",
  "nativeCurrency": {
    "name": "BlackFort Token",
    "symbol": "BXN",
    "decimals": 18
  },
  "networkId": 4999,
  "rpc": ["https://4999.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.blackfort.network/rpc", "https://mainnet-1.blackfort.network/rpc", "https://mainnet-2.blackfort.network/rpc", "https://mainnet-3.blackfort.network/rpc"],
  "shortName": "BXN",
  "slug": "blackfort-exchange-network",
  "testnet": false
};

var c5000 = {
  "chain": "ETH",
  "chainId": 5000,
  "explorers": [{
    "name": "Mantle Explorer",
    "url": "https://explorer.mantle.xyz",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYddHh5zdceSsBU7uGfQvEHg6UUtAFbzQBBaePS4whx7o",
    "width": 225,
    "height": 225,
    "format": "png"
  },
  "infoURL": "https://mantle.xyz",
  "name": "Mantle",
  "nativeCurrency": {
    "name": "Mantle",
    "symbol": "MNT",
    "decimals": 18
  },
  "networkId": 5000,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.mantle.xyz"
    }]
  },
  "rpc": ["https://5000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.mantle.xyz", "https://mantle-rpc.publicnode.com", "wss://mantle-rpc.publicnode.com"],
  "shortName": "mantle",
  "slug": "mantle",
  "testnet": false
};

var c5001 = {
  "chain": "ETH",
  "chainId": 5001,
  "explorers": [{
    "name": "Mantle Testnet Explorer",
    "url": "https://explorer.testnet.mantle.xyz",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.testnet.mantle.xyz"],
  "infoURL": "https://mantle.xyz",
  "name": "Mantle Testnet",
  "nativeCurrency": {
    "name": "Testnet Mantle",
    "symbol": "MNT",
    "decimals": 18
  },
  "networkId": 5001,
  "rpc": ["https://5001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.mantle.xyz"],
  "shortName": "mantle-testnet",
  "slip44": 1,
  "slug": "mantle-testnet",
  "testnet": true
};

var c5002 = {
  "chain": "Treasurenet Mainnet Alpha",
  "chainId": 5002,
  "explorers": [{
    "name": "Treasurenet EVM BlockExplorer",
    "url": "https://evmexplorer.treasurenet.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmTcNX8ukHkXiVfVah1W8Sed3vtGN95Sq2QSimfLuHva6B",
      "width": 1844,
      "height": 1920,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://QmTcNX8ukHkXiVfVah1W8Sed3vtGN95Sq2QSimfLuHva6B",
    "width": 1844,
    "height": 1920,
    "format": "png"
  },
  "infoURL": "https://www.treasurenet.io",
  "name": "Treasurenet Mainnet Alpha",
  "nativeCurrency": {
    "name": "UNIT",
    "symbol": "UNIT",
    "decimals": 18
  },
  "networkId": 5002,
  "rpc": ["https://5002.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node0.treasurenet.io", "https://node1.treasurenet.io", "https://node2.treasurenet.io", "https://node3.treasurenet.io"],
  "shortName": "treasurenet",
  "slug": "treasurenet-alpha",
  "testnet": false
};

var c5003 = {
  "chain": "ETH",
  "chainId": 5003,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.sepolia.mantle.xyz",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.sepolia.mantle.xyz"],
  "infoURL": "https://mantle.xyz",
  "name": "Mantle Sepolia Testnet",
  "nativeCurrency": {
    "name": "Sepolia Mantle",
    "symbol": "MNT",
    "decimals": 18
  },
  "networkId": 5003,
  "rpc": ["https://5003.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.sepolia.mantle.xyz"],
  "shortName": "mnt-sep",
  "slip44": 1,
  "slug": "mantle-sepolia-testnet",
  "testnet": true
};

var c5005 = {
  "chain": "Treasurenet Testnet",
  "chainId": 5005,
  "explorers": [{
    "name": "Treasurenet EVM BlockExplorer",
    "url": "https://evmexplorer.testnet.treasurenet.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmTcNX8ukHkXiVfVah1W8Sed3vtGN95Sq2QSimfLuHva6B",
      "width": 1844,
      "height": 1920,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://QmTcNX8ukHkXiVfVah1W8Sed3vtGN95Sq2QSimfLuHva6B",
    "width": 1844,
    "height": 1920,
    "format": "png"
  },
  "infoURL": "https://www.testnet.treasurenet.io",
  "name": "Treasurenet Testnet",
  "nativeCurrency": {
    "name": "UNIT",
    "symbol": "UNIT",
    "decimals": 18
  },
  "networkId": 5005,
  "rpc": ["https://5005.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node0.testnet.treasurenet.io", "https://node1.testnet.treasurenet.io", "https://node2.testnet.treasurenet.io", "https://node3.testnet.treasurenet.io"],
  "shortName": "tntest",
  "slip44": 1,
  "slug": "treasurenet-testnet",
  "testnet": true
};

var c5039 = {
  "chain": "ONIGIRI",
  "chainId": 5039,
  "explorers": [{
    "name": "ONIGIRI Explorer",
    "url": "https://subnets-test.avax.network/onigiri",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://www.ongr.org/",
  "name": "ONIGIRI Test Subnet",
  "nativeCurrency": {
    "name": "ONIGIRI",
    "symbol": "ONGR",
    "decimals": 18
  },
  "networkId": 5039,
  "rpc": ["https://5039.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/onigiri/testnet/rpc"],
  "shortName": "onigiri",
  "slug": "onigiri-test-subnet",
  "testnet": true
};

var c5042 = {
  "chain": "Avalanche",
  "chainId": 5042,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "OMOCHI",
  "nativeCurrency": {
    "name": "OMOCHI Token",
    "symbol": "OMCH",
    "decimals": 18
  },
  "networkId": 5042,
  "redFlags": [],
  "rpc": ["https://5042.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/omochi/testnet/rpc"],
  "shortName": "OMOCHI",
  "slug": "omochi",
  "testnet": true
};

var c5051 = {
  "chain": "Skatechain",
  "chainId": 5051,
  "explorers": [{
    "name": "Nollie Skate Chain Testnet Explorer",
    "url": "https://nolliescan.skatechain.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://QmdofX1W8QFt4TSDaq2wyPvYuUba9LabgD1MYcn3Hezu8h",
    "width": 600,
    "height": 875,
    "format": "png"
  },
  "name": "Nollie Skatechain Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 5051,
  "rpc": ["https://5051.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://nollie-rpc.skatechain.org/"],
  "shortName": "nollie-testnet",
  "slug": "nollie-skatechain-testnet",
  "status": "active",
  "testnet": true
};

var c5100 = {
  "chain": "Syndicate",
  "chainId": 5100,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeSvQcD3XvLFAiMLoQSPbGK9JxVfbCWPBUTMLhhhzYPqX",
    "width": 16000,
    "height": 16000,
    "format": "png"
  },
  "infoURL": "https://syndicate.io",
  "name": "Syndicate Testnet",
  "nativeCurrency": {
    "name": "S-Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 5100,
  "rpc": ["https://5100.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.syndicate.io"],
  "shortName": "syndicate-chain-testnet",
  "slug": "syndicate-testnet",
  "status": "incubating",
  "testnet": true,
  "title": "Syndicate Testnet"
};

var c5101 = {
  "chain": "Syndicate Frame",
  "chainId": 5101,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeSvQcD3XvLFAiMLoQSPbGK9JxVfbCWPBUTMLhhhzYPqX",
    "width": 16000,
    "height": 16000,
    "format": "png"
  },
  "infoURL": "https://syndicate.io",
  "name": "Syndicate Frame Chain",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 5101,
  "rpc": ["https://5101.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-frame.syndicate.io"],
  "shortName": "syndicate-chain-frame",
  "slug": "syndicate-frame-chain",
  "status": "incubating",
  "testnet": false,
  "title": "Syndicate Frame Chain"
};

var c5102 = {
  "chain": "SIC Testnet",
  "chainId": 5102,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorerl2new-sic-testnet-zvr7tlkzsi.t.conduit.xyz",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.fwb.help/",
  "name": "SIC Testnet",
  "nativeCurrency": {
    "name": "ETH",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 5102,
  "rpc": ["https://5102.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-sic-testnet-zvr7tlkzsi.t.conduit.xyz"],
  "shortName": "sic-testnet",
  "slug": "sic-testnet",
  "testnet": true
};

var c5103 = {
  "chain": "Coordinape Testnet",
  "chainId": 5103,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://coordinape.com/",
  "name": "Coordinape Testnet",
  "nativeCurrency": {
    "name": "ETH",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 5103,
  "rpc": ["https://5103.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-coordinape-testnet-vs9se3oc4v.t.conduit.xyz"],
  "shortName": "coordinape-testnet",
  "slug": "coordinape-testnet",
  "testnet": true
};

var c5104 = {
  "chain": "Charmverse Testnet",
  "chainId": 5104,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://charmverse.io/",
  "name": "Charmverse Testnet",
  "nativeCurrency": {
    "name": "ETH",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 5104,
  "rpc": ["https://5104.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-charmverse-testnet-g6blnaebes.t.conduit.xyz"],
  "shortName": "charmverse-testnet",
  "slug": "charmverse-testnet",
  "testnet": true
};

var c5105 = {
  "chain": "Superloyalty Testnet",
  "chainId": 5105,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.superloyal.com/",
  "name": "Superloyalty Testnet",
  "nativeCurrency": {
    "name": "ETH",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 5105,
  "rpc": ["https://5105.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-superloyalty-testnet-1m5gwjbsv1.t.conduit.xyz"],
  "shortName": "superloyalty-testnet",
  "slug": "superloyalty-testnet",
  "testnet": true
};

var c5106 = {
  "chain": "Azra Testnet",
  "chainId": 5106,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorerl2new-azra-testnet-6hz86owb1n.t.conduit.xyz",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://azragames.com",
  "name": "Azra Testnet",
  "nativeCurrency": {
    "name": "ETH",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 5106,
  "rpc": ["https://5106.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-azra-testnet-6hz86owb1n.t.conduit.xyz"],
  "shortName": "azra-testnet",
  "slug": "azra-testnet",
  "testnet": true
};

var c5165 = {
  "chain": "Bahamut",
  "chainId": 5165,
  "explorers": [{
    "name": "blockscout",
    "url": "https://ftnscan.com",
    "standard": "none"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmSemioP83RXnDWwTZbet8VpwJxcFRboX4B3pcdhLZGodP",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://bahamut.io",
  "name": "Bahamut",
  "nativeCurrency": {
    "name": "FTN",
    "symbol": "FTN",
    "decimals": 18
  },
  "networkId": 5165,
  "rpc": ["https://5165.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc1.bahamut.io", "https://rpc2.bahamut.io", "wss://ws1.sahara.bahamutchain.com", "wss://ws2.sahara.bahamutchain.com", "https://bahamut-rpc.publicnode.com", "wss://bahamut-rpc.publicnode.com"],
  "shortName": "ftn",
  "slug": "bahamut",
  "testnet": false,
  "title": "Bahamut mainnet"
};

var c5169 = {
  "chain": "SLN",
  "chainId": 5169,
  "explorers": [{
    "name": "SLN Mainnet Explorer",
    "url": "https://explorer.main.smartlayer.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.smartlayer.network/",
  "name": "Smart Layer Network",
  "nativeCurrency": {
    "name": "Service Unit Token",
    "symbol": "SU",
    "decimals": 18
  },
  "networkId": 5169,
  "rpc": ["https://5169.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.main.smartlayer.network"],
  "shortName": "SLN",
  "slug": "smart-layer-network",
  "testnet": false
};

var c5177 = {
  "chain": "TLC",
  "chainId": 5177,
  "explorers": [{
    "name": "TLChain Explorer",
    "url": "https://explorer.tlchain.network",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmaR5TsgnWSjLys6wGaciKUbc5qYL3Es4jtgQcosVqDWR3",
    "width": 2048,
    "height": 2048,
    "format": "png"
  },
  "infoURL": "https://tlchain.network/",
  "name": "TLChain Network Mainnet",
  "nativeCurrency": {
    "name": "TLChain Network",
    "symbol": "TLC",
    "decimals": 18
  },
  "networkId": 5177,
  "rpc": ["https://5177.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.tlxscan.com/"],
  "shortName": "tlc",
  "slug": "tlchain-network",
  "testnet": false
};

var c5197 = {
  "chain": "ESN",
  "chainId": 5197,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmV1wZ1RVXeD7216aiVBpLkbBBHWNuoTvcSzpVQsqi2uaH",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://eraswap.info/",
  "name": "EraSwap Mainnet",
  "nativeCurrency": {
    "name": "EraSwap",
    "symbol": "ES",
    "decimals": 18
  },
  "networkId": 5197,
  "rpc": ["https://5197.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.eraswap.network", "https://rpc-mumbai.mainnet.eraswap.network"],
  "shortName": "es",
  "slug": "eraswap",
  "testnet": false
};

var c5234 = {
  "chain": "HMND",
  "chainId": 5234,
  "explorers": [{
    "name": "Subscan",
    "url": "https://humanode.subscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://Qma2GfW5nQHuA7nGqdEfwaXPL63G9oTwRTQKaGTfjNtM2W",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeihuskzfwqogwvutaxil6sztmvpiavzbrzwjwpn6w2i4j3jysbybra",
    "width": 1043,
    "height": 1043,
    "format": "png"
  },
  "infoURL": "https://humanode.io",
  "name": "Humanode Mainnet",
  "nativeCurrency": {
    "name": "eHMND",
    "symbol": "eHMND",
    "decimals": 18
  },
  "networkId": 5234,
  "rpc": ["https://5234.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://explorer-rpc-http.mainnet.stages.humanode.io"],
  "shortName": "hmnd",
  "slug": "humanode",
  "testnet": false
};

var c5290 = {
  "chain": "FIRE",
  "chainId": 5290,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYjuztyURb3Fc6ZTLgCbwQa64CcVoigF5j9cafzuSbqgf",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://thefirechain.com",
  "name": "Firechain Mainnet Old",
  "nativeCurrency": {
    "name": "Firechain",
    "symbol": "FIRE",
    "decimals": 18
  },
  "networkId": 5290,
  "rpc": ["https://5290.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.rpc1.thefirechain.com"],
  "shortName": "_old_fire",
  "slug": "firechain-old",
  "status": "deprecated",
  "testnet": false
};

var c5315 = {
  "chain": "UZMI",
  "chainId": 5315,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://uzmigames.com.br/",
  "name": "Uzmi Network Mainnet",
  "nativeCurrency": {
    "name": "UZMI",
    "symbol": "UZMI",
    "decimals": 18
  },
  "networkId": 5315,
  "rpc": ["https://5315.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://network.uzmigames.com.br/"],
  "shortName": "UZMI",
  "slug": "uzmi-network",
  "testnet": false
};

var c5317 = {
  "chain": "OpTrust",
  "chainId": 5317,
  "explorers": [{
    "name": "OpTrust Testnet explorer",
    "url": "https://scantest.optrust.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmYktPMo4tdQhMA9nRJBVckjzHcFLbpHbTVNSpGUUPEP8J",
      "width": 500,
      "height": 500,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYktPMo4tdQhMA9nRJBVckjzHcFLbpHbTVNSpGUUPEP8J",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://optrust.io",
  "name": "OpTrust Testnet",
  "nativeCurrency": {
    "name": "TestBSC",
    "symbol": "tBNB",
    "decimals": 18
  },
  "networkId": 5317,
  "rpc": ["https://5317.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpctest.optrust.io"],
  "shortName": "toptrust",
  "slug": "optrust-testnet",
  "testnet": true
};

var c5353 = {
  "chain": "TRITANIUM",
  "chainId": 5353,
  "explorers": [{
    "name": "TRITANIUM Testnet Explorer",
    "url": "https://testnet.tritanium.network",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmRm6gcEPJmU9a86zrmyP7FALTN4Toz9HrnrL2Kwg6FPeh",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.tritanium.network"],
  "icon": {
    "url": "ipfs://QmRm6gcEPJmU9a86zrmyP7FALTN4Toz9HrnrL2Kwg6FPeh",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://tritanium.network",
  "name": "Tritanium Testnet",
  "nativeCurrency": {
    "name": "Tritanium Native Token",
    "symbol": "tTRN",
    "decimals": 18
  },
  "networkId": 5353,
  "rpc": ["https://5353.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://nodetestnet-station-one.tritanium.network/", "https://nodetestnet-station-two.tritanium.network/"],
  "shortName": "ttrn",
  "slip44": 1,
  "slug": "tritanium-testnet",
  "testnet": true
};

var c5439 = {
  "chain": "EGAX",
  "chainId": 5439,
  "explorers": [{
    "name": "egoscan",
    "url": "https://egoscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://docs.egochain.org/",
  "name": "Egochain",
  "nativeCurrency": {
    "name": "EGAX",
    "symbol": "EGAX",
    "decimals": 18
  },
  "networkId": 5439,
  "rpc": ["https://5439.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.egochain.org"],
  "shortName": "egax",
  "slug": "egochain",
  "testnet": false
};

var c5522 = {
  "chain": "vex",
  "chainId": 5522,
  "explorers": [{
    "name": "Vexascan-EVM-TestNet",
    "url": "https://testnet.vexascan.com/evmexplorer",
    "standard": "EIP3091"
  }],
  "faucets": ["https://t.me/vexfaucetbot"],
  "infoURL": "https://vexanium.com",
  "name": "VEX EVM TESTNET",
  "nativeCurrency": {
    "name": "VEX EVM TESTNET",
    "symbol": "VEX",
    "decimals": 18
  },
  "networkId": 5522,
  "rpc": ["https://5522.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.vexascan.com/evmapi"],
  "shortName": "VEX",
  "slip44": 1,
  "slug": "vex-evm-testnet",
  "testnet": true
};

var c5551 = {
  "chain": "Nahmii",
  "chainId": 5551,
  "explorers": [{
    "name": "Nahmii mainnet explorer",
    "url": "https://explorer.nahmii.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmZhKXgoGpzvthr2eh8ZNgT75YvMtEBegdELAaMPPzf5QT",
      "width": 384,
      "height": 384,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZhKXgoGpzvthr2eh8ZNgT75YvMtEBegdELAaMPPzf5QT",
    "width": 384,
    "height": 384,
    "format": "png"
  },
  "infoURL": "https://nahmii.io",
  "name": "Nahmii Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 5551,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.nahmii.io"
    }]
  },
  "rpc": ["https://5551.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://l2.nahmii.io"],
  "shortName": "Nahmii",
  "slug": "nahmii",
  "testnet": false
};

var c5553 = {
  "chain": "Nahmii",
  "chainId": 5553,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.testnet.nahmii.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmZhKXgoGpzvthr2eh8ZNgT75YvMtEBegdELAaMPPzf5QT",
      "width": 384,
      "height": 384,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZhKXgoGpzvthr2eh8ZNgT75YvMtEBegdELAaMPPzf5QT",
    "width": 384,
    "height": 384,
    "format": "png"
  },
  "infoURL": "https://nahmii.io",
  "name": "Nahmii Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 5553,
  "parent": {
    "type": "L2",
    "chain": "eip155-3",
    "bridges": [{
      "url": "https://bridge.nahmii.io"
    }]
  },
  "rpc": ["https://5553.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://l2.testnet.nahmii.io"],
  "shortName": "NahmiiTestnet",
  "slip44": 1,
  "slug": "nahmii-testnet",
  "testnet": true
};

var c5555 = {
  "chain": "CVERSE",
  "chainId": 5555,
  "explorers": [{
    "name": "Chain Verse Explorer",
    "url": "https://explorer.chainverse.info",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQyJt28h4wN3QHPXUQJQYQqGiFUD77han3zibZPzHbitk",
    "width": 1000,
    "height": 1436,
    "format": "png"
  },
  "infoURL": "https://chainverse.info",
  "name": "Chain Verse Mainnet",
  "nativeCurrency": {
    "name": "Oasys",
    "symbol": "OAS",
    "decimals": 18
  },
  "networkId": 5555,
  "rpc": ["https://5555.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.chainverse.info"],
  "shortName": "cverse",
  "slug": "chain-verse",
  "testnet": false
};

var c5611 = {
  "chain": "opBNB",
  "chainId": 5611,
  "explorers": [{
    "name": "bscscan-opbnb-testnet",
    "url": "https://opbnb-testnet.bscscan.com",
    "standard": "EIP3091"
  }, {
    "name": "opbnbscan",
    "url": "https://opbnbscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://testnet.bnbchain.org/faucet-smart"],
  "icon": {
    "url": "ipfs://bafybeib75gwytvblyvjpfminitr3i6mpat3a624udfsqsl5nysf5vuuvie",
    "width": 96,
    "height": 96,
    "format": "png"
  },
  "infoURL": "https://opbnb.bnbchain.org/en",
  "name": "opBNB Testnet",
  "nativeCurrency": {
    "name": "BNB Chain Native Token",
    "symbol": "tBNB",
    "decimals": 18
  },
  "networkId": 5611,
  "rpc": ["https://5611.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://opbnb-testnet-rpc.bnbchain.org", "https://opbnb-testnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3", "wss://opbnb-testnet.nodereal.io/ws/v1/64a9df0874fb4a93b9d0a3849de012d3", "https://opbnb-testnet.nodereal.io/v1/e9a36765eb8a40b9bd12e680a1fd2bc5", "wss://opbnb-testnet.nodereal.io/ws/v1/e9a36765eb8a40b9bd12e680a1fd2bc5", "https://opbnb-testnet-rpc.publicnode.com", "wss://opbnb-testnet-rpc.publicnode.com"],
  "shortName": "obnbt",
  "slip44": 1,
  "slug": "opbnb-testnet",
  "testnet": true
};

var c5615 = {
  "chain": "Arcturus",
  "chainId": 5615,
  "explorers": [{
    "name": "explorer-arcturus-testnet",
    "url": "https://testnet.arcscan.net",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.arcturuschain.io"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://arcturuschain.io",
  "name": "Arcturus Testneet",
  "nativeCurrency": {
    "name": "tARC",
    "symbol": "tARC",
    "decimals": 18
  },
  "networkId": 5615,
  "rpc": ["https://5615.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.arcturuschain.io/"],
  "shortName": "arcturus-testnet",
  "slug": "arcturus-testneet",
  "testnet": true
};

var c5616 = {
  "chain": "ARCTURUS",
  "chainId": 5616,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://arcturuschain.io",
  "name": "Arcturus Chain Testnet",
  "nativeCurrency": {
    "name": "Test Arct",
    "symbol": "tARCT",
    "decimals": 18
  },
  "networkId": 5616,
  "rpc": ["https://5616.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://185.99.196.3:8545"],
  "shortName": "ARCT",
  "slip44": 1,
  "slug": "arcturus-chain-testnet",
  "testnet": true
};

var c5678 = {
  "chain": "EVMCC",
  "chainId": 5678,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://tanssi.network",
  "name": "Tanssi EVM ContainerChain",
  "nativeCurrency": {
    "name": "TANGO",
    "symbol": "TANGO",
    "decimals": 18
  },
  "networkId": 5678,
  "rpc": ["https://5678.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://fraa-dancebox-3001-rpc.a.dancebox.tanssi.network", "wss://fraa-dancebox-3001-rpc.a.dancebox.tanssi.network"],
  "shortName": "TanssiCC",
  "slug": "tanssi-evm-containerchain",
  "testnet": false
};

var c5700 = {
  "chain": "SYS",
  "chainId": 5700,
  "explorers": [{
    "name": "Syscoin Testnet Block Explorer",
    "url": "https://tanenbaum.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.tanenbaum.io"],
  "infoURL": "https://syscoin.org",
  "name": "Syscoin Tanenbaum Testnet",
  "nativeCurrency": {
    "name": "Testnet Syscoin",
    "symbol": "tSYS",
    "decimals": 18
  },
  "networkId": 5700,
  "rpc": ["https://5700.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.tanenbaum.io", "wss://rpc.tanenbaum.io/wss", "https://syscoin-tanenbaum-evm.publicnode.com", "wss://syscoin-tanenbaum-evm.publicnode.com"],
  "shortName": "tsys",
  "slip44": 1,
  "slug": "syscoin-tanenbaum-testnet",
  "testnet": true
};

var c5729 = {
  "chain": "HIK",
  "chainId": 5729,
  "explorers": [{
    "name": "Hika Network Testnet Explorer",
    "url": "https://scan-testnet.hika.network",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmW44FPm3CMM2JDs8BQxLNvUtykkUtrGkQkQsUDJSi3Gmp",
    "width": 350,
    "height": 84,
    "format": "png"
  },
  "infoURL": "https://hika.network/",
  "name": "Hika Network Testnet",
  "nativeCurrency": {
    "name": "Hik Token",
    "symbol": "HIK",
    "decimals": 18
  },
  "networkId": 5729,
  "rpc": ["https://5729.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.hika.network/"],
  "shortName": "hik",
  "slug": "hika-network-testnet",
  "testnet": true,
  "title": "Hika Network Testnet"
};

var c5758 = {
  "chain": "SATS",
  "chainId": 5758,
  "explorers": [{
    "name": "SatoshiChain Testnet Explorer",
    "url": "https://testnet.satoshiscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.satoshichain.io"],
  "icon": {
    "url": "ipfs://QmRegpZQBW4o1imYNsW3d27MQjygBSU23Gf6JKje26nvs7",
    "width": 1251,
    "height": 1251,
    "format": "png"
  },
  "infoURL": "https://satoshichain.net",
  "name": "SatoshiChain Testnet",
  "nativeCurrency": {
    "name": "SatoshiChain Coin",
    "symbol": "SATS",
    "decimals": 18
  },
  "networkId": 5758,
  "rpc": ["https://5758.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.satoshichain.io"],
  "shortName": "satst",
  "slip44": 1,
  "slug": "satoshichain-testnet",
  "testnet": true
};

var c5777 = {
  "chain": "ETH",
  "chainId": 5777,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmc9N7V8CiLB4r7FEcG7GojqfiGGsRCZqcFWCahwMohbDW",
    "width": 267,
    "height": 300,
    "format": "png"
  },
  "infoURL": "https://trufflesuite.com/ganache/",
  "name": "Ganache",
  "nativeCurrency": {
    "name": "Ganache Test Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 5777,
  "rpc": ["https://5777.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://127.0.0.1:7545"],
  "shortName": "ggui",
  "slip44": 1,
  "slug": "ganache",
  "testnet": true,
  "title": "Ganache GUI Ethereum Testnet"
};

var c5810 = {
  "chain": "Avalanche",
  "chainId": 5810,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Reg Tnet",
  "nativeCurrency": {
    "name": "Reg Tnet Token",
    "symbol": "LUG",
    "decimals": 18
  },
  "networkId": 5810,
  "redFlags": [],
  "rpc": ["https://5810.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Reg Tnet",
  "slug": "reg-tnet",
  "testnet": true
};

var c5851 = {
  "chain": "Ontology",
  "chainId": 5851,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer.ont.io/testnet",
    "standard": "EIP3091"
  }],
  "faucets": ["https://developer.ont.io/"],
  "icon": {
    "url": "ipfs://bafkreigmvn6spvbiirtutowpq6jmetevbxoof5plzixjoerbeswy4htfb4",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://ont.io/",
  "name": "Ontology Testnet",
  "nativeCurrency": {
    "name": "ONG",
    "symbol": "ONG",
    "decimals": 18
  },
  "networkId": 5851,
  "rpc": ["https://5851.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://polaris1.ont.io:20339", "http://polaris2.ont.io:20339", "http://polaris3.ont.io:20339", "http://polaris4.ont.io:20339", "https://polaris1.ont.io:10339", "https://polaris2.ont.io:10339", "https://polaris3.ont.io:10339", "https://polaris4.ont.io:10339"],
  "shortName": "OntologyTestnet",
  "slip44": 1,
  "slug": "ontology-testnet",
  "testnet": true
};

var c5869 = {
  "chain": "RBD",
  "chainId": 5869,
  "explorers": [{
    "name": "wegoscan2",
    "url": "https://scan2.wegochain.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.wegochain.io",
  "name": "Wegochain Rubidium Mainnet",
  "nativeCurrency": {
    "name": "Rubid",
    "symbol": "RBD",
    "decimals": 18
  },
  "networkId": 5869,
  "rpc": ["https://5869.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://proxy.wegochain.io", "http://wallet.wegochain.io:7764"],
  "shortName": "rbd",
  "slug": "wegochain-rubidium",
  "testnet": false
};

var c6000 = {
  "chain": "BounceBit",
  "chainId": 6000,
  "explorers": [{
    "name": "BBScan Testnet Explorer",
    "url": "https://bbscan.io",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://bouncebit.io",
  "name": "BounceBit Testnet",
  "nativeCurrency": {
    "name": "BounceBit",
    "symbol": "BB",
    "decimals": 18
  },
  "networkId": 6000,
  "rpc": ["https://6000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://fullnode-testnet.bouncebitapi.com/"],
  "shortName": "bouncebit-testnet",
  "slug": "bouncebit-testnet",
  "testnet": true
};

var c6065 = {
  "chain": "TresLeches",
  "chainId": 6065,
  "explorers": [{
    "name": "treslechesexplorer",
    "url": "https://explorer-test.tresleches.finance",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmS33ypsZ1Hx5LMMACaJaxePy9QNYMwu4D12niobExLK74",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": ["http://faucet.tresleches.finance:8080"],
  "icon": {
    "url": "ipfs://QmS33ypsZ1Hx5LMMACaJaxePy9QNYMwu4D12niobExLK74",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://treschain.com",
  "name": "Tres Testnet",
  "nativeCurrency": {
    "name": "TRES",
    "symbol": "TRES",
    "decimals": 18
  },
  "networkId": 6065,
  "rpc": ["https://6065.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-test.tresleches.finance/"],
  "shortName": "TRESTEST",
  "slip44": 1,
  "slug": "tres-testnet",
  "testnet": true
};

var c6066 = {
  "chain": "TresLeches",
  "chainId": 6066,
  "explorers": [{
    "name": "treslechesexplorer",
    "url": "https://explorer.tresleches.finance",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmS33ypsZ1Hx5LMMACaJaxePy9QNYMwu4D12niobExLK74",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmS33ypsZ1Hx5LMMACaJaxePy9QNYMwu4D12niobExLK74",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://treschain.com",
  "name": "Tres Mainnet",
  "nativeCurrency": {
    "name": "TRES",
    "symbol": "TRES",
    "decimals": 18
  },
  "networkId": 6066,
  "rpc": ["https://6066.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.tresleches.finance/", "https://rpc.treschain.io/"],
  "shortName": "TRESMAIN",
  "slug": "tres",
  "testnet": false
};

var c6102 = {
  "chain": "Cascadia",
  "chainId": 6102,
  "explorers": [{
    "name": "Cascadia EVM Explorer",
    "url": "https://explorer.cascadia.foundation",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmQtcwxNiJ9D1QDz4k6jZ7qacLcqMk6CeW85TTBWBvNp3z",
      "width": 256,
      "height": 256,
      "format": "png"
    }
  }, {
    "name": "Cascadia Cosmos Explorer",
    "url": "https://validator.cascadia.foundation",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmQtcwxNiJ9D1QDz4k6jZ7qacLcqMk6CeW85TTBWBvNp3z",
      "width": 256,
      "height": 256,
      "format": "png"
    }
  }],
  "faucets": ["https://www.cascadia.foundation/faucet"],
  "icon": {
    "url": "ipfs://QmQtcwxNiJ9D1QDz4k6jZ7qacLcqMk6CeW85TTBWBvNp3z",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://www.cascadia.foundation",
  "name": "Cascadia Testnet",
  "nativeCurrency": {
    "name": "CC",
    "symbol": "tCC",
    "decimals": 18
  },
  "networkId": 6102,
  "rpc": ["https://6102.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.cascadia.foundation"],
  "shortName": "cascadia",
  "slug": "cascadia-testnet",
  "testnet": true
};

var c6118 = {
  "chain": "UPTN",
  "chainId": 6118,
  "explorers": [{
    "name": "UPTN Testnet Explorer",
    "url": "https://testnet.explorer.uptn.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://Qma6cGPCDcJPFxy5KQaMBrLtuVQiqeLncXVybcBoQuhai5",
    "width": 128,
    "height": 128,
    "format": "png"
  },
  "infoURL": "https://uptn.io",
  "name": "UPTN Testnet",
  "nativeCurrency": {
    "name": "UPTN",
    "symbol": "UPTN",
    "decimals": 18
  },
  "networkId": 6118,
  "rpc": ["https://6118.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node-api.alp.uptn.io/v1/ext/rpc"],
  "shortName": "UPTN-TEST",
  "slip44": 1,
  "slug": "uptn-testnet",
  "testnet": true
};

var c6119 = {
  "chain": "UPTN",
  "chainId": 6119,
  "explorers": [{
    "name": "UPTN Explorer",
    "url": "https://explorer.uptn.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://Qma6cGPCDcJPFxy5KQaMBrLtuVQiqeLncXVybcBoQuhai5",
    "width": 128,
    "height": 128,
    "format": "png"
  },
  "infoURL": "https://uptn.io",
  "name": "UPTN",
  "nativeCurrency": {
    "name": "UPTN",
    "symbol": "UPTN",
    "decimals": 18
  },
  "networkId": 6119,
  "rpc": ["https://6119.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node-api.uptn.io/v1/ext/rpc"],
  "shortName": "UPTN",
  "slug": "uptn",
  "testnet": false
};

var c6363 = {
  "chain": "DGS",
  "chainId": 6363,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRiAUu3xV5uiX6Nk1iXD5w6qjki5ugGFETRVavzJ2h5QF",
    "width": 370,
    "height": 320,
    "format": "png"
  },
  "name": "Digit Soul Smart Chain",
  "nativeCurrency": {
    "name": "Digit Coin",
    "symbol": "DGC",
    "decimals": 18
  },
  "networkId": 6363,
  "rpc": ["https://6363.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dsc-rpc.digitsoul.co.th"],
  "shortName": "DGS",
  "slug": "digit-soul-smart-chain",
  "testnet": false
};

var c6502 = {
  "chain": "P2P",
  "chainId": 6502,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://peerpay.su.gy",
  "name": "Peerpay",
  "nativeCurrency": {
    "name": "Peerpay",
    "symbol": "P2P",
    "decimals": 18
  },
  "networkId": 6502,
  "rpc": ["https://6502.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://peerpay.su.gy/p2p"],
  "shortName": "Peerpay",
  "slug": "peerpay",
  "testnet": false
};

var c6552 = {
  "chain": "SCOLWEI-testnet",
  "chainId": 6552,
  "explorers": [{
    "name": "Scolscan Testnet Explorer",
    "url": "https://testnet-explorer.scolcoin.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.scolcoin.com"],
  "icon": {
    "url": "ipfs://QmVES1eqDXhP8SdeCpM85wvjmhrQDXGRquQebDrSdvJqpt",
    "width": 792,
    "height": 822,
    "format": "png"
  },
  "infoURL": "https://scolcoin.com",
  "name": "Scolcoin WeiChain Testnet",
  "nativeCurrency": {
    "name": "Scolcoin",
    "symbol": "SCOL",
    "decimals": 18
  },
  "networkId": 6552,
  "rpc": ["https://6552.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.scolcoin.com"],
  "shortName": "SRC-test",
  "slip44": 1,
  "slug": "scolcoin-weichain-testnet",
  "testnet": true
};

var c6565 = {
  "chain": "FOX",
  "chainId": 6565,
  "explorers": [{
    "name": "FOX Testnet Explorer",
    "url": "https://testnet.foxscan.app",
    "standard": "none",
    "icon": {
      "url": "ipfs://Qmbp1rwhtRr6JQRyYqyfLqkbmzXr1T17zbmChsi2ouvg3M",
      "width": 100,
      "height": 100,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.foxchain.app"],
  "icon": {
    "url": "ipfs://Qmbp1rwhtRr6JQRyYqyfLqkbmzXr1T17zbmChsi2ouvg3M",
    "width": 100,
    "height": 100,
    "format": "png"
  },
  "infoURL": "https://foxchain.app",
  "name": "Fox Testnet Network",
  "nativeCurrency": {
    "name": "FOX Native Token",
    "symbol": "tFOX",
    "decimals": 18
  },
  "networkId": 6565,
  "rpc": ["https://6565.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet-v1.foxchain.app/", "https://rpc2-testnet-v1.foxchain.app/", "https://rpc3-testnet-v1.foxchain.app"],
  "shortName": "fox",
  "slip44": 1,
  "slug": "fox-testnet-network",
  "testnet": true
};

var c6626 = {
  "chain": "PixieChain",
  "chainId": 6626,
  "explorers": [{
    "name": "blockscout",
    "url": "https://scan.chain.pixie.xyz",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://chain.pixie.xyz",
  "name": "Pixie Chain Mainnet",
  "nativeCurrency": {
    "name": "Pixie Chain Native Token",
    "symbol": "PIX",
    "decimals": 18
  },
  "networkId": 6626,
  "rpc": ["https://6626.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://http-mainnet.chain.pixie.xyz", "wss://ws-mainnet.chain.pixie.xyz"],
  "shortName": "pixie-chain",
  "slug": "pixie-chain",
  "testnet": false
};

var c6660 = {
  "chain": "LATEST",
  "chainId": 6660,
  "explorers": [{
    "name": "Latest Chain",
    "url": "http://testnet.latestchain.io",
    "standard": "EIP3091"
  }],
  "faucets": ["http://faucet.latestchain.io"],
  "icon": {
    "url": "ipfs://QmUU784i1ZHDNwgXvt9weZmq6YbHHkyXvuDS7r4iDzao72",
    "width": 1115,
    "height": 1242,
    "format": "png"
  },
  "infoURL": "https://latestcoin.io",
  "name": "Latest Chain Testnet",
  "nativeCurrency": {
    "name": "Latest",
    "symbol": "LATEST",
    "decimals": 18
  },
  "networkId": 6660,
  "rpc": ["https://6660.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.latestcoin.io"],
  "shortName": "LATESTt",
  "slug": "latest-chain-testnet",
  "testnet": true
};

var c6661 = {
  "chain": "CYBA",
  "chainId": 6661,
  "explorers": [{
    "name": "Cybria Explorer",
    "url": "https://cybascan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreiagdqfrvnbdjhkh27gjbvepzo66dpqgnbffmpnywuw5ncprg3jk3u",
      "width": 2264,
      "height": 408,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreiarso74bytq5ccnl3mlfhd4ejiylwautsr6ovbqgmynzjzmkorn6y",
    "width": 500,
    "height": 500,
    "format": "svg"
  },
  "infoURL": "https://cybria.io",
  "name": "Cybria Mainnet",
  "nativeCurrency": {
    "name": "Cybria",
    "symbol": "CYBA",
    "decimals": 18
  },
  "networkId": 6661,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155420",
    "bridges": [{
      "url": "https://app.optimism.io/bridge"
    }]
  },
  "rpc": ["https://6661.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mainnet.cybria.io"],
  "shortName": "cyba",
  "slug": "cybria",
  "testnet": false
};

var c6666 = {
  "chain": "CYBA",
  "chainId": 6666,
  "explorers": [{
    "name": "Cybria Explorer",
    "url": "https://explorer.cybascan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreiagdqfrvnbdjhkh27gjbvepzo66dpqgnbffmpnywuw5ncprg3jk3u",
      "width": 2264,
      "height": 408,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.cybascan.io"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreiarso74bytq5ccnl3mlfhd4ejiylwautsr6ovbqgmynzjzmkorn6y",
    "width": 500,
    "height": 500,
    "format": "svg"
  },
  "infoURL": "https://cybria.io",
  "name": "Cybria Testnet",
  "nativeCurrency": {
    "name": "Cybria",
    "symbol": "CYBA",
    "decimals": 18
  },
  "networkId": 6666,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155420",
    "bridges": [{
      "url": "https://app.optimism.io/bridge"
    }]
  },
  "rpc": ["https://6666.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://l2-rpc.cybascan.io"],
  "shortName": "tcyba",
  "slug": "cybria-testnet",
  "testnet": true
};

var c6688 = {
  "chain": "IRIShub",
  "chainId": 6688,
  "explorers": [{
    "name": "IRISHub Cosmos Explorer (IOBScan)",
    "url": "https://irishub.iobscan.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmTKgKs7kJiWDhdjbELE4Y2HVZ36KS4bYkNCbXdsXk66sW",
      "width": 1062,
      "height": 1062,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmTKgKs7kJiWDhdjbELE4Y2HVZ36KS4bYkNCbXdsXk66sW",
    "width": 1062,
    "height": 1062,
    "format": "png"
  },
  "infoURL": "https://www.irisnet.org",
  "name": "IRIShub",
  "nativeCurrency": {
    "name": "Eris",
    "symbol": "ERIS",
    "decimals": 18
  },
  "networkId": 6688,
  "rpc": ["https://6688.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evmrpc.irishub-1.irisnet.org", "https://iris-evm.publicnode.com", "wss://iris-evm.publicnode.com"],
  "shortName": "iris",
  "slug": "irishub",
  "testnet": false
};

var c6701 = {
  "chain": "PAXB",
  "chainId": 6701,
  "explorers": [{
    "name": "PAXB Explorer",
    "url": "https://scan.paxb.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmSP66CHynXpMYkjV28uLjTR4kjuoJyy92igYYpvLoqHtG",
      "width": 300,
      "height": 300,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmSP66CHynXpMYkjV28uLjTR4kjuoJyy92igYYpvLoqHtG",
    "width": 300,
    "height": 300,
    "format": "png"
  },
  "infoURL": "https://paxb.io/",
  "name": "PAXB Mainnet",
  "nativeCurrency": {
    "name": "PAXB",
    "symbol": "PAXB",
    "decimals": 18
  },
  "networkId": 6701,
  "rpc": ["https://6701.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://chain.paxb.io"],
  "shortName": "PAXB",
  "slug": "paxb",
  "testnet": false
};

var c6779 = {
  "chain": "CPV",
  "chainId": 6779,
  "explorers": [{
    "name": "cpvscan",
    "url": "https://scan.compverse.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYbskrGpidbMwsJekTeLrr8Z6GA9q4Uxh7piS1F9BdWWv",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://compverse.io",
  "name": "Compverse Mainnet",
  "nativeCurrency": {
    "name": "compverse",
    "symbol": "CPV",
    "decimals": 18
  },
  "networkId": 6779,
  "rpc": ["https://6779.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.compverse.io/", "https://rpc-useast1.compverse.io/"],
  "shortName": "compverse",
  "slip44": 7779,
  "slug": "compverse",
  "testnet": false
};

var c6789 = {
  "chain": "STAND",
  "chainId": 6789,
  "explorers": [{
    "name": "Gold Smart Chain",
    "url": "https://mainnet.goldsmartchain.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.goldsmartchain.com"],
  "icon": {
    "url": "ipfs://QmPNuymyaKLJhCaXnyrsL8358FeTxabZFsaxMmWNU4Tzt3",
    "width": 396,
    "height": 418,
    "format": "png"
  },
  "infoURL": "https://goldsmartchain.com",
  "name": "Gold Smart Chain Mainnet",
  "nativeCurrency": {
    "name": "Standard in Gold",
    "symbol": "STAND",
    "decimals": 18
  },
  "networkId": 6789,
  "rpc": ["https://6789.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mainnet.goldsmartchain.com"],
  "shortName": "STANDm",
  "slug": "gold-smart-chain",
  "testnet": false
};

var c6969 = {
  "chain": "Tomb Chain",
  "chainId": 6969,
  "explorers": [{
    "name": "tombscout",
    "url": "https://tombscout.com",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://tombchain.com/",
  "name": "Tomb Chain Mainnet",
  "nativeCurrency": {
    "name": "Tomb",
    "symbol": "TOMB",
    "decimals": 18
  },
  "networkId": 6969,
  "parent": {
    "type": "L2",
    "chain": "eip155-250",
    "bridges": [{
      "url": "https://lif3.com/bridge"
    }]
  },
  "rpc": ["https://6969.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.tombchain.com/"],
  "shortName": "tombchain",
  "slug": "tomb-chain",
  "testnet": false
};

var c6999 = {
  "chain": "PSC",
  "chainId": 6999,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.polysmartchain.com/",
  "name": "PolySmartChain",
  "nativeCurrency": {
    "name": "PSC",
    "symbol": "PSC",
    "decimals": 18
  },
  "networkId": 6999,
  "rpc": ["https://6999.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://seed0.polysmartchain.com/", "https://seed1.polysmartchain.com/", "https://seed2.polysmartchain.com/"],
  "shortName": "psc",
  "slug": "polysmartchain",
  "testnet": false
};

var c7000 = {
  "chain": "ZetaChain",
  "chainId": 7000,
  "explorers": [{
    "name": "ZetaChain Mainnet Explorer",
    "url": "https://explorer.mainnet.zetachain.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmP4Gnf4Lkp8q5LQVePNjAWxSqrw8vU2JAf7amcFz4vEUy",
    "width": 712,
    "height": 712,
    "format": "png"
  },
  "infoURL": "https://zetachain.com/docs/",
  "name": "ZetaChain Mainnet",
  "nativeCurrency": {
    "name": "Zeta",
    "symbol": "ZETA",
    "decimals": 18
  },
  "networkId": 7000,
  "rpc": ["https://7000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://zetachain-evm.blockpi.network/v1/rpc/public", "https://zetachain-mainnet-archive.allthatnode.com:8545"],
  "shortName": "zetachain-mainnet",
  "slug": "zetachain",
  "status": "active",
  "testnet": false
};

var c7001 = {
  "chain": "ZetaChain",
  "chainId": 7001,
  "explorers": [{
    "name": "blockscout",
    "url": "https://zetachain-athens-3.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }, {
    "name": "ZetaChain Athens Testnet Explorer",
    "url": "https://athens3.explorer.zetachain.com",
    "standard": "none"
  }],
  "faucets": ["https://labs.zetachain.com/get-zeta"],
  "icon": {
    "url": "ipfs://QmP4Gnf4Lkp8q5LQVePNjAWxSqrw8vU2JAf7amcFz4vEUy",
    "width": 712,
    "height": 712,
    "format": "png"
  },
  "infoURL": "https://zetachain.com/docs",
  "name": "ZetaChain Athens 3 Testnet",
  "nativeCurrency": {
    "name": "Zeta",
    "symbol": "ZETA",
    "decimals": 18
  },
  "networkId": 7001,
  "rpc": ["https://7001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://zetachain-athens-evm.blockpi.network/v1/rpc/public", "wss://zetachain-athens.blockpi.network/rpc/v1/public/websocket", "https://zetachain-testnet-archive.allthatnode.com:8545"],
  "shortName": "zetachain-athens",
  "slip44": 1,
  "slug": "zetachain-athens-3-testnet",
  "status": "active",
  "testnet": true
};

var c7007 = {
  "chain": "BSTC",
  "chainId": 7007,
  "explorers": [{
    "name": "blockscout",
    "url": "https://bstscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPko9BJhR5FWTsThcwUFnnnjgLjrXVDm1n98dCuaQNW59",
    "width": 506,
    "height": 652,
    "format": "png"
  },
  "infoURL": "https://bstchain.io",
  "name": "BST Chain",
  "nativeCurrency": {
    "name": "BST Chain",
    "symbol": "BSTC",
    "decimals": 18
  },
  "networkId": 7007,
  "rpc": ["https://7007.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.bstchain.io/"],
  "shortName": "BSTC",
  "slug": "bst-chain",
  "testnet": false
};

var c7027 = {
  "chain": "ella",
  "chainId": 7027,
  "explorers": [{
    "name": "Ella",
    "url": "https://ella.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVkAhSaHhH3wKoLT56Aq8dNyEH4RySPEpqPcLwsptGBDm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://ella.network",
  "name": "Ella the heart",
  "nativeCurrency": {
    "name": "Ella",
    "symbol": "ELLA",
    "decimals": 18
  },
  "networkId": 7027,
  "rpc": ["https://7027.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.ella.network"],
  "shortName": "ELLA",
  "slug": "ella-the-heart",
  "testnet": false
};

var c7070 = {
  "chain": "Planq",
  "chainId": 7070,
  "explorers": [{
    "name": "Planq EVM Explorer (Blockscout)",
    "url": "https://evm.planq.network",
    "standard": "none"
  }, {
    "name": "Planq Cosmos Explorer (BigDipper)",
    "url": "https://explorer.planq.network",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWEy9xK5BoqxPuVs7T48WM4exJrxzkEFt45iHcxWqUy8D",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://planq.network",
  "name": "Planq Mainnet",
  "nativeCurrency": {
    "name": "Planq",
    "symbol": "PLQ",
    "decimals": 18
  },
  "networkId": 7070,
  "rpc": ["https://7070.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm-rpc.planq.network"],
  "shortName": "planq",
  "slug": "planq",
  "testnet": false
};

var c7100 = {
  "chain": "Nume",
  "chainId": 7100,
  "explorers": [{
    "name": "numeexplorer",
    "url": "https://explorer.numecrypto.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmNbp1K6vKKFYh7bWeWtjBqKgdH88suDVbztP5CYU3pYNG",
      "width": 1280,
      "height": 1280,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNbp1K6vKKFYh7bWeWtjBqKgdH88suDVbztP5CYU3pYNG",
    "width": 1280,
    "height": 1280,
    "format": "png"
  },
  "infoURL": "https://numecrypto.com",
  "name": "Nume",
  "nativeCurrency": {
    "name": "Dai Stablecoin",
    "symbol": "DAI",
    "decimals": 18
  },
  "networkId": 7100,
  "rpc": ["https://7100.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.numecrypto.com"],
  "shortName": "nume",
  "slug": "nume",
  "testnet": false,
  "title": "Nume"
};

var c7118 = {
  "chain": "mainnet",
  "chainId": 7118,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNR4Y3cUxefV7KGpGxMkjp5ofeJvbaUkR1GavsmTtK248",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://hth.world",
  "name": "Help The Homeless",
  "nativeCurrency": {
    "name": "Help The Homeless Coin",
    "symbol": "HTH",
    "decimals": 18
  },
  "networkId": 7118,
  "rpc": [],
  "shortName": "hth",
  "slug": "help-the-homeless",
  "status": "incubating",
  "testnet": false
};

var c7158 = {
  "chain": "Avalanche",
  "chainId": 7158,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "TESTNet FirstTEST",
  "nativeCurrency": {
    "name": "TESTNet FirstTEST Token",
    "symbol": "TEST",
    "decimals": 18
  },
  "networkId": 7158,
  "redFlags": [],
  "rpc": ["https://7158.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/testnetfir/testnet/rpc"],
  "shortName": "TESTNet FirstTEST",
  "slug": "testnet-firsttest",
  "testnet": true
};

var c7171 = {
  "chain": "Bitrock",
  "chainId": 7171,
  "explorers": [{
    "name": "Bitrock Explorer",
    "url": "https://explorer.bit-rock.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmfXZCAh3HWS2bJroUStN9TieL4QA9QArMotie3X4pwBfj",
    "width": 72,
    "height": 72,
    "format": "svg"
  },
  "infoURL": "https://bit-rock.io",
  "name": "Bitrock Mainnet",
  "nativeCurrency": {
    "name": "BITROCK",
    "symbol": "BROCK",
    "decimals": 18
  },
  "networkId": 7171,
  "rpc": ["https://7171.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://connect.bit-rock.io", "https://brockrpc.io"],
  "shortName": "bitrock",
  "slug": "bitrock",
  "testnet": false
};

var c7207 = {
  "chain": "Avalanche",
  "chainId": 7207,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2401222",
  "nativeCurrency": {
    "name": "QI M 2401222 Token",
    "symbol": "HZU",
    "decimals": 18
  },
  "networkId": 7207,
  "redFlags": [],
  "rpc": ["https://7207.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/f14d837e-de8f-446d-8222-0077f26e6694"],
  "shortName": "QI M 2401222",
  "slug": "qi-m-2401222",
  "testnet": true
};

var c7317 = {
  "chain": "Avalanche",
  "chainId": 7317,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser5017 Testnet",
  "nativeCurrency": {
    "name": "QaUser5017 Testnet Token",
    "symbol": "IHS",
    "decimals": 18
  },
  "networkId": 7317,
  "redFlags": [],
  "rpc": ["https://7317.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser5017 Testnet",
  "slug": "qauser5017-testnet",
  "testnet": true
};

var c7326 = {
  "chain": "Avalanche",
  "chainId": 7326,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2403051 Testnet",
  "nativeCurrency": {
    "name": "QI M 2403051 Testnet Token",
    "symbol": "VVC",
    "decimals": 18
  },
  "networkId": 7326,
  "redFlags": [],
  "rpc": ["https://7326.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI M 2403051 Testnet",
  "slug": "qi-m-2403051-testnet",
  "testnet": true
};

var c7331 = {
  "chain": "KLY",
  "chainId": 7331,
  "explorers": [],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmaDr9R6dKnZLsogRxojjq4dwXuXcudR8UeTZ8Nq553K4u",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://klyntar.org",
  "name": "KLYNTAR",
  "nativeCurrency": {
    "name": "KLYNTAR",
    "symbol": "KLY",
    "decimals": 18
  },
  "networkId": 7331,
  "rpc": ["https://7331.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm.klyntar.org/kly_evm_rpc", "https://evm.klyntarscan.org/kly_evm_rpc"],
  "shortName": "kly",
  "slug": "klyntar",
  "status": "incubating",
  "testnet": false
};

var c7332 = {
  "chain": "EON",
  "chainId": 7332,
  "explorers": [{
    "name": "Horizen EON Block Explorer",
    "url": "https://eon-explorer.horizenlabs.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmSFMBk3rMyu45Sy9KQHjgArFj4HdywANNYrSosLMUdcti",
      "width": 1213,
      "height": 1213,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmSFMBk3rMyu45Sy9KQHjgArFj4HdywANNYrSosLMUdcti",
    "width": 1213,
    "height": 1213,
    "format": "png"
  },
  "infoURL": "https://horizen.io/",
  "name": "Horizen EON Mainnet",
  "nativeCurrency": {
    "name": "Zencash",
    "symbol": "ZEN",
    "decimals": 18
  },
  "networkId": 7332,
  "rpc": ["https://7332.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eon-rpc.horizenlabs.io/ethv1", "https://rpc.ankr.com/horizen_eon"],
  "shortName": "EON",
  "slip44": 121,
  "slug": "horizen-eon",
  "testnet": false
};

var c7341 = {
  "chain": "SHYFT",
  "chainId": 7341,
  "explorers": [{
    "name": "Shyft BX",
    "url": "https://bx.shyft.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmUkFZC2ZmoYPTKf7AHdjwRPZoV2h1MCuHaGM4iu8SNFpi",
    "width": 400,
    "height": 400,
    "format": "svg"
  },
  "infoURL": "https://shyft.network",
  "name": "Shyft Mainnet",
  "nativeCurrency": {
    "name": "Shyft",
    "symbol": "SHYFT",
    "decimals": 18
  },
  "networkId": 7341,
  "rpc": ["https://7341.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.shyft.network/"],
  "shortName": "shyft",
  "slip44": 2147490989,
  "slug": "shyft",
  "testnet": false
};

var c7484 = {
  "chain": "Raba",
  "chainId": 7484,
  "explorers": [{
    "name": "raba",
    "url": "https://x.raba.app/explorer",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmatP9qMHEYoXqRDyHMTyjYRQa6j6Gk7pmv1QLxQkvpGRP",
    "width": 787,
    "height": 750,
    "format": "png"
  },
  "infoURL": "https://x.raba.app/",
  "name": "Raba Network Mainnet",
  "nativeCurrency": {
    "name": "Raba",
    "symbol": "RABA",
    "decimals": 18
  },
  "networkId": 7484,
  "rpc": ["https://7484.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.x.raba.app/", "wss://rpc.x.raba.app/ws/"],
  "shortName": "raba",
  "slug": "raba-network",
  "testnet": false
};

var c7507 = {
  "chain": "Avalanche",
  "chainId": 7507,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser7740 Testnet",
  "nativeCurrency": {
    "name": "QaUser7740 Testnet Token",
    "symbol": "RUI",
    "decimals": 18
  },
  "networkId": 7507,
  "redFlags": [],
  "rpc": ["https://7507.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser7740 Testnet",
  "slug": "qauser7740-testnet",
  "testnet": true
};

var c7518 = {
  "chain": "MEVerse",
  "chainId": 7518,
  "explorers": [{
    "name": "MEVerse Chain Explorer",
    "url": "https://www.meversescan.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmPuQ6gaCfUtNdRuaEDbdhot2m2KCy2ZHCJUvZXJAtdeyJ",
      "width": 800,
      "height": 800,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPuQ6gaCfUtNdRuaEDbdhot2m2KCy2ZHCJUvZXJAtdeyJ",
    "width": 800,
    "height": 800,
    "format": "png"
  },
  "infoURL": "https://www.meverse.sg",
  "name": "MEVerse Chain Mainnet",
  "nativeCurrency": {
    "name": "MEVerse",
    "symbol": "MEV",
    "decimals": 18
  },
  "networkId": 7518,
  "rpc": ["https://7518.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.meversemainnet.io"],
  "shortName": "MEV",
  "slug": "meverse-chain",
  "testnet": false
};

var c7575 = {
  "chain": "ADIL",
  "chainId": 7575,
  "explorers": [{
    "name": "ADIL Testnet Explorer",
    "url": "https://testnet.adilchain-scan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://testnet-faucet.adil-scan.io"],
  "icon": {
    "url": "ipfs://QmeHNYUx6n8CjUFSLWNT17oAtDYrUq6r8buyvGCUBXCJw6",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://adilchain.io",
  "name": "ADIL Testnet",
  "nativeCurrency": {
    "name": "Testnet ADIL",
    "symbol": "ADIL",
    "decimals": 18
  },
  "networkId": 7575,
  "rpc": ["https://7575.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.adilchain-rpc.io"],
  "shortName": "tadil",
  "slip44": 1,
  "slug": "adil-testnet",
  "testnet": true
};

var c7576 = {
  "chain": "ADIL",
  "chainId": 7576,
  "explorers": [{
    "name": "ADIL Mainnet Explorer",
    "url": "https://adilchain-scan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeHNYUx6n8CjUFSLWNT17oAtDYrUq6r8buyvGCUBXCJw6",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://adilchain.io",
  "name": "Adil Chain V2 Mainnet",
  "nativeCurrency": {
    "name": "ADIL",
    "symbol": "ADIL",
    "decimals": 18
  },
  "networkId": 7576,
  "rpc": ["https://7576.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://adilchain-rpc.io"],
  "shortName": "adil",
  "slug": "adil-chain-v2",
  "testnet": false
};

var c7640 = {
  "chain": "Avalanche",
  "chainId": 7640,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0205I1",
  "nativeCurrency": {
    "name": "QI0205I1 Token",
    "symbol": "KOA",
    "decimals": 18
  },
  "networkId": 7640,
  "redFlags": [],
  "rpc": ["https://7640.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0205I1",
  "slug": "qi0205i1",
  "testnet": true
};

var c7668 = {
  "chain": "TRN",
  "chainId": 7668,
  "explorers": [{
    "name": "rootnet",
    "url": "https://explorer.rootnet.live",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.futureverse.com/technology/root",
  "name": "The Root Network - Mainnet",
  "nativeCurrency": {
    "name": "XRP",
    "symbol": "XRP",
    "decimals": 6
  },
  "networkId": 7668,
  "rpc": ["https://7668.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://root.rootnet.live/archive", "wss://root.rootnet.live/archive/ws"],
  "shortName": "trn-mainnet",
  "slug": "the-root-network",
  "testnet": false
};

var c7672 = {
  "chain": "TRN",
  "chainId": 7672,
  "explorers": [{
    "name": "rootnet",
    "url": "https://explorer.rootnet.cloud",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.futureverse.com/technology/root",
  "name": "The Root Network - Porcini Testnet",
  "nativeCurrency": {
    "name": "XRP",
    "symbol": "XRP",
    "decimals": 6
  },
  "networkId": 7672,
  "rpc": ["https://7672.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://porcini.rootnet.app/archive", "wss://porcini.rootnet.app/archive/ws"],
  "shortName": "trn-porcini",
  "slip44": 1,
  "slug": "the-root-network-porcini-testnet",
  "testnet": true
};

var c7700 = {
  "chain": "Canto",
  "chainId": 7700,
  "explorers": [{
    "name": "Canto Explorer (OKLink)",
    "url": "https://www.oklink.com/canto",
    "standard": "EIP3091"
  }, {
    "name": "Canto EVM Explorer (Blockscout)",
    "url": "https://tuber.build",
    "standard": "EIP3091"
  }, {
    "name": "dexguru",
    "url": "https://canto.dex.guru",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne",
      "width": 83,
      "height": 82,
      "format": "svg"
    }
  }],
  "faucets": [],
  "infoURL": "https://canto.io",
  "name": "Canto",
  "nativeCurrency": {
    "name": "Canto",
    "symbol": "CANTO",
    "decimals": 18
  },
  "networkId": 7700,
  "rpc": ["https://7700.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://canto.slingshot.finance", "https://canto-rpc.ansybl.io", "https://mainnode.plexnode.org:8545", "https://canto.gravitychain.io/"],
  "shortName": "canto",
  "slug": "canto",
  "testnet": false
};

var c7701 = {
  "chain": "Canto",
  "chainId": 7701,
  "explorers": [{
    "name": "Canto Testnet EVM Explorer (Blockscout)",
    "url": "https://testnet.tuber.build",
    "standard": "none"
  }, {
    "name": "dexguru",
    "url": "https://canto-test.dex.guru",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne",
      "width": 83,
      "height": 82,
      "format": "svg"
    }
  }],
  "faucets": [],
  "infoURL": "https://canto.io",
  "name": "Canto Tesnet",
  "nativeCurrency": {
    "name": "Testnet Canto",
    "symbol": "CANTO",
    "decimals": 18
  },
  "networkId": 7701,
  "rpc": ["https://7701.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-archive.plexnode.wtf"],
  "shortName": "TestnetCanto",
  "slip44": 1,
  "slug": "canto-tesnet",
  "testnet": true
};

var c7771 = {
  "chain": "Bitrock",
  "chainId": 7771,
  "explorers": [{
    "name": "Bitrock Testnet Explorer",
    "url": "https://testnetscan.bit-rock.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.bit-rock.io"],
  "icon": {
    "url": "ipfs://QmfXZCAh3HWS2bJroUStN9TieL4QA9QArMotie3X4pwBfj",
    "width": 72,
    "height": 72,
    "format": "svg"
  },
  "infoURL": "https://bit-rock.io",
  "name": "Bitrock Testnet",
  "nativeCurrency": {
    "name": "BITROCK",
    "symbol": "BROCK",
    "decimals": 18
  },
  "networkId": 7771,
  "rpc": ["https://7771.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.bit-rock.io"],
  "shortName": "tbitrock",
  "slip44": 1,
  "slug": "bitrock-testnet",
  "testnet": true
};

var c7777 = {
  "chain": "nmactest",
  "chainId": 7777,
  "explorers": [{
    "name": "avascan",
    "url": "https://testnet.avascan.info/blockchain/2mZ9doojfwHzXN3VXDQELKnKyZYxv7833U8Yq5eTfFx3hxJtiy",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://riseofthewarbots.com/",
  "name": "Rise of the Warbots Testnet",
  "nativeCurrency": {
    "name": "Nano Machines",
    "symbol": "NMAC",
    "decimals": 18
  },
  "networkId": 7777,
  "rpc": ["https://7777.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet1.riseofthewarbots.com", "https://testnet2.riseofthewarbots.com", "https://testnet3.riseofthewarbots.com", "https://testnet4.riseofthewarbots.com", "https://testnet5.riseofthewarbots.com"],
  "shortName": "RiseOfTheWarbotsTestnet",
  "slip44": 1,
  "slug": "rise-of-the-warbots-testnet",
  "testnet": true
};

var c7778 = {
  "chain": "ORE",
  "chainId": 7778,
  "explorers": [{
    "name": "ORE Mainnet Explorer",
    "url": "https://oreniumscan.org",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmXszYAtQxaFCG3s9vGHoLJnqxGJw2wTKNbruTJ8iDXU7K",
      "width": 200,
      "height": 200,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmXszYAtQxaFCG3s9vGHoLJnqxGJw2wTKNbruTJ8iDXU7K",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://orenium.org",
  "name": "Orenium Mainnet Protocol",
  "nativeCurrency": {
    "name": "ORENIUM",
    "symbol": "ORE",
    "decimals": 18
  },
  "networkId": 7778,
  "rpc": ["https://7778.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://validator-mainnet.orenium.org", "https://rpc-oracle-mainnet.orenium.org", "https://portalmainnet.orenium.org"],
  "shortName": "ore",
  "slip44": 1,
  "slug": "orenium-protocol",
  "testnet": false
};

var c7798 = {
  "chain": "OEX",
  "chainId": 7798,
  "explorers": [{
    "name": "OpenEX Long Testnet Explorer",
    "url": "https://scan.long.openex.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreidnu6p6vmmplerzvkboq7fz73ygkomzpnnokuxstrqv2fvxgmgg7i",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": ["https://long.hub.openex.network/faucet"],
  "icon": {
    "url": "ipfs://bafkreidnu6p6vmmplerzvkboq7fz73ygkomzpnnokuxstrqv2fvxgmgg7i",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://openex.network",
  "name": "OpenEX LONG Testnet",
  "nativeCurrency": {
    "name": "USDT Testnet",
    "symbol": "USDT",
    "decimals": 18
  },
  "networkId": 7798,
  "rpc": ["https://7798.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://long.rpc.openex.network/"],
  "shortName": "oex",
  "slip44": 1,
  "slug": "openex-long-testnet",
  "testnet": true,
  "title": "OpenEX LONG Testnet"
};

var c7860 = {
  "chain": "MaalChain Testnet",
  "chainId": 7860,
  "explorers": [{
    "name": "maalscan testnet",
    "url": "https://testnet.maalscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet-testnet.maalscan.io/"],
  "icon": {
    "url": "ipfs://bafkreiexfqfe2x4impvwhra3xxa5eb25gv25zi3kkaoatdnld7wbxdzf2a",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://www.maalchain.com/",
  "name": "MaalChain Testnet",
  "nativeCurrency": {
    "name": "MAAL",
    "symbol": "MAAL",
    "decimals": 18
  },
  "networkId": 7860,
  "rpc": ["https://7860.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node1.maalscan.io/", "https://rpc-bntest.maalscan.io/"],
  "shortName": "maal-test",
  "slip44": 1,
  "slug": "maalchain-testnet",
  "testnet": true
};

var c7865 = {
  "chain": "Avalanche",
  "chainId": 7865,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "ST 02-07",
  "nativeCurrency": {
    "name": "ST 02-07 Token",
    "symbol": "TJO",
    "decimals": 18
  },
  "networkId": 7865,
  "redFlags": [],
  "rpc": ["https://7865.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "ST 02-07",
  "slug": "st-02-07",
  "testnet": true
};

var c7872 = {
  "chain": "Avalanche",
  "chainId": 7872,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QAUSer4 Testnet",
  "nativeCurrency": {
    "name": "QAUSer4 Testnet Token",
    "symbol": "VVC",
    "decimals": 18
  },
  "networkId": 7872,
  "redFlags": [],
  "rpc": ["https://7872.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QAUSer4 Testnet",
  "slug": "qauser4-testnet",
  "testnet": true
};

var c7878 = {
  "chain": "SCAS",
  "chainId": 7878,
  "explorers": [{
    "name": "Hazlor Testnet Explorer",
    "url": "https://explorer.hazlor.com",
    "standard": "none"
  }],
  "faucets": ["https://faucet.hazlor.com"],
  "infoURL": "https://hazlor.com",
  "name": "Hazlor Testnet",
  "nativeCurrency": {
    "name": "Hazlor Test Coin",
    "symbol": "TSCAS",
    "decimals": 18
  },
  "networkId": 7878,
  "rpc": ["https://7878.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://hatlas.rpc.hazlor.com:8545", "wss://hatlas.rpc.hazlor.com:8546"],
  "shortName": "tscas",
  "slip44": 1,
  "slug": "hazlor-testnet",
  "testnet": true
};

var c7887 = {
  "chain": "Kinto Mainnet",
  "chainId": 7887,
  "explorers": [{
    "name": "Kinto Explorer",
    "url": "https://explorer.kinto.xyz",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmZw4zfR4Q8MD6MZRwkQrMeiiiu77AJffHdCMdemt4R2VM",
      "width": 400,
      "height": 400,
      "format": "jpg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZw4zfR4Q8MD6MZRwkQrMeiiiu77AJffHdCMdemt4R2VM",
    "width": 400,
    "height": 400,
    "format": "jpg"
  },
  "infoURL": "https://kinto.xyz",
  "name": "Kinto Mainnet",
  "nativeCurrency": {
    "name": "Ethereum",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 7887,
  "rpc": ["https://7887.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.kinto.xyz/http", "https://kinto-mainnet.calderachain.xyz/http"],
  "shortName": "kintoMainnet",
  "slug": "kinto",
  "testnet": false
};

var c7895 = {
  "chain": "ATHENA",
  "chainId": 7895,
  "explorers": [{
    "name": "ARDENIUM Athena Explorer",
    "url": "https://testnet.ardscan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmdwifhejRfF8QfyzYrNdFVhfhCR6iuzWMmppK4eL7kttG",
      "width": 120,
      "height": 120,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet-athena.ardescan.com/"],
  "icon": {
    "url": "ipfs://QmdwifhejRfF8QfyzYrNdFVhfhCR6iuzWMmppK4eL7kttG",
    "width": 120,
    "height": 120,
    "format": "png"
  },
  "infoURL": "https://ardenium.org",
  "name": "ARDENIUM Athena",
  "nativeCurrency": {
    "name": "ARD",
    "symbol": "tARD",
    "decimals": 18
  },
  "networkId": 7895,
  "rpc": ["https://7895.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-athena.ardescan.com/"],
  "shortName": "ard",
  "slug": "ardenium-athena",
  "testnet": true
};

var c7909 = {
  "chain": "Avalanche",
  "chainId": 7909,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser3870 Testnet",
  "nativeCurrency": {
    "name": "QaUser3870 Testnet Token",
    "symbol": "RAY",
    "decimals": 18
  },
  "networkId": 7909,
  "redFlags": [],
  "rpc": ["https://7909.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser3870 Testnet",
  "slug": "qauser3870-testnet",
  "testnet": true
};

var c7979 = {
  "chain": "DOS",
  "chainId": 7979,
  "explorers": [{
    "name": "DOScan",
    "url": "https://doscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmV2Nowzo81F6pi2qFcHePA4MwmmdMKBMUzBJUrxcymxx4",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }, {
    "name": "DOScan",
    "url": "https://explorer.doschain.com/",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmV2Nowzo81F6pi2qFcHePA4MwmmdMKBMUzBJUrxcymxx4",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmV2Nowzo81F6pi2qFcHePA4MwmmdMKBMUzBJUrxcymxx4",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://doschain.com/",
  "name": "DOS Chain",
  "nativeCurrency": {
    "name": "DOS",
    "symbol": "DOS",
    "decimals": 18
  },
  "networkId": 7979,
  "redFlags": [],
  "rpc": ["https://7979.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://main.doschain.com"],
  "shortName": "dos",
  "slug": "dos-chain",
  "testnet": false
};

var c8000 = {
  "chain": "Teleport",
  "chainId": 8000,
  "explorers": [{
    "name": "Teleport EVM Explorer (Blockscout)",
    "url": "https://evm-explorer.teleport.network",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmdP1sLnsmW9dwnfb1GxAXU1nHDzCvWBQNumvMXpdbCSuz",
      "width": 390,
      "height": 390,
      "format": "svg"
    }
  }, {
    "name": "Teleport Cosmos Explorer (Big Dipper)",
    "url": "https://explorer.teleport.network",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmdP1sLnsmW9dwnfb1GxAXU1nHDzCvWBQNumvMXpdbCSuz",
      "width": 390,
      "height": 390,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdP1sLnsmW9dwnfb1GxAXU1nHDzCvWBQNumvMXpdbCSuz",
    "width": 390,
    "height": 390,
    "format": "svg"
  },
  "infoURL": "https://teleport.network",
  "name": "Teleport",
  "nativeCurrency": {
    "name": "Tele",
    "symbol": "TELE",
    "decimals": 18
  },
  "networkId": 8000,
  "rpc": ["https://8000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm-rpc.teleport.network"],
  "shortName": "teleport",
  "slug": "teleport",
  "testnet": false
};

var c8001 = {
  "chain": "Teleport",
  "chainId": 8001,
  "explorers": [{
    "name": "Teleport EVM Explorer (Blockscout)",
    "url": "https://evm-explorer.testnet.teleport.network",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmdP1sLnsmW9dwnfb1GxAXU1nHDzCvWBQNumvMXpdbCSuz",
      "width": 390,
      "height": 390,
      "format": "svg"
    }
  }, {
    "name": "Teleport Cosmos Explorer (Big Dipper)",
    "url": "https://explorer.testnet.teleport.network",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmdP1sLnsmW9dwnfb1GxAXU1nHDzCvWBQNumvMXpdbCSuz",
      "width": 390,
      "height": 390,
      "format": "svg"
    }
  }],
  "faucets": ["https://chain-docs.teleport.network/testnet/faucet.html"],
  "icon": {
    "url": "ipfs://QmdP1sLnsmW9dwnfb1GxAXU1nHDzCvWBQNumvMXpdbCSuz",
    "width": 390,
    "height": 390,
    "format": "svg"
  },
  "infoURL": "https://teleport.network",
  "name": "Teleport Testnet",
  "nativeCurrency": {
    "name": "Tele",
    "symbol": "TELE",
    "decimals": 18
  },
  "networkId": 8001,
  "rpc": ["https://8001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm-rpc.testnet.teleport.network"],
  "shortName": "teleport-testnet",
  "slip44": 1,
  "slug": "teleport-testnet",
  "testnet": true
};

var c8029 = {
  "chain": "MDGL",
  "chainId": 8029,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://mdgl.io",
  "name": "MDGL Testnet",
  "nativeCurrency": {
    "name": "MDGL Token",
    "symbol": "MDGLT",
    "decimals": 18
  },
  "networkId": 8029,
  "rpc": ["https://8029.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.mdgl.io"],
  "shortName": "mdgl",
  "slip44": 1,
  "slug": "mdgl-testnet",
  "testnet": true
};

var c8054 = {
  "chain": "Karak",
  "chainId": 8054,
  "explorers": [{
    "name": "Karak Sepolia Explorer",
    "url": "https://explorer.sepolia.karak.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRvHRuhfQgDRyGgt6vCoHqjZW2Dir7siowYnBpR5BRSej",
    "width": 1080,
    "height": 1080,
    "format": "png"
  },
  "infoURL": "https://karak.network",
  "name": "Karak Sepolia",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 8054,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111"
  },
  "rpc": ["https://8054.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.sepolia.karak.network"],
  "shortName": "karak-sepolia",
  "slug": "karak-sepolia",
  "testnet": false
};

var c8080 = {
  "chain": "Shardeum",
  "chainId": 8080,
  "explorers": [{
    "name": "Shardeum Scan",
    "url": "https://explorer-liberty10.shardeum.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.liberty10.shardeum.org"],
  "features": [],
  "icon": {
    "url": "ipfs://Qma1bfuubpepKn7DLDy4NPSKDeT3S4VPCNhu6UmdGrb6YD",
    "width": 609,
    "height": 533,
    "format": "png"
  },
  "infoURL": "https://docs.shardeum.org/",
  "name": "Shardeum Liberty 1.X",
  "nativeCurrency": {
    "name": "Shardeum SHM",
    "symbol": "SHM",
    "decimals": 18
  },
  "networkId": 8080,
  "redFlags": ["reusedChainId"],
  "rpc": ["https://8080.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://liberty10.shardeum.org/"],
  "shortName": "Liberty10",
  "slug": "shardeum-liberty-1-x",
  "status": "deprecated",
  "testnet": true
};

var c8081 = {
  "chain": "Shardeum",
  "chainId": 8081,
  "explorers": [{
    "name": "Shardeum Scan",
    "url": "https://explorer-liberty20.shardeum.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.liberty20.shardeum.org"],
  "features": [],
  "icon": {
    "url": "ipfs://Qma1bfuubpepKn7DLDy4NPSKDeT3S4VPCNhu6UmdGrb6YD",
    "width": 609,
    "height": 533,
    "format": "png"
  },
  "infoURL": "https://docs.shardeum.org/",
  "name": "Shardeum Liberty 2.X",
  "nativeCurrency": {
    "name": "Shardeum SHM",
    "symbol": "SHM",
    "decimals": 18
  },
  "networkId": 8081,
  "redFlags": ["reusedChainId"],
  "rpc": ["https://8081.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://liberty20.shardeum.org/"],
  "shortName": "Liberty20",
  "slug": "shardeum-liberty-2-x",
  "status": "deprecated",
  "testnet": true
};

var c8082 = {
  "chain": "Shardeum",
  "chainId": 8082,
  "explorers": [{
    "name": "Shardeum Scan",
    "url": "https://explorer-sphinx.shardeum.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet-sphinx.shardeum.org/"],
  "features": [],
  "icon": {
    "url": "ipfs://Qma1bfuubpepKn7DLDy4NPSKDeT3S4VPCNhu6UmdGrb6YD",
    "width": 609,
    "height": 533,
    "format": "png"
  },
  "infoURL": "https://docs.shardeum.org/",
  "name": "Shardeum Sphinx 1.X",
  "nativeCurrency": {
    "name": "Shardeum SHM",
    "symbol": "SHM",
    "decimals": 18
  },
  "networkId": 8082,
  "redFlags": ["reusedChainId"],
  "rpc": ["https://8082.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sphinx.shardeum.org/"],
  "shortName": "Sphinx10",
  "slug": "shardeum-sphinx-1-x",
  "testnet": true
};

var c8086 = {
  "chain": "BTC",
  "chainId": 8086,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://biteth.org",
  "name": "Bitcoin Chain",
  "nativeCurrency": {
    "name": "Bitcoin",
    "symbol": "BTC",
    "decimals": 18
  },
  "networkId": 8086,
  "rpc": ["https://8086.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.biteth.org"],
  "shortName": "Bitcoin",
  "slug": "bitcoin-chain",
  "testnet": false
};

var c8087 = {
  "chain": "USD",
  "chainId": 8087,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://e-dollar.org",
  "name": "E-Dollar",
  "nativeCurrency": {
    "name": "E-Dollar",
    "symbol": "USD",
    "decimals": 18
  },
  "networkId": 8087,
  "rpc": ["https://8087.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.e-dollar.org"],
  "shortName": "E-Dollar",
  "slug": "e-dollar",
  "testnet": false
};

var c8098 = {
  "chain": "StreamuX",
  "chainId": 8098,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.streamux.cloud",
  "name": "StreamuX Blockchain",
  "nativeCurrency": {
    "name": "StreamuX",
    "symbol": "SmuX",
    "decimals": 18
  },
  "networkId": 8098,
  "rpc": ["https://8098.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://u0ma6t6heb:KDNwOsRDGcyM2Oeui1p431Bteb4rvcWkuPgQNHwB4FM@u0xy4x6x82-u0e2mg517m-rpc.us0-aws.kaleido.io/"],
  "shortName": "StreamuX",
  "slug": "streamux-blockchain",
  "testnet": false
};

var c8131 = {
  "chain": "MEER",
  "chainId": 8131,
  "explorers": [{
    "name": "meerscan testnet",
    "url": "https://testnet-qng.qitmeer.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.qitmeer.io"],
  "icon": {
    "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://github.com/Qitmeer",
  "name": "Qitmeer Network Testnet",
  "nativeCurrency": {
    "name": "Qitmeer Testnet",
    "symbol": "MEER-T",
    "decimals": 18
  },
  "networkId": 8131,
  "rpc": ["https://8131.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-qng.rpc.qitmeer.io", "https://testnet.meerlabs.com", "https://meer.testnet.meerfans.club"],
  "shortName": "meertest",
  "slip44": 1,
  "slug": "qitmeer-network-testnet",
  "testnet": true
};

var c8132 = {
  "chain": "MEER",
  "chainId": 8132,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://github.com/Qitmeer",
  "name": "Qitmeer Network Mixnet",
  "nativeCurrency": {
    "name": "Qitmeer Mixnet",
    "symbol": "MEER-M",
    "decimals": 18
  },
  "networkId": 8132,
  "rpc": [],
  "shortName": "meermix",
  "slug": "qitmeer-network-mixnet",
  "status": "incubating",
  "testnet": false
};

var c8133 = {
  "chain": "MEER",
  "chainId": 8133,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://github.com/Qitmeer",
  "name": "Qitmeer Network Privnet",
  "nativeCurrency": {
    "name": "Qitmeer Privnet",
    "symbol": "MEER-P",
    "decimals": 18
  },
  "networkId": 8133,
  "rpc": [],
  "shortName": "meerpriv",
  "slug": "qitmeer-network-privnet",
  "status": "incubating",
  "testnet": false
};

var c8134 = {
  "chain": "MEER",
  "chainId": 8134,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://github.com/Qitmeer",
  "name": "Amana",
  "nativeCurrency": {
    "name": "Amana Mainnet",
    "symbol": "MEER",
    "decimals": 18
  },
  "networkId": 8134,
  "rpc": [],
  "shortName": "amana",
  "slug": "amana",
  "status": "incubating",
  "testnet": false
};

var c8135 = {
  "chain": "MEER",
  "chainId": 8135,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://github.com/Qitmeer",
  "name": "Flana",
  "nativeCurrency": {
    "name": "Flana Mainnet",
    "symbol": "MEER",
    "decimals": 18
  },
  "networkId": 8135,
  "rpc": [],
  "shortName": "flana",
  "slug": "flana",
  "status": "incubating",
  "testnet": false
};

var c8136 = {
  "chain": "MEER",
  "chainId": 8136,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://github.com/Qitmeer",
  "name": "Mizana",
  "nativeCurrency": {
    "name": "Mizana Mainnet",
    "symbol": "MEER",
    "decimals": 18
  },
  "networkId": 8136,
  "rpc": [],
  "shortName": "mizana",
  "slug": "mizana",
  "status": "incubating",
  "testnet": false
};

var c8154 = {
  "chain": "Avalanche",
  "chainId": 8154,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0318sGCP",
  "nativeCurrency": {
    "name": "QR0318sGCP Token",
    "symbol": "VEG",
    "decimals": 18
  },
  "networkId": 8154,
  "redFlags": [],
  "rpc": ["https://8154.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0318sgcp/testnet/rpc"],
  "shortName": "QR0318sGCP",
  "slug": "qr0318sgcp",
  "testnet": true
};

var c8181 = {
  "chain": "tBOC",
  "chainId": 8181,
  "explorers": [{
    "name": "Testnet BeOne Chain",
    "url": "https://testnet.beonescan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmbVLQnaMDu86bPyKgCvTGhFBeYwjr15hQnrCcsp1EkAGL",
      "width": 500,
      "height": 500,
      "format": "png"
    }
  }],
  "faucets": ["https://testnet.beonescan.com/faucet"],
  "icon": {
    "url": "ipfs://QmbVLQnaMDu86bPyKgCvTGhFBeYwjr15hQnrCcsp1EkAGL",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://testnet.beonescan.com",
  "name": "Testnet BeOne Chain",
  "nativeCurrency": {
    "name": "Testnet BeOne Chain",
    "symbol": "tBOC",
    "decimals": 18
  },
  "networkId": 8181,
  "rpc": ["https://8181.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://pre-boc1.beonechain.com"],
  "shortName": "tBOC",
  "slip44": 1,
  "slug": "testnet-beone-chain",
  "testnet": true
};

var c8192 = {
  "chain": "TQF",
  "chainId": 8192,
  "explorers": [{
    "name": "blockscout",
    "url": "https://toruscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreidchntjaxmq52cuqqoalpajk5ssk4p77k7n4jgywqmkpldo5qgobm",
    "width": 1200,
    "height": 1200,
    "format": "png"
  },
  "infoURL": "https://docs.toruschain.com",
  "name": "Torus Mainnet",
  "nativeCurrency": {
    "name": "TQF",
    "symbol": "TQF",
    "decimals": 18
  },
  "networkId": 8192,
  "rpc": ["https://8192.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.toruschain.com"],
  "shortName": "tqf",
  "slug": "torus",
  "testnet": false
};

var c8194 = {
  "chain": "TQF",
  "chainId": 8194,
  "explorers": [{
    "name": "blockscout",
    "url": "https://testnet.toruscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreidchntjaxmq52cuqqoalpajk5ssk4p77k7n4jgywqmkpldo5qgobm",
    "width": 1200,
    "height": 1200,
    "format": "png"
  },
  "infoURL": "https://docs.toruschain.com",
  "name": "Torus Testnet",
  "nativeCurrency": {
    "name": "tTQF",
    "symbol": "TTQF",
    "decimals": 18
  },
  "networkId": 8194,
  "rpc": ["https://8194.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.toruschain.com"],
  "shortName": "ttqf",
  "slip44": 1,
  "slug": "torus-testnet",
  "testnet": true
};

var c8217 = {
  "chain": "KLAY",
  "chainId": 8217,
  "explorers": [{
    "name": "Klaytnscope",
    "url": "https://scope.klaytn.com",
    "standard": "EIP3091"
  }, {
    "name": "Klaytnfinder",
    "url": "https://klaytnfinder.io",
    "standard": "EIP3091"
  }, {
    "name": "klaytnfinder",
    "url": "https://www.klaytnfinder.io/",
    "standard": "none"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://bafkreigtgdivlmfvf7trqjqy4vkz2d26xk3iif6av265v4klu5qavsugm4",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://klaytn.foundation",
  "name": "Klaytn Mainnet Cypress",
  "nativeCurrency": {
    "name": "KLAY",
    "symbol": "KLAY",
    "decimals": 18
  },
  "networkId": 8217,
  "redFlags": [],
  "rpc": ["https://8217.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://public-en-cypress.klaytn.net", "https://klaytn-mainnet-rpc.allthatnode.com:8551", "https://klaytn.blockpi.network/v1/rpc/public"],
  "shortName": "Cypress",
  "slip44": 8217,
  "slug": "klaytn-cypress",
  "testnet": false
};

var c8272 = {
  "chain": "Blockton Blockchain",
  "chainId": 8272,
  "explorers": [{
    "name": "Blockton Explorer",
    "url": "https://blocktonscan.com",
    "standard": "none"
  }],
  "faucets": ["https://faucet.blocktonscan.com/"],
  "icon": {
    "url": "ipfs://bafkreig3hoedafisrgc6iffdo2jcblm6kov35h72gcblc3zkmt7t4ucwhy",
    "width": 800,
    "height": 800,
    "format": "png"
  },
  "infoURL": "https://blocktoncoin.com",
  "name": "Blockton Blockchain",
  "nativeCurrency": {
    "name": "BLOCKTON",
    "symbol": "BTON",
    "decimals": 18
  },
  "networkId": 8272,
  "rpc": ["https://8272.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.blocktonscan.com/"],
  "shortName": "BTON",
  "slug": "blockton-blockchain",
  "testnet": false
};

var c8285 = {
  "chain": "Kortho",
  "chainId": 8285,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.kortho.io/",
  "name": "KorthoTest",
  "nativeCurrency": {
    "name": "Kortho Test",
    "symbol": "KTO",
    "decimals": 11
  },
  "networkId": 8285,
  "rpc": ["https://8285.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://www.krotho-test.net"],
  "shortName": "Kortho",
  "slip44": 1,
  "slug": "korthotest",
  "testnet": true
};

var c8387 = {
  "chain": "FUCK",
  "chainId": 8387,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeibpyckp65pqjvrvqhdt26wqoqk55m6anshbfgyqnaemn6l34nlwya",
    "width": 1024,
    "height": 1024,
    "format": "png"
  },
  "infoURL": "https://wolfery.com",
  "name": "Dracones Financial Services",
  "nativeCurrency": {
    "name": "Functionally Universal Coin Kind",
    "symbol": "FUCK",
    "decimals": 18
  },
  "networkId": 8387,
  "rpc": ["https://8387.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.dracones.net/"],
  "shortName": "fuck",
  "slug": "dracones-financial-services",
  "testnet": false,
  "title": "The Dracones Mainnet"
};

var c8453 = {
  "chain": "ETH",
  "chainId": 8453,
  "explorers": [{
    "name": "basescan",
    "url": "https://basescan.org",
    "standard": "none"
  }, {
    "name": "basescout",
    "url": "https://base.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }, {
    "name": "dexguru",
    "url": "https://base.dex.guru",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne",
      "width": 83,
      "height": 82,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmW5Vn15HeRkScMfPcW12ZdZcC2yUASpu6eCsECRdEmjjj/base-512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://base.org",
  "name": "Base",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 8453,
  "redFlags": [],
  "rpc": ["https://8453.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.base.org/", "https://developer-access-mainnet.base.org/", "https://base.gateway.tenderly.co", "wss://base.gateway.tenderly.co", "https://base-rpc.publicnode.com", "wss://base-rpc.publicnode.com"],
  "shortName": "base",
  "slug": "base",
  "status": "active",
  "testnet": false
};

var c8654 = {
  "chain": "TOKI",
  "chainId": 8654,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmbCBBH4dFHGr8u1yQspCieQG9hLcPFNYdRx1wnVsX8hUw",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://www.buildwithtoki.com",
  "name": "Toki Network",
  "nativeCurrency": {
    "name": "Toki",
    "symbol": "TOKI",
    "decimals": 18
  },
  "networkId": 8654,
  "rpc": ["https://8654.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.buildwithtoki.com/v0/rpc"],
  "shortName": "toki",
  "slug": "toki-network",
  "testnet": false
};

var c8655 = {
  "chain": "TOKI",
  "chainId": 8655,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmbCBBH4dFHGr8u1yQspCieQG9hLcPFNYdRx1wnVsX8hUw",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://www.buildwithtoki.com",
  "name": "Toki Testnet",
  "nativeCurrency": {
    "name": "Toki",
    "symbol": "TOKI",
    "decimals": 18
  },
  "networkId": 8655,
  "rpc": ["https://8655.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.buildwithtoki.com/v0/rpc"],
  "shortName": "toki-testnet",
  "slip44": 1,
  "slug": "toki-testnet",
  "testnet": true
};

var c8668 = {
  "chain": "Hela",
  "chainId": 8668,
  "explorers": [{
    "name": "Hela Official Runtime Mainnet Explorer",
    "url": "https://mainnet-blockexplorer.helachain.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQbUVcaxFwY8gqMq1Jeup4NEyivo12QYhbLvVRvgXRBFb",
    "width": 719,
    "height": 216,
    "format": "png"
  },
  "infoURL": "https://helalabs.com",
  "name": "Hela Official Runtime Mainnet",
  "nativeCurrency": {
    "name": "Hela HLUSD",
    "symbol": "HLUSD",
    "decimals": 18
  },
  "networkId": 8668,
  "rpc": ["https://8668.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.helachain.com"],
  "shortName": "hela",
  "slug": "hela-official-runtime",
  "testnet": false
};

var c8723 = {
  "chain": "OLO",
  "chainId": 8723,
  "explorers": [{
    "name": "OLO Block Explorer",
    "url": "https://www.olo.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://ibdt.io",
  "name": "TOOL Global Mainnet",
  "nativeCurrency": {
    "name": "TOOL Global",
    "symbol": "OLO",
    "decimals": 18
  },
  "networkId": 8723,
  "rpc": ["https://8723.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-web3.wolot.io"],
  "shortName": "olo",
  "slip44": 479,
  "slug": "tool-global",
  "testnet": false
};

var c8724 = {
  "chain": "OLO",
  "chainId": 8724,
  "explorers": [],
  "faucets": ["https://testnet-explorer.wolot.io"],
  "infoURL": "https://testnet-explorer.wolot.io",
  "name": "TOOL Global Testnet",
  "nativeCurrency": {
    "name": "TOOL Global",
    "symbol": "OLO",
    "decimals": 18
  },
  "networkId": 8724,
  "rpc": ["https://8724.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-web3.wolot.io"],
  "shortName": "tolo",
  "slip44": 1,
  "slug": "tool-global-testnet",
  "testnet": true
};

var c8726 = {
  "chain": "Storagechain",
  "chainId": 8726,
  "explorers": [{
    "name": "Storscan",
    "url": "https://explorer-storagechain.invo.zone/?network=StorageChain",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmfN9r1S7FvzkbjqfNMdUikhHmCw5e6UqsTuRD51S8T6Cq",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://storagechain.io/about-us",
  "name": "Storagechain Mainnet",
  "nativeCurrency": {
    "name": "Storagechain",
    "symbol": "STOR",
    "decimals": 18
  },
  "networkId": 8726,
  "rpc": ["https://8726.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-validator.storagechain.io"],
  "shortName": "stor",
  "slug": "storagechain",
  "testnet": false
};

var c8727 = {
  "chain": "Storagechain",
  "chainId": 8727,
  "explorers": [{
    "name": "Storscan",
    "url": "https://explorer-storagechain.invo.zone/?network=StorageChain%20Testnet",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmfN9r1S7FvzkbjqfNMdUikhHmCw5e6UqsTuRD51S8T6Cq",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://storagechain.io/about-us",
  "name": "Storagechain Testnet",
  "nativeCurrency": {
    "name": "Storagechain",
    "symbol": "STOR",
    "decimals": 18
  },
  "networkId": 8727,
  "rpc": ["https://8727.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-validator.storagechain.io"],
  "shortName": "tstor",
  "slug": "storagechain-testnet",
  "testnet": true
};

var c8738 = {
  "chain": "ALPH",
  "chainId": 8738,
  "explorers": [{
    "name": "alphscan",
    "url": "https://explorer.alph.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://alph.network",
  "name": "Alph Network",
  "nativeCurrency": {
    "name": "Alph Network",
    "symbol": "ALPH",
    "decimals": 18
  },
  "networkId": 8738,
  "rpc": ["https://8738.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.alph.network", "wss://rpc.alph.network"],
  "shortName": "alph",
  "slug": "alph-network",
  "testnet": false
};

var c8768 = {
  "chain": "TMY",
  "chainId": 8768,
  "explorers": [],
  "faucets": ["https://faucet.tmychain.org/"],
  "icon": {
    "url": "ipfs://Qmcd19ksUvNMD1XQFSC55jJhDPoF2zUzzV7woteFiugwBH",
    "width": 1024,
    "height": 1023,
    "format": "svg"
  },
  "infoURL": "https://tmychain.org/",
  "name": "TMY Chain",
  "nativeCurrency": {
    "name": "TMY",
    "symbol": "TMY",
    "decimals": 18
  },
  "networkId": 8768,
  "rpc": ["https://8768.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node1.tmyblockchain.org/rpc"],
  "shortName": "tmy",
  "slug": "tmy-chain",
  "testnet": false
};

var c8822 = {
  "chain": "IOTA EVM",
  "chainId": 8822,
  "explorers": [{
    "name": "explorer",
    "url": "https://iota-evm.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreibky2sy6qhi6arktayvologkrgu5kudpgdxfkx4uosbvmstz7v4di",
      "width": 720,
      "height": 720,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreibky2sy6qhi6arktayvologkrgu5kudpgdxfkx4uosbvmstz7v4di",
    "width": 720,
    "height": 720,
    "format": "png"
  },
  "infoURL": "https://www.iota.org",
  "name": "IOTA EVM",
  "nativeCurrency": {
    "name": "IOTA",
    "symbol": "IOTA",
    "decimals": 18
  },
  "networkId": 8822,
  "rpc": ["https://8822.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://json-rpc.evm.iotaledger.net"],
  "shortName": "iotaevm",
  "slug": "iota-evm",
  "testnet": false,
  "title": "IOTA EVM"
};

var c8848 = {
  "chain": "MARO Blockchain",
  "chainId": 8848,
  "explorers": [{
    "name": "MARO Scan",
    "url": "https://scan.ma.ro/#",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreig47k53aipns6nu3u5fxpysp7mogzk6zyvatgpbam7yut3yvtuefa",
    "width": 160,
    "height": 160,
    "format": "png"
  },
  "infoURL": "https://ma.ro/",
  "name": "MARO Blockchain Mainnet",
  "nativeCurrency": {
    "name": "MARO",
    "symbol": "MARO",
    "decimals": 18
  },
  "networkId": 8848,
  "rpc": ["https://8848.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mainnet.ma.ro"],
  "shortName": "maro",
  "slug": "maro-blockchain",
  "testnet": false
};

var c8866 = {
  "chain": "SuperLumio",
  "chainId": 8866,
  "explorers": [{
    "name": "Lumio explorer",
    "url": "https://explorer.lumio.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmXiatdz5WBFypfsudoDsFnsLdiHzDwcD3pWcHwBovbPiZ",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://lumio.io/",
  "name": "SuperLumio",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 8866,
  "rpc": ["https://8866.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.lumio.io/"],
  "shortName": "superlumio",
  "slug": "superlumio",
  "testnet": false
};

var c8880 = {
  "chain": "UNQ",
  "chainId": 8880,
  "explorers": [{
    "name": "Unique Scan",
    "url": "https://uniquescan.io/unique",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmbJ7CGZ2GxWMp7s6jy71UGzRsMe4w3KANKXDAExYWdaFR",
    "width": 48,
    "height": 48,
    "format": "svg"
  },
  "infoURL": "https://unique.network",
  "name": "Unique",
  "nativeCurrency": {
    "name": "Unique",
    "symbol": "UNQ",
    "decimals": 18
  },
  "networkId": 8880,
  "rpc": ["https://8880.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.unique.network", "https://eu-rpc.unique.network", "https://asia-rpc.unique.network", "https://us-rpc.unique.network"],
  "shortName": "unq",
  "slug": "unique",
  "testnet": false
};

var c8881 = {
  "chain": "UNQ",
  "chainId": 8881,
  "explorers": [{
    "name": "Unique Scan / Quartz",
    "url": "https://uniquescan.io/quartz",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmaGPdccULQEFcCGxzstnmE8THfac2kSiGwvWRAiaRq4dp",
    "width": 48,
    "height": 48,
    "format": "svg"
  },
  "infoURL": "https://unique.network",
  "name": "Quartz by Unique",
  "nativeCurrency": {
    "name": "Quartz",
    "symbol": "QTZ",
    "decimals": 18
  },
  "networkId": 8881,
  "rpc": ["https://8881.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-quartz.unique.network", "https://quartz.api.onfinality.io/public-ws", "https://eu-rpc-quartz.unique.network", "https://asia-rpc-quartz.unique.network", "https://us-rpc-quartz.unique.network"],
  "shortName": "qtz",
  "slug": "quartz-by-unique",
  "testnet": false
};

var c8882 = {
  "chain": "UNQ",
  "chainId": 8882,
  "explorers": [{
    "name": "Unique Scan / Opal",
    "url": "https://uniquescan.io/opal",
    "standard": "none"
  }],
  "faucets": ["https://t.me/unique2faucet_opal_bot"],
  "icon": {
    "url": "ipfs://QmYJDpmWyjDa3H6BxweFmQXk4fU8b1GU7M9EqYcaUNvXzc",
    "width": 48,
    "height": 48,
    "format": "svg"
  },
  "infoURL": "https://unique.network",
  "name": "Opal testnet by Unique",
  "nativeCurrency": {
    "name": "Opal",
    "symbol": "UNQ",
    "decimals": 18
  },
  "networkId": 8882,
  "rpc": ["https://8882.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-opal.unique.network", "https://us-rpc-opal.unique.network", "https://eu-rpc-opal.unique.network", "https://asia-rpc-opal.unique.network"],
  "shortName": "opl",
  "slip44": 1,
  "slug": "opal-testnet-by-unique",
  "testnet": true
};

var c8883 = {
  "chain": "UNQ",
  "chainId": 8883,
  "explorers": [{
    "name": "Unique Scan / Sapphire",
    "url": "https://uniquescan.io/sapphire",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmd1PGt4cDRjFbh4ihP5QKEd4XQVwN1MkebYKdF56V74pf",
    "width": 48,
    "height": 48,
    "format": "svg"
  },
  "infoURL": "https://unique.network",
  "name": "Sapphire by Unique",
  "nativeCurrency": {
    "name": "Quartz",
    "symbol": "QTZ",
    "decimals": 18
  },
  "networkId": 8883,
  "rpc": ["https://8883.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-sapphire.unique.network", "https://us-rpc-sapphire.unique.network", "https://eu-rpc-sapphire.unique.network", "https://asia-rpc-sapphire.unique.network"],
  "shortName": "sph",
  "slug": "sapphire-by-unique",
  "testnet": false
};

var c8888 = {
  "chain": "XANAChain",
  "chainId": 8888,
  "explorers": [{
    "name": "XANAChain",
    "url": "https://xanachain.xana.net",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWGNfwJ9o2vmKD3E6fjrxpbFP8W5q45zmYzHHoXwqqAoj",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://xanachain.xana.net/",
  "name": "XANAChain",
  "nativeCurrency": {
    "name": "XETA",
    "symbol": "XETA",
    "decimals": 18
  },
  "networkId": 8888,
  "redFlags": ["reusedChainId"],
  "rpc": ["https://8888.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.xana.net/rpc"],
  "shortName": "XANAChain",
  "slug": "xanachain",
  "testnet": false
};

var c8889 = {
  "chain": "VSC",
  "chainId": 8889,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://vsc-dataseed.vyvo.org",
  "name": "Vyvo Smart Chain",
  "nativeCurrency": {
    "name": "VSC",
    "symbol": "VSC",
    "decimals": 18
  },
  "networkId": 8889,
  "rpc": ["https://8889.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://vsc-dataseed.vyvo.org:8889"],
  "shortName": "vsc",
  "slug": "vyvo-smart-chain",
  "testnet": false
};

var c8890 = {
  "chain": "ORE",
  "chainId": 8890,
  "explorers": [{
    "name": "ORE Testnet Explorer",
    "url": "https://testnet.oreniumscan.org",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmXszYAtQxaFCG3s9vGHoLJnqxGJw2wTKNbruTJ8iDXU7K",
      "width": 200,
      "height": 200,
      "format": "png"
    }
  }],
  "faucets": ["https://faucetcoin.orenium.org"],
  "icon": {
    "url": "ipfs://QmXszYAtQxaFCG3s9vGHoLJnqxGJw2wTKNbruTJ8iDXU7K",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://orenium.org",
  "name": "Orenium Testnet Protocol",
  "nativeCurrency": {
    "name": "ORENIUM",
    "symbol": "tORE",
    "decimals": 18
  },
  "networkId": 8890,
  "rpc": ["https://8890.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-dev-testnet.orenium.org/", "https://rpc-testnet.orenium.org/", "https://rpc-orc.oredex.finance", "https://testnet-rpc.oredex.finance", "https://oredex-node.oredex.finance"],
  "shortName": "tore",
  "slip44": 1,
  "slug": "orenium-testnet-protocol",
  "testnet": true
};

var c8898 = {
  "chain": "MMT",
  "chainId": 8898,
  "explorers": [{
    "name": "mmtscan",
    "url": "https://mmtscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmaF5gi2CbDKsJ2UchNkjBqmWjv8JEDP3vePBmxeUHiaK4",
      "width": 250,
      "height": 250,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.mmtscan.io/"],
  "icon": {
    "url": "ipfs://QmaF5gi2CbDKsJ2UchNkjBqmWjv8JEDP3vePBmxeUHiaK4",
    "width": 250,
    "height": 250,
    "format": "png"
  },
  "infoURL": "https://mmtchain.io/",
  "name": "Mammoth Mainnet",
  "nativeCurrency": {
    "name": "Mammoth Token",
    "symbol": "MMT",
    "decimals": 18
  },
  "networkId": 8898,
  "rpc": ["https://8898.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dataseed.mmtscan.io", "https://dataseed1.mmtscan.io", "https://dataseed2.mmtscan.io"],
  "shortName": "mmt",
  "slug": "mammoth",
  "testnet": false,
  "title": "Mammoth Chain"
};

var c8899 = {
  "chain": "JBC",
  "chainId": 8899,
  "explorers": [{
    "name": "JIBCHAIN Explorer",
    "url": "https://exp-l1.jibchain.net",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmWvTUSCcQ17mDiKg3w1X5nW3q4wZGuVsZ9vwzJ8S9oCns",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://jibchain.net",
  "name": "JIBCHAIN L1",
  "nativeCurrency": {
    "name": "JIBCOIN",
    "symbol": "JBC",
    "decimals": 18
  },
  "networkId": 8899,
  "rpc": ["https://8899.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-l1.jibchain.net", "https://jib-rpc.inan.in.th"],
  "shortName": "jbc",
  "slug": "jibchain-l1",
  "testnet": false
};

var c8989 = {
  "chain": "GMMT",
  "chainId": 8989,
  "explorers": [{
    "name": "gmmtscan",
    "url": "https://scan.gmmtchain.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmVth4aPeskDTFqRifUugJx6gyEHCmx2PFbMWUtsCSQFkF",
      "width": 468,
      "height": 518,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVth4aPeskDTFqRifUugJx6gyEHCmx2PFbMWUtsCSQFkF",
    "width": 468,
    "height": 518,
    "format": "png"
  },
  "infoURL": "https://gmmtchain.io/",
  "name": "Giant Mammoth Mainnet",
  "nativeCurrency": {
    "name": "Giant Mammoth Coin",
    "symbol": "GMMT",
    "decimals": 18
  },
  "networkId": 8989,
  "rpc": ["https://8989.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-asia.gmmtchain.io"],
  "shortName": "gmmt",
  "slug": "giant-mammoth",
  "testnet": false,
  "title": "Giant Mammoth Chain"
};

var c8995 = {
  "chain": "bloxberg",
  "chainId": 8995,
  "explorers": [],
  "faucets": ["https://faucet.bloxberg.org/"],
  "infoURL": "https://bloxberg.org",
  "name": "bloxberg",
  "nativeCurrency": {
    "name": "BERG",
    "symbol": "U+25B3",
    "decimals": 18
  },
  "networkId": 8995,
  "rpc": ["https://8995.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://core.bloxberg.org"],
  "shortName": "berg",
  "slug": "bloxberg",
  "testnet": false
};

var c9000 = {
  "chain": "Evmos",
  "chainId": 9000,
  "explorers": [{
    "name": "Evmos Explorer (Escan)",
    "url": "https://testnet.escan.live",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmeZW6VKUFTbz7PPW8PmDR3ZHa6osYPLBFPnW8T5LSU49c",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.evmos.dev"],
  "icon": {
    "url": "ipfs://QmeZW6VKUFTbz7PPW8PmDR3ZHa6osYPLBFPnW8T5LSU49c",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://evmos.org",
  "name": "Evmos Testnet",
  "nativeCurrency": {
    "name": "test-Evmos",
    "symbol": "tEVMOS",
    "decimals": 18
  },
  "networkId": 9000,
  "rpc": ["https://9000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evmos-testnet.lava.build", "https://eth.bd.evmos.dev:8545"],
  "shortName": "evmos-testnet",
  "slip44": 1,
  "slug": "evmos-testnet",
  "testnet": true
};

var c9001 = {
  "chain": "Evmos",
  "chainId": 9001,
  "explorers": [{
    "name": "Evmos Explorer (Escan)",
    "url": "https://escan.live",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmeZW6VKUFTbz7PPW8PmDR3ZHa6osYPLBFPnW8T5LSU49c",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeZW6VKUFTbz7PPW8PmDR3ZHa6osYPLBFPnW8T5LSU49c",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://evmos.org",
  "name": "Evmos",
  "nativeCurrency": {
    "name": "Evmos",
    "symbol": "EVMOS",
    "decimals": 18
  },
  "networkId": 9001,
  "rpc": ["https://9001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evmos.lava.build", "wss://evmos.lava.build/websocket", "https://evmos-evm.publicnode.com", "wss://evmos-evm.publicnode.com"],
  "shortName": "evmos",
  "slug": "evmos",
  "testnet": false
};

var c9007 = {
  "chain": "Shido Testnet",
  "chainId": 9007,
  "explorers": [{
    "name": "Shidoblock Testnet Explorer",
    "url": "https://testnet.shidoscan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreiatrf5pp7ywvrwvsv4otrex73u6v6bvhorqkxiop2hy2i572zjrba",
      "width": 1080,
      "height": 1080,
      "format": "png"
    }
  }],
  "faucets": ["https://testnet.shidoscan.com/faucet"],
  "icon": {
    "url": "ipfs://bafkreiatrf5pp7ywvrwvsv4otrex73u6v6bvhorqkxiop2hy2i572zjrba",
    "width": 1080,
    "height": 1080,
    "format": "png"
  },
  "infoURL": "https://www.nexablock.io",
  "name": "Shido Testnet Block",
  "nativeCurrency": {
    "name": "Shido Testnet Token",
    "symbol": "SHIDO",
    "decimals": 18
  },
  "networkId": 9007,
  "rpc": ["https://9007.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet-nodes.shidoscan.com", "wss://wss-testnet-nodes.shidoscan.com"],
  "shortName": "ShidoTestnet",
  "slug": "shido-testnet-block",
  "testnet": true
};

var c9008 = {
  "chain": "Shido Mainnet",
  "chainId": 9008,
  "explorers": [{
    "name": "Shidoblock Mainnet Explorer",
    "url": "https://shidoscan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreiatrf5pp7ywvrwvsv4otrex73u6v6bvhorqkxiop2hy2i572zjrba",
      "width": 1080,
      "height": 1080,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreiatrf5pp7ywvrwvsv4otrex73u6v6bvhorqkxiop2hy2i572zjrba",
    "width": 1080,
    "height": 1080,
    "format": "png"
  },
  "infoURL": "https://shido.io",
  "name": "Shido Mainnet Block",
  "nativeCurrency": {
    "name": "Shido Mainnet Token",
    "symbol": "SHIDO",
    "decimals": 18
  },
  "networkId": 9008,
  "rpc": ["https://9008.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-nodes.shidoscan.com", "wss://wss-nodes.shidoscan.com", "https://rpc-delta-nodes.shidoscan.com", "wss://wss-delta-nodes.shidoscan.com"],
  "shortName": "Shido",
  "slug": "shido-block",
  "testnet": false
};

var c9012 = {
  "chain": "BRB",
  "chainId": 9012,
  "explorers": [{
    "name": "berylbit-explorer",
    "url": "https://explorer.berylbit.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://t.me/BerylBit"],
  "icon": {
    "url": "ipfs://QmeDXHkpranzqGN1BmQqZSrFp4vGXf4JfaB5iq8WHHiwDi",
    "width": 162,
    "height": 162,
    "format": "png"
  },
  "infoURL": "https://www.beryl-bit.com",
  "name": "BerylBit Mainnet",
  "nativeCurrency": {
    "name": "BerylBit Chain Native Token",
    "symbol": "BRB",
    "decimals": 18
  },
  "networkId": 9012,
  "rpc": ["https://9012.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.berylbit.io"],
  "shortName": "brb",
  "slug": "berylbit",
  "testnet": false
};

var c9024 = {
  "chain": "Nexa Testnet",
  "chainId": 9024,
  "explorers": [{
    "name": "Nexablock Testnet Explorer",
    "url": "https://testnet.nexablockscan.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreib2t2lcaoh6iixrx4gjjvepws5tlsszfla5hb36b3mgyq7clve35y",
      "width": 192,
      "height": 192,
      "format": "png"
    }
  }],
  "faucets": ["https://testnet.nexablockscan.io/faucet"],
  "icon": {
    "url": "ipfs://bafkreib2t2lcaoh6iixrx4gjjvepws5tlsszfla5hb36b3mgyq7clve35y",
    "width": 192,
    "height": 192,
    "format": "png"
  },
  "infoURL": "https://www.nexablock.io",
  "name": "Nexa Testnet Block",
  "nativeCurrency": {
    "name": "Nexa Testnet Token",
    "symbol": "NEXB",
    "decimals": 18
  },
  "networkId": 9024,
  "rpc": ["https://9024.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet-nodes.nexablockscan.io"],
  "shortName": "NexaTestnet",
  "slug": "nexa-testnet-block",
  "testnet": true
};

var c9025 = {
  "chain": "Nexa Mainnet",
  "chainId": 9025,
  "explorers": [{
    "name": "Nexablock Mainnet Explorer",
    "url": "https://nexablockscan.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreib2t2lcaoh6iixrx4gjjvepws5tlsszfla5hb36b3mgyq7clve35y",
      "width": 192,
      "height": 192,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreib2t2lcaoh6iixrx4gjjvepws5tlsszfla5hb36b3mgyq7clve35y",
    "width": 192,
    "height": 192,
    "format": "png"
  },
  "infoURL": "https://www.nexablock.io",
  "name": "Nexa Mainnet Block",
  "nativeCurrency": {
    "name": "Nexa Mainnet Token",
    "symbol": "NEXB",
    "decimals": 18
  },
  "networkId": 9025,
  "rpc": ["https://9025.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-nodes.nexablockscan.io", "wss://wss-nodes.nexablockscan.io", "https://rpc-nodes-delta.nexablockscan.io"],
  "shortName": "Nexa",
  "slug": "nexa-block",
  "testnet": false
};

var c9100 = {
  "chain": "Genesis",
  "chainId": 9100,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://genesis-gn.com",
  "name": "Genesis Coin",
  "nativeCurrency": {
    "name": "GN Coin",
    "symbol": "GNC",
    "decimals": 18
  },
  "networkId": 9100,
  "rpc": ["https://9100.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://genesis-gn.com", "wss://genesis-gn.com"],
  "shortName": "GENEC",
  "slug": "genesis-coin",
  "testnet": false
};

var c9170 = {
  "chain": "FIRE",
  "chainId": 9170,
  "explorers": [],
  "faucets": ["https://faucet.thefirechain.com"],
  "icon": {
    "url": "ipfs://QmRnnw2gtbU9TWJMLJ6tks7SN6HQV5rRugeoyN6csTYHt1",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://thefirechain.com",
  "name": "Rinia Testnet Old",
  "nativeCurrency": {
    "name": "Firechain",
    "symbol": "FIRE",
    "decimals": 18
  },
  "networkId": 9170,
  "rpc": [],
  "shortName": "_old_tfire",
  "slip44": 1,
  "slug": "rinia-testnet-old",
  "status": "deprecated",
  "testnet": true
};

var c9223 = {
  "chain": "COF",
  "chainId": 9223,
  "explorers": [{
    "name": "Codefin Net Explorer",
    "url": "https://explorer.codefin.pro",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVyAuAnKKNnGEpqeYMLPRfMdysLgPBTZeEXihXbRytGhp",
    "width": 1024,
    "height": 1024,
    "format": "png"
  },
  "infoURL": "https://network.codefin.pro",
  "name": "Codefin Mainnet",
  "nativeCurrency": {
    "name": "Codefin",
    "symbol": "COF",
    "decimals": 18
  },
  "networkId": 9223,
  "rpc": ["https://9223.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://chain-rpc.codefin.pro"],
  "shortName": "COF",
  "slug": "codefin",
  "testnet": false
};

var c9294 = {
  "chain": "Avalanche",
  "chainId": 9294,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser4 Testnet",
  "nativeCurrency": {
    "name": "QaUser4 Testnet Token",
    "symbol": "TQO",
    "decimals": 18
  },
  "networkId": 9294,
  "redFlags": [],
  "rpc": ["https://9294.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser4 Testnet",
  "slug": "qauser4-testnet-qauser4 testnet",
  "testnet": true
};

var c9339 = {
  "chain": "DOGS",
  "chainId": 9339,
  "explorers": [{
    "name": "Dogcoin",
    "url": "https://testnet.dogcoin.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.dogcoin.network"],
  "icon": {
    "url": "ipfs://QmZCadkExKThak3msvszZjo6UnAbUJKE61dAcg4TixuMC3",
    "width": 160,
    "height": 171,
    "format": "png"
  },
  "infoURL": "https://dogcoin.network",
  "name": "Dogcoin Testnet",
  "nativeCurrency": {
    "name": "Dogcoin",
    "symbol": "DOGS",
    "decimals": 18
  },
  "networkId": 9339,
  "rpc": ["https://9339.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.dogcoin.me"],
  "shortName": "DOGSt",
  "slip44": 1,
  "slug": "dogcoin-testnet",
  "testnet": true
};

var c9393 = {
  "chain": "ETH",
  "chainId": 9393,
  "explorers": [{
    "name": "basescout",
    "url": "https://sepolia-delascan.deperp.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZQbfJfxYez8iQyVsB65y7ZTssKbgUpMXzPTEk5xGDwQB",
    "width": 600,
    "height": 600,
    "format": "png"
  },
  "infoURL": "https://www.deperp.com/dela",
  "name": "Dela Sepolia Testnet",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 9393,
  "rpc": ["https://9393.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sepolia-dela.deperp.com"],
  "shortName": "delasep",
  "slip44": 1,
  "slug": "dela-sepolia-testnet",
  "testnet": true
};

var c9395 = {
  "chain": "MTHN",
  "chainId": 9395,
  "explorers": [{
    "name": "Evoke SmartChain Explorer",
    "url": "https://explorer.evokescan.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreia5q26knsvxgkwxze7woepvsqat5n2hodokh4ozzphmhexqez5s34",
    "width": 100,
    "height": 100,
    "format": "png"
  },
  "infoURL": "https://explorer.evokescan.org",
  "name": "Evoke Mainnet",
  "nativeCurrency": {
    "name": "MTHN",
    "symbol": "MTHN",
    "decimals": 18
  },
  "networkId": 9395,
  "rpc": ["https://9395.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.evokescan.org"],
  "shortName": "MTHN",
  "slug": "evoke",
  "testnet": false
};

var c9527 = {
  "chain": "Rangers",
  "chainId": 9527,
  "explorers": [{
    "name": "rangersscan-robin",
    "url": "https://robin-rangersscan.rangersprotocol.com",
    "standard": "none"
  }],
  "faucets": ["https://robin-faucet.rangersprotocol.com"],
  "icon": {
    "url": "ipfs://QmXR5e5SDABWfQn6XT9uMsVYAo5Bv7vUv4jVs8DFqatZWG",
    "width": 2000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://rangersprotocol.com",
  "name": "Rangers Protocol Testnet Robin",
  "nativeCurrency": {
    "name": "Rangers Protocol Gas",
    "symbol": "tRPG",
    "decimals": 18
  },
  "networkId": 9527,
  "rpc": ["https://9527.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://robin.rangersprotocol.com/api/jsonrpc"],
  "shortName": "trpg",
  "slip44": 1,
  "slug": "rangers-protocol-testnet-robin",
  "testnet": true
};

var c9528 = {
  "chain": "QET",
  "chainId": 9528,
  "explorers": [{
    "name": "QEasyWeb3 Explorer",
    "url": "https://www.qeasyweb3.com",
    "standard": "EIP3091"
  }],
  "faucets": ["http://faucet.qeasyweb3.com"],
  "infoURL": "https://www.qeasyweb3.com",
  "name": "QEasyWeb3 Testnet",
  "nativeCurrency": {
    "name": "QET",
    "symbol": "QET",
    "decimals": 18
  },
  "networkId": 9528,
  "rpc": ["https://9528.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://qeasyweb3.com"],
  "shortName": "QETTest",
  "slip44": 1,
  "slug": "qeasyweb3-testnet",
  "testnet": true
};

var c9559 = {
  "chain": "Neonlink",
  "chainId": 9559,
  "explorers": [{
    "name": "Neon Blockchain Explorer",
    "url": "https://testnet-scan.neonlink.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmX3hBv8WyvVfYjh1gmgDfJCpJBvKk4TYG9wFX9sC8WAjz",
      "width": 512,
      "height": 512,
      "format": "svg"
    }
  }],
  "faucets": ["https://faucet.neonlink.io/"],
  "icon": {
    "url": "ipfs://QmX3hBv8WyvVfYjh1gmgDfJCpJBvKk4TYG9wFX9sC8WAjz",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://neonlink.io",
  "name": "Neonlink Testnet",
  "nativeCurrency": {
    "name": "Neonlink Native Token",
    "symbol": "tNEON",
    "decimals": 18
  },
  "networkId": 9559,
  "rpc": ["https://9559.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.neonlink.io"],
  "shortName": "testneon",
  "slip44": 1,
  "slug": "neonlink-testnet",
  "testnet": true
};

var c9700 = {
  "chain": "MainnetDev",
  "chainId": 9700,
  "explorers": [{
    "name": "Oort MainnetDev Scan",
    "url": "https://dev-scan.oortech.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreidrbvklkb52sgmg7cmy42fhf7vqpig7qj7bnrq24ijdwywkzr2tfy",
      "width": 1440,
      "height": 1440,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreidrbvklkb52sgmg7cmy42fhf7vqpig7qj7bnrq24ijdwywkzr2tfy",
    "width": 1440,
    "height": 1440,
    "format": "png"
  },
  "infoURL": "https://oortech.com",
  "name": "Oort MainnetDev",
  "nativeCurrency": {
    "name": "Oort",
    "symbol": "OORT",
    "decimals": 18
  },
  "networkId": 9700,
  "rpc": ["https://9700.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dev-rpc.oortech.com"],
  "shortName": "MainnetDev",
  "slug": "oort-dev",
  "testnet": false,
  "title": "Oort MainnetDev"
};

var c9728 = {
  "chain": "Boba BNB Testnet",
  "chainId": 9728,
  "explorers": [{
    "name": "Boba BNB Testnet block explorer",
    "url": "https://blockexplorer.testnet.bnb.boba.network",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://boba.network",
  "name": "Boba BNB Testnet",
  "nativeCurrency": {
    "name": "Boba Token",
    "symbol": "BOBA",
    "decimals": 18
  },
  "networkId": 9728,
  "parent": {
    "type": "L2",
    "chain": "eip155-5",
    "bridges": [{
      "url": "https://gateway.boba.network"
    }]
  },
  "rpc": ["https://9728.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.bnb.boba.network", "wss://wss.testnet.bnb.boba.network", "https://replica.testnet.bnb.boba.network", "wss://replica-wss.testnet.bnb.boba.network", "https://boba-bnb-testnet.gateway.tenderly.co", "wss://boba-bnb-testnet.gateway.tenderly.co"],
  "shortName": "BobaBnbTestnet",
  "slip44": 1,
  "slug": "boba-bnb-testnet",
  "testnet": true
};

var c9768 = {
  "chain": "NetZ",
  "chainId": 9768,
  "explorers": [{
    "name": "MainnetZ",
    "url": "https://testnet.mainnetz.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.mainnetz.io"],
  "icon": {
    "url": "ipfs://QmT5gJ5weBiLT3GoYuF5yRTRLdPLCVZ3tXznfqW7M8fxgG",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://testnet.mainnetz.io",
  "name": "MainnetZ Testnet",
  "nativeCurrency": {
    "name": "MainnetZ",
    "symbol": "NetZ",
    "decimals": 18
  },
  "networkId": 9768,
  "rpc": ["https://9768.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.mainnetz.io"],
  "shortName": "NetZt",
  "slip44": 1,
  "slug": "z-testnet",
  "testnet": true
};

var c9779 = {
  "chain": "PepeNetwork",
  "chainId": 9779,
  "explorers": [{
    "name": "Pepe Explorer",
    "url": "https://explorer.pepenetwork.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmPX3uipdwd195z1MJff7uj8hpZdSuVvM5z47eiz2o7Gz5",
      "width": 960,
      "height": 944,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPX3uipdwd195z1MJff7uj8hpZdSuVvM5z47eiz2o7Gz5",
    "width": 960,
    "height": 944,
    "format": "png"
  },
  "infoURL": "https://pepenetwork.io",
  "name": "PepeNetwork Mainnet",
  "nativeCurrency": {
    "name": "Pepe",
    "symbol": "WPEPE",
    "decimals": 18
  },
  "networkId": 9779,
  "rpc": ["https://9779.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mainnet.pepenetwork.io"],
  "shortName": "pn",
  "slug": "pepenetwork",
  "testnet": false
};

var c9790 = {
  "chain": "Carbon",
  "chainId": 9790,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQUHqi1gyuTuKmJQHqt9EyhN1FPmmmLNUK8u93nMGrxAy",
    "width": 1600,
    "height": 1600,
    "format": "png"
  },
  "infoURL": "https://carbon.network/",
  "name": "Carbon EVM",
  "nativeCurrency": {
    "name": "swth",
    "symbol": "SWTH",
    "decimals": 18
  },
  "networkId": 9790,
  "rpc": ["https://9790.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm-api.carbon.network/"],
  "shortName": "carbon",
  "slug": "carbon-evm",
  "testnet": false
};

var c9792 = {
  "chain": "Carbon",
  "chainId": 9792,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQUHqi1gyuTuKmJQHqt9EyhN1FPmmmLNUK8u93nMGrxAy",
    "width": 1600,
    "height": 1600,
    "format": "png"
  },
  "infoURL": "https://carbon.network/",
  "name": "Carbon EVM Testnet",
  "nativeCurrency": {
    "name": "swth",
    "symbol": "SWTH",
    "decimals": 18
  },
  "networkId": 9792,
  "rpc": ["https://9792.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://test-evm-api.carbon.network/"],
  "shortName": "carbon-testnet",
  "slip44": 1,
  "slug": "carbon-evm-testnet",
  "testnet": true
};

var c9818 = {
  "chain": "tIMP",
  "chainId": 9818,
  "explorers": [{
    "name": "IMPERIUM TESTNET Explorer",
    "url": "https://network.impscan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmcNGLzKyc7Gu2dgpBFF6t3KJwFuKC79D56DW8GTc5DWRw",
      "width": 200,
      "height": 200,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.imperiumchain.com/"],
  "icon": {
    "url": "ipfs://QmcNGLzKyc7Gu2dgpBFF6t3KJwFuKC79D56DW8GTc5DWRw",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://imperiumchain.com",
  "name": "IMPERIUM TESTNET",
  "nativeCurrency": {
    "name": "tIMP",
    "symbol": "tIMP",
    "decimals": 18
  },
  "networkId": 9818,
  "rpc": ["https://9818.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://data-aws-testnet.imperiumchain.com", "https://data-aws2-testnet.imperiumchain.com"],
  "shortName": "tIMP",
  "slip44": 1,
  "slug": "imperium-testnet",
  "testnet": true
};

var c9819 = {
  "chain": "IMP",
  "chainId": 9819,
  "explorers": [{
    "name": "IMPERIUM Explorer",
    "url": "https://impscan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmcNGLzKyc7Gu2dgpBFF6t3KJwFuKC79D56DW8GTc5DWRw",
      "width": 200,
      "height": 200,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.imperiumchain.com/"],
  "icon": {
    "url": "ipfs://QmcNGLzKyc7Gu2dgpBFF6t3KJwFuKC79D56DW8GTc5DWRw",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://imperiumchain.com",
  "name": "IMPERIUM MAINNET",
  "nativeCurrency": {
    "name": "IMP",
    "symbol": "IMP",
    "decimals": 18
  },
  "networkId": 9819,
  "rpc": ["https://9819.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://data-aws-mainnet.imperiumchain.com", "https://data-aws2-mainnet.imperiumchain.com"],
  "shortName": "IMP",
  "slug": "imperium",
  "testnet": false
};

var c9872 = {
  "chain": "Avalanche",
  "chainId": 9872,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser0507 Testnet",
  "nativeCurrency": {
    "name": "QaUser0507 Testnet Token",
    "symbol": "KQA",
    "decimals": 18
  },
  "networkId": 9872,
  "redFlags": [],
  "rpc": ["https://9872.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser0507 Testnet",
  "slug": "qauser0507-testnet",
  "testnet": true
};

var c9888 = {
  "chain": "Dogelayer",
  "chainId": 9888,
  "explorers": [{
    "name": "Dogelayer mainnet explorer",
    "url": "https://dl-explorer.dogelayer.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://dogelayer.org",
  "name": "Dogelayer Mainnet",
  "nativeCurrency": {
    "name": "Dogecoin",
    "symbol": "DOGE",
    "decimals": 18
  },
  "networkId": 9888,
  "rpc": ["https://9888.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dl-rpc.dogelayer.org"],
  "shortName": "Dogelayer",
  "slug": "dogelayer",
  "testnet": false
};

var c9898 = {
  "chain": "Larissa",
  "chainId": 9898,
  "explorers": [{
    "name": "Larissa Scan",
    "url": "https://scan.larissa.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZTWoZ3LvivSinaJ4aSwqU8pCXw8oSZNnUCh4wwXxtAoQ",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://larissa.network",
  "name": "Larissa Chain",
  "nativeCurrency": {
    "name": "Larissa",
    "symbol": "LRS",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://9898.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.larissa.network"],
  "shortName": "lrs",
  "slip44": 9898,
  "slug": "larissa-chain",
  "status": "active",
  "testnet": false,
  "title": "Larissa Chain"
};

var c9911 = {
  "chain": "SPENT",
  "chainId": 9911,
  "explorers": [{
    "name": "escscan",
    "url": "https://escscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmVvQdmAj6GNQjP1dsxQKbA7xgzqsciooGTQtQ2RsJ37Lf",
      "width": 335,
      "height": 335,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVvQdmAj6GNQjP1dsxQKbA7xgzqsciooGTQtQ2RsJ37Lf",
    "width": 335,
    "height": 335,
    "format": "svg"
  },
  "infoURL": "https://espento.network",
  "name": "Espento Mainnet",
  "nativeCurrency": {
    "name": "ESPENTO",
    "symbol": "SPENT",
    "decimals": 18
  },
  "networkId": 9911,
  "rpc": ["https://9911.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.escscan.com/"],
  "shortName": "spent",
  "slug": "espento",
  "testnet": false
};

var c9977 = {
  "chain": "tMIND",
  "chainId": 9977,
  "explorers": [{
    "name": "Mind Chain explorer",
    "url": "https://testnet.mindscan.info",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.mindchain.info/"],
  "icon": {
    "url": "ipfs://QmX2b4CzNyrNgy4ERBEteSS9MsuYNVYeq2sSMMiogGjbFP",
    "width": 732,
    "height": 732,
    "format": "jpg"
  },
  "infoURL": "https://mindchain.info",
  "name": "Mind Smart Chain Testnet",
  "nativeCurrency": {
    "name": "MIND Coin",
    "symbol": "tMIND",
    "decimals": 18
  },
  "networkId": 9977,
  "rpc": ["https://9977.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-msc.mindchain.info/", "wss://testnet-msc.mindchain.info/ws"],
  "shortName": "tMIND",
  "slip44": 1,
  "slug": "mind-smart-chain-testnet",
  "testnet": true
};

var c9980 = {
  "chain": "Combo",
  "chainId": 9980,
  "explorers": [{
    "name": "combotrace explorer",
    "url": "https://combotrace.nodereal.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRR4v6h6z21BpgS9xY3ExLB4Gkmm3i3dJWQx27oTGifq8",
    "width": 800,
    "height": 693,
    "format": "png"
  },
  "infoURL": "https://combonetwork.io",
  "name": "Combo Mainnet",
  "nativeCurrency": {
    "name": "BNB Chain Native Token",
    "symbol": "BNB",
    "decimals": 18
  },
  "networkId": 9980,
  "rpc": ["https://9980.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.combonetwork.io"],
  "shortName": "combo-mainnet",
  "slug": "combo",
  "testnet": false
};

var c9990 = {
  "chain": "Agung",
  "chainId": 9990,
  "explorers": [{
    "name": "Polkadot.js",
    "url": "https://polkadot.js.org/apps/?rpc=wss://wsspc1-qa.agung.peaq.network#/explorer",
    "standard": "none"
  }, {
    "name": "Subscan",
    "url": "https://agung.subscan.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreibkqdof3ztkdhgukwvkacwgrjb27e23hgz5c6mmudzu5hipyvgisa",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://www.peaq.network",
  "name": "Agung Network",
  "nativeCurrency": {
    "name": "Agung",
    "symbol": "AGNG",
    "decimals": 18
  },
  "networkId": 9990,
  "rpc": ["https://9990.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpcpc1-qa.agung.peaq.network"],
  "shortName": "AGNG",
  "slug": "agung-network",
  "testnet": false
};

var c9996 = {
  "chain": "MIND",
  "chainId": 9996,
  "explorers": [{
    "name": "Mind Chain explorer",
    "url": "https://mainnet.mindscan.info",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmX2b4CzNyrNgy4ERBEteSS9MsuYNVYeq2sSMMiogGjbFP",
    "width": 732,
    "height": 732,
    "format": "jpg"
  },
  "infoURL": "https://mindchain.info",
  "name": "Mind Smart Chain Mainnet",
  "nativeCurrency": {
    "name": "MIND Coin",
    "symbol": "MIND",
    "decimals": 18
  },
  "networkId": 9996,
  "rpc": ["https://9996.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-msc.mindchain.info/", "https://seednode.mindchain.info", "https://archive.mindchain.info/", "wss://archive.mindchain.info/ws", "wss://seednode.mindchain.info/ws"],
  "shortName": "MIND",
  "slug": "mind-smart-chain",
  "testnet": false
};

var c9997 = {
  "chain": "ETH",
  "chainId": 9997,
  "explorers": [{
    "name": "blockscout",
    "url": "https://testnet-rollup-explorer.altlayer.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmcEfZJU7NMn9ycTAcEooQgGNfa2nYBToSUZHdFCFadcjb",
    "width": 1080,
    "height": 1025,
    "format": "png"
  },
  "infoURL": "https://altlayer.io",
  "name": "AltLayer Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 9997,
  "rpc": ["https://9997.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rollup-api.altlayer.io"],
  "shortName": "alt-testnet",
  "slip44": 1,
  "slug": "altlayer-testnet",
  "testnet": true
};

var c9998 = {
  "chain": "ZTC",
  "chainId": 9998,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://ztc.best",
  "name": "Ztc Mainnet",
  "nativeCurrency": {
    "name": "Ztcer",
    "symbol": "ZTC",
    "decimals": 5
  },
  "networkId": 9998,
  "rpc": ["https://9998.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://zitcoin.us"],
  "shortName": "ZTC",
  "slug": "ztc",
  "testnet": false
};

var c9999 = {
  "chain": "myOwn",
  "chainId": 9999,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://docs.bccloud.net/",
  "name": "myOwn Testnet",
  "nativeCurrency": {
    "name": "MYN",
    "symbol": "MYN",
    "decimals": 18
  },
  "networkId": 9999,
  "rpc": ["https://9999.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://geth.dev.bccloud.net"],
  "shortName": "myn",
  "slip44": 1,
  "slug": "myown-testnet",
  "testnet": true
};

var c10000 = {
  "chain": "smartBCH",
  "chainId": 10000,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://smartbch.org/",
  "name": "Smart Bitcoin Cash",
  "nativeCurrency": {
    "name": "Bitcoin Cash",
    "symbol": "BCH",
    "decimals": 18
  },
  "networkId": 10000,
  "rpc": ["https://10000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://smartbch.greyh.at", "https://rpc-mainnet.smartbch.org", "https://smartbch.fountainhead.cash/mainnet", "https://smartbch.devops.cash/mainnet"],
  "shortName": "smartbch",
  "slug": "smart-bitcoin-cash",
  "testnet": false
};

var c10001 = {
  "chain": "smartBCHTest",
  "chainId": 10001,
  "explorers": [],
  "faucets": [],
  "infoURL": "http://smartbch.org/",
  "name": "Smart Bitcoin Cash Testnet",
  "nativeCurrency": {
    "name": "Bitcoin Cash Test Token",
    "symbol": "BCHT",
    "decimals": 18
  },
  "networkId": 10001,
  "rpc": ["https://10001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.smartbch.org", "https://smartbch.devops.cash/testnet"],
  "shortName": "smartbchtest",
  "slip44": 1,
  "slug": "smart-bitcoin-cash-testnet",
  "testnet": true
};

var c10024 = {
  "chain": "GonChain",
  "chainId": 10024,
  "explorers": [{
    "name": "Gon Explorer",
    "url": "https://gonscan.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPtiJGaApbW3ATZhPW3pKJpw3iGVrRGsZLWhrDKF9ZK18",
    "width": 1024,
    "height": 1024,
    "format": "png"
  },
  "name": "Gon Chain",
  "nativeCurrency": {
    "name": "Gon Token",
    "symbol": "GT",
    "decimals": 18
  },
  "networkId": 10024,
  "rpc": ["https://10024.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node1.testnet.gaiaopen.network", "https://node1.mainnet.gon.network", "https://node2.mainnet.gon.network", "https://node3.mainnet.gon.network", "https://node4.mainnet.gon.network"],
  "shortName": "gon",
  "slug": "gon-chain",
  "testnet": true
};

var c10050 = {
  "chain": "Avalanche",
  "chainId": 10050,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0327S1D Testnet",
  "nativeCurrency": {
    "name": "QR0327S1D Testnet Token",
    "symbol": "WZL",
    "decimals": 18
  },
  "networkId": 10050,
  "redFlags": [],
  "rpc": ["https://10050.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0327s1dt/testnet/rpc"],
  "shortName": "QR0327S1D Testnet",
  "slug": "qr0327s1d-testnet",
  "testnet": true
};

var c10081 = {
  "chain": "JOCT",
  "chainId": 10081,
  "explorers": [{
    "name": "Testnet Block Explorer",
    "url": "https://explorer.testnet.japanopenchain.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.japanopenchain.org/",
  "name": "Japan Open Chain Testnet",
  "nativeCurrency": {
    "name": "Japan Open Chain Testnet Token",
    "symbol": "JOCT",
    "decimals": 18
  },
  "networkId": 10081,
  "rpc": ["https://10081.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-1.testnet.japanopenchain.org:8545", "https://rpc-2.testnet.japanopenchain.org:8545"],
  "shortName": "joct",
  "slip44": 1,
  "slug": "japan-open-chain-testnet",
  "testnet": true
};

var c10086 = {
  "chain": "ETH",
  "chainId": 10086,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://sjis.me",
  "name": "SJATSH",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 10086,
  "rpc": ["https://10086.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://geth.free.idcfengye.com"],
  "shortName": "SJ",
  "slug": "sjatsh",
  "testnet": false
};

var c10101 = {
  "chain": "GEN",
  "chainId": 10101,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.xixoio.com/",
  "name": "Blockchain Genesis Mainnet",
  "nativeCurrency": {
    "name": "GEN",
    "symbol": "GEN",
    "decimals": 18
  },
  "networkId": 10101,
  "rpc": ["https://10101.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eu.mainnet.xixoio.com", "https://us.mainnet.xixoio.com", "https://asia.mainnet.xixoio.com"],
  "shortName": "GEN",
  "slug": "blockchain-genesis",
  "testnet": false
};

var c10200 = {
  "chain": "GNO",
  "chainId": 10200,
  "explorers": [{
    "name": "blockscout",
    "url": "https://gnosis-chiado.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": ["https://gnosisfaucet.com"],
  "icon": {
    "url": "ipfs://bafybeidk4swpgdyqmpz6shd5onvpaujvwiwthrhypufnwr6xh3dausz2dm",
    "width": 1800,
    "height": 1800,
    "format": "png"
  },
  "infoURL": "https://docs.gnosischain.com",
  "name": "Gnosis Chiado Testnet",
  "nativeCurrency": {
    "name": "Chiado xDAI",
    "symbol": "XDAI",
    "decimals": 18
  },
  "networkId": 10200,
  "rpc": ["https://10200.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.chiadochain.net", "https://rpc.chiado.gnosis.gateway.fm", "wss://rpc.chiadochain.net/wss", "https://gnosis-chiado-rpc.publicnode.com", "wss://gnosis-chiado-rpc.publicnode.com", "https://gnosis-chiado.drpc.org", "wss://gnosis-chiado.drpc.org"],
  "shortName": "chi",
  "slip44": 1,
  "slug": "gnosis-chiado-testnet",
  "testnet": true
};

var c10201 = {
  "chain": "MaxxChain",
  "chainId": 10201,
  "explorers": [{
    "name": "MaxxChain Block Explorer",
    "url": "https://explorer.maxxchain.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.maxxchain.org"],
  "icon": {
    "url": "ipfs://QmRhQG9TZrXDdbQeTzBmjg3pqgwaD5TKVZj8k4kaz8AoZx",
    "width": 1021,
    "height": 1021,
    "format": "png"
  },
  "infoURL": "https://www.maxxchain.org/",
  "name": "MaxxChain Mainnet",
  "nativeCurrency": {
    "name": "Power",
    "symbol": "PWR",
    "decimals": 18
  },
  "networkId": 10201,
  "rpc": ["https://10201.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.maxxchain.org", "https://rpc1.maxxchain.org", "https://rpc2.maxxchain.org"],
  "shortName": "PWR",
  "slug": "maxxchain",
  "testnet": false
};

var c10242 = {
  "chain": "AA",
  "chainId": 10242,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.arthera.net",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYQp3e52KjkT4bYdAvB6ACEEpXs2D8DozsDitaADRY2Ak",
    "width": 1024,
    "height": 998,
    "format": "png"
  },
  "infoURL": "https://docs.arthera.net/build/developing-sc/using-hardhat",
  "name": "Arthera Mainnet",
  "nativeCurrency": {
    "name": "Arthera",
    "symbol": "AA",
    "decimals": 18
  },
  "networkId": 10242,
  "rpc": ["https://10242.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.arthera.net"],
  "shortName": "aa",
  "slip44": 10242,
  "slug": "arthera",
  "testnet": false
};

var c10243 = {
  "chain": "AA",
  "chainId": 10243,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer-test.arthera.net",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.arthera.net"],
  "icon": {
    "url": "ipfs://QmYQp3e52KjkT4bYdAvB6ACEEpXs2D8DozsDitaADRY2Ak",
    "width": 1024,
    "height": 998,
    "format": "png"
  },
  "infoURL": "https://docs.arthera.net",
  "name": "Arthera Testnet",
  "nativeCurrency": {
    "name": "Arthera",
    "symbol": "AA",
    "decimals": 18
  },
  "networkId": 10243,
  "rpc": ["https://10243.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-test.arthera.net"],
  "shortName": "aat",
  "slip44": 1,
  "slug": "arthera-testnet",
  "testnet": true
};

var c10248 = {
  "chain": "0XTade Chain",
  "chainId": 10248,
  "explorers": [{
    "name": "0xtrade Scan",
    "url": "https://www.0xtscan.com",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.0xtrade.finance/",
  "name": "0XTade",
  "nativeCurrency": {
    "name": "0XT",
    "symbol": "0XT",
    "decimals": 18
  },
  "networkId": 10248,
  "rpc": ["https://10248.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node.0xtchain.com"],
  "shortName": "0xt",
  "slug": "0xtade",
  "testnet": false
};

var c10395 = {
  "chain": "Worldland",
  "chainId": 10395,
  "explorers": [{
    "name": "Worldland Explorer",
    "url": "https://testscan.worldland.foundation",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYZNTfK3byhgLsTjXP8vPubVHRz2CWsBrTJxZrQmKq6JZ",
    "width": 3509,
    "height": 2482,
    "format": "png"
  },
  "infoURL": "https://worldland.foundation",
  "name": "Worldland Testnet",
  "nativeCurrency": {
    "name": "Worldland",
    "symbol": "WLC",
    "decimals": 18
  },
  "networkId": 10395,
  "rpc": ["https://10395.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://gwangju.worldland.foundation"],
  "shortName": "TWLC",
  "slip44": 1,
  "slug": "worldland-testnet",
  "testnet": true
};

var c10507 = {
  "chain": "NUM",
  "chainId": 10507,
  "explorers": [{
    "name": "ethernal",
    "url": "https://mainnet.num.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreie3ba6ofosjqqiya6empkyw6u5xdrtcfzi2evvyt4u6utzeiezyhi",
    "width": 1500,
    "height": 1500,
    "format": "png"
  },
  "infoURL": "https://numbersprotocol.io",
  "name": "Numbers Mainnet",
  "nativeCurrency": {
    "name": "NUM Token",
    "symbol": "NUM",
    "decimals": 18
  },
  "networkId": 10507,
  "rpc": ["https://10507.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnetrpc.num.network"],
  "shortName": "Jade",
  "slug": "numbers",
  "testnet": false
};

var c10508 = {
  "chain": "NUM",
  "chainId": 10508,
  "explorers": [{
    "name": "ethernal",
    "url": "https://testnet.num.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.avax.network/?subnet=num", "https://faucet.num.network"],
  "icon": {
    "url": "ipfs://bafkreie3ba6ofosjqqiya6empkyw6u5xdrtcfzi2evvyt4u6utzeiezyhi",
    "width": 1500,
    "height": 1500,
    "format": "png"
  },
  "infoURL": "https://numbersprotocol.io",
  "name": "Numbers Testnet",
  "nativeCurrency": {
    "name": "NUM Token",
    "symbol": "NUM",
    "decimals": 18
  },
  "networkId": 10508,
  "rpc": ["https://10508.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnetrpc.num.network"],
  "shortName": "Snow",
  "slip44": 1,
  "slug": "numbers-testnet",
  "testnet": true
};

var c10671 = {
  "chain": "Avalanche",
  "chainId": 10671,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 12131",
  "nativeCurrency": {
    "name": "QI M 12131 Token",
    "symbol": "XVL",
    "decimals": 18
  },
  "networkId": 10671,
  "redFlags": [],
  "rpc": ["https://10671.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-test.io/c3c8cc74-5101-4380-937f-4f534cad0128"],
  "shortName": "QI M 12131",
  "slug": "qi-m-12131",
  "testnet": true
};

var c10823 = {
  "chain": "CCP",
  "chainId": 10823,
  "explorers": [{
    "name": "CCP Explorer",
    "url": "https://cryptocoinpay.info",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPw1ixYYeXvTiRWoCt2jWe4YMd3B5o7TzL18SBEHXvhXX",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://www.cryptocoinpay.co",
  "name": "CryptoCoinPay",
  "nativeCurrency": {
    "name": "CryptoCoinPay",
    "symbol": "CCP",
    "decimals": 18
  },
  "networkId": 10823,
  "rpc": ["https://10823.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://node106.cryptocoinpay.info:8545", "ws://node106.cryptocoinpay.info:8546"],
  "shortName": "CCP",
  "slug": "cryptocoinpay",
  "testnet": false
};

var c10946 = {
  "chain": "QDC",
  "chainId": 10946,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer.quadrans.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmZFiYHnE4TrezPz8wSap9nMxG6m98w4fv7ataj2TfLNck",
      "width": 1024,
      "height": 1024,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZFiYHnE4TrezPz8wSap9nMxG6m98w4fv7ataj2TfLNck",
    "width": 1024,
    "height": 1024,
    "format": "png"
  },
  "infoURL": "https://quadrans.io",
  "name": "Quadrans Blockchain",
  "nativeCurrency": {
    "name": "Quadrans Coin",
    "symbol": "QDC",
    "decimals": 18
  },
  "networkId": 10946,
  "rpc": ["https://10946.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.quadrans.io", "https://rpcna.quadrans.io", "https://rpceu.quadrans.io"],
  "shortName": "quadrans",
  "slug": "quadrans-blockchain",
  "testnet": false
};

var c10947 = {
  "chain": "tQDC",
  "chainId": 10947,
  "explorers": [{
    "name": "explorer",
    "url": "https://explorer.testnet.quadrans.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmZFiYHnE4TrezPz8wSap9nMxG6m98w4fv7ataj2TfLNck",
      "width": 1024,
      "height": 1024,
      "format": "png"
    }
  }],
  "faucets": ["https://faucetpage.quadrans.io"],
  "icon": {
    "url": "ipfs://QmZFiYHnE4TrezPz8wSap9nMxG6m98w4fv7ataj2TfLNck",
    "width": 1024,
    "height": 1024,
    "format": "png"
  },
  "infoURL": "https://quadrans.io",
  "name": "Quadrans Blockchain Testnet",
  "nativeCurrency": {
    "name": "Quadrans Testnet Coin",
    "symbol": "tQDC",
    "decimals": 18
  },
  "networkId": 10947,
  "rpc": ["https://10947.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpctest.quadrans.io", "https://rpctest2.quadrans.io"],
  "shortName": "quadranstestnet",
  "slip44": 1,
  "slug": "quadrans-blockchain-testnet",
  "testnet": true
};

var c11110 = {
  "chain": "Astra",
  "chainId": 11110,
  "explorers": [{
    "name": "Astra EVM Explorer (Blockscout)",
    "url": "https://explorer.astranaut.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmaBtaukPNNUNjdJSUAwuFFQMLbZX1Pc3fvXKTKQcds7Kf",
      "width": 104,
      "height": 80,
      "format": "png"
    }
  }, {
    "name": "Astra PingPub Explorer",
    "url": "https://ping.astranaut.io/astra",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmaBtaukPNNUNjdJSUAwuFFQMLbZX1Pc3fvXKTKQcds7Kf",
      "width": 104,
      "height": 80,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmaBtaukPNNUNjdJSUAwuFFQMLbZX1Pc3fvXKTKQcds7Kf",
    "width": 104,
    "height": 80,
    "format": "png"
  },
  "infoURL": "https://astranaut.io",
  "name": "Astra",
  "nativeCurrency": {
    "name": "Astra",
    "symbol": "ASA",
    "decimals": 18
  },
  "networkId": 11110,
  "rpc": ["https://11110.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.astranaut.io", "https://rpc1.astranaut.io"],
  "shortName": "astra",
  "slug": "astra",
  "testnet": false
};

var c11111 = {
  "chain": "WAGMI",
  "chainId": 11111,
  "explorers": [{
    "name": "Avalanche Subnet Explorer",
    "url": "https://subnets-test.avax.network/wagmi",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.avax.network/?subnet=wagmi"],
  "icon": {
    "url": "ipfs://QmNoyUXxnak8B3xgFxErkVfyVEPJUMHBzq7qJcYzkUrPR4",
    "width": 1920,
    "height": 1920,
    "format": "png"
  },
  "infoURL": "https://subnets-test.avax.network/wagmi/details",
  "name": "WAGMI",
  "nativeCurrency": {
    "name": "WAGMI",
    "symbol": "WGM",
    "decimals": 18
  },
  "networkId": 11111,
  "rpc": ["https://11111.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/wagmi/wagmi-chain-testnet/rpc"],
  "shortName": "WAGMI",
  "slug": "wagmi",
  "testnet": true
};

var c11115 = {
  "chain": "Astra",
  "chainId": 11115,
  "explorers": [{
    "name": "Astra EVM Explorer",
    "url": "https://explorer.astranaut.dev",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmaBtaukPNNUNjdJSUAwuFFQMLbZX1Pc3fvXKTKQcds7Kf",
      "width": 104,
      "height": 80,
      "format": "png"
    }
  }, {
    "name": "Astra PingPub Explorer",
    "url": "https://ping.astranaut.dev/astra",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmaBtaukPNNUNjdJSUAwuFFQMLbZX1Pc3fvXKTKQcds7Kf",
      "width": 104,
      "height": 80,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.astranaut.dev"],
  "icon": {
    "url": "ipfs://QmaBtaukPNNUNjdJSUAwuFFQMLbZX1Pc3fvXKTKQcds7Kf",
    "width": 104,
    "height": 80,
    "format": "png"
  },
  "infoURL": "https://astranaut.io",
  "name": "Astra Testnet",
  "nativeCurrency": {
    "name": "test-Astra",
    "symbol": "tASA",
    "decimals": 18
  },
  "networkId": 11115,
  "rpc": ["https://11115.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.astranaut.dev"],
  "shortName": "astra-testnet",
  "slip44": 1,
  "slug": "astra-testnet",
  "testnet": true
};

var c11119 = {
  "chain": "HBIT",
  "chainId": 11119,
  "explorers": [{
    "name": "hashbitscan",
    "url": "https://explorer.hashbit.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://hashbit.org",
  "name": "HashBit Mainnet",
  "nativeCurrency": {
    "name": "HashBit Native Token",
    "symbol": "HBIT",
    "decimals": 18
  },
  "networkId": 11119,
  "rpc": ["https://11119.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.hashbit.org", "https://rpc.hashbit.org"],
  "shortName": "hbit",
  "slug": "hashbit",
  "testnet": false
};

var c11198 = {
  "chain": "Avalanche",
  "chainId": 11198,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0304I2 Testnet",
  "nativeCurrency": {
    "name": "QI0304I2 Testnet Token",
    "symbol": "LOD",
    "decimals": 18
  },
  "networkId": 11198,
  "redFlags": [],
  "rpc": ["https://11198.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0304I2 Testnet",
  "slug": "qi0304i2-testnet",
  "testnet": true
};

var c11221 = {
  "chain": "SC20",
  "chainId": 11221,
  "explorers": [{
    "name": "shinescan",
    "url": "https://shinescan.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmUBkpY3prCTZHpx1fjrYLAJ6dPaGvNVTj97iy6p3NPUi1",
      "width": 161,
      "height": 161,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmUBkpY3prCTZHpx1fjrYLAJ6dPaGvNVTj97iy6p3NPUi1",
    "width": 161,
    "height": 161,
    "format": "png"
  },
  "infoURL": "https://shinechain.tech",
  "name": "Shine Chain",
  "nativeCurrency": {
    "name": "Shine",
    "symbol": "SC20",
    "decimals": 18
  },
  "networkId": 11221,
  "rpc": ["https://11221.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.shinescan.io"],
  "shortName": "SC20",
  "slug": "shine-chain",
  "testnet": false
};

var c11227 = {
  "chain": "Avalanche",
  "chainId": 11227,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Jiritsu Testnet",
  "nativeCurrency": {
    "name": "Jiritsu Testnet Token",
    "symbol": "TZW",
    "decimals": 18
  },
  "networkId": 11227,
  "redFlags": [],
  "rpc": ["https://11227.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/jiritsutes/testnet/rpc"],
  "shortName": "Jiritsu Testnet",
  "slug": "jiritsu-testnet",
  "testnet": true
};

var c11235 = {
  "chain": "Haqq",
  "chainId": 11235,
  "explorers": [{
    "name": "Mainnet HAQQ Explorer",
    "url": "https://explorer.haqq.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://islamiccoin.net",
  "name": "Haqq Network",
  "nativeCurrency": {
    "name": "Islamic Coin",
    "symbol": "ISLM",
    "decimals": 18
  },
  "networkId": 11235,
  "rpc": ["https://11235.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.eth.haqq.network", "https://haqq-evm-rpc.publicnode.com", "wss://haqq-evm-rpc.publicnode.com", "https://haqq.drpc.org", "wss://haqq.drpc.org"],
  "shortName": "ISLM",
  "slug": "haqq-network",
  "testnet": false
};

var c11437 = {
  "chain": "SHYFTT",
  "chainId": 11437,
  "explorers": [{
    "name": "Shyft Testnet BX",
    "url": "https://bx.testnet.shyft.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmUkFZC2ZmoYPTKf7AHdjwRPZoV2h1MCuHaGM4iu8SNFpi",
    "width": 400,
    "height": 400,
    "format": "svg"
  },
  "infoURL": "https://shyft.network",
  "name": "Shyft Testnet",
  "nativeCurrency": {
    "name": "Shyft Test Token",
    "symbol": "SHYFTT",
    "decimals": 18
  },
  "networkId": 11437,
  "rpc": [],
  "shortName": "shyftt",
  "slip44": 1,
  "slug": "shyft-testnet",
  "testnet": true
};

var c11501 = {
  "chain": "BEVM",
  "chainId": 11501,
  "explorers": [{
    "name": "bevm mainnet scan",
    "url": "https://scan-mainnet.bevm.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmfMXiYn4xF9JwdjaqM5YKhqoByox51XvnL68VvKJS6yyu",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://bevm.io",
  "name": "BEVM Mainnet",
  "nativeCurrency": {
    "name": "BTC",
    "symbol": "BTC",
    "decimals": 18
  },
  "networkId": 11501,
  "rpc": ["https://11501.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mainnet-1.bevm.io/", "https://rpc-mainnet-2.bevm.io/"],
  "shortName": "bevm",
  "slug": "bevm",
  "testnet": false
};

var c11503 = {
  "chain": "BEVM",
  "chainId": 11503,
  "explorers": [{
    "name": "bevm testnet scan",
    "url": "https://scan-testnet.bevm.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmfMXiYn4xF9JwdjaqM5YKhqoByox51XvnL68VvKJS6yyu",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://bevm.io",
  "name": "BEVM Testnet",
  "nativeCurrency": {
    "name": "BTC",
    "symbol": "BTC",
    "decimals": 18
  },
  "networkId": 11503,
  "rpc": ["https://11503.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.bevm.io/"],
  "shortName": "bevm-test",
  "slug": "bevm-testnet",
  "testnet": true
};

var c11516 = {
  "chain": "Avalanche",
  "chainId": 11516,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Tenzro",
  "nativeCurrency": {
    "name": "Tenzro Token",
    "symbol": "TNZO",
    "decimals": 18
  },
  "networkId": 11516,
  "redFlags": [],
  "rpc": ["https://11516.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/tenzro/testnet/rpc"],
  "shortName": "Tenzro",
  "slug": "tenzro",
  "testnet": true
};

var c11612 = {
  "chain": "SRDX",
  "chainId": 11612,
  "explorers": [{
    "name": "Sardis",
    "url": "https://testnet.sardisnetwork.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.sardisnetwork.com"],
  "icon": {
    "url": "ipfs://QmdR9QJjQEh1mBnf2WbJfehverxiP5RDPWMtEECbDP2rc3",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://mysardis.com",
  "name": "Sardis Testnet",
  "nativeCurrency": {
    "name": "Sardis",
    "symbol": "SRDX",
    "decimals": 18
  },
  "networkId": 11612,
  "rpc": ["https://11612.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.sardisnetwork.com"],
  "shortName": "SRDXt",
  "slip44": 1,
  "slug": "sardis-testnet",
  "testnet": true
};

var c11625 = {
  "chain": "Avalanche",
  "chainId": 11625,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 202402121",
  "nativeCurrency": {
    "name": "QI M 202402121 Token",
    "symbol": "CYB",
    "decimals": 18
  },
  "networkId": 11625,
  "redFlags": [],
  "rpc": ["https://11625.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI M 202402121",
  "slug": "qi-m-202402121",
  "testnet": true
};

var c11888 = {
  "chain": "Santiment Intelligence Network",
  "chainId": 11888,
  "explorers": [{
    "name": "Santiment Intelligence Explorer",
    "url": "https://app-explorer-pos.sanr.app",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPLMg5mYD8XRknvYbDkD2x7FXxYan7MPTeUWZC2CihwDM",
    "width": 2048,
    "height": 2048,
    "format": "png"
  },
  "infoURL": "https://sanr.app",
  "name": "Santiment Intelligence Network",
  "nativeCurrency": {
    "name": "SANR",
    "symbol": "SANR",
    "decimals": 18
  },
  "networkId": 11888,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://sanr.app"
    }]
  },
  "rpc": ["https://11888.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sanrchain-node.santiment.net"],
  "shortName": "SAN",
  "slug": "santiment-intelligence-network",
  "testnet": false
};

var c11891 = {
  "chain": "Arianee",
  "chainId": 11891,
  "explorers": [{
    "name": "Polygon Supernet Arianee Explorer",
    "url": "https://polygonsupernet.explorer.arianee.net",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://arianee.org",
  "name": "Polygon Supernet Arianee",
  "nativeCurrency": {
    "name": "Arianee",
    "symbol": "ARIA20",
    "decimals": 18
  },
  "networkId": 11891,
  "parent": {
    "type": "L2",
    "chain": "eip155-1"
  },
  "rpc": ["https://11891.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.polygonsupernet.public.arianee.net"],
  "shortName": "Arianee",
  "slug": "polygon-supernet-arianee",
  "testnet": false
};

var c12001 = {
  "chain": "Avalanche",
  "chainId": 12001,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Mikias's Testnet",
  "nativeCurrency": {
    "name": "Mikias's Testnet Token",
    "symbol": "XVL",
    "decimals": 18
  },
  "networkId": 12001,
  "redFlags": [],
  "rpc": ["https://12001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-test.io/c3c8cc74-5101-4380-937f-4f534cad0128"],
  "shortName": "Mikias's Testnet",
  "slug": "mikias-s-testnet",
  "testnet": true
};

var c12009 = {
  "chain": "SATS",
  "chainId": 12009,
  "explorers": [{
    "name": "SatoshiChain Explorer",
    "url": "https://satoshiscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRegpZQBW4o1imYNsW3d27MQjygBSU23Gf6JKje26nvs7",
    "width": 1251,
    "height": 1251,
    "format": "png"
  },
  "infoURL": "https://satoshichain.net",
  "name": "SatoshiChain Mainnet",
  "nativeCurrency": {
    "name": "SatoshiChain Coin",
    "symbol": "SATS",
    "decimals": 18
  },
  "networkId": 12009,
  "rpc": ["https://12009.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.satoshichain.io"],
  "shortName": "sats",
  "slug": "satoshichain",
  "testnet": false
};

var c12020 = {
  "chain": "Aternos",
  "chainId": 12020,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.aternoschain.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.aternoschain.com"],
  "icon": {
    "url": "ipfs://QmUgfhv3rEsS6t9g6Lsf3TJ1mbnJqBrb8YUFPDiNG59QvT",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://aternoschain.com",
  "name": "Aternos",
  "nativeCurrency": {
    "name": "Aternos",
    "symbol": "ATR",
    "decimals": 18
  },
  "networkId": 12020,
  "rpc": ["https://12020.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.aternoschain.com"],
  "shortName": "ATR",
  "slug": "aternos",
  "testnet": false
};

var c12035 = {
  "chain": "Avalanche",
  "chainId": 12035,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 11272",
  "nativeCurrency": {
    "name": "QI M 11272 Token",
    "symbol": "JZW",
    "decimals": 18
  },
  "networkId": 12035,
  "redFlags": [],
  "rpc": ["https://12035.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/b19c9e32-f359-451f-ad15-7ec784625c04"],
  "shortName": "QI M 11272",
  "slug": "qi-m-11272",
  "testnet": true
};

var c12051 = {
  "chain": "ZERO",
  "chainId": 12051,
  "explorers": [{
    "name": "zeroscan",
    "url": "https://betaenv.singularity.gold:18002",
    "standard": "EIP3091"
  }],
  "faucets": ["https://nft.singularity.gold"],
  "infoURL": "https://www.singularity.gold",
  "name": "Singularity ZERO Testnet",
  "nativeCurrency": {
    "name": "ZERO",
    "symbol": "tZERO",
    "decimals": 18
  },
  "networkId": 12051,
  "rpc": ["https://12051.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://betaenv.singularity.gold:18545"],
  "shortName": "tZERO",
  "slip44": 1,
  "slug": "singularity-zero-testnet",
  "testnet": true
};

var c12052 = {
  "chain": "ZERO",
  "chainId": 12052,
  "explorers": [{
    "name": "zeroscan",
    "url": "https://zeroscan.singularity.gold",
    "standard": "EIP3091"
  }],
  "faucets": ["https://zeroscan.singularity.gold"],
  "infoURL": "https://www.singularity.gold",
  "name": "Singularity ZERO Mainnet",
  "nativeCurrency": {
    "name": "ZERO",
    "symbol": "ZERO",
    "decimals": 18
  },
  "networkId": 12052,
  "rpc": ["https://12052.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://zerorpc.singularity.gold"],
  "shortName": "ZERO",
  "slip44": 621,
  "slug": "singularity-zero",
  "testnet": false
};

var c12123 = {
  "chain": "BRC",
  "chainId": 12123,
  "explorers": [{
    "name": "BRC Chain Explorer",
    "url": "https://scan.brcchain.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.brcchain.io"],
  "icon": {
    "url": "ipfs://QmX8qGX7xoZqYUpHxA85uZwQX2fgbTHvmddE1NfseDyBED",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://bridge.brcchain.io",
  "name": "BRC Chain Mainnet",
  "nativeCurrency": {
    "name": "BRC Chain mainnet native token",
    "symbol": "BRC",
    "decimals": 18
  },
  "networkId": 12123,
  "rpc": ["https://12123.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.brcchain.io"],
  "shortName": "BRC",
  "slug": "brc-chain",
  "testnet": false
};

var c12306 = {
  "chain": "FIBO",
  "chainId": 12306,
  "explorers": [{
    "name": "fiboscan",
    "url": "https://scan.fibochain.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://test.fibochain.org/faucets"],
  "icon": {
    "url": "ipfs://bafkreidiedaz3jugxmh2ylzlc4nympbd5iwab33adhwkcnblyop6vvj25y",
    "width": 1494,
    "height": 1494,
    "format": "png"
  },
  "infoURL": "https://fibochain.org",
  "name": "Fibonacci Mainnet",
  "nativeCurrency": {
    "name": "FIBONACCI UTILITY TOKEN",
    "symbol": "FIBO",
    "decimals": 18
  },
  "networkId": 1230,
  "rpc": ["https://12306.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node1.fibo-api.asia", "https://node2.fibo-api.asia", "https://node3.fibo-api.asia", "https://node4.fibo-api.asia", "https://node5.fibo-api.asia", "https://node6.fibo-api.asia", "https://node7.fibo-api.asia", "https://node1.fibo-rpc.asia", "https://node2.fibo-rpc.asia", "https://node3.fibo-rpc.asia", "https://node4.fibo-rpc.asia", "https://node5.fibo-rpc.asia", "https://node6.fibo-rpc.asia", "https://node7.fibo-rpc.asia"],
  "shortName": "fibo",
  "slug": "fibonacci",
  "testnet": true
};

var c12321 = {
  "chain": "BLG",
  "chainId": 12321,
  "explorers": [],
  "faucets": ["https://faucet.blgchain.com"],
  "icon": {
    "url": "ipfs://QmUN5j2cre8GHKv52JE8ag88aAnRmuHMGFxePPvKMogisC",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://blgchain.com",
  "name": "BLG Testnet",
  "nativeCurrency": {
    "name": "Blg",
    "symbol": "BLG",
    "decimals": 18
  },
  "networkId": 12321,
  "rpc": ["https://12321.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.blgchain.com"],
  "shortName": "blgchain",
  "slip44": 1,
  "slug": "blg-testnet",
  "testnet": true
};

var c12345 = {
  "chain": "STEP",
  "chainId": 12345,
  "explorers": [{
    "name": "StepScan",
    "url": "https://testnet.stepscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmVp9jyb3UFW71867yVtymmiRw7dPY4BTnsp3hEjr9tn8L",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.step.network"],
  "icon": {
    "url": "ipfs://QmVp9jyb3UFW71867yVtymmiRw7dPY4BTnsp3hEjr9tn8L",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://step.network",
  "name": "Step Testnet",
  "nativeCurrency": {
    "name": "FITFI",
    "symbol": "FITFI",
    "decimals": 18
  },
  "networkId": 12345,
  "parent": {
    "type": "L2",
    "chain": "eip155-43113"
  },
  "rpc": ["https://12345.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.step.network"],
  "shortName": "steptest",
  "slip44": 1,
  "slug": "step-testnet",
  "testnet": true,
  "title": "Step Test Network"
};

var c12553 = {
  "chain": "RSS3",
  "chainId": 12553,
  "explorers": [{
    "name": "RSS3 VSL Scan",
    "url": "https://scan.rss3.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZFWYnufi6G2Z54oJ25sx2yf2Skx5tseJHJJa6Hc1G34t",
    "width": 200,
    "height": 200,
    "format": "svg"
  },
  "infoURL": "https://rss3.io",
  "name": "RSS3 VSL Mainnet",
  "nativeCurrency": {
    "name": "RSS3",
    "symbol": "RSS3",
    "decimals": 18
  },
  "networkId": 12553,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://explorer.rss3.io/bridge"
    }]
  },
  "rpc": ["https://12553.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.rss3.io"],
  "shortName": "rss3",
  "slug": "rss3-vsl",
  "testnet": false
};

var c12715 = {
  "chain": "Rikeza",
  "chainId": 12715,
  "explorers": [{
    "name": "Rikeza Blockchain explorer",
    "url": "https://testnet.rikscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmfJ1Qxpzi6CSLeFeWY1Bwe435CpT5za5WfrLUE7vNzZfy",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://rikeza.io",
  "name": "Rikeza Network Testnet",
  "nativeCurrency": {
    "name": "Rikeza",
    "symbol": "RIK",
    "decimals": 18
  },
  "networkId": 12715,
  "rpc": ["https://12715.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.rikscan.com"],
  "shortName": "tRIK",
  "slip44": 1,
  "slug": "rikeza-network-testnet",
  "testnet": true,
  "title": "Rikeza Network Testnet"
};

var c12781 = {
  "chain": "Avalanche",
  "chainId": 12781,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "playdapp Testnet",
  "nativeCurrency": {
    "name": "playdapp Testnet Token",
    "symbol": "PDA",
    "decimals": 18
  },
  "networkId": 12781,
  "redFlags": [],
  "rpc": ["https://12781.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/playdappte/testnet/rpc"],
  "shortName": "playdapp Testnet",
  "slug": "playdapp-testnet",
  "testnet": true
};

var c12890 = {
  "chain": "tQNET",
  "chainId": 12890,
  "explorers": [{
    "name": "Quantum Scan Testnet",
    "url": "https://testnet.quantumscan.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreibwywok67uewqbtqdzgr7nlk3lvvg7hxmbgwtn7kdwxe34useucvm",
    "width": 1024,
    "height": 1024,
    "format": "png"
  },
  "infoURL": "https://quantumnetwork.gg",
  "name": "Quantum Chain Testnet",
  "nativeCurrency": {
    "name": "Quantum Chain",
    "symbol": "tQNET",
    "decimals": 18
  },
  "networkId": 12890,
  "rpc": ["https://12890.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.quantumscan.org"],
  "shortName": "tqnet",
  "slip44": 1,
  "slug": "quantum-chain-testnet",
  "testnet": true
};

var c13000 = {
  "chain": "SPS",
  "chainId": 13000,
  "explorers": [{
    "name": "SPS Explorer",
    "url": "http://spsscan.ssquad.games",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://ssquad.games/",
  "name": "SPS",
  "nativeCurrency": {
    "name": "ECG",
    "symbol": "ECG",
    "decimals": 18
  },
  "networkId": 13000,
  "rpc": ["https://13000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.ssquad.games"],
  "shortName": "SPS",
  "slug": "sps",
  "testnet": false
};

var c13308 = {
  "chain": "CREDIT",
  "chainId": 13308,
  "explorers": [{
    "name": "Creditscan",
    "url": "https://scan.creditsmartchain.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreifbso3gd4wu5wxl27xyurxctmuae2jyuy37guqtzx23nga6ba4ag4",
      "width": 1000,
      "height": 1628,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreifbso3gd4wu5wxl27xyurxctmuae2jyuy37guqtzx23nga6ba4ag4",
    "width": 1000,
    "height": 1628,
    "format": "png"
  },
  "infoURL": "https://creditsmartchain.com",
  "name": "Credit Smart Chain",
  "nativeCurrency": {
    "name": "Credit",
    "symbol": "CREDIT",
    "decimals": 18
  },
  "networkId": 13308,
  "rpc": ["https://13308.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.creditsmartchain.com"],
  "shortName": "Credit",
  "slug": "credit-smart-chain-credit",
  "testnet": false
};

var c13337 = {
  "chain": "BEAM",
  "chainId": 13337,
  "explorers": [{
    "name": "Beam Explorer",
    "url": "https://subnets-test.avax.network/beam",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.avax.network/?subnet=beam", "https://faucet.onbeam.com"],
  "features": [{
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmQJ21NWyGGDraicVEzS1Uqq1yXahM9NCuNZgnfYvtspdt",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://www.onbeam.com",
  "name": "Beam Testnet",
  "nativeCurrency": {
    "name": "Beam",
    "symbol": "BEAM",
    "decimals": 18
  },
  "networkId": 13337,
  "rpc": ["https://13337.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://build.onbeam.com/rpc/testnet", "wss://build.onbeam.com/ws/testnet", "https://subnets.avax.network/beam/testnet/rpc", "wss://subnets.avax.network/beam/testnet/ws"],
  "shortName": "beam-testnet",
  "slip44": 1,
  "slug": "beam-testnet",
  "testnet": true
};

var c13371 = {
  "chain": "Immutable zkEVM",
  "chainId": 13371,
  "explorers": [{
    "name": "Immutable explorer",
    "url": "https://explorer.immutable.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmXFUYFW4e6wifbU9LKVq7owM14bnE6ZbbYq3bn1jBP3Mw",
      "width": 1168,
      "height": 1168,
      "format": "png"
    }
  }],
  "faucets": ["https://docs.immutable.com/docs/zkEVM/guides/faucet"],
  "icon": {
    "url": "ipfs://QmXFUYFW4e6wifbU9LKVq7owM14bnE6ZbbYq3bn1jBP3Mw",
    "width": 1168,
    "height": 1168,
    "format": "png"
  },
  "infoURL": "https://www.immutable.com",
  "name": "Immutable zkEVM",
  "nativeCurrency": {
    "name": "IMX",
    "symbol": "IMX",
    "decimals": 18
  },
  "networkId": 13371,
  "rpc": ["https://13371.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.immutable.com", "https://immutable-zkevm.drpc.org", "wss://immutable-zkevm.drpc.org"],
  "shortName": "imx",
  "slug": "immutable-zkevm",
  "testnet": false
};

var c13381 = {
  "chain": "Phoenix",
  "chainId": 13381,
  "explorers": [{
    "name": "phoenixplorer",
    "url": "https://phoenixplorer.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYiLMeKDXMSNuQmtxNdxm53xR588pcRXMf7zuiZLjQnc6",
    "width": 1501,
    "height": 1501,
    "format": "png"
  },
  "infoURL": "https://cryptophoenix.org/phoenix",
  "name": "Phoenix Mainnet",
  "nativeCurrency": {
    "name": "Phoenix",
    "symbol": "PHX",
    "decimals": 18
  },
  "networkId": 13381,
  "rpc": ["https://13381.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.phoenixplorer.com/"],
  "shortName": "Phoenix",
  "slug": "phoenix",
  "testnet": false
};

var c13396 = {
  "chain": "Avalanche",
  "chainId": 13396,
  "explorers": [{
    "name": "Masa Explorer",
    "url": "https://subnets.avax.network/masa",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Masa Network ",
  "nativeCurrency": {
    "name": "Masa Network  Token",
    "symbol": "MASA",
    "decimals": 18
  },
  "networkId": 13396,
  "redFlags": [],
  "rpc": ["https://13396.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/masanetwork/mainnet/rpc"],
  "shortName": "Masa Network ",
  "slug": "masa-network",
  "testnet": false
};

var c13473 = {
  "chain": "Immutable zkEVM",
  "chainId": 13473,
  "explorers": [{
    "name": "Immutable Testnet explorer",
    "url": "https://explorer.testnet.immutable.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmXFUYFW4e6wifbU9LKVq7owM14bnE6ZbbYq3bn1jBP3Mw",
      "width": 1168,
      "height": 1168,
      "format": "png"
    }
  }],
  "faucets": ["https://docs.immutable.com/docs/zkEVM/guides/faucet"],
  "icon": {
    "url": "ipfs://QmXFUYFW4e6wifbU9LKVq7owM14bnE6ZbbYq3bn1jBP3Mw",
    "width": 1168,
    "height": 1168,
    "format": "png"
  },
  "infoURL": "https://www.immutable.com",
  "name": "Immutable zkEVM Testnet",
  "nativeCurrency": {
    "name": "Test IMX",
    "symbol": "tIMX",
    "decimals": 18
  },
  "networkId": 13473,
  "rpc": ["https://13473.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.immutable.com", "https://immutable-zkevm-testnet.drpc.org", "wss://immutable-zkevm-testnet.drpc.org"],
  "shortName": "imx-testnet",
  "slip44": 1,
  "slug": "immutable-zkevm-testnet",
  "testnet": true
};

var c13812 = {
  "chain": "SUS",
  "chainId": 13812,
  "explorers": [{
    "name": "Susono",
    "url": "http://explorer.opn.network",
    "standard": "none"
  }],
  "faucets": [],
  "name": "Susono",
  "nativeCurrency": {
    "name": "Susono",
    "symbol": "OPN",
    "decimals": 18
  },
  "networkId": 13812,
  "rpc": ["https://13812.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://gateway.opn.network/node/ext/bc/2VsZe5DstWw2bfgdx3YbjKcMsJnNDjni95sZorBEdk9L9Qr9Fr/rpc"],
  "shortName": "sus",
  "slug": "susono",
  "testnet": false
};

var c13838 = {
  "chain": "Avalanche",
  "chainId": 13838,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "XTraderlands Subnet Tesnet",
  "nativeCurrency": {
    "name": "XTraderlands Subnet Tesnet Token",
    "symbol": "XTDL",
    "decimals": 18
  },
  "networkId": 13838,
  "redFlags": [],
  "rpc": ["https://13838.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/xtraderlan/testnet/rpc"],
  "shortName": "XTraderlands Subnet Tesnet",
  "slug": "xtraderlands-subnet-tesnet",
  "testnet": true
};

var c14000 = {
  "chain": "SPS-Testnet",
  "chainId": 14000,
  "explorers": [{
    "name": "SPS Test Explorer",
    "url": "https://explorer.3sps.net",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://ssquad.games/",
  "name": "SPS Testnet",
  "nativeCurrency": {
    "name": "ECG",
    "symbol": "ECG",
    "decimals": 18
  },
  "networkId": 14000,
  "rpc": ["https://14000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://www.3sps.net"],
  "shortName": "SPS-Test",
  "slip44": 1,
  "slug": "sps-testnet",
  "testnet": true
};

var c14324 = {
  "chain": "EVO",
  "chainId": 14324,
  "explorers": [{
    "name": "Evolve Testnet Explorer",
    "url": "https://testnet.evolveblockchain.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.evolveblockchain.io"],
  "icon": {
    "url": "ipfs://QmVxtpYYzc5214CB7BgsMC4mRNRHCD8fpbNMzZguBWyRwa",
    "width": 600,
    "height": 600,
    "format": "png"
  },
  "infoURL": "https://evolveblockchain.io",
  "name": "EVOLVE Testnet",
  "nativeCurrency": {
    "name": "Evolve",
    "symbol": "EVO",
    "decimals": 18
  },
  "networkId": 14324,
  "rpc": ["https://14324.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.evolveblockchain.io"],
  "shortName": "evo",
  "slug": "evolve-testnet",
  "testnet": true
};

var c14333 = {
  "chain": "Vitruveo",
  "chainId": 14333,
  "explorers": [{
    "name": "Vitruveo Testnet Explorer",
    "url": "https://test-explorer.vitruveo.xyz",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreidjhjv7uu7if745ys7ari3ka75spm2hqyr5po66sbe7kqsfk7ahua",
      "width": 1000,
      "height": 1000,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.vitruveo.xyz"],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://bafkreidjhjv7uu7if745ys7ari3ka75spm2hqyr5po66sbe7kqsfk7ahua",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://www.vitruveo.xyz",
  "name": "Vitruveo Testnet",
  "nativeCurrency": {
    "name": "Vitruveo Test Coin",
    "symbol": "tVTRU",
    "decimals": 18
  },
  "networkId": 14333,
  "rpc": ["https://14333.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://test-rpc.vitruveo.xyz"],
  "shortName": "vitruveo-test",
  "slug": "vitruveo-testnet",
  "testnet": true,
  "title": "Vitruveo is a blockchain for Creators"
};

var c14853 = {
  "chain": "Humanode Testnet 5",
  "chainId": 14853,
  "explorers": [],
  "faucets": ["https://t.me/HumanodeTestnet5FaucetBot"],
  "icon": {
    "url": "ipfs://bafybeihuskzfwqogwvutaxil6sztmvpiavzbrzwjwpn6w2i4j3jysbybra",
    "width": 1043,
    "height": 1043,
    "format": "png"
  },
  "infoURL": "https://humanode.io",
  "name": "Humanode Testnet 5 Israfel",
  "nativeCurrency": {
    "name": "eHMND",
    "symbol": "eHMND",
    "decimals": 18
  },
  "networkId": 14853,
  "rpc": ["https://14853.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://explorer-rpc-http.testnet5.stages.humanode.io"],
  "shortName": "hmnd-t5",
  "slip44": 1,
  "slug": "humanode-testnet-5-israfel",
  "testnet": true
};

var c15003 = {
  "chain": "Immutable zkEVM",
  "chainId": 15003,
  "explorers": [{
    "name": "Immutable Devnet explorer",
    "url": "https://explorer.dev.immutable.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmXFUYFW4e6wifbU9LKVq7owM14bnE6ZbbYq3bn1jBP3Mw",
      "width": 1168,
      "height": 1168,
      "format": "png"
    }
  }],
  "faucets": ["https://docs.immutable.com/docs/zkEVM/guides/faucet"],
  "icon": {
    "url": "ipfs://QmXFUYFW4e6wifbU9LKVq7owM14bnE6ZbbYq3bn1jBP3Mw",
    "width": 1168,
    "height": 1168,
    "format": "png"
  },
  "infoURL": "https://www.immutable.com",
  "name": "Immutable zkEVM Devnet",
  "nativeCurrency": {
    "name": "Dev IMX",
    "symbol": "dIMX",
    "decimals": 18
  },
  "networkId": 15003,
  "rpc": ["https://15003.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.dev.immutable.com"],
  "shortName": "imx-devnet",
  "slug": "immutable-zkevm-devnet",
  "testnet": false
};

var c15056 = {
  "chain": "Avalanche",
  "chainId": 15056,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2402052",
  "nativeCurrency": {
    "name": "QI M 2402052 Token",
    "symbol": "ACI",
    "decimals": 18
  },
  "networkId": 15056,
  "redFlags": [],
  "rpc": ["https://15056.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/c908add6-74c5-4407-8091-18762786a0b9"],
  "shortName": "QI M 2402052",
  "slug": "qi-m-2402052",
  "testnet": true
};

var c15104 = {
  "chain": "Avalanche",
  "chainId": 15104,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2402054",
  "nativeCurrency": {
    "name": "QI M 2402054 Token",
    "symbol": "ACI",
    "decimals": 18
  },
  "networkId": 15104,
  "redFlags": [],
  "rpc": ["https://15104.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/c908add6-74c5-4407-8091-18762786a0b9"],
  "shortName": "QI M 2402054",
  "slug": "qi-m-2402054",
  "testnet": true
};

var c15535 = {
  "chain": "Avalanche",
  "chainId": 15535,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 11271",
  "nativeCurrency": {
    "name": "QI M 11271 Token",
    "symbol": "JZW",
    "decimals": 18
  },
  "networkId": 15535,
  "redFlags": [],
  "rpc": ["https://15535.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/a47e1c06-fa75-4536-a900-1574d198e197"],
  "shortName": "QI M 11271",
  "slug": "qi-m-11271",
  "testnet": true
};

var c15551 = {
  "chain": "LoopNetwork",
  "chainId": 15551,
  "explorers": [{
    "name": "loopscan",
    "url": "http://explorer.mainnetloop.com",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "http://theloopnetwork.org/",
  "name": "LoopNetwork Mainnet",
  "nativeCurrency": {
    "name": "LOOP",
    "symbol": "LOOP",
    "decimals": 18
  },
  "networkId": 15551,
  "rpc": ["https://15551.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.mainnetloop.com"],
  "shortName": "loop",
  "slug": "loopnetwork",
  "testnet": false
};

var c15555 = {
  "chain": "Trust EVM Testnet",
  "chainId": 15555,
  "explorers": [{
    "name": "Trust EVM Explorer",
    "url": "https://trustscan.one",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.testnet-dev.trust.one/"],
  "infoURL": "https://www.trust.one/",
  "name": "Trust EVM Testnet",
  "nativeCurrency": {
    "name": "Trust EVM",
    "symbol": "EVM",
    "decimals": 18
  },
  "networkId": 15555,
  "rpc": ["https://15555.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.testnet-dev.trust.one"],
  "shortName": "TrustTestnet",
  "slip44": 1,
  "slug": "trust-evm-testnet",
  "testnet": true
};

var c15557 = {
  "chain": "EOS",
  "chainId": 15557,
  "explorers": [{
    "name": "EOS EVM Explorer",
    "url": "https://explorer.testnet.evm.eosnetwork.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmXkK5D5GWizvY1FmL6pV8cYLAbhehKETubktCgh6qDJZb",
    "width": 500,
    "height": 750,
    "format": "png"
  },
  "infoURL": "https://eosnetwork.com/eos-evm",
  "name": "EOS EVM Network Testnet",
  "nativeCurrency": {
    "name": "EOS",
    "symbol": "EOS",
    "decimals": 18
  },
  "networkId": 15557,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.testnet.evm.eosnetwork.com"
    }]
  },
  "rpc": ["https://15557.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.testnet.evm.eosnetwork.com"],
  "shortName": "eos-testnet",
  "slip44": 1,
  "slug": "eos-evm-network-testnet",
  "testnet": true
};

var c16000 = {
  "chain": "MTT",
  "chainId": 16000,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://metadot.network",
  "name": "MetaDot Mainnet",
  "nativeCurrency": {
    "name": "MetaDot Token",
    "symbol": "MTT",
    "decimals": 18
  },
  "networkId": 16000,
  "rpc": ["https://16000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.metadot.network"],
  "shortName": "mtt",
  "slug": "metadot",
  "testnet": false
};

var c16001 = {
  "chain": "MTTTest",
  "chainId": 16001,
  "explorers": [],
  "faucets": ["https://faucet.metadot.network/"],
  "infoURL": "https://metadot.network",
  "name": "MetaDot Testnet",
  "nativeCurrency": {
    "name": "MetaDot Token TestNet",
    "symbol": "MTTest",
    "decimals": 18
  },
  "networkId": 16001,
  "rpc": ["https://16001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.metadot.network"],
  "shortName": "mtttest",
  "slip44": 1,
  "slug": "metadot-testnet",
  "testnet": true
};

var c16507 = {
  "chain": "Genesys",
  "chainId": 16507,
  "explorers": [{
    "name": "GchainExplorer",
    "url": "https://gchainexplorer.genesys.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreie6nai3yhykcdlsyshn5lbcbyba5y7zwsqg6owcfek2urhoucr6rm",
    "width": 800,
    "height": 800,
    "format": "png"
  },
  "infoURL": "https://www.genesys.network/",
  "name": "Genesys Mainnet",
  "nativeCurrency": {
    "name": "Genesys",
    "symbol": "GSYS",
    "decimals": 18
  },
  "networkId": 16507,
  "rpc": ["https://16507.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.genesys.network"],
  "shortName": "Genesys",
  "slug": "genesys",
  "testnet": false
};

var c16688 = {
  "chain": "IRIShub",
  "chainId": 16688,
  "explorers": [{
    "name": "IRISHub Testnet Cosmos Explorer (IOBScan)",
    "url": "https://nyancat.iobscan.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmRaSx7AX1VDgcqjwLgSDP4WZmKBHPdHhbjkcEEXPA2Fnc",
      "width": 1062,
      "height": 822,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmRaSx7AX1VDgcqjwLgSDP4WZmKBHPdHhbjkcEEXPA2Fnc",
    "width": 1062,
    "height": 822,
    "format": "png"
  },
  "infoURL": "https://www.irisnet.org",
  "name": "IRIShub Testnet",
  "nativeCurrency": {
    "name": "Eris",
    "symbol": "ERIS",
    "decimals": 18
  },
  "networkId": 16688,
  "rpc": ["https://16688.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evmrpc.nyancat.irisnet.org"],
  "shortName": "nyancat",
  "slip44": 1,
  "slug": "irishub-testnet",
  "testnet": true
};

var c16718 = {
  "chain": "ambnet",
  "chainId": 16718,
  "explorers": [{
    "name": "AirDAO Network Explorer",
    "url": "https://airdao.io/explorer",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmSxXjvWng3Diz4YwXDV2VqSPgMyzLYBNfkjJcr7rzkxom",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://airdao.io",
  "name": "AirDAO Mainnet",
  "nativeCurrency": {
    "name": "Amber",
    "symbol": "AMB",
    "decimals": 18
  },
  "networkId": 16718,
  "rpc": ["https://16718.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://network.ambrosus.io"],
  "shortName": "airdao",
  "slug": "airdao",
  "testnet": false
};

var c16888 = {
  "chain": "IVAR",
  "chainId": 16888,
  "explorers": [{
    "name": "ivarscan",
    "url": "https://testnet.ivarscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://tfaucet.ivarex.com/"],
  "icon": {
    "url": "ipfs://QmV8UmSwqGF2fxrqVEBTHbkyZueahqyYtkfH2RBF5pNysM",
    "width": 519,
    "height": 519,
    "format": "svg"
  },
  "infoURL": "https://ivarex.com",
  "name": "IVAR Chain Testnet",
  "nativeCurrency": {
    "name": "tIvar",
    "symbol": "tIVAR",
    "decimals": 18
  },
  "networkId": 16888,
  "rpc": ["https://16888.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.ivarex.com"],
  "shortName": "tivar",
  "slip44": 1,
  "slug": "ivar-chain-testnet",
  "testnet": true
};

var c17000 = {
  "chain": "ETH",
  "chainId": 17000,
  "explorers": [{
    "name": "Holesky Explorer",
    "url": "https://holesky.beaconcha.in",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt",
      "width": 1000,
      "height": 1628,
      "format": "png"
    }
  }, {
    "name": "otterscan-holesky",
    "url": "https://holesky.otterscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt",
      "width": 1000,
      "height": 1628,
      "format": "png"
    }
  }, {
    "name": "Holesky Etherscan",
    "url": "https://holesky.etherscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt",
      "width": 1000,
      "height": 1628,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.holesky.ethpandaops.io", "https://holesky-faucet.pk910.de"],
  "features": [],
  "icon": {
    "url": "ipfs://QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt",
    "width": 1000,
    "height": 1628,
    "format": "png"
  },
  "infoURL": "https://holesky.ethpandaops.io",
  "name": "Holesky",
  "nativeCurrency": {
    "name": "Testnet ETH",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 17000,
  "redFlags": [],
  "rpc": ["https://17000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.holesky.ethpandaops.io", "https://ethereum-holesky-rpc.publicnode.com", "wss://ethereum-holesky-rpc.publicnode.com", "https://holesky.drpc.org", "wss://holesky.drpc.org"],
  "shortName": "holesky",
  "slip44": 1,
  "slug": "holesky",
  "status": "incubating",
  "testnet": true,
  "title": "Ethereum Testnet Holesky"
};

var c17001 = {
  "chain": "ETH",
  "chainId": 17001,
  "explorers": [{
    "name": "Redstone Holesky Explorer",
    "url": "https://explorer.holesky.redstone.xyz",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt",
      "width": 1000,
      "height": 1628,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreieyaqgkgntvxuo5tnhgseladga5q6gutc37dab7kqqfdguhq7vkxq",
    "width": 5836,
    "height": 5836,
    "format": "png"
  },
  "infoURL": "https://redstone.xyz/docs/network-info",
  "name": "Redstone Holesky Testnet",
  "nativeCurrency": {
    "name": "Redstone Testnet Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 17001,
  "rpc": ["https://17001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.holesky.redstone.xyz"],
  "shortName": "redstone",
  "slip44": 1,
  "slug": "redstone-holesky-testnet",
  "testnet": true
};

var c17026 = {
  "chain": "Avalanche",
  "chainId": 17026,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI1204I3",
  "nativeCurrency": {
    "name": "QI1204I3 Token",
    "symbol": "BHOX",
    "decimals": 18
  },
  "networkId": 17026,
  "redFlags": [],
  "rpc": ["https://17026.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-test.io/e7aeac38-06b2-4aaa-87b4-2c2da10fa43e"],
  "shortName": "QI1204I3",
  "slug": "qi1204i3",
  "testnet": true
};

var c17171 = {
  "chain": "G8C",
  "chainId": 17171,
  "explorers": [{
    "name": "G8Chain",
    "url": "https://mainnet.oneg8.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.oneg8.network"],
  "icon": {
    "url": "ipfs://QmbkCVC5vZpVAfq8SuPXR9PhpTRS2m8w6LGqBkhXAvmie6",
    "width": 80,
    "height": 80,
    "format": "png"
  },
  "infoURL": "https://oneg8.one",
  "name": "G8Chain Mainnet",
  "nativeCurrency": {
    "name": "G8Chain",
    "symbol": "G8C",
    "decimals": 18
  },
  "networkId": 17171,
  "rpc": ["https://17171.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.oneg8.network"],
  "shortName": "G8Cm",
  "slug": "g8chain",
  "testnet": false
};

var c17172 = {
  "chain": "ECLIPSE",
  "chainId": 17172,
  "explorers": [{
    "name": "ECLIPSE Explorer",
    "url": "https://subnets-test.avax.network/eclipse",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "infoURL": "http://eclipsenet.io",
  "name": "Eclipse Subnet",
  "nativeCurrency": {
    "name": "Eclipse",
    "symbol": "ECLP",
    "decimals": 16
  },
  "networkId": 17172,
  "rpc": ["https://17172.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/eclipse/testnet/rpc"],
  "shortName": "eclipse",
  "slug": "eclipse-subnet",
  "testnet": true
};

var c17180 = {
  "chain": "PLT",
  "chainId": 17180,
  "explorers": [{
    "name": "Palettescan",
    "url": "https://testnet.palettescan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmPCEGZD1p1keTT2YfPp725azx1r9Ci41hejeUuGL2whFA",
      "width": 800,
      "height": 800,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmPCEGZD1p1keTT2YfPp725azx1r9Ci41hejeUuGL2whFA",
    "width": 800,
    "height": 800,
    "format": "png"
  },
  "infoURL": "https://hashpalette.com/",
  "name": "Palette Chain Testnet",
  "nativeCurrency": {
    "name": "Palette Token",
    "symbol": "PLT",
    "decimals": 18
  },
  "networkId": 17180,
  "rpc": ["https://17180.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://palette-opennet.com:22000"],
  "shortName": "PCT",
  "slip44": 1,
  "slug": "palette-chain-testnet",
  "testnet": true
};

var c17186 = {
  "chain": "ETH",
  "chainId": 17186,
  "explorers": [],
  "faucets": [],
  "features": [],
  "name": "lazy-crimson-coral",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 17186,
  "parent": {
    "type": "L3",
    "chain": "Base",
    "bridges": [{
      "url": "https://lazy-crimson-coral-cotlv0ftqf.testnets.superbridge.app"
    }]
  },
  "redFlags": [],
  "rpc": ["https://17186.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://l2-lazy-crimson-coral-cotlv0ftqf.t.conduit.xyz"],
  "shortName": "lazy-crimson-coral",
  "slug": "lazy-crimson-coral",
  "testnet": true
};

var c17217 = {
  "chain": "KONET",
  "chainId": 17217,
  "explorers": [{
    "name": "konet-explorer",
    "url": "https://explorer.kon-wallet.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmSszu2AhLPgcp8SZYiBYCQiRVwb9ueqbnGbcTx9H9CJjZ",
    "width": 1851,
    "height": 1851,
    "format": "png"
  },
  "infoURL": "https://konetmain.com",
  "name": "KONET Mainnet",
  "nativeCurrency": {
    "name": "KONET",
    "symbol": "KONET",
    "decimals": 18
  },
  "networkId": 17217,
  "rpc": ["https://17217.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.kon-wallet.com"],
  "shortName": "KONET",
  "slip44": 1,
  "slug": "konet",
  "testnet": false
};

var c17511 = {
  "chain": "Avalanche",
  "chainId": 17511,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "PST 1-17-24",
  "nativeCurrency": {
    "name": "PST 1-17-24 Token",
    "symbol": "MUB",
    "decimals": 18
  },
  "networkId": 17511,
  "redFlags": [],
  "rpc": ["https://17511.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "PST 1-17-24",
  "slug": "pst-1-17-24",
  "testnet": true
};

var c17777 = {
  "chain": "EOS",
  "chainId": 17777,
  "explorers": [{
    "name": "EOS EVM Explorer",
    "url": "https://explorer.evm.eosnetwork.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmXkK5D5GWizvY1FmL6pV8cYLAbhehKETubktCgh6qDJZb",
    "width": 500,
    "height": 750,
    "format": "png"
  },
  "infoURL": "https://eosnetwork.com/eos-evm",
  "name": "EOS EVM Network",
  "nativeCurrency": {
    "name": "EOS",
    "symbol": "EOS",
    "decimals": 18
  },
  "networkId": 17777,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.evm.eosnetwork.com"
    }, {
      "url": "https://app.multichain.org"
    }]
  },
  "rpc": ["https://17777.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.evm.eosnetwork.com"],
  "shortName": "eos",
  "slug": "eos-evm-network",
  "testnet": false
};

var c18000 = {
  "chain": "Game Network",
  "chainId": 18000,
  "explorers": [{
    "name": "Game Network",
    "url": "https://explorer.fod.games",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://goexosphere.com",
  "name": "Frontier of Dreams Testnet",
  "nativeCurrency": {
    "name": "ZKST",
    "symbol": "ZKST",
    "decimals": 18
  },
  "networkId": 18000,
  "rpc": ["https://18000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.fod.games/"],
  "shortName": "ZKST",
  "slip44": 1,
  "slug": "frontier-of-dreams-testnet",
  "testnet": true
};

var c18105 = {
  "chain": "Avalanche",
  "chainId": 18105,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Found Test",
  "nativeCurrency": {
    "name": "Found Test Token",
    "symbol": "TVJ",
    "decimals": 18
  },
  "networkId": 18105,
  "redFlags": [],
  "rpc": ["https://18105.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Found Test",
  "slug": "found-test",
  "testnet": true
};

var c18109 = {
  "chain": "Avalanche",
  "chainId": 18109,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser7737 Testnet",
  "nativeCurrency": {
    "name": "QaUser7737 Testnet Token",
    "symbol": "XSP",
    "decimals": 18
  },
  "networkId": 18109,
  "redFlags": [],
  "rpc": ["https://18109.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser7737 Testnet",
  "slug": "qauser7737-testnet",
  "testnet": true
};

var c18122 = {
  "chain": "Smart Trade Networks",
  "chainId": 18122,
  "explorers": [{
    "name": "stnscan",
    "url": "https://stnscan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmRgZVpjik4cH3Sb6wLRpdnfv9kiMEZ8fugfkzTgk3bpRW",
      "width": 500,
      "height": 500,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRgZVpjik4cH3Sb6wLRpdnfv9kiMEZ8fugfkzTgk3bpRW",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://www.smarttradenetworks.com",
  "name": "Smart Trade Networks",
  "nativeCurrency": {
    "name": "STN",
    "symbol": "STN",
    "decimals": 18
  },
  "networkId": 18122,
  "rpc": ["https://18122.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://beefledgerwallet.com:8544"],
  "shortName": "STN",
  "slug": "smart-trade-networks",
  "testnet": false
};

var c18159 = {
  "chain": "POM",
  "chainId": 18159,
  "explorers": [{
    "name": "explorer-proofofmemes",
    "url": "https://memescan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmePhfibWz9jnGUqF9Rven4x734br1h3LxrChYTEjbbQvo",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://proofofmemes.org",
  "name": "Proof Of Memes",
  "nativeCurrency": {
    "name": "Proof Of Memes",
    "symbol": "POM",
    "decimals": 18
  },
  "networkId": 18159,
  "rpc": ["https://18159.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.memescan.io", "https://mainnet-rpc2.memescan.io", "https://mainnet-rpc3.memescan.io", "https://mainnet-rpc4.memescan.io"],
  "shortName": "pom",
  "slug": "proof-of-memes",
  "testnet": false,
  "title": "Proof Of Memes Mainnet"
};

var c18181 = {
  "chain": "G8C",
  "chainId": 18181,
  "explorers": [{
    "name": "G8Chain",
    "url": "https://testnet.oneg8.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.oneg8.network"],
  "icon": {
    "url": "ipfs://QmbkCVC5vZpVAfq8SuPXR9PhpTRS2m8w6LGqBkhXAvmie6",
    "width": 80,
    "height": 80,
    "format": "png"
  },
  "infoURL": "https://oneg8.one",
  "name": "G8Chain Testnet",
  "nativeCurrency": {
    "name": "G8Coin",
    "symbol": "G8C",
    "decimals": 18
  },
  "networkId": 18181,
  "rpc": ["https://18181.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.oneg8.network"],
  "shortName": "G8Ct",
  "slip44": 1,
  "slug": "g8chain-testnet",
  "testnet": true
};

var c18231 = {
  "chain": "unreal",
  "chainId": 18231,
  "explorers": [{
    "name": "blockscout",
    "url": "https://unreal.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmZbtoK9Q1DHTHjsgPUfHkzb9xdWzrSfPwPQ8M8FPu84mA",
      "width": 300,
      "height": 301,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZbtoK9Q1DHTHjsgPUfHkzb9xdWzrSfPwPQ8M8FPu84mA",
    "width": 300,
    "height": 301,
    "format": "png"
  },
  "infoURL": "https://raas.gelato.network/rollups/details/public/unreal",
  "name": "unreal-old",
  "nativeCurrency": {
    "name": "unreal Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 18231,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": []
  },
  "rpc": ["https://18231.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.unreal.gelato.digital", "wss://ws.unreal.gelato.digital"],
  "shortName": "unreal-old",
  "slip44": 60,
  "slug": "unreal-old",
  "status": "deprecated",
  "testnet": true,
  "title": "unreal testnet for re.al"
};

var c18233 = {
  "chain": "unreal",
  "chainId": 18233,
  "explorers": [{
    "name": "blockscout",
    "url": "https://unreal.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmZbtoK9Q1DHTHjsgPUfHkzb9xdWzrSfPwPQ8M8FPu84mA",
      "width": 300,
      "height": 301,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZbtoK9Q1DHTHjsgPUfHkzb9xdWzrSfPwPQ8M8FPu84mA",
    "width": 300,
    "height": 301,
    "format": "png"
  },
  "infoURL": "https://raas.gelato.network/rollups/details/public/unreal",
  "name": "unreal",
  "nativeCurrency": {
    "name": "unreal Ether",
    "symbol": "reETH",
    "decimals": 18
  },
  "networkId": 18233,
  "parent": {
    "type": "L2",
    "chain": "eip155-17000",
    "bridges": [{
      "url": "https://bridge.gelato.network/bridge/unreal"
    }]
  },
  "rpc": ["https://18233.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.unreal-orbit.gelato.digital", "wss://ws.unreal-orbit.gelato.digital"],
  "shortName": "unreal",
  "slip44": 60,
  "slug": "unreal",
  "testnet": true,
  "title": "unreal testnet for re.al"
};

var c18303 = {
  "chain": "Avalanche",
  "chainId": 18303,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Zeroone Testnet",
  "nativeCurrency": {
    "name": "Zeroone Testnet Token",
    "symbol": "ZERO",
    "decimals": 18
  },
  "networkId": 18303,
  "redFlags": [],
  "rpc": ["https://18303.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/zeroonetes/testnet/rpc"],
  "shortName": "Zeroone Testnet",
  "slug": "zeroone-testnet",
  "testnet": true
};

var c18686 = {
  "chain": "MXC zkEVM",
  "chainId": 18686,
  "explorers": [{
    "name": "MXC zkEVM Moonchain",
    "url": "https://explorer.moonchain.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdGCthKA11K9kCZJdbTP5WPAyq1wiRZ3REn6KG58MrWaE",
    "width": 159,
    "height": 159,
    "format": "png"
  },
  "infoURL": "https://doc.mxc.com/docs/intro",
  "name": "MXC zkEVM Moonchain",
  "nativeCurrency": {
    "name": "MXC zkEVM Moonchain",
    "symbol": "MXC",
    "decimals": 18
  },
  "networkId": 18686,
  "rpc": ["https://18686.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.mxc.com"],
  "shortName": "MXCzkEVM",
  "slug": "mxc-zkevm-moonchain",
  "testnet": false
};

var c18889 = {
  "chain": "Titan (TKX)",
  "chainId": 18889,
  "explorers": [{
    "name": "Titan Explorer",
    "url": "https://titan-testnet-explorer-light.titanlab.io/Titan%20Testnet",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreicyvc7t55zsejv6vwaxbmhvea5vdfkkbgqkmn65rhyyifpg3mq3ua",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreicyvc7t55zsejv6vwaxbmhvea5vdfkkbgqkmn65rhyyifpg3mq3ua",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://titanlab.io",
  "name": "Titan (TKX) Testnet",
  "nativeCurrency": {
    "name": "Titan tkx",
    "symbol": "TKX",
    "decimals": 18
  },
  "networkId": 18889,
  "rpc": ["https://18889.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://titan-testnet-json-rpc.titanlab.io", "https://titan-testnet-json-rpc-1.titanlab.io", "https://titan-testnet-json-rpc-2.titanlab.io"],
  "shortName": "titan_tkx-testnet",
  "slip44": 1,
  "slug": "titan-tkx-testnet",
  "testnet": true
};

var c18898 = {
  "chain": "Avalanche",
  "chainId": 18898,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser4 Testnet",
  "nativeCurrency": {
    "name": "QaUser4 Testnet Token",
    "symbol": "NLD",
    "decimals": 18
  },
  "networkId": 18898,
  "redFlags": [],
  "rpc": ["https://18898.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser4 Testnet",
  "slug": "qauser4-testnet-qauser4 testnet-18898",
  "testnet": true
};

var c19011 = {
  "chain": "HOME Verse",
  "chainId": 19011,
  "explorers": [{
    "name": "HOME Verse Explorer",
    "url": "https://explorer.oasys.homeverse.games",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeGb65zSworzoHmwK3jdkPtEsQZMUSJRxf8K8Feg56soU",
    "width": 597,
    "height": 597,
    "format": "png"
  },
  "infoURL": "https://www.homeverse.games/",
  "name": "HOME Verse Mainnet",
  "nativeCurrency": {
    "name": "OAS",
    "symbol": "OAS",
    "decimals": 18
  },
  "networkId": 19011,
  "parent": {
    "type": "L2",
    "chain": "eip155-248"
  },
  "rpc": ["https://19011.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.mainnet.oasys.homeverse.games/"],
  "shortName": "HMV",
  "slug": "home-verse",
  "testnet": false
};

var c19112 = {
  "chain": "Avalanche",
  "chainId": 19112,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0304s1 Testnet",
  "nativeCurrency": {
    "name": "QI0304s1 Testnet Token",
    "symbol": "LKG",
    "decimals": 18
  },
  "networkId": 19112,
  "redFlags": [],
  "rpc": ["https://19112.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0304s1 Testnet",
  "slug": "qi0304s1-testnet",
  "testnet": true
};

var c19224 = {
  "chain": "DCSM",
  "chainId": 19224,
  "explorers": [{
    "name": "Decentraconnect Social",
    "url": "https://decentraconnect.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmatvJXLgMthjXwydGBVFRtga9fZXJ3qFEVJ6cMRxniFUc",
    "width": 307,
    "height": 314,
    "format": "png"
  },
  "infoURL": "https://docs.decentraconnect.io",
  "name": "Decentraconnect Social",
  "nativeCurrency": {
    "name": "Decentraconnect Social",
    "symbol": "DCSM",
    "decimals": 18
  },
  "networkId": 19224,
  "rpc": ["https://19224.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.decentraconnect.io"],
  "shortName": "DCSMs",
  "slug": "decentraconnect-social",
  "testnet": false
};

var c19527 = {
  "chain": "Magnet",
  "chainId": 19527,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://magnet.magport.io/",
  "name": "Magnet Network",
  "nativeCurrency": {
    "name": "Magnet Network",
    "symbol": "DOT",
    "decimals": 18
  },
  "networkId": 19527,
  "rpc": ["https://19527.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://magnet-rpc.magport.io/"],
  "shortName": "mgt",
  "slug": "magnet-network",
  "testnet": false
};

var c19683 = {
  "chain": "Avalanche",
  "chainId": 19683,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "ST 12-07 V1",
  "nativeCurrency": {
    "name": "ST 12-07 V1 Token",
    "symbol": "XRL",
    "decimals": 18
  },
  "networkId": 19683,
  "redFlags": [],
  "rpc": ["https://19683.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-test.io/d26b972e-1832-4d3a-bf7b-d0ce1f4331c2"],
  "shortName": "ST 12-07 V1",
  "slug": "st-12-07-v1",
  "testnet": true
};

var c19845 = {
  "chain": "BTCIX",
  "chainId": 19845,
  "explorers": [{
    "name": "BTCIXScan",
    "url": "https://btcixscan.com",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://bitcolojix.org",
  "name": "BTCIX Network",
  "nativeCurrency": {
    "name": "BTCIX Network",
    "symbol": "BTCIX",
    "decimals": 18
  },
  "networkId": 19845,
  "rpc": ["https://19845.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://seed.btcix.org/rpc"],
  "shortName": "btcix",
  "slug": "btcix-network",
  "testnet": false
};

var c20001 = {
  "chain": "ETHW",
  "chainId": 20001,
  "explorers": [{
    "name": "CamelarkScan",
    "url": "https://scan.camelark.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeJerrsURFNt2LL7DE7TxeunjrQXiuezdfHyqmsbwX3MZ",
    "width": 128,
    "height": 128,
    "format": "png"
  },
  "infoURL": "https://www.camelark.com",
  "name": "Camelark Mainnet",
  "nativeCurrency": {
    "name": "EthereumPoW",
    "symbol": "ETHW",
    "decimals": 18
  },
  "networkId": 20001,
  "rpc": ["https://20001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-http-rpc.camelark.com"],
  "shortName": "Camelark",
  "slug": "camelark",
  "testnet": false
};

var c20139 = {
  "chain": "Avalanche",
  "chainId": 20139,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0129I1",
  "nativeCurrency": {
    "name": "QR0129I1 Token",
    "symbol": "YOD",
    "decimals": 18
  },
  "networkId": 20139,
  "redFlags": [],
  "rpc": ["https://20139.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0129i1/testnet/rpc"],
  "shortName": "QR0129I1",
  "slug": "qr0129i1",
  "testnet": true
};

var c20141 = {
  "chain": "Avalanche",
  "chainId": 20141,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Shelby's Testnet",
  "nativeCurrency": {
    "name": "Shelby's Testnet Token",
    "symbol": "FUC",
    "decimals": 18
  },
  "networkId": 20141,
  "redFlags": [],
  "rpc": ["https://20141.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/c6fcfa18-e711-4f91-b8d4-ad59cfd30316"],
  "shortName": "Shelby's Testnet",
  "slug": "shelby-s-testnet",
  "testnet": true
};

var c20519 = {
  "chain": "Avalanche",
  "chainId": 20519,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser4113 Testnet",
  "nativeCurrency": {
    "name": "QaUser4113 Testnet Token",
    "symbol": "FYP",
    "decimals": 18
  },
  "networkId": 20519,
  "redFlags": [],
  "rpc": ["https://20519.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser4113 Testnet",
  "slug": "qauser4113-testnet",
  "testnet": true
};

var c20729 = {
  "chain": "CLO",
  "chainId": 20729,
  "explorers": [],
  "faucets": ["https://faucet.callisto.network/"],
  "infoURL": "https://callisto.network",
  "name": "Callisto Testnet",
  "nativeCurrency": {
    "name": "Callisto",
    "symbol": "CLO",
    "decimals": 18
  },
  "networkId": 79,
  "rpc": ["https://20729.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.callisto.network/"],
  "shortName": "CLOTestnet",
  "slip44": 1,
  "slug": "callisto-testnet",
  "testnet": true
};

var c20736 = {
  "chain": "P12",
  "chainId": 20736,
  "explorers": [{
    "name": "P12 Chain Explorer",
    "url": "https://explorer.p12.games",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreieiro4imoujeewc4r4thf5hxj47l56j2iwuz6d6pdj6ieb6ub3h7e",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://p12.network",
  "name": "P12 Chain",
  "nativeCurrency": {
    "name": "Hooked P2",
    "symbol": "hP2",
    "decimals": 18
  },
  "networkId": 20736,
  "rpc": ["https://20736.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-chain.p12.games"],
  "shortName": "p12",
  "slug": "p12-chain",
  "testnet": false
};

var c20765 = {
  "chain": "JONO11",
  "chainId": 20765,
  "explorers": [{
    "name": "JONO11 Explorer",
    "url": "https://subnets-test.avax.network/jono11",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreievzx4ke62dtc77o47x7vs7nn67ghzrwku6h5dxo3hwcsqfeblke4",
    "width": 612,
    "height": 612,
    "format": "png"
  },
  "name": "Jono11 Subnet",
  "nativeCurrency": {
    "name": "Jono11 Token",
    "symbol": "JONO",
    "decimals": 18
  },
  "networkId": 20765,
  "rpc": ["https://20765.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/jono11/testnet/rpc"],
  "shortName": "jono11",
  "slug": "jono11-subnet",
  "testnet": true
};

var c20948 = {
  "chain": "Avalanche",
  "chainId": 20948,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "GoldFever",
  "nativeCurrency": {
    "name": "GoldFever Token",
    "symbol": "GFT",
    "decimals": 18
  },
  "networkId": 20948,
  "redFlags": [],
  "rpc": ["https://20948.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/goldfever/testnet/rpc"],
  "shortName": "GoldFever",
  "slug": "goldfever",
  "testnet": true
};

var c21004 = {
  "chain": "C4EI",
  "chainId": 21004,
  "explorers": [{
    "name": "C4EI sirato",
    "url": "https://exp.c4ei.net",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmNPQBLEau3DsUYczt9QCLqZd9jK488GhF5y2SbtLRSrvB",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": ["https://play.google.com/store/apps/details?id=net.c4ei.fps2"],
  "infoURL": "https://c4ei.net",
  "name": "C4EI",
  "nativeCurrency": {
    "name": "C4EI",
    "symbol": "C4EI",
    "decimals": 18
  },
  "networkId": 21004,
  "rpc": ["https://21004.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.c4ei.net"],
  "shortName": "c4ei",
  "slug": "c4ei",
  "testnet": false
};

var c21133 = {
  "chain": "AAH",
  "chainId": 21133,
  "explorers": [{
    "name": "AAH Blockscout",
    "url": "https://exp.c4ex.net",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmY7HDEj3vnTZzCmenotr48nYyD13R2Fyd5t12R9ARu4wJ",
      "width": 256,
      "height": 256,
      "format": "png"
    }
  }],
  "faucets": ["https://t.me/c4eiAirdrop"],
  "infoURL": "https://c4ex.net",
  "name": "All About Healthy",
  "nativeCurrency": {
    "name": "AAH",
    "symbol": "AAH",
    "decimals": 18
  },
  "networkId": 21133,
  "rpc": ["https://21133.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.c4ex.net"],
  "shortName": "aah",
  "slug": "all-about-healthy",
  "testnet": false
};

var c21337 = {
  "chain": "CENNZnet",
  "chainId": 21337,
  "explorers": [{
    "name": "UNcover",
    "url": "https://uncoverexplorer.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWhNm7tTi6SYbiumULDRk956hxgqaZSX77vcxBNn8fvnw",
    "width": 112,
    "height": 112,
    "format": "svg"
  },
  "infoURL": "https://cennz.net",
  "name": "CENNZnet Azalea",
  "nativeCurrency": {
    "name": "CPAY",
    "symbol": "CPAY",
    "decimals": 18
  },
  "networkId": 21337,
  "rpc": ["https://21337.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://cennznet.unfrastructure.io/public"],
  "shortName": "cennz-a",
  "slug": "cennznet-azalea",
  "testnet": false
};

var c21758 = {
  "chain": "Avalanche",
  "chainId": 21758,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "FST 01-16 Multi",
  "nativeCurrency": {
    "name": "FST 01-16 Multi Token",
    "symbol": "RUI",
    "decimals": 18
  },
  "networkId": 21758,
  "redFlags": [],
  "rpc": ["https://21758.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "FST 01-16 Multi",
  "slug": "fst-01-16-multi",
  "testnet": true
};

var c21816 = {
  "chain": "OML",
  "chainId": 21816,
  "explorers": [{
    "name": "omChain Explorer",
    "url": "https://explorer.omchain.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQtEHaejiDbmiCvbBYw9jNQv3DLK5XHCQwLRfnLNpdN5j",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://omchain.io",
  "name": "omChain Mainnet",
  "nativeCurrency": {
    "name": "omChain",
    "symbol": "OMC",
    "decimals": 18
  },
  "networkId": 21816,
  "rpc": ["https://21816.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://seed.omchain.io"],
  "shortName": "omc",
  "slug": "omchain",
  "testnet": false
};

var c21912 = {
  "chain": "BSL",
  "chainId": 21912,
  "explorers": [{
    "name": "BSL Mainnet Explorer",
    "url": "https://scan.nftruth.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://bsquarelab.com/",
  "name": "BSL Mainnet",
  "nativeCurrency": {
    "name": "Origin NFT",
    "symbol": "ONF",
    "decimals": 18
  },
  "networkId": 21912,
  "rpc": ["https://21912.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://rpc-mainnet.nftruth.io:8545", "ws://rpc-mainnet.nftruth.io:8645"],
  "shortName": "onf",
  "slug": "bsl",
  "testnet": false
};

var c22023 = {
  "chain": "Taycan",
  "chainId": 22023,
  "explorers": [{
    "name": "Taycan Explorer(Blockscout)",
    "url": "https://taycan-evmscan.hupayx.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreidvjcc73v747lqlyrhgbnkvkdepdvepo6baj6hmjsmjtvdyhmzzmq",
      "width": 1000,
      "height": 1206,
      "format": "png"
    }
  }, {
    "name": "Taycan Cosmos Explorer(BigDipper)",
    "url": "https://taycan-cosmoscan.hupayx.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreidvjcc73v747lqlyrhgbnkvkdepdvepo6baj6hmjsmjtvdyhmzzmq",
      "width": 1000,
      "height": 1206,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreidvjcc73v747lqlyrhgbnkvkdepdvepo6baj6hmjsmjtvdyhmzzmq",
    "width": 1000,
    "height": 1206,
    "format": "png"
  },
  "infoURL": "https://hupayx.io",
  "name": "Taycan",
  "nativeCurrency": {
    "name": "shuffle",
    "symbol": "SFL",
    "decimals": 18
  },
  "networkId": 22023,
  "rpc": ["https://22023.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://taycan-rpc.hupayx.io:8545"],
  "shortName": "SFL",
  "slug": "taycan",
  "testnet": false
};

var c22040 = {
  "chain": "ambnet-test",
  "chainId": 22040,
  "explorers": [{
    "name": "AirDAO Network Explorer",
    "url": "https://testnet.airdao.io/explorer",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmSxXjvWng3Diz4YwXDV2VqSPgMyzLYBNfkjJcr7rzkxom",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://testnet.airdao.io",
  "name": "AirDAO Testnet",
  "nativeCurrency": {
    "name": "Amber",
    "symbol": "AMB",
    "decimals": 18
  },
  "networkId": 22040,
  "rpc": ["https://22040.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://network.ambrosus-test.io"],
  "shortName": "airdao-test",
  "slip44": 1,
  "slug": "airdao-testnet",
  "testnet": true
};

var c22222 = {
  "chain": "ETH",
  "chainId": 22222,
  "explorers": [{
    "name": "Nautscan",
    "url": "https://nautscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmNutSgM7n6aJPPDiofe9Dm1epy1RcYTMvugukLUK2vmPM",
      "width": 500,
      "height": 500,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNutSgM7n6aJPPDiofe9Dm1epy1RcYTMvugukLUK2vmPM",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://docs.nautchain.xyz",
  "name": "Nautilus Mainnet",
  "nativeCurrency": {
    "name": "Zebec",
    "symbol": "ZBC",
    "decimals": 18
  },
  "networkId": 22222,
  "rpc": ["https://22222.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.nautilus.nautchain.xyz"],
  "shortName": "NAUTCHAIN",
  "slug": "nautilus",
  "testnet": false
};

var c22324 = {
  "chain": "GoldXTestnet",
  "chainId": 22324,
  "explorers": [{
    "name": "GoldXChain Testnet Explorer",
    "url": "https://testnet-explorer.goldxchain.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.goldxchain.io"],
  "infoURL": "https://goldxchain.io",
  "name": "GoldXChain Testnet",
  "nativeCurrency": {
    "name": "GoldX",
    "symbol": "GOLDX",
    "decimals": 18
  },
  "networkId": 22324,
  "rpc": ["https://22324.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.goldxchain.io"],
  "shortName": "goldx-testnet",
  "slug": "goldxchain-testnet",
  "testnet": true
};

var c22662 = {
  "chain": "Avalanche",
  "chainId": 22662,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QA5-03-07 Testnet",
  "nativeCurrency": {
    "name": "QA5-03-07 Testnet Token",
    "symbol": "TYP",
    "decimals": 18
  },
  "networkId": 22662,
  "redFlags": [],
  "rpc": ["https://22662.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QA5-03-07 Testnet",
  "slug": "qa5-03-07-testnet",
  "testnet": true
};

var c22776 = {
  "chain": "MAPO",
  "chainId": 22776,
  "explorers": [{
    "name": "maposcan",
    "url": "https://maposcan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmcLdQ8gM4iHv3CCKA9HuxmzTxY4WhjWtepUVCc3dpzKxD",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://mapprotocol.io/",
  "name": "MAP Protocol",
  "nativeCurrency": {
    "name": "MAPO",
    "symbol": "MAPO",
    "decimals": 18
  },
  "networkId": 22776,
  "rpc": ["https://22776.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.maplabs.io"],
  "shortName": "mapo",
  "slip44": 60,
  "slug": "map-protocol",
  "testnet": false
};

var c22886 = {
  "chain": "Avalanche",
  "chainId": 22886,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Will's Testnet",
  "nativeCurrency": {
    "name": "Will's Testnet Token",
    "symbol": "MBM",
    "decimals": 18
  },
  "networkId": 22886,
  "redFlags": [],
  "rpc": ["https://22886.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Will's Testnet",
  "slug": "will-s-testnet-will's testnet",
  "testnet": true
};

var c22985 = {
  "chain": "ETH",
  "chainId": 22985,
  "explorers": [{
    "name": "beyond-sepolia-3wng1zu3j3 explorer",
    "url": "https://explorerl2new-beyond-sepolia-3wng1zu3j3.t.conduit.xyz",
    "standard": "standard",
    "icon": {
      "url": "ipfs://QmbLxRVZ27Yy6RE9xAdYgSxGPB1TjPtcxahy6uNnp2Pt6T/Beyond.jpg",
      "width": 512,
      "height": 512,
      "format": "jpg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmbLxRVZ27Yy6RE9xAdYgSxGPB1TjPtcxahy6uNnp2Pt6T/Beyond.jpg",
    "width": 512,
    "height": 512,
    "format": "jpg"
  },
  "infoURL": "https://explorerl2new-beyond-sepolia-3wng1zu3j3.t.conduit.xyz",
  "name": "Beyond Sepolia",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 22985,
  "redFlags": [],
  "rpc": ["https://22985.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-beyond-sepolia-3wng1zu3j3.t.conduit.xyz"],
  "shortName": "beyond-sepolia",
  "slug": "beyond-sepolia",
  "testnet": true
};

var c23006 = {
  "chain": "ABN",
  "chainId": 23006,
  "explorers": [{
    "name": "Antofy Testnet",
    "url": "https://test.antofyscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.antofy.io"],
  "icon": {
    "url": "ipfs://QmdTfku81ohnG9ECU1Xswmeumt678cBhwHWuFYZ7i1Qsto",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://antofy.io",
  "name": "Antofy Testnet",
  "nativeCurrency": {
    "name": "Antofy",
    "symbol": "ABN",
    "decimals": 18
  },
  "networkId": 23006,
  "rpc": ["https://23006.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.antofy.io"],
  "shortName": "ABNt",
  "slip44": 1,
  "slug": "antofy-testnet",
  "testnet": true
};

var c23118 = {
  "chain": "Opside",
  "chainId": 23118,
  "explorers": [{
    "name": "opsideInfo",
    "url": "https://opside.info",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.opside.network"],
  "icon": {
    "url": "ipfs://QmeCyZeibUoHNoYGzy1GkzH2uhxyRHKvH51PdaUMer4VTo",
    "width": 591,
    "height": 591,
    "format": "png"
  },
  "infoURL": "https://opside.network",
  "name": "Opside Testnet",
  "nativeCurrency": {
    "name": "IDE",
    "symbol": "IDE",
    "decimals": 18
  },
  "networkId": 23118,
  "rpc": ["https://23118.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testrpc.opside.network"],
  "shortName": "opside",
  "slip44": 1,
  "slug": "opside-testnet",
  "testnet": true
};

var c23294 = {
  "chain": "Sapphire",
  "chainId": 23294,
  "explorers": [{
    "name": "Oasis Sapphire Explorer",
    "url": "https://explorer.oasis.io/mainnet/sapphire",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreiespupb52akiwrexxg7g72mh7m7h7lum5hmqijmpdh3kmuunzclha",
    "width": 2000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://docs.oasis.io/dapp/sapphire",
  "name": "Oasis Sapphire",
  "nativeCurrency": {
    "name": "Sapphire Rose",
    "symbol": "ROSE",
    "decimals": 18
  },
  "networkId": 23294,
  "rpc": ["https://23294.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sapphire.oasis.io", "wss://sapphire.oasis.io/ws"],
  "shortName": "sapphire",
  "slug": "oasis-sapphire",
  "testnet": false
};

var c23295 = {
  "chain": "Sapphire",
  "chainId": 23295,
  "explorers": [{
    "name": "Oasis Sapphire Testnet Explorer",
    "url": "https://explorer.oasis.io/testnet/sapphire",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreiespupb52akiwrexxg7g72mh7m7h7lum5hmqijmpdh3kmuunzclha",
    "width": 2000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://docs.oasis.io/dapp/sapphire",
  "name": "Oasis Sapphire Testnet",
  "nativeCurrency": {
    "name": "Sapphire Test Rose",
    "symbol": "TEST",
    "decimals": 18
  },
  "networkId": 23295,
  "rpc": ["https://23295.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.sapphire.oasis.io", "wss://testnet.sapphire.oasis.io/ws"],
  "shortName": "sapphire-testnet",
  "slip44": 1,
  "slug": "oasis-sapphire-testnet",
  "testnet": true
};

var c23444 = {
  "chain": "Avalanche",
  "chainId": 23444,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2402272",
  "nativeCurrency": {
    "name": "QI M 2402272 Token",
    "symbol": "OVU",
    "decimals": 18
  },
  "networkId": 23444,
  "redFlags": [],
  "rpc": ["https://23444.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI M 2402272",
  "slug": "qi-m-2402272",
  "testnet": true
};

var c23812 = {
  "chain": "Avalanche",
  "chainId": 23812,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "kjCohan Testnet",
  "nativeCurrency": {
    "name": "kjCohan Testnet Token",
    "symbol": "DBM",
    "decimals": 18
  },
  "networkId": 23812,
  "redFlags": [],
  "rpc": ["https://23812.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/d2b6bd35-89f7-4019-bc88-643c31221e5c"],
  "shortName": "kjCohan Testnet",
  "slug": "kjcohan-testnet",
  "testnet": true
};

var c23888 = {
  "chain": "ETH",
  "chainId": 23888,
  "explorers": [{
    "name": "Blast Testnet",
    "url": "http://testnet-explorer.blastblockchain.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdHpjiepU2Q4bt4kR48tKHPgaQW57Sb6UVFgLh4MCyg6U",
    "width": 595,
    "height": 582,
    "format": "png"
  },
  "infoURL": "https://docs.blastblockchain.com",
  "name": "Blast Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 23888,
  "rpc": ["https://23888.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://testnet-rpc.blastblockchain.com"],
  "shortName": "blastT",
  "slug": "blast-testnet",
  "testnet": true
};

var c23934 = {
  "chain": "Avalanche",
  "chainId": 23934,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "ST 11-16 v7 Regression",
  "nativeCurrency": {
    "name": "ST 11-16 v7 Regression Token",
    "symbol": "WLA",
    "decimals": 18
  },
  "networkId": 23934,
  "redFlags": [],
  "rpc": ["https://23934.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "ST 11-16 v7 Regression",
  "slug": "st-11-16-v7-regression",
  "testnet": true
};

var c24070 = {
  "chain": "Avalanche",
  "chainId": 24070,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0315I2 Testnet",
  "nativeCurrency": {
    "name": "QI0315I2 Testnet Token",
    "symbol": "GAW",
    "decimals": 18
  },
  "networkId": 24070,
  "redFlags": [],
  "rpc": ["https://24070.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0315I2 Testnet",
  "slug": "qi0315i2-testnet",
  "testnet": true
};

var c24347 = {
  "chain": "Avalanche",
  "chainId": 24347,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Tnet 02-27",
  "nativeCurrency": {
    "name": "Tnet 02-27 Token",
    "symbol": "TJO",
    "decimals": 18
  },
  "networkId": 24347,
  "redFlags": [],
  "rpc": ["https://24347.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Tnet 02-27",
  "slug": "tnet-02-27",
  "testnet": true
};

var c24484 = {
  "chain": "WEB",
  "chainId": 24484,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://webchain.network",
  "name": "Webchain",
  "nativeCurrency": {
    "name": "Webchain Ether",
    "symbol": "WEB",
    "decimals": 18
  },
  "networkId": 37129,
  "rpc": [],
  "shortName": "web",
  "slip44": 227,
  "slug": "webchain",
  "testnet": false
};

var c24538 = {
  "chain": "Avalanche",
  "chainId": 24538,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2402133",
  "nativeCurrency": {
    "name": "QI M 2402133 Token",
    "symbol": "XVL",
    "decimals": 18
  },
  "networkId": 24538,
  "redFlags": [],
  "rpc": ["https://24538.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI M 2402133",
  "slug": "qi-m-2402133",
  "testnet": true
};

var c24545 = {
  "chain": "Avalanche",
  "chainId": 24545,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser9167 Testnet",
  "nativeCurrency": {
    "name": "QaUser9167 Testnet Token",
    "symbol": "HBG",
    "decimals": 18
  },
  "networkId": 24545,
  "redFlags": [],
  "rpc": ["https://24545.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser9167 Testnet",
  "slug": "qauser9167-testnet",
  "testnet": true
};

var c24668 = {
  "chain": "Avalanche",
  "chainId": 24668,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser4994 Testnet",
  "nativeCurrency": {
    "name": "QaUser4994 Testnet Token",
    "symbol": "PBE",
    "decimals": 18
  },
  "networkId": 24668,
  "redFlags": [],
  "rpc": ["https://24668.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser4994 Testnet",
  "slug": "qauser4994-testnet",
  "testnet": true
};

var c24734 = {
  "chain": "MINTME",
  "chainId": 24734,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.mintme.com",
  "name": "MintMe.com Coin",
  "nativeCurrency": {
    "name": "MintMe.com Coin",
    "symbol": "MINTME",
    "decimals": 18
  },
  "networkId": 37480,
  "rpc": ["https://24734.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node1.mintme.com"],
  "shortName": "mintme",
  "slug": "mintme-com-coin",
  "testnet": false
};

var c24867 = {
  "chain": "Avalanche",
  "chainId": 24867,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser45 Testnet",
  "nativeCurrency": {
    "name": "QaUser45 Testnet Token",
    "symbol": "ZAG",
    "decimals": 18
  },
  "networkId": 24867,
  "redFlags": [],
  "rpc": ["https://24867.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser45 Testnet",
  "slug": "qauser45-testnet",
  "testnet": true
};

var c25186 = {
  "chain": "LiquidLayer",
  "chainId": 25186,
  "explorers": [{
    "name": "LiquidLayer Mainnet Explorer",
    "url": "https://scan.liquidlayer.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreiayuuzfpcgwjll4us4hquvpqa5gwq3lbiedv4qftmlwcxhcyjzzpq",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://scan.liquidlayer.network",
  "name": "LiquidLayer Mainnet",
  "nativeCurrency": {
    "name": "LiquidLayer",
    "symbol": "LILA",
    "decimals": 18
  },
  "networkId": 25186,
  "rpc": ["https://25186.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.liquidlayer.network"],
  "shortName": "LILA",
  "slug": "liquidlayer",
  "testnet": false
};

var c25839 = {
  "chain": "tALV",
  "chainId": 25839,
  "explorers": [{
    "name": "AlveyScan Testnet",
    "url": "https://alveytestnet.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmTuY2Goyxpuy5GmA32EMYZBwxRcGsahiMFgfeBixSk7rb",
      "width": 2048,
      "height": 1538,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.alveytestnet.com"],
  "icon": {
    "url": "ipfs://QmTuY2Goyxpuy5GmA32EMYZBwxRcGsahiMFgfeBixSk7rb",
    "width": 2048,
    "height": 1538,
    "format": "png"
  },
  "infoURL": "https://alveychain.com/",
  "name": "AlveyChain Testnet",
  "nativeCurrency": {
    "name": "AlveyCoin Testnet",
    "symbol": "tALV",
    "decimals": 18
  },
  "networkId": 25839,
  "rpc": ["https://25839.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.alvey.io"],
  "shortName": "talv",
  "slug": "alveychain-testnet",
  "testnet": true
};

var c25888 = {
  "chain": "HammerChain",
  "chainId": 25888,
  "explorers": [{
    "name": "Hammer Chain Explorer",
    "url": "https://www.hammerchain.io",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.hammerchain.io",
  "name": "Hammer Chain Mainnet",
  "nativeCurrency": {
    "name": "GOLDT",
    "symbol": "GOLDT",
    "decimals": 18
  },
  "networkId": 25888,
  "rpc": ["https://25888.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://www.hammerchain.io/rpc"],
  "shortName": "GOLDT",
  "slug": "hammer-chain",
  "testnet": false
};

var c25925 = {
  "chain": "BKC",
  "chainId": 25925,
  "explorers": [{
    "name": "bkcscan-testnet",
    "url": "https://testnet.bkcscan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmYFYwyquipwc9gURQGcEd4iAq7pq15chQrJ3zJJe9HuFT",
      "width": 1000,
      "height": 1000,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.bitkubchain.com"],
  "icon": {
    "url": "ipfs://QmYFYwyquipwc9gURQGcEd4iAq7pq15chQrJ3zJJe9HuFT",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://www.bitkubchain.com/",
  "name": "Bitkub Chain Testnet",
  "nativeCurrency": {
    "name": "Bitkub Coin",
    "symbol": "tKUB",
    "decimals": 18
  },
  "networkId": 25925,
  "rpc": ["https://25925.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.bitkubchain.io", "wss://wss-testnet.bitkubchain.io"],
  "shortName": "bkct",
  "slip44": 1,
  "slug": "bitkub-chain-testnet",
  "testnet": true
};

var c26026 = {
  "chain": "tFRM",
  "chainId": 26026,
  "explorers": [{
    "name": "polkadotjs",
    "url": "https://polkadot.js.org/apps/?rpc=wss%3A%2F%2Ftestnet.dev.svcs.ferrumnetwork.io#/explorer",
    "standard": "none"
  }],
  "faucets": ["https://testnet.faucet.ferrumnetwork.io"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://ferrum.network",
  "name": "Ferrum Testnet",
  "nativeCurrency": {
    "name": "Ferrum",
    "symbol": "tFRM",
    "decimals": 18
  },
  "networkId": 26026,
  "rpc": ["https://26026.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://testnet.dev.svcs.ferrumnetwork.io:9933"],
  "shortName": "frm",
  "slip44": 1,
  "slug": "ferrum-testnet",
  "testnet": true
};

var c26031 = {
  "chain": "Avalanche",
  "chainId": 26031,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser7894 Testnet",
  "nativeCurrency": {
    "name": "QaUser7894 Testnet Token",
    "symbol": "YUT",
    "decimals": 18
  },
  "networkId": 26031,
  "redFlags": [],
  "rpc": ["https://26031.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser7894 Testnet",
  "slug": "qauser7894-testnet",
  "testnet": true
};

var c26600 = {
  "chain": "HTZ",
  "chainId": 26600,
  "explorers": [{
    "name": "Hertz Scan",
    "url": "https://hertzscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://Qmf3GYbPXmTDpSP6t7Ug2j5HjEwrY5oGhBDP7d4TQHvGnG",
      "width": 162,
      "height": 129,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://Qmf3GYbPXmTDpSP6t7Ug2j5HjEwrY5oGhBDP7d4TQHvGnG",
    "width": 162,
    "height": 129,
    "format": "png"
  },
  "infoURL": "https://www.hertz-network.com",
  "name": "Hertz Network Mainnet",
  "nativeCurrency": {
    "name": "Hertz",
    "symbol": "HTZ",
    "decimals": 18
  },
  "networkId": 26600,
  "rpc": ["https://26600.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.hertzscan.com"],
  "shortName": "HTZ",
  "slug": "hertz-network",
  "testnet": false
};

var c26863 = {
  "chain": "OasisChain",
  "chainId": 26863,
  "explorers": [{
    "name": "OasisChain Explorer",
    "url": "https://scan.oasischain.io",
    "standard": "EIP3091"
  }],
  "faucets": ["http://faucet.oasischain.io"],
  "infoURL": "https://scan.oasischain.io",
  "name": "OasisChain Mainnet",
  "nativeCurrency": {
    "name": "OAC",
    "symbol": "OAC",
    "decimals": 18
  },
  "networkId": 26863,
  "rpc": ["https://26863.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc1.oasischain.io", "https://rpc2.oasischain.io", "https://rpc3.oasischain.io"],
  "shortName": "OAC",
  "slug": "oasischain",
  "testnet": false
};

var c27827 = {
  "chain": "Avalanche",
  "chainId": 27827,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "zeroone Mainnet",
  "nativeCurrency": {
    "name": "zeroone Mainnet Token",
    "symbol": "ZERO",
    "decimals": 18
  },
  "networkId": 27827,
  "redFlags": [],
  "rpc": ["https://27827.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/zeroonemai/mainnet/rpc"],
  "shortName": "zeroone Mainnet",
  "slug": "zeroone",
  "testnet": false
};

var c28106 = {
  "chain": "Avalanche",
  "chainId": 28106,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Mezzanine Testnet",
  "nativeCurrency": {
    "name": "Mezzanine Testnet Token",
    "symbol": "OWQ",
    "decimals": 18
  },
  "networkId": 28106,
  "redFlags": [],
  "rpc": ["https://28106.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/mezzaninet/testnet/rpc"],
  "shortName": "Mezzanine Testnet",
  "slug": "mezzanine-testnet",
  "testnet": true
};

var c28528 = {
  "chain": "ETH",
  "chainId": 28528,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscout.com/optimism/bedrock-alpha",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "infoURL": "https://community.optimism.io/docs/developers/bedrock",
  "name": "Optimism Bedrock (Goerli Alpha Testnet)",
  "nativeCurrency": {
    "name": "Goerli Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 28528,
  "redFlags": [],
  "rpc": ["https://28528.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://alpha-1-replica-0.bedrock-goerli.optimism.io", "https://alpha-1-replica-1.bedrock-goerli.optimism.io", "https://alpha-1-replica-2.bedrock-goerli.optimism.io"],
  "shortName": "obgor",
  "slip44": 1,
  "slug": "optimism-bedrock-goerli-alpha-testnet",
  "status": "deprecated",
  "testnet": true
};

var c28982 = {
  "chain": "Avalanche",
  "chainId": 28982,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Testnet",
  "nativeCurrency": {
    "name": "Testnet Token",
    "symbol": "RUI",
    "decimals": 18
  },
  "networkId": 28982,
  "redFlags": [],
  "rpc": ["https://28982.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Testnet",
  "slug": "testnet",
  "testnet": true
};

var c29112 = {
  "chain": "ETH",
  "chainId": 29112,
  "explorers": [{
    "name": "blockscout",
    "url": "https://testnet.explorer.hychain.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmcSJmAfk3iay6uCGJxgUPd9pTsRxbtF4BrNnC5txE9cg8",
      "width": 400,
      "height": 400,
      "format": "jpg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmcSJmAfk3iay6uCGJxgUPd9pTsRxbtF4BrNnC5txE9cg8",
    "width": 400,
    "height": 400,
    "format": "jpg"
  },
  "infoURL": "https://www.hychain.com",
  "name": "HYCHAIN Testnet",
  "nativeCurrency": {
    "name": "TOPIA",
    "symbol": "TOPIA",
    "decimals": 18
  },
  "networkId": 29112,
  "parent": {
    "type": "L2",
    "chain": "eip155-58008",
    "bridges": []
  },
  "redFlags": [],
  "rpc": ["https://29112.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.hychain.com/http"],
  "shortName": "hychain-testnet",
  "slug": "hychain-testnet",
  "testnet": true
};

var c29442 = {
  "chain": "Avalanche",
  "chainId": 29442,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2402055",
  "nativeCurrency": {
    "name": "QI M 2402055 Token",
    "symbol": "ACI",
    "decimals": 18
  },
  "networkId": 29442,
  "redFlags": [],
  "rpc": ["https://29442.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/c908add6-74c5-4407-8091-18762786a0b9"],
  "shortName": "QI M 2402055",
  "slug": "qi-m-2402055",
  "testnet": true
};

var c29548 = {
  "chain": "MCH Verse",
  "chainId": 29548,
  "explorers": [{
    "name": "MCH Verse Explorer",
    "url": "https://explorer.oasys.mycryptoheroes.net",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZZnwR1y6cU1sare2TQmwqkNDLXQxD4GdPrmHLmUoPtbU",
    "width": 4000,
    "height": 4000,
    "format": "png"
  },
  "infoURL": "https://www.mycryptoheroes.net/verse",
  "name": "MCH Verse Mainnet",
  "nativeCurrency": {
    "name": "OAS",
    "symbol": "OAS",
    "decimals": 18
  },
  "networkId": 29548,
  "parent": {
    "type": "L2",
    "chain": "eip155-248"
  },
  "rpc": ["https://29548.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.oasys.mycryptoheroes.net"],
  "shortName": "MCHV",
  "slug": "mch-verse",
  "testnet": false
};

var c29645 = {
  "chain": "Avalanche",
  "chainId": 29645,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser6355 Testnet",
  "nativeCurrency": {
    "name": "QaUser6355 Testnet Token",
    "symbol": "MQO",
    "decimals": 18
  },
  "networkId": 29645,
  "redFlags": [],
  "rpc": ["https://29645.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser6355 Testnet",
  "slug": "qauser6355-testnet",
  "testnet": true
};

var c29830 = {
  "chain": "Avalanche",
  "chainId": 29830,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser6165 Testnet",
  "nativeCurrency": {
    "name": "QaUser6165 Testnet Token",
    "symbol": "TGQ",
    "decimals": 18
  },
  "networkId": 29830,
  "redFlags": [],
  "rpc": ["https://29830.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser6165 Testnet",
  "slug": "qauser6165-testnet",
  "testnet": true
};

var c30067 = {
  "chain": "PieceNetwork",
  "chainId": 30067,
  "explorers": [{
    "name": "Piece Scan",
    "url": "https://testnet-scan.piecenetwork.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://piecenetwork.com/faucet"],
  "icon": {
    "url": "ipfs://QmWAU39z1kcYshAqkENRH8qUjfR5CJehCxA4GiC33p3HpH",
    "width": 800,
    "height": 800,
    "format": "png"
  },
  "infoURL": "https://piecenetwork.com",
  "name": "Piece testnet",
  "nativeCurrency": {
    "name": "ECE",
    "symbol": "ECE",
    "decimals": 18
  },
  "networkId": 30067,
  "rpc": ["https://30067.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc0.piecenetwork.com"],
  "shortName": "Piece",
  "slip44": 1,
  "slug": "piece-testnet",
  "testnet": true
};

var c30103 = {
  "chain": "CAU",
  "chainId": 30103,
  "explorers": [{
    "name": "canxium explorer",
    "url": "https://cerium-explorer.canxium.net",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmXHSbtVNCJVfe2CvRH7njdyf2SrX5u5bNTfvhqjLeFN2A",
    "width": 938,
    "height": 938,
    "format": "png"
  },
  "infoURL": "https://canxium.org",
  "name": "Cerium Testnet",
  "nativeCurrency": {
    "name": "Canxium",
    "symbol": "CAU",
    "decimals": 18
  },
  "networkId": 30103,
  "rpc": ["https://30103.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://cerium-rpc.canxium.net"],
  "shortName": "ceri",
  "slip44": 1,
  "slug": "cerium-testnet",
  "testnet": true
};

var c30226 = {
  "chain": "Avalanche",
  "chainId": 30226,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Will's Testnet",
  "nativeCurrency": {
    "name": "Will's Testnet Token",
    "symbol": "JPQ",
    "decimals": 18
  },
  "networkId": 30226,
  "redFlags": [],
  "rpc": ["https://30226.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Will's Testnet",
  "slug": "will-s-testnet-will's testnet-30226",
  "testnet": true
};

var c30266 = {
  "chain": "Avalanche",
  "chainId": 30266,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Tnet02-06",
  "nativeCurrency": {
    "name": "Tnet02-06 Token",
    "symbol": "LFC",
    "decimals": 18
  },
  "networkId": 30266,
  "redFlags": [],
  "rpc": ["https://30266.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Tnet02-06",
  "slug": "tnet02-06",
  "testnet": true
};

var c30891 = {
  "chain": "Avalanche",
  "chainId": 30891,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Jambon's Testnet",
  "nativeCurrency": {
    "name": "Jambon's Testnet Token",
    "symbol": "CXY",
    "decimals": 18
  },
  "networkId": 30891,
  "redFlags": [],
  "rpc": ["https://30891.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/e8b04790-d50c-4bb1-89ba-7bd140b674f3"],
  "shortName": "Jambon's Testnet",
  "slug": "jambon-s-testnet-jambon's testnet",
  "testnet": true
};

var c30915 = {
  "chain": "Avalanche",
  "chainId": 30915,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Deboard's Testnet",
  "nativeCurrency": {
    "name": "Deboard's Testnet Token",
    "symbol": "DEVAX",
    "decimals": 18
  },
  "networkId": 30915,
  "redFlags": [],
  "rpc": ["https://30915.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/deboardste/testnet/rpc"],
  "shortName": "Deboard's Testnet",
  "slug": "deboard-s-testnet",
  "testnet": true
};

var c31102 = {
  "chain": "ESN",
  "chainId": 31102,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://ethersocial.org",
  "name": "Ethersocial Network",
  "nativeCurrency": {
    "name": "Ethersocial Network Ether",
    "symbol": "ESN",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://31102.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.esn.gonspool.com"],
  "shortName": "esn",
  "slip44": 31102,
  "slug": "ethersocial-network",
  "testnet": false
};

var c31223 = {
  "chain": "CLD",
  "chainId": 31223,
  "explorers": [{
    "name": "cloudtxscan",
    "url": "https://scan.cloudtx.finance",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmSEsi71AdA5HYH6VNC5QUQezFg1C7BiVQJdx1VVfGz3g3",
    "width": 713,
    "height": 830,
    "format": "png"
  },
  "infoURL": "https://cloudtx.finance",
  "name": "CloudTx Mainnet",
  "nativeCurrency": {
    "name": "CloudTx",
    "symbol": "CLD",
    "decimals": 18
  },
  "networkId": 31223,
  "rpc": ["https://31223.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.cloudtx.finance"],
  "shortName": "CLDTX",
  "slug": "cloudtx",
  "testnet": false
};

var c31224 = {
  "chain": "CloudTx",
  "chainId": 31224,
  "explorers": [{
    "name": "cloudtxexplorer",
    "url": "https://explorer.cloudtx.finance",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.cloudtx.finance"],
  "icon": {
    "url": "ipfs://QmSEsi71AdA5HYH6VNC5QUQezFg1C7BiVQJdx1VVfGz3g3",
    "width": 713,
    "height": 830,
    "format": "png"
  },
  "infoURL": "https://cloudtx.finance/",
  "name": "CloudTx Testnet",
  "nativeCurrency": {
    "name": "CloudTx",
    "symbol": "CLD",
    "decimals": 18
  },
  "networkId": 31224,
  "rpc": ["https://31224.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.cloudtx.finance"],
  "shortName": "CLD",
  "slip44": 1,
  "slug": "cloudtx-testnet",
  "testnet": true
};

var c31337 = {
  "chain": "GO",
  "chainId": 31337,
  "explorers": [{
    "name": "GoChain Testnet Explorer",
    "url": "https://testnet-explorer.gochain.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://gochain.io",
  "name": "GoChain Testnet",
  "nativeCurrency": {
    "name": "GoChain Coin",
    "symbol": "GO",
    "decimals": 18
  },
  "networkId": 31337,
  "rpc": ["https://31337.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.gochain.io"],
  "shortName": "got",
  "slip44": 1,
  "slug": "gochain-testnet",
  "testnet": true
};

var c31414 = {
  "chain": "Evoke",
  "chainId": 31414,
  "explorers": [{
    "name": "Evoke SmartChain Testnet Explorer",
    "url": "https://testnet-explorer.evokescan.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.evokescan.org"],
  "icon": {
    "url": "ipfs://bafkreia5q26knsvxgkwxze7woepvsqat5n2hodokh4ozzphmhexqez5s34",
    "width": 100,
    "height": 100,
    "format": "png"
  },
  "infoURL": "https://testnet-explorer.evokescan.org",
  "name": "Evoke Testnet",
  "nativeCurrency": {
    "name": "MTHN Testnet",
    "symbol": "MTHN",
    "decimals": 18
  },
  "networkId": 31414,
  "rpc": ["https://31414.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.evokescan.org"],
  "shortName": "tmthn",
  "slug": "evoke-testnet",
  "testnet": true
};

var c31415 = {
  "chain": "FIL",
  "chainId": 31415,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmS9r9XQkMHVomWcSBNDkKkz9n87h9bH9ssabeiKZtANoU",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://filecoin.io",
  "name": "Filecoin - Wallaby testnet",
  "nativeCurrency": {
    "name": "testnet filecoin",
    "symbol": "tFIL",
    "decimals": 18
  },
  "networkId": 31415,
  "rpc": [],
  "shortName": "filecoin-wallaby",
  "slip44": 1,
  "slug": "filecoin-wallaby-testnet",
  "status": "deprecated",
  "testnet": true
};

var c31646 = {
  "chain": "Avalanche",
  "chainId": 31646,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser9492 Testnet",
  "nativeCurrency": {
    "name": "QaUser9492 Testnet Token",
    "symbol": "UVI",
    "decimals": 18
  },
  "networkId": 31646,
  "redFlags": [],
  "rpc": ["https://31646.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser9492 Testnet",
  "slug": "qauser9492-testnet",
  "testnet": true
};

var c32001 = {
  "chain": "ETH",
  "chainId": 32001,
  "explorers": [{
    "name": "W3Gamez Holesky Explorer",
    "url": "https://w3gamez-holesky.web3games.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmUc57w3UTHiWapNW9oQb1dP57ymtdemTTbpvGkjVHBRCo",
      "width": 192,
      "height": 192,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmaQdiE7vwxKeuWCjk4nKBikcpg4XCzQkFWGrAZHmMKnrq",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://web3games.com/",
  "name": "W3Gamez Holesky Testnet",
  "nativeCurrency": {
    "name": "W3Gamez Testnet Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 32001,
  "rpc": ["https://32001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-holesky.w3gamez.network"],
  "shortName": "w3gamez",
  "slip44": 1,
  "slug": "w3gamez-holesky-testnet",
  "testnet": true
};

var c32277 = {
  "chain": "Avalanche",
  "chainId": 32277,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2402058",
  "nativeCurrency": {
    "name": "QI M 2402058 Token",
    "symbol": "ACI",
    "decimals": 18
  },
  "networkId": 32277,
  "redFlags": [],
  "rpc": ["https://32277.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/c908add6-74c5-4407-8091-18762786a0b9"],
  "shortName": "QI M 2402058",
  "slug": "qi-m-2402058",
  "testnet": true
};

var c32517 = {
  "chain": "Avalanche",
  "chainId": 32517,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser4536 Testnet",
  "nativeCurrency": {
    "name": "QaUser4536 Testnet Token",
    "symbol": "ZKJ",
    "decimals": 18
  },
  "networkId": 32517,
  "redFlags": [],
  "rpc": ["https://32517.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser4536 Testnet",
  "slug": "qauser4536-testnet",
  "testnet": true
};

var c32520 = {
  "chain": "Brise",
  "chainId": 32520,
  "explorers": [{
    "name": "Brise Scan",
    "url": "https://brisescan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmY3vKe1rG9AyHSGH1ouP3ER3EVUZRtRrFbFZEfEpMSd4V",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmY3vKe1rG9AyHSGH1ouP3ER3EVUZRtRrFbFZEfEpMSd4V",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://bitgert.com/",
  "name": "Bitgert Mainnet",
  "nativeCurrency": {
    "name": "Bitrise Token",
    "symbol": "Brise",
    "decimals": 18
  },
  "networkId": 32520,
  "rpc": ["https://32520.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.icecreamswap.com", "https://mainnet-rpc.brisescan.com", "https://chainrpc.com", "https://serverrpc.com"],
  "shortName": "Brise",
  "slug": "bitgert",
  "testnet": false
};

var c32659 = {
  "chain": "FSN",
  "chainId": 32659,
  "explorers": [{
    "name": "fsnscan",
    "url": "https://fsnscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmSAFx34SKNi7a139agX12f68oBMo2Ktt9c8yD8aFa14gd",
      "width": 48,
      "height": 51,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmX3tsEoj7SdaBLLV8VyyCUAmymdEGiSGeuTbxMrEMVvth",
    "width": 31,
    "height": 31,
    "format": "svg"
  },
  "infoURL": "https://fusion.org",
  "name": "Fusion Mainnet",
  "nativeCurrency": {
    "name": "Fusion",
    "symbol": "FSN",
    "decimals": 18
  },
  "networkId": 32659,
  "rpc": ["https://32659.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.fusionnetwork.io", "wss://mainnet.fusionnetwork.io"],
  "shortName": "fsn",
  "slip44": 288,
  "slug": "fusion",
  "testnet": false
};

var c32769 = {
  "chain": "ZIL",
  "chainId": 32769,
  "explorers": [{
    "name": "Zilliqa EVM Explorer",
    "url": "https://evmx.zilliqa.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmTREXNgGtUhSoxFsrkhTe5LUnDBTKL5byaX8kpET6UuKp",
    "width": 2048,
    "height": 2048,
    "format": "png"
  },
  "infoURL": "https://www.zilliqa.com/",
  "name": "Zilliqa EVM",
  "nativeCurrency": {
    "name": "Zilliqa",
    "symbol": "ZIL",
    "decimals": 18
  },
  "networkId": 32769,
  "rpc": ["https://32769.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.zilliqa.com"],
  "shortName": "zil",
  "slug": "zilliqa-evm",
  "testnet": false
};

var c32990 = {
  "chain": "ZIL",
  "chainId": 32990,
  "explorers": [{
    "name": "Zilliqa EVM Isolated Server Explorer",
    "url": "https://devex.zilliqa.com/?network=https://zilliqa-isolated-server.zilliqa.com",
    "standard": "none"
  }],
  "faucets": ["https://dev-wallet.zilliqa.com/faucet?network=isolated_server"],
  "icon": {
    "url": "ipfs://QmTREXNgGtUhSoxFsrkhTe5LUnDBTKL5byaX8kpET6UuKp",
    "width": 2048,
    "height": 2048,
    "format": "png"
  },
  "infoURL": "https://www.zilliqa.com/",
  "name": "Zilliqa EVM Isolated Server",
  "nativeCurrency": {
    "name": "Zilliqa",
    "symbol": "ZIL",
    "decimals": 18
  },
  "networkId": 32990,
  "rpc": ["https://32990.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://zilliqa-isolated-server.zilliqa.com/"],
  "shortName": "zil-isolated-server",
  "slug": "zilliqa-evm-isolated-server",
  "testnet": false
};

var c33101 = {
  "chain": "ZIL",
  "chainId": 33101,
  "explorers": [{
    "name": "Zilliqa EVM Explorer",
    "url": "https://evmx.zilliqa.com",
    "standard": "none"
  }],
  "faucets": ["https://dev-wallet.zilliqa.com/faucet?network=testnet"],
  "infoURL": "https://www.zilliqa.com/",
  "name": "Zilliqa EVM Testnet",
  "nativeCurrency": {
    "name": "Zilliqa",
    "symbol": "ZIL",
    "decimals": 18
  },
  "networkId": 33101,
  "rpc": ["https://33101.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dev-api.zilliqa.com"],
  "shortName": "zil-testnet",
  "slip44": 1,
  "slug": "zilliqa-evm-testnet",
  "testnet": true
};

var c33210 = {
  "chain": "CLOUDVERSE",
  "chainId": 33210,
  "explorers": [{
    "name": "CLOUDVERSE Explorer",
    "url": "https://subnets.avax.network/cloudverse",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "infoURL": "https://muadao.build/",
  "name": "Cloudverse Subnet",
  "nativeCurrency": {
    "name": "XCLOUD",
    "symbol": "XCLOUD",
    "decimals": 18
  },
  "networkId": 33210,
  "rpc": ["https://33210.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/cloudverse/mainnet/rpc"],
  "shortName": "cloudverse",
  "slug": "cloudverse-subnet",
  "testnet": false
};

var c33333 = {
  "chain": "AVS",
  "chainId": 33333,
  "explorers": [{
    "name": "avescan",
    "url": "https://avescan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmeKQVv2QneHaaggw2NfpZ7DGMdjVhPywTdse5RzCs4oGn",
      "width": 232,
      "height": 232,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmeKQVv2QneHaaggw2NfpZ7DGMdjVhPywTdse5RzCs4oGn",
    "width": 232,
    "height": 232,
    "format": "png"
  },
  "infoURL": "https://avescoin.io",
  "name": "Aves Mainnet",
  "nativeCurrency": {
    "name": "Aves",
    "symbol": "AVS",
    "decimals": 18
  },
  "networkId": 33333,
  "rpc": ["https://33333.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.avescoin.io"],
  "shortName": "avs",
  "slug": "aves",
  "testnet": false
};

var c33385 = {
  "chain": "ZIL",
  "chainId": 33385,
  "explorers": [{
    "name": "Zilliqa EVM Devnet Explorer",
    "url": "https://otterscan.devnet.zilliqa.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.devnet.zilliqa.com/"],
  "icon": {
    "url": "ipfs://QmTREXNgGtUhSoxFsrkhTe5LUnDBTKL5byaX8kpET6UuKp",
    "width": 2048,
    "height": 2048,
    "format": "png"
  },
  "infoURL": "https://www.zilliqa.com/",
  "name": "Zilliqa EVM Devnet",
  "nativeCurrency": {
    "name": "Zilliqa",
    "symbol": "ZIL",
    "decimals": 18
  },
  "networkId": 33385,
  "rpc": ["https://33385.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.devnet.zilliqa.com/"],
  "shortName": "zil-devnet",
  "slug": "zilliqa-evm-devnet",
  "testnet": false
};

var c33448 = {
  "chain": "Avalanche",
  "chainId": 33448,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0408s2 Testnet",
  "nativeCurrency": {
    "name": "QI0408s2 Testnet Token",
    "symbol": "QCE",
    "decimals": 18
  },
  "networkId": 33448,
  "redFlags": [],
  "rpc": ["https://33448.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0408s2 Testnet",
  "slug": "qi0408s2-testnet",
  "testnet": true
};

var c33469 = {
  "chain": "ZIL",
  "chainId": 33469,
  "explorers": [{
    "name": "Zilliqa-2 EVM Devnet Explorer",
    "url": "https://explorer.zq2-devnet.zilliqa.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.zq2-devnet.zilliqa.com"],
  "icon": {
    "url": "ipfs://QmTREXNgGtUhSoxFsrkhTe5LUnDBTKL5byaX8kpET6UuKp",
    "width": 2048,
    "height": 2048,
    "format": "png"
  },
  "infoURL": "https://www.zilliqa.com/",
  "name": "Zilliqa-2 EVM Devnet",
  "nativeCurrency": {
    "name": "Zilliqa",
    "symbol": "ZIL",
    "decimals": 18
  },
  "networkId": 33469,
  "rpc": ["https://33469.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.zq2-devnet.zilliqa.com"],
  "shortName": "zq2-devnet",
  "slug": "zilliqa-2-evm-devnet",
  "testnet": false
};

var c33909 = {
  "chain": "Avalanche",
  "chainId": 33909,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Reg1116test",
  "nativeCurrency": {
    "name": "Reg1116test Token",
    "symbol": "JUO",
    "decimals": 18
  },
  "networkId": 33909,
  "redFlags": [],
  "rpc": ["https://33909.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Reg1116test",
  "slug": "reg1116test",
  "testnet": true
};

var c34295 = {
  "chain": "Avalanche",
  "chainId": 34295,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2402132",
  "nativeCurrency": {
    "name": "QI M 2402132 Token",
    "symbol": "CYB",
    "decimals": 18
  },
  "networkId": 34295,
  "redFlags": [],
  "rpc": ["https://34295.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI M 2402132",
  "slug": "qi-m-2402132",
  "testnet": true
};

var c34443 = {
  "chain": "ETH",
  "chainId": 34443,
  "explorers": [{
    "name": "modescout",
    "url": "https://explorer.mode.network",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreidi5y7afj5z4xrz7uz5rkg2mcsv2p2n4ui4g7q4k4ecdz65i2agou",
    "width": 2160,
    "height": 2160,
    "format": "png"
  },
  "infoURL": "https://docs.mode.network/",
  "name": "Mode",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 34443,
  "rpc": ["https://34443.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.mode.network", "https://mode.drpc.org", "wss://mode.drpc.org"],
  "shortName": "mode",
  "slug": "mode",
  "testnet": false
};

var c35011 = {
  "chain": "TARO",
  "chainId": 35011,
  "explorers": [{
    "name": "J2O Taro Explorer",
    "url": "https://exp.j2o.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmdUYi8fjnvdM9iFQ7dwE2YvmhDtavSB3bKhCD2GhPxPks",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://j2o.io",
  "name": "J2O Taro",
  "nativeCurrency": {
    "name": "TARO Coin",
    "symbol": "taro",
    "decimals": 18
  },
  "networkId": 35011,
  "rpc": ["https://35011.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.j2o.io"],
  "shortName": "j2o",
  "slug": "j2o-taro",
  "testnet": false
};

var c35395 = {
  "chain": "Avalanche",
  "chainId": 35395,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Found 1-4-23",
  "nativeCurrency": {
    "name": "Found 1-4-23 Token",
    "symbol": "TVJ",
    "decimals": 18
  },
  "networkId": 35395,
  "redFlags": [],
  "rpc": ["https://35395.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Found 1-4-23",
  "slug": "found-1-4-23",
  "testnet": true
};

var c35439 = {
  "chain": "Avalanche",
  "chainId": 35439,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2401122",
  "nativeCurrency": {
    "name": "QI M 2401122 Token",
    "symbol": "HZU",
    "decimals": 18
  },
  "networkId": 35439,
  "redFlags": [],
  "rpc": ["https://35439.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/f14d837e-de8f-446d-8222-0077f26e6694"],
  "shortName": "QI M 2401122",
  "slug": "qi-m-2401122",
  "testnet": true
};

var c35441 = {
  "chain": "Q",
  "chainId": 35441,
  "explorers": [{
    "name": "Q explorer",
    "url": "https://explorer.q.org",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmQUQKe8VEtSthhgXnJ3EmEz94YhpVCpUDZAiU9KYyNLya",
      "width": 585,
      "height": 603,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQUQKe8VEtSthhgXnJ3EmEz94YhpVCpUDZAiU9KYyNLya",
    "width": 585,
    "height": 603,
    "format": "png"
  },
  "infoURL": "https://q.org",
  "name": "Q Mainnet",
  "nativeCurrency": {
    "name": "QGOV",
    "symbol": "QGOV",
    "decimals": 18
  },
  "networkId": 35441,
  "rpc": ["https://35441.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.q.org"],
  "shortName": "q",
  "slug": "q",
  "testnet": false
};

var c35443 = {
  "chain": "Q",
  "chainId": 35443,
  "explorers": [{
    "name": "Q explorer",
    "url": "https://explorer.qtestnet.org",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmQUQKe8VEtSthhgXnJ3EmEz94YhpVCpUDZAiU9KYyNLya",
      "width": 585,
      "height": 603,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQUQKe8VEtSthhgXnJ3EmEz94YhpVCpUDZAiU9KYyNLya",
    "width": 585,
    "height": 603,
    "format": "png"
  },
  "infoURL": "https://q.org/",
  "name": "Q Testnet",
  "nativeCurrency": {
    "name": "Q token",
    "symbol": "Q",
    "decimals": 18
  },
  "networkId": 35443,
  "rpc": ["https://35443.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.qtestnet.org"],
  "shortName": "q-testnet",
  "slip44": 1,
  "slug": "q-testnet",
  "testnet": true
};

var c35730 = {
  "chain": "Avalanche",
  "chainId": 35730,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR1129I1",
  "nativeCurrency": {
    "name": "QR1129I1 Token",
    "symbol": "YXAX",
    "decimals": 18
  },
  "networkId": 35730,
  "redFlags": [],
  "rpc": ["https://35730.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr1129i1/testnet/rpc"],
  "shortName": "QR1129I1",
  "slug": "qr1129i1",
  "testnet": true
};

var c36530 = {
  "chain": "Avalanche",
  "chainId": 36530,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Will's Super Subnet",
  "nativeCurrency": {
    "name": "Will's Super Subnet Token",
    "symbol": "VRJ",
    "decimals": 18
  },
  "networkId": 36530,
  "redFlags": [],
  "rpc": ["https://36530.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Will's Super Subnet",
  "slug": "will-s-super-subnet",
  "testnet": true
};

var c36695 = {
  "chain": "Avalanche",
  "chainId": 36695,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Cohan Yolo Testnet",
  "nativeCurrency": {
    "name": "Cohan Yolo Testnet Token",
    "symbol": "KYI",
    "decimals": 18
  },
  "networkId": 36695,
  "redFlags": [],
  "rpc": ["https://36695.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/c033f73a-70ff-463d-b121-81b9542e11a1"],
  "shortName": "Cohan Yolo Testnet",
  "slug": "cohan-yolo-testnet",
  "testnet": true
};

var c36746 = {
  "chain": "Avalanche",
  "chainId": 36746,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser1213 Testnet",
  "nativeCurrency": {
    "name": "QaUser1213 Testnet Token",
    "symbol": "ZKJ",
    "decimals": 18
  },
  "networkId": 36746,
  "redFlags": [],
  "rpc": ["https://36746.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser1213 Testnet",
  "slug": "qauser1213-testnet",
  "testnet": true
};

var c36908 = {
  "chain": "Avalanche",
  "chainId": 36908,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR1205s1",
  "nativeCurrency": {
    "name": "QR1205s1 Token",
    "symbol": "MDN",
    "decimals": 18
  },
  "networkId": 36908,
  "redFlags": [],
  "rpc": ["https://36908.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr1205s1/testnet/rpc"],
  "shortName": "QR1205s1",
  "slug": "qr1205s1",
  "testnet": true
};

var c37195 = {
  "chain": "Avalanche",
  "chainId": 37195,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Thari",
  "nativeCurrency": {
    "name": "Thari Token",
    "symbol": "THARI",
    "decimals": 18
  },
  "networkId": 37195,
  "redFlags": [],
  "rpc": ["https://37195.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/thari/testnet/rpc"],
  "shortName": "Thari",
  "slug": "thari",
  "testnet": true
};

var c37375 = {
  "chain": "Avalanche",
  "chainId": 37375,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2402057",
  "nativeCurrency": {
    "name": "QI M 2402057 Token",
    "symbol": "ACI",
    "decimals": 18
  },
  "networkId": 37375,
  "redFlags": [],
  "rpc": ["https://37375.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/c908add6-74c5-4407-8091-18762786a0b9"],
  "shortName": "QI M 2402057",
  "slug": "qi-m-2402057",
  "testnet": true
};

var c37767 = {
  "chain": "Avalanche",
  "chainId": 37767,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Tnet 01-15",
  "nativeCurrency": {
    "name": "Tnet 01-15 Token",
    "symbol": "LFC",
    "decimals": 18
  },
  "networkId": 37767,
  "redFlags": [],
  "rpc": ["https://37767.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Tnet 01-15",
  "slug": "tnet-01-15",
  "testnet": true
};

var c38085 = {
  "chain": "Avalanche",
  "chainId": 38085,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0227I1",
  "nativeCurrency": {
    "name": "QI0227I1 Token",
    "symbol": "ULH",
    "decimals": 18
  },
  "networkId": 38085,
  "redFlags": [],
  "rpc": ["https://38085.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0227I1",
  "slug": "qi0227i1",
  "testnet": true
};

var c38400 = {
  "chain": "Rangers",
  "chainId": 38400,
  "explorers": [{
    "name": "rangersscan",
    "url": "https://scan.rangersprotocol.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmXR5e5SDABWfQn6XT9uMsVYAo5Bv7vUv4jVs8DFqatZWG",
    "width": 2000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://rangersprotocol.com",
  "name": "ConnectorManager",
  "nativeCurrency": {
    "name": "Rangers Protocol Gas",
    "symbol": "cmRPG",
    "decimals": 18
  },
  "networkId": 38400,
  "rpc": ["https://38400.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://cm.rangersprotocol.com/api/jsonrpc"],
  "shortName": "cmrpg",
  "slug": "connectormanager",
  "testnet": false
};

var c38401 = {
  "chain": "Rangers",
  "chainId": 38401,
  "explorers": [{
    "name": "rangersscan-robin",
    "url": "https://robin-rangersscan.rangersprotocol.com",
    "standard": "none"
  }],
  "faucets": ["https://robin-faucet.rangersprotocol.com"],
  "icon": {
    "url": "ipfs://QmXR5e5SDABWfQn6XT9uMsVYAo5Bv7vUv4jVs8DFqatZWG",
    "width": 2000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://rangersprotocol.com",
  "name": "ConnectorManager Robin",
  "nativeCurrency": {
    "name": "Rangers Protocol Gas",
    "symbol": "ttRPG",
    "decimals": 18
  },
  "networkId": 38401,
  "rpc": ["https://38401.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://robin-cm.rangersprotocol.com/api/jsonrpc"],
  "shortName": "ttrpg",
  "slug": "connectormanager-robin",
  "testnet": false
};

var c39098 = {
  "chain": "Avalanche",
  "chainId": 39098,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI 20240108",
  "nativeCurrency": {
    "name": "QI 20240108 Token",
    "symbol": "COZ",
    "decimals": 18
  },
  "networkId": 39098,
  "redFlags": [],
  "rpc": ["https://39098.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/f575b5b1-8b60-47f3-af28-13f3f3de2ba5"],
  "shortName": "QI 20240108",
  "slug": "qi-20240108",
  "testnet": true
};

var c39142 = {
  "chain": "Avalanche",
  "chainId": 39142,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "ST Found 1-05-24",
  "nativeCurrency": {
    "name": "ST Found 1-05-24 Token",
    "symbol": "LGT",
    "decimals": 18
  },
  "networkId": 39142,
  "redFlags": [],
  "rpc": ["https://39142.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "ST Found 1-05-24",
  "slug": "st-found-1-05-24",
  "testnet": true
};

var c39747 = {
  "chain": "Avalanche",
  "chainId": 39747,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser41Testnet",
  "nativeCurrency": {
    "name": "QaUser41Testnet Token",
    "symbol": "GYF",
    "decimals": 18
  },
  "networkId": 39747,
  "redFlags": [],
  "rpc": ["https://39747.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser41Testnet",
  "slug": "qauser41testnet",
  "testnet": true
};

var c39797 = {
  "chain": "NRG",
  "chainId": 39797,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.energi.world/",
  "name": "Energi Mainnet",
  "nativeCurrency": {
    "name": "Energi",
    "symbol": "NRG",
    "decimals": 18
  },
  "networkId": 39797,
  "rpc": ["https://39797.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://nodeapi.energi.network"],
  "shortName": "nrg",
  "slip44": 39797,
  "slug": "energi",
  "testnet": false
};

var c39815 = {
  "chain": "OHO",
  "chainId": 39815,
  "explorers": [{
    "name": "ohoscan",
    "url": "https://ohoscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmZt75xixnEtFzqHTrJa8kJkV4cTXmUZqeMeHM8BcvomQc",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZt75xixnEtFzqHTrJa8kJkV4cTXmUZqeMeHM8BcvomQc",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://oho.ai",
  "name": "OHO Mainnet",
  "nativeCurrency": {
    "name": "OHO",
    "symbol": "OHO",
    "decimals": 18
  },
  "networkId": 39815,
  "rpc": ["https://39815.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.oho.ai"],
  "shortName": "oho",
  "slug": "oho",
  "testnet": false
};

var c40542 = {
  "chain": "Avalanche",
  "chainId": 40542,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI1212I8",
  "nativeCurrency": {
    "name": "QI1212I8 Token",
    "symbol": "HSCX",
    "decimals": 18
  },
  "networkId": 40542,
  "redFlags": [],
  "rpc": ["https://40542.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-test.io/ba4e7766-4bc6-44ec-b43f-598647b4ee71"],
  "shortName": "QI1212I8",
  "slug": "qi1212i8",
  "testnet": true
};

var c40798 = {
  "chain": "Avalanche",
  "chainId": 40798,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "qr0109y1p",
  "nativeCurrency": {
    "name": "qr0109y1p Token",
    "symbol": "KZP",
    "decimals": 18
  },
  "networkId": 40798,
  "redFlags": [],
  "rpc": ["https://40798.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0109y1p/testnet/rpc"],
  "shortName": "qr0109y1p",
  "slug": "qr0109y1p",
  "testnet": true
};

var c40868 = {
  "chain": "Avalanche",
  "chainId": 40868,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser5110 Testnet",
  "nativeCurrency": {
    "name": "QaUser5110 Testnet Token",
    "symbol": "CRL",
    "decimals": 18
  },
  "networkId": 40868,
  "redFlags": [],
  "rpc": ["https://40868.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser5110 Testnet",
  "slug": "qauser5110-testnet",
  "testnet": true
};

var c41077 = {
  "chain": "Avalanche",
  "chainId": 41077,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "REALLY",
  "nativeCurrency": {
    "name": "REALLY Token",
    "symbol": "FAN",
    "decimals": 18
  },
  "networkId": 41077,
  "redFlags": [],
  "rpc": ["https://41077.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/really/testnet/rpc"],
  "shortName": "REALLY",
  "slug": "really",
  "testnet": true
};

var c41425 = {
  "chain": "Avalanche",
  "chainId": 41425,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0205I1",
  "nativeCurrency": {
    "name": "QR0205I1 Token",
    "symbol": "PVW",
    "decimals": 18
  },
  "networkId": 41425,
  "redFlags": [],
  "rpc": ["https://41425.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0205i1/testnet/rpc"],
  "shortName": "QR0205I1",
  "slug": "qr0205i1",
  "testnet": true
};

var c41500 = {
  "chain": "Opulent-X",
  "chainId": 41500,
  "explorers": [{
    "name": "Opulent-X BETA Explorer",
    "url": "https://explorer.opulent-x.com",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://beta.opulent-x.com",
  "name": "Opulent-X BETA",
  "nativeCurrency": {
    "name": "Oxyn Gas",
    "symbol": "OXYN",
    "decimals": 18
  },
  "networkId": 41500,
  "rpc": ["https://41500.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://connect.opulent-x.com"],
  "shortName": "ox-beta",
  "slug": "opulent-x-beta",
  "testnet": false
};

var c41604 = {
  "chain": "Avalanche",
  "chainId": 41604,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Testnet",
  "nativeCurrency": {
    "name": "Testnet Token",
    "symbol": "LFC",
    "decimals": 18
  },
  "networkId": 41604,
  "redFlags": [],
  "rpc": ["https://41604.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Testnet",
  "slug": "testnet-testnet",
  "testnet": true
};

var c41799 = {
  "chain": "Avalanche",
  "chainId": 41799,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Will's New Testnet",
  "nativeCurrency": {
    "name": "Will's New Testnet Token",
    "symbol": "ZBO",
    "decimals": 18
  },
  "networkId": 41799,
  "redFlags": [],
  "rpc": ["https://41799.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Will's New Testnet",
  "slug": "will-s-new-testnet",
  "testnet": true
};

var c42069 = {
  "chain": "42069",
  "chainId": 42069,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://teampeggle.com",
  "name": "pegglecoin",
  "nativeCurrency": {
    "name": "pegglecoin",
    "symbol": "peggle",
    "decimals": 18
  },
  "networkId": 42069,
  "rpc": [],
  "shortName": "PC",
  "slug": "pegglecoin",
  "testnet": false
};

var c42161 = {
  "chain": "ETH",
  "chainId": 42161,
  "explorers": [{
    "name": "Arbiscan",
    "url": "https://arbiscan.io",
    "standard": "EIP3091"
  }, {
    "name": "Arbitrum Explorer",
    "url": "https://explorer.arbitrum.io",
    "standard": "EIP3091"
  }, {
    "name": "dexguru",
    "url": "https://arbitrum.dex.guru",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne",
      "width": 83,
      "height": 82,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/arbitrum/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://arbitrum.io",
  "name": "Arbitrum One",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 42161,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.arbitrum.io"
    }]
  },
  "redFlags": [],
  "rpc": ["https://42161.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://arbitrum-mainnet.infura.io/v3/${INFURA_API_KEY}", "https://arb-mainnet.g.alchemy.com/v2/${ALCHEMY_API_KEY}", "https://arb1.arbitrum.io/rpc", "https://arbitrum-one.publicnode.com", "wss://arbitrum-one.publicnode.com"],
  "shortName": "arb1",
  "slug": "arbitrum",
  "testnet": false
};

var c42170 = {
  "chain": "ETH",
  "chainId": 42170,
  "explorers": [{
    "name": "Arbitrum Nova Chain Explorer",
    "url": "https://nova-explorer.arbitrum.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }, {
    "name": "dexguru",
    "url": "https://nova.dex.guru",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne",
      "width": 83,
      "height": 82,
      "format": "svg"
    }
  }],
  "faucets": [],
  "infoURL": "https://arbitrum.io",
  "name": "Arbitrum Nova",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 42170,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.arbitrum.io"
    }]
  },
  "rpc": ["https://42170.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://nova.arbitrum.io/rpc", "https://arbitrum-nova.publicnode.com", "wss://arbitrum-nova.publicnode.com"],
  "shortName": "arb-nova",
  "slug": "arbitrum-nova",
  "testnet": false
};

var c42220 = {
  "chain": "CELO",
  "chainId": 42220,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.celo.org",
    "standard": "none"
  }, {
    "name": "Celoscan",
    "url": "https://celoscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://docs.celo.org/",
  "name": "Celo Mainnet",
  "nativeCurrency": {
    "name": "CELO",
    "symbol": "CELO",
    "decimals": 18
  },
  "networkId": 42220,
  "rpc": ["https://42220.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://forno.celo.org", "wss://forno.celo.org/ws"],
  "shortName": "celo",
  "slug": "celo",
  "testnet": false
};

var c42261 = {
  "chain": "Emerald",
  "chainId": 42261,
  "explorers": [{
    "name": "Oasis Emerald Testnet Explorer",
    "url": "https://explorer.oasis.io/testnet/emerald",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.testnet.oasis.io/"],
  "icon": {
    "url": "ipfs://bafkreiespupb52akiwrexxg7g72mh7m7h7lum5hmqijmpdh3kmuunzclha",
    "width": 2000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://docs.oasis.io/dapp/emerald",
  "name": "Oasis Emerald Testnet",
  "nativeCurrency": {
    "name": "Emerald Rose",
    "symbol": "ROSE",
    "decimals": 18
  },
  "networkId": 42261,
  "rpc": ["https://42261.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.emerald.oasis.io/", "wss://testnet.emerald.oasis.io/ws"],
  "shortName": "emerald-testnet",
  "slip44": 1,
  "slug": "oasis-emerald-testnet",
  "testnet": true
};

var c42262 = {
  "chain": "Emerald",
  "chainId": 42262,
  "explorers": [{
    "name": "Oasis Emerald Explorer",
    "url": "https://explorer.oasis.io/mainnet/emerald",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreiespupb52akiwrexxg7g72mh7m7h7lum5hmqijmpdh3kmuunzclha",
    "width": 2000,
    "height": 2000,
    "format": "png"
  },
  "infoURL": "https://docs.oasis.io/dapp/emerald",
  "name": "Oasis Emerald",
  "nativeCurrency": {
    "name": "Emerald Rose",
    "symbol": "ROSE",
    "decimals": 18
  },
  "networkId": 42262,
  "rpc": ["https://42262.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://emerald.oasis.io", "wss://emerald.oasis.io/ws"],
  "shortName": "emerald",
  "slug": "oasis-emerald",
  "testnet": false
};

var c42355 = {
  "chain": "GoldX",
  "chainId": 42355,
  "explorers": [{
    "name": "GoldXChain Explorer",
    "url": "https://explorer.goldxchain.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://goldxchain.io",
  "name": "GoldXChain Mainnet",
  "nativeCurrency": {
    "name": "GoldX",
    "symbol": "GOLDX",
    "decimals": 18
  },
  "networkId": 42355,
  "rpc": ["https://42355.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.goldxchain.io"],
  "shortName": "goldx",
  "slug": "goldxchain",
  "testnet": false
};

var c42451 = {
  "chain": "Avalanche",
  "chainId": 42451,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI1220s1",
  "nativeCurrency": {
    "name": "QI1220s1 Token",
    "symbol": "BKX",
    "decimals": 18
  },
  "networkId": 42451,
  "redFlags": [],
  "rpc": ["https://42451.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI1220s1",
  "slug": "qi1220s1",
  "testnet": true
};

var c42766 = {
  "chain": "ZKFair",
  "chainId": 42766,
  "explorers": [{
    "name": "blockscout",
    "url": "https://scan.zkfair.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmVb682D4mUXkKNP28xxJDNgSYbDLvEc3kVYx7TQxEa6Cw",
      "width": 400,
      "height": 400,
      "format": "jpg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVb682D4mUXkKNP28xxJDNgSYbDLvEc3kVYx7TQxEa6Cw",
    "width": 400,
    "height": 400,
    "format": "jpg"
  },
  "infoURL": "https://zkfair.io",
  "name": "ZKFair Mainnet",
  "nativeCurrency": {
    "name": "USDC Token",
    "symbol": "USDC",
    "decimals": 18
  },
  "networkId": 42766,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://wallet.zkfair.io"
    }]
  },
  "rpc": ["https://42766.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.zkfair.io"],
  "shortName": "ZKFair-Mainnet",
  "slug": "zkfair",
  "testnet": false,
  "title": "ZKFair Mainnet"
};

var c42801 = {
  "chain": "Gesoten Verse",
  "chainId": 42801,
  "explorers": [{
    "name": "Gesoten Verse Testnet Explorer",
    "url": "https://explorer.testnet.verse.gesoten.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmb7oJY9zd9sTzxNNQNTVZQz2hkd1aA94mWm4cvXfJ9QxV",
    "width": 1280,
    "height": 1280,
    "format": "png"
  },
  "infoURL": "https://gesoten.com/",
  "name": "Gesoten Verse Testnet",
  "nativeCurrency": {
    "name": "OAS",
    "symbol": "OAS",
    "decimals": 18
  },
  "networkId": 42801,
  "rpc": ["https://42801.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.verse.gesoten.com/"],
  "shortName": "GST",
  "slip44": 1,
  "slug": "gesoten-verse-testnet",
  "testnet": true
};

var c42840 = {
  "chain": "Avalanche",
  "chainId": 42840,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Will's Testnet",
  "nativeCurrency": {
    "name": "Will's Testnet Token",
    "symbol": "DQX",
    "decimals": 18
  },
  "networkId": 42840,
  "redFlags": [],
  "rpc": ["https://42840.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Will's Testnet",
  "slug": "will-s-testnet-will's testnet-42840",
  "testnet": true
};

var c42888 = {
  "chain": "ETH",
  "chainId": 42888,
  "explorers": [{
    "name": "kintoscan",
    "url": "http://35.215.120.180:4000",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://ethereum.org",
  "name": "Kinto Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 42888,
  "rpc": ["https://42888.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://35.215.120.180:8545"],
  "shortName": "keth",
  "slip44": 1,
  "slug": "kinto-testnet",
  "testnet": true,
  "title": "Kinto Testnet"
};

var c43110 = {
  "chain": "ATH",
  "chainId": 43110,
  "explorers": [],
  "faucets": ["http://athfaucet.ava.network//?address=${ADDRESS}"],
  "infoURL": "https://athereum.ava.network",
  "name": "Athereum",
  "nativeCurrency": {
    "name": "Athereum Ether",
    "symbol": "ATH",
    "decimals": 18
  },
  "networkId": 43110,
  "rpc": ["https://43110.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://ava.network:21015/ext/evm/rpc"],
  "shortName": "avaeth",
  "slug": "athereum",
  "testnet": false
};

var c43111 = {
  "chain": "ETH",
  "chainId": 43111,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://hemi.xyz",
  "name": "Hemi Network",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 43111,
  "parent": {
    "type": "L2",
    "chain": "eip155-1"
  },
  "rpc": [],
  "shortName": "hemi",
  "slug": "hemi-network",
  "status": "incubating",
  "testnet": false
};

var c43113 = {
  "chain": "AVAX",
  "chainId": 43113,
  "explorers": [{
    "name": "snowtrace",
    "url": "https://testnet.snowtrace.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.avax-test.network/"],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/avalanche/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://cchain.explorer.avax-test.network",
  "name": "Avalanche Fuji Testnet",
  "nativeCurrency": {
    "name": "Avalanche",
    "symbol": "AVAX",
    "decimals": 18
  },
  "networkId": 43113,
  "redFlags": [],
  "rpc": ["https://43113.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.avax-test.network/ext/bc/C/rpc", "https://avalanche-fuji-c-chain-rpc.publicnode.com", "wss://avalanche-fuji-c-chain-rpc.publicnode.com"],
  "shortName": "Fuji",
  "slip44": 1,
  "slug": "avalanche-fuji",
  "testnet": true
};

var c43114 = {
  "chain": "AVAX",
  "chainId": 43114,
  "explorers": [{
    "name": "snowtrace",
    "url": "https://snowtrace.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/avalanche/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://www.avax.network/",
  "name": "Avalanche C-Chain",
  "nativeCurrency": {
    "name": "Avalanche",
    "symbol": "AVAX",
    "decimals": 18
  },
  "networkId": 43114,
  "redFlags": [],
  "rpc": ["https://43114.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://avalanche-mainnet.infura.io/v3/${INFURA_API_KEY}", "https://api.avax.network/ext/bc/C/rpc", "https://avalanche-c-chain-rpc.publicnode.com", "wss://avalanche-c-chain-rpc.publicnode.com"],
  "shortName": "avax",
  "slip44": 9005,
  "slug": "avalanche",
  "testnet": false
};

var c43125 = {
  "chain": "Avalanche",
  "chainId": 43125,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser3950 Testnet",
  "nativeCurrency": {
    "name": "QaUser3950 Testnet Token",
    "symbol": "SZL",
    "decimals": 18
  },
  "networkId": 43125,
  "redFlags": [],
  "rpc": ["https://43125.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser3950 Testnet",
  "slug": "qauser3950-testnet",
  "testnet": true
};

var c43288 = {
  "chain": "Boba Avax",
  "chainId": 43288,
  "explorers": [{
    "name": "Boba Avax Explorer",
    "url": "https://blockexplorer.avax.boba.network",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://docs.boba.network/for-developers/network-avalanche",
  "name": "Boba Avax",
  "nativeCurrency": {
    "name": "Boba Token",
    "symbol": "BOBA",
    "decimals": 18
  },
  "networkId": 43288,
  "rpc": ["https://43288.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://avax.boba.network", "wss://wss.avax.boba.network", "https://replica.avax.boba.network", "wss://replica-wss.avax.boba.network"],
  "shortName": "bobaavax",
  "slug": "boba-avax",
  "testnet": false
};

var c43851 = {
  "chain": "ETH",
  "chainId": 43851,
  "explorers": [{
    "name": "ZKFair Testnet Info",
    "url": "https://testnet-scan.zkfair.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmVb682D4mUXkKNP28xxJDNgSYbDLvEc3kVYx7TQxEa6Cw",
      "width": 400,
      "height": 400,
      "format": "jpg"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmVb682D4mUXkKNP28xxJDNgSYbDLvEc3kVYx7TQxEa6Cw",
    "width": 400,
    "height": 400,
    "format": "jpg"
  },
  "infoURL": "https://zkfair.io",
  "name": "ZKFair Testnet",
  "nativeCurrency": {
    "name": "USDC Token",
    "symbol": "USDC",
    "decimals": 18
  },
  "networkId": 43851,
  "rpc": ["https://43851.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.zkfair.io"],
  "shortName": "ZKFair-Testnet",
  "slip44": 1,
  "slug": "zkfair-testnet",
  "testnet": true
};

var c44444 = {
  "chain": "fren",
  "chainId": 44444,
  "explorers": [{
    "name": "blockscout",
    "url": "https://frenscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmQk41bYX6WpYyUAdRgomZekxP5mbvZXhfxLEEqtatyJv4",
      "width": 128,
      "height": 128,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQk41bYX6WpYyUAdRgomZekxP5mbvZXhfxLEEqtatyJv4",
    "width": 128,
    "height": 128,
    "format": "png"
  },
  "infoURL": "https://frenchain.app",
  "name": "Frenchain",
  "nativeCurrency": {
    "name": "FREN",
    "symbol": "FREN",
    "decimals": 18
  },
  "networkId": 44444,
  "rpc": ["https://44444.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-02.frenscan.io"],
  "shortName": "FREN",
  "slug": "frenchain",
  "testnet": false
};

var c44445 = {
  "chain": "Quantum",
  "chainId": 44445,
  "explorers": [{
    "name": "Quantum Explorer",
    "url": "https://qtm.avescoin.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmeKQVv2QneHaaggw2NfpZ7DGMdjVhPywTdse5RzCs4oGn",
      "width": 232,
      "height": 232,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeKQVv2QneHaaggw2NfpZ7DGMdjVhPywTdse5RzCs4oGn",
    "width": 232,
    "height": 232,
    "format": "png"
  },
  "infoURL": "https://avescoin.io/",
  "name": "Quantum Network",
  "nativeCurrency": {
    "name": "Quantum",
    "symbol": "QTM",
    "decimals": 18
  },
  "networkId": 44445,
  "rpc": ["https://44445.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpcqtm.avescoin.io"],
  "shortName": "QTM",
  "slug": "quantum-network",
  "testnet": false
};

var c44787 = {
  "chain": "CELO",
  "chainId": 44787,
  "explorers": [{
    "name": "Alfajoresscan",
    "url": "https://alfajores.celoscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://celo.org/developers/faucet", "https://cauldron.pretoriaresearchlab.io/alfajores-faucet"],
  "features": [],
  "infoURL": "https://docs.celo.org/",
  "name": "Celo Alfajores Testnet",
  "nativeCurrency": {
    "name": "CELO",
    "symbol": "CELO",
    "decimals": 18
  },
  "networkId": 44787,
  "redFlags": [],
  "rpc": ["https://44787.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://alfajores-forno.celo-testnet.org", "wss://alfajores-forno.celo-testnet.org/ws"],
  "shortName": "ALFA",
  "slip44": 1,
  "slug": "celo-alfajores-testnet",
  "testnet": true
};

var c44808 = {
  "chain": "Avalanche",
  "chainId": 44808,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "klCohan Testnet",
  "nativeCurrency": {
    "name": "klCohan Testnet Token",
    "symbol": "DBM",
    "decimals": 18
  },
  "networkId": 44808,
  "redFlags": [],
  "rpc": ["https://44808.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/d2b6bd35-89f7-4019-bc88-643c31221e5c"],
  "shortName": "klCohan Testnet",
  "slug": "klcohan-testnet",
  "testnet": true
};

var c44850 = {
  "chain": "Avalanche",
  "chainId": 44850,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0318I1 Testnet",
  "nativeCurrency": {
    "name": "QI0318I1 Testnet Token",
    "symbol": "WJN",
    "decimals": 18
  },
  "networkId": 44850,
  "redFlags": [],
  "rpc": ["https://44850.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0318I1 Testnet",
  "slug": "qi0318i1-testnet",
  "testnet": true
};

var c45000 = {
  "chain": "TXL",
  "chainId": 45000,
  "explorers": [{
    "name": "autobahn explorer",
    "url": "https://explorer.autobahn.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmZP19pbqTco4vaP9siduLWP8pdYArFK3onfR55tvjr12s",
      "width": 489,
      "height": 489,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmZP19pbqTco4vaP9siduLWP8pdYArFK3onfR55tvjr12s",
    "width": 489,
    "height": 489,
    "format": "png"
  },
  "infoURL": "https://autobahn.network",
  "name": "Autobahn Network",
  "nativeCurrency": {
    "name": "TXL",
    "symbol": "TXL",
    "decimals": 18
  },
  "networkId": 45000,
  "rpc": ["https://45000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.autobahn.network"],
  "shortName": "AutobahnNetwork",
  "slug": "autobahn-network",
  "testnet": false
};

var c45454 = {
  "chain": "SWP",
  "chainId": 45454,
  "explorers": [{
    "name": "blockscout",
    "url": "https://swamps-explorer.tc.l2aas.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmTEEgWsknzdqjLbaAvLHqCCzCtMJZh2d1SqMscxZCXBwA",
    "width": 150,
    "height": 150,
    "format": "png"
  },
  "infoURL": "https://www.swamps.fi",
  "name": "Swamps L2",
  "nativeCurrency": {
    "name": "SWP",
    "symbol": "SWP",
    "decimals": 18
  },
  "networkId": 45454,
  "rpc": ["https://45454.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://swamps.tc.l2aas.com"],
  "shortName": "SWP",
  "slug": "swamps-l2",
  "testnet": false
};

var c45510 = {
  "chain": "DEE",
  "chainId": 45510,
  "explorers": [{
    "name": "Deelance Mainnet Explorer",
    "url": "https://deescan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.deelance.com"],
  "icon": {
    "url": "ipfs://Qmay2j8biuo5xLJL8NcLtrzubAEHuCWz65cdbKE1pSnGf6",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://deelance.com",
  "name": "Deelance Mainnet",
  "nativeCurrency": {
    "name": "Deelance",
    "symbol": "DEE",
    "decimals": 18
  },
  "networkId": 45510,
  "rpc": ["https://45510.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.deelance.com"],
  "shortName": "dee",
  "slug": "deelance",
  "testnet": false,
  "title": "Deelance Network Mainnet"
};

var c45544 = {
  "chain": "Avalanche",
  "chainId": 45544,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser6609 Testnet",
  "nativeCurrency": {
    "name": "QaUser6609 Testnet Token",
    "symbol": "NHU",
    "decimals": 18
  },
  "networkId": 45544,
  "redFlags": [],
  "rpc": ["https://45544.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser6609 Testnet",
  "slug": "qauser6609-testnet",
  "testnet": true
};

var c46092 = {
  "chain": "Avalanche",
  "chainId": 46092,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0213I1",
  "nativeCurrency": {
    "name": "QI0213I1 Token",
    "symbol": "ORR",
    "decimals": 18
  },
  "networkId": 46092,
  "redFlags": [],
  "rpc": ["https://46092.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-test.io/f0aae4b1-a373-43ed-9e61-ba61d42131bb"],
  "shortName": "QI0213I1",
  "slug": "qi0213i1",
  "testnet": true
};

var c46688 = {
  "chain": "FSN",
  "chainId": 46688,
  "explorers": [{
    "name": "fsnscan",
    "url": "https://testnet.fsnscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmSAFx34SKNi7a139agX12f68oBMo2Ktt9c8yD8aFa14gd",
      "width": 48,
      "height": 51,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmX3tsEoj7SdaBLLV8VyyCUAmymdEGiSGeuTbxMrEMVvth",
    "width": 31,
    "height": 31,
    "format": "svg"
  },
  "infoURL": "https://fusion.org",
  "name": "Fusion Testnet",
  "nativeCurrency": {
    "name": "Testnet Fusion",
    "symbol": "T-FSN",
    "decimals": 18
  },
  "networkId": 46688,
  "rpc": ["https://46688.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.fusionnetwork.io", "wss://testnet.fusionnetwork.io"],
  "shortName": "tfsn",
  "slip44": 1,
  "slug": "fusion-testnet",
  "testnet": true
};

var c47805 = {
  "chain": "REI",
  "chainId": 47805,
  "explorers": [{
    "name": "rei-scan",
    "url": "https://scan.rei.network",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://rei.network/",
  "name": "REI Network",
  "nativeCurrency": {
    "name": "REI",
    "symbol": "REI",
    "decimals": 18
  },
  "networkId": 47805,
  "rpc": ["https://47805.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.rei.network", "wss://rpc.rei.network"],
  "shortName": "REI",
  "slug": "rei-network",
  "testnet": false
};

var c48137 = {
  "chain": "Avalanche",
  "chainId": 48137,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser9608 Testnet",
  "nativeCurrency": {
    "name": "QaUser9608 Testnet Token",
    "symbol": "ASI",
    "decimals": 18
  },
  "networkId": 48137,
  "redFlags": [],
  "rpc": ["https://48137.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser9608 Testnet",
  "slug": "qauser9608-testnet",
  "testnet": true
};

var c48267 = {
  "chain": "Avalanche",
  "chainId": 48267,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0130I2",
  "nativeCurrency": {
    "name": "QI0130I2 Token",
    "symbol": "NZY",
    "decimals": 18
  },
  "networkId": 48267,
  "redFlags": [],
  "rpc": ["https://48267.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0130I2",
  "slug": "qi0130i2",
  "testnet": true
};

var c48702 = {
  "chain": "Avalanche",
  "chainId": 48702,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Testnet",
  "nativeCurrency": {
    "name": "Testnet Token",
    "symbol": "LUG",
    "decimals": 18
  },
  "networkId": 48702,
  "redFlags": [],
  "rpc": ["https://48702.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Testnet",
  "slug": "testnet-testnet-48702",
  "testnet": true
};

var c49049 = {
  "chain": "Wireshape",
  "chainId": 49049,
  "explorers": [{
    "name": "Wire Explorer",
    "url": "https://floripa-explorer.wireshape.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmTAyT3YrW2654CBRqRkec2cCznv6EBsbsRc2y6WQPbvXx",
    "width": 1280,
    "height": 1280,
    "format": "png"
  },
  "infoURL": "https://wireshape.org",
  "name": "Wireshape Floripa Testnet",
  "nativeCurrency": {
    "name": "WIRE",
    "symbol": "WIRE",
    "decimals": 18
  },
  "networkId": 49049,
  "rpc": ["https://49049.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-floripa.wireshape.org"],
  "shortName": "floripa",
  "slip44": 1,
  "slug": "wireshape-floripa-testnet",
  "testnet": true,
  "title": "Wireshape Floripa Testnet"
};

var c49053 = {
  "chain": "Avalanche",
  "chainId": 49053,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser5759 Testnet",
  "nativeCurrency": {
    "name": "QaUser5759 Testnet Token",
    "symbol": "ATZ",
    "decimals": 18
  },
  "networkId": 49053,
  "redFlags": [],
  "rpc": ["https://49053.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser5759 Testnet",
  "slug": "qauser5759-testnet",
  "testnet": true
};

var c49088 = {
  "chain": "BFC",
  "chainId": 49088,
  "explorers": [{
    "name": "explorer-thebifrost",
    "url": "https://explorer.testnet.bifrostnetwork.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYxniqbiFD7nXBNjN8boUhoXYEAW23YquArD2Rnkq8WHS",
    "width": 480,
    "height": 480,
    "format": "png"
  },
  "infoURL": "https://bifrostnetwork.com",
  "name": "Bifrost Testnet",
  "nativeCurrency": {
    "name": "Bifrost",
    "symbol": "BFC",
    "decimals": 18
  },
  "networkId": 49088,
  "rpc": ["https://49088.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://public-01.testnet.bifrostnetwork.com/rpc", "https://public-02.testnet.bifrostnetwork.com/rpc"],
  "shortName": "tbfc",
  "slip44": 1,
  "slug": "bifrost-testnet",
  "testnet": true,
  "title": "Bifrost Network Testnet"
};

var c49321 = {
  "chain": "tGUN",
  "chainId": 49321,
  "explorers": [{
    "name": "blockscout",
    "url": "https://testnet.gunzscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://Qmd5R5khFePwY9dYBGhjRA1rGtUAKaHg7Z2B7mBrbA6TiB",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://gunbygunz.com",
  "name": "GUNZ Testnet",
  "nativeCurrency": {
    "name": "GUN",
    "symbol": "GUN",
    "decimals": 18
  },
  "networkId": 49321,
  "rpc": ["https://49321.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.gunz.dev/ext/bc/ryk9vkvNuKtewME2PeCgybo9sdWXGmCkBrrx4VPuZPdVdAak8/rpc"],
  "shortName": "Stork",
  "slug": "gunz-testnet",
  "testnet": true
};

var c49797 = {
  "chain": "NRG",
  "chainId": 49797,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.energi.world/",
  "name": "Energi Testnet",
  "nativeCurrency": {
    "name": "Energi",
    "symbol": "NRG",
    "decimals": 18
  },
  "networkId": 49797,
  "rpc": ["https://49797.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://nodeapi.test.energi.network"],
  "shortName": "tnrg",
  "slip44": 1,
  "slug": "energi-testnet",
  "testnet": true
};

var c50001 = {
  "chain": "Liveplex OracleEVM Network",
  "chainId": 50001,
  "explorers": [],
  "faucets": [],
  "name": "Liveplex OracleEVM",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 50001,
  "rpc": ["https://50001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.oracle.liveplex.io"],
  "shortName": "LOE",
  "slug": "liveplex-oracleevm",
  "testnet": false
};

var c50005 = {
  "chain": "Yooldo Verse",
  "chainId": 50005,
  "explorers": [{
    "name": "Yooldo Verse Explorer",
    "url": "https://explorer.yooldo-verse.xyz",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWvfA2usnYp1ktzLcqFS8eTLgdp4ifrxjiify46KyG9NZ",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://yooldo.gg/",
  "name": "Yooldo Verse Mainnet",
  "nativeCurrency": {
    "name": "OAS",
    "symbol": "OAS",
    "decimals": 18
  },
  "networkId": 50005,
  "parent": {
    "type": "L2",
    "chain": "eip155-248"
  },
  "rpc": ["https://50005.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.yooldo-verse.xyz/"],
  "shortName": "YVM",
  "slug": "yooldo-verse",
  "testnet": false
};

var c50006 = {
  "chain": "Yooldo Verse",
  "chainId": 50006,
  "explorers": [{
    "name": "Yooldo Verse Explorer",
    "url": "https://explorer.testnet.yooldo-verse.xyz",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWvfA2usnYp1ktzLcqFS8eTLgdp4ifrxjiify46KyG9NZ",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://yooldo.gg/",
  "name": "Yooldo Verse Testnet",
  "nativeCurrency": {
    "name": "OAS",
    "symbol": "OAS",
    "decimals": 18
  },
  "networkId": 50006,
  "parent": {
    "type": "L2",
    "chain": "eip155-248"
  },
  "rpc": ["https://50006.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.yooldo-verse.xyz/"],
  "shortName": "YVT",
  "slip44": 1,
  "slug": "yooldo-verse-testnet",
  "testnet": true
};

var c50021 = {
  "chain": "GTON Testnet",
  "chainId": 50021,
  "explorers": [{
    "name": "GTON Testnet Network Explorer",
    "url": "https://explorer.testnet.gton.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://gton.capital",
  "name": "GTON Testnet",
  "nativeCurrency": {
    "name": "GCD",
    "symbol": "GCD",
    "decimals": 18
  },
  "networkId": 50021,
  "parent": {
    "type": "L2",
    "chain": "eip155-3"
  },
  "rpc": ["https://50021.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.gton.network/"],
  "shortName": "tgton",
  "slip44": 1,
  "slug": "gton-testnet",
  "testnet": true
};

var c50059 = {
  "chain": "Avalanche",
  "chainId": 50059,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0122I1 Testnet",
  "nativeCurrency": {
    "name": "QI0122I1 Testnet Token",
    "symbol": "MPX",
    "decimals": 18
  },
  "networkId": 50059,
  "redFlags": [],
  "rpc": ["https://50059.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0122I1 Testnet",
  "slug": "qi0122i1-testnet",
  "testnet": true
};

var c50528 = {
  "chain": "Avalanche",
  "chainId": 50528,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser9606 Testnet",
  "nativeCurrency": {
    "name": "QaUser9606 Testnet Token",
    "symbol": "JTW",
    "decimals": 18
  },
  "networkId": 50528,
  "redFlags": [],
  "rpc": ["https://50528.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser9606 Testnet",
  "slug": "qauser9606-testnet",
  "testnet": true
};

var c51161 = {
  "chain": "Avalanche",
  "chainId": 51161,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI1212I6",
  "nativeCurrency": {
    "name": "QI1212I6 Token",
    "symbol": "HSCX",
    "decimals": 18
  },
  "networkId": 51161,
  "redFlags": [],
  "rpc": ["https://51161.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI1212I6",
  "slug": "qi1212i6",
  "testnet": true
};

var c51178 = {
  "chain": "ETH",
  "chainId": 51178,
  "explorers": [{
    "name": "LumozTestnetInfo",
    "url": "https://lumoz.info",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmZnE2ygPL2ZGuzHGvFCHmrqxwdurrhz3K1yPnwLzKbgay",
      "width": 401,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmZnE2ygPL2ZGuzHGvFCHmrqxwdurrhz3K1yPnwLzKbgay",
    "width": 401,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://lumoz.org",
  "name": "Lumoz Testnet Alpha",
  "nativeCurrency": {
    "name": "Lumoz Test Token",
    "symbol": "MOZ",
    "decimals": 18
  },
  "networkId": 51178,
  "rpc": ["https://51178.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://alpha-us-http-geth.lumoz.org", "https://alpha-hk-http-geth.lumoz.org"],
  "shortName": "Lumoz-Testnet",
  "slip44": 1,
  "slug": "lumoz-testnet-alpha",
  "testnet": true
};

var c51277 = {
  "chain": "Avalanche",
  "chainId": 51277,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0344s1 Testne",
  "nativeCurrency": {
    "name": "QI0344s1 Testne Token",
    "symbol": "LKG",
    "decimals": 18
  },
  "networkId": 51277,
  "redFlags": [],
  "rpc": ["https://51277.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0344s1 Testne",
  "slug": "qi0344s1-testne",
  "testnet": true
};

var c51712 = {
  "chain": "SRDX",
  "chainId": 51712,
  "explorers": [{
    "name": "Sardis",
    "url": "https://contract-mainnet.sardisnetwork.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.sardisnetwork.com"],
  "icon": {
    "url": "ipfs://QmdR9QJjQEh1mBnf2WbJfehverxiP5RDPWMtEECbDP2rc3",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://mysardis.com",
  "name": "Sardis Mainnet",
  "nativeCurrency": {
    "name": "Sardis",
    "symbol": "SRDX",
    "decimals": 18
  },
  "networkId": 51712,
  "rpc": ["https://51712.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.sardisnetwork.com"],
  "shortName": "SRDXm",
  "slug": "sardis",
  "testnet": false
};

var c51740 = {
  "chain": "Avalanche",
  "chainId": 51740,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser4Testnet",
  "nativeCurrency": {
    "name": "QaUser4Testnet Token",
    "symbol": "VGW",
    "decimals": 18
  },
  "networkId": 51740,
  "redFlags": [],
  "rpc": ["https://51740.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser4Testnet",
  "slug": "qauser4testnet",
  "testnet": true
};

var c52014 = {
  "chain": "Electroneum",
  "chainId": 52014,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockexplorer.electroneum.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmVgFqXA3kkCrVYGcWFF7Mhx8JUSe9vSCauNamuKWSvCym",
      "width": 1000,
      "height": 1000,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmVgFqXA3kkCrVYGcWFF7Mhx8JUSe9vSCauNamuKWSvCym",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://electroneum.com",
  "name": "Electroneum Mainnet",
  "nativeCurrency": {
    "name": "Electroneum",
    "symbol": "ETN",
    "decimals": 18
  },
  "networkId": 52014,
  "rpc": ["https://52014.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.electroneum.com"],
  "shortName": "etn-mainnet",
  "slug": "electroneum",
  "testnet": false
};

var c52146 = {
  "chain": "Avalanche",
  "chainId": 52146,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser4359 Testnet",
  "nativeCurrency": {
    "name": "QaUser4359 Testnet Token",
    "symbol": "WBP",
    "decimals": 18
  },
  "networkId": 52146,
  "redFlags": [],
  "rpc": ["https://52146.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser4359 Testnet",
  "slug": "qauser4359-testnet",
  "testnet": true
};

var c52150 = {
  "chain": "Avalanche",
  "chainId": 52150,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0304I1 Testnet",
  "nativeCurrency": {
    "name": "QI0304I1 Testnet Token",
    "symbol": "LOD",
    "decimals": 18
  },
  "networkId": 52150,
  "redFlags": [],
  "rpc": ["https://52150.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0304I1 Testnet",
  "slug": "qi0304i1-testnet",
  "testnet": true
};

var c53123 = {
  "chain": "Avalanche",
  "chainId": 53123,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Metasky",
  "nativeCurrency": {
    "name": "Metasky Token",
    "symbol": "MSK",
    "decimals": 18
  },
  "networkId": 53123,
  "redFlags": [],
  "rpc": ["https://53123.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/metasky/testnet/rpc"],
  "shortName": "Metasky",
  "slug": "metasky",
  "testnet": true
};

var c53277 = {
  "chain": "DOID",
  "chainId": 53277,
  "explorers": [{
    "name": "DOID Scan",
    "url": "https://scan.doid.tech",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmXYSMyMnMvBf2F1ih6dTcRVUhmMnpzvmuP7vieLjmNQo5",
      "width": 41,
      "height": 52,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmXYSMyMnMvBf2F1ih6dTcRVUhmMnpzvmuP7vieLjmNQo5",
    "width": 41,
    "height": 52,
    "format": "svg"
  },
  "infoURL": "https://doid.tech",
  "name": "DOID",
  "nativeCurrency": {
    "name": "DOID",
    "symbol": "DOID",
    "decimals": 18
  },
  "networkId": 53277,
  "rpc": ["https://53277.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.doid.tech"],
  "shortName": "DOID",
  "slug": "doid",
  "testnet": false
};

var c53383 = {
  "chain": "Avalanche",
  "chainId": 53383,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Jambon's Testnet",
  "nativeCurrency": {
    "name": "Jambon's Testnet Token",
    "symbol": "GNF",
    "decimals": 18
  },
  "networkId": 53383,
  "redFlags": [],
  "rpc": ["https://53383.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/c37c3f83-6d95-4473-b5c7-626fad519f50"],
  "shortName": "Jambon's Testnet",
  "slug": "jambon-s-testnet-jambon's testnet-53383",
  "testnet": true
};

var c53935 = {
  "chain": "DFK",
  "chainId": 53935,
  "explorers": [{
    "name": "ethernal",
    "url": "https://explorer.dfkchain.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt",
      "width": 1000,
      "height": 1628,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmQB48m15TzhUFrmu56QCRQjkrkgUaKfgCmKE8o3RzmuPJ",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://defikingdoms.com",
  "name": "DFK Chain",
  "nativeCurrency": {
    "name": "Jewel",
    "symbol": "JEWEL",
    "decimals": 18
  },
  "networkId": 53935,
  "redFlags": [],
  "rpc": ["https://53935.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc", "https://avax-pokt.nodies.app/ext/bc/q2aTwKuyzgs8pynF7UXBZCU7DejbZbZ6EUyHr3JQzYgwNPUPi/rpc"],
  "shortName": "DFK",
  "slug": "dfk-chain",
  "testnet": false
};

var c54211 = {
  "chain": "TestEdge2",
  "chainId": 54211,
  "explorers": [{
    "name": "TestEdge HAQQ Explorer",
    "url": "https://explorer.testedge2.haqq.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://testedge2.haqq.network"],
  "infoURL": "https://islamiccoin.net",
  "name": "Haqq Chain Testnet",
  "nativeCurrency": {
    "name": "Islamic Coin",
    "symbol": "ISLMT",
    "decimals": 18
  },
  "networkId": 54211,
  "rpc": ["https://54211.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.eth.testedge2.haqq.network"],
  "shortName": "ISLMT",
  "slip44": 1,
  "slug": "haqq-chain-testnet",
  "testnet": true
};

var c54321 = {
  "chain": "Toronet",
  "chainId": 54321,
  "ens": {
    "registry": "0x059C474f26D65B0458F9da10A649a7322aB02C09"
  },
  "explorers": [{
    "name": "toronet_explorer",
    "url": "https://testnet.toronet.org",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmciSvgLatP6jhgdazuiyD3fSrhipfAN7wC943v1qxcrpv",
    "width": 846,
    "height": 733,
    "format": "png"
  },
  "infoURL": "https://toronet.org",
  "name": "Toronet Testnet",
  "nativeCurrency": {
    "name": "Toro",
    "symbol": "TORO",
    "decimals": 18
  },
  "networkId": 54321,
  "rpc": ["https://54321.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://testnet.toronet.org/rpc"],
  "shortName": "ToronetTestnet",
  "slip44": 1,
  "slug": "toronet-testnet",
  "testnet": true
};

var c54356 = {
  "chain": "Avalanche",
  "chainId": 54356,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Jambon's Testnet",
  "nativeCurrency": {
    "name": "Jambon's Testnet Token",
    "symbol": "ZEG",
    "decimals": 18
  },
  "networkId": 54356,
  "redFlags": [],
  "rpc": ["https://54356.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/e6f00b45-8486-445d-b3b8-815708aab379"],
  "shortName": "Jambon's Testnet",
  "slug": "jambon-s-testnet-jambon's testnet-54356",
  "testnet": true
};

var c54414 = {
  "chain": "Avalanche",
  "chainId": 54414,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Innovo Markets Testnet",
  "nativeCurrency": {
    "name": "Innovo Markets Testnet Token",
    "symbol": "INN",
    "decimals": 18
  },
  "networkId": 54414,
  "redFlags": [],
  "rpc": ["https://54414.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/innovomark/testnet/rpc"],
  "shortName": "Innovo Markets Testnet",
  "slug": "innovo-markets-testnet",
  "testnet": true
};

var c54763 = {
  "chain": "Avalanche",
  "chainId": 54763,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser3051 Testnet",
  "nativeCurrency": {
    "name": "QaUser3051 Testnet Token",
    "symbol": "DSX",
    "decimals": 18
  },
  "networkId": 54763,
  "redFlags": [],
  "rpc": ["https://54763.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser3051 Testnet",
  "slug": "qauser3051-testnet",
  "testnet": true
};

var c55004 = {
  "chain": "ETH",
  "chainId": 55004,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.titan.tokamak.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://tokamak.network",
  "name": "Titan",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 55004,
  "rpc": ["https://55004.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.titan.tokamak.network", "wss://rpc.titan.tokamak.network"],
  "shortName": "teth",
  "slug": "titan",
  "testnet": false
};

var c55555 = {
  "chain": "REI",
  "chainId": 55555,
  "explorers": [{
    "name": "reiscan",
    "url": "https://reiscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["http://kururu.finance/faucet?chainId=55555"],
  "icon": {
    "url": "ipfs://QmNy5d5knHVjJJS9g4kLsh9i73RTjckpKL6KZvRk6ptbhf",
    "width": 591,
    "height": 591,
    "format": "svg"
  },
  "infoURL": "https://reichain.io",
  "name": "REI Chain Mainnet",
  "nativeCurrency": {
    "name": "Rei",
    "symbol": "REI",
    "decimals": 18
  },
  "networkId": 55555,
  "rpc": ["https://55555.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rei-rpc.moonrhythm.io"],
  "shortName": "reichain",
  "slug": "rei-chain",
  "testnet": false
};

var c55556 = {
  "chain": "REI",
  "chainId": 55556,
  "explorers": [{
    "name": "reiscan",
    "url": "https://testnet.reiscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["http://kururu.finance/faucet?chainId=55556"],
  "icon": {
    "url": "ipfs://QmNy5d5knHVjJJS9g4kLsh9i73RTjckpKL6KZvRk6ptbhf",
    "width": 591,
    "height": 591,
    "format": "svg"
  },
  "infoURL": "https://reichain.io",
  "name": "REI Chain Testnet",
  "nativeCurrency": {
    "name": "tRei",
    "symbol": "tREI",
    "decimals": 18
  },
  "networkId": 55556,
  "rpc": ["https://55556.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rei-testnet-rpc.moonrhythm.io"],
  "shortName": "trei",
  "slip44": 1,
  "slug": "rei-chain-testnet",
  "testnet": true
};

var c56288 = {
  "chain": "Boba BNB Mainnet",
  "chainId": 56288,
  "explorers": [{
    "name": "Boba BNB block explorer",
    "url": "https://blockexplorer.bnb.boba.network",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://boba.network",
  "name": "Boba BNB Mainnet",
  "nativeCurrency": {
    "name": "Boba Token",
    "symbol": "BOBA",
    "decimals": 18
  },
  "networkId": 56288,
  "parent": {
    "type": "L2",
    "chain": "eip155-5",
    "bridges": [{
      "url": "https://gateway.boba.network"
    }]
  },
  "rpc": ["https://56288.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://bnb.boba.network", "https://boba-bnb.gateway.tenderly.co/", "https://gateway.tenderly.co/public/boba-bnb", "https://replica.bnb.boba.network", "wss://boba-bnb.gateway.tenderly.co/", "wss://gateway.tenderly.co/public/boba-bnb"],
  "shortName": "BobaBnb",
  "slug": "boba-bnb",
  "testnet": false
};

var c56400 = {
  "chain": "Avalanche",
  "chainId": 56400,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Testnet Zeroone",
  "nativeCurrency": {
    "name": "Testnet Zeroone Token",
    "symbol": "ZERO",
    "decimals": 18
  },
  "networkId": 56400,
  "redFlags": [],
  "rpc": ["https://56400.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/testnetzer/testnet/rpc"],
  "shortName": "Testnet Zeroone",
  "slug": "testnet-zeroone",
  "testnet": true
};

var c56525 = {
  "chain": "Avalanche",
  "chainId": 56525,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser4 Testnet",
  "nativeCurrency": {
    "name": "QaUser4 Testnet Token",
    "symbol": "TSQ",
    "decimals": 18
  },
  "networkId": 56525,
  "redFlags": [],
  "rpc": ["https://56525.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser4 Testnet",
  "slug": "qauser4-testnet-qauser4 testnet-56525",
  "testnet": true
};

var c56570 = {
  "chain": "Avalanche",
  "chainId": 56570,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser4Testnet",
  "nativeCurrency": {
    "name": "QaUser4Testnet Token",
    "symbol": "GYF",
    "decimals": 18
  },
  "networkId": 56570,
  "redFlags": [],
  "rpc": ["https://56570.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser4Testnet",
  "slug": "qauser4testnet-qauser4testnet",
  "testnet": true
};

var c56789 = {
  "chain": "NOVA chain",
  "chainId": 56789,
  "explorers": [{
    "name": "novascan",
    "url": "https://novascan.velo.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://nova-faucet.velo.org"],
  "icon": {
    "url": "ipfs://QmYqvnW2jwPEKUv8BdaV4sbL8Audcwosat6SPn4GqYtKxc",
    "width": 225,
    "height": 225,
    "format": "png"
  },
  "infoURL": "https://velo.org",
  "name": "VELO Labs Mainnet",
  "nativeCurrency": {
    "name": "Nova",
    "symbol": "NOVA",
    "decimals": 18
  },
  "networkId": 56789,
  "rpc": ["https://56789.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://nova.velo.org"],
  "shortName": "VELO",
  "slug": "velo-labs",
  "testnet": false
};

var c56797 = {
  "chain": "DOID",
  "chainId": 56797,
  "explorers": [{
    "name": "DOID Testnet Scan",
    "url": "https://scan.testnet.doid.tech",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmXYSMyMnMvBf2F1ih6dTcRVUhmMnpzvmuP7vieLjmNQo5",
      "width": 41,
      "height": 52,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmXYSMyMnMvBf2F1ih6dTcRVUhmMnpzvmuP7vieLjmNQo5",
    "width": 41,
    "height": 52,
    "format": "svg"
  },
  "infoURL": "https://doid.tech",
  "name": "DOID Testnet",
  "nativeCurrency": {
    "name": "DOID",
    "symbol": "DOID",
    "decimals": 18
  },
  "networkId": 56797,
  "rpc": ["https://56797.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.doid.tech"],
  "shortName": "doidTestnet",
  "slug": "doid-testnet",
  "testnet": true
};

var c56914 = {
  "chain": "Avalanche",
  "chainId": 56914,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "KK1223",
  "nativeCurrency": {
    "name": "KK1223 Token",
    "symbol": "KLK",
    "decimals": 18
  },
  "networkId": 56914,
  "redFlags": [],
  "rpc": ["https://56914.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/bf540c23-4601-4768-9e26-f2e5f0f89c18"],
  "shortName": "KK1223",
  "slug": "kk1223",
  "testnet": true
};

var c57000 = {
  "chain": "SYS",
  "chainId": 57000,
  "explorers": [{
    "name": "Rollux Testnet Explorer",
    "url": "https://rollux.tanenbaum.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://rollux.id/faucetapp"],
  "infoURL": "https://rollux.com",
  "name": "Rollux Testnet",
  "nativeCurrency": {
    "name": "Testnet Syscoin",
    "symbol": "TSYS",
    "decimals": 18
  },
  "networkId": 57000,
  "rpc": ["https://57000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-tanenbaum.rollux.com", "https://rpc.ankr.com/rollux_testnet/${ANKR_API_KEY}", "wss://rpc-tanenbaum.rollux.com/wss", "https://rollux.rpc.tanenbaum.io", "wss://rollux.rpc.tanenbaum.io/wss"],
  "shortName": "tsys-rollux",
  "slip44": 1,
  "slug": "rollux-testnet",
  "testnet": true
};

var c57021 = {
  "chain": "Avalanche",
  "chainId": 57021,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QIM2403061",
  "nativeCurrency": {
    "name": "QIM2403061 Token",
    "symbol": "VVC",
    "decimals": 18
  },
  "networkId": 57021,
  "redFlags": [],
  "rpc": ["https://57021.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QIM2403061",
  "slug": "qim2403061",
  "testnet": true
};

var c57522 = {
  "chain": "Avalanche",
  "chainId": 57522,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Cohan Test",
  "nativeCurrency": {
    "name": "Cohan Test Token",
    "symbol": "NYU",
    "decimals": 18
  },
  "networkId": 57522,
  "redFlags": [],
  "rpc": ["https://57522.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/fc395ee3-9e2d-45ea-951a-233b4f3e367d"],
  "shortName": "Cohan Test",
  "slug": "cohan-test",
  "testnet": true
};

var c57973 = {
  "chain": "Avalanche",
  "chainId": 57973,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser5524 Testnet",
  "nativeCurrency": {
    "name": "QaUser5524 Testnet Token",
    "symbol": "ADN",
    "decimals": 18
  },
  "networkId": 57973,
  "redFlags": [],
  "rpc": ["https://57973.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser5524 Testnet",
  "slug": "qauser5524-testnet",
  "testnet": true
};

var c58008 = {
  "chain": "ETH",
  "chainId": 58008,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.sepolia.publicgoods.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmUVJ7MLCEAfq3pHVPFLscqRMiyAY5biVgTkeDQCmAhHNS",
    "width": 574,
    "height": 574,
    "format": "svg"
  },
  "infoURL": "https://publicgoods.network/",
  "name": "Sepolia PGN (Public Goods Network)",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 58008,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": [{
      "url": "https://pgn-bridge.vercel.app/bridge"
    }]
  },
  "redFlags": [],
  "rpc": ["https://58008.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sepolia.publicgoods.network"],
  "shortName": "sepPGN",
  "slug": "sepolia-pgn-public-goods-network",
  "testnet": true
};

var c58064 = {
  "chain": "Avalanche",
  "chainId": 58064,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0209I3",
  "nativeCurrency": {
    "name": "QI0209I3 Token",
    "symbol": "BLOX",
    "decimals": 18
  },
  "networkId": 58064,
  "redFlags": [],
  "rpc": ["https://58064.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0209I3",
  "slug": "qi0209i3",
  "testnet": true
};

var c59069 = {
  "chain": "Avalanche",
  "chainId": 59069,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "ST 12-12 V2",
  "nativeCurrency": {
    "name": "ST 12-12 V2 Token",
    "symbol": "GXE",
    "decimals": 18
  },
  "networkId": 59069,
  "redFlags": [],
  "rpc": ["https://59069.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "ST 12-12 V2",
  "slug": "st-12-12-v2",
  "testnet": true
};

var c59140 = {
  "chain": "ETH",
  "chainId": 59140,
  "explorers": [{
    "name": "Etherscan",
    "url": "https://goerli.lineascan.build",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH",
      "width": 97,
      "height": 102,
      "format": "svg"
    }
  }, {
    "name": "Blockscout",
    "url": "https://explorer.goerli.linea.build",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH",
      "width": 97,
      "height": 102,
      "format": "svg"
    }
  }],
  "faucets": ["https://faucetlink.to/goerli"],
  "icon": {
    "url": "ipfs://QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH",
    "width": 97,
    "height": 102,
    "format": "svg"
  },
  "infoURL": "https://linea.build",
  "name": "Linea Testnet",
  "nativeCurrency": {
    "name": "Linea Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 59140,
  "parent": {
    "type": "L2",
    "chain": "eip155-5",
    "bridges": [{
      "url": "https://goerli.hop.exchange/#/send?token=ETH&sourceNetwork=ethereum&destNetwork=linea"
    }]
  },
  "rpc": ["https://59140.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.goerli.linea.build", "wss://rpc.goerli.linea.build", "https://linea-goerli.infura.io/v3/${INFURA_API_KEY}", "wss://linea-goerli.infura.io/ws/v3/${INFURA_API_KEY}"],
  "shortName": "linea-testnet",
  "slip44": 1,
  "slug": "linea-testnet",
  "status": "active",
  "testnet": true,
  "title": "Linea Goerli Testnet"
};

var c59141 = {
  "chain": "ETH",
  "chainId": 59141,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.sepolia.linea.build/",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH",
      "width": 30,
      "height": 30,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH",
    "width": 30,
    "height": 30,
    "format": "svg"
  },
  "infoURL": "https://linea.build",
  "name": "Linea Sepolia",
  "nativeCurrency": {
    "name": "Linea Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 59141,
  "parent": {
    "type": "L2",
    "chain": "eip155-5",
    "bridges": []
  },
  "redFlags": [],
  "rpc": ["https://59141.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.sepolia.linea.build"],
  "shortName": "linea-sepolia",
  "slug": "linea-sepolia",
  "testnet": true,
  "title": "Linea Sepolia Testnet"
};

var c59144 = {
  "chain": "ETH",
  "chainId": 59144,
  "explorers": [{
    "name": "lineascan",
    "url": "https://lineascan.build",
    "standard": "EIP3091"
  }, {
    "name": "Blockscout",
    "url": "https://explorer.linea.build",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH",
      "width": 97,
      "height": 102,
      "format": "svg"
    }
  }, {
    "name": "L2scan",
    "url": "https://linea.l2scan.co",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH",
      "width": 97,
      "height": 102,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH",
    "width": 97,
    "height": 102,
    "format": "svg"
  },
  "infoURL": "https://linea.build",
  "name": "Linea",
  "nativeCurrency": {
    "name": "Linea Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 59144,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://bridge.linea.build"
    }]
  },
  "redFlags": [],
  "rpc": ["https://59144.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://linea-mainnet.infura.io/v3/${INFURA_API_KEY}", "wss://linea-mainnet.infura.io/ws/v3/${INFURA_API_KEY}", "https://rpc.linea.build", "wss://rpc.linea.build"],
  "shortName": "linea",
  "slug": "linea",
  "status": "active",
  "testnet": false,
  "title": "Linea Mainnet"
};

var c59185 = {
  "chain": "BEYOND",
  "chainId": 59185,
  "explorers": [{
    "name": "Beyond",
    "url": "https://explorerl2new-beyond-indigo-playground-xz87sjgmaj.t.conduit.xyz",
    "standard": "standard",
    "icon": {
      "url": "ipfs://QmbLxRVZ27Yy6RE9xAdYgSxGPB1TjPtcxahy6uNnp2Pt6T/Beyond.jpg",
      "width": 512,
      "height": 512,
      "format": "jpg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmbLxRVZ27Yy6RE9xAdYgSxGPB1TjPtcxahy6uNnp2Pt6T/Beyond.jpg",
    "width": 512,
    "height": 512,
    "format": "jpg"
  },
  "infoURL": "https://explorerl2new-beyond-indigo-playground-xz87sjgmaj.t.conduit.xyz",
  "name": "BeyondChain Testnet",
  "nativeCurrency": {
    "name": "BEYOND",
    "symbol": "BEYOND",
    "decimals": 18
  },
  "networkId": 59185,
  "redFlags": [],
  "rpc": ["https://59185.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-beyond-indigo-playground-xz87sjgmaj.t.conduit.xyz"],
  "shortName": "beyond-indigo-playground-xz87sjgmaj",
  "slug": "beyondchain-testnet",
  "testnet": true
};

var c59944 = {
  "chain": "Avalanche",
  "chainId": 59944,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser7920 Testnet",
  "nativeCurrency": {
    "name": "QaUser7920 Testnet Token",
    "symbol": "USH",
    "decimals": 18
  },
  "networkId": 59944,
  "redFlags": [],
  "rpc": ["https://59944.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser7920 Testnet",
  "slug": "qauser7920-testnet",
  "testnet": true
};

var c59971 = {
  "chain": "GCODE",
  "chainId": 59971,
  "explorers": [{
    "name": "Genesys Scan",
    "url": "https://genesysscan.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreihgmpaceze7rxpajv7yrlx3cb6daqubippkpvgryzairtaubsjjoe",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreihgmpaceze7rxpajv7yrlx3cb6daqubippkpvgryzairtaubsjjoe",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://genesyscode.io",
  "name": "Genesys Code Mainnet",
  "nativeCurrency": {
    "name": "GenesysCode",
    "symbol": "GCODE",
    "decimals": 18
  },
  "networkId": 59971,
  "rpc": ["https://59971.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.genesyscode.io/"],
  "shortName": "gcode",
  "slug": "genesys-code",
  "testnet": false
};

var c60000 = {
  "chain": "Thinkium",
  "chainId": 60000,
  "explorers": [{
    "name": "thinkiumscan",
    "url": "https://test0.thinkiumscan.net",
    "standard": "EIP3091"
  }],
  "faucets": ["https://www.thinkiumdev.net/faucet"],
  "infoURL": "https://thinkium.net/",
  "name": "Thinkium Testnet Chain 0",
  "nativeCurrency": {
    "name": "TKM",
    "symbol": "TKM",
    "decimals": 18
  },
  "networkId": 60000,
  "rpc": ["https://60000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://test.thinkiumrpc.net/"],
  "shortName": "TKM-test0",
  "slip44": 1,
  "slug": "thinkium-testnet-chain-0",
  "testnet": true
};

var c60001 = {
  "chain": "Thinkium",
  "chainId": 60001,
  "explorers": [{
    "name": "thinkiumscan",
    "url": "https://test1.thinkiumscan.net",
    "standard": "EIP3091"
  }],
  "faucets": ["https://www.thinkiumdev.net/faucet"],
  "infoURL": "https://thinkium.net/",
  "name": "Thinkium Testnet Chain 1",
  "nativeCurrency": {
    "name": "TKM",
    "symbol": "TKM",
    "decimals": 18
  },
  "networkId": 60001,
  "rpc": ["https://60001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://test1.thinkiumrpc.net/"],
  "shortName": "TKM-test1",
  "slip44": 1,
  "slug": "thinkium-testnet-chain-1",
  "testnet": true
};

var c60002 = {
  "chain": "Thinkium",
  "chainId": 60002,
  "explorers": [{
    "name": "thinkiumscan",
    "url": "https://test2.thinkiumscan.net",
    "standard": "EIP3091"
  }],
  "faucets": ["https://www.thinkiumdev.net/faucet"],
  "infoURL": "https://thinkium.net/",
  "name": "Thinkium Testnet Chain 2",
  "nativeCurrency": {
    "name": "TKM",
    "symbol": "TKM",
    "decimals": 18
  },
  "networkId": 60002,
  "rpc": ["https://60002.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://test2.thinkiumrpc.net/"],
  "shortName": "TKM-test2",
  "slip44": 1,
  "slug": "thinkium-testnet-chain-2",
  "testnet": true
};

var c60103 = {
  "chain": "Thinkium",
  "chainId": 60103,
  "explorers": [{
    "name": "thinkiumscan",
    "url": "https://test103.thinkiumscan.net",
    "standard": "EIP3091"
  }],
  "faucets": ["https://www.thinkiumdev.net/faucet"],
  "infoURL": "https://thinkium.net/",
  "name": "Thinkium Testnet Chain 103",
  "nativeCurrency": {
    "name": "TKM",
    "symbol": "TKM",
    "decimals": 18
  },
  "networkId": 60103,
  "rpc": ["https://60103.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://test103.thinkiumrpc.net/"],
  "shortName": "TKM-test103",
  "slip44": 1,
  "slug": "thinkium-testnet-chain-103",
  "testnet": true
};

var c60834 = {
  "chain": "Avalanche",
  "chainId": 60834,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2402059",
  "nativeCurrency": {
    "name": "QI M 2402059 Token",
    "symbol": "ACI",
    "decimals": 18
  },
  "networkId": 60834,
  "redFlags": [],
  "rpc": ["https://60834.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/c908add6-74c5-4407-8091-18762786a0b9"],
  "shortName": "QI M 2402059",
  "slug": "qi-m-2402059",
  "testnet": true
};

var c60841 = {
  "chain": "Avalanche",
  "chainId": 60841,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "SCG-K",
  "nativeCurrency": {
    "name": "SCG-K Token",
    "symbol": "REC",
    "decimals": 18
  },
  "networkId": 60841,
  "redFlags": [],
  "rpc": ["https://60841.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/scgk/testnet/rpc"],
  "shortName": "SCG-K",
  "slug": "scg-k",
  "testnet": true
};

var c61205 = {
  "chain": "Avalanche",
  "chainId": 61205,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser6116 Testnet",
  "nativeCurrency": {
    "name": "QaUser6116 Testnet Token",
    "symbol": "YLJ",
    "decimals": 18
  },
  "networkId": 61205,
  "redFlags": [],
  "rpc": ["https://61205.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser6116 Testnet",
  "slug": "qauser6116-testnet",
  "testnet": true
};

var c61258 = {
  "chain": "Avalanche",
  "chainId": 61258,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser7821 Testnet",
  "nativeCurrency": {
    "name": "QaUser7821 Testnet Token",
    "symbol": "WND",
    "decimals": 18
  },
  "networkId": 61258,
  "redFlags": [],
  "rpc": ["https://61258.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser7821 Testnet",
  "slug": "qauser7821-testnet",
  "testnet": true
};

var c61406 = {
  "chain": "KEC",
  "chainId": 61406,
  "explorers": [{
    "name": "KEC SCAN",
    "url": "https://explorer.kaichain.net/",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmbfRP2Ugo66pw6Mn8m9ChP4UE6Rn5nobtDo7Vy7ej93qA/kaichain%20icon.png",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmbfRP2Ugo66pw6Mn8m9ChP4UE6Rn5nobtDo7Vy7ej93qA/kaichain%20icon.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "http://kaichain.net/",
  "name": "Kaichain Mainnet",
  "nativeCurrency": {
    "name": "Kaichain",
    "symbol": "KEC",
    "decimals": 18
  },
  "networkId": 61406,
  "redFlags": [],
  "rpc": ["https://61406.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.kaichain.net"],
  "shortName": "Kaichain",
  "slug": "kaichain",
  "testnet": false
};

var c61514 = {
  "chain": "Avalanche",
  "chainId": 61514,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI011624I1",
  "nativeCurrency": {
    "name": "QI011624I1 Token",
    "symbol": "DGQ",
    "decimals": 18
  },
  "networkId": 61514,
  "redFlags": [],
  "rpc": ["https://61514.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/e81adde6-3c1b-46ce-8dfe-e7a689f8c7eb"],
  "shortName": "QI011624I1",
  "slug": "qi011624i1",
  "testnet": true
};

var c61551 = {
  "chain": "Avalanche",
  "chainId": 61551,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0304T1TS Testnet",
  "nativeCurrency": {
    "name": "QR0304T1TS Testnet Token",
    "symbol": "OYU",
    "decimals": 18
  },
  "networkId": 61551,
  "redFlags": [],
  "rpc": ["https://61551.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0304t1ts/testnet/rpc"],
  "shortName": "QR0304T1TS Testnet",
  "slug": "qr0304t1ts-testnet",
  "testnet": true
};

var c61800 = {
  "chain": "AXEL",
  "chainId": 61800,
  "explorers": [{
    "name": "AxelChain Dev-Net Explorer",
    "url": "https://devexplorer2.viacube.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNx8FRacfNeawhkjk5p57EKzDHkLGMaBBmK2VRL5CB2P2",
    "width": 40,
    "height": 40,
    "format": "svg"
  },
  "infoURL": "https://www.axel.org",
  "name": "AxelChain Dev-Net",
  "nativeCurrency": {
    "name": "Axelium",
    "symbol": "AIUM",
    "decimals": 18
  },
  "networkId": 61800,
  "rpc": ["https://61800.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://aium-rpc-dev.viacube.com"],
  "shortName": "aium-dev",
  "slug": "axelchain-dev-net",
  "testnet": false
};

var c61803 = {
  "chain": "Etica Protocol (ETI/EGAZ)",
  "chainId": 61803,
  "explorers": [{
    "name": "eticascan",
    "url": "https://eticascan.org",
    "standard": "EIP3091"
  }, {
    "name": "eticastats",
    "url": "http://explorer.etica-stats.org",
    "standard": "EIP3091"
  }],
  "faucets": ["http://faucet.etica-stats.org/"],
  "icon": {
    "url": "ipfs://QmYSyhUqm6ArWyALBe3G64823ZpEUmFdkzKZ93hUUhNKgU",
    "width": 360,
    "height": 361,
    "format": "png"
  },
  "infoURL": "https://eticaprotocol.org",
  "name": "Etica Mainnet",
  "nativeCurrency": {
    "name": "EGAZ",
    "symbol": "EGAZ",
    "decimals": 18
  },
  "networkId": 61803,
  "rpc": ["https://61803.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eticamainnet.eticascan.org", "https://eticamainnet.eticaprotocol.org"],
  "shortName": "Etica",
  "slug": "etica",
  "testnet": false
};

var c61916 = {
  "chain": "DoKEN Super Chain",
  "chainId": 61916,
  "explorers": [{
    "name": "DSC Scan",
    "url": "https://explore.doken.dev",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreifms4eio6v56oyeemnnu5luq3sc44hptan225lr45itgzu3u372iu",
      "width": 200,
      "height": 200,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreifms4eio6v56oyeemnnu5luq3sc44hptan225lr45itgzu3u372iu",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://doken.dev/",
  "name": "DoKEN Super Chain Mainnet",
  "nativeCurrency": {
    "name": "DoKEN",
    "symbol": "DKN",
    "decimals": 18
  },
  "networkId": 61916,
  "rpc": ["https://61916.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sgrpc.doken.dev", "https://nyrpc.doken.dev", "https://ukrpc.doken.dev"],
  "shortName": "DoKEN",
  "slug": "doken-super-chain",
  "testnet": false
};

var c62049 = {
  "chain": "ETH",
  "chainId": 62049,
  "explorers": [{
    "name": "optopia-testnet-scan",
    "url": "https://scan-testnet.optopia.ai",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreid3xv3zkuo2cygwt7vwm5c2aqjbyhy5qxn7xkc66ajhu2mjh2ybki",
      "width": 1000,
      "height": 1000,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreid3xv3zkuo2cygwt7vwm5c2aqjbyhy5qxn7xkc66ajhu2mjh2ybki",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://optopia.ai",
  "name": "OPTOPIA Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 62049,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": [{
      "url": "https://bridge-testnet.optopia.ai"
    }]
  },
  "rpc": ["https://62049.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.optopia.ai"],
  "shortName": "OPTOPIA-Testnet",
  "slug": "optopia-testnet",
  "testnet": true
};

var c62278 = {
  "chain": "Avalanche",
  "chainId": 62278,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "qi1121i1",
  "nativeCurrency": {
    "name": "qi1121i1 Token",
    "symbol": "SJOX",
    "decimals": 18
  },
  "networkId": 62278,
  "redFlags": [],
  "rpc": ["https://62278.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "qi1121i1",
  "slug": "qi1121i1",
  "testnet": true
};

var c62320 = {
  "chain": "CELO",
  "chainId": 62320,
  "explorers": [],
  "faucets": ["https://docs.google.com/forms/d/e/1FAIpQLSdfr1BwUTYepVmmvfVUDRCwALejZ-TUva2YujNpvrEmPAX2pg/viewform", "https://cauldron.pretoriaresearchlab.io/baklava-faucet"],
  "infoURL": "https://docs.celo.org/",
  "name": "Celo Baklava Testnet",
  "nativeCurrency": {
    "name": "CELO",
    "symbol": "CELO",
    "decimals": 18
  },
  "networkId": 62320,
  "rpc": ["https://62320.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://baklava-forno.celo-testnet.org"],
  "shortName": "BKLV",
  "slip44": 1,
  "slug": "celo-baklava-testnet",
  "testnet": true
};

var c62621 = {
  "chain": "MultiVAC",
  "chainId": 62621,
  "explorers": [{
    "name": "MultiVAC Explorer",
    "url": "https://e.mtv.ac",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWb1gthhbzkiLdgcP8ccZprGbJVjFcW8Rn4uJjrw4jd3B",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://mtv.ac",
  "name": "MultiVAC Mainnet",
  "nativeCurrency": {
    "name": "MultiVAC",
    "symbol": "MTV",
    "decimals": 18
  },
  "networkId": 62621,
  "rpc": ["https://62621.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.mtv.ac", "https://rpc-eu.mtv.ac"],
  "shortName": "mtv",
  "slug": "multivac",
  "testnet": false
};

var c63000 = {
  "chain": "ECS",
  "chainId": 63000,
  "explorers": [{
    "name": "eCredits MainNet Explorer",
    "url": "https://explorer.ecredits.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmU9H9JE1KtLh2Fxrd8EWTMjKGJBpgRWKUeEx7u6ic4kBY",
      "width": 32,
      "height": 32,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmU9H9JE1KtLh2Fxrd8EWTMjKGJBpgRWKUeEx7u6ic4kBY",
    "width": 32,
    "height": 32,
    "format": "png"
  },
  "infoURL": "https://ecredits.com",
  "name": "eCredits Mainnet",
  "nativeCurrency": {
    "name": "eCredits",
    "symbol": "ECS",
    "decimals": 18
  },
  "networkId": 63000,
  "rpc": ["https://63000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.ecredits.com"],
  "shortName": "ecs",
  "slug": "ecredits",
  "testnet": false
};

var c63001 = {
  "chain": "ECS",
  "chainId": 63001,
  "explorers": [{
    "name": "eCredits TestNet Explorer",
    "url": "https://explorer.tst.ecredits.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmU9H9JE1KtLh2Fxrd8EWTMjKGJBpgRWKUeEx7u6ic4kBY",
      "width": 32,
      "height": 32,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.tst.ecredits.com"],
  "icon": {
    "url": "ipfs://QmU9H9JE1KtLh2Fxrd8EWTMjKGJBpgRWKUeEx7u6ic4kBY",
    "width": 32,
    "height": 32,
    "format": "png"
  },
  "infoURL": "https://ecredits.com",
  "name": "eCredits Testnet",
  "nativeCurrency": {
    "name": "eCredits",
    "symbol": "ECS",
    "decimals": 18
  },
  "networkId": 63001,
  "rpc": ["https://63001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.tst.ecredits.com"],
  "shortName": "ecs-testnet",
  "slip44": 1,
  "slug": "ecredits-testnet",
  "testnet": true
};

var c63079 = {
  "chain": "Avalanche",
  "chainId": 63079,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "MT 1121-2",
  "nativeCurrency": {
    "name": "MT 1121-2 Token",
    "symbol": "RCE",
    "decimals": 18
  },
  "networkId": 63079,
  "redFlags": [],
  "rpc": ["https://63079.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-test.io/d76ea66a-e423-49f6-8ef1-4355260b47f1"],
  "shortName": "MT 1121-2",
  "slug": "mt-1121-2",
  "testnet": true
};

var c63367 = {
  "chain": "Avalanche",
  "chainId": 63367,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "ReSFT 1-16-24",
  "nativeCurrency": {
    "name": "ReSFT 1-16-24 Token",
    "symbol": "ZAF",
    "decimals": 18
  },
  "networkId": 63367,
  "redFlags": [],
  "rpc": ["https://63367.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "ReSFT 1-16-24",
  "slug": "resft-1-16-24",
  "testnet": true
};

var c63891 = {
  "chain": "Avalanche",
  "chainId": 63891,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Tnetv2",
  "nativeCurrency": {
    "name": "Tnetv2 Token",
    "symbol": "LFC",
    "decimals": 18
  },
  "networkId": 63891,
  "redFlags": [],
  "rpc": ["https://63891.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Tnetv2",
  "slug": "tnetv2",
  "testnet": true
};

var c64165 = {
  "chain": "FTM",
  "chainId": 64165,
  "ens": {
    "registry": "standard"
  },
  "explorers": [{
    "name": "Fantom Sonic Builders Testnet",
    "url": "https://sonicscan.io/",
    "standard": "standard",
    "icon": {
      "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/fantom/512.png",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": ["https://public-sonic.fantom.network/account"],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/fantom/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://sonicscan.io/",
  "name": "Fantom Sonic Builders Testnet",
  "nativeCurrency": {
    "name": "Fantom",
    "symbol": "FTM",
    "decimals": 18
  },
  "networkId": 64165,
  "redFlags": [],
  "rpc": ["https://64165.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.sonic.fantom.network/"],
  "shortName": "FantomTestnet",
  "slug": "fantom-sonic-builders-testnet",
  "testnet": true
};

var c64273 = {
  "chain": "Avalanche",
  "chainId": 64273,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "REALLY",
  "nativeCurrency": {
    "name": "REALLY Token",
    "symbol": "FAN",
    "decimals": 18
  },
  "networkId": 64273,
  "redFlags": [],
  "rpc": ["https://64273.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/really/mainnet/rpc"],
  "shortName": "REALLY",
  "slug": "really-really",
  "testnet": false
};

var c64361 = {
  "chain": "Avalanche",
  "chainId": 64361,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser8734 Testnet",
  "nativeCurrency": {
    "name": "QaUser8734 Testnet Token",
    "symbol": "XPI",
    "decimals": 18
  },
  "networkId": 64361,
  "redFlags": [],
  "rpc": ["https://64361.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser8734 Testnet",
  "slug": "qauser8734-testnet",
  "testnet": true
};

var c65044 = {
  "chain": "Avalanche",
  "chainId": 65044,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "EXR0314 Testnet",
  "nativeCurrency": {
    "name": "EXR0314 Testnet Token",
    "symbol": "BPR",
    "decimals": 18
  },
  "networkId": 65044,
  "redFlags": [],
  "rpc": ["https://65044.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "EXR0314 Testnet",
  "slug": "exr0314-testnet",
  "testnet": true
};

var c65300 = {
  "chain": "Avalanche",
  "chainId": 65300,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser46 Testnet",
  "nativeCurrency": {
    "name": "QaUser46 Testnet Token",
    "symbol": "ZAG",
    "decimals": 18
  },
  "networkId": 65300,
  "redFlags": [],
  "rpc": ["https://65300.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser46 Testnet",
  "slug": "qauser46-testnet",
  "testnet": true
};

var c65450 = {
  "chain": "SCOLWEI",
  "chainId": 65450,
  "explorers": [{
    "name": "Scolscan Explorer",
    "url": "https://explorer.scolcoin.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVES1eqDXhP8SdeCpM85wvjmhrQDXGRquQebDrSdvJqpt",
    "width": 792,
    "height": 822,
    "format": "png"
  },
  "infoURL": "https://scolcoin.com",
  "name": "Scolcoin Mainnet",
  "nativeCurrency": {
    "name": "Scolcoin",
    "symbol": "SCOL",
    "decimals": 18
  },
  "networkId": 65450,
  "rpc": ["https://65450.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.scolcoin.com"],
  "shortName": "SRC",
  "slug": "scolcoin",
  "testnet": false
};

var c65842 = {
  "chain": "Avalanche",
  "chainId": 65842,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser4143 Testnet",
  "nativeCurrency": {
    "name": "QaUser4143 Testnet Token",
    "symbol": "NHU",
    "decimals": 18
  },
  "networkId": 65842,
  "redFlags": [],
  "rpc": ["https://65842.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser4143 Testnet",
  "slug": "qauser4143-testnet",
  "testnet": true
};

var c66042 = {
  "chain": "Avalanche",
  "chainId": 66042,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0408I1 Testnet",
  "nativeCurrency": {
    "name": "QI0408I1 Testnet Token",
    "symbol": "YXE",
    "decimals": 18
  },
  "networkId": 66042,
  "redFlags": [],
  "rpc": ["https://66042.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0408I1 Testnet",
  "slug": "qi0408i1-testnet",
  "testnet": true
};

var c66063 = {
  "chain": "Avalanche",
  "chainId": 66063,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser3324 Testnet",
  "nativeCurrency": {
    "name": "QaUser3324 Testnet Token",
    "symbol": "IYM",
    "decimals": 18
  },
  "networkId": 66063,
  "redFlags": [],
  "rpc": ["https://66063.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser3324 Testnet",
  "slug": "qauser3324-testnet",
  "testnet": true
};

var c66904 = {
  "chain": "Avalanche",
  "chainId": 66904,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser1335 Testnet",
  "nativeCurrency": {
    "name": "QaUser1335 Testnet Token",
    "symbol": "KFZ",
    "decimals": 18
  },
  "networkId": 66904,
  "redFlags": [],
  "rpc": ["https://66904.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser1335 Testnet",
  "slug": "qauser1335-testnet",
  "testnet": true
};

var c66988 = {
  "chain": "JanusNetwork",
  "chainId": 66988,
  "explorers": [{
    "name": "JanusNetwork Testnet Explorer",
    "url": "https://beta.scan.janusnetwork.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreifc3vnwf4hj3bo6fg4u5qlqmjgajjgezyeg236qjcihl4ha42siuq",
    "width": 819,
    "height": 792,
    "format": "png"
  },
  "infoURL": "https://janus-network.gitbook.io/janus",
  "name": "Janus Testnet",
  "nativeCurrency": {
    "name": "Janus",
    "symbol": "JNS",
    "decimals": 18
  },
  "networkId": 66988,
  "rpc": ["https://66988.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.test.janusnetwork.io"],
  "shortName": "janusnetwork-testnet",
  "slip44": 1,
  "slug": "janus-testnet",
  "status": "active",
  "testnet": true
};

var c67390 = {
  "chain": "SIN",
  "chainId": 67390,
  "explorers": [{
    "name": "siriusnetscan",
    "url": "https://siriusnet.tryethernal.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://macaucasinolisboa.xyz",
  "name": "SiriusNet",
  "nativeCurrency": {
    "name": "MCD",
    "symbol": "MCD",
    "decimals": 18
  },
  "networkId": 67390,
  "rpc": ["https://67390.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://u0tnafcv6j:o2T045sxuCNXL878RDQLp5__Zj-es2cvdjtgkl4etn0@u0v7kwtvtg-u0wj114sve-rpc.us0-aws.kaleido.io/"],
  "shortName": "mcl",
  "slug": "siriusnet",
  "status": "deprecated",
  "testnet": false
};

var c67451 = {
  "chain": "Avalanche",
  "chainId": 67451,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser6097 Testnet",
  "nativeCurrency": {
    "name": "QaUser6097 Testnet Token",
    "symbol": "NHU",
    "decimals": 18
  },
  "networkId": 67451,
  "redFlags": [],
  "rpc": ["https://67451.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser6097 Testnet",
  "slug": "qauser6097-testnet",
  "testnet": true
};

var c67588 = {
  "chain": "COSMIC",
  "chainId": 67588,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://cosmicchain.site",
  "name": "Cosmic Chain",
  "nativeCurrency": {
    "name": "Cosmic Chain",
    "symbol": "COSMIC",
    "decimals": 18
  },
  "networkId": 3344,
  "rpc": ["https://67588.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://testnet.cosmicchain.site:3344"],
  "shortName": "Cosmic",
  "slug": "cosmic-chain",
  "testnet": true
};

var c68007 = {
  "chain": "Avalanche",
  "chainId": 68007,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "infra Testnet",
  "nativeCurrency": {
    "name": "infra Testnet Token",
    "symbol": "ZPO",
    "decimals": 18
  },
  "networkId": 68007,
  "redFlags": [],
  "rpc": ["https://68007.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/infratestn/testnet/rpc"],
  "shortName": "infra Testnet",
  "slug": "infra-testnet",
  "testnet": true
};

var c68295 = {
  "chain": "Avalanche",
  "chainId": 68295,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "qr0116y1s",
  "nativeCurrency": {
    "name": "qr0116y1s Token",
    "symbol": "ANG",
    "decimals": 18
  },
  "networkId": 68295,
  "redFlags": [],
  "rpc": ["https://68295.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0116y1s/testnet/rpc"],
  "shortName": "qr0116y1s",
  "slug": "qr0116y1s",
  "testnet": true
};

var c68770 = {
  "chain": "DM2 Verse",
  "chainId": 68770,
  "explorers": [{
    "name": "DM2Verse Explorer",
    "url": "https://explorer.dm2verse.dmm.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPMqjf5XKZ4Cxa1u8qc8Zj9mmVLBoqK7N5h2zFr3Rsyzw",
    "width": 260,
    "height": 260,
    "format": "png"
  },
  "infoURL": "https://seamoon.dmm.com",
  "name": "DM2 Verse Mainnet",
  "nativeCurrency": {
    "name": "OAS",
    "symbol": "OAS",
    "decimals": 18
  },
  "networkId": 68770,
  "parent": {
    "type": "L2",
    "chain": "eip155-248"
  },
  "rpc": ["https://68770.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.dm2verse.dmm.com"],
  "shortName": "dm2",
  "slug": "dm2-verse",
  "testnet": false
};

var c68976 = {
  "chain": "Avalanche",
  "chainId": 68976,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0408s1 Testnet",
  "nativeCurrency": {
    "name": "QI0408s1 Testnet Token",
    "symbol": "ICV",
    "decimals": 18
  },
  "networkId": 68976,
  "redFlags": [],
  "rpc": ["https://68976.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0408s1 Testnet",
  "slug": "qi0408s1-testnet",
  "testnet": true
};

var c69399 = {
  "chain": "Avalanche",
  "chainId": 69399,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0103I1",
  "nativeCurrency": {
    "name": "QI0103I1 Token",
    "symbol": "AYYX",
    "decimals": 18
  },
  "networkId": 69399,
  "redFlags": [],
  "rpc": ["https://69399.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0103I1",
  "slug": "qi0103i1",
  "testnet": true
};

var c69420 = {
  "chain": "ETH",
  "chainId": 69420,
  "explorers": [{
    "name": "Condrieu explorer",
    "url": "https://explorer.condrieu.ethdevops.io",
    "standard": "none"
  }],
  "faucets": ["https://faucet.condrieu.ethdevops.io"],
  "infoURL": "https://condrieu.ethdevops.io",
  "name": "Condrieu",
  "nativeCurrency": {
    "name": "Condrieu Testnet Ether",
    "symbol": "CTE",
    "decimals": 18
  },
  "networkId": 69420,
  "rpc": ["https://69420.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.condrieu.ethdevops.io:8545"],
  "shortName": "cndr",
  "slip44": 1,
  "slug": "condrieu",
  "testnet": true,
  "title": "Ethereum Verkle Testnet Condrieu"
};

var c69740 = {
  "chain": "Avalanche",
  "chainId": 69740,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Will's Testnet",
  "nativeCurrency": {
    "name": "Will's Testnet Token",
    "symbol": "WLDVNT",
    "decimals": 18
  },
  "networkId": 69740,
  "redFlags": [],
  "rpc": ["https://69740.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Will's Testnet",
  "slug": "will-s-testnet-will's testnet-69740",
  "testnet": true
};

var c69743 = {
  "chain": "Avalanche",
  "chainId": 69743,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "SCG-K",
  "nativeCurrency": {
    "name": "SCG-K Token",
    "symbol": "REC",
    "decimals": 18
  },
  "networkId": 69743,
  "redFlags": [],
  "rpc": ["https://69743.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/scgk/mainnet/rpc"],
  "shortName": "SCG-K",
  "slug": "scg-k-scg-k",
  "testnet": false
};

var c70000 = {
  "chain": "Thinkium",
  "chainId": 70000,
  "explorers": [{
    "name": "thinkiumscan",
    "url": "https://chain0.thinkiumscan.net",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://thinkium.net/",
  "name": "Thinkium Mainnet Chain 0",
  "nativeCurrency": {
    "name": "TKM",
    "symbol": "TKM",
    "decimals": 18
  },
  "networkId": 70000,
  "rpc": ["https://70000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://proxy.thinkiumrpc.net/"],
  "shortName": "TKM0",
  "slug": "thinkium-chain-0",
  "testnet": false
};

var c70001 = {
  "chain": "Thinkium",
  "chainId": 70001,
  "explorers": [{
    "name": "thinkiumscan",
    "url": "https://chain1.thinkiumscan.net",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://thinkium.net/",
  "name": "Thinkium Mainnet Chain 1",
  "nativeCurrency": {
    "name": "TKM",
    "symbol": "TKM",
    "decimals": 18
  },
  "networkId": 70001,
  "rpc": ["https://70001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://proxy1.thinkiumrpc.net/"],
  "shortName": "TKM1",
  "slug": "thinkium-chain-1",
  "testnet": false
};

var c70002 = {
  "chain": "Thinkium",
  "chainId": 70002,
  "explorers": [{
    "name": "thinkiumscan",
    "url": "https://chain2.thinkiumscan.net",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://thinkium.net/",
  "name": "Thinkium Mainnet Chain 2",
  "nativeCurrency": {
    "name": "TKM",
    "symbol": "TKM",
    "decimals": 18
  },
  "networkId": 70002,
  "rpc": ["https://70002.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://proxy2.thinkiumrpc.net/"],
  "shortName": "TKM2",
  "slug": "thinkium-chain-2",
  "testnet": false
};

var c70038 = {
  "chain": "Avalanche",
  "chainId": 70038,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "John's Testnet",
  "nativeCurrency": {
    "name": "John's Testnet Token",
    "symbol": "FLG",
    "decimals": 18
  },
  "networkId": 70038,
  "redFlags": [],
  "rpc": ["https://70038.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "John's Testnet",
  "slug": "john-s-testnet",
  "testnet": true
};

var c70103 = {
  "chain": "Thinkium",
  "chainId": 70103,
  "explorers": [{
    "name": "thinkiumscan",
    "url": "https://chain103.thinkiumscan.net",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://thinkium.net/",
  "name": "Thinkium Mainnet Chain 103",
  "nativeCurrency": {
    "name": "TKM",
    "symbol": "TKM",
    "decimals": 18
  },
  "networkId": 70103,
  "rpc": ["https://70103.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://proxy103.thinkiumrpc.net/"],
  "shortName": "TKM103",
  "slug": "thinkium-chain-103",
  "testnet": false
};

var c70341 = {
  "chain": "Avalanche",
  "chainId": 70341,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser1957 Testnet",
  "nativeCurrency": {
    "name": "QaUser1957 Testnet Token",
    "symbol": "AKI",
    "decimals": 18
  },
  "networkId": 70341,
  "redFlags": [],
  "rpc": ["https://70341.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser1957 Testnet",
  "slug": "qauser1957-testnet",
  "testnet": true
};

var c70466 = {
  "chain": "Avalanche",
  "chainId": 70466,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Cohan test3",
  "nativeCurrency": {
    "name": "Cohan test3 Token",
    "symbol": "HYN",
    "decimals": 18
  },
  "networkId": 70466,
  "redFlags": [],
  "rpc": ["https://70466.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/f44b72ee-0574-44d2-a10b-363a74964145"],
  "shortName": "Cohan test3",
  "slug": "cohan-test3",
  "testnet": true
};

var c70700 = {
  "chain": "ETH",
  "chainId": 70700,
  "explorers": [{
    "name": "Proof of Play Apex Explorer",
    "url": "https://explorer.apex.proofofplay.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmW3NPDe6WRqucrWbe8pg3GqSMPi8V6Qa1fAiaQuqjxSJC",
      "width": 1256,
      "height": 1256,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmW3NPDe6WRqucrWbe8pg3GqSMPi8V6Qa1fAiaQuqjxSJC",
    "width": 1256,
    "height": 1256,
    "format": "png"
  },
  "infoURL": "https://proofofplay.com",
  "name": "Proof of Play - Apex",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 70700,
  "parent": {
    "type": "L2",
    "chain": "eip155-42161",
    "bridges": [{
      "url": "https://bridge.arbitrum.io"
    }, {
      "url": "https://relay.link/bridge/apex/"
    }]
  },
  "rpc": ["https://70700.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.apex.proofofplay.com"],
  "shortName": "pop-apex",
  "slug": "proof-of-play-apex",
  "testnet": false
};

var c71111 = {
  "chain": "GuapcoinX",
  "chainId": 71111,
  "explorers": [{
    "name": "GuapcoinX Explorer",
    "url": "http://explorer.guapcoinx.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmcDTR7982VQKDDz2Mh4fZbnE9hn67MuFPWQv1MimCqPvB",
      "width": 800,
      "height": 800,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmcDTR7982VQKDDz2Mh4fZbnE9hn67MuFPWQv1MimCqPvB",
    "width": 800,
    "height": 800,
    "format": "png"
  },
  "infoURL": "https://guapcoin.org/",
  "name": "GuapcoinX",
  "nativeCurrency": {
    "name": "GuapcoinX",
    "symbol": "GuapX",
    "decimals": 18
  },
  "networkId": 71111,
  "rpc": ["https://71111.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mainnet.guapcoinx.com/", "https://rpc-mainnet-1.guapcoinx.com/", "https://rpc-mainnet-2.guapcoinx.com/"],
  "shortName": "GuapX",
  "slug": "guapcoinx",
  "testnet": false
};

var c71169 = {
  "chain": "Avalanche",
  "chainId": 71169,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser4 Testnet",
  "nativeCurrency": {
    "name": "QaUser4 Testnet Token",
    "symbol": "PJH",
    "decimals": 18
  },
  "networkId": 71169,
  "redFlags": [],
  "rpc": ["https://71169.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser4 Testnet",
  "slug": "qauser4-testnet-qauser4 testnet-71169",
  "testnet": true
};

var c71393 = {
  "chain": "CKB",
  "chainId": 71393,
  "explorers": [],
  "faucets": ["https://faucet.nervos.org/"],
  "icon": {
    "url": "ipfs://QmZ5gFWUxLFqqT3DkefYfRsVksMwMTc5VvBjkbHpeFMsNe",
    "width": 1001,
    "height": 1629,
    "format": "png"
  },
  "infoURL": "https://github.com/nervosnetwork/godwoken",
  "name": "Polyjuice Testnet",
  "nativeCurrency": {
    "name": "CKB",
    "symbol": "CKB",
    "decimals": 8
  },
  "networkId": 1,
  "rpc": ["https://71393.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://godwoken-testnet-web3-rpc.ckbapp.dev", "ws://godwoken-testnet-web3-rpc.ckbapp.dev/ws"],
  "shortName": "ckb",
  "slip44": 1,
  "slug": "polyjuice-testnet",
  "testnet": true
};

var c71401 = {
  "chain": "GWT",
  "chainId": 71401,
  "explorers": [{
    "name": "GWScan Block Explorer",
    "url": "https://v1.testnet.gwscan.com",
    "standard": "none"
  }],
  "faucets": ["https://testnet.bridge.godwoken.io"],
  "infoURL": "https://www.nervos.org",
  "name": "Godwoken Testnet v1",
  "nativeCurrency": {
    "name": "pCKB",
    "symbol": "pCKB",
    "decimals": 18
  },
  "networkId": 71401,
  "rpc": ["https://71401.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://godwoken-testnet-v1.ckbapp.dev", "https://v1.testnet.godwoken.io/rpc"],
  "shortName": "gw-testnet-v1",
  "slip44": 1,
  "slug": "godwoken-testnet-v1",
  "testnet": true
};

var c71402 = {
  "chain": "GWT",
  "chainId": 71402,
  "explorers": [{
    "name": "GWScan Block Explorer",
    "url": "https://v1.gwscan.com",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.nervos.org",
  "name": "Godwoken Mainnet",
  "nativeCurrency": {
    "name": "pCKB",
    "symbol": "pCKB",
    "decimals": 18
  },
  "networkId": 71402,
  "rpc": ["https://71402.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://v1.mainnet.godwoken.io/rpc"],
  "shortName": "gw-mainnet-v1",
  "slug": "godwoken",
  "testnet": false
};

var c72605 = {
  "chain": "Jambon's Devnet",
  "chainId": 72605,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "name": "Jambon's Devnet",
  "nativeCurrency": {
    "name": "Jambon's Devnet",
    "symbol": "DOB",
    "decimals": 18
  },
  "networkId": 72605,
  "redFlags": [],
  "rpc": [],
  "shortName": "Jambon's Devnet",
  "slug": "jambon-s-devnet",
  "testnet": true
};

var c72709 = {
  "chain": "Avalanche",
  "chainId": 72709,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Dragon Testnet",
  "nativeCurrency": {
    "name": "Dragon Testnet Token",
    "symbol": "BDI",
    "decimals": 18
  },
  "networkId": 72709,
  "redFlags": [],
  "rpc": ["https://72709.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/dragontest/testnet/rpc"],
  "shortName": "Dragon Testnet",
  "slug": "dragon-testnet",
  "testnet": true
};

var c72778 = {
  "chain": "Ankara",
  "chainId": 72778,
  "explorers": [{
    "name": "ankara",
    "url": "https://explorer.ankara-cagacrypto.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmeiop9gSdzU4NNJ6GCuPk6AeYwD9pbhEFVfRdk4dXs3kJ",
    "width": 640,
    "height": 640,
    "format": "png"
  },
  "infoURL": "https://www.cagacrypto.com/",
  "name": "CAGA crypto Ankara testnet",
  "nativeCurrency": {
    "name": "Caga",
    "symbol": "CAGA",
    "decimals": 18
  },
  "networkId": 72778,
  "rpc": ["https://72778.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://www.ankara-cagacrypto.com", "wss://wss.ankara-cagacrypto.com"],
  "shortName": "caga",
  "slug": "caga-crypto-ankara-testnet",
  "testnet": true
};

var c72877 = {
  "chain": "Avalanche",
  "chainId": 72877,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser4 Testnet",
  "nativeCurrency": {
    "name": "QaUser4 Testnet Token",
    "symbol": "ZAG",
    "decimals": 18
  },
  "networkId": 72877,
  "redFlags": [],
  "rpc": ["https://72877.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser4 Testnet",
  "slug": "qauser4-testnet-qauser4 testnet-72877",
  "testnet": true
};

var c72992 = {
  "chain": "Grok",
  "chainId": 72992,
  "explorers": [{
    "name": "GrokScan",
    "url": "https://mainnet-explorer.grokchain.dev",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreicepw6yqtmubtpcthecjx47ndwgywartfqnkdhf66k3q57h2hlewm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://grokchain.dev",
  "name": "Grok Chain Mainnet",
  "nativeCurrency": {
    "name": "Groc",
    "symbol": "GROC",
    "decimals": 18
  },
  "networkId": 72992,
  "rpc": ["https://72992.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.grokchain.dev"],
  "shortName": "GrokChain",
  "slug": "grok-chain",
  "testnet": false
};

var c73114 = {
  "chain": "ICBT",
  "chainId": 73114,
  "explorers": [{
    "name": "ICB Tesnet Explorer",
    "url": "https://testnet.icbscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreifgpv7tnai42hsdegnpwzbvq5iymgub357e553cotitirwy2ir7je",
    "width": 2000,
    "height": 2243,
    "format": "png"
  },
  "infoURL": "https://icb.network",
  "name": "ICB Testnet",
  "nativeCurrency": {
    "name": "ICB Testnet Token",
    "symbol": "ICBT",
    "decimals": 18
  },
  "networkId": 73114,
  "rpc": ["https://73114.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc1-testnet.icbnetwork.info/", "https://rpc2-testnet.icbnetwork.info/"],
  "shortName": "ICBT",
  "slug": "icb-testnet",
  "testnet": true
};

var c73115 = {
  "chain": "ICB",
  "chainId": 73115,
  "explorers": [{
    "name": "ICB Explorer",
    "url": "https://icbscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreifgpv7tnai42hsdegnpwzbvq5iymgub357e553cotitirwy2ir7je",
    "width": 2000,
    "height": 2243,
    "format": "png"
  },
  "infoURL": "https://icb.network",
  "name": "ICB Network",
  "nativeCurrency": {
    "name": "ICB Native Token",
    "symbol": "ICBX",
    "decimals": 18
  },
  "networkId": 73115,
  "rpc": ["https://73115.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc1-mainnet.icbnetwork.info/", "https://rpc2-mainnet.icbnetwork.info/"],
  "shortName": "ICBX",
  "slug": "icb-network",
  "testnet": false
};

var c73677 = {
  "chain": "Avalanche",
  "chainId": 73677,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser9318 Testnet",
  "nativeCurrency": {
    "name": "QaUser9318 Testnet Token",
    "symbol": "XUK",
    "decimals": 18
  },
  "networkId": 73677,
  "redFlags": [],
  "rpc": ["https://73677.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser9318 Testnet",
  "slug": "qauser9318-testnet",
  "testnet": true
};

var c73799 = {
  "chain": "Volta",
  "chainId": 73799,
  "explorers": [],
  "faucets": ["https://voltafaucet.energyweb.org"],
  "infoURL": "https://energyweb.org",
  "name": "Energy Web Volta Testnet",
  "nativeCurrency": {
    "name": "Volta Token",
    "symbol": "VT",
    "decimals": 18
  },
  "networkId": 73799,
  "rpc": ["https://73799.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://volta-rpc.energyweb.org", "wss://volta-rpc.energyweb.org/ws"],
  "shortName": "vt",
  "slip44": 1,
  "slug": "energy-web-volta-testnet",
  "testnet": true
};

var c73927 = {
  "chain": "MVM",
  "chainId": 73927,
  "explorers": [{
    "name": "mvmscan",
    "url": "https://scan.mvm.dev",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmeuDgSprukzfV7fi9XYHYcfmT4aZZZU7idgShtRS8Vf6V",
      "width": 471,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeuDgSprukzfV7fi9XYHYcfmT4aZZZU7idgShtRS8Vf6V",
    "width": 471,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://mvm.dev",
  "name": "Mixin Virtual Machine",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 73927,
  "rpc": ["https://73927.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://geth.mvm.dev"],
  "shortName": "mvm",
  "slug": "mixin-virtual-machine",
  "testnet": false
};

var c74356 = {
  "chain": "Avalanche",
  "chainId": 74356,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "S Testnet 1-5-24",
  "nativeCurrency": {
    "name": "S Testnet 1-5-24 Token",
    "symbol": "ZLQ",
    "decimals": 18
  },
  "networkId": 74356,
  "redFlags": [],
  "rpc": ["https://74356.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "S Testnet 1-5-24",
  "slug": "s-testnet-1-5-24",
  "testnet": true
};

var c74738 = {
  "chain": "Avalanche",
  "chainId": 74738,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Testnet",
  "nativeCurrency": {
    "name": "Testnet Token",
    "symbol": "CWA",
    "decimals": 18
  },
  "networkId": 74738,
  "redFlags": [],
  "rpc": ["https://74738.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Testnet",
  "slug": "testnet-testnet-74738",
  "testnet": true
};

var c75000 = {
  "chain": "RESIN",
  "chainId": 75000,
  "explorers": [{
    "name": "ResinScan",
    "url": "https://explorer.resincoin.dev",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmTBszPzBeWPhjozf4TxpL2ws1NkG9yJvisx9h6MFii1zb",
    "width": 460,
    "height": 460,
    "format": "png"
  },
  "infoURL": "https://resincoin.dev",
  "name": "ResinCoin Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "RESIN",
    "decimals": 18
  },
  "networkId": 75000,
  "rpc": [],
  "shortName": "resin",
  "slug": "resincoin",
  "testnet": false
};

var c75817 = {
  "chain": "Avalanche",
  "chainId": 75817,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "SFT 1-8-24",
  "nativeCurrency": {
    "name": "SFT 1-8-24 Token",
    "symbol": "ZAF",
    "decimals": 18
  },
  "networkId": 75817,
  "redFlags": [],
  "rpc": ["https://75817.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "SFT 1-8-24",
  "slug": "sft-1-8-24",
  "testnet": true
};

var c76950 = {
  "chain": "Avalanche",
  "chainId": 76950,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI1204I2",
  "nativeCurrency": {
    "name": "QI1204I2 Token",
    "symbol": "BHOX",
    "decimals": 18
  },
  "networkId": 76950,
  "redFlags": [],
  "rpc": ["https://76950.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-test.io/ba4e7766-4bc6-44ec-b43f-598647b4ee71"],
  "shortName": "QI1204I2",
  "slug": "qi1204i2",
  "testnet": true
};

var c77001 = {
  "chain": "BORA",
  "chainId": 77001,
  "explorers": [{
    "name": "BORAchainscope",
    "url": "https://scope.boraportal.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmccGWJcCzQh3rP6ZMdRyTc7JjtusKnXkoUtGUANQgjNqR",
    "width": 48,
    "height": 48,
    "format": "svg"
  },
  "infoURL": "https://www.boraportal.com",
  "name": "BORAchain mainnet",
  "nativeCurrency": {
    "name": "BGAS",
    "symbol": "BGAS",
    "decimals": 18
  },
  "networkId": 77001,
  "rpc": ["https://77001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://public-node.api.boraportal.com/bora/mainnet"],
  "shortName": "BORAchain",
  "slip44": 8217,
  "slug": "borachain",
  "testnet": false
};

var c77238 = {
  "chain": "tFNC",
  "chainId": 77238,
  "explorers": [{
    "name": "Foundry Scan Testnet",
    "url": "https://testnet-explorer.foundryscan.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.foundryscan.org"],
  "icon": {
    "url": "ipfs://bafkreifx4vef7ubqz4iiaxckcvkdwjrp2hbliljwjlwu2vytlngg3r4pg4",
    "width": 192,
    "height": 192,
    "format": "png"
  },
  "infoURL": "https://foundrychain.org",
  "name": "Foundry Chain Testnet",
  "nativeCurrency": {
    "name": "Foundry Chain Testnet",
    "symbol": "tFNC",
    "decimals": 18
  },
  "networkId": 77238,
  "rpc": ["https://77238.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.foundryscan.org/"],
  "shortName": "fnc",
  "slip44": 1,
  "slug": "foundry-chain-testnet",
  "testnet": true
};

var c77552 = {
  "chain": "Avalanche",
  "chainId": 77552,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser3673 Testnet",
  "nativeCurrency": {
    "name": "QaUser3673 Testnet Token",
    "symbol": "YSI",
    "decimals": 18
  },
  "networkId": 77552,
  "redFlags": [],
  "rpc": ["https://77552.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser3673 Testnet",
  "slug": "qauser3673-testnet",
  "testnet": true
};

var c77612 = {
  "chain": "VSC",
  "chainId": 77612,
  "explorers": [{
    "name": "ventionscan",
    "url": "https://ventionscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.vention.network"],
  "icon": {
    "url": "ipfs://QmcNepHmbmHW1BZYM3MFqJW4awwhmDqhUPRXXmRnXwg1U4",
    "width": 250,
    "height": 250,
    "format": "png"
  },
  "infoURL": "https://ventionscan.io",
  "name": "Vention Smart Chain Mainnet",
  "nativeCurrency": {
    "name": "VNT",
    "symbol": "VNT",
    "decimals": 18
  },
  "networkId": 77612,
  "rpc": ["https://77612.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.vention.network"],
  "shortName": "vscm",
  "slug": "vention-smart-chain",
  "testnet": false
};

var c77777 = {
  "chain": "Toronet",
  "chainId": 77777,
  "ens": {
    "registry": "0x1f45a71f4aAD769E27c969c4359E0e250C67165c"
  },
  "explorers": [{
    "name": "toronet_explorer",
    "url": "https://toronet.org/explorer",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmciSvgLatP6jhgdazuiyD3fSrhipfAN7wC943v1qxcrpv",
    "width": 846,
    "height": 733,
    "format": "png"
  },
  "infoURL": "https://toronet.org",
  "name": "Toronet Mainnet",
  "nativeCurrency": {
    "name": "Toro",
    "symbol": "TORO",
    "decimals": 18
  },
  "networkId": 77777,
  "rpc": ["https://77777.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://toronet.org/rpc"],
  "shortName": "Toronet",
  "slug": "toronet",
  "testnet": false
};

var c78110 = {
  "chain": "ETH",
  "chainId": 78110,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://primusmoney.com",
  "name": "Firenze test network",
  "nativeCurrency": {
    "name": "Firenze Ether",
    "symbol": "FIN",
    "decimals": 18
  },
  "networkId": 78110,
  "rpc": ["https://78110.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://ethnode.primusmoney.com/firenze"],
  "shortName": "firenze",
  "slip44": 1,
  "slug": "firenze-test-network",
  "testnet": true
};

var c78170 = {
  "chain": "Avalanche",
  "chainId": 78170,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "MXS Games Testnet",
  "nativeCurrency": {
    "name": "MXS Games Testnet Token",
    "symbol": "XSEED",
    "decimals": 18
  },
  "networkId": 78170,
  "redFlags": [],
  "rpc": ["https://78170.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/mxsgameste/testnet/rpc"],
  "shortName": "MXS Games Testnet",
  "slug": "mxs-games-testnet",
  "testnet": true
};

var c78281 = {
  "chain": "Dragonfly",
  "chainId": 78281,
  "explorers": [{
    "name": "Dragonfly Blockscout",
    "url": "https://blockscout.dragonfly.hexapod.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmPXhdPGufjcPzZ9Y6nY6QyW8MgA6793L88iPMRh1Q3gjJ",
    "width": 512,
    "height": 366,
    "format": "png"
  },
  "infoURL": "https://hexapod.network",
  "name": "Dragonfly Mainnet (Hexapod)",
  "nativeCurrency": {
    "name": "Dragonfly",
    "symbol": "DFLY",
    "decimals": 18
  },
  "networkId": 78281,
  "rpc": ["https://78281.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dragonfly-rpc.switch.ch", "https://dragonfly-rpc.kore-technologies.ch", "https://dragonfly-rpc.phoenix-systems.io", "https://dragonfly-rpc.block-spirit.ch"],
  "shortName": "dfly",
  "slug": "dragonfly-hexapod",
  "testnet": false
};

var c78430 = {
  "chain": "AMPLIFY",
  "chainId": 78430,
  "explorers": [{
    "name": "AMPLIFY Explorer",
    "url": "https://subnets-test.avax.network/amplify",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "infoURL": "https://www.avax.network",
  "name": "Amplify Subnet",
  "nativeCurrency": {
    "name": "AMP",
    "symbol": "AMP",
    "decimals": 18
  },
  "networkId": 78430,
  "rpc": ["https://78430.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/amplify/testnet/rpc"],
  "shortName": "amplify",
  "slip44": 1,
  "slug": "amplify-subnet",
  "testnet": true
};

var c78431 = {
  "chain": "BULLETIN",
  "chainId": 78431,
  "explorers": [{
    "name": "BULLETIN Explorer",
    "url": "https://subnets-test.avax.network/bulletin",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "infoURL": "https://www.avax.network",
  "name": "Bulletin Subnet",
  "nativeCurrency": {
    "name": "BLT",
    "symbol": "BLT",
    "decimals": 18
  },
  "networkId": 78431,
  "rpc": ["https://78431.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/bulletin/testnet/rpc"],
  "shortName": "bulletin",
  "slip44": 1,
  "slug": "bulletin-subnet",
  "testnet": true
};

var c78432 = {
  "chain": "CONDUIT",
  "chainId": 78432,
  "explorers": [{
    "name": "CONDUIT Explorer",
    "url": "https://subnets-test.avax.network/conduit",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "infoURL": "https://www.avax.network",
  "name": "Conduit Subnet",
  "nativeCurrency": {
    "name": "CON",
    "symbol": "CON",
    "decimals": 18
  },
  "networkId": 78432,
  "rpc": ["https://78432.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/conduit/testnet/rpc"],
  "shortName": "conduit",
  "slip44": 1,
  "slug": "conduit-subnet",
  "testnet": true
};

var c78600 = {
  "chain": "VANAR",
  "chainId": 78600,
  "explorers": [{
    "name": "Vanguard Explorer",
    "url": "https://explorer-vanguard.vanarchain.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmeERjnmdZ6v1tfCyfKfy2Rzh1vPCsU7x2sLJcLqQ6E3Fd",
      "width": 1000,
      "height": 1628,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.vanarchain.com"],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://QmeERjnmdZ6v1tfCyfKfy2Rzh1vPCsU7x2sLJcLqQ6E3Fd",
    "width": 1000,
    "height": 1628,
    "format": "png"
  },
  "infoURL": "https://vanarchain.com",
  "name": "Vanguard",
  "nativeCurrency": {
    "name": "Vanguard Vanry",
    "symbol": "VG",
    "decimals": 18
  },
  "networkId": 78600,
  "rpc": ["https://78600.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-vanguard.vanarchain.com", "wss://ws-vanguard.vanarchain.com"],
  "shortName": "vanguard",
  "slug": "vanguard",
  "testnet": true,
  "title": "Vanar Testnet Vanguard"
};

var c78933 = {
  "chain": "Avalanche",
  "chainId": 78933,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "FST 12-22 V2",
  "nativeCurrency": {
    "name": "FST 12-22 V2 Token",
    "symbol": "EJJ",
    "decimals": 18
  },
  "networkId": 78933,
  "redFlags": [],
  "rpc": ["https://78933.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "FST 12-22 V2",
  "slug": "fst-12-22-v2",
  "testnet": true
};

var c79338 = {
  "chain": "Avalanche",
  "chainId": 79338,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0122I1 Testnet",
  "nativeCurrency": {
    "name": "QR0122I1 Testnet Token",
    "symbol": "JVTX",
    "decimals": 18
  },
  "networkId": 79338,
  "redFlags": [],
  "rpc": ["https://79338.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0122i1te/testnet/rpc"],
  "shortName": "QR0122I1 Testnet",
  "slug": "qr0122i1-testnet",
  "testnet": true
};

var c79879 = {
  "chain": "STAND",
  "chainId": 79879,
  "explorers": [{
    "name": "Gold Smart Chain",
    "url": "https://testnet.goldsmartchain.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.goldsmartchain.com"],
  "icon": {
    "url": "ipfs://QmPNuymyaKLJhCaXnyrsL8358FeTxabZFsaxMmWNU4Tzt3",
    "width": 396,
    "height": 418,
    "format": "png"
  },
  "infoURL": "https://goldsmartchain.com",
  "name": "Gold Smart Chain Testnet",
  "nativeCurrency": {
    "name": "Standard in Gold",
    "symbol": "STAND",
    "decimals": 18
  },
  "networkId": 79879,
  "rpc": ["https://79879.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.goldsmartchain.com"],
  "shortName": "STANDt",
  "slip44": 1,
  "slug": "gold-smart-chain-testnet",
  "testnet": true
};

var c80001 = {
  "chain": "Polygon",
  "chainId": 80001,
  "explorers": [{
    "name": "polygonscan",
    "url": "https://mumbai.polygonscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.polygon.technology/"],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/polygon/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://polygon.technology/",
  "name": "Mumbai",
  "nativeCurrency": {
    "name": "MATIC",
    "symbol": "MATIC",
    "decimals": 18
  },
  "networkId": 80001,
  "redFlags": [],
  "rpc": ["https://80001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-mumbai.maticvigil.com", "https://polygon-mumbai-bor-rpc.publicnode.com", "wss://polygon-mumbai-bor-rpc.publicnode.com", "https://polygon-mumbai.gateway.tenderly.co", "wss://polygon-mumbai.gateway.tenderly.co"],
  "shortName": "maticmum",
  "slip44": 1,
  "slug": "mumbai",
  "status": "deprecated",
  "testnet": true,
  "title": "Polygon Testnet Mumbai"
};

var c80002 = {
  "chain": "Polygon",
  "chainId": 80002,
  "explorers": [{
    "name": "polygonamoy",
    "url": "https://www.oklink.com/amoy",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.polygon.technology/"],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/polygon/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://polygon.technology/",
  "name": "Polygon Amoy Testnet",
  "nativeCurrency": {
    "name": "MATIC",
    "symbol": "MATIC",
    "decimals": 18
  },
  "networkId": 80002,
  "redFlags": [],
  "rpc": ["https://80002.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-amoy.polygon.technology"],
  "shortName": "polygonamoy",
  "slip44": 1,
  "slug": "polygon-amoy-testnet",
  "testnet": true,
  "title": "Polygon Amoy Testnet"
};

var c80085 = {
  "chain": "Berachain",
  "chainId": 80085,
  "explorers": [{
    "name": "Beratrail",
    "url": "https://artio.beratrail.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmW2xrDkSqBB7qgftp5PUecEGg4zwUBJgSN45CaR7CKJMr",
      "width": 256,
      "height": 256,
      "format": "png"
    }
  }],
  "faucets": ["https://artio.faucet.berachain.com"],
  "features": [],
  "icon": {
    "url": "ipfs://QmW2xrDkSqBB7qgftp5PUecEGg4zwUBJgSN45CaR7CKJMr",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://www.berachain.com/",
  "name": "Berachain Artio",
  "nativeCurrency": {
    "name": "BERA",
    "symbol": "BERA",
    "decimals": 18
  },
  "networkId": 80085,
  "redFlags": [],
  "rpc": ["https://80085.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://quicknode-rpc.berachain.com", "https://artio.rpc.berachain.com", "https://rpc.ankr.com/berachain_testnet"],
  "shortName": "bera-artio",
  "slug": "berachain-artio",
  "testnet": true
};

var c80096 = {
  "chain": "HZC",
  "chainId": 80096,
  "explorers": [{
    "name": "blockscout",
    "url": "https://hizoco.net:38443",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNWGj94URMQNyGZbGuAareEL4UpHjTwYWFEFBcX9utBZX",
    "width": 421,
    "height": 421,
    "format": "png"
  },
  "infoURL": "http://hizoco.net",
  "name": "Hizoco mainnet",
  "nativeCurrency": {
    "name": "Hizoco",
    "symbol": "HZC",
    "decimals": 18
  },
  "networkId": 80096,
  "rpc": ["https://80096.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://hizoco.net/rpc"],
  "shortName": "hzc",
  "slug": "hizoco",
  "testnet": false
};

var c80182 = {
  "chain": "Avalanche",
  "chainId": 80182,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 12051",
  "nativeCurrency": {
    "name": "QI M 12051 Token",
    "symbol": "VTV",
    "decimals": 18
  },
  "networkId": 80182,
  "redFlags": [],
  "rpc": ["https://80182.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/b19c9e32-f359-451f-ad15-7ec784625c04"],
  "shortName": "QI M 12051",
  "slug": "qi-m-12051",
  "testnet": true
};

var c80375 = {
  "chain": "Avalanche",
  "chainId": 80375,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "qr0103y1s",
  "nativeCurrency": {
    "name": "qr0103y1s Token",
    "symbol": "IJB",
    "decimals": 18
  },
  "networkId": 80375,
  "redFlags": [],
  "rpc": ["https://80375.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0103y1s/testnet/rpc"],
  "shortName": "qr0103y1s",
  "slug": "qr0103y1s",
  "testnet": true
};

var c80719 = {
  "chain": "Avalanche",
  "chainId": 80719,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser4301 Testnet",
  "nativeCurrency": {
    "name": "QaUser4301 Testnet Token",
    "symbol": "NHU",
    "decimals": 18
  },
  "networkId": 80719,
  "redFlags": [],
  "rpc": ["https://80719.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser4301 Testnet",
  "slug": "qauser4301-testnet",
  "testnet": true
};

var c81041 = {
  "chain": "Nordek",
  "chainId": 81041,
  "explorers": [{
    "name": "nordek",
    "url": "https://nordekscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreie45fcr2hllmej2elwqpdxmiaycxmz25tl5ymraduhtefqndhlm4q",
    "width": 222,
    "height": 306,
    "format": "png"
  },
  "infoURL": "https://nordekscan.com",
  "name": "Nordek Mainnet",
  "nativeCurrency": {
    "name": "NRK",
    "symbol": "NRK",
    "decimals": 18
  },
  "networkId": 81041,
  "rpc": ["https://81041.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.nordekscan.com"],
  "shortName": "nordek",
  "slug": "nordek",
  "testnet": false
};

var c81079 = {
  "chain": "Avalanche",
  "chainId": 81079,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 21343243",
  "nativeCurrency": {
    "name": "QI M 21343243 Token",
    "symbol": "JZW",
    "decimals": 18
  },
  "networkId": 81079,
  "redFlags": [],
  "rpc": ["https://81079.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/f575b5b1-8b60-47f3-af28-13f3f3de2ba5"],
  "shortName": "QI M 21343243",
  "slug": "qi-m-21343243",
  "testnet": true
};

var c81341 = {
  "chain": "MEER",
  "chainId": 81341,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://github.com/Qitmeer",
  "name": "Amana Testnet",
  "nativeCurrency": {
    "name": "Amana Testnet",
    "symbol": "MEER-T",
    "decimals": 18
  },
  "networkId": 81341,
  "rpc": [],
  "shortName": "amanatest",
  "slip44": 1,
  "slug": "amana-testnet",
  "status": "incubating",
  "testnet": true
};

var c81342 = {
  "chain": "MEER",
  "chainId": 81342,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://github.com/Qitmeer",
  "name": "Amana Mixnet",
  "nativeCurrency": {
    "name": "Amana Mixnet",
    "symbol": "MEER-M",
    "decimals": 18
  },
  "networkId": 81342,
  "rpc": [],
  "shortName": "amanamix",
  "slug": "amana-mixnet",
  "status": "incubating",
  "testnet": false
};

var c81343 = {
  "chain": "MEER",
  "chainId": 81343,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://github.com/Qitmeer",
  "name": "Amana Privnet",
  "nativeCurrency": {
    "name": "Amana Privnet",
    "symbol": "MEER-P",
    "decimals": 18
  },
  "networkId": 81343,
  "rpc": [],
  "shortName": "amanapriv",
  "slug": "amana-privnet",
  "status": "incubating",
  "testnet": false
};

var c81351 = {
  "chain": "MEER",
  "chainId": 81351,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://github.com/Qitmeer",
  "name": "Flana Testnet",
  "nativeCurrency": {
    "name": "Flana Testnet",
    "symbol": "MEER-T",
    "decimals": 18
  },
  "networkId": 81351,
  "rpc": [],
  "shortName": "flanatest",
  "slip44": 1,
  "slug": "flana-testnet",
  "status": "incubating",
  "testnet": true
};

var c81352 = {
  "chain": "MEER",
  "chainId": 81352,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://github.com/Qitmeer",
  "name": "Flana Mixnet",
  "nativeCurrency": {
    "name": "Flana Mixnet",
    "symbol": "MEER-M",
    "decimals": 18
  },
  "networkId": 81352,
  "rpc": [],
  "shortName": "flanamix",
  "slug": "flana-mixnet",
  "status": "incubating",
  "testnet": false
};

var c81353 = {
  "chain": "MEER",
  "chainId": 81353,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://github.com/Qitmeer",
  "name": "Flana Privnet",
  "nativeCurrency": {
    "name": "Flana Privnet",
    "symbol": "MEER-P",
    "decimals": 18
  },
  "networkId": 81353,
  "rpc": [],
  "shortName": "flanapriv",
  "slug": "flana-privnet",
  "status": "incubating",
  "testnet": false
};

var c81361 = {
  "chain": "MEER",
  "chainId": 81361,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://github.com/Qitmeer",
  "name": "Mizana Testnet",
  "nativeCurrency": {
    "name": "Mizana Testnet",
    "symbol": "MEER-T",
    "decimals": 18
  },
  "networkId": 81361,
  "rpc": [],
  "shortName": "mizanatest",
  "slip44": 1,
  "slug": "mizana-testnet",
  "status": "incubating",
  "testnet": true
};

var c81362 = {
  "chain": "MEER",
  "chainId": 81362,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://github.com/Qitmeer",
  "name": "Mizana Mixnet",
  "nativeCurrency": {
    "name": "Mizana Mixnet",
    "symbol": "MEER-M",
    "decimals": 18
  },
  "networkId": 81362,
  "rpc": [],
  "shortName": "mizanamix",
  "slug": "mizana-mixnet",
  "status": "incubating",
  "testnet": false
};

var c81363 = {
  "chain": "MEER",
  "chainId": 81363,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://github.com/Qitmeer",
  "name": "Mizana Privnet",
  "nativeCurrency": {
    "name": "Mizana Privnet",
    "symbol": "MEER-P",
    "decimals": 18
  },
  "networkId": 81363,
  "rpc": [],
  "shortName": "mizanapriv",
  "slug": "mizana-privnet",
  "status": "incubating",
  "testnet": false
};

var c81457 = {
  "chain": "ETH",
  "chainId": 81457,
  "explorers": [{
    "name": "Blastscan",
    "url": "https://blastscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafybeifc2h3x7jgy4x4nmg2m54ghbvmkfu6oweujambwefzqzew5vujhsi",
      "width": 400,
      "height": 400,
      "format": "jpg"
    }
  }, {
    "name": "Blast Explorer",
    "url": "https://blastexplorer.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafybeifc2h3x7jgy4x4nmg2m54ghbvmkfu6oweujambwefzqzew5vujhsi",
      "width": 400,
      "height": 400,
      "format": "jpg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://bafybeifc2h3x7jgy4x4nmg2m54ghbvmkfu6oweujambwefzqzew5vujhsi",
    "width": 400,
    "height": 400,
    "format": "jpg"
  },
  "infoURL": "https://blast.io/",
  "name": "Blast",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 81457,
  "parent": {
    "type": "L2",
    "chain": "eip155-1"
  },
  "redFlags": [],
  "rpc": ["https://81457.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.blast.io", "https://rpc.ankr.com/blast", "https://blast.din.dev/rpc", "https://blast.blockpi.network/v1/rpc/public", "https://blastl2-mainnet.public.blastapi.io"],
  "shortName": "blastmainnet",
  "slug": "blast-blastmainnet",
  "status": "active",
  "testnet": false
};

var c81573 = {
  "chain": "Avalanche",
  "chainId": 81573,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QIS0311 Testnet",
  "nativeCurrency": {
    "name": "QIS0311 Testnet Token",
    "symbol": "MVD",
    "decimals": 18
  },
  "networkId": 81573,
  "redFlags": [],
  "rpc": ["https://81573.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QIS0311 Testnet",
  "slug": "qis0311-testnet",
  "testnet": true
};

var c81720 = {
  "chain": "QNET",
  "chainId": 81720,
  "explorers": [{
    "name": "Quantum Scan Mainnet",
    "url": "https://quantumscan.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreibwywok67uewqbtqdzgr7nlk3lvvg7hxmbgwtn7kdwxe34useucvm",
    "width": 1024,
    "height": 1024,
    "format": "png"
  },
  "infoURL": "https://quantumnetwork.gg",
  "name": "Quantum Chain Mainnet",
  "nativeCurrency": {
    "name": "Quantum Chain",
    "symbol": "QNET",
    "decimals": 18
  },
  "networkId": 81720,
  "rpc": ["https://81720.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.quantumscan.org"],
  "shortName": "qnet",
  "slug": "quantum-chain",
  "testnet": false
};

var c82368 = {
  "chain": "Avalanche",
  "chainId": 82368,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0116S1",
  "nativeCurrency": {
    "name": "QR0116S1 Token",
    "symbol": "USJ",
    "decimals": 18
  },
  "networkId": 82368,
  "redFlags": [],
  "rpc": ["https://82368.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0116s1/testnet/rpc"],
  "shortName": "QR0116S1",
  "slug": "qr0116s1",
  "testnet": true
};

var c82459 = {
  "chain": "SLN",
  "chainId": 82459,
  "explorers": [{
    "name": "SLN Testnet Explorer",
    "url": "https://explorer.test.smartlayer.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.smartlayer.network/",
  "name": "Smart Layer Network Testnet",
  "nativeCurrency": {
    "name": "Service Unit Token",
    "symbol": "SU",
    "decimals": 18
  },
  "networkId": 82459,
  "rpc": ["https://82459.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.test.smartlayer.network"],
  "shortName": "tSLN",
  "slug": "smart-layer-network-testnet",
  "testnet": true
};

var c82552 = {
  "chain": "Avalanche",
  "chainId": 82552,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0209I2",
  "nativeCurrency": {
    "name": "QI0209I2 Token",
    "symbol": "BLOX",
    "decimals": 18
  },
  "networkId": 82552,
  "redFlags": [],
  "rpc": ["https://82552.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0209I2",
  "slug": "qi0209i2",
  "testnet": true
};

var c82807 = {
  "chain": "zFirst AvaCloud Subnet Thirdweb",
  "chainId": 82807,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "zFirst AvaCloud Subnet Thirdweb",
  "nativeCurrency": {
    "name": "zFirst AvaCloud Subnet Thirdweb",
    "symbol": "YOOO",
    "decimals": 18
  },
  "networkId": 82807,
  "redFlags": [],
  "rpc": ["https://82807.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/f2ea180d-0fda-4b06-9b2e-53a65d3fd789"],
  "shortName": "zFirst AvaCloud Subnet Thirdweb",
  "slug": "zfirst-avacloud-subnet-thirdweb",
  "testnet": true
};

var c83414 = {
  "chain": "Avalanche",
  "chainId": 83414,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Q IM 2402132",
  "nativeCurrency": {
    "name": "Q IM 2402132 Token",
    "symbol": "XVL",
    "decimals": 18
  },
  "networkId": 83414,
  "redFlags": [],
  "rpc": ["https://83414.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Q IM 2402132",
  "slug": "q-im-2402132",
  "testnet": true
};

var c83862 = {
  "chain": "Avalanche",
  "chainId": 83862,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "ST 12-12 V1",
  "nativeCurrency": {
    "name": "ST 12-12 V1 Token",
    "symbol": "GXE",
    "decimals": 18
  },
  "networkId": 83862,
  "redFlags": [],
  "rpc": ["https://83862.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "ST 12-12 V1",
  "slug": "st-12-12-v1",
  "testnet": true
};

var c83872 = {
  "chain": "ZEDXION",
  "chainId": 83872,
  "explorers": [{
    "name": "Zedscan",
    "url": "http://zedscan.net",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://docs.zedscan.net",
  "name": "ZEDXION",
  "nativeCurrency": {
    "name": "Zedxion",
    "symbol": "zedx",
    "decimals": 9
  },
  "networkId": 83872,
  "rpc": ["https://83872.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.zedscan.net"],
  "shortName": "ZEDX",
  "slug": "zedxion",
  "testnet": false
};

var c83900 = {
  "chain": "Avalanche",
  "chainId": 83900,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0122I1 Testnet",
  "nativeCurrency": {
    "name": "QI0122I1 Testnet Token",
    "symbol": "XTT",
    "decimals": 18
  },
  "networkId": 83900,
  "redFlags": [],
  "rpc": ["https://83900.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-test.io/a5f62fea-1375-4ddd-b88f-72b56b435259"],
  "shortName": "QI0122I1 Testnet",
  "slug": "qi0122i1-testnet-qi0122i1 testnet",
  "testnet": true
};

var c84531 = {
  "chain": "ETH",
  "chainId": 84531,
  "explorers": [{
    "name": "basescan",
    "url": "https://goerli.basescan.org",
    "standard": "none"
  }, {
    "name": "basescout",
    "url": "https://base-goerli.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }, {
    "name": "dexguru",
    "url": "https://base-goerli.dex.guru",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRaASKRSjQ5btoUQ2rNTJNxKtx2a2RoewgA7DMQkLVEne",
      "width": 83,
      "height": 82,
      "format": "svg"
    }
  }],
  "faucets": ["https://www.coinbase.com/faucets/base-ethereum-goerli-faucet"],
  "features": [],
  "icon": {
    "url": "ipfs://QmW5Vn15HeRkScMfPcW12ZdZcC2yUASpu6eCsECRdEmjjj/base-512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://base.org",
  "name": "Base Goerli Testnet",
  "nativeCurrency": {
    "name": "Goerli Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 84531,
  "redFlags": [],
  "rpc": ["https://84531.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://goerli.base.org", "https://base-goerli.gateway.tenderly.co", "wss://base-goerli.gateway.tenderly.co", "https://base-goerli-rpc.publicnode.com", "wss://base-goerli-rpc.publicnode.com"],
  "shortName": "basegor",
  "slip44": 1,
  "slug": "base-goerli",
  "status": "deprecated",
  "testnet": true
};

var c84532 = {
  "chain": "ETH",
  "chainId": 84532,
  "explorers": [{
    "name": "basescout",
    "url": "https://base-sepolia.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmaxRoHpxZd8PqccAynherrMznMufG6sdmHZLihkECXmZv",
    "width": 1200,
    "height": 1200,
    "format": "png"
  },
  "infoURL": "https://base.org",
  "name": "Base Sepolia Testnet",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 84532,
  "rpc": ["https://84532.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sepolia.base.org", "https://base-sepolia-rpc.publicnode.com", "wss://base-sepolia-rpc.publicnode.com"],
  "shortName": "basesep",
  "slip44": 1,
  "slug": "base-sepolia-testnet",
  "testnet": true
};

var c84623 = {
  "chain": "Avalanche",
  "chainId": 84623,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2401221",
  "nativeCurrency": {
    "name": "QI M 2401221 Token",
    "symbol": "HZU",
    "decimals": 18
  },
  "networkId": 84623,
  "redFlags": [],
  "rpc": ["https://84623.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/f14d837e-de8f-446d-8222-0077f26e6694"],
  "shortName": "QI M 2401221",
  "slug": "qi-m-2401221",
  "testnet": true
};

var c84886 = {
  "chain": "Aerie",
  "chainId": 84886,
  "explorers": [{
    "name": "Aerie Explorer",
    "url": "https://explorer.aerielab.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreig54jss26xllpjbclmfgwvot72m4ku7qxignhlqei6mijvwi2m4pu",
      "width": 1062,
      "height": 1069,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreig54jss26xllpjbclmfgwvot72m4ku7qxignhlqei6mijvwi2m4pu",
    "width": 1062,
    "height": 1069,
    "format": "png"
  },
  "infoURL": "https://aerielab.io/",
  "name": "Aerie Network",
  "nativeCurrency": {
    "name": "Aerie",
    "symbol": "AER",
    "decimals": 18
  },
  "networkId": 84886,
  "rpc": ["https://84886.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.aerielab.io"],
  "shortName": "Aerie",
  "slug": "aerie-network",
  "testnet": false
};

var c85023 = {
  "chain": "Avalanche",
  "chainId": 85023,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "NishiOgikubo Subnet",
  "nativeCurrency": {
    "name": "NishiOgikubo Subnet Token",
    "symbol": "NOS",
    "decimals": 18
  },
  "networkId": 85023,
  "redFlags": [],
  "rpc": ["https://85023.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/nishiogiku/testnet/rpc"],
  "shortName": "NishiOgikubo Subnet",
  "slug": "nishiogikubo-subnet",
  "testnet": true
};

var c85449 = {
  "chain": "CYBER",
  "chainId": 85449,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://cybertrust.space",
  "name": "CYBERTRUST",
  "nativeCurrency": {
    "name": "Cyber Trust",
    "symbol": "CYBER",
    "decimals": 18
  },
  "networkId": 48501,
  "rpc": ["https://85449.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://testnet.cybertrust.space:48501"],
  "shortName": "Cyber",
  "slug": "cybertrust",
  "testnet": true
};

var c85678 = {
  "chain": "Avalanche",
  "chainId": 85678,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0122I1 Testnet",
  "nativeCurrency": {
    "name": "QI0122I1 Testnet Token",
    "symbol": "KIP",
    "decimals": 18
  },
  "networkId": 85678,
  "redFlags": [],
  "rpc": ["https://85678.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0122I1 Testnet",
  "slug": "qi0122i1-testnet-qi0122i1 testnet-85678",
  "testnet": true
};

var c86663 = {
  "chain": "Avalanche",
  "chainId": 86663,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser7218 Testnet",
  "nativeCurrency": {
    "name": "QaUser7218 Testnet Token",
    "symbol": "GCY",
    "decimals": 18
  },
  "networkId": 86663,
  "redFlags": [],
  "rpc": ["https://86663.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser7218 Testnet",
  "slug": "qauser7218-testnet",
  "testnet": true
};

var c87460 = {
  "chain": "Avalanche",
  "chainId": 87460,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser1360 Testnet",
  "nativeCurrency": {
    "name": "QaUser1360 Testnet Token",
    "symbol": "KYP",
    "decimals": 18
  },
  "networkId": 87460,
  "redFlags": [],
  "rpc": ["https://87460.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser1360 Testnet",
  "slug": "qauser1360-testnet",
  "testnet": true
};

var c87815 = {
  "chain": "Avalanche",
  "chainId": 87815,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2402056",
  "nativeCurrency": {
    "name": "QI M 2402056 Token",
    "symbol": "ACI",
    "decimals": 18
  },
  "networkId": 87815,
  "redFlags": [],
  "rpc": ["https://87815.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/c908add6-74c5-4407-8091-18762786a0b9"],
  "shortName": "QI M 2402056",
  "slug": "qi-m-2402056",
  "testnet": true
};

var c88002 = {
  "chain": "ETH",
  "chainId": 88002,
  "explorers": [{
    "name": "Nautscan",
    "url": "https://proteus.nautscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmNutSgM7n6aJPPDiofe9Dm1epy1RcYTMvugukLUK2vmPM",
      "width": 500,
      "height": 500,
      "format": "png"
    }
  }],
  "faucets": ["https://proteusfaucet.nautchain.xyz"],
  "icon": {
    "url": "ipfs://QmNutSgM7n6aJPPDiofe9Dm1epy1RcYTMvugukLUK2vmPM",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://docs.nautchain.xyz",
  "name": "Nautilus Proteus Testnet",
  "nativeCurrency": {
    "name": "Zebec Test Token",
    "symbol": "tZBC",
    "decimals": 18
  },
  "networkId": 88002,
  "rpc": ["https://88002.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.proteus.nautchain.xyz/solana"],
  "shortName": "NAUTTest",
  "slip44": 1,
  "slug": "nautilus-proteus-testnet",
  "testnet": true
};

var c88018 = {
  "chain": "Avalanche",
  "chainId": 88018,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2402131",
  "nativeCurrency": {
    "name": "QI M 2402131 Token",
    "symbol": "CYB",
    "decimals": 18
  },
  "networkId": 88018,
  "redFlags": [],
  "rpc": ["https://88018.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI M 2402131",
  "slug": "qi-m-2402131",
  "testnet": true
};

var c88817 = {
  "chain": "Unit Zero",
  "chainId": 88817,
  "explorers": [{
    "name": "explorer-testnet",
    "url": "https://explorer-testnet.unit0.dev",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://units.network",
  "name": "Unit Zero Testnet",
  "nativeCurrency": {
    "name": "UNIT0",
    "symbol": "UNIT0",
    "decimals": 18
  },
  "networkId": 88817,
  "rpc": ["https://88817.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.unit0.dev"],
  "shortName": "unit0-testnet",
  "slug": "unit-zero-testnet",
  "testnet": true
};

var c88819 = {
  "chain": "Unit Zero",
  "chainId": 88819,
  "explorers": [{
    "name": "explorer-stagenet",
    "url": "https://explorer-stagenet.unit0.dev",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://units.network",
  "name": "Unit Zero Stagenet",
  "nativeCurrency": {
    "name": "UNIT0",
    "symbol": "UNIT0",
    "decimals": 18
  },
  "networkId": 88819,
  "rpc": ["https://88819.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-stagenet.unit0.dev"],
  "shortName": "unit0-stagenet",
  "slug": "unit-zero-stagenet",
  "testnet": false
};

var c88880 = {
  "chain": "CHZ",
  "chainId": 88880,
  "explorers": [{
    "name": "scoville-explorer",
    "url": "https://scoville-explorer.chiliz.com",
    "standard": "none"
  }],
  "faucets": ["https://scoville-faucet.chiliz.com"],
  "icon": {
    "url": "ipfs://QmYV5xUVZhHRzLy7ie9D8qZeygJHvNZZAxwnB9GXYy6EED",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://www.chiliz.com/en/chain",
  "name": "Chiliz Scoville Testnet",
  "nativeCurrency": {
    "name": "Chiliz",
    "symbol": "CHZ",
    "decimals": 18
  },
  "networkId": 88880,
  "rpc": ["https://88880.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://scoville-rpc.chiliz.com"],
  "shortName": "chz",
  "slip44": 1,
  "slug": "chiliz-scoville-testnet",
  "testnet": true
};

var c88882 = {
  "chain": "Spicy",
  "chainId": 88882,
  "explorers": [{
    "name": "Spicy Explorer",
    "url": "http://spicy-explorer.chiliz.com/",
    "standard": "none"
  }],
  "faucets": ["https://spicy-faucet.chiliz.com/"],
  "features": [],
  "icon": {
    "url": "ipfs://QmTGYofJ8VLkeNY4J69AvXi8e126kmbHmf34wLFoJ1FKAK",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://chiliz.com/",
  "name": "Spicy Chain",
  "nativeCurrency": {
    "name": "Chiliz",
    "symbol": "CHZ",
    "decimals": 18
  },
  "networkId": 88882,
  "redFlags": [],
  "rpc": ["https://88882.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://spicy-rpc.chiliz.com/"],
  "shortName": "Spicy",
  "slug": "spicy-chain",
  "testnet": true
};

var c88883 = {
  "chain": "Avalanche",
  "chainId": 88883,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Proj Orc Testnet Alpha",
  "nativeCurrency": {
    "name": "Proj Orc Testnet Alpha Token",
    "symbol": "STX",
    "decimals": 18
  },
  "networkId": 88883,
  "redFlags": [],
  "rpc": ["https://88883.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/projorctes/testnet/rpc"],
  "shortName": "Proj Orc Testnet Alpha",
  "slug": "proj-orc-testnet-alpha",
  "testnet": true
};

var c88888 = {
  "chain": "CC2",
  "chainId": 88888,
  "explorers": [{
    "name": "cc2scan",
    "url": "https://scan.chiliz.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmTGYofJ8VLkeNY4J69AvXi8e126kmbHmf34wLFoJ1FKAK",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://chiliz.com/chiliz-chain-2-0/",
  "name": "Chiliz Chain",
  "nativeCurrency": {
    "name": "Chiliz",
    "symbol": "CHZ",
    "decimals": 18
  },
  "networkId": 88888,
  "redFlags": ["reusedChainId"],
  "rpc": ["https://88888.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.ankr.com/chiliz", "https://rpc.chiliz.com"],
  "shortName": "cc2",
  "slug": "chiliz-chain",
  "testnet": false
};

var c89283 = {
  "chain": "Avalanche",
  "chainId": 89283,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QIS0326 Testnet",
  "nativeCurrency": {
    "name": "QIS0326 Testnet Token",
    "symbol": "AKK",
    "decimals": 18
  },
  "networkId": 89283,
  "redFlags": [],
  "rpc": ["https://89283.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QIS0326 Testnet",
  "slug": "qis0326-testnet",
  "testnet": true
};

var c89327 = {
  "chain": "Avalanche",
  "chainId": 89327,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0304I3 Testnet",
  "nativeCurrency": {
    "name": "QI0304I3 Testnet Token",
    "symbol": "ZIK",
    "decimals": 18
  },
  "networkId": 89327,
  "redFlags": [],
  "rpc": ["https://89327.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0304I3 Testnet",
  "slug": "qi0304i3-testnet",
  "testnet": true
};

var c90210 = {
  "chain": "ETH",
  "chainId": 90210,
  "explorers": [{
    "name": "Beverly Hills explorer",
    "url": "https://explorer.beverlyhills.ethdevops.io",
    "standard": "none"
  }],
  "faucets": ["https://faucet.beverlyhills.ethdevops.io"],
  "infoURL": "https://beverlyhills.ethdevops.io",
  "name": "Beverly Hills",
  "nativeCurrency": {
    "name": "Beverly Hills Testnet Ether",
    "symbol": "BVE",
    "decimals": 18
  },
  "networkId": 90210,
  "rpc": ["https://90210.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.beverlyhills.ethdevops.io:8545"],
  "shortName": "bvhl",
  "slug": "beverly-hills",
  "status": "incubating",
  "testnet": true,
  "title": "Ethereum multi-client Verkle Testnet Beverly Hills"
};

var c91002 = {
  "chain": "ETH",
  "chainId": 91002,
  "explorers": [{
    "name": "Nautscan",
    "url": "https://triton.nautscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.eclipse.builders"],
  "icon": {
    "url": "ipfs://QmNutSgM7n6aJPPDiofe9Dm1epy1RcYTMvugukLUK2vmPM",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://docs.nautchain.xyz",
  "name": "Nautilus Trition Chain",
  "nativeCurrency": {
    "name": "Nautilus Zebec Testnet Tokens",
    "symbol": "tZBC",
    "decimals": 18
  },
  "networkId": 91002,
  "rpc": ["https://91002.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://triton.api.nautchain.xyz"],
  "shortName": "NAUT",
  "slug": "nautilus-trition-chain",
  "testnet": true,
  "title": "Nautilus Trition Testnet"
};

var c91003 = {
  "chain": "WRLDS",
  "chainId": 91003,
  "explorers": [],
  "faucets": ["https://faucet.evm.worlds.dev.eclipsenetwork.xyz/request_neon"],
  "features": [],
  "name": "Worlds Appchain",
  "nativeCurrency": {
    "name": "WRLDS",
    "symbol": "WRLDS",
    "decimals": 18
  },
  "networkId": 91003,
  "redFlags": [],
  "rpc": ["https://91003.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.evm.worlds.dev.eclipsenetwork.xyz/"],
  "shortName": "WRLDS",
  "slug": "worlds-appchain",
  "testnet": true
};

var c91041 = {
  "chain": "Avalanche",
  "chainId": 91041,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0318I1 Testnet",
  "nativeCurrency": {
    "name": "QI0318I1 Testnet Token",
    "symbol": "DVN",
    "decimals": 18
  },
  "networkId": 91041,
  "redFlags": [],
  "rpc": ["https://91041.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0318I1 Testnet",
  "slug": "qi0318i1-testnet-qi0318i1 testnet",
  "testnet": true
};

var c91120 = {
  "chain": "MetaDAP",
  "chainId": 91120,
  "explorers": [{
    "name": "MetaDAP Enterprise Mainnet explorer",
    "url": "https://explorer.chain.metadap.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmcCFUTStKKJKfzTwrjfMFoVaPCMsvAvWXRdDkYMvCkEs3",
    "width": 800,
    "height": 800,
    "format": "svg"
  },
  "infoURL": "https://metadap.io/",
  "name": "MetaDAP Enterprise Mainnet",
  "nativeCurrency": {
    "name": "DAP",
    "symbol": "DAP",
    "decimals": 18
  },
  "networkId": 91120,
  "rpc": ["https://91120.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.chain.metadap.io", "wss://rpc-ws.chain.metadap.io"],
  "shortName": "MetaDAP",
  "slug": "metadap-enterprise",
  "testnet": false,
  "title": "MetaDAP Enterprise Mainnet"
};

var c91132 = {
  "chain": "Avalanche",
  "chainId": 91132,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "New Will's Testnet",
  "nativeCurrency": {
    "name": "New Will's Testnet Token",
    "symbol": "MBM",
    "decimals": 18
  },
  "networkId": 91132,
  "redFlags": [],
  "rpc": ["https://91132.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "New Will's Testnet",
  "slug": "new-will-s-testnet",
  "testnet": true
};

var c91558 = {
  "chain": "Avalanche",
  "chainId": 91558,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Shelby's Testnet 1-18",
  "nativeCurrency": {
    "name": "Shelby's Testnet 1-18 Token",
    "symbol": "LIE",
    "decimals": 18
  },
  "networkId": 91558,
  "redFlags": [],
  "rpc": ["https://91558.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Shelby's Testnet 1-18",
  "slug": "shelby-s-testnet-1-18",
  "testnet": true
};

var c91715 = {
  "chain": "Combo",
  "chainId": 91715,
  "explorers": [{
    "name": "combotrace explorer",
    "url": "https://combotrace-testnet.nodereal.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRR4v6h6z21BpgS9xY3ExLB4Gkmm3i3dJWQx27oTGifq8",
    "width": 800,
    "height": 693,
    "format": "png"
  },
  "infoURL": "https://combonetwork.io",
  "name": "Combo Testnet",
  "nativeCurrency": {
    "name": "BNB Chain Native Token",
    "symbol": "tcBNB",
    "decimals": 18
  },
  "networkId": 91715,
  "rpc": ["https://91715.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://test-rpc.combonetwork.io"],
  "shortName": "combo-testnet",
  "slug": "combo-testnet",
  "testnet": true
};

var c91735 = {
  "chain": "Avalanche",
  "chainId": 91735,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI1228I2",
  "nativeCurrency": {
    "name": "QI1228I2 Token",
    "symbol": "ZMY",
    "decimals": 18
  },
  "networkId": 91735,
  "redFlags": [],
  "rpc": ["https://91735.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/f51649a9-3420-4636-bb44-206f63998951"],
  "shortName": "QI1228I2",
  "slug": "qi1228i2",
  "testnet": true
};

var c92001 = {
  "chain": "Lambda",
  "chainId": 92001,
  "explorers": [{
    "name": "Lambda EVM Explorer",
    "url": "https://explorer.lambda.top",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmWsoME6LCghQTpGYf7EnUojaDdYo7kfkWVjE6VvNtkjwy",
      "width": 500,
      "height": 500,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.lambda.top"],
  "icon": {
    "url": "ipfs://QmWsoME6LCghQTpGYf7EnUojaDdYo7kfkWVjE6VvNtkjwy",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://lambda.im",
  "name": "Lambda Testnet",
  "nativeCurrency": {
    "name": "test-Lamb",
    "symbol": "LAMB",
    "decimals": 18
  },
  "networkId": 92001,
  "rpc": ["https://92001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm.lambda.top/"],
  "shortName": "lambda-testnet",
  "slip44": 1,
  "slug": "lambda-testnet",
  "testnet": true
};

var c92496 = {
  "chain": "Avalanche",
  "chainId": 92496,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Testnet",
  "nativeCurrency": {
    "name": "Testnet Token",
    "symbol": "OWO",
    "decimals": 18
  },
  "networkId": 92496,
  "redFlags": [],
  "rpc": ["https://92496.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/testnet/testnet/rpc"],
  "shortName": "Testnet",
  "slug": "testnet-testnet-92496",
  "testnet": true
};

var c92780 = {
  "chain": "Avalanche",
  "chainId": 92780,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2402053",
  "nativeCurrency": {
    "name": "QI M 2402053 Token",
    "symbol": "ACI",
    "decimals": 18
  },
  "networkId": 92780,
  "redFlags": [],
  "rpc": ["https://92780.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/c908add6-74c5-4407-8091-18762786a0b9"],
  "shortName": "QI M 2402053",
  "slug": "qi-m-2402053",
  "testnet": true
};

var c92850 = {
  "chain": "Avalanche",
  "chainId": 92850,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI1212I3",
  "nativeCurrency": {
    "name": "QI1212I3 Token",
    "symbol": "HSCX",
    "decimals": 18
  },
  "networkId": 92850,
  "redFlags": [],
  "rpc": ["https://92850.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI1212I3",
  "slug": "qi1212i3",
  "testnet": true
};

var c92978 = {
  "chain": "Avalanche",
  "chainId": 92978,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser4903 Testnet",
  "nativeCurrency": {
    "name": "QaUser4903 Testnet Token",
    "symbol": "CQS",
    "decimals": 18
  },
  "networkId": 92978,
  "redFlags": [],
  "rpc": ["https://92978.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser4903 Testnet",
  "slug": "qauser4903-testnet",
  "testnet": true
};

var c93017 = {
  "chain": "Avalanche",
  "chainId": 93017,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QIS0313 Testnet",
  "nativeCurrency": {
    "name": "QIS0313 Testnet Token",
    "symbol": "NCG",
    "decimals": 18
  },
  "networkId": 93017,
  "redFlags": [],
  "rpc": ["https://93017.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QIS0313 Testnet",
  "slug": "qis0313-testnet",
  "testnet": true
};

var c93572 = {
  "chain": "LILA",
  "chainId": 93572,
  "explorers": [{
    "name": "LiquidLayer Testnet Explorer",
    "url": "https://testnet-scan.liquidlayer.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://claim.liquidlayer.network"],
  "icon": {
    "url": "ipfs://bafkreiayuuzfpcgwjll4us4hquvpqa5gwq3lbiedv4qftmlwcxhcyjzzpq",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://testnet-scan.liquidlayer.network",
  "name": "LiquidLayer Testnet",
  "nativeCurrency": {
    "name": "LiquidLayer Testnet",
    "symbol": "LILA",
    "decimals": 18
  },
  "networkId": 93572,
  "rpc": ["https://93572.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.liquidlayer.network"],
  "shortName": "tLILA",
  "slug": "liquidlayer-testnet",
  "testnet": true
};

var c93625 = {
  "chain": "Avalanche",
  "chainId": 93625,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0222I2",
  "nativeCurrency": {
    "name": "QI0222I2 Token",
    "symbol": "INK",
    "decimals": 18
  },
  "networkId": 93625,
  "redFlags": [],
  "rpc": ["https://93625.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0222I2",
  "slug": "qi0222i2",
  "testnet": true
};

var c93694 = {
  "chain": "Avalanche",
  "chainId": 93694,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2401291",
  "nativeCurrency": {
    "name": "QI M 2401291 Token",
    "symbol": "HZU",
    "decimals": 18
  },
  "networkId": 93694,
  "redFlags": [],
  "rpc": ["https://93694.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-dev.io/f14d837e-de8f-446d-8222-0077f26e6694"],
  "shortName": "QI M 2401291",
  "slug": "qi-m-2401291",
  "testnet": true
};

var c94158 = {
  "chain": "Avalanche",
  "chainId": 94158,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "FST 12-22 V1",
  "nativeCurrency": {
    "name": "FST 12-22 V1 Token",
    "symbol": "EJJ",
    "decimals": 18
  },
  "networkId": 94158,
  "redFlags": [],
  "rpc": ["https://94158.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "FST 12-22 V1",
  "slug": "fst-12-22-v1",
  "testnet": true
};

var c94565 = {
  "chain": "Avalanche",
  "chainId": 94565,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "T 0117",
  "nativeCurrency": {
    "name": "T 0117 Token",
    "symbol": "RUI",
    "decimals": 18
  },
  "networkId": 94565,
  "redFlags": [],
  "rpc": ["https://94565.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "T 0117",
  "slug": "t-0117",
  "testnet": true
};

var c94918 = {
  "chain": "Avalanche",
  "chainId": 94918,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Sample Testnet",
  "nativeCurrency": {
    "name": "Sample Testnet Token",
    "symbol": "INS",
    "decimals": 18
  },
  "networkId": 94918,
  "redFlags": [],
  "rpc": ["https://94918.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/sampletest/testnet/rpc"],
  "shortName": "Sample Testnet",
  "slug": "sample-testnet",
  "testnet": true
};

var c95395 = {
  "chain": "Avalanche",
  "chainId": 95395,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Testnet",
  "nativeCurrency": {
    "name": "Testnet Token",
    "symbol": "MFD",
    "decimals": 18
  },
  "networkId": 95395,
  "redFlags": [],
  "rpc": ["https://95395.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "Testnet",
  "slug": "testnet-testnet-95395",
  "testnet": true
};

var c96552 = {
  "chain": "Avalanche",
  "chainId": 96552,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI032924 Testnet",
  "nativeCurrency": {
    "name": "QI032924 Testnet Token",
    "symbol": "KJA",
    "decimals": 18
  },
  "networkId": 96552,
  "redFlags": [],
  "rpc": ["https://96552.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI032924 Testnet",
  "slug": "qi032924-testnet",
  "testnet": true
};

var c96809 = {
  "chain": "Avalanche",
  "chainId": 96809,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser2368 Testnet",
  "nativeCurrency": {
    "name": "QaUser2368 Testnet Token",
    "symbol": "ZKJ",
    "decimals": 18
  },
  "networkId": 96809,
  "redFlags": [],
  "rpc": ["https://96809.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser2368 Testnet",
  "slug": "qauser2368-testnet",
  "testnet": true
};

var c96970 = {
  "chain": "Mantis",
  "chainId": 96970,
  "explorers": [{
    "name": "Mantis Blockscout",
    "url": "https://blockscout.mantis.hexapod.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": ["https://mantis.switch.ch/faucet", "https://mantis.kore-technologies.ch/faucet", "https://mantis.phoenix-systems.io/faucet", "https://mantis.block-spirit.ch/faucet"],
  "icon": {
    "url": "ipfs://Qma8dDhxSSVUyzV8Pu5bo252WaZEEikYFndRh7LVktvQEy",
    "width": 512,
    "height": 330,
    "format": "png"
  },
  "infoURL": "https://hexapod.network",
  "name": "Mantis Testnet (Hexapod)",
  "nativeCurrency": {
    "name": "Mantis",
    "symbol": "MANTIS",
    "decimals": 18
  },
  "networkId": 96970,
  "rpc": ["https://96970.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mantis-rpc.switch.ch", "https://mantis-rpc.kore-technologies.ch", "https://mantis-rpc.phoenix-systems.io"],
  "shortName": "mantis",
  "slip44": 1,
  "slug": "mantis-testnet-hexapod",
  "testnet": true
};

var c97288 = {
  "chain": "Boba BNB Mainnet",
  "chainId": 97288,
  "explorers": [{
    "name": "Boba BNB block explorer",
    "url": "https://blockexplorer.bnb.boba.network",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://boba.network",
  "name": "Boba BNB Mainnet Old",
  "nativeCurrency": {
    "name": "Boba Token",
    "symbol": "BOBA",
    "decimals": 18
  },
  "networkId": 97288,
  "rpc": [],
  "shortName": "BobaBnbOld",
  "slug": "boba-bnb-old",
  "status": "deprecated",
  "testnet": false
};

var c97622 = {
  "chain": "Avalanche",
  "chainId": 97622,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0130I1",
  "nativeCurrency": {
    "name": "QI0130I1 Token",
    "symbol": "NZY",
    "decimals": 18
  },
  "networkId": 97622,
  "redFlags": [],
  "rpc": ["https://97622.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0130I1",
  "slug": "qi0130i1",
  "testnet": true
};

var c98540 = {
  "chain": "Avalanche",
  "chainId": 98540,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI1212I5",
  "nativeCurrency": {
    "name": "QI1212I5 Token",
    "symbol": "HSCX",
    "decimals": 18
  },
  "networkId": 98540,
  "redFlags": [],
  "rpc": ["https://98540.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avacloud-test.io/ba4e7766-4bc6-44ec-b43f-598647b4ee71"],
  "shortName": "QI1212I5",
  "slug": "qi1212i5",
  "testnet": true
};

var c98557 = {
  "chain": "Avalanche",
  "chainId": 98557,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0201I1",
  "nativeCurrency": {
    "name": "QR0201I1 Token",
    "symbol": "OCZ",
    "decimals": 18
  },
  "networkId": 98557,
  "redFlags": [],
  "rpc": ["https://98557.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0201i1/testnet/rpc"],
  "shortName": "QR0201I1",
  "slug": "qr0201i1",
  "testnet": true
};

var c99099 = {
  "chain": "$EL",
  "chainId": 99099,
  "explorers": [{
    "name": "eLiberty Testnet",
    "url": "https://testnet.eliberty.ngo",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.eliberty.ngo"],
  "icon": {
    "url": "ipfs://Qmcr8US1DZcK3ooiMtE8tEQPgep12abXzxPw1jCkgZhji9",
    "width": 150,
    "height": 150,
    "format": "png"
  },
  "infoURL": "https://eliberty.ngo",
  "name": "eLiberty Testnet",
  "nativeCurrency": {
    "name": "eLiberty",
    "symbol": "$EL",
    "decimals": 18
  },
  "networkId": 99099,
  "rpc": ["https://99099.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.eliberty.ngo"],
  "shortName": "ELt",
  "slip44": 1,
  "slug": "eliberty-testnet",
  "testnet": true
};

var c99132 = {
  "chain": "Avalanche",
  "chainId": 99132,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0222I1",
  "nativeCurrency": {
    "name": "QI0222I1 Token",
    "symbol": "ZKUx",
    "decimals": 18
  },
  "networkId": 99132,
  "redFlags": [],
  "rpc": ["https://99132.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0222I1",
  "slug": "qi0222i1",
  "testnet": true
};

var c99181 = {
  "chain": "Avalanche",
  "chainId": 99181,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser9727 Testnet",
  "nativeCurrency": {
    "name": "QaUser9727 Testnet Token",
    "symbol": "PCE",
    "decimals": 18
  },
  "networkId": 99181,
  "redFlags": [],
  "rpc": ["https://99181.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser9727 Testnet",
  "slug": "qauser9727-testnet",
  "testnet": true
};

var c99308 = {
  "chain": "Avalanche",
  "chainId": 99308,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Borne Gaming Testnet",
  "nativeCurrency": {
    "name": "Borne Gaming Testnet Token",
    "symbol": "BORNE",
    "decimals": 18
  },
  "networkId": 99308,
  "redFlags": [],
  "rpc": ["https://99308.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/bornegamin/testnet/rpc"],
  "shortName": "Borne Gaming Testnet",
  "slug": "borne-gaming-testnet",
  "testnet": true
};

var c99733 = {
  "chain": "Avalanche",
  "chainId": 99733,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QaUser6779 Testnet",
  "nativeCurrency": {
    "name": "QaUser6779 Testnet Token",
    "symbol": "WAG",
    "decimals": 18
  },
  "networkId": 99733,
  "redFlags": [],
  "rpc": ["https://99733.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QaUser6779 Testnet",
  "slug": "qauser6779-testnet",
  "testnet": true
};

var c99947 = {
  "chain": "Avalanche",
  "chainId": 99947,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI M 2402141",
  "nativeCurrency": {
    "name": "QI M 2402141 Token",
    "symbol": "CYB",
    "decimals": 18
  },
  "networkId": 99947,
  "redFlags": [],
  "rpc": ["https://99947.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI M 2402141",
  "slug": "qi-m-2402141",
  "testnet": true
};

var c99998 = {
  "chain": "USC",
  "chainId": 99998,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.ubchain.site",
  "name": "UB Smart Chain(testnet)",
  "nativeCurrency": {
    "name": "UBC",
    "symbol": "UBC",
    "decimals": 18
  },
  "networkId": 99998,
  "rpc": ["https://99998.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.rpc.uschain.network"],
  "shortName": "usctest",
  "slip44": 1,
  "slug": "ub-smart-chain-testnet",
  "testnet": true
};

var c99999 = {
  "chain": "USC",
  "chainId": 99999,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.ubchain.site/",
  "name": "UB Smart Chain",
  "nativeCurrency": {
    "name": "UBC",
    "symbol": "UBC",
    "decimals": 18
  },
  "networkId": 99999,
  "rpc": ["https://99999.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.uschain.network"],
  "shortName": "usc",
  "slug": "ub-smart-chain",
  "testnet": false
};

var c100000 = {
  "chain": "QuarkChain",
  "chainId": 100000,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Mainnet Root",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 100000,
  "rpc": ["https://100000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://jrpc.mainnet.quarkchain.io:38391"],
  "shortName": "qkc-r",
  "slug": "quarkchain-root",
  "testnet": false
};

var c100001 = {
  "chain": "QuarkChain",
  "chainId": 100001,
  "explorers": [{
    "name": "quarkchain-mainnet",
    "url": "https://mainnet.quarkchain.io/0",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Mainnet Shard 0",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 100001,
  "parent": {
    "type": "shard",
    "chain": "eip155-100000"
  },
  "rpc": ["https://100001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-s0-ethapi.quarkchain.io", "http://eth-jrpc.mainnet.quarkchain.io:39000"],
  "shortName": "qkc-s0",
  "slug": "quarkchain-shard-0",
  "testnet": false
};

var c100002 = {
  "chain": "QuarkChain",
  "chainId": 100002,
  "explorers": [{
    "name": "quarkchain-mainnet",
    "url": "https://mainnet.quarkchain.io/1",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Mainnet Shard 1",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 100002,
  "parent": {
    "type": "shard",
    "chain": "eip155-100000"
  },
  "rpc": ["https://100002.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-s1-ethapi.quarkchain.io", "http://eth-jrpc.mainnet.quarkchain.io:39001"],
  "shortName": "qkc-s1",
  "slug": "quarkchain-shard-1",
  "testnet": false
};

var c100003 = {
  "chain": "QuarkChain",
  "chainId": 100003,
  "explorers": [{
    "name": "quarkchain-mainnet",
    "url": "https://mainnet.quarkchain.io/2",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Mainnet Shard 2",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 100003,
  "parent": {
    "type": "shard",
    "chain": "eip155-100000"
  },
  "rpc": ["https://100003.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-s2-ethapi.quarkchain.io", "http://eth-jrpc.mainnet.quarkchain.io:39002"],
  "shortName": "qkc-s2",
  "slug": "quarkchain-shard-2",
  "testnet": false
};

var c100004 = {
  "chain": "QuarkChain",
  "chainId": 100004,
  "explorers": [{
    "name": "quarkchain-mainnet",
    "url": "https://mainnet.quarkchain.io/3",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Mainnet Shard 3",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 100004,
  "parent": {
    "type": "shard",
    "chain": "eip155-100000"
  },
  "rpc": ["https://100004.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-s3-ethapi.quarkchain.io", "http://eth-jrpc.mainnet.quarkchain.io:39003"],
  "shortName": "qkc-s3",
  "slug": "quarkchain-shard-3",
  "testnet": false
};

var c100005 = {
  "chain": "QuarkChain",
  "chainId": 100005,
  "explorers": [{
    "name": "quarkchain-mainnet",
    "url": "https://mainnet.quarkchain.io/4",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Mainnet Shard 4",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 100005,
  "parent": {
    "type": "shard",
    "chain": "eip155-100000"
  },
  "rpc": ["https://100005.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-s4-ethapi.quarkchain.io", "http://eth-jrpc.mainnet.quarkchain.io:39004"],
  "shortName": "qkc-s4",
  "slug": "quarkchain-shard-4",
  "testnet": false
};

var c100006 = {
  "chain": "QuarkChain",
  "chainId": 100006,
  "explorers": [{
    "name": "quarkchain-mainnet",
    "url": "https://mainnet.quarkchain.io/5",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Mainnet Shard 5",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 100006,
  "parent": {
    "type": "shard",
    "chain": "eip155-100000"
  },
  "rpc": ["https://100006.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-s5-ethapi.quarkchain.io", "http://eth-jrpc.mainnet.quarkchain.io:39005"],
  "shortName": "qkc-s5",
  "slug": "quarkchain-shard-5",
  "testnet": false
};

var c100007 = {
  "chain": "QuarkChain",
  "chainId": 100007,
  "explorers": [{
    "name": "quarkchain-mainnet",
    "url": "https://mainnet.quarkchain.io/6",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Mainnet Shard 6",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 100007,
  "parent": {
    "type": "shard",
    "chain": "eip155-100000"
  },
  "rpc": ["https://100007.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-s6-ethapi.quarkchain.io", "http://eth-jrpc.mainnet.quarkchain.io:39006"],
  "shortName": "qkc-s6",
  "slug": "quarkchain-shard-6",
  "testnet": false
};

var c100008 = {
  "chain": "QuarkChain",
  "chainId": 100008,
  "explorers": [{
    "name": "quarkchain-mainnet",
    "url": "https://mainnet.quarkchain.io/7",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Mainnet Shard 7",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 100008,
  "parent": {
    "type": "shard",
    "chain": "eip155-100000"
  },
  "rpc": ["https://100008.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-s7-ethapi.quarkchain.io", "http://eth-jrpc.mainnet.quarkchain.io:39007"],
  "shortName": "qkc-s7",
  "slug": "quarkchain-shard-7",
  "testnet": false
};

var c100009 = {
  "chain": "VeChain",
  "chainId": 100009,
  "explorers": [{
    "name": "VeChain Stats",
    "url": "https://vechainstats.com",
    "standard": "none"
  }, {
    "name": "VeChain Explorer",
    "url": "https://explore.vechain.org",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://vechain.org",
  "name": "VeChain",
  "nativeCurrency": {
    "name": "VeChain",
    "symbol": "VET",
    "decimals": 18
  },
  "networkId": 100009,
  "rpc": [],
  "shortName": "vechain",
  "slug": "vechain",
  "testnet": false
};

var c100010 = {
  "chain": "VeChain",
  "chainId": 100010,
  "explorers": [{
    "name": "VeChain Explorer",
    "url": "https://explore-testnet.vechain.org",
    "standard": "none"
  }],
  "faucets": ["https://faucet.vecha.in"],
  "infoURL": "https://vechain.org",
  "name": "VeChain Testnet",
  "nativeCurrency": {
    "name": "VeChain",
    "symbol": "VET",
    "decimals": 18
  },
  "networkId": 100010,
  "rpc": [],
  "shortName": "vechain-testnet",
  "slip44": 1,
  "slug": "vechain-testnet",
  "testnet": true
};

var c100100 = {
  "chain": "CHI1",
  "chainId": 100100,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafybeidk4swpgdyqmpz6shd5onvpaujvwiwthrhypufnwr6xh3dausz2dm",
    "width": 1800,
    "height": 1800,
    "format": "png"
  },
  "infoURL": "https://docs.gnosischain.com",
  "name": "Deprecated CHI",
  "nativeCurrency": {
    "name": "Chiado xDAI",
    "symbol": "xDAI",
    "decimals": 18
  },
  "networkId": 100100,
  "rpc": [],
  "shortName": "chi1",
  "slug": "deprecated-chi",
  "status": "deprecated",
  "testnet": false
};

var c101010 = {
  "chain": "GTN",
  "chainId": 101010,
  "explorers": [{
    "name": "blockscout",
    "url": "https://stability.blockscout.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreid3wd6ouu53r677q2z24a4eq5un5tlwbc4izfapcvvtrlhkmz43au",
    "width": 133,
    "height": 144,
    "format": "png"
  },
  "infoURL": "https://stabilityprotocol.com",
  "name": "Global Trust Network",
  "nativeCurrency": {
    "name": "FREE",
    "symbol": "FREE",
    "decimals": 18
  },
  "networkId": 101010,
  "redFlags": ["reusedChainId"],
  "rpc": ["https://101010.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://gtn.stabilityprotocol.com"],
  "shortName": "stabilityprotocol",
  "slug": "global-trust-network",
  "testnet": false
};

var c102031 = {
  "chain": "CTC",
  "chainId": 102031,
  "explorers": [{
    "name": "blockscout",
    "url": "https://creditcoin-testnet.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmTfecECALDCy51zwVbXBSXb6TokqowCYzVLv65etahLxX",
    "width": 1024,
    "height": 1024,
    "format": "png"
  },
  "infoURL": "https://creditcoin.org",
  "name": "Creditcoin Testnet",
  "nativeCurrency": {
    "name": "Testnet CTC",
    "symbol": "tCTC",
    "decimals": 18
  },
  "networkId": 102031,
  "rpc": ["https://102031.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.cc3-testnet.creditcoin.network"],
  "shortName": "ctctest",
  "slug": "creditcoin-testnet",
  "testnet": true
};

var c103090 = {
  "chain": "crystal",
  "chainId": 103090,
  "explorers": [{
    "name": "blockscout",
    "url": "https://scan.crystaleum.org",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://Qmbry1Uc6HnXmqFNXW5dFJ7To8EezCCjNr4TqqvAyzXS4h",
      "width": 150,
      "height": 150,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmbry1Uc6HnXmqFNXW5dFJ7To8EezCCjNr4TqqvAyzXS4h",
    "width": 150,
    "height": 150,
    "format": "png"
  },
  "infoURL": "https://crystaleum.org",
  "name": "Crystaleum",
  "nativeCurrency": {
    "name": "CRFI",
    "symbol": "◈",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://103090.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm.cryptocurrencydevs.org", "https://rpc.crystaleum.org"],
  "shortName": "CRFI",
  "slug": "crystaleum",
  "testnet": false
};

var c103454 = {
  "chain": "Avalanche",
  "chainId": 103454,
  "explorers": [{
    "name": "Masa Testnet Explorer",
    "url": "https://subnets-test.avax.network/masatestnet",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Masa Testnet",
  "nativeCurrency": {
    "name": "Masa Testnet Token",
    "symbol": "tMASA",
    "decimals": 18
  },
  "networkId": 103454,
  "redFlags": [],
  "rpc": ["https://103454.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/masatestne/testnet/rpc"],
  "shortName": "Masa Testnet",
  "slug": "masa-testnet",
  "testnet": true
};

var c105105 = {
  "chain": "Stratis",
  "chainId": 105105,
  "explorers": [{
    "name": "Stratis Explorer",
    "url": "https://explorer.stratisevm.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmWiRBqfzoZ3GC7oCbYFqbwLyF4uDHM4eYdKUUJ7LHf2EA",
    "width": 59,
    "height": 55,
    "format": "svg"
  },
  "infoURL": "https://www.stratisplatform.com",
  "name": "Stratis Mainnet",
  "nativeCurrency": {
    "name": "Stratis",
    "symbol": "STRAX",
    "decimals": 18
  },
  "networkId": 105105,
  "rpc": ["https://105105.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.stratisevm.com"],
  "shortName": "stratis",
  "slug": "stratis",
  "testnet": false
};

var c108801 = {
  "chain": "BRO",
  "chainId": 108801,
  "explorers": [{
    "name": "BROChain Explorer",
    "url": "https://explorer.brochain.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://brochain.org",
  "name": "BROChain Mainnet",
  "nativeCurrency": {
    "name": "Brother",
    "symbol": "BRO",
    "decimals": 18
  },
  "networkId": 108801,
  "rpc": ["https://108801.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.brochain.org", "http://rpc.brochain.org", "https://rpc.brochain.org/mainnet", "http://rpc.brochain.org/mainnet"],
  "shortName": "bro",
  "slug": "brochain",
  "testnet": false
};

var c110000 = {
  "chain": "QuarkChain",
  "chainId": 110000,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Devnet Root",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 110000,
  "rpc": ["https://110000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://jrpc.devnet.quarkchain.io:38391"],
  "shortName": "qkc-d-r",
  "slug": "quarkchain-devnet-root",
  "testnet": false
};

var c110001 = {
  "chain": "QuarkChain",
  "chainId": 110001,
  "explorers": [{
    "name": "quarkchain-devnet",
    "url": "https://devnet.quarkchain.io/0",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Devnet Shard 0",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 110001,
  "parent": {
    "type": "shard",
    "chain": "eip155-110000"
  },
  "rpc": ["https://110001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnet-s0-ethapi.quarkchain.io", "http://eth-jrpc.devnet.quarkchain.io:39900"],
  "shortName": "qkc-d-s0",
  "slug": "quarkchain-devnet-shard-0",
  "testnet": false
};

var c110002 = {
  "chain": "QuarkChain",
  "chainId": 110002,
  "explorers": [{
    "name": "quarkchain-devnet",
    "url": "https://devnet.quarkchain.io/1",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Devnet Shard 1",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 110002,
  "parent": {
    "type": "shard",
    "chain": "eip155-110000"
  },
  "rpc": ["https://110002.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnet-s1-ethapi.quarkchain.io", "http://eth-jrpc.devnet.quarkchain.io:39901"],
  "shortName": "qkc-d-s1",
  "slug": "quarkchain-devnet-shard-1",
  "testnet": false
};

var c110003 = {
  "chain": "QuarkChain",
  "chainId": 110003,
  "explorers": [{
    "name": "quarkchain-devnet",
    "url": "https://devnet.quarkchain.io/2",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Devnet Shard 2",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 110003,
  "parent": {
    "type": "shard",
    "chain": "eip155-110000"
  },
  "rpc": ["https://110003.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnet-s2-ethapi.quarkchain.io", "http://eth-jrpc.devnet.quarkchain.io:39902"],
  "shortName": "qkc-d-s2",
  "slug": "quarkchain-devnet-shard-2",
  "testnet": false
};

var c110004 = {
  "chain": "QuarkChain",
  "chainId": 110004,
  "explorers": [{
    "name": "quarkchain-devnet",
    "url": "https://devnet.quarkchain.io/3",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Devnet Shard 3",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 110004,
  "parent": {
    "type": "shard",
    "chain": "eip155-110000"
  },
  "rpc": ["https://110004.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnet-s3-ethapi.quarkchain.io", "http://eth-jrpc.devnet.quarkchain.io:39903"],
  "shortName": "qkc-d-s3",
  "slug": "quarkchain-devnet-shard-3",
  "testnet": false
};

var c110005 = {
  "chain": "QuarkChain",
  "chainId": 110005,
  "explorers": [{
    "name": "quarkchain-devnet",
    "url": "https://devnet.quarkchain.io/4",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Devnet Shard 4",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 110005,
  "parent": {
    "type": "shard",
    "chain": "eip155-110000"
  },
  "rpc": ["https://110005.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnet-s4-ethapi.quarkchain.io", "http://eth-jrpc.devnet.quarkchain.io:39904"],
  "shortName": "qkc-d-s4",
  "slug": "quarkchain-devnet-shard-4",
  "testnet": false
};

var c110006 = {
  "chain": "QuarkChain",
  "chainId": 110006,
  "explorers": [{
    "name": "quarkchain-devnet",
    "url": "https://devnet.quarkchain.io/5",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Devnet Shard 5",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 110006,
  "parent": {
    "type": "shard",
    "chain": "eip155-110000"
  },
  "rpc": ["https://110006.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnet-s5-ethapi.quarkchain.io", "http://eth-jrpc.devnet.quarkchain.io:39905"],
  "shortName": "qkc-d-s5",
  "slug": "quarkchain-devnet-shard-5",
  "testnet": false
};

var c110007 = {
  "chain": "QuarkChain",
  "chainId": 110007,
  "explorers": [{
    "name": "quarkchain-devnet",
    "url": "https://devnet.quarkchain.io/6",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Devnet Shard 6",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 110007,
  "parent": {
    "type": "shard",
    "chain": "eip155-110000"
  },
  "rpc": ["https://110007.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnet-s6-ethapi.quarkchain.io", "http://eth-jrpc.devnet.quarkchain.io:39906"],
  "shortName": "qkc-d-s6",
  "slug": "quarkchain-devnet-shard-6",
  "testnet": false
};

var c110008 = {
  "chain": "QuarkChain",
  "chainId": 110008,
  "explorers": [{
    "name": "quarkchain-devnet",
    "url": "https://devnet.quarkchain.io/7",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.quarkchain.io",
  "name": "QuarkChain Devnet Shard 7",
  "nativeCurrency": {
    "name": "QKC",
    "symbol": "QKC",
    "decimals": 18
  },
  "networkId": 110008,
  "parent": {
    "type": "shard",
    "chain": "eip155-110000"
  },
  "rpc": ["https://110008.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnet-s7-ethapi.quarkchain.io", "http://eth-jrpc.devnet.quarkchain.io:39907"],
  "shortName": "qkc-d-s7",
  "slug": "quarkchain-devnet-shard-7",
  "testnet": false
};

var c111000 = {
  "chain": "SBR",
  "chainId": 111000,
  "explorers": [{
    "name": "Siberium Testnet Explorer - blockscout",
    "url": "https://explorer.test.siberium.net",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYeMdWDZ1iaBFeSPorRyPi7RuSXTdDKTgW3rfnUf3W5ne",
      "width": 512,
      "height": 512,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYeMdWDZ1iaBFeSPorRyPi7RuSXTdDKTgW3rfnUf3W5ne",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://siberium.net",
  "name": "Siberium Test Network",
  "nativeCurrency": {
    "name": "TestSIBR",
    "symbol": "SIBR",
    "decimals": 18
  },
  "networkId": 111000,
  "rpc": ["https://111000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.test.siberium.net"],
  "shortName": "testsbr",
  "slip44": 1,
  "slug": "siberium-test-network",
  "testnet": true
};

var c111111 = {
  "chain": "SBR",
  "chainId": 111111,
  "explorers": [{
    "name": "Siberium Mainnet Explorer - blockscout - 2",
    "url": "https://explorer.main.siberium.net.ru",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYeMdWDZ1iaBFeSPorRyPi7RuSXTdDKTgW3rfnUf3W5ne",
      "width": 512,
      "height": 512,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYeMdWDZ1iaBFeSPorRyPi7RuSXTdDKTgW3rfnUf3W5ne",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://siberium.net",
  "name": "Siberium Network",
  "nativeCurrency": {
    "name": "Siberium",
    "symbol": "SIBR",
    "decimals": 18
  },
  "networkId": 111111,
  "rpc": ["https://111111.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.main.siberium.net", "https://rpc.main.siberium.net.ru"],
  "shortName": "sbr",
  "slug": "siberium-network",
  "testnet": false
};

var c111188 = {
  "chain": "re.al",
  "chainId": 111188,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.re.al",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmNUmWC7jNEBcTs6ZqkrQ5vMAQG8qjq7n3FcZnXvJZLoQ9",
      "width": 301,
      "height": 302,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNUmWC7jNEBcTs6ZqkrQ5vMAQG8qjq7n3FcZnXvJZLoQ9",
    "width": 301,
    "height": 302,
    "format": "png"
  },
  "infoURL": "https://re.al",
  "name": "re.al",
  "nativeCurrency": {
    "name": "re.al Ether",
    "symbol": "reETH",
    "decimals": 18
  },
  "networkId": 111188,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://re.al/bridge"
    }, {
      "url": "https://bridge.gelato.network/bridge/real"
    }]
  },
  "rpc": ["https://111188.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://real.drpc.org", "wss://real.drpc.org"],
  "shortName": "re-al",
  "slip44": 60,
  "slug": "re-al",
  "testnet": false,
  "title": "re.al Real-World Assets network"
};

var c112358 = {
  "chain": "METAO",
  "chainId": 112358,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.metachain.one",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmTmo2QAtX5PbhX96vewnvH4Vc5H83Ft2DJGi6tAqTcFij",
    "width": 1000,
    "height": 981,
    "format": "png"
  },
  "infoURL": "https://metachain.one",
  "name": "Metachain One Mainnet",
  "nativeCurrency": {
    "name": "Metao",
    "symbol": "METAO",
    "decimals": 18
  },
  "networkId": 112358,
  "rpc": ["https://112358.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.metachain.one", "https://rpc2.metachain.one"],
  "shortName": "metao",
  "slug": "metachain-one",
  "testnet": false
};

var c119139 = {
  "chain": "MetaDAP",
  "chainId": 119139,
  "explorers": [{
    "name": "MetaDAP Enterprise Testnet explorer",
    "url": "https://explorer.testnet.chain.metadap.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmcCFUTStKKJKfzTwrjfMFoVaPCMsvAvWXRdDkYMvCkEs3",
    "width": 800,
    "height": 800,
    "format": "svg"
  },
  "infoURL": "https://metadap.io/",
  "name": "MetaDAP Enterprise Testnet",
  "nativeCurrency": {
    "name": "DAP",
    "symbol": "DAP",
    "decimals": 18
  },
  "networkId": 119139,
  "rpc": ["https://119139.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.chain.metadap.io", "wss://rpc-ws.testnet.chain.metadap.io"],
  "shortName": "MetaDAP-T",
  "slug": "metadap-enterprise-testnet",
  "testnet": true,
  "title": "MetaDAP Enterprise Testnet"
};

var c123456 = {
  "chain": "ADIL",
  "chainId": 123456,
  "explorers": [{
    "name": "ADIL Devnet Explorer",
    "url": "https://devnet.adilchain-scan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeHNYUx6n8CjUFSLWNT17oAtDYrUq6r8buyvGCUBXCJw6",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://adilchain.io",
  "name": "ADIL Devnet",
  "nativeCurrency": {
    "name": "Devnet ADIL",
    "symbol": "ADIL",
    "decimals": 18
  },
  "networkId": 123456,
  "rpc": ["https://123456.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnet.adilchain-rpc.io"],
  "shortName": "dadil",
  "slug": "adil-devnet",
  "testnet": false
};

var c128123 = {
  "chain": "Etherlink",
  "chainId": 128123,
  "explorers": [{
    "name": "Etherlink Testnet Explorer",
    "url": "https://testnet-explorer.etherlink.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.etherlink.com"],
  "features": [{
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmVqE4wq3fd3RKZwo7GxmW333ywHgYBZGvqwh3TUBM5DUi",
    "width": 3600,
    "height": 3600,
    "format": "PNG"
  },
  "infoURL": "https://node.ghostnet.etherlink.com",
  "name": "Etherlink Testnet",
  "nativeCurrency": {
    "name": "tez",
    "symbol": "XTZ",
    "decimals": 18
  },
  "networkId": 128123,
  "parent": {
    "type": "Etherlink",
    "chain": "Etherlink",
    "bridges": []
  },
  "redFlags": [],
  "rpc": ["https://128123.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node.ghostnet.etherlink.com"],
  "shortName": "etlt",
  "slug": "etherlink-testnet",
  "testnet": true
};

var c131419 = {
  "chain": "ETND",
  "chainId": 131419,
  "explorers": [{
    "name": "etndscan",
    "url": "https://scan.etnd.pro",
    "standard": "none",
    "icon": {
      "url": "ipfs://Qmd26eRJxPb1jJg5Q4mC2M4kD9Jrs5vmcnr5LczHFMGwSD",
      "width": 128,
      "height": 128,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmd26eRJxPb1jJg5Q4mC2M4kD9Jrs5vmcnr5LczHFMGwSD",
    "width": 128,
    "height": 128,
    "format": "png"
  },
  "infoURL": "https://www.etnd.pro",
  "name": "ETND Chain Mainnets",
  "nativeCurrency": {
    "name": "ETND",
    "symbol": "ETND",
    "decimals": 18
  },
  "networkId": 131419,
  "rpc": ["https://131419.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.node1.etnd.pro/"],
  "shortName": "ETND",
  "slug": "etnd-chain-s",
  "testnet": false
};

var c132902 = {
  "chain": "Form",
  "chainId": 132902,
  "explorers": [],
  "faucets": ["https://info.form.network/faucet"],
  "features": [],
  "icon": {
    "url": "ipfs://bafkreif6anuffunp3le26jsyemdrg4ydf2abensokw4qnlgvg5nc43zqbi",
    "width": 3600,
    "height": 3600,
    "format": "PNG"
  },
  "infoURL": "https://info.form.network",
  "name": "Form Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 132902,
  "parent": {
    "type": "Optimism",
    "chain": "Optimism",
    "bridges": []
  },
  "redFlags": [],
  "rpc": ["https://132902.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.form.network/http"],
  "shortName": "Form",
  "slug": "form-testnet",
  "testnet": true,
  "title": "https://explorer.form.network/"
};

var c141221 = {
  "chain": "Avalanche",
  "chainId": 141221,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Xantus Testnet",
  "nativeCurrency": {
    "name": "Xantus Testnet Token",
    "symbol": "XAN",
    "decimals": 18
  },
  "networkId": 141221,
  "redFlags": [],
  "rpc": ["https://141221.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/xantustest/testnet/rpc"],
  "shortName": "Xantus Testnet",
  "slug": "xantus-testnet",
  "testnet": true
};

var c142857 = {
  "chain": "ICPlaza",
  "chainId": 142857,
  "explorers": [{
    "name": "ICPlaza",
    "url": "https://browsemainnet.ic-plaza.org/index",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQpKKwpqrx77VA4SJLEWhuv9eLFMcVV9uvxRCLb6gdgCX",
    "width": 847,
    "height": 906,
    "format": "png"
  },
  "infoURL": "https://docs.ic-plaza.org/",
  "name": "ICPlaza Mainnet",
  "nativeCurrency": {
    "name": "ict",
    "symbol": "ict",
    "decimals": 18
  },
  "networkId": 142857,
  "rpc": ["https://142857.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpcmainnet.ic-plaza.org/"],
  "shortName": "ICPlaza",
  "slug": "icplaza",
  "testnet": false
};

var c151221 = {
  "chain": "Avalanche",
  "chainId": 151221,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Xantus",
  "nativeCurrency": {
    "name": "Xantus Token",
    "symbol": "XAN",
    "decimals": 18
  },
  "networkId": 151221,
  "redFlags": [],
  "rpc": ["https://151221.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/xantus/testnet/rpc"],
  "shortName": "Xantus",
  "slug": "xantus",
  "testnet": true
};

var c167004 = {
  "chain": "ETH",
  "chainId": 167004,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.a2.taiko.xyz",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmcHdmVr5VRUJq13jnM6tgah5Ge7hn3Dm14eY6vwivJ5ui",
    "width": 288,
    "height": 258,
    "format": "png"
  },
  "infoURL": "https://taiko.xyz",
  "name": "Taiko (Alpha-2 Testnet)",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 167004,
  "rpc": ["https://167004.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.a2.taiko.xyz"],
  "shortName": "taiko-a2",
  "slip44": 1,
  "slug": "taiko-alpha-2-testnet",
  "status": "deprecated",
  "testnet": true
};

var c167008 = {
  "chain": "ETH",
  "chainId": 167008,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.katla.taiko.xyz",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmcHdmVr5VRUJq13jnM6tgah5Ge7hn3Dm14eY6vwivJ5ui",
    "width": 288,
    "height": 258,
    "format": "png"
  },
  "infoURL": "https://taiko.xyz",
  "name": "Taiko Katla L2",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 167008,
  "redFlags": [],
  "rpc": ["https://167008.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.katla.taiko.xyz", "wss://rpc.katla.taiko.xyz", "https://taiko-katla.drpc.org", "wss://taiko-katla.drpc.org"],
  "shortName": "tko-katla",
  "slug": "taiko-katla-l2",
  "status": "active",
  "testnet": true
};

var c167009 = {
  "chain": "ETH",
  "chainId": 167009,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockscoutapi.hekla.taiko.xyz",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmcHdmVr5VRUJq13jnM6tgah5Ge7hn3Dm14eY6vwivJ5ui",
    "width": 288,
    "height": 258,
    "format": "png"
  },
  "infoURL": "https://taiko.xyz",
  "name": "Taiko Hekla L2",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 167009,
  "rpc": ["https://167009.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.hekla.taiko.xyz", "wss://ws.hekla.taiko.xyz"],
  "shortName": "tko-hekla",
  "slug": "taiko-hekla-l2",
  "status": "active",
  "testnet": false
};

var c188710 = {
  "chain": "BDCC",
  "chainId": 188710,
  "explorers": [{
    "name": "Bitica DPOS Blockchain Explorer",
    "url": "https://biticablockchain.com",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://biticablockchain.com/",
  "name": "Bitica Chain Mainnet",
  "nativeCurrency": {
    "name": "Bitica Coin",
    "symbol": "BDCC",
    "decimals": 18
  },
  "networkId": 188710,
  "rpc": ["https://188710.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.biticablockchain.com/"],
  "shortName": "bdcc",
  "slug": "bitica-chain",
  "testnet": false
};

var c188881 = {
  "chain": "CONDOR",
  "chainId": 188881,
  "explorers": [{
    "name": "CondorScan",
    "url": "https://explorer.condor.systems",
    "standard": "none"
  }],
  "faucets": ["https://faucet.condor.systems"],
  "icon": {
    "url": "ipfs://QmPRDuEJSTqp2cDUvWCp71Wns6XV8nvdeAVKWH6srpk4xM",
    "width": 752,
    "height": 752,
    "format": "png"
  },
  "infoURL": "https://condor.systems",
  "name": "Condor Test Network",
  "nativeCurrency": {
    "name": "Condor Native Token",
    "symbol": "CONDOR",
    "decimals": 18
  },
  "networkId": 188881,
  "rpc": ["https://188881.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.condor.systems/rpc"],
  "shortName": "condor",
  "slip44": 1,
  "slug": "condor-test-network",
  "testnet": true
};

var c200101 = {
  "chain": "milkTAda",
  "chainId": 200101,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://explorer-devnet-cardano-evm.c1.milkomeda.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdoUtvHDybu5ppYBZT8BMRp6AqByVSoQs8nFwKbaS55jd",
    "width": 367,
    "height": 367,
    "format": "svg"
  },
  "infoURL": "https://milkomeda.com",
  "name": "Milkomeda C1 Testnet",
  "nativeCurrency": {
    "name": "milkTAda",
    "symbol": "mTAda",
    "decimals": 18
  },
  "networkId": 200101,
  "rpc": ["https://200101.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-devnet-cardano-evm.c1.milkomeda.com", "wss://rpc-devnet-cardano-evm.c1.milkomeda.com"],
  "shortName": "milkTAda",
  "slip44": 1,
  "slug": "milkomeda-c1-testnet",
  "testnet": true
};

var c200202 = {
  "chain": "milkTAlgo",
  "chainId": 200202,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://explorer-devnet-algorand-rollup.a1.milkomeda.com",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdoUtvHDybu5ppYBZT8BMRp6AqByVSoQs8nFwKbaS55jd",
    "width": 367,
    "height": 367,
    "format": "svg"
  },
  "infoURL": "https://milkomeda.com",
  "name": "Milkomeda A1 Testnet",
  "nativeCurrency": {
    "name": "milkTAlgo",
    "symbol": "mTAlgo",
    "decimals": 18
  },
  "networkId": 200202,
  "rpc": ["https://200202.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-devnet-algorand-rollup.a1.milkomeda.com"],
  "shortName": "milkTAlgo",
  "slip44": 1,
  "slug": "milkomeda-a1-testnet",
  "testnet": true
};

var c200625 = {
  "chain": "AKA",
  "chainId": 200625,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://akroma.io",
  "name": "Akroma",
  "nativeCurrency": {
    "name": "Akroma Ether",
    "symbol": "AKA",
    "decimals": 18
  },
  "networkId": 200625,
  "rpc": ["https://200625.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://remote.akroma.io"],
  "shortName": "aka",
  "slip44": 200625,
  "slug": "akroma",
  "testnet": false
};

var c200810 = {
  "chain": "Bitlayer",
  "chainId": 200810,
  "explorers": [{
    "name": "bitlayer testnet scan",
    "url": "https://testnet-scan.bitlayer.org",
    "standard": "none"
  }],
  "faucets": ["https://www.bitlayer.org/faucet"],
  "icon": {
    "url": "ipfs://QmdWZ1frB47fr3tw31xE68C2Vocaw5Ef53LQ5WDNdNnNyG",
    "width": 4500,
    "height": 4500,
    "format": "jpg"
  },
  "infoURL": "https://docs.bitlayer.org/",
  "name": "Bitlayer Testnet",
  "nativeCurrency": {
    "name": "BTC",
    "symbol": "BTC",
    "decimals": 18
  },
  "networkId": 200810,
  "rpc": ["https://200810.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.bitlayer.org", "wss://testnet-ws.bitlayer.org", "https://testnet-rpc.bitlayer-rpc.com", "wss://testnet-ws.bitlayer-rpc.com", "https://rpc.ankr.com/bitlayer_testnet"],
  "shortName": "btrt",
  "slip44": 1,
  "slug": "bitlayer-testnet",
  "testnet": true
};

var c200901 = {
  "chain": "Bitlayer",
  "chainId": 200901,
  "explorers": [{
    "name": "bitlayer mainnet scan",
    "url": "https://www.btrscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdWZ1frB47fr3tw31xE68C2Vocaw5Ef53LQ5WDNdNnNyG",
    "width": 4500,
    "height": 4500,
    "format": "jpg"
  },
  "infoURL": "https://docs.bitlayer.org/",
  "name": "Bitlayer Mainnet",
  "nativeCurrency": {
    "name": "BTC",
    "symbol": "BTC",
    "decimals": 18
  },
  "networkId": 200901,
  "rpc": ["https://200901.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.bitlayer.org", "https://rpc.bitlayer-rpc.com", "https://rpc.ankr.com/bitlayer", "wss://ws.bitlayer.org", "wss://ws.bitlayer-rpc.com"],
  "shortName": "btr",
  "slip44": 1,
  "slug": "bitlayer",
  "testnet": false
};

var c201018 = {
  "chain": "Alaya",
  "chainId": 201018,
  "explorers": [{
    "name": "alaya explorer",
    "url": "https://scan.alaya.network",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmci6vPcWAwmq19j98yuQxjV6UPzHtThMdCAUDbKeb8oYu",
    "width": 1140,
    "height": 1140,
    "format": "png"
  },
  "infoURL": "https://www.alaya.network/",
  "name": "Alaya Mainnet",
  "nativeCurrency": {
    "name": "ATP",
    "symbol": "atp",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://201018.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://openapi.alaya.network/rpc", "wss://openapi.alaya.network/ws"],
  "shortName": "alaya",
  "slug": "alaya",
  "testnet": false
};

var c201030 = {
  "chain": "Alaya",
  "chainId": 201030,
  "explorers": [{
    "name": "alaya explorer",
    "url": "https://devnetscan.alaya.network",
    "standard": "none"
  }],
  "faucets": ["https://faucet.alaya.network/faucet/?id=f93426c0887f11eb83b900163e06151c"],
  "icon": {
    "url": "ipfs://Qmci6vPcWAwmq19j98yuQxjV6UPzHtThMdCAUDbKeb8oYu",
    "width": 1140,
    "height": 1140,
    "format": "png"
  },
  "infoURL": "https://www.alaya.network/",
  "name": "Alaya Dev Testnet",
  "nativeCurrency": {
    "name": "ATP",
    "symbol": "atp",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://201030.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnetopenapi.alaya.network/rpc", "wss://devnetopenapi.alaya.network/ws"],
  "shortName": "alayadev",
  "slip44": 1,
  "slug": "alaya-dev-testnet",
  "testnet": true
};

var c201804 = {
  "chain": "MYTH",
  "chainId": 201804,
  "explorers": [{
    "name": "Mythical Chain Explorer",
    "url": "https://explorer.mythicalgames.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreihru6cccfblrjz5bv36znq2l3h67u6xj5ivtc4bj5l6gzofbgtnb4",
      "width": 350,
      "height": 350,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreihru6cccfblrjz5bv36znq2l3h67u6xj5ivtc4bj5l6gzofbgtnb4",
    "width": 350,
    "height": 350,
    "format": "png"
  },
  "infoURL": "https://mythicalgames.com/",
  "name": "Mythical Chain",
  "nativeCurrency": {
    "name": "Mythos",
    "symbol": "MYTH",
    "decimals": 18
  },
  "networkId": 201804,
  "rpc": ["https://201804.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://chain-rpc.mythicalgames.com"],
  "shortName": "myth",
  "slug": "mythical-chain",
  "testnet": false
};

var c202020 = {
  "chain": "tDSC",
  "chainId": 202020,
  "explorers": [{
    "name": "DSC Explorer Testnet",
    "url": "https://testnet.explorer.decimalchain.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmSgzwKnJJjys3Uq2aVVdwJ3NffLj3CXMVCph9uByTBegc",
      "width": 256,
      "height": 256,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmSgzwKnJJjys3Uq2aVVdwJ3NffLj3CXMVCph9uByTBegc",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://decimalchain.com",
  "name": "Decimal Smart Chain Testnet",
  "nativeCurrency": {
    "name": "Decimal",
    "symbol": "tDEL",
    "decimals": 18
  },
  "networkId": 202020,
  "rpc": ["https://202020.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-val.decimalchain.com/web3/"],
  "shortName": "tDSC",
  "slip44": 1,
  "slug": "decimal-smart-chain-testnet",
  "testnet": true
};

var c202212 = {
  "chain": "X1",
  "chainId": 202212,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://explorer.x1-devnet.xen.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "infoURL": "https://docs.xen.network/x1/",
  "name": "X1 Devnet",
  "nativeCurrency": {
    "name": "XN",
    "symbol": "XN",
    "decimals": 18
  },
  "networkId": 202212,
  "rpc": ["https://202212.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://x1-devnet.xen.network"],
  "shortName": "x1-devnet",
  "slug": "x1-devnet",
  "testnet": false
};

var c202401 = {
  "chain": "YMTECH-BESU",
  "chainId": 202401,
  "explorers": [{
    "name": "YMTECH-BESU Chainlens",
    "url": "http://39.119.118.198",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.ymtech.co.kr",
  "name": "YMTECH-BESU Testnet",
  "nativeCurrency": {
    "name": "ETH",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 202401,
  "rpc": ["https://202401.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://39.119.118.216:8545"],
  "shortName": "YMTECH-BESU",
  "slug": "ymtech-besu-testnet",
  "testnet": true
};

var c202624 = {
  "chain": "ETH",
  "chainId": 202624,
  "explorers": [{
    "name": "Jellie Blockchain Explorer",
    "url": "https://jellie.twala.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmTXJVhVKvVC7DQEnGKXvydvwpvVaUEBJrMHvsCr4nr1sK",
      "width": 1326,
      "height": 1265,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmTXJVhVKvVC7DQEnGKXvydvwpvVaUEBJrMHvsCr4nr1sK",
    "width": 1326,
    "height": 1265,
    "format": "png"
  },
  "infoURL": "https://twala.io/",
  "name": "Jellie",
  "nativeCurrency": {
    "name": "Twala Coin",
    "symbol": "TWL",
    "decimals": 18
  },
  "networkId": 202624,
  "rpc": ["https://202624.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://jellie-rpc.twala.io/", "wss://jellie-rpc-wss.twala.io/"],
  "shortName": "twl-jellie",
  "slip44": 1,
  "slug": "jellie",
  "testnet": true,
  "title": "Twala Testnet Jellie"
};

var c204005 = {
  "chain": "X1",
  "chainId": 204005,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://explorer.x1-testnet.xen.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "infoURL": "https://docs.xen.network/go-x1/",
  "name": "X1 Network",
  "nativeCurrency": {
    "name": "XN",
    "symbol": "XN",
    "decimals": 18
  },
  "networkId": 204005,
  "rpc": ["https://204005.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://x1-testnet.xen.network"],
  "shortName": "x1-testnet",
  "slug": "x1-network",
  "testnet": true
};

var c205205 = {
  "chain": "Auroria",
  "chainId": 205205,
  "explorers": [{
    "name": "Auroria Testnet Explorer",
    "url": "https://auroria.explorer.stratisevm.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://auroria.faucet.stratisevm.com"],
  "icon": {
    "url": "ipfs://QmbkTh6qNYUnae5yNjied3qZqVyZcb4x3hfUpJ33bGg9QY",
    "width": 800,
    "height": 800,
    "format": "jpg"
  },
  "infoURL": "https://www.stratisplatform.com",
  "name": "Auroria Testnet",
  "nativeCurrency": {
    "name": "Auroria Stratis",
    "symbol": "tSTRAX",
    "decimals": 18
  },
  "networkId": 205205,
  "rpc": ["https://205205.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://auroria.rpc.stratisevm.com"],
  "shortName": "auroria",
  "slug": "auroria-testnet",
  "testnet": true,
  "title": "Stratis Testnet Auroria"
};

var c210425 = {
  "chain": "PlatON",
  "chainId": 210425,
  "explorers": [{
    "name": "PlatON explorer",
    "url": "https://scan.platon.network",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmT7PSXBiVBma6E15hNkivmstqLu3JSnG1jXN5pTmcCGRC",
    "width": 180,
    "height": 180,
    "format": "png"
  },
  "infoURL": "https://www.platon.network",
  "name": "PlatON Mainnet",
  "nativeCurrency": {
    "name": "LAT",
    "symbol": "lat",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://210425.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://openapi2.platon.network/rpc", "wss://openapi2.platon.network/ws"],
  "shortName": "platon",
  "slug": "platon",
  "testnet": false
};

var c210815 = {
  "chain": "Avalanche",
  "chainId": 210815,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Stavax Testnet",
  "nativeCurrency": {
    "name": "Stavax Testnet Token",
    "symbol": "STA",
    "decimals": 18
  },
  "networkId": 210815,
  "redFlags": [],
  "rpc": ["https://210815.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/stavaxtest/testnet/rpc"],
  "shortName": "Stavax Testnet",
  "slug": "stavax-testnet",
  "testnet": true
};

var c220315 = {
  "chain": "MAS",
  "chainId": 220315,
  "explorers": [{
    "name": "explorer masnet",
    "url": "https://explorer.masnet.ai",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmZ9njQhhKkpJKGnoYy6XTuDtk5CYiDFUd8atqWthqUT3Q",
    "width": 1024,
    "height": 1024,
    "format": "png"
  },
  "infoURL": "https://masterbank.org",
  "name": "Mas Mainnet",
  "nativeCurrency": {
    "name": "Master Bank",
    "symbol": "MAS",
    "decimals": 18
  },
  "networkId": 220315,
  "rpc": ["https://220315.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://node.masnet.ai:8545"],
  "shortName": "mas",
  "slug": "mas",
  "testnet": false
};

var c221230 = {
  "chain": "REAP",
  "chainId": 221230,
  "explorers": [{
    "name": "Reapchain Dashboard",
    "url": "https://dashboard.reapchain.org",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmevQ8jmDWHmdnUQg6BpoMwVB3NhpzS75adbMnKL78Ls2h",
      "width": 256,
      "height": 256,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmevQ8jmDWHmdnUQg6BpoMwVB3NhpzS75adbMnKL78Ls2h",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://reapchain.com",
  "name": "Reapchain Mainnet",
  "nativeCurrency": {
    "name": "Reap",
    "symbol": "REAP",
    "decimals": 18
  },
  "networkId": 221230,
  "rpc": ["https://221230.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://eth.reapchain.org"],
  "shortName": "reap",
  "slug": "reapchain",
  "testnet": false
};

var c221231 = {
  "chain": "REAP",
  "chainId": 221231,
  "explorers": [{
    "name": "Reapchain Testnet Dashboard",
    "url": "https://test-dashboard.reapchain.org",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmevQ8jmDWHmdnUQg6BpoMwVB3NhpzS75adbMnKL78Ls2h",
      "width": 256,
      "height": 256,
      "format": "png"
    }
  }],
  "faucets": ["http://faucet.reapchain.com"],
  "features": [],
  "icon": {
    "url": "ipfs://QmevQ8jmDWHmdnUQg6BpoMwVB3NhpzS75adbMnKL78Ls2h",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://reapchain.com",
  "name": "Reapchain Testnet",
  "nativeCurrency": {
    "name": "test-Reap",
    "symbol": "tREAP",
    "decimals": 18
  },
  "networkId": 221231,
  "rpc": ["https://221231.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://test-eth.reapchain.org"],
  "shortName": "reap-testnet",
  "slip44": 1,
  "slug": "reapchain-testnet",
  "testnet": true
};

var c222555 = {
  "chain": "DEEPL",
  "chainId": 222555,
  "explorers": [{
    "name": "DeepL Mainnet Explorer",
    "url": "https://scan.deeplnetwork.org",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafybeihjwgy4qja5cee452malk5hpb25pzpipfaka7hjcyb437ldodxzaq",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafybeihjwgy4qja5cee452malk5hpb25pzpipfaka7hjcyb437ldodxzaq",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://deeplnetwork.org",
  "name": "DeepL Mainnet",
  "nativeCurrency": {
    "name": "DeepL",
    "symbol": "DEEPL",
    "decimals": 18
  },
  "networkId": 222555,
  "rpc": ["https://222555.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.deeplnetwork.org"],
  "shortName": "deepl",
  "slug": "deepl",
  "testnet": false
};

var c222666 = {
  "chain": "DEEPL",
  "chainId": 222666,
  "explorers": [{
    "name": "DeepL Testnet Explorer",
    "url": "https://testnet-scan.deeplnetwork.org",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafybeihjwgy4qja5cee452malk5hpb25pzpipfaka7hjcyb437ldodxzaq",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.deeplnetwork.org"],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafybeihjwgy4qja5cee452malk5hpb25pzpipfaka7hjcyb437ldodxzaq",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://deeplnetwork.org",
  "name": "DeepL Testnet",
  "nativeCurrency": {
    "name": "DeepL",
    "symbol": "DEEPL",
    "decimals": 18
  },
  "networkId": 222666,
  "rpc": ["https://222666.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.deeplnetwork.org"],
  "shortName": "tdeepl",
  "slug": "deepl-testnet",
  "testnet": true
};

var c224168 = {
  "chain": "Taf ECO Chain",
  "chainId": 224168,
  "explorers": [{
    "name": "Taf ECO Chain Mainnet",
    "url": "https://ecoscan.tafchain.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreigpxhu7glccsislhjqpl5fnsfmj2io4cy33blhky642uiuyojossy",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://www.tafchain.com",
  "name": "Taf ECO Chain Mainnet",
  "nativeCurrency": {
    "name": "Taf ECO Chain Mainnet",
    "symbol": "TAFECO",
    "decimals": 18
  },
  "networkId": 224168,
  "rpc": ["https://224168.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.tafchain.com/v1"],
  "shortName": "TAFECO",
  "slug": "taf-eco-chain",
  "testnet": false
};

var c224422 = {
  "chain": "CONET",
  "chainId": 224422,
  "explorers": [{
    "name": "CONET Scan",
    "url": "https://scan.conet.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://bafkreibjxqd5kqcc2shstjjujvxzg6cwegwr6dgjyyd56v6h7yusgks7sy",
    "width": 1200,
    "height": 1200,
    "format": "png"
  },
  "infoURL": "https://conet.network",
  "name": "CONET Sebolia Testnet",
  "nativeCurrency": {
    "name": "CONET Sebolia",
    "symbol": "CONET",
    "decimals": 18
  },
  "networkId": 224422,
  "rpc": ["https://224422.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc1.conet.network"],
  "shortName": "conet-sebolia",
  "slip44": 1,
  "slug": "conet-sebolia-testnet",
  "testnet": true
};

var c224433 = {
  "chain": "CONET Holesky",
  "chainId": 224433,
  "explorers": [{
    "name": "CONET Holesky Scan",
    "url": "https://scan.conet.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://bafkreibjxqd5kqcc2shstjjujvxzg6cwegwr6dgjyyd56v6h7yusgks7sy",
    "width": 1200,
    "height": 1200,
    "format": "png"
  },
  "infoURL": "https://conet.network",
  "name": "CONET Holesky",
  "nativeCurrency": {
    "name": "CONET Holesky",
    "symbol": "CONET",
    "decimals": 18
  },
  "networkId": 224433,
  "rpc": ["https://224433.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://holeskyrpc1.conet.network"],
  "shortName": "conet-holesky",
  "slip44": 2147708081,
  "slug": "conet-holesky",
  "testnet": false
};

var c230315 = {
  "chain": "HashKey",
  "chainId": 230315,
  "explorers": [{
    "name": "HashKey Chain Testnet Explorer",
    "url": "https://testnet.hashkeyscan.io",
    "standard": "none"
  }],
  "faucets": ["https://testnet.hashkeychain/faucet"],
  "icon": {
    "url": "ipfs://QmNU11AqYB2htrrSyBSP9ct7bPtuZTP7Hrz21PrEcB9nYE",
    "width": 1440,
    "height": 448,
    "format": "png"
  },
  "infoURL": "https://www.hashkey.com",
  "name": "HashKey Chain Testnet",
  "nativeCurrency": {
    "name": "HashKey Token",
    "symbol": "tHSK",
    "decimals": 18
  },
  "networkId": 230315,
  "rpc": ["https://230315.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.hashkeychain/rpc"],
  "shortName": "hsktest",
  "slip44": 1,
  "slug": "hashkey-chain-testnet",
  "testnet": true
};

var c234560 = {
  "chain": "Avalanche",
  "chainId": 234560,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Project Orc",
  "nativeCurrency": {
    "name": "Project Orc Token",
    "symbol": "STX",
    "decimals": 18
  },
  "networkId": 234560,
  "redFlags": [],
  "rpc": ["https://234560.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/projectorc/testnet/rpc"],
  "shortName": "Project Orc",
  "slug": "project-orc",
  "testnet": true
};

var c234666 = {
  "chain": "tHYM",
  "chainId": 234666,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://haymoswap.web.app/",
  "name": "Haymo Testnet",
  "nativeCurrency": {
    "name": "HAYMO",
    "symbol": "HYM",
    "decimals": 18
  },
  "networkId": 234666,
  "rpc": ["https://234666.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet1.haymo.network"],
  "shortName": "hym",
  "slip44": 1,
  "slug": "haymo-testnet",
  "testnet": true
};

var c246529 = {
  "chain": "ARTIS",
  "chainId": 246529,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://artis.eco",
  "name": "ARTIS sigma1",
  "nativeCurrency": {
    "name": "ARTIS sigma1 Ether",
    "symbol": "ATS",
    "decimals": 18
  },
  "networkId": 246529,
  "rpc": ["https://246529.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.sigma1.artis.network"],
  "shortName": "ats",
  "slip44": 246529,
  "slug": "artis-sigma1",
  "testnet": false
};

var c246785 = {
  "chain": "ARTIS",
  "chainId": 246785,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://artis.network",
  "name": "ARTIS Testnet tau1",
  "nativeCurrency": {
    "name": "ARTIS tau1 Ether",
    "symbol": "tATS",
    "decimals": 18
  },
  "networkId": 246785,
  "rpc": ["https://246785.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.tau1.artis.network"],
  "shortName": "atstau",
  "slip44": 1,
  "slug": "artis-testnet-tau1",
  "testnet": true
};

var c247253 = {
  "chain": "Saakuru",
  "chainId": 247253,
  "explorers": [{
    "name": "saakuru-explorer-testnet",
    "url": "https://explorer-testnet.saakuru.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmduEdtFobPpZWSc45MU6RKxZfTEzLux2z8ikHFhT8usqv",
    "width": 1024,
    "height": 1024,
    "format": "png"
  },
  "infoURL": "https://saakuru.network",
  "name": "Saakuru Testnet",
  "nativeCurrency": {
    "name": "OAS",
    "symbol": "OAS",
    "decimals": 18
  },
  "networkId": 247253,
  "rpc": ["https://247253.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.saakuru.network"],
  "shortName": "saakuru-testnet",
  "slip44": 1,
  "slug": "saakuru-testnet",
  "testnet": true
};

var c256256 = {
  "chain": "CMP",
  "chainId": 256256,
  "explorers": [{
    "name": "Mainnet Scan",
    "url": "https://mainnet.scan.caduceus.foundation",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://caduceus.foundation/",
  "name": "CMP-Mainnet",
  "nativeCurrency": {
    "name": "Caduceus Token",
    "symbol": "CMP",
    "decimals": 18
  },
  "networkId": 256256,
  "rpc": ["https://256256.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.block.caduceus.foundation", "wss://mainnet.block.caduceus.foundation"],
  "shortName": "cmp-mainnet",
  "slug": "cmp",
  "testnet": false
};

var c266256 = {
  "chain": "GearZero",
  "chainId": 266256,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://token.gearzero.ca/testnet",
  "name": "Gear Zero Network Testnet",
  "nativeCurrency": {
    "name": "Gear Zero Network Native Token",
    "symbol": "GZN",
    "decimals": 18
  },
  "networkId": 266256,
  "rpc": ["https://266256.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://gzn-test.linksme.info"],
  "shortName": "gz-testnet",
  "slip44": 1,
  "slug": "gear-zero-network-testnet",
  "testnet": true
};

var c271271 = {
  "chain": "EGON",
  "chainId": 271271,
  "explorers": [{
    "name": "EgonCoin Testnet",
    "url": "https://testnet.egonscan.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.egonscan.com"],
  "icon": {
    "url": "ipfs://QmNZiMmzMQYjyGtNSghtzLg4UooYhDgMQsa677DAP5KsBg",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://egonscan.com",
  "name": "EgonCoin Testnet",
  "nativeCurrency": {
    "name": "EgonCoin",
    "symbol": "EGON",
    "decimals": 18
  },
  "networkId": 271271,
  "rpc": ["https://271271.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpctest.egonscan.com"],
  "shortName": "EGONt",
  "slip44": 1,
  "slug": "egoncoin-testnet",
  "testnet": true
};

var c281121 = {
  "chain": "SoChain",
  "chainId": 281121,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://digitalnext.business/SocialSmartChain",
  "name": "Social Smart Chain Mainnet",
  "nativeCurrency": {
    "name": "SoChain",
    "symbol": "$OC",
    "decimals": 18
  },
  "networkId": 281121,
  "rpc": ["https://281121.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://socialsmartchain.digitalnext.business"],
  "shortName": "SoChain",
  "slug": "social-smart-chain",
  "testnet": false
};

var c282828 = {
  "chain": "ETH",
  "chainId": 282828,
  "explorers": [{
    "name": "zillscout",
    "url": "https://sepolia.zillnet.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmfVmjLNiBh8KyCr9mwDZh34aEhhQ2LAjuP87DFxhfd9nn",
      "width": 264,
      "height": 264,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmfVmjLNiBh8KyCr9mwDZh34aEhhQ2LAjuP87DFxhfd9nn",
    "width": 264,
    "height": 264,
    "format": "png"
  },
  "infoURL": "https://zillnet.io",
  "name": "Zillion Sepolia Testnet",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 282828,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111"
  },
  "rpc": ["https://282828.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sepolia.zillnet.io/rpc"],
  "shortName": "zillsep",
  "slip44": 1,
  "slug": "zillion-sepolia-testnet",
  "status": "active",
  "testnet": true
};

var c313313 = {
  "chain": "Sahara",
  "chainId": 313313,
  "explorers": [],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmQXCm6w8xvWMkksTQYw3So14VCbwHP6chH41v6ysXdSwF",
    "width": 608,
    "height": 608,
    "format": "svg"
  },
  "infoURL": "https://saharalabs.ai",
  "name": "SaharaAI Testnet",
  "nativeCurrency": {
    "name": "SAHARA",
    "symbol": "SAH",
    "decimals": 18
  },
  "networkId": 313313,
  "rpc": ["https://313313.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.saharalabs.ai"],
  "shortName": "saharatest",
  "slug": "saharaai-testnet",
  "testnet": true
};

var c314159 = {
  "chain": "FIL",
  "chainId": 314159,
  "explorers": [{
    "name": "Filscan - Calibration",
    "url": "https://calibration.filscan.io",
    "standard": "none"
  }, {
    "name": "Filscout - Calibration",
    "url": "https://calibration.filscout.com/en",
    "standard": "none"
  }, {
    "name": "Filfox - Calibration",
    "url": "https://calibration.filfox.info",
    "standard": "none"
  }, {
    "name": "Glif Explorer - Calibration",
    "url": "https://explorer.glif.io/?network=calibration",
    "standard": "none"
  }, {
    "name": "Beryx",
    "url": "https://beryx.zondax.ch",
    "standard": "none"
  }],
  "faucets": ["https://faucet.calibration.fildev.network/"],
  "icon": {
    "url": "ipfs://QmS9r9XQkMHVomWcSBNDkKkz9n87h9bH9ssabeiKZtANoU",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://filecoin.io",
  "name": "Filecoin - Calibration testnet",
  "nativeCurrency": {
    "name": "testnet filecoin",
    "symbol": "tFIL",
    "decimals": 18
  },
  "networkId": 314159,
  "rpc": ["https://314159.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.calibration.node.glif.io/rpc/v1", "https://rpc.ankr.com/filecoin_testnet", "https://filecoin-calibration.chainstacklabs.com/rpc/v1", "https://filecoin-calibration.chainup.net/rpc/v1", "https://calibration.filfox.info/rpc/v1", "https://filecoin-calibration.drpc.org", "wss://filecoin-calibration.drpc.org"],
  "shortName": "filecoin-calibration",
  "slip44": 1,
  "slug": "filecoin-calibration-testnet",
  "testnet": true
};

var c323213 = {
  "chain": "Bloom",
  "chainId": 323213,
  "explorers": [{
    "name": "Bloom Genesis Testnet",
    "url": "https://testnet.bloomgenesis.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.bloomgenesis.com"],
  "icon": {
    "url": "ipfs://Qmetu9hMLvczYo7tDPRyjqjBHwwpHU8mEgW3PEPPre56su",
    "width": 2794,
    "height": 2711,
    "format": "png"
  },
  "infoURL": "https://www.bloomgenesis.com",
  "name": "Bloom Genesis Testnet",
  "nativeCurrency": {
    "name": "Bloom",
    "symbol": "BGBC",
    "decimals": 18
  },
  "networkId": 323213,
  "rpc": ["https://323213.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.bloomgenesis.com"],
  "shortName": "BGBC-Testnet",
  "slug": "bloom-genesis-testnet",
  "testnet": true
};

var c330844 = {
  "chain": "TSC",
  "chainId": 330844,
  "explorers": [{
    "name": "TTcoin Smart Chain Explorer",
    "url": "https://tscscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmS7ipvvyZ16weG1DM7AZbi1v9ixYwU2FjP25Jj5jkLiuf",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.tscscan.com"],
  "icon": {
    "url": "ipfs://QmS7ipvvyZ16weG1DM7AZbi1v9ixYwU2FjP25Jj5jkLiuf",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://ttcoin.info/",
  "name": "TTcoin Smart Chain Mainnet",
  "nativeCurrency": {
    "name": "TTcoin",
    "symbol": "TC",
    "decimals": 18
  },
  "networkId": 330844,
  "rpc": ["https://330844.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.tscscan.com"],
  "shortName": "tc",
  "slug": "ttcoin-smart-chain",
  "testnet": false
};

var c331769 = {
  "chain": "POPTestnet",
  "chainId": 331769,
  "explorers": [{
    "name": "ProofOfPepe Explorer",
    "url": "https://pepescan.app/",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmP8rYvcc7aJB3c2YZxjxaySvHapHnoK8MnxuSuDT4PtF2",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "name": "ProofOfPepe Testnet",
  "nativeCurrency": {
    "name": "POP",
    "symbol": "POP",
    "decimals": 18
  },
  "networkId": 331769,
  "redFlags": [],
  "rpc": ["https://331769.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet01.proofofpepe.tech"],
  "shortName": "POPTestnet",
  "slug": "proofofpepe-testnet",
  "testnet": true
};

var c331771 = {
  "chain": "POP",
  "chainId": 331771,
  "explorers": [{
    "name": "Pepescan",
    "url": "https://pepescan.app",
    "standard": "none"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmP8rYvcc7aJB3c2YZxjxaySvHapHnoK8MnxuSuDT4PtF2",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "name": "POP Mainnet",
  "nativeCurrency": {
    "name": "Pepe",
    "symbol": "PEPE",
    "decimals": 18
  },
  "networkId": 331771,
  "redFlags": [],
  "rpc": ["https://331771.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc00.proofofpepe.tech", "https://rpc01.proofofpepe.tech", "https://rpc02.proofofpepe.tech"],
  "shortName": "POP",
  "slug": "pop",
  "testnet": false
};

var c332323 = {
  "chain": "Avalanche",
  "chainId": 332323,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QI0408s3dev Testnet",
  "nativeCurrency": {
    "name": "QI0408s3dev Testnet Token",
    "symbol": "REQ",
    "decimals": 18
  },
  "networkId": 332323,
  "redFlags": [],
  "rpc": ["https://332323.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"],
  "shortName": "QI0408s3dev Testnet",
  "slug": "qi0408s3dev-testnet",
  "testnet": true
};

var c333313 = {
  "chain": "Bloom",
  "chainId": 333313,
  "explorers": [{
    "name": "Bloom Genesis Mainnet",
    "url": "https://explorer.bloomgenesis.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmetu9hMLvczYo7tDPRyjqjBHwwpHU8mEgW3PEPPre56su",
    "width": 2794,
    "height": 2711,
    "format": "png"
  },
  "infoURL": "https://www.bloomgenesis.com",
  "name": "Bloom Genesis Mainnet",
  "nativeCurrency": {
    "name": "Bloom",
    "symbol": "BGBC",
    "decimals": 18
  },
  "networkId": 333313,
  "rpc": ["https://333313.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.bloomgenesis.com"],
  "shortName": "BGBC",
  "slug": "bloom-genesis",
  "testnet": false
};

var c333331 = {
  "chain": "AVST",
  "chainId": 333331,
  "explorers": [{
    "name": "avescan",
    "url": "https://testnet.avescoin.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmeKQVv2QneHaaggw2NfpZ7DGMdjVhPywTdse5RzCs4oGn",
      "width": 232,
      "height": 232,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmeKQVv2QneHaaggw2NfpZ7DGMdjVhPywTdse5RzCs4oGn",
    "width": 232,
    "height": 232,
    "format": "png"
  },
  "infoURL": "https://ethereum.org",
  "name": "Aves Testnet",
  "nativeCurrency": {
    "name": "AvesT",
    "symbol": "AVST",
    "decimals": 18
  },
  "networkId": 333331,
  "rpc": ["https://333331.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://test.rpc.avescoin.io"],
  "shortName": "avst",
  "slip44": 1,
  "slug": "aves-testnet",
  "testnet": true
};

var c333333 = {
  "chain": "N3-Test",
  "chainId": 333333,
  "explorers": [{
    "name": "Nativ3 Test Explorer",
    "url": "https://scantest.nativ3.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVzJDndPui6qBSeJWe5kMLA56C3KpVhqqqk9xvVKE1DGb",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://nativ3.network",
  "name": "Nativ3 Testnet",
  "nativeCurrency": {
    "name": "USNT",
    "symbol": "USNT",
    "decimals": 18
  },
  "networkId": 333333,
  "parent": {
    "type": "L2",
    "chain": "eip155-421613",
    "bridges": [{
      "url": "https://bridgetest.nativ3.network"
    }]
  },
  "rpc": ["https://333333.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpctest.nativ3.network", "wss://wstest.nativ3.network"],
  "shortName": "N3-Test",
  "slip44": 1,
  "slug": "nativ3-testnet",
  "testnet": true
};

var c333666 = {
  "chain": "OONE Testnet",
  "chainId": 333666,
  "explorers": [{
    "name": "blockscout",
    "url": "https://testnet.oonescan.com",
    "standard": "none"
  }],
  "faucets": ["https://apps-test.adigium.com/faucet"],
  "infoURL": "https://oonechain.com",
  "name": "Oone Chain Testnet",
  "nativeCurrency": {
    "name": "tOONE",
    "symbol": "tOONE",
    "decimals": 18
  },
  "networkId": 333666,
  "rpc": ["https://333666.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.oonechain.com"],
  "shortName": "oonetest",
  "slip44": 1,
  "slug": "oone-chain-testnet",
  "testnet": true
};

var c333777 = {
  "chain": "OONE Devnet",
  "chainId": 333777,
  "explorers": [{
    "name": "blockscout",
    "url": "https://dev.oonescan.com",
    "standard": "none"
  }],
  "faucets": ["https://apps-test.adigium.com/faucet"],
  "infoURL": "https://oonechain.com",
  "name": "Oone Chain Devnet",
  "nativeCurrency": {
    "name": "tOONE",
    "symbol": "tOONE",
    "decimals": 18
  },
  "networkId": 333777,
  "rpc": ["https://333777.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.dev.oonechain.com"],
  "shortName": "oonedev",
  "slug": "oone-chain-devnet",
  "testnet": true
};

var c333888 = {
  "chain": "Sparta",
  "chainId": 333888,
  "explorers": [],
  "faucets": ["https://faucet.polis.tech"],
  "icon": {
    "url": "ipfs://QmagWrtyApex28H2QeXcs3jJ2F7p2K7eESz3cDbHdQ3pjG",
    "width": 1050,
    "height": 1050,
    "format": "png"
  },
  "infoURL": "https://polis.tech",
  "name": "Polis Testnet",
  "nativeCurrency": {
    "name": "tPolis",
    "symbol": "tPOLIS",
    "decimals": 18
  },
  "networkId": 333888,
  "rpc": ["https://333888.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sparta-rpc.polis.tech"],
  "shortName": "sparta",
  "slip44": 1,
  "slug": "polis-testnet",
  "testnet": true
};

var c333999 = {
  "chain": "Olympus",
  "chainId": 333999,
  "explorers": [],
  "faucets": ["https://faucet.polis.tech"],
  "icon": {
    "url": "ipfs://QmagWrtyApex28H2QeXcs3jJ2F7p2K7eESz3cDbHdQ3pjG",
    "width": 1050,
    "height": 1050,
    "format": "png"
  },
  "infoURL": "https://polis.tech",
  "name": "Polis Mainnet",
  "nativeCurrency": {
    "name": "Polis",
    "symbol": "POLIS",
    "decimals": 18
  },
  "networkId": 333999,
  "rpc": ["https://333999.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.polis.tech"],
  "shortName": "olympus",
  "slug": "polis",
  "testnet": false
};

var c355113 = {
  "chain": "BFT",
  "chainId": 355113,
  "explorers": [{
    "name": "Bitfinity Block Explorer",
    "url": "https://explorer.bitfinity.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreiczbhnoc5wpjikskmehexmg3xmqr4fchrny64db4wmk3lrygqik5e",
      "width": 796,
      "height": 129,
      "format": "png"
    }
  }],
  "faucets": ["https://bitfinity.network/faucet"],
  "infoURL": "https://bitfinity.network",
  "name": "Bitfinity Network Testnet",
  "nativeCurrency": {
    "name": "BITFINITY",
    "symbol": "BFT",
    "decimals": 18
  },
  "networkId": 355113,
  "rpc": ["https://355113.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.bitfinity.network"],
  "shortName": "Bitfinity",
  "slip44": 1,
  "slug": "bitfinity-network-testnet",
  "testnet": true
};

var c363636 = {
  "chain": "DS2",
  "chainId": 363636,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRiAUu3xV5uiX6Nk1iXD5w6qjki5ugGFETRVavzJ2h5QF",
    "width": 370,
    "height": 320,
    "format": "png"
  },
  "name": "Digit Soul Smart Chain 2",
  "nativeCurrency": {
    "name": "Digit Coin",
    "symbol": "DGC",
    "decimals": 18
  },
  "networkId": 363636,
  "rpc": ["https://363636.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://dgs-rpc.digitsoul.co.th"],
  "shortName": "DS2",
  "slug": "digit-soul-smart-chain-2",
  "testnet": false
};

var c373737 = {
  "chain": "HAPchain",
  "chainId": 373737,
  "explorers": [{
    "name": "HAP EVM Explorer (Blockscout)",
    "url": "https://blockscout-test.hap.land",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmQ4V9JC25yUrYk2kFJwmKguSsZBQvtGcg6q9zkDV8mkJW",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQ4V9JC25yUrYk2kFJwmKguSsZBQvtGcg6q9zkDV8mkJW",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://hap.land",
  "name": "HAPchain Testnet",
  "nativeCurrency": {
    "name": "HAP",
    "symbol": "HAP",
    "decimals": 18
  },
  "networkId": 373737,
  "rpc": ["https://373737.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://jsonrpc-test.hap.land"],
  "shortName": "hap-testnet",
  "slip44": 1,
  "slug": "hapchain-testnet",
  "testnet": true
};

var c381931 = {
  "chain": "Metal",
  "chainId": 381931,
  "explorers": [{
    "name": "metalscan",
    "url": "https://metalscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.metalblockchain.org/",
  "name": "Metal C-Chain",
  "nativeCurrency": {
    "name": "Metal",
    "symbol": "METAL",
    "decimals": 18
  },
  "networkId": 381931,
  "rpc": ["https://381931.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.metalblockchain.org/ext/bc/C/rpc"],
  "shortName": "metal",
  "slip44": 9005,
  "slug": "metal-c-chain",
  "testnet": false
};

var c381932 = {
  "chain": "Metal",
  "chainId": 381932,
  "explorers": [{
    "name": "metalscan",
    "url": "https://tahoe.metalscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.metalblockchain.org/",
  "name": "Metal Tahoe C-Chain",
  "nativeCurrency": {
    "name": "Metal",
    "symbol": "METAL",
    "decimals": 18
  },
  "networkId": 381932,
  "rpc": ["https://381932.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://tahoe.metalblockchain.org/ext/bc/C/rpc"],
  "shortName": "Tahoe",
  "slip44": 9005,
  "slug": "metal-tahoe-c-chain",
  "testnet": false
};

var c404040 = {
  "chain": "TPBX",
  "chainId": 404040,
  "explorers": [{
    "name": "Tipboxcoin",
    "url": "https://tipboxcoin.net",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.tipboxcoin.net"],
  "icon": {
    "url": "ipfs://QmbiaHnR3fVVofZ7Xq2GYZxwHkLEy3Fh5qDtqnqXD6ACAh",
    "width": 192,
    "height": 192,
    "format": "png"
  },
  "infoURL": "https://tipboxcoin.net",
  "name": "Tipboxcoin Mainnet",
  "nativeCurrency": {
    "name": "Tipboxcoin",
    "symbol": "TPBX",
    "decimals": 18
  },
  "networkId": 404040,
  "rpc": ["https://404040.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.tipboxcoin.net"],
  "shortName": "TPBXm",
  "slug": "tipboxcoin",
  "testnet": false
};

var c420420 = {
  "chain": "kek",
  "chainId": 420420,
  "explorers": [{
    "name": "blockscout",
    "url": "https://mainnet-explorer.kekchain.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmNzwHAmaaQyuvKudrzGkrTT2GMshcmCmJ9FH8gG2mNJtM",
      "width": 401,
      "height": 401,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNzwHAmaaQyuvKudrzGkrTT2GMshcmCmJ9FH8gG2mNJtM",
    "width": 401,
    "height": 401,
    "format": "svg"
  },
  "infoURL": "https://kekchain.com",
  "name": "Kekchain",
  "nativeCurrency": {
    "name": "KEK",
    "symbol": "KEK",
    "decimals": 18
  },
  "networkId": 103090,
  "rpc": ["https://420420.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.kekchain.com"],
  "shortName": "KEK",
  "slug": "kekchain",
  "testnet": false
};

var c420666 = {
  "chain": "kek",
  "chainId": 420666,
  "explorers": [{
    "name": "blockscout",
    "url": "https://testnet-explorer.kekchain.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmNzwHAmaaQyuvKudrzGkrTT2GMshcmCmJ9FH8gG2mNJtM",
      "width": 401,
      "height": 401,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNzwHAmaaQyuvKudrzGkrTT2GMshcmCmJ9FH8gG2mNJtM",
    "width": 401,
    "height": 401,
    "format": "svg"
  },
  "infoURL": "https://kekchain.com",
  "name": "Kekchain (kektest)",
  "nativeCurrency": {
    "name": "tKEK",
    "symbol": "tKEK",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://420666.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.kekchain.com"],
  "shortName": "tKEK",
  "slip44": 1,
  "slug": "kekchain-kektest",
  "testnet": true
};

var c420692 = {
  "chain": "ALT",
  "chainId": 420692,
  "explorers": [{
    "name": "Alterium L2 Testnet Explorer",
    "url": "https://l2-testnet.altscan.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreid3v7ow4c4t3ljya6aouiwvqbtssb2lzmkwt2eghryk234g7yynrq",
    "width": 756,
    "height": 756,
    "format": "png"
  },
  "infoURL": "https://alteriumprotocol.org",
  "name": "Alterium L2 Testnet",
  "nativeCurrency": {
    "name": "Alterium ETH",
    "symbol": "AltETH",
    "decimals": 18
  },
  "networkId": 420692,
  "parent": {
    "type": "L2",
    "chain": "eip155-5",
    "bridges": [{
      "url": "https://testnet-bridge.alteriumprotocol.org"
    }]
  },
  "rpc": ["https://420692.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://l2-testnet-rpc.altscan.org"],
  "shortName": "alterium",
  "slip44": 1,
  "slug": "alterium-l2-testnet",
  "testnet": true
};

var c421611 = {
  "chain": "ETH",
  "chainId": 421611,
  "explorers": [{
    "name": "arbiscan-testnet",
    "url": "https://testnet.arbiscan.io",
    "standard": "EIP3091"
  }, {
    "name": "arbitrum-rinkeby",
    "url": "https://rinkeby-explorer.arbitrum.io",
    "standard": "EIP3091"
  }],
  "faucets": ["http://fauceth.komputing.org?chain=421611&address=${ADDRESS}"],
  "features": [],
  "infoURL": "https://arbitrum.io",
  "name": "Arbitrum Rinkeby",
  "nativeCurrency": {
    "name": "Arbitrum Rinkeby Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 421611,
  "parent": {
    "type": "L2",
    "chain": "eip155-4",
    "bridges": [{
      "url": "https://bridge.arbitrum.io"
    }]
  },
  "redFlags": [],
  "rpc": ["https://421611.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rinkeby.arbitrum.io/rpc"],
  "shortName": "arb-rinkeby",
  "slip44": 1,
  "slug": "arbitrum-rinkeby",
  "status": "deprecated",
  "testnet": true,
  "title": "Arbitrum Testnet Rinkeby"
};

var c421613 = {
  "chain": "ETH",
  "chainId": 421613,
  "explorers": [{
    "name": "Arbitrum Goerli Arbiscan",
    "url": "https://goerli.arbiscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/arbitrum/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://arbitrum.io/",
  "name": "Arbitrum Goerli",
  "nativeCurrency": {
    "name": "Arbitrum Goerli Ether",
    "symbol": "AGOR",
    "decimals": 18
  },
  "networkId": 421613,
  "parent": {
    "type": "L2",
    "chain": "eip155-5",
    "bridges": [{
      "url": "https://bridge.arbitrum.io/"
    }]
  },
  "redFlags": [],
  "rpc": ["https://421613.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://goerli-rollup.arbitrum.io/rpc", "https://arbitrum-goerli.publicnode.com", "wss://arbitrum-goerli.publicnode.com"],
  "shortName": "arb-goerli",
  "slip44": 1,
  "slug": "arbitrum-goerli",
  "status": "deprecated",
  "testnet": true,
  "title": "Arbitrum Goerli Rollup Testnet"
};

var c421614 = {
  "chain": "ETH",
  "chainId": 421614,
  "explorers": [{
    "name": "Arbitrum Sepolia Rollup Testnet Explorer",
    "url": "https://sepolia-explorer.arbitrum.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://arbitrum.io",
  "name": "Arbitrum Sepolia",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 421614,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": [{
      "url": "https://bridge.arbitrum.io"
    }]
  },
  "rpc": ["https://421614.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sepolia-rollup.arbitrum.io/rpc", "https://arbitrum-sepolia.infura.io/v3/${INFURA_API_KEY}"],
  "shortName": "arb-sep",
  "slip44": 1,
  "slug": "arbitrum-sepolia",
  "testnet": true,
  "title": "Arbitrum Sepolia Rollup Testnet"
};

var c424242 = {
  "chain": "FTN",
  "chainId": 424242,
  "explorers": [{
    "name": "blockscout",
    "url": "https://testnet.ftnscan.com",
    "standard": "none"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "infoURL": "https://fastex.com",
  "name": "Fastex Chain testnet",
  "nativeCurrency": {
    "name": "FTN",
    "symbol": "FTN",
    "decimals": 18
  },
  "networkId": 424242,
  "rpc": ["https://424242.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.fastexchain.com"],
  "shortName": "fastexTestnet",
  "slip44": 1,
  "slug": "fastex-chain-testnet",
  "testnet": true,
  "title": "Fastex Chain testnet"
};

var c431140 = {
  "chain": "Unified",
  "chainId": 431140,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVMBTZVPawyLBD2B5VbG68dfWLfZ1CnB8V59xduBe2kwh",
    "width": 84,
    "height": 84,
    "format": "png"
  },
  "infoURL": "https://www.markr.io/",
  "name": "Markr Go",
  "nativeCurrency": {
    "name": "Avalanche",
    "symbol": "AVAX",
    "decimals": 18
  },
  "networkId": 431140,
  "rpc": ["https://431140.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.markr.io/ext/"],
  "shortName": "markr-go",
  "slug": "markr-go",
  "status": "incubating",
  "testnet": false
};

var c431188 = {
  "chain": "Avalanche",
  "chainId": 431188,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Foundation Testnet",
  "nativeCurrency": {
    "name": "Foundation Testnet Token",
    "symbol": "TFND",
    "decimals": 18
  },
  "networkId": 431188,
  "redFlags": [],
  "rpc": ["https://431188.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/foundation/testnet/rpc"],
  "shortName": "Foundation Testnet",
  "slug": "foundation-testnet",
  "testnet": true
};

var c432201 = {
  "chain": "DEXALOT",
  "chainId": 432201,
  "explorers": [{
    "name": "Avalanche Subnet Testnet Explorer",
    "url": "https://subnets-test.avax.network/dexalot",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.avax.network/?subnet=dexalot"],
  "icon": {
    "url": "ipfs://QmfVxdrWjtUKiGzqFDzAxHH2FqwP2aRuZTGcYWdWg519Xy",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://dexalot.com",
  "name": "Dexalot Subnet Testnet",
  "nativeCurrency": {
    "name": "Dexalot",
    "symbol": "ALOT",
    "decimals": 18
  },
  "networkId": 432201,
  "rpc": ["https://432201.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/dexalot/testnet/rpc"],
  "shortName": "dexalot-testnet",
  "slip44": 1,
  "slug": "dexalot-subnet-testnet",
  "testnet": true
};

var c432204 = {
  "chain": "DEXALOT",
  "chainId": 432204,
  "explorers": [{
    "name": "Avalanche Subnet Explorer",
    "url": "https://subnets.avax.network/dexalot",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmfVxdrWjtUKiGzqFDzAxHH2FqwP2aRuZTGcYWdWg519Xy",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://dexalot.com",
  "name": "Dexalot Subnet",
  "nativeCurrency": {
    "name": "Dexalot",
    "symbol": "ALOT",
    "decimals": 18
  },
  "networkId": 432204,
  "rpc": ["https://432204.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/dexalot/mainnet/rpc"],
  "shortName": "dexalot",
  "slug": "dexalot-subnet",
  "testnet": false
};

var c444444 = {
  "chain": "SYNDRSEPOLIA",
  "chainId": 444444,
  "explorers": [{
    "name": "Syndr L3 Sepolia Testnet Explorer",
    "url": "https://sepolia-explorer.syndr.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://syndr.com",
  "name": "Syndr L3 Sepolia",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 444444,
  "parent": {
    "type": "L2",
    "chain": "eip155-421614",
    "bridges": [{
      "url": "https://sepolia-bridge.syndr.com"
    }]
  },
  "rpc": ["https://444444.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sepolia.syndr.com/http", "wss://sepolia.syndr.com/ws"],
  "shortName": "syndr",
  "slug": "syndr-l3-sepolia",
  "testnet": true,
  "title": "Syndr L3 Sepolia Rollup Testnet"
};

var c444900 = {
  "chain": "WLK",
  "chainId": 444900,
  "explorers": [{
    "name": "weelink-testnet",
    "url": "https://weelink.cloud/#/blockView/overview",
    "standard": "none"
  }],
  "faucets": ["https://faucet.weelink.gw002.oneitfarm.com"],
  "infoURL": "https://weelink.cloud",
  "name": "Weelink Testnet",
  "nativeCurrency": {
    "name": "Weelink Chain Token",
    "symbol": "tWLK",
    "decimals": 18
  },
  "networkId": 444900,
  "rpc": ["https://444900.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://weelinknode1c.gw002.oneitfarm.com"],
  "shortName": "wlkt",
  "slip44": 1,
  "slug": "weelink-testnet",
  "testnet": true
};

var c471100 = {
  "chain": "ETH",
  "chainId": 471100,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://patex.io/",
  "name": "Patex Sepolia Testnet",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 471100,
  "rpc": ["https://471100.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://test-rpc.patex.io/"],
  "shortName": "psep",
  "slip44": 1,
  "slug": "patex-sepolia-testnet",
  "testnet": true
};

var c473861 = {
  "chain": "ultrapro",
  "chainId": 473861,
  "explorers": [{
    "name": "ultraproscan",
    "url": "https://ultraproscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmT11iJMLe9sAk5NiRQbe2wv1jtLFCs2sF2w9vFwDLkkgE",
      "width": 500,
      "height": 500,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmT11iJMLe9sAk5NiRQbe2wv1jtLFCs2sF2w9vFwDLkkgE",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://ultrapro.info",
  "name": "Ultra Pro Mainnet",
  "nativeCurrency": {
    "name": "Ultra Pro",
    "symbol": "UPRO",
    "decimals": 18
  },
  "networkId": 473861,
  "rpc": ["https://473861.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.ultraproscan.io"],
  "shortName": "ultrapro",
  "slug": "ultra-pro",
  "testnet": false
};

var c474142 = {
  "chain": "OpenChain",
  "chainId": 474142,
  "explorers": [{
    "name": "SIDE SCAN",
    "url": "https://sidescan.luniverse.io/1641349324562974539",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.openchain.live",
  "name": "OpenChain Mainnet",
  "nativeCurrency": {
    "name": "OpenCoin",
    "symbol": "OPC",
    "decimals": 10
  },
  "networkId": 474142,
  "rpc": ["https://474142.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://baas-rpc.luniverse.io:18545?lChainId=1641349324562974539"],
  "shortName": "oc",
  "slug": "openchain",
  "testnet": false
};

var c512512 = {
  "chain": "CMP",
  "chainId": 512512,
  "explorers": [{
    "name": "Galaxy Scan",
    "url": "https://galaxy.scan.caduceus.foundation",
    "standard": "none"
  }],
  "faucets": ["https://dev.caduceus.foundation/testNetwork"],
  "infoURL": "https://caduceus.foundation/",
  "name": "CMP-Testnet",
  "nativeCurrency": {
    "name": "Caduceus Testnet Token",
    "symbol": "CMP",
    "decimals": 18
  },
  "networkId": 512512,
  "rpc": ["https://512512.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://galaxy.block.caduceus.foundation", "wss://galaxy.block.caduceus.foundation"],
  "shortName": "cmp",
  "slip44": 1,
  "slug": "cmp-testnet",
  "testnet": true
};

var c513100 = {
  "chain": "DIS",
  "chainId": 513100,
  "explorers": [{
    "name": "DisChain",
    "url": "https://www.oklink.com/dis",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://dischain.xyz",
  "name": "DisChain",
  "nativeCurrency": {
    "name": "DisChain",
    "symbol": "DIS",
    "decimals": 18
  },
  "networkId": 513100,
  "rpc": ["https://513100.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.dischain.xyz"],
  "shortName": "dis",
  "slug": "dischain",
  "testnet": false
};

var c534351 = {
  "chain": "ETH",
  "chainId": 534351,
  "explorers": [{
    "name": "Scroll Sepolia Etherscan",
    "url": "https://sepolia.scrollscan.com",
    "standard": "EIP3091"
  }, {
    "name": "Scroll Sepolia Blockscout",
    "url": "https://sepolia-blockscout.scroll.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://scroll.io",
  "name": "Scroll Sepolia Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 534351,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": [{
      "url": "https://sepolia.scroll.io/bridge"
    }]
  },
  "rpc": ["https://534351.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sepolia-rpc.scroll.io", "https://rpc.ankr.com/scroll_sepolia_testnet", "https://scroll-sepolia.chainstacklabs.com", "https://scroll-testnet-public.unifra.io"],
  "shortName": "scr-sepolia",
  "slip44": 1,
  "slug": "scroll-sepolia-testnet",
  "status": "active",
  "testnet": true
};

var c534352 = {
  "chain": "ETH",
  "chainId": 534352,
  "explorers": [{
    "name": "Scrollscan",
    "url": "https://scrollscan.com",
    "standard": "EIP3091"
  }, {
    "name": "Blockscout",
    "url": "https://blockscout.scroll.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://scroll.io",
  "name": "Scroll",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 534352,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://scroll.io/bridge"
    }]
  },
  "rpc": ["https://534352.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.scroll.io", "https://rpc-scroll.icecreamswap.com", "https://rpc.ankr.com/scroll", "https://scroll-mainnet.chainstacklabs.com"],
  "shortName": "scr",
  "slug": "scroll",
  "status": "active",
  "testnet": false
};

var c534353 = {
  "chain": "ETH",
  "chainId": 534353,
  "explorers": [{
    "name": "Scroll Alpha Testnet Block Explorer",
    "url": "https://alpha-blockscout.scroll.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://scroll.io",
  "name": "Scroll Alpha Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 534353,
  "parent": {
    "type": "L2",
    "chain": "eip155-5",
    "bridges": []
  },
  "rpc": ["https://534353.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://alpha-rpc.scroll.io/l2"],
  "shortName": "scr-alpha",
  "slip44": 1,
  "slug": "scroll-alpha-testnet",
  "status": "deprecated",
  "testnet": true
};

var c534354 = {
  "chain": "ETH",
  "chainId": 534354,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://scroll.io",
  "name": "Scroll Pre-Alpha Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "TSETH",
    "decimals": 18
  },
  "networkId": 534354,
  "rpc": [],
  "shortName": "scr-prealpha",
  "slip44": 1,
  "slug": "scroll-pre-alpha-testnet",
  "status": "deprecated",
  "testnet": true
};

var c534849 = {
  "chain": "Shinarium",
  "chainId": 534849,
  "explorers": [{
    "name": "shinascan",
    "url": "https://shinascan.shinarium.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.shinarium.org"],
  "icon": {
    "url": "ipfs://bafybeiadbavrwcial76vs5ovhyykyaobteltuhliqcthdairbja4klwzhu",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://shinarium.org",
  "name": "Shinarium Beta",
  "nativeCurrency": {
    "name": "Shina Inu",
    "symbol": "SHI",
    "decimals": 18
  },
  "networkId": 534849,
  "rpc": ["https://534849.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.shinarium.org"],
  "shortName": "shi",
  "slug": "shinarium-beta",
  "testnet": false
};

var c535037 = {
  "chain": "BESC",
  "chainId": 535037,
  "explorers": [{
    "name": "bescscan",
    "url": "https://Bescscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "name": "BeanEco SmartChain",
  "nativeCurrency": {
    "name": "BeanEco SmartChain",
    "symbol": "BESC",
    "decimals": 18
  },
  "networkId": 535037,
  "rpc": ["https://535037.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.bescscan.io"],
  "shortName": "BESC",
  "slug": "beaneco-smartchain",
  "testnet": false,
  "title": "BESC Mainnet"
};

var c555666 = {
  "chain": "Avalanche",
  "chainId": 555666,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "EclipseChain Testnet",
  "nativeCurrency": {
    "name": "EclipseChain Testnet Token",
    "symbol": "ECLPS",
    "decimals": 18
  },
  "networkId": 555666,
  "redFlags": [],
  "rpc": ["https://555666.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/eclipsecha/testnet/rpc"],
  "shortName": "EclipseChain Testnet",
  "slug": "eclipsechain-testnet",
  "testnet": true
};

var c622277 = {
  "chain": "HYP",
  "chainId": 622277,
  "explorers": [{
    "name": "hypra",
    "url": "https://explorer.hypra.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreiawlhc2trzyxgnz24vowdymxme2m446uk4vmrplgxsdd74ecpfloq",
    "width": 830,
    "height": 830,
    "format": "png"
  },
  "infoURL": "https://www.hypra.network",
  "name": "Hypra Mainnet",
  "nativeCurrency": {
    "name": "Hypra",
    "symbol": "HYP",
    "decimals": 18
  },
  "networkId": 622277,
  "rpc": ["https://622277.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.hypra.network", "https://rpc.rethereum.org", "https://rethereum.rpc.restratagem.com", "https://rpc.rthcentral.org"],
  "shortName": "hyp",
  "slug": "hypra",
  "testnet": false
};

var c641230 = {
  "chain": "BRNKC",
  "chainId": 641230,
  "explorers": [{
    "name": "brnkscan",
    "url": "https://brnkscan.bearnetwork.net",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQqhH28QpUrreoRw5Gj8YShzdHxxVGMjfVrx3TqJNLSLv",
    "width": 1067,
    "height": 1067,
    "format": "png"
  },
  "infoURL": "https://bearnetwork.net",
  "name": "Bear Network Chain Mainnet",
  "nativeCurrency": {
    "name": "Bear Network Chain Native Token",
    "symbol": "BRNKC",
    "decimals": 18
  },
  "networkId": 641230,
  "rpc": ["https://641230.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://brnkc-mainnet.bearnetwork.net", "https://brnkc-mainnet1.bearnetwork.net"],
  "shortName": "BRNKC",
  "slug": "bear-network-chain",
  "testnet": false
};

var c651940 = {
  "chain": "ALL",
  "chainId": 651940,
  "explorers": [{
    "name": "Alltra SmartChain Explorer",
    "url": "https://alltra.global",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreibqe2mgiqezi24sx272kunqt6pv7uzxhpkxuobvpbsptce3q6nn5i",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://alltra.world",
  "name": "ALL Mainnet",
  "nativeCurrency": {
    "name": "ALL",
    "symbol": "ALL",
    "decimals": 18
  },
  "networkId": 651940,
  "rpc": ["https://651940.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.alltra.global"],
  "shortName": "ALL",
  "slug": "all",
  "testnet": false
};

var c660279 = {
  "chain": "Xai Mainnet",
  "chainId": 660279,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmZKFekbHxDkB8gFmmmjWz89SLhwg38GkALmAKo3gn753N/2024-01-10%2012.50.15.jpg",
    "width": 512,
    "height": 512,
    "format": "jpg"
  },
  "infoURL": "https://xai.games/",
  "name": "Xai Mainnet",
  "nativeCurrency": {
    "name": "XAI token",
    "symbol": "XAI",
    "decimals": 18
  },
  "networkId": 660279,
  "redFlags": [],
  "rpc": ["https://660279.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://xai-chain.net/rpc/xai79df8614da076af58f199126a07db"],
  "shortName": "xai",
  "slug": "xai",
  "testnet": false
};

var c660868 = {
  "chain": "OCASH",
  "chainId": 660868,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://ipfs.io/ipfs/QmbwuoezvkfZBY9nrZ65n3iHGyhJG6yDRyhPjqE6k3uCiM",
    "width": 350,
    "height": 350,
    "format": "PNG"
  },
  "infoURL": "https://www.overline.network",
  "name": "Ocash testnet",
  "nativeCurrency": {
    "name": "OCASH",
    "symbol": "OCASH",
    "decimals": 18
  },
  "networkId": 660868,
  "redFlags": [],
  "rpc": [],
  "shortName": "ocash",
  "slug": "ocash-testnet",
  "testnet": true
};

var c666666 = {
  "chain": "Vision-Vpioneer",
  "chainId": 666666,
  "explorers": [],
  "faucets": ["https://vpioneerfaucet.visionscan.org"],
  "infoURL": "https://visionscan.org",
  "name": "Vision - Vpioneer Test Chain",
  "nativeCurrency": {
    "name": "VS",
    "symbol": "VS",
    "decimals": 18
  },
  "networkId": 666666,
  "rpc": ["https://666666.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://vpioneer.infragrid.v.network/ethereum/compatible"],
  "shortName": "vpioneer",
  "slip44": 1,
  "slug": "vision-vpioneer-test-chain",
  "testnet": true
};

var c666888 = {
  "chain": "Hela",
  "chainId": 666888,
  "explorers": [{
    "name": "Hela Official Runtime Testnet Explorer",
    "url": "https://testnet-blockexplorer.helachain.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://testnet-faucet.helachain.com"],
  "icon": {
    "url": "ipfs://QmQbUVcaxFwY8gqMq1Jeup4NEyivo12QYhbLvVRvgXRBFb",
    "width": 719,
    "height": 216,
    "format": "png"
  },
  "infoURL": "https://helalabs.com",
  "name": "Hela Official Runtime Testnet",
  "nativeCurrency": {
    "name": "Hela HLUSD",
    "symbol": "HLUSD",
    "decimals": 18
  },
  "networkId": 666888,
  "rpc": ["https://666888.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.helachain.com"],
  "shortName": "hela-testnet",
  "slip44": 1,
  "slug": "hela-official-runtime-testnet",
  "testnet": true
};

var c686868 = {
  "chain": "WON",
  "chainId": 686868,
  "explorers": [{
    "name": "Won Explorer",
    "url": "https://scan.wonnetwork.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.wondollars.org"],
  "icon": {
    "url": "ipfs://QmQ6mjKWJQ5WmFiJzcqJnuHWZK53nQYJB1SnMQZEqgr74h",
    "width": 250,
    "height": 250,
    "format": "png"
  },
  "infoURL": "https://wonnetwork.org",
  "name": "Won Network",
  "nativeCurrency": {
    "name": "Won",
    "symbol": "WON",
    "decimals": 18
  },
  "networkId": 686868,
  "rpc": ["https://686868.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.wonnetwork.org"],
  "shortName": "WonChain",
  "slug": "won-network",
  "testnet": false
};

var c696969 = {
  "chain": "Galadriel",
  "chainId": 696969,
  "explorers": [{
    "name": "Galadriel Explorer",
    "url": "https://explorer.galadriel.com",
    "standard": "none"
  }],
  "faucets": ["https://docs.galadriel.com/faucet"],
  "infoURL": "https://galadriel.com",
  "name": "Galadriel Devnet",
  "nativeCurrency": {
    "name": "Galadriel Devnet token",
    "symbol": "GAL",
    "decimals": 18
  },
  "networkId": 696969,
  "rpc": ["https://696969.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnet.galadriel.com"],
  "shortName": "galadriel-devnet",
  "slug": "galadriel-devnet",
  "testnet": false
};

var c710420 = {
  "chain": "Avalanche",
  "chainId": 710420,
  "explorers": [{
    "name": "TILTYARD Explorer",
    "url": "https://subnets.avax.network/tiltyard",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Tiltyard",
  "nativeCurrency": {
    "name": "Tiltyard Token",
    "symbol": "TILT",
    "decimals": 18
  },
  "networkId": 710420,
  "redFlags": [],
  "rpc": ["https://710420.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/tiltyard/mainnet/rpc"],
  "shortName": "Tiltyard",
  "slug": "tiltyard",
  "testnet": false
};

var c713715 = {
  "chain": "Sei",
  "chainId": 713715,
  "explorers": [{
    "name": "Seistream",
    "url": "https://seistream.app",
    "standard": "none"
  }, {
    "name": "Seitrace",
    "url": "https://seitrace.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://sei-faucet.nima.enterprises", "https://sei-evm.faucetme.pro"],
  "icon": {
    "url": "ipfs://bafkreih3l3iisplmikofkbfyimqlox7nmixzlkzhjoewmpi4jbqitwryoa",
    "width": 600,
    "height": 600,
    "format": "png"
  },
  "infoURL": "https://www.sei.io",
  "name": "Sei Devnet",
  "nativeCurrency": {
    "name": "Sei",
    "symbol": "SEI",
    "decimals": 18
  },
  "networkId": 713715,
  "rpc": ["https://713715.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://evm-rpc-arctic-1.sei-apis.com", "https://evm-rpc.arctic-1.seinetwork.io"],
  "shortName": "sei-devnet",
  "slug": "sei-devnet",
  "testnet": false
};

var c743111 = {
  "chain": "ETH",
  "chainId": 743111,
  "explorers": [{
    "name": "blockscout",
    "url": "https://testnet.explorer.hemi.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "infoURL": "https://hemi.xyz",
  "name": "Hemi Sepolia",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 743111,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111"
  },
  "rpc": ["https://743111.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.rpc.hemi.network/rpc"],
  "shortName": "hemi-sep",
  "slug": "hemi-sepolia",
  "status": "active",
  "testnet": true
};

var c751230 = {
  "chain": "BRNKCTEST",
  "chainId": 751230,
  "explorers": [{
    "name": "brnktestscan",
    "url": "https://brnktest-scan.bearnetwork.net",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.bearnetwork.net"],
  "icon": {
    "url": "ipfs://QmQqhH28QpUrreoRw5Gj8YShzdHxxVGMjfVrx3TqJNLSLv",
    "width": 1067,
    "height": 1067,
    "format": "png"
  },
  "infoURL": "https://bearnetwork.net",
  "name": "Bear Network Chain Testnet",
  "nativeCurrency": {
    "name": "Bear Network Chain Testnet Token",
    "symbol": "tBRNKC",
    "decimals": 18
  },
  "networkId": 751230,
  "rpc": ["https://751230.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://brnkc-test.bearnetwork.net"],
  "shortName": "BRNKCTEST",
  "slip44": 1,
  "slug": "bear-network-chain-testnet",
  "testnet": true
};

var c761412 = {
  "chain": "MiexsSmartchain",
  "chainId": 761412,
  "explorers": [{
    "name": "Miexs Smartchain Explorer",
    "url": "https://miexs.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreic6tcc6swh5kzljwqnswj6rlemcm7n6ra7xkgttwv5v3fv7ozj5zu",
    "width": 1500,
    "height": 1500,
    "format": "png"
  },
  "infoURL": "https://miexs.com",
  "name": "Miexs Smartchain",
  "nativeCurrency": {
    "name": "Miexs Coin",
    "symbol": "MIX",
    "decimals": 18
  },
  "networkId": 761412,
  "rpc": ["https://761412.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.miexs.com"],
  "shortName": "Miexs",
  "slug": "miexs-smartchain",
  "testnet": false
};

var c764984 = {
  "chain": "Avalanche",
  "chainId": 764984,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "Lamina1 Testnet",
  "nativeCurrency": {
    "name": "Lamina1 Testnet Token",
    "symbol": "L1T",
    "decimals": 18
  },
  "networkId": 764984,
  "redFlags": [],
  "rpc": ["https://764984.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/lamina1tes/testnet/rpc"],
  "shortName": "Lamina1 Testnet",
  "slug": "lamina1-testnet",
  "testnet": true
};

var c776877 = {
  "chain": "EVMCC",
  "chainId": 776877,
  "explorers": [{
    "name": "Tanssi Explorer",
    "url": "https://tanssi-evmexplorer.netlify.app/?rpcUrl=https://fraa-dancebox-3035-rpc.a.dancebox.tanssi.network",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.rmrk.app/",
  "name": "Modularium",
  "nativeCurrency": {
    "name": "Modularium",
    "symbol": "MDM",
    "decimals": 18
  },
  "networkId": 776877,
  "rpc": ["https://776877.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://fraa-dancebox-3035-rpc.a.dancebox.tanssi.network"],
  "shortName": "mdlrm",
  "slug": "modularium",
  "testnet": false
};

var c800001 = {
  "chain": "OCTA",
  "chainId": 800001,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.octa.space",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVhezQHkqSZ5Tvtsw18giA1yBjV1URSsBQ7HenUh6p6oC",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://octa.space",
  "name": "OctaSpace",
  "nativeCurrency": {
    "name": "OctaSpace",
    "symbol": "OCTA",
    "decimals": 18
  },
  "networkId": 800001,
  "rpc": ["https://800001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.octa.space", "wss://rpc.octa.space"],
  "shortName": "octa",
  "slug": "octaspace",
  "testnet": false
};

var c808080 = {
  "chain": "BIZT Testnet",
  "chainId": 808080,
  "explorers": [{
    "name": "BIZ Smart Chain Testnet Explorer",
    "url": "https://testnet.btscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmNnaDZRoMz9aoho35TGHBY5zD16P39cgPpw3z3jnkDHHB",
    "width": 104,
    "height": 104,
    "format": "png"
  },
  "infoURL": "https://www.biztoken.io/",
  "name": "BIZ Smart Chain Testnet",
  "nativeCurrency": {
    "name": "tBIZT",
    "symbol": "tBIZT",
    "decimals": 18
  },
  "networkId": 808080,
  "rpc": ["https://808080.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.bizex.io/"],
  "shortName": "bizt-testnet",
  "slip44": 1,
  "slug": "biz-smart-chain-testnet",
  "testnet": true
};

var c810180 = {
  "chain": "ETH",
  "chainId": 810180,
  "explorers": [{
    "name": "zkLink Nova Block Explorer",
    "url": "https://explorer.zklink.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreiaj7b6pdekv3rjuta5wsdvmfdcsat2jftjgozape7wvmyj6d3vjcm",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreiaj7b6pdekv3rjuta5wsdvmfdcsat2jftjgozape7wvmyj6d3vjcm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://zklink.io",
  "name": "zkLink Nova Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 810180,
  "parent": {
    "type": "L2",
    "chain": "eip155-59144",
    "bridges": [{
      "url": "https://portal.zklink.io"
    }]
  },
  "rpc": ["https://810180.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.zklink.io", "wss://rpc.zklink.io"],
  "shortName": "zklink-nova",
  "slip44": 1,
  "slug": "zklink-nova",
  "testnet": false
};

var c810182 = {
  "chain": "ETH",
  "chainId": 810182,
  "explorers": [{
    "name": "zkLink Nova Block Explorer",
    "url": "https://goerli.explorer.zklink.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafkreiaj7b6pdekv3rjuta5wsdvmfdcsat2jftjgozape7wvmyj6d3vjcm",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreiaj7b6pdekv3rjuta5wsdvmfdcsat2jftjgozape7wvmyj6d3vjcm",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://zklink.io",
  "name": "zkLink Nova Goerli Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 810182,
  "parent": {
    "type": "L2",
    "chain": "eip155-59140",
    "bridges": [{
      "url": "https://goerli.portal.zklink.io"
    }]
  },
  "rpc": ["https://810182.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://goerli.rpc.zklink.io", "wss://goerli.rpc.zklink.io"],
  "shortName": "zklink-nova-goerli",
  "slip44": 1,
  "slug": "zklink-nova-goerli-testnet",
  "testnet": true
};

var c827431 = {
  "chain": "CURVE",
  "chainId": 827431,
  "explorers": [{
    "name": "CURVE Mainnet",
    "url": "https://curvescan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmTjV3TTR5aLb7fi7tjx8gcDvYtqBpusqhCSaznVxJ7NJg",
    "width": 150,
    "height": 150,
    "format": "png"
  },
  "infoURL": "https://curvescan.io",
  "name": "CURVE Mainnet",
  "nativeCurrency": {
    "name": "Curve",
    "symbol": "CURVE",
    "decimals": 18
  },
  "networkId": 827431,
  "rpc": ["https://827431.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.curvescan.io"],
  "shortName": "CURVEm",
  "slug": "curve",
  "testnet": false
};

var c846000 = {
  "chain": "4GN",
  "chainId": 846000,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://bloqs4good.com",
  "name": "4GoodNetwork",
  "nativeCurrency": {
    "name": "APTA",
    "symbol": "APTA",
    "decimals": 18
  },
  "networkId": 846000,
  "rpc": ["https://846000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://chain.deptofgood.com"],
  "shortName": "bloqs4good",
  "slug": "4goodnetwork",
  "testnet": false
};

var c855456 = {
  "chain": "EVMCC",
  "chainId": 855456,
  "explorers": [{
    "name": "Dodao Explorer",
    "url": "https://tanssi-evmexplorer.netlify.app/?rpcUrl=https://fraa-dancebox-3041-rpc.a.dancebox.tanssi.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmdWsi6mhs6Agb3LF4uycUwx2fgNmwkuAGb7JmsLPkwd3j",
      "width": 636,
      "height": 629,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdWsi6mhs6Agb3LF4uycUwx2fgNmwkuAGb7JmsLPkwd3j",
    "width": 636,
    "height": 629,
    "format": "png"
  },
  "infoURL": "https://dodao.dev/",
  "name": "Dodao",
  "nativeCurrency": {
    "name": "Dodao",
    "symbol": "DODAO",
    "decimals": 18
  },
  "networkId": 855456,
  "rpc": ["https://855456.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://fraa-dancebox-3041-rpc.a.dancebox.tanssi.network", "wss://fraa-dancebox-3041-rpc.a.dancebox.tanssi.network"],
  "shortName": "dodao",
  "slug": "dodao",
  "testnet": false
};

var c879151 = {
  "chain": "BLX",
  "chainId": 879151,
  "explorers": [{
    "name": "BlocX Mainnet Explorer",
    "url": "https://explorer.blxscan.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmXM7XiLdSxhCub8MLSSo2J9V2qAkTcwdAGxcT57kurUzg",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmXM7XiLdSxhCub8MLSSo2J9V2qAkTcwdAGxcT57kurUzg",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://www.blocxchain.org/",
  "name": "BlocX Mainnet",
  "nativeCurrency": {
    "name": "BlocX",
    "symbol": "BLX",
    "decimals": 18
  },
  "networkId": 879151,
  "rpc": ["https://879151.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.blxscan.com/"],
  "shortName": "blx",
  "slug": "blocx",
  "testnet": false
};

var c888888 = {
  "chain": "Vision",
  "chainId": 888888,
  "explorers": [{
    "name": "Visionscan",
    "url": "https://www.visionscan.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.v.network",
  "name": "Vision - Mainnet",
  "nativeCurrency": {
    "name": "VS",
    "symbol": "VS",
    "decimals": 18
  },
  "networkId": 888888,
  "rpc": ["https://888888.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://infragrid.v.network/ethereum/compatible"],
  "shortName": "vision",
  "slip44": 60,
  "slug": "vision",
  "testnet": false
};

var c894538 = {
  "chain": "TWT",
  "chainId": 894538,
  "explorers": [{
    "name": "explorer",
    "url": "https://subnets-test.avax.network/thirdweb",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmXDGoJKuuwQKzY1Y7ZhgULg8hcmveu6PVaDaYQzEjKwkQ/Thirdweb-Icon-Black-BG.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "name": "thirdweb test subnet",
  "nativeCurrency": {
    "name": "TWT",
    "symbol": "TWT",
    "decimals": 18
  },
  "networkId": 894538,
  "redFlags": [],
  "rpc": ["https://894538.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/thirdweb/testnet/rpc"],
  "shortName": "twt",
  "slug": "thirdweb-test-subnet",
  "testnet": true
};

var c900000 = {
  "chain": "PSC",
  "chainId": 900000,
  "explorers": [{
    "name": "Posichain Explorer",
    "url": "https://explorer.posichain.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://posichain.org",
  "name": "Posichain Mainnet Shard 0",
  "nativeCurrency": {
    "name": "Posichain Native Token",
    "symbol": "POSI",
    "decimals": 18
  },
  "networkId": 900000,
  "rpc": ["https://900000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.posichain.org", "https://api.s0.posichain.org"],
  "shortName": "psc-s0",
  "slug": "posichain-shard-0",
  "testnet": false
};

var c910000 = {
  "chain": "PSC",
  "chainId": 910000,
  "explorers": [{
    "name": "Posichain Explorer Testnet",
    "url": "https://explorer-testnet.posichain.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.posichain.org/"],
  "infoURL": "https://posichain.org",
  "name": "Posichain Testnet Shard 0",
  "nativeCurrency": {
    "name": "Posichain Native Token",
    "symbol": "POSI",
    "decimals": 18
  },
  "networkId": 910000,
  "rpc": ["https://910000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.s0.t.posichain.org"],
  "shortName": "psc-t-s0",
  "slug": "posichain-testnet-shard-0",
  "testnet": true
};

var c912559 = {
  "chain": "RIA",
  "chainId": 912559,
  "explorers": [{
    "name": "Astria EVM Dusknet Explorer",
    "url": "https://explorer.evm.dusk-3.devnet.astria.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.evm.dusk-3.devnet.astria.org/"],
  "icon": {
    "url": "ipfs://QmVbzZYXdVFY3uFaWQd7iSRtdM2UKWohj9fVqqEwxcw2RV",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://docs.astria.org",
  "name": "Astria EVM Dusknet",
  "nativeCurrency": {
    "name": "RIA",
    "symbol": "RIA",
    "decimals": 18
  },
  "networkId": 912559,
  "rpc": ["https://912559.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.evm.dusk-3.devnet.astria.org"],
  "shortName": "ria-dev",
  "slug": "astria-evm-dusknet",
  "testnet": false
};

var c914031 = {
  "chain": "Avalanche",
  "chainId": 914031,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0408T1TS Testnet",
  "nativeCurrency": {
    "name": "QR0408T1TS Testnet Token",
    "symbol": "HOK",
    "decimals": 18
  },
  "networkId": 914031,
  "redFlags": [],
  "rpc": ["https://914031.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0408t1ts/testnet/rpc"],
  "shortName": "QR0408T1TS Testnet",
  "slug": "qr0408t1ts-testnet",
  "testnet": true
};

var c920000 = {
  "chain": "PSC",
  "chainId": 920000,
  "explorers": [{
    "name": "Posichain Explorer Devnet",
    "url": "https://explorer-devnet.posichain.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.posichain.org/"],
  "infoURL": "https://posichain.org",
  "name": "Posichain Devnet Shard 0",
  "nativeCurrency": {
    "name": "Posichain Native Token",
    "symbol": "POSI",
    "decimals": 18
  },
  "networkId": 920000,
  "rpc": ["https://920000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.s0.d.posichain.org"],
  "shortName": "psc-d-s0",
  "slug": "posichain-devnet-shard-0",
  "testnet": false
};

var c920001 = {
  "chain": "PSC",
  "chainId": 920001,
  "explorers": [{
    "name": "Posichain Explorer Devnet",
    "url": "https://explorer-devnet.posichain.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.posichain.org/"],
  "infoURL": "https://posichain.org",
  "name": "Posichain Devnet Shard 1",
  "nativeCurrency": {
    "name": "Posichain Native Token",
    "symbol": "POSI",
    "decimals": 18
  },
  "networkId": 920001,
  "rpc": ["https://920001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.s1.d.posichain.org"],
  "shortName": "psc-d-s1",
  "slug": "posichain-devnet-shard-1",
  "testnet": false
};

var c923018 = {
  "chain": "FNCY",
  "chainId": 923018,
  "explorers": [{
    "name": "fncy scan testnet",
    "url": "https://fncyscan-testnet.fncy.world",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmfXCh6UnaEHn3Evz7RFJ3p2ggJBRm9hunDHegeoquGuhD",
      "width": 256,
      "height": 256,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet-testnet.fncy.world"],
  "icon": {
    "url": "ipfs://QmfXCh6UnaEHn3Evz7RFJ3p2ggJBRm9hunDHegeoquGuhD",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://fncyscan-testnet.fncy.world",
  "name": "FNCY Testnet",
  "nativeCurrency": {
    "name": "FNCY",
    "symbol": "FNCY",
    "decimals": 18
  },
  "networkId": 923018,
  "rpc": ["https://923018.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://fncy-testnet-seed.fncy.world"],
  "shortName": "tFNCY",
  "slip44": 1,
  "slug": "fncy-testnet",
  "testnet": true
};

var c928010 = {
  "chain": "Avalanche",
  "chainId": 928010,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0408T2TS Testnet",
  "nativeCurrency": {
    "name": "QR0408T2TS Testnet Token",
    "symbol": "XYZ",
    "decimals": 18
  },
  "networkId": 928010,
  "redFlags": [],
  "rpc": ["https://928010.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0408t2ts/testnet/rpc"],
  "shortName": "QR0408T2TS Testnet",
  "slug": "qr0408t2ts-testnet",
  "testnet": true
};

var c929038 = {
  "chain": "Avalanche",
  "chainId": 929038,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0215Y1MP",
  "nativeCurrency": {
    "name": "QR0215Y1MP Token",
    "symbol": "QAT",
    "decimals": 18
  },
  "networkId": 929038,
  "redFlags": [],
  "rpc": ["https://929038.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0215y1mp/mainnet/rpc"],
  "shortName": "QR0215Y1MP",
  "slug": "qr0215y1mp",
  "testnet": false
};

var c933326 = {
  "chain": "Avalanche",
  "chainId": 933326,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0326T2TS Testnet",
  "nativeCurrency": {
    "name": "QR0326T2TS Testnet Token",
    "symbol": "XFT",
    "decimals": 18
  },
  "networkId": 933326,
  "redFlags": [],
  "rpc": [],
  "shortName": "QR0326T2TS Testnet",
  "slug": "qr0326t2ts-testnet",
  "testnet": true
};

var c946751 = {
  "chain": "Avalanche",
  "chainId": 946751,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0214Y1P",
  "nativeCurrency": {
    "name": "QR0214Y1P Token",
    "symbol": "QAT",
    "decimals": 18
  },
  "networkId": 946751,
  "redFlags": [],
  "rpc": ["https://946751.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0214y1p/testnet/rpc"],
  "shortName": "QR0214Y1P",
  "slug": "qr0214y1p",
  "testnet": true
};

var c950375 = {
  "chain": "Avalanche",
  "chainId": 950375,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0209Y1S",
  "nativeCurrency": {
    "name": "QR0209Y1S Token",
    "symbol": "XPU",
    "decimals": 18
  },
  "networkId": 950375,
  "redFlags": [],
  "rpc": ["https://950375.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0209y1s/testnet/rpc"],
  "shortName": "QR0209Y1S",
  "slug": "qr0209y1s",
  "testnet": true
};

var c951083 = {
  "chain": "Avalanche",
  "chainId": 951083,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0205Y1S",
  "nativeCurrency": {
    "name": "QR0205Y1S Token",
    "symbol": "MYO",
    "decimals": 18
  },
  "networkId": 951083,
  "redFlags": [],
  "rpc": ["https://951083.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0205y1s/testnet/rpc"],
  "shortName": "QR0205Y1S",
  "slug": "qr0205y1s",
  "testnet": true
};

var c955081 = {
  "chain": "JONO12",
  "chainId": 955081,
  "explorers": [{
    "name": "JONO12 Explorer",
    "url": "https://subnets-test.avax.network/jono12",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafkreievzx4ke62dtc77o47x7vs7nn67ghzrwku6h5dxo3hwcsqfeblke4",
    "width": 612,
    "height": 612,
    "format": "png"
  },
  "name": "Jono12 Subnet",
  "nativeCurrency": {
    "name": "Jono12 Token",
    "symbol": "JONO",
    "decimals": 18
  },
  "networkId": 955081,
  "rpc": ["https://955081.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/jono12/testnet/rpc"],
  "shortName": "jono12",
  "slug": "jono12-subnet",
  "testnet": true
};

var c955305 = {
  "chain": "Eluvio",
  "chainId": 955305,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.eluv.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://eluv.io",
  "name": "Eluvio Content Fabric",
  "nativeCurrency": {
    "name": "ELV",
    "symbol": "ELV",
    "decimals": 18
  },
  "networkId": 955305,
  "rpc": ["https://955305.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://host-76-74-28-226.contentfabric.io/eth/", "https://host-76-74-28-232.contentfabric.io/eth/", "https://host-76-74-29-2.contentfabric.io/eth/", "https://host-76-74-29-8.contentfabric.io/eth/", "https://host-76-74-29-34.contentfabric.io/eth/", "https://host-76-74-29-35.contentfabric.io/eth/", "https://host-154-14-211-98.contentfabric.io/eth/", "https://host-154-14-192-66.contentfabric.io/eth/", "https://host-60-240-133-202.contentfabric.io/eth/", "https://host-64-235-250-98.contentfabric.io/eth/"],
  "shortName": "elv",
  "slip44": 1011,
  "slug": "eluvio-content-fabric",
  "testnet": false
};

var c961256 = {
  "chain": "Avalanche",
  "chainId": 961256,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0326T4TS Testnet",
  "nativeCurrency": {
    "name": "QR0326T4TS Testnet Token",
    "symbol": "HTF",
    "decimals": 18
  },
  "networkId": 961256,
  "redFlags": [],
  "rpc": ["https://961256.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0326t4ts/testnet/rpc"],
  "shortName": "QR0326T4TS Testnet",
  "slug": "qr0326t4ts-testnet",
  "testnet": true
};

var c978993 = {
  "chain": "Avalanche",
  "chainId": 978993,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0318T1TS Testnet",
  "nativeCurrency": {
    "name": "QR0318T1TS Testnet Token",
    "symbol": "OSF",
    "decimals": 18
  },
  "networkId": 978993,
  "redFlags": [],
  "rpc": ["https://978993.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0318t1ts/testnet/rpc"],
  "shortName": "QR0318T1TS Testnet",
  "slug": "qr0318t1ts-testnet",
  "testnet": true
};

var c988207 = {
  "chain": "Ecrox Chain",
  "chainId": 988207,
  "explorers": [{
    "name": "Ecrox Chain Explorer",
    "url": "https://ecroxscan.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreibnqdlwgotu4hwx6oeu4ye3huobr3eaiuvv55n5tolyxya2q7edmq",
    "width": 300,
    "height": 300,
    "format": "png"
  },
  "infoURL": "https://ecroxcoin.io/",
  "name": "Ecrox Chain Mainnet",
  "nativeCurrency": {
    "name": "ECROX COIN",
    "symbol": "ECROX",
    "decimals": 18
  },
  "networkId": 988207,
  "rpc": ["https://988207.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.ecroxscan.com/"],
  "shortName": "ecrox",
  "slug": "ecrox-chain",
  "testnet": false
};

var c991424 = {
  "chain": "Avalanche",
  "chainId": 991424,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0213Y1S",
  "nativeCurrency": {
    "name": "QR0213Y1S Token",
    "symbol": "GCH",
    "decimals": 18
  },
  "networkId": 991424,
  "redFlags": [],
  "rpc": ["https://991424.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0213y1s/testnet/rpc"],
  "shortName": "QR0213Y1S",
  "slug": "qr0213y1s",
  "testnet": true
};

var c993535 = {
  "chain": "Avalanche",
  "chainId": 993535,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": ".svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "qr1120y1",
  "nativeCurrency": {
    "name": "qr1120y1 Token",
    "symbol": "LMK",
    "decimals": 18
  },
  "networkId": 993535,
  "redFlags": [],
  "rpc": ["https://993535.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr1120y1/testnet/rpc"],
  "shortName": "qr1120y1",
  "slug": "qr1120y1",
  "testnet": true
};

var c999511 = {
  "chain": "Avalanche",
  "chainId": 999511,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "https://images.ctfassets.net/9bazykntljf6/62CceHSYsRS4D9fgDSkLRB/877cb8f26954e1743ff535fd7fdaf78f/avacloud-placeholder.svg",
    "width": 256,
    "height": 256,
    "format": "svg"
  },
  "infoURL": "https://avacloud.io",
  "name": "QR0227T1TS",
  "nativeCurrency": {
    "name": "QR0227T1TS Token",
    "symbol": "YFL",
    "decimals": 18
  },
  "networkId": 999511,
  "redFlags": [],
  "rpc": ["https://999511.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/qr0227t1ts/testnet/rpc"],
  "shortName": "QR0227T1TS",
  "slug": "qr0227t1ts",
  "testnet": true
};

var c1100789 = {
  "chain": "NetMind",
  "chainId": 1100789,
  "explorers": [{
    "name": "NetMind Testnet Explorer",
    "url": "https://testbrower.protago-dev.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmQNipd6uen7sm7HZXGbqhcSVkUXxu3Tp6c3BoeFpvmywp",
      "width": 500,
      "height": 500,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQNipd6uen7sm7HZXGbqhcSVkUXxu3Tp6c3BoeFpvmywp",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://netmind.ai",
  "name": "Netmind Chain Testnet",
  "nativeCurrency": {
    "name": "NMT",
    "symbol": "NMT",
    "decimals": 18
  },
  "networkId": 1100789,
  "rpc": ["https://1100789.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testblock.protago-dev.com"],
  "shortName": "nmtTest",
  "slug": "netmind-chain-testnet",
  "testnet": true,
  "title": "NetMind Chain Testnet"
};

var c1127469 = {
  "chain": "TILTYARD",
  "chainId": 1127469,
  "explorers": [{
    "name": "TILTYARD Explorer",
    "url": "http://testnet-explorer.tiltyard.gg",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP1559"
  }],
  "name": "Tiltyard Subnet",
  "nativeCurrency": {
    "name": "Tiltyard Token",
    "symbol": "TILTG",
    "decimals": 18
  },
  "networkId": 1127469,
  "rpc": ["https://1127469.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://subnets.avax.network/tiltyard/testnet/rpc"],
  "shortName": "tiltyard",
  "slug": "tiltyard-subnet",
  "testnet": true
};

var c1261120 = {
  "chain": "ETH",
  "chainId": 1261120,
  "explorers": [{
    "name": "Blockscout zKatana chain explorer",
    "url": "https://zkatana.blockscout.com",
    "standard": "EIP3091"
  }, {
    "name": "Startale zKatana chain explorer",
    "url": "https://zkatana.explorer.startale.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRySLe3su59dE5x5JPm2b1GeZfz6DR9qUzcbp3rt4SD3A",
    "width": 300,
    "height": 300,
    "format": "png"
  },
  "infoURL": "https://astar.network",
  "name": "zKatana",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1261120,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": [{
      "url": "https://portal.astar.network"
    }, {
      "url": "https://bridge.zkatana.gelato.digital"
    }]
  },
  "rpc": ["https://1261120.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.zkatana.gelato.digital", "https://rpc.startale.com/zkatana", "https://astar-zkatana.drpc.org", "wss://astar-zkatana.drpc.org"],
  "shortName": "azktn",
  "slug": "zkatana",
  "status": "active",
  "testnet": true,
  "title": "Astar zkEVM Testnet zKatana"
};

var c1313114 = {
  "chain": "ETHO",
  "chainId": 1313114,
  "explorers": [{
    "name": "blockscout",
    "url": "https://explorer.ethoprotocol.com",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://ethoprotocol.com",
  "name": "Etho Protocol",
  "nativeCurrency": {
    "name": "Etho Protocol",
    "symbol": "ETHO",
    "decimals": 18
  },
  "networkId": 1313114,
  "rpc": ["https://1313114.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.ethoprotocol.com"],
  "shortName": "etho",
  "slip44": 1313114,
  "slug": "etho-protocol",
  "testnet": false
};

var c1313500 = {
  "chain": "XERO",
  "chainId": 1313500,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://xerom.org",
  "name": "Xerom",
  "nativeCurrency": {
    "name": "Xerom Ether",
    "symbol": "XERO",
    "decimals": 18
  },
  "networkId": 1313500,
  "rpc": ["https://1313500.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.xerom.org"],
  "shortName": "xero",
  "slug": "xerom",
  "testnet": false
};

var c1337702 = {
  "chain": "ETH",
  "chainId": 1337702,
  "explorers": [{
    "name": "kintsugi explorer",
    "url": "https://explorer.kintsugi.themerge.dev",
    "standard": "EIP3091"
  }],
  "faucets": ["http://fauceth.komputing.org?chain=1337702&address=${ADDRESS}", "https://faucet.kintsugi.themerge.dev"],
  "infoURL": "https://kintsugi.themerge.dev/",
  "name": "Kintsugi",
  "nativeCurrency": {
    "name": "kintsugi Ethere",
    "symbol": "kiETH",
    "decimals": 18
  },
  "networkId": 1337702,
  "rpc": ["https://1337702.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.kintsugi.themerge.dev"],
  "shortName": "kintsugi",
  "slug": "kintsugi",
  "testnet": true,
  "title": "Kintsugi merge testnet"
};

var c1337802 = {
  "chain": "ETH",
  "chainId": 1337802,
  "explorers": [{
    "name": "Kiln Explorer",
    "url": "https://explorer.kiln.themerge.dev",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt",
      "width": 1000,
      "height": 1628,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.kiln.themerge.dev", "https://kiln-faucet.pk910.de", "https://kilnfaucet.com"],
  "features": [],
  "icon": {
    "url": "ipfs://QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt",
    "width": 1000,
    "height": 1628,
    "format": "png"
  },
  "infoURL": "https://kiln.themerge.dev/",
  "name": "Kiln",
  "nativeCurrency": {
    "name": "Testnet ETH",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1337802,
  "redFlags": [],
  "rpc": ["https://1337802.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.kiln.themerge.dev"],
  "shortName": "kiln",
  "slug": "kiln",
  "status": "deprecated",
  "testnet": false
};

var c1337803 = {
  "chain": "ETH",
  "chainId": 1337803,
  "explorers": [{
    "name": "Zhejiang Explorer",
    "url": "https://zhejiang.beaconcha.in",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt",
      "width": 1000,
      "height": 1628,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.zhejiang.ethpandaops.io", "https://zhejiang-faucet.pk910.de"],
  "icon": {
    "url": "ipfs://QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt",
    "width": 1000,
    "height": 1628,
    "format": "png"
  },
  "infoURL": "https://zhejiang.ethpandaops.io",
  "name": "Zhejiang",
  "nativeCurrency": {
    "name": "Testnet ETH",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1337803,
  "rpc": ["https://1337803.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.zhejiang.ethpandaops.io"],
  "shortName": "zhejiang",
  "slug": "zhejiang",
  "testnet": true
};

var c1440002 = {
  "chain": "XRPL",
  "chainId": 1440002,
  "explorers": [{
    "name": "XRP Ledger Explorer",
    "url": "https://evm-sidechain.xrpl.org/",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://bafkreidmgxjwjircegjkvysgz25b2ukw6h7axoirkxv6idupzzqsdrljgy",
    "width": 780,
    "height": 680,
    "format": "png"
  },
  "name": "XRP Ledger EVM Devnet Sidechain",
  "nativeCurrency": {
    "name": "XRP",
    "symbol": "XRP",
    "decimals": 18
  },
  "networkId": 1440002,
  "redFlags": [],
  "rpc": ["https://1440002.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-evm-sidechain.xrpl.org"],
  "shortName": "XRPL-EVM-Devnet-Sidechain",
  "slug": "xrp-ledger-evm-devnet-sidechain",
  "testnet": true
};

var c1731313 = {
  "chain": "ETH",
  "chainId": 1731313,
  "explorers": [],
  "faucets": [],
  "name": "Turkey Demo Dev",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1731313,
  "rpc": ["https://1731313.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devchain-poa.huabeizhenxuan.com"],
  "shortName": "TDD",
  "slug": "turkey-demo-dev",
  "testnet": false
};

var c2021398 = {
  "chain": "DeBank",
  "chainId": 2021398,
  "explorers": [{
    "name": "DeBank Chain Explorer",
    "url": "https://explorer.testnet.debank.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmW9pBps8WHRRWmyXhjLZrjZJUe8F48hUu7z98bu2RVsjN",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://debank.com",
  "name": "DeBank Testnet",
  "nativeCurrency": {
    "name": "DeBank USD",
    "symbol": "USD",
    "decimals": 18
  },
  "networkId": 2021398,
  "rpc": ["https://2021398.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://rpc.testnet.debank.com"],
  "shortName": "dbk",
  "slip44": 1,
  "slug": "debank-testnet",
  "testnet": true
};

var c2099156 = {
  "chain": "Plian",
  "chainId": 2099156,
  "explorers": [{
    "name": "piscan",
    "url": "https://piscan.plian.org/pchain",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://plian.org/",
  "name": "Plian Mainnet Main",
  "nativeCurrency": {
    "name": "Plian Token",
    "symbol": "PI",
    "decimals": 18
  },
  "networkId": 2099156,
  "rpc": ["https://2099156.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.plian.io/pchain"],
  "shortName": "plian-mainnet",
  "slug": "plian-main",
  "testnet": false
};

var c2125031 = {
  "chain": "Optimism",
  "chainId": 2125031,
  "explorers": [{
    "name": "Bubs Sepolia Explorer",
    "url": "https://bubs-sepolia.explorer.caldera.xyz/",
    "standard": "EIP1559",
    "icon": {
      "url": "https://raw.githubusercontent.com/twitter/twemoji/d94f4cf793e6d5ca592aa00f58a88f6a4229ad43/assets/svg/1f9cb.svg",
      "width": 512,
      "height": 512,
      "format": "svg"
    }
  }],
  "faucets": ["https://bubs-sepolia.hub.caldera.xyz/"],
  "features": [],
  "icon": {
    "url": "https://raw.githubusercontent.com/twitter/twemoji/d94f4cf793e6d5ca592aa00f58a88f6a4229ad43/assets/svg/1f9cb.svg",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://bubs-sepolia.hub.caldera.xyz/",
  "name": "Bubs Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 2125031,
  "redFlags": [],
  "rpc": ["https://2125031.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://bubs-sepolia.rpc.caldera.xyz/http", "wss://bubs-sepolia.rpc.caldera.xyz/ws"],
  "shortName": "Bubs",
  "slug": "bubs-testnet-bubs",
  "testnet": true
};

var c2203181 = {
  "chain": "PlatON",
  "chainId": 2203181,
  "explorers": [{
    "name": "PlatON explorer",
    "url": "https://devnetscan.platon.network",
    "standard": "none"
  }],
  "faucets": ["https://devnet2faucet.platon.network/faucet"],
  "icon": {
    "url": "ipfs://QmT7PSXBiVBma6E15hNkivmstqLu3JSnG1jXN5pTmcCGRC",
    "width": 180,
    "height": 180,
    "format": "png"
  },
  "infoURL": "https://www.platon.network",
  "name": "PlatON Dev Testnet Deprecated",
  "nativeCurrency": {
    "name": "LAT",
    "symbol": "lat",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://2203181.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnetopenapi2.platon.network/rpc", "wss://devnetopenapi2.platon.network/ws"],
  "shortName": "platondev",
  "slip44": 1,
  "slug": "platon-dev-testnet-deprecated",
  "status": "deprecated",
  "testnet": true
};

var c2206132 = {
  "chain": "PlatON",
  "chainId": 2206132,
  "explorers": [{
    "name": "PlatON explorer",
    "url": "https://devnet2scan.platon.network",
    "standard": "none"
  }],
  "faucets": ["https://devnet2faucet.platon.network/faucet"],
  "icon": {
    "url": "ipfs://QmT7PSXBiVBma6E15hNkivmstqLu3JSnG1jXN5pTmcCGRC",
    "width": 180,
    "height": 180,
    "format": "png"
  },
  "infoURL": "https://www.platon.network",
  "name": "PlatON Dev Testnet2",
  "nativeCurrency": {
    "name": "LAT",
    "symbol": "lat",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://2206132.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnet2openapi.platon.network/rpc", "wss://devnet2openapi.platon.network/ws"],
  "shortName": "platondev2",
  "slip44": 1,
  "slug": "platon-dev-testnet2",
  "testnet": true
};

var c2611555 = {
  "chain": "DPU",
  "chainId": 2611555,
  "explorers": [],
  "faucets": [],
  "name": "DPU Chain",
  "nativeCurrency": {
    "name": "DGC",
    "symbol": "DGC",
    "decimals": 18
  },
  "networkId": 2611555,
  "rpc": ["https://2611555.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sc-rpc.dpu.ac.th"],
  "shortName": "DPU",
  "slug": "dpu-chain",
  "testnet": false
};

var c3132023 = {
  "chain": "Sahara",
  "chainId": 3132023,
  "explorers": [],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmQXCm6w8xvWMkksTQYw3So14VCbwHP6chH41v6ysXdSwF",
    "width": 608,
    "height": 608,
    "format": "svg"
  },
  "infoURL": "https://saharalabs.ai",
  "name": "SaharaAI Network",
  "nativeCurrency": {
    "name": "SAHARA",
    "symbol": "SAH",
    "decimals": 18
  },
  "networkId": 3132023,
  "rpc": ["https://3132023.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.saharalabs.ai"],
  "shortName": "sahara",
  "slug": "saharaai-network",
  "testnet": false
};

var c3141592 = {
  "chain": "FIL",
  "chainId": 3141592,
  "explorers": [],
  "faucets": ["https://faucet.butterfly.fildev.network"],
  "icon": {
    "url": "ipfs://QmS9r9XQkMHVomWcSBNDkKkz9n87h9bH9ssabeiKZtANoU",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://filecoin.io",
  "name": "Filecoin - Butterfly testnet",
  "nativeCurrency": {
    "name": "testnet filecoin",
    "symbol": "tFIL",
    "decimals": 18
  },
  "networkId": 3141592,
  "rpc": [],
  "shortName": "filecoin-butterfly",
  "slip44": 1,
  "slug": "filecoin-butterfly-testnet",
  "status": "incubating",
  "testnet": true
};

var c3441005 = {
  "chain": "Manta Pacific",
  "chainId": 3441005,
  "explorers": [{
    "name": "manta-testnet Explorer",
    "url": "https://manta-testnet.calderaexplorer.xyz",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmTckcVTViRZ3NqT36MTt8AvgBSmudrbgU3pi8AaNtthoV",
    "width": 834,
    "height": 834,
    "format": "png"
  },
  "infoURL": "https://manta-testnet.caldera.dev/",
  "name": "Manta Pacific Testnet",
  "nativeCurrency": {
    "name": "Manta",
    "symbol": "MANTA",
    "decimals": 18
  },
  "networkId": 3441005,
  "rpc": ["https://3441005.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://manta-testnet.calderachain.xyz/http", "https://manta-pacific-testnet.drpc.org", "wss://manta-pacific-testnet.drpc.org"],
  "shortName": "mantaTestnet",
  "slip44": 1,
  "slug": "manta-pacific-testnet",
  "testnet": true
};

var c3441006 = {
  "chain": "Manta Pacific",
  "chainId": 3441006,
  "explorers": [{
    "name": "manta-testnet Explorer",
    "url": "https://pacific-explorer.sepolia-testnet.manta.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmTckcVTViRZ3NqT36MTt8AvgBSmudrbgU3pi8AaNtthoV",
    "width": 834,
    "height": 834,
    "format": "png"
  },
  "infoURL": "https://manta-testnet.caldera.dev/",
  "name": "Manta Pacific Sepolia Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 3441006,
  "rpc": ["https://3441006.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://pacific-rpc.sepolia-testnet.manta.network/http"],
  "shortName": "mantaSepoliaTestnet",
  "slip44": 1,
  "slug": "manta-pacific-sepolia-testnet",
  "testnet": true
};

var c4000003 = {
  "chain": "ETH",
  "chainId": 4000003,
  "explorers": [{
    "name": "blockscout",
    "url": "https://zero-explorer.alt.technology",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmcEfZJU7NMn9ycTAcEooQgGNfa2nYBToSUZHdFCFadcjb",
    "width": 1080,
    "height": 1025,
    "format": "png"
  },
  "infoURL": "https://altlayer.io",
  "name": "AltLayer Zero Gas Network",
  "nativeCurrency": {
    "name": "ZERO",
    "symbol": "ZERO",
    "decimals": 18
  },
  "networkId": 4000003,
  "rpc": ["https://4000003.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://zero.alt.technology"],
  "shortName": "alt-zerogas",
  "slug": "altlayer-zero-gas-network",
  "testnet": false
};

var c4281033 = {
  "chain": "WCal",
  "chainId": 4281033,
  "explorers": [],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt",
    "width": 1000,
    "height": 1628,
    "format": "png"
  },
  "infoURL": "https://caldera.xyz/",
  "name": "Worlds Caldera",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 4281033,
  "rpc": ["https://4281033.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://worlds-test.calderachain.xyz/http"],
  "shortName": "worldscal",
  "slug": "worlds-caldera",
  "testnet": true
};

var c5151706 = {
  "chain": "ETH",
  "chainId": 5151706,
  "explorers": [{
    "name": "Explorer",
    "url": "https://explorer.lootchain.com/",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt",
      "width": 1000,
      "height": 1628,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt",
    "width": 1000,
    "height": 1628,
    "format": "png"
  },
  "infoURL": "https://adventuregold.org/",
  "name": "Loot Chain Mainnet",
  "nativeCurrency": {
    "name": "AGLD",
    "symbol": "AGLD",
    "decimals": 18
  },
  "networkId": 5151706,
  "redFlags": [],
  "rpc": ["https://5151706.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.lootchain.com/http "],
  "shortName": "AGLD",
  "slug": "loot-chain",
  "testnet": true
};

var c5167003 = {
  "chain": "MXC zkEVM",
  "chainId": 5167003,
  "explorers": [{
    "name": "MXC Wannsee zkEVM Testnet",
    "url": "https://wannsee-explorer.mxc.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdGCthKA11K9kCZJdbTP5WPAyq1wiRZ3REn6KG58MrWaE",
    "width": 159,
    "height": 159,
    "format": "png"
  },
  "infoURL": "https://wannsee.mxc.com/docs/intro",
  "name": "MXC Wannsee zkEVM Testnet",
  "nativeCurrency": {
    "name": "MXC Wannsee zkEVM Testnet",
    "symbol": "MXC",
    "decimals": 18
  },
  "networkId": 5167003,
  "rpc": ["https://5167003.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://wannsee-rpc.mxc.com"],
  "shortName": "MXCdiscontinued",
  "slip44": 1,
  "slug": "mxc-wannsee-zkevm-testnet",
  "testnet": true
};

var c5167004 = {
  "chain": "MXC zkEVM",
  "chainId": 5167004,
  "explorers": [{
    "name": "Moonchain Geneva Testnet",
    "url": "https://geneva-explorer.moonchain.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmdGCthKA11K9kCZJdbTP5WPAyq1wiRZ3REn6KG58MrWaE",
    "width": 159,
    "height": 159,
    "format": "png"
  },
  "infoURL": "https://doc.mxc.com/docs/intro",
  "name": "Moonchain Geneva Testnet",
  "nativeCurrency": {
    "name": "Moonchain Geneva Testnet",
    "symbol": "MXC",
    "decimals": 18
  },
  "networkId": 5167004,
  "rpc": ["https://5167004.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://geneva-rpc.moonchain.com"],
  "shortName": "MXC",
  "slip44": 1,
  "slug": "moonchain-geneva-testnet",
  "testnet": true
};

var c5201420 = {
  "chain": "Electroneum",
  "chainId": 5201420,
  "explorers": [{
    "name": "blockscout",
    "url": "https://blockexplorer.thesecurityteam.rocks",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmVgFqXA3kkCrVYGcWFF7Mhx8JUSe9vSCauNamuKWSvCym",
      "width": 1000,
      "height": 1000,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmVgFqXA3kkCrVYGcWFF7Mhx8JUSe9vSCauNamuKWSvCym",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://electroneum.com",
  "name": "Electroneum Testnet",
  "nativeCurrency": {
    "name": "Electroneum",
    "symbol": "ETN",
    "decimals": 18
  },
  "networkId": 5201420,
  "rpc": ["https://5201420.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.electroneum.com"],
  "shortName": "etn-testnet",
  "slip44": 1,
  "slug": "electroneum-testnet",
  "testnet": true
};

var c5555555 = {
  "chain": "Imversed",
  "chainId": 5555555,
  "explorers": [{
    "name": "Imversed EVM explorer (Blockscout)",
    "url": "https://txe.imversed.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYwvmJZ1bgTdiZUKXk4SifTpTj286CkZjMCshUyJuBFH1",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }, {
    "name": "Imversed Cosmos Explorer (Big Dipper)",
    "url": "https://tex-c.imversed.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmYwvmJZ1bgTdiZUKXk4SifTpTj286CkZjMCshUyJuBFH1",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYwvmJZ1bgTdiZUKXk4SifTpTj286CkZjMCshUyJuBFH1",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://imversed.com",
  "name": "Imversed Mainnet",
  "nativeCurrency": {
    "name": "Imversed Token",
    "symbol": "IMV",
    "decimals": 18
  },
  "networkId": 5555555,
  "rpc": ["https://5555555.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://jsonrpc.imversed.network", "https://ws-jsonrpc.imversed.network"],
  "shortName": "imversed",
  "slug": "imversed",
  "testnet": false
};

var c5555558 = {
  "chain": "Imversed",
  "chainId": 5555558,
  "explorers": [{
    "name": "Imversed EVM Explorer (Blockscout)",
    "url": "https://txe-test.imversed.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYwvmJZ1bgTdiZUKXk4SifTpTj286CkZjMCshUyJuBFH1",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }, {
    "name": "Imversed Cosmos Explorer (Big Dipper)",
    "url": "https://tex-t.imversed.com",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmYwvmJZ1bgTdiZUKXk4SifTpTj286CkZjMCshUyJuBFH1",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmYwvmJZ1bgTdiZUKXk4SifTpTj286CkZjMCshUyJuBFH1",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://imversed.com",
  "name": "Imversed Testnet",
  "nativeCurrency": {
    "name": "Imversed Token",
    "symbol": "IMV",
    "decimals": 18
  },
  "networkId": 5555558,
  "rpc": ["https://5555558.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://jsonrpc-test.imversed.network", "https://ws-jsonrpc-test.imversed.network"],
  "shortName": "imversed-testnet",
  "slip44": 1,
  "slug": "imversed-testnet",
  "testnet": true
};

var c6038361 = {
  "chain": "ETH",
  "chainId": 6038361,
  "explorers": [{
    "name": "Blockscout zKyoto explorer",
    "url": "https://astar-zkyoto.blockscout.com",
    "standard": "EIP3091"
  }, {
    "name": "Astar zkEVM Testnet zKyoto",
    "url": "https://zkyoto.explorer.startale.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmRySLe3su59dE5x5JPm2b1GeZfz6DR9qUzcbp3rt4SD3A",
    "width": 300,
    "height": 300,
    "format": "png"
  },
  "infoURL": "https://astar.network",
  "name": "Astar zKyoto",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 6038361,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": []
  },
  "redFlags": [],
  "rpc": ["https://6038361.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.startale.com/zkyoto", "https://rpc.zkyoto.gelato.digital"],
  "shortName": "azkyt",
  "slug": "astar-zkyoto",
  "testnet": true,
  "title": "Astar zkEVM Testnet zKyoto"
};

var c7225878 = {
  "chain": "Saakuru",
  "chainId": 7225878,
  "explorers": [{
    "name": "saakuru-explorer",
    "url": "https://explorer.saakuru.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmduEdtFobPpZWSc45MU6RKxZfTEzLux2z8ikHFhT8usqv",
    "width": 1024,
    "height": 1024,
    "format": "png"
  },
  "infoURL": "https://saakuru.network",
  "name": "Saakuru Mainnet",
  "nativeCurrency": {
    "name": "OAS",
    "symbol": "OAS",
    "decimals": 18
  },
  "networkId": 7225878,
  "rpc": ["https://7225878.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.saakuru.network"],
  "shortName": "saakuru",
  "slug": "saakuru",
  "testnet": false
};

var c7355310 = {
  "chain": "VSL",
  "chainId": 7355310,
  "explorers": [{
    "name": "openvessel-mainnet",
    "url": "https://mainnet-explorer.openvessel.io",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeknNzGCZXQK7egwfwyxQan7Lw8bLnqYsyoEgEbDNCzJX",
    "width": 600,
    "height": 529,
    "format": "png"
  },
  "infoURL": "https://www.openvessel.io",
  "name": "OpenVessel",
  "nativeCurrency": {
    "name": "Vessel ETH",
    "symbol": "VETH",
    "decimals": 18
  },
  "networkId": 7355310,
  "rpc": ["https://7355310.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-external.openvessel.io"],
  "shortName": "vsl",
  "slug": "openvessel",
  "testnet": false
};

var c7668378 = {
  "chain": "QOM",
  "chainId": 7668378,
  "explorers": [{
    "name": "QL1 Testnet Explorer",
    "url": "https://testnet.qom.one",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRc1kJ7AgcDL1BSoMYudatWHTrz27K6WNTwGifQb5V17D",
      "width": 518,
      "height": 518,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.qom.one"],
  "icon": {
    "url": "ipfs://QmRc1kJ7AgcDL1BSoMYudatWHTrz27K6WNTwGifQb5V17D",
    "width": 518,
    "height": 518,
    "format": "png"
  },
  "infoURL": "https://qom.one",
  "name": "QL1 Testnet",
  "nativeCurrency": {
    "name": "Shiba Predator",
    "symbol": "QOM",
    "decimals": 18
  },
  "networkId": 7668378,
  "rpc": ["https://7668378.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.qom.one"],
  "shortName": "tqom",
  "slip44": 1,
  "slug": "ql1-testnet",
  "status": "incubating",
  "testnet": true
};

var c7762959 = {
  "chain": "MUSIC",
  "chainId": 7762959,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://musicoin.tw",
  "name": "Musicoin",
  "nativeCurrency": {
    "name": "Musicoin",
    "symbol": "MUSIC",
    "decimals": 18
  },
  "networkId": 7762959,
  "rpc": ["https://7762959.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mewapi.musicoin.tw"],
  "shortName": "music",
  "slip44": 184,
  "slug": "musicoin",
  "testnet": false
};

var c7777777 = {
  "chain": "ETH",
  "chainId": 7777777,
  "explorers": [{
    "name": "Zora Network Explorer",
    "url": "https://explorer.zora.energy",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmZ6qaRwTPFEZUspwMUjaxC6KhmzcELdRQcQzS3P72Dzts/Vector.svg",
    "width": 512,
    "height": 512,
    "format": "svg"
  },
  "infoURL": "https://zora.energy",
  "name": "Zora",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 7777777,
  "redFlags": [],
  "rpc": ["https://7777777.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.zora.energy/"],
  "shortName": "zora",
  "slug": "zora",
  "testnet": false
};

var c8007736 = {
  "chain": "Plian",
  "chainId": 8007736,
  "explorers": [{
    "name": "piscan",
    "url": "https://piscan.plian.org/child_0",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://plian.org",
  "name": "Plian Mainnet Subchain 1",
  "nativeCurrency": {
    "name": "Plian Token",
    "symbol": "PI",
    "decimals": 18
  },
  "networkId": 8007736,
  "parent": {
    "type": "L2",
    "chain": "eip155-2099156"
  },
  "rpc": ["https://8007736.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.plian.io/child_0"],
  "shortName": "plian-mainnet-l2",
  "slug": "plian-subchain-1",
  "testnet": false
};

var c8080808 = {
  "chain": "Hokum",
  "chainId": 8080808,
  "explorers": [{
    "name": "Hokum Explorer",
    "url": "https://explorer.hokum.gg",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmafrUmh1FD48WWQwk6pfW1Y7eA9VQTdpeL387Wt2JFrAd",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://hokum.gg",
  "name": "Hokum",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 8080808,
  "rpc": ["https://8080808.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.hokum.gg"],
  "shortName": "hokum",
  "slug": "hokum",
  "testnet": false
};

var c8794598 = {
  "chain": "HAPchain",
  "chainId": 8794598,
  "explorers": [{
    "name": "HAP EVM Explorer (Blockscout)",
    "url": "https://blockscout.hap.land",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmQ4V9JC25yUrYk2kFJwmKguSsZBQvtGcg6q9zkDV8mkJW",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmQ4V9JC25yUrYk2kFJwmKguSsZBQvtGcg6q9zkDV8mkJW",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://hap.land",
  "name": "HAPchain",
  "nativeCurrency": {
    "name": "HAP",
    "symbol": "HAP",
    "decimals": 18
  },
  "networkId": 8794598,
  "rpc": ["https://8794598.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://jsonrpc.hap.land"],
  "shortName": "hap",
  "slug": "hapchain",
  "testnet": false
};

var c8888881 = {
  "chain": "Quarix",
  "chainId": 8888881,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmTw8TyeeNhUFWrck2WCiN17MaHRt5qzRBtaAvmz6L7qq7",
    "width": 669,
    "height": 587,
    "format": "png"
  },
  "name": "Quarix Testnet",
  "nativeCurrency": {
    "name": "QARE",
    "symbol": "QARE",
    "decimals": 18
  },
  "networkId": 8888881,
  "rpc": [],
  "shortName": "quarix-testnet",
  "slip44": 1,
  "slug": "quarix-testnet",
  "status": "incubating",
  "testnet": true
};

var c8888888 = {
  "chain": "Quarix",
  "chainId": 8888888,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmTw8TyeeNhUFWrck2WCiN17MaHRt5qzRBtaAvmz6L7qq7",
    "width": 669,
    "height": 587,
    "format": "png"
  },
  "name": "Quarix",
  "nativeCurrency": {
    "name": "QARE",
    "symbol": "QARE",
    "decimals": 18
  },
  "networkId": 8888888,
  "rpc": [],
  "shortName": "quarix",
  "slug": "quarix",
  "status": "incubating",
  "testnet": false
};

var c9322252 = {
  "chain": "XCAP",
  "chainId": 9322252,
  "explorers": [{
    "name": "blockscout",
    "url": "https://xcap-mainnet.explorer.xcap.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeTj6tfaw9qf9wnEUQh7PnCpNWyvm56e7kY35kANRWNxj",
    "width": 1600,
    "height": 1600,
    "format": "png"
  },
  "infoURL": "https://xcap.network/",
  "name": "XCAP",
  "nativeCurrency": {
    "name": "Gas",
    "symbol": "GAS",
    "decimals": 18
  },
  "networkId": 9322252,
  "rpc": ["https://9322252.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://xcap-mainnet.relay.xcap.network/znzvh2ueyvm2yts5fv5gnul395jbkfb2/rpc1"],
  "shortName": "xcap",
  "slug": "xcap",
  "testnet": false,
  "title": "XCAP Mainnet"
};

var c9322253 = {
  "chain": "XCAP",
  "chainId": 9322253,
  "explorers": [{
    "name": "blockscout",
    "url": "https://xcap-milvine.explorer.xcap.network",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeTj6tfaw9qf9wnEUQh7PnCpNWyvm56e7kY35kANRWNxj",
    "width": 1600,
    "height": 1600,
    "format": "png"
  },
  "infoURL": "https://xcap.network/",
  "name": "Milvine",
  "nativeCurrency": {
    "name": "Gas",
    "symbol": "GAS",
    "decimals": 18
  },
  "networkId": 9322253,
  "rpc": ["https://9322253.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://xcap-milvine.relay.xcap.network/zj5l55ftsgi027kz4nf14vs8d89inego/rpc1"],
  "shortName": "milv",
  "slug": "milvine",
  "testnet": true,
  "title": "XCAP Testnet Milvine"
};

var c10067275 = {
  "chain": "Plian",
  "chainId": 10067275,
  "explorers": [{
    "name": "piscan",
    "url": "https://testnet.plian.org/child_test",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://plian.org/",
  "name": "Plian Testnet Subchain 1",
  "nativeCurrency": {
    "name": "Plian Token",
    "symbol": "TPI",
    "decimals": 18
  },
  "networkId": 10067275,
  "parent": {
    "type": "L2",
    "chain": "eip155-16658437"
  },
  "rpc": ["https://10067275.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.plian.io/child_test"],
  "shortName": "plian-testnet-l2",
  "slip44": 1,
  "slug": "plian-testnet-subchain-1",
  "testnet": true
};

var c10101010 = {
  "chain": "SVRN",
  "chainId": 10101010,
  "explorers": [{
    "name": "Soverun",
    "url": "https://explorer.soverun.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.soverun.com"],
  "icon": {
    "url": "ipfs://QmTYazUzgY9Nn2mCjWwFUSLy3dG6i2PvALpwCNQvx1zXyi",
    "width": 1154,
    "height": 1154,
    "format": "png"
  },
  "infoURL": "https://soverun.com",
  "name": "Soverun Mainnet",
  "nativeCurrency": {
    "name": "Soverun",
    "symbol": "SVRN",
    "decimals": 18
  },
  "networkId": 10101010,
  "rpc": ["https://10101010.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.soverun.com"],
  "shortName": "SVRNm",
  "slug": "soverun",
  "testnet": false
};

var c11155111 = {
  "chain": "ETH",
  "chainId": 11155111,
  "explorers": [{
    "name": "etherscan-sepolia",
    "url": "https://sepolia.etherscan.io",
    "standard": "EIP3091"
  }, {
    "name": "otterscan-sepolia",
    "url": "https://sepolia.otterscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["http://fauceth.komputing.org?chain=11155111&address=${ADDRESS}"],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/ethereum/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://sepolia.otterscan.io",
  "name": "Sepolia",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 11155111,
  "redFlags": [],
  "rpc": ["https://11155111.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sepolia.infura.io/v3/${INFURA_API_KEY}", "wss://sepolia.infura.io/v3/${INFURA_API_KEY}", "https://rpc.sepolia.org", "https://rpc2.sepolia.org", "https://rpc-sepolia.rockx.com", "https://rpc.sepolia.ethpandaops.io", "https://sepolia.gateway.tenderly.co", "wss://sepolia.gateway.tenderly.co", "https://ethereum-sepolia-rpc.publicnode.com", "wss://ethereum-sepolia-rpc.publicnode.com", "https://sepolia.drpc.org", "wss://sepolia.drpc.org"],
  "shortName": "sep",
  "slip44": 1,
  "slug": "sepolia",
  "testnet": true,
  "title": "Ethereum Testnet Sepolia"
};

var c11155420 = {
  "chain": "ETH",
  "chainId": 11155420,
  "explorers": [{
    "name": "opscout",
    "url": "https://optimism-sepolia.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": ["https://app.optimism.io/faucet"],
  "features": [],
  "icon": {
    "url": "ipfs://QmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9/optimism/512.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://optimism.io",
  "name": "OP Sepolia Testnet",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 11155420,
  "redFlags": [],
  "rpc": ["https://11155420.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sepolia.optimism.io", "https://optimism-sepolia.drpc.org", "wss://optimism-sepolia.drpc.org"],
  "shortName": "opsep",
  "slip44": 1,
  "slug": "op-sepolia-testnet",
  "testnet": true
};

var c13371337 = {
  "chain": "PEP",
  "chainId": 13371337,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://pepchain.io",
  "name": "PepChain Churchill",
  "nativeCurrency": {
    "name": "PepChain Churchill Ether",
    "symbol": "TPEP",
    "decimals": 18
  },
  "networkId": 13371337,
  "rpc": ["https://13371337.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://churchill-rpc.pepchain.io"],
  "shortName": "tpep",
  "slug": "pepchain-churchill",
  "testnet": false
};

var c14288640 = {
  "chain": "anduschain",
  "chainId": 14288640,
  "explorers": [{
    "name": "anduschain explorer",
    "url": "https://explorer.anduschain.io",
    "standard": "none",
    "icon": {
      "url": "ipfs://bafkreiapaxokh2p4j7hg43ug2inomixiwrdhni4kpqazvqifssnez7efze",
      "width": 512,
      "height": 512,
      "format": "png"
    }
  }],
  "faucets": [],
  "infoURL": "https://anduschain.io/",
  "name": "Anduschain Mainnet",
  "nativeCurrency": {
    "name": "DAON",
    "symbol": "DEB",
    "decimals": 18
  },
  "networkId": 14288640,
  "rpc": ["https://14288640.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.anduschain.io/rpc", "wss://rpc.anduschain.io/ws"],
  "shortName": "anduschain-mainnet",
  "slug": "anduschain",
  "testnet": false
};

var c16658437 = {
  "chain": "Plian",
  "chainId": 16658437,
  "explorers": [{
    "name": "piscan",
    "url": "https://testnet.plian.org/testnet",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://plian.org",
  "name": "Plian Testnet Main",
  "nativeCurrency": {
    "name": "Plian Testnet Token",
    "symbol": "TPI",
    "decimals": 18
  },
  "networkId": 16658437,
  "rpc": ["https://16658437.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.plian.io/testnet"],
  "shortName": "plian-testnet",
  "slip44": 1,
  "slug": "plian-testnet-main",
  "testnet": true
};

var c18289463 = {
  "chain": "ILT",
  "chainId": 18289463,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://iolite.io",
  "name": "IOLite",
  "nativeCurrency": {
    "name": "IOLite Ether",
    "symbol": "ILT",
    "decimals": 18
  },
  "networkId": 18289463,
  "rpc": ["https://18289463.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://net.iolite.io"],
  "shortName": "ilt",
  "slug": "iolite",
  "testnet": false
};

var c20180427 = {
  "chain": "stabilityTestnet",
  "chainId": 20180427,
  "explorers": [{
    "name": "blockscout",
    "url": "https://stability-testnet.blockscout.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreid3wd6ouu53r677q2z24a4eq5un5tlwbc4izfapcvvtrlhkmz43au",
    "width": 133,
    "height": 144,
    "format": "png"
  },
  "infoURL": "https://stabilityprotocol.com",
  "name": "Stability Testnet",
  "nativeCurrency": {
    "name": "FREE",
    "symbol": "FREE",
    "decimals": 18
  },
  "networkId": 20180427,
  "rpc": ["https://20180427.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://free.testnet.stabilityprotocol.com"],
  "shortName": "stabilitytestnet",
  "slip44": 1,
  "slug": "stability-testnet",
  "testnet": true
};

var c20180430 = {
  "chain": "Spectrum",
  "chainId": 20180430,
  "explorers": [{
    "name": "spectrum",
    "url": "https://spectrum.pub",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://smartmesh.io",
  "name": "SmartMesh Mainnet",
  "nativeCurrency": {
    "name": "SmartMesh Native Token",
    "symbol": "SMT",
    "decimals": 18
  },
  "networkId": 1,
  "rpc": ["https://20180430.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://jsonapi1.smartmesh.cn"],
  "shortName": "spectrum",
  "slug": "smartmesh",
  "testnet": false
};

var c20181205 = {
  "chain": "QKI",
  "chainId": 20181205,
  "explorers": [{
    "name": "qkiscan",
    "url": "https://qkiscan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://quarkblockchain.org/",
  "name": "quarkblockchain",
  "nativeCurrency": {
    "name": "quarkblockchain Native Token",
    "symbol": "QKI",
    "decimals": 18
  },
  "networkId": 20181205,
  "rpc": ["https://20181205.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://hz.rpc.qkiscan.cn", "https://jp.rpc.qkiscan.io", "https://rpc1.qkiscan.io", "https://rpc2.qkiscan.io", "https://rpc3.qkiscan.io"],
  "shortName": "qki",
  "slug": "quarkblockchain",
  "testnet": false
};

var c20201022 = {
  "chain": "PEGO",
  "chainId": 20201022,
  "explorers": [{
    "name": "Pego Network Explorer",
    "url": "https://scan.pego.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmVf1afskRHuZjFSLCZH8397KrVNAoYgyAePX9VMBrPVtx",
    "width": 246,
    "height": 247,
    "format": "png"
  },
  "infoURL": "https://pego.network",
  "name": "Pego Network",
  "nativeCurrency": {
    "name": "Pego Native Token",
    "symbol": "PG",
    "decimals": 18
  },
  "networkId": 20201022,
  "rpc": ["https://20201022.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://pegorpc.com", "https://node1.pegorpc.com", "https://node2.pegorpc.com", "https://node3.pegorpc.com"],
  "shortName": "pg",
  "slug": "pego-network",
  "testnet": false
};

var c20240324 = {
  "chain": "DeBank",
  "chainId": 20240324,
  "explorers": [{
    "name": "DeBank Chain Explorer",
    "url": "https://sepolia-explorer.testnet.debank.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmW9pBps8WHRRWmyXhjLZrjZJUe8F48hUu7z98bu2RVsjN",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "infoURL": "https://debank.com",
  "name": "DeBank Sepolia Testnet",
  "nativeCurrency": {
    "name": "DeBank USD",
    "symbol": "USD",
    "decimals": 18
  },
  "networkId": 20240324,
  "rpc": ["https://20240324.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sepolia-rpc.testnet.debank.com"],
  "shortName": "dbkse",
  "slip44": 1,
  "slug": "debank-sepolia-testnet",
  "testnet": true
};

var c20482050 = {
  "chain": "HokumTestnet",
  "chainId": 20482050,
  "explorers": [{
    "name": "Hokum Explorer",
    "url": "https://testnet-explorer.hokum.gg",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmafrUmh1FD48WWQwk6pfW1Y7eA9VQTdpeL387Wt2JFrAd",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://hokum.gg",
  "name": "Hokum Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 20482050,
  "rpc": ["https://20482050.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.hokum.gg"],
  "shortName": "hokum-testnet",
  "slug": "hokum-testnet",
  "testnet": true
};

var c22052002 = {
  "chain": "XLON",
  "chainId": 22052002,
  "explorers": [{
    "name": "Excelon explorer",
    "url": "https://explorer.excelon.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmTV45o4jTe6ayscF1XWh1WXk5DPck4QohR5kQocSWjvQP",
    "width": 300,
    "height": 300,
    "format": "png"
  },
  "infoURL": "https://xlon.org",
  "name": "Excelon Mainnet",
  "nativeCurrency": {
    "name": "Excelon",
    "symbol": "xlon",
    "decimals": 18
  },
  "networkId": 22052002,
  "rpc": ["https://22052002.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://edgewallet1.xlon.org/"],
  "shortName": "xlon",
  "slug": "excelon",
  "testnet": false
};

var c27082017 = {
  "chain": "TEXL",
  "chainId": 27082017,
  "explorers": [{
    "name": "exlscan",
    "url": "https://testnet-explorer.exlscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmeooM7QicT1YbgY93XPd5p7JsCjYhN3qjWt68X57g6bVC",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": ["https://faucet.exlscan.com"],
  "icon": {
    "url": "ipfs://QmeooM7QicT1YbgY93XPd5p7JsCjYhN3qjWt68X57g6bVC",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "name": "Excoincial Chain Volta-Testnet",
  "nativeCurrency": {
    "name": "TExlcoin",
    "symbol": "TEXL",
    "decimals": 18
  },
  "networkId": 27082017,
  "rpc": ["https://27082017.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.exlscan.com"],
  "shortName": "exlvolta",
  "slip44": 1,
  "slug": "excoincial-chain-volta-testnet",
  "testnet": true
};

var c27082022 = {
  "chain": "EXL",
  "chainId": 27082022,
  "explorers": [{
    "name": "exlscan",
    "url": "https://exlscan.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmeooM7QicT1YbgY93XPd5p7JsCjYhN3qjWt68X57g6bVC",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmeooM7QicT1YbgY93XPd5p7JsCjYhN3qjWt68X57g6bVC",
    "width": 400,
    "height": 400,
    "format": "png"
  },
  "name": "Excoincial Chain Mainnet",
  "nativeCurrency": {
    "name": "Exlcoin",
    "symbol": "EXL",
    "decimals": 18
  },
  "networkId": 27082022,
  "rpc": ["https://27082022.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.exlscan.com"],
  "shortName": "exl",
  "slug": "excoincial-chain",
  "testnet": false
};

var c28122024 = {
  "chain": "Ancient8",
  "chainId": 28122024,
  "explorers": [{
    "name": "scan-testnet",
    "url": "https://scanv2-testnet.ancient8.gg",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreievnqg3xjokaty4kfbxxbrzm5v5y7exbaaia2txrh4sfgrqsalfym",
    "width": 128,
    "height": 128,
    "format": "png"
  },
  "infoURL": "https://ancient8.gg/",
  "name": "Ancient8 Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 28122024,
  "rpc": ["https://28122024.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpcv2-testnet.ancient8.gg"],
  "shortName": "a8",
  "slip44": 1,
  "slug": "ancient8-testnet",
  "testnet": true
};

var c28945486 = {
  "chain": "AUX",
  "chainId": 28945486,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://auxilium.global",
  "name": "Auxilium Network Mainnet",
  "nativeCurrency": {
    "name": "Auxilium coin",
    "symbol": "AUX",
    "decimals": 18
  },
  "networkId": 28945486,
  "rpc": ["https://28945486.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.auxilium.global"],
  "shortName": "auxi",
  "slip44": 344,
  "slug": "auxilium-network",
  "testnet": false
};

var c29032022 = {
  "chain": "FLX",
  "chainId": 29032022,
  "explorers": [{
    "name": "FLXExplorer",
    "url": "https://explorer.flaexchange.top",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://bafybeiadlvc4pfiykehyt2z67nvgt5w4vlov27olu5obvmryv4xzua4tae",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://www.flaexchange.top",
  "name": "Flachain Mainnet",
  "nativeCurrency": {
    "name": "Flacoin",
    "symbol": "FLA",
    "decimals": 18
  },
  "networkId": 29032022,
  "rpc": ["https://29032022.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://flachain.flaexchange.top/"],
  "shortName": "fla",
  "slug": "flachain",
  "testnet": false
};

var c31415926 = {
  "chain": "FIL",
  "chainId": 31415926,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmS9r9XQkMHVomWcSBNDkKkz9n87h9bH9ssabeiKZtANoU",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://filecoin.io",
  "name": "Filecoin - Local testnet",
  "nativeCurrency": {
    "name": "testnet filecoin",
    "symbol": "tFIL",
    "decimals": 18
  },
  "networkId": 31415926,
  "rpc": [],
  "shortName": "filecoin-local",
  "slip44": 1,
  "slug": "filecoin-local-testnet",
  "status": "incubating",
  "testnet": true
};

var c35855456 = {
  "chain": "JOYS",
  "chainId": 35855456,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://joys.digital",
  "name": "Joys Digital Mainnet",
  "nativeCurrency": {
    "name": "JOYS",
    "symbol": "JOYS",
    "decimals": 18
  },
  "networkId": 35855456,
  "rpc": ["https://35855456.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://node.joys.digital"],
  "shortName": "JOYS",
  "slug": "joys-digital",
  "testnet": false
};

var c37084624 = {
  "chain": "lanky-ill-funny-testnet",
  "chainId": 37084624,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://lanky-ill-funny-testnet.explorer.testnet.skalenodes.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://www.sfuelstation.com/"],
  "icon": {
    "url": "ipfs://bafybeic5eexvd34wfy4kuebcyu73qpkv3x57s54ebzjyhyjsmeuni5jwcm",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://nebulachain.io/",
  "name": "SKALE Nebula Hub Testnet",
  "nativeCurrency": {
    "name": "sFUEL",
    "symbol": "sFUEL",
    "decimals": 18
  },
  "networkId": 37084624,
  "rpc": ["https://37084624.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.skalenodes.com/v1/lanky-ill-funny-testnet", "wss://testnet.skalenodes.com/v1/ws/lanky-ill-funny-testnet"],
  "shortName": "nebula-testnet",
  "slip44": 1,
  "slug": "skale-nebula-hub-testnet",
  "testnet": true,
  "title": "SKALE Nebula Hub Testnet"
};

var c43214913 = {
  "chain": "MAI",
  "chainId": 43214913,
  "explorers": [{
    "name": "maistesntet",
    "url": "http://174.138.9.169:3006/?network=maistesntet",
    "standard": "none"
  }],
  "faucets": [],
  "name": "maistestsubnet",
  "nativeCurrency": {
    "name": "maistestsubnet",
    "symbol": "MAI",
    "decimals": 18
  },
  "networkId": 43214913,
  "rpc": ["https://43214913.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://174.138.9.169:9650/ext/bc/VUKSzFZKckx4PoZF9gX5QAqLPxbLzvu1vcssPG5QuodaJtdHT/rpc"],
  "shortName": "mais",
  "slip44": 1,
  "slug": "maistestsubnet",
  "testnet": true
};

var c61717561 = {
  "chain": "AQUA",
  "chainId": 61717561,
  "explorers": [],
  "faucets": ["https://aquacha.in/faucet"],
  "infoURL": "https://aquachain.github.io",
  "name": "Aquachain",
  "nativeCurrency": {
    "name": "Aquachain Ether",
    "symbol": "AQUA",
    "decimals": 18
  },
  "networkId": 61717561,
  "rpc": ["https://61717561.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://c.onical.org", "https://tx.aquacha.in/api"],
  "shortName": "aqua",
  "slip44": 61717561,
  "slug": "aquachain",
  "testnet": false
};

var c65010000 = {
  "chain": "AUT",
  "chainId": 65010000,
  "explorers": [{
    "name": "autonity-blockscout",
    "url": "https://bakerloo.autonity.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.autonity.org/"],
  "icon": {
    "url": "ipfs://Qme5nxFZZoNNpiT8u9WwcBot4HyLTg2jxMxRnsbc5voQwB",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://autonity.org/",
  "name": "Autonity Bakerloo (Thames) Testnet",
  "nativeCurrency": {
    "name": "Bakerloo Auton",
    "symbol": "ATN",
    "decimals": 18
  },
  "networkId": 65010000,
  "rpc": [],
  "shortName": "bakerloo-0",
  "slip44": 1,
  "slug": "autonity-bakerloo-thames-testnet",
  "status": "deprecated",
  "testnet": true
};

var c65010001 = {
  "chain": "AUT",
  "chainId": 65010001,
  "explorers": [{
    "name": "autonity-blockscout",
    "url": "https://bakerloo.autonity.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.autonity.org/"],
  "icon": {
    "url": "ipfs://Qme5nxFZZoNNpiT8u9WwcBot4HyLTg2jxMxRnsbc5voQwB",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://autonity.org/",
  "name": "Autonity Bakerloo (Barada) Testnet",
  "nativeCurrency": {
    "name": "Bakerloo Auton",
    "symbol": "ATN",
    "decimals": 18
  },
  "networkId": 65010001,
  "rpc": [],
  "shortName": "bakerloo-01",
  "slip44": 1,
  "slug": "autonity-bakerloo-barada-testnet",
  "status": "deprecated",
  "testnet": true
};

var c65010002 = {
  "chain": "AUT",
  "chainId": 65010002,
  "explorers": [{
    "name": "autonity-blockscout",
    "url": "https://bakerloo.autonity.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.autonity.org/"],
  "icon": {
    "url": "ipfs://Qme5nxFZZoNNpiT8u9WwcBot4HyLTg2jxMxRnsbc5voQwB",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://autonity.org/",
  "name": "Autonity Bakerloo (Sumida) Testnet",
  "nativeCurrency": {
    "name": "Bakerloo Auton",
    "symbol": "ATN",
    "decimals": 18
  },
  "networkId": 65010002,
  "rpc": ["https://65010002.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc1.bakerloo.autonity.org/", "wss://rpc1.bakerloo.autonity.org/ws/"],
  "shortName": "bakerloo-02",
  "slip44": 1,
  "slug": "autonity-bakerloo-sumida-testnet",
  "testnet": true
};

var c65100000 = {
  "chain": "AUT",
  "chainId": 65100000,
  "explorers": [{
    "name": "autonity-blockscout",
    "url": "https://piccadilly.autonity.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.autonity.org/"],
  "icon": {
    "url": "ipfs://Qme5nxFZZoNNpiT8u9WwcBot4HyLTg2jxMxRnsbc5voQwB",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://autonity.org/",
  "name": "Autonity Piccadilly (Thames) Testnet",
  "nativeCurrency": {
    "name": "Piccadilly Auton",
    "symbol": "ATN",
    "decimals": 18
  },
  "networkId": 65100000,
  "rpc": [],
  "shortName": "piccadilly-0",
  "slip44": 1,
  "slug": "autonity-piccadilly-thames-testnet",
  "status": "deprecated",
  "testnet": true
};

var c65100001 = {
  "chain": "AUT",
  "chainId": 65100001,
  "explorers": [{
    "name": "autonity-blockscout",
    "url": "https://piccadilly.autonity.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qme5nxFZZoNNpiT8u9WwcBot4HyLTg2jxMxRnsbc5voQwB",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://autonity.org/",
  "name": "Autonity Piccadilly (Barada) Testnet",
  "nativeCurrency": {
    "name": "Piccadilly Auton",
    "symbol": "ATN",
    "decimals": 18
  },
  "networkId": 65100001,
  "rpc": [],
  "shortName": "piccadilly-01",
  "slip44": 1,
  "slug": "autonity-piccadilly-barada-testnet",
  "status": "deprecated",
  "testnet": true
};

var c65100002 = {
  "chain": "AUT",
  "chainId": 65100002,
  "explorers": [{
    "name": "autonity-blockscout",
    "url": "https://piccadilly.autonity.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qme5nxFZZoNNpiT8u9WwcBot4HyLTg2jxMxRnsbc5voQwB",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://autonity.org/",
  "name": "Autonity Piccadilly (Sumida) Testnet",
  "nativeCurrency": {
    "name": "Piccadilly Auton",
    "symbol": "ATN",
    "decimals": 18
  },
  "networkId": 65100002,
  "rpc": ["https://65100002.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc1.piccadilly.autonity.org/", "wss://rpc1.piccadilly.autonity.org/ws/"],
  "shortName": "piccadilly-02",
  "slip44": 1,
  "slug": "autonity-piccadilly-sumida-testnet",
  "testnet": true
};

var c68840142 = {
  "chain": "ETH",
  "chainId": 68840142,
  "explorers": [{
    "name": "Frame Testnet Explorer",
    "url": "https://explorer.testnet.frame.xyz",
    "standard": "EIP3091"
  }, {
    "name": "Frame Testnet Explorer",
    "url": "https://explorer.testnet.frame.xyz/",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.triangleplatform.com/frame/testnet", "https://faucet.triangleplatform.com/frame"],
  "features": [],
  "icon": {
    "url": "ipfs://QmRxeKFwBwrXyDksoN4NzNRp3R35s8pVnTBfBj4AJSCq5g",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://frame.xyz",
  "name": "Frame Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 68840142,
  "redFlags": [],
  "rpc": ["https://68840142.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.testnet.frame.xyz/http"],
  "shortName": "frame-test",
  "slip44": 1,
  "slug": "frame-testnet",
  "testnet": true
};

var c77787778 = {
  "chain": "HETH",
  "chainId": 77787778,
  "explorers": [{
    "name": "blockscout",
    "url": "https://test.0xhashscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt",
    "width": 1000,
    "height": 1628,
    "format": "png"
  },
  "infoURL": "https://0xhash.io",
  "name": "0xHash Testnet",
  "nativeCurrency": {
    "name": "0xHash",
    "symbol": "HETH",
    "decimals": 18
  },
  "networkId": 77787778,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://app.optimism.io/bridge/deposit"
    }]
  },
  "rpc": ["https://77787778.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-test.0xhash.io"],
  "shortName": "HETH",
  "slip44": 1,
  "slug": "0xhash-testnet",
  "testnet": true
};

var c88888888 = {
  "chain": "TEAM",
  "chainId": 88888888,
  "explorers": [{
    "name": "teamscan",
    "url": "https://teamblockchain.team",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }, {
    "name": "EIP1559"
  }],
  "icon": {
    "url": "ipfs://QmcnA15BLE9uvznbugXKjqquizZs1eLPeEEkc92DSmvhmt",
    "width": 248,
    "height": 248,
    "format": "png"
  },
  "infoURL": "https://teamblockchain.team",
  "name": "T.E.A.M Blockchain",
  "nativeCurrency": {
    "name": "TEAM",
    "symbol": "$TEAM",
    "decimals": 18
  },
  "networkId": 88888888,
  "rpc": ["https://88888888.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.teamblockchain.team"],
  "shortName": "team",
  "slug": "t-e-a-m-blockchain",
  "testnet": false
};

var c94204209 = {
  "chain": "ETH",
  "chainId": 94204209,
  "explorers": [{
    "name": "blockscout",
    "url": "https://polygon-blackberry.gelatoscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }, {
    "name": "blockscout",
    "url": "https://polygon-blackberry.gelatoscout.com/",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYotcuJYjUBXZ33CYoWMyNnJbjK14f8ma6sge55Z5bg5W/polygon-blackberry.svg",
      "width": 300,
      "height": 300,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmYotcuJYjUBXZ33CYoWMyNnJbjK14f8ma6sge55Z5bg5W/polygon-blackberry.svg",
    "width": 300,
    "height": 300,
    "format": "svg"
  },
  "infoURL": "https://raas.gelato.network/rollups/details/public/polygon-blackberry",
  "name": "Polygon Blackberry",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 94204209,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": [{
      "url": "https://bridge.gelato.network/bridge/polygon-blackberry"
    }]
  },
  "redFlags": [],
  "rpc": ["https://94204209.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.polygon-blackberry.gelato.digital", "wss://ws.polygon-blackberry.gelato.digital"],
  "shortName": "polygon-blackberry",
  "slip44": 60,
  "slug": "polygon-blackberry",
  "status": "active",
  "testnet": true,
  "title": "Polygon Blackberry Testnet"
};

var c99415706 = {
  "chain": "TOYS",
  "chainId": 99415706,
  "explorers": [],
  "faucets": ["https://faucet.joys.digital/"],
  "infoURL": "https://joys.digital",
  "name": "Joys Digital TestNet",
  "nativeCurrency": {
    "name": "TOYS",
    "symbol": "TOYS",
    "decimals": 18
  },
  "networkId": 99415706,
  "rpc": ["https://99415706.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://toys.joys.cash/"],
  "shortName": "TOYS",
  "slip44": 1,
  "slug": "joys-digital-testnet",
  "testnet": true
};

var c123420111 = {
  "chain": "ETH",
  "chainId": 123420111,
  "explorers": [{
    "name": "blockscout",
    "url": "https://opcelestia-raspberry.gelatoscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmQXw4QEDR4AbUwX9scH7aGhiSDhQRxu6LCQoUkgsYgGyK/Gelato%20brand%20mark.png",
    "width": 300,
    "height": 300,
    "format": "png"
  },
  "infoURL": "https://raas.gelato.network/rollups/details/public/opcelestia-raspberry",
  "name": "OP Celestia Rasberry",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 123420111,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": [{
      "url": "https://bridge.gelato.network/bridge/opcelestia-raspberry"
    }]
  },
  "redFlags": [],
  "rpc": ["https://123420111.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.opcelestia-raspberry.gelato.digital", "wss://ws.opcelestia-raspberry.gelato.digital"],
  "shortName": "opcelestia-rasberry",
  "slip44": 60,
  "slug": "op-celestia-rasberry",
  "status": "active",
  "testnet": true,
  "title": "OP Celestia Rasberry"
};

var c161221135 = {
  "chain": "ETH",
  "chainId": 161221135,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://testnet-explorer.plumenetwork.xyz",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNUpqkYWYJoDXKUpZ8FVbGyN6HCwxYonKNAieCf2oTzGn",
    "width": 1062,
    "height": 1062,
    "format": "png"
  },
  "infoURL": "https://www.plumenetwork.xyz/",
  "name": "Plume Testnet",
  "nativeCurrency": {
    "name": "Plume Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 161221135,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": [{
      "url": "https://testnet-bridge.plumenetwork.xyz"
    }]
  },
  "rpc": ["https://161221135.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.plumenetwork.xyz/http", "wss://testnet-rpc.plumenetwork.xyz/ws"],
  "shortName": "plume-testnet",
  "slip44": 1,
  "slug": "plume-testnet",
  "testnet": true,
  "title": "Plume Sepolia Rollup Testnet"
};

var c168587773 = {
  "chain": "ETH",
  "chainId": 168587773,
  "explorers": [{
    "name": "Blast Sepolia Explorer",
    "url": "https://testnet.blastscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://bafybeifc2h3x7jgy4x4nmg2m54ghbvmkfu6oweujambwefzqzew5vujhsi",
      "width": 400,
      "height": 400,
      "format": "jpg"
    }
  }],
  "faucets": ["https://faucet.quicknode.com/blast/sepolia"],
  "icon": {
    "url": "ipfs://bafybeifc2h3x7jgy4x4nmg2m54ghbvmkfu6oweujambwefzqzew5vujhsi",
    "width": 400,
    "height": 400,
    "format": "jpg"
  },
  "infoURL": "https://blast.io/",
  "name": "Blast Sepolia Testnet",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 168587773,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111"
  },
  "rpc": ["https://168587773.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sepolia.blast.io", "https://blast-sepolia.drpc.org", "wss://blast-sepolia.drpc.org"],
  "shortName": "blastsepolia",
  "slug": "blast-sepolia-testnet",
  "testnet": true
};

var c192837465 = {
  "chain": "GTH",
  "chainId": 192837465,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://explorer.gather.network",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmTYR8CeFiNbJ1zJHnE3DK2wEN18r2y2vqSKUcLweUT2Gz",
      "width": 1080,
      "height": 1080,
      "format": "svg"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://Qmc9AJGg9aNhoH56n3deaZeUc8Ty1jDYJsW6Lu6hgSZH4S",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://gather.network",
  "name": "Gather Mainnet Network",
  "nativeCurrency": {
    "name": "Gather",
    "symbol": "GTH",
    "decimals": 18
  },
  "networkId": 192837465,
  "redFlags": [],
  "rpc": ["https://192837465.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.gather.network"],
  "shortName": "GTH",
  "slug": "gather-network",
  "testnet": false
};

var c222000222 = {
  "chain": "Kanazawa",
  "chainId": 222000222,
  "explorers": [{
    "name": "explorer",
    "url": "https://testnet.meldscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRhB4AbjDrhvwfSAQi2JvKirFiDWxzJvKEvG8S8AdDdED",
      "width": 4000,
      "height": 4000,
      "format": "png"
    }
  }, {
    "name": "explorer",
    "url": "https://subnets-test.avax.network/meld",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRhB4AbjDrhvwfSAQi2JvKirFiDWxzJvKEvG8S8AdDdED",
      "width": 4000,
      "height": 4000,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmRhB4AbjDrhvwfSAQi2JvKirFiDWxzJvKEvG8S8AdDdED",
    "width": 4000,
    "height": 4000,
    "format": "png"
  },
  "infoURL": "https://meld.com",
  "name": "Kanazawa",
  "nativeCurrency": {
    "name": "gMeld",
    "symbol": "gMELD",
    "decimals": 18
  },
  "networkId": 222000222,
  "rpc": ["https://222000222.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-rpc.meld.com"],
  "shortName": "kanazawa",
  "slip44": 1,
  "slug": "kanazawa",
  "testnet": true,
  "title": "Meld Testnet Kanazawa"
};

var c245022926 = {
  "chain": "Solana",
  "chainId": 245022926,
  "explorers": [{
    "name": "blockscout",
    "url": "https://neon-devnet.blockscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }, {
    "name": "neonscan",
    "url": "https://devnet.neonscan.org",
    "standard": "EIP3091"
  }],
  "faucets": ["https://neonfaucet.org"],
  "icon": {
    "url": "ipfs://Qmcxevb3v8PEvnvfYgcG3bCBuPhe5YAdsHeaufDChSSR3Q",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://neon-labs.org",
  "name": "Neon EVM Devnet",
  "nativeCurrency": {
    "name": "Neon",
    "symbol": "NEON",
    "decimals": 18
  },
  "networkId": 245022926,
  "rpc": ["https://245022926.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnet.neonevm.org", "https://neon-evm-devnet.drpc.org", "wss://neon-evm-devnet.drpc.org"],
  "shortName": "neonevm-devnet",
  "slug": "neon-evm-devnet",
  "testnet": false
};

var c245022934 = {
  "chain": "Solana",
  "chainId": 245022934,
  "explorers": [{
    "name": "neonscan",
    "url": "https://neonscan.org",
    "standard": "EIP3091"
  }, {
    "name": "native",
    "url": "https://neon.blockscout.com",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmcxevb3v8PEvnvfYgcG3bCBuPhe5YAdsHeaufDChSSR3Q",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://neonevm.org",
  "name": "Neon EVM Mainnet",
  "nativeCurrency": {
    "name": "Neon",
    "symbol": "NEON",
    "decimals": 18
  },
  "networkId": 245022934,
  "rpc": ["https://245022934.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://neon-proxy-mainnet.solana.p2p.org", "https://neon-evm.drpc.org", "wss://neon-evm.drpc.org"],
  "shortName": "neonevm-mainnet",
  "slug": "neon-evm",
  "testnet": false
};

var c245022940 = {
  "chain": "Solana",
  "chainId": 245022940,
  "explorers": [{
    "name": "native",
    "url": "https://testnet.explorer.neon-labs.org",
    "standard": "EIP3091"
  }, {
    "name": "neonscan",
    "url": "https://testnet.neonscan.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmcxevb3v8PEvnvfYgcG3bCBuPhe5YAdsHeaufDChSSR3Q",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://neon-labs.org",
  "name": "Neon EVM TestNet",
  "nativeCurrency": {
    "name": "Neon",
    "symbol": "NEON",
    "decimals": 18
  },
  "networkId": 245022940,
  "rpc": ["https://245022940.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.neonevm.org"],
  "shortName": "neonevm-testnet",
  "slip44": 1,
  "slug": "neon-evm-testnet",
  "status": "deprecated",
  "testnet": true
};

var c278611351 = {
  "chain": "Razor Schain",
  "chainId": 278611351,
  "explorers": [{
    "name": "turbulent-unique-scheat",
    "url": "https://turbulent-unique-scheat.explorer.mainnet.skalenodes.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.razorscan.io/"],
  "icon": {
    "url": "ipfs://QmUdwAZJfyKGZnfPGDsCnNvGu123mdd57kTGj1Y3EWVuWK",
    "width": 900,
    "height": 900,
    "format": "png"
  },
  "infoURL": "https://razor.network",
  "name": "Razor Skale Chain",
  "nativeCurrency": {
    "name": "sFuel",
    "symbol": "SFUEL",
    "decimals": 18
  },
  "networkId": 278611351,
  "rpc": ["https://278611351.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.skalenodes.com/v1/turbulent-unique-scheat"],
  "shortName": "razor",
  "slug": "razor-skale-chain",
  "testnet": false
};

var c311752642 = {
  "chain": "OLT",
  "chainId": 311752642,
  "explorers": [{
    "name": "OneLedger Block Explorer",
    "url": "https://mainnet-explorer.oneledger.network",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmRhqq4Gp8G9w27ND3LeFW49o5PxcxrbJsqHbpBFtzEMfC",
    "width": 225,
    "height": 225,
    "format": "png"
  },
  "infoURL": "https://oneledger.io",
  "name": "OneLedger Mainnet",
  "nativeCurrency": {
    "name": "OLT",
    "symbol": "OLT",
    "decimals": 18
  },
  "networkId": 311752642,
  "rpc": ["https://311752642.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet-rpc.oneledger.network"],
  "shortName": "oneledger",
  "slug": "oneledger",
  "testnet": false
};

var c333000333 = {
  "chain": "MELD",
  "chainId": 333000333,
  "explorers": [{
    "name": "explorer",
    "url": "https://meldscan.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRhB4AbjDrhvwfSAQi2JvKirFiDWxzJvKEvG8S8AdDdED",
      "width": 4000,
      "height": 4000,
      "format": "png"
    }
  }, {
    "name": "explorer",
    "url": "https://subnets.avax.network/meld",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmRhB4AbjDrhvwfSAQi2JvKirFiDWxzJvKEvG8S8AdDdED",
      "width": 4000,
      "height": 4000,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmRhB4AbjDrhvwfSAQi2JvKirFiDWxzJvKEvG8S8AdDdED",
    "width": 4000,
    "height": 4000,
    "format": "png"
  },
  "infoURL": "https://meld.com",
  "name": "Meld",
  "nativeCurrency": {
    "name": "gMeld",
    "symbol": "gMELD",
    "decimals": 18
  },
  "networkId": 333000333,
  "rpc": ["https://333000333.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-1.meld.com"],
  "shortName": "meld",
  "slug": "meld",
  "testnet": false,
  "title": "Meld Mainnet"
};

var c344106930 = {
  "chain": "staging-utter-unripe-menkar",
  "chainId": 344106930,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://staging-utter-unripe-menkar.explorer.staging-v3.skalenodes.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://sfuel.dirtroad.dev/staging"],
  "icon": {
    "url": "ipfs://bafybeigyayzxvt7vosat4rtrbmhhnldgx57w2pfbutuniax7h6kswzi42m",
    "width": 1637,
    "height": 1636,
    "format": "png"
  },
  "infoURL": "https://calypsohub.network/",
  "name": "Deprecated SKALE Calypso Hub Testnet",
  "nativeCurrency": {
    "name": "sFUEL",
    "symbol": "sFUEL",
    "decimals": 18
  },
  "networkId": 344106930,
  "rpc": ["https://344106930.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://staging-v3.skalenodes.com/v1/staging-utter-unripe-menkar"],
  "shortName": "deprected-calypso-testnet",
  "slip44": 1,
  "slug": "deprecated-skale-calypso-hub-testnet",
  "status": "deprecated",
  "testnet": true,
  "title": "Deprecated Calypso NFT Hub Testnet"
};

var c356256156 = {
  "chain": "GTH",
  "chainId": 356256156,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://testnet-explorer.gather.network",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmTYR8CeFiNbJ1zJHnE3DK2wEN18r2y2vqSKUcLweUT2Gz",
      "width": 1080,
      "height": 1080,
      "format": "svg"
    }
  }],
  "faucets": ["https://testnet-faucet.gather.network/"],
  "features": [],
  "icon": {
    "url": "ipfs://Qmc9AJGg9aNhoH56n3deaZeUc8Ty1jDYJsW6Lu6hgSZH4S",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://gather.network",
  "name": "Gather Testnet Network",
  "nativeCurrency": {
    "name": "Gather",
    "symbol": "GTH",
    "decimals": 18
  },
  "networkId": 356256156,
  "redFlags": [],
  "rpc": ["https://356256156.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.gather.network"],
  "shortName": "tGTH",
  "slip44": 1,
  "slug": "gather-testnet-network",
  "testnet": true
};

var c476158412 = {
  "chain": "staging-legal-crazy-castor",
  "chainId": 476158412,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://staging-legal-crazy-castor.explorer.staging-v3.skalenodes.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://sfuel.dirtroad.dev/staging"],
  "icon": {
    "url": "ipfs://bafkreiezcwowhm6xjrkt44cmiu6ml36rhrxx3amcg3cfkcntv2vgcvgbre",
    "width": 600,
    "height": 600,
    "format": "png"
  },
  "infoURL": "https://europahub.network/",
  "name": "Deprecated SKALE Europa Hub Testnet",
  "nativeCurrency": {
    "name": "sFUEL",
    "symbol": "sFUEL",
    "decimals": 18
  },
  "networkId": 476158412,
  "rpc": ["https://476158412.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://staging-v3.skalenodes.com/v1/staging-legal-crazy-castor"],
  "shortName": "deprecated-europa-testnet",
  "slip44": 1,
  "slug": "deprecated-skale-europa-hub-testnet",
  "status": "deprecated",
  "testnet": true,
  "title": "Deprecated Europa Hub Testnet"
};

var c486217935 = {
  "chain": "GTH",
  "chainId": 486217935,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://devnet-explorer.gather.network",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://gather.network",
  "name": "Gather Devnet Network",
  "nativeCurrency": {
    "name": "Gather",
    "symbol": "GTH",
    "decimals": 18
  },
  "networkId": 486217935,
  "rpc": ["https://486217935.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://devnet.gather.network"],
  "shortName": "dGTH",
  "slug": "gather-devnet-network",
  "testnet": false
};

var c503129905 = {
  "chain": "staging-faint-slimy-achird",
  "chainId": 503129905,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://staging-faint-slimy-achird.explorer.staging-v3.skalenodes.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://sfuel.dirtroad.dev/staging"],
  "icon": {
    "url": "ipfs://bafybeic5eexvd34wfy4kuebcyu73qpkv3x57s54ebzjyhyjsmeuni5jwcm",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://nebulachain.io/",
  "name": "Deprecated SKALE Nebula Hub Testnet",
  "nativeCurrency": {
    "name": "sFUEL",
    "symbol": "sFUEL",
    "decimals": 18
  },
  "networkId": 503129905,
  "rpc": ["https://503129905.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://staging-v3.skalenodes.com/v1/staging-faint-slimy-achird", "wss://staging-v3.skalenodes.com/v1/ws/staging-faint-slimy-achird"],
  "shortName": "deprecated-nebula-testnet",
  "slip44": 1,
  "slug": "deprecated-skale-nebula-hub-testnet",
  "status": "deprecated",
  "testnet": true
};

var c666666666 = {
  "chain": "Degen",
  "chainId": 666666666,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://Qmb6yAe4wXeBkxjfhxzoUT9TzETcmE7Vne59etm9GJaQf7",
    "width": 789,
    "height": 668,
    "format": "svg"
  },
  "infoURL": "https://degen.tips",
  "name": "Degen Chain",
  "nativeCurrency": {
    "name": "DEGEN",
    "symbol": "DEGEN",
    "decimals": 18
  },
  "networkId": 666666666,
  "rpc": ["https://666666666.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.degen.tips"],
  "shortName": "degen-chain",
  "slug": "degen-chain",
  "status": "incubating",
  "testnet": false,
  "title": "Degen Chain"
};

var c888888888 = {
  "chain": "Ancient8",
  "chainId": 888888888,
  "explorers": [{
    "name": "Ancient8 Explorer",
    "url": "https://scan.ancient8.gg",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreievnqg3xjokaty4kfbxxbrzm5v5y7exbaaia2txrh4sfgrqsalfym",
    "width": 128,
    "height": 128,
    "format": "png"
  },
  "infoURL": "https://ancient8.gg/",
  "name": "Ancient8",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 888888888,
  "rpc": ["https://888888888.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.ancient8.gg"],
  "shortName": "ancient8",
  "slug": "ancient8",
  "testnet": false
};

var c889910245 = {
  "chain": "PTCE",
  "chainId": 889910245,
  "explorers": [{
    "name": "PTCESCAN Testnet Explorer",
    "url": "https://explorer-testnet.ptcscan.io",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.ptcscan.io/"],
  "infoURL": "https://ptcscan.io",
  "name": "PTCESCAN Testnet",
  "nativeCurrency": {
    "name": "PTCE",
    "symbol": "PTCE",
    "decimals": 18
  },
  "networkId": 889910245,
  "rpc": ["https://889910245.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.ptcscan.io"],
  "shortName": "PTCE",
  "slug": "ptcescan-testnet",
  "testnet": true,
  "title": "PTCESCAN Testnet"
};

var c974399131 = {
  "chain": "giant-half-dual-testnet",
  "chainId": 974399131,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://giant-half-dual-testnet.explorer.testnet.skalenodes.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://www.sfuelstation.com/"],
  "icon": {
    "url": "ipfs://bafybeigyayzxvt7vosat4rtrbmhhnldgx57w2pfbutuniax7h6kswzi42m",
    "width": 1637,
    "height": 1636,
    "format": "png"
  },
  "infoURL": "https://calypsohub.network/",
  "name": "SKALE Calypso Hub Testnet",
  "nativeCurrency": {
    "name": "sFUEL",
    "symbol": "sFUEL",
    "decimals": 18
  },
  "networkId": 974399131,
  "rpc": ["https://974399131.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.skalenodes.com/v1/giant-half-dual-testnet"],
  "shortName": "calypso-testnet",
  "slip44": 1,
  "slug": "skale-calypso-hub-testnet",
  "testnet": true,
  "title": "SKALE Calypso Hub Testnet"
};

var c999999999 = {
  "chain": "ETH",
  "chainId": 999999999,
  "explorers": [{
    "name": "Zora Sepolia Testnet Network Explorer",
    "url": "https://sepolia.explorer.zora.energy",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreifvrly5tgd34xqeo67s4etmiu52bkroml7uy7eosizf57htf5nrzq",
    "width": 250,
    "height": 250,
    "format": "png"
  },
  "infoURL": "https://zora.energy",
  "name": "Zora Sepolia Testnet",
  "nativeCurrency": {
    "name": "Sepolia Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 999999999,
  "rpc": ["https://999999999.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://sepolia.rpc.zora.energy"],
  "shortName": "zsep",
  "slip44": 1,
  "slug": "zora-sepolia-testnet",
  "testnet": true
};

var c1020352220 = {
  "chain": "aware-fake-trim-testnet",
  "chainId": 1020352220,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://aware-fake-trim-testnet.explorer.testnet.skalenodes.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://www.sfuelstation.com/"],
  "icon": {
    "url": "ipfs://bafkreiagrt5dhgltg2kmw7hf24kslstr5h42e745luuxwp2wbg24gm6zza",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "name": "SKALE Titan Hub Testnet",
  "nativeCurrency": {
    "name": "sFUEL",
    "symbol": "sFUEL",
    "decimals": 18
  },
  "networkId": 1020352220,
  "rpc": ["https://1020352220.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.skalenodes.com/v1/aware-fake-trim-testnet", "wss://testnet.skalenodes.com/v1/ws/aware-fake-trim-testnet"],
  "shortName": "titan-testnet",
  "slip44": 1,
  "slug": "skale-titan-hub-testnet",
  "testnet": true,
  "title": "SKALE Titan Hub Testnet"
};

var c1122334455 = {
  "chain": "IPOS",
  "chainId": 1122334455,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://iposlab.com",
  "name": "IPOS Network",
  "nativeCurrency": {
    "name": "IPOS Network Ether",
    "symbol": "IPOS",
    "decimals": 18
  },
  "networkId": 1122334455,
  "rpc": ["https://1122334455.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.iposlab.com", "https://rpc2.iposlab.com"],
  "shortName": "ipos",
  "slug": "ipos-network",
  "testnet": false
};

var c1146703430 = {
  "chain": "cyberdeck",
  "chainId": 1146703430,
  "explorers": [{
    "name": "CybEthExplorer",
    "url": "http://cybeth1.cyberdeck.eu:8000",
    "standard": "none",
    "icon": {
      "url": "ipfs://QmTvYMJXeZeWxYPuoQ15mHCS8K5EQzkMMCHQVs3GshooyR",
      "width": 193,
      "height": 214,
      "format": "png"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmTvYMJXeZeWxYPuoQ15mHCS8K5EQzkMMCHQVs3GshooyR",
    "width": 193,
    "height": 214,
    "format": "png"
  },
  "infoURL": "https://cyberdeck.eu",
  "name": "CyberdeckNet",
  "nativeCurrency": {
    "name": "Cyb",
    "symbol": "CYB",
    "decimals": 18
  },
  "networkId": 1146703430,
  "rpc": ["https://1146703430.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "http://cybeth1.cyberdeck.eu:8545"],
  "shortName": "cyb",
  "slug": "cyberdecknet",
  "status": "active",
  "testnet": false
};

var c1273227453 = {
  "chain": "wan-red-ain",
  "chainId": 1273227453,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://wan-red-ain.explorer.mainnet.skalenodes.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmT5KKrpNt6duU8QfwaYw3xf4ifTBPtjahpWsMi3gsFmcS",
      "width": 440,
      "height": 600,
      "format": "png"
    }
  }],
  "faucets": ["https://dashboard.humanprotocol.org/faucet"],
  "infoURL": "https://www.humanprotocol.org",
  "name": "HUMAN Protocol",
  "nativeCurrency": {
    "name": "sFUEL",
    "symbol": "sFUEL",
    "decimals": 18
  },
  "networkId": 1273227453,
  "rpc": ["https://1273227453.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.skalenodes.com/v1/wan-red-ain"],
  "shortName": "human-mainnet",
  "slug": "human-protocol",
  "testnet": false,
  "title": "HUMAN Protocol"
};

var c1313161554 = {
  "chain": "NEAR",
  "chainId": 1313161554,
  "explorers": [{
    "name": "aurorascan.dev",
    "url": "https://aurorascan.dev",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://aurora.dev",
  "name": "Aurora Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1313161554,
  "rpc": ["https://1313161554.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.aurora.dev", "https://aurora.drpc.org", "wss://aurora.drpc.org"],
  "shortName": "aurora",
  "slug": "aurora",
  "testnet": false
};

var c1313161555 = {
  "chain": "NEAR",
  "chainId": 1313161555,
  "explorers": [{
    "name": "aurorascan.dev",
    "url": "https://testnet.aurorascan.dev",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://aurora.dev",
  "name": "Aurora Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1313161555,
  "rpc": ["https://1313161555.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.aurora.dev/", "https://aurora-testnet.drpc.org", "wss://aurora-testnet.drpc.org"],
  "shortName": "aurora-testnet",
  "slip44": 1,
  "slug": "aurora-testnet",
  "testnet": true
};

var c1313161556 = {
  "chain": "NEAR",
  "chainId": 1313161556,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://aurora.dev",
  "name": "Aurora Betanet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1313161556,
  "rpc": [],
  "shortName": "aurora-betanet",
  "slug": "aurora-betanet",
  "testnet": false
};

var c1313161560 = {
  "chain": "NEAR",
  "chainId": 1313161560,
  "explorers": [{
    "name": "PowerGold explorer",
    "url": "https://explorer.powergold.aurora.dev",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreib2sabb6vgfoskobp2wdr6if7v6s34f2xwjecfceui6qhjudmu4u4",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://www.powergold.tech",
  "name": "PowerGold",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1313161560,
  "rpc": ["https://1313161560.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://powergold.aurora.dev"],
  "shortName": "powergold",
  "slug": "powergold",
  "testnet": false
};

var c1350216234 = {
  "chain": "parallel-stormy-spica",
  "chainId": 1350216234,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://parallel-stormy-spica.explorer.mainnet.skalenodes.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://sfuel.skale.network/"],
  "icon": {
    "url": "ipfs://bafkreiagrt5dhgltg2kmw7hf24kslstr5h42e745luuxwp2wbg24gm6zza",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "name": "SKALE Titan Hub",
  "nativeCurrency": {
    "name": "sFUEL",
    "symbol": "sFUEL",
    "decimals": 18
  },
  "networkId": 1350216234,
  "rpc": ["https://1350216234.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.skalenodes.com/v1/parallel-stormy-spica", "wss://mainnet.skalenodes.com/v1/ws/parallel-stormy-spica"],
  "shortName": "titan-mainnet",
  "slug": "skale-titan-hub",
  "testnet": false
};

var c1351057110 = {
  "chain": "staging-fast-active-bellatrix",
  "chainId": 1351057110,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://staging-fast-active-bellatrix.explorer.staging-v3.skalenodes.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmbYYCoU2G4LUfRr9ofGowF3eatfvWv9FiPVhqKndZeqwA",
      "width": 400,
      "height": 400,
      "format": "png"
    }
  }],
  "faucets": ["https://sfuel.skale.network/staging/chaos"],
  "infoURL": "https://docs.skale.network/develop/",
  "name": "Chaos (SKALE Testnet)",
  "nativeCurrency": {
    "name": "sFUEL",
    "symbol": "sFUEL",
    "decimals": 18
  },
  "networkId": 1351057110,
  "rpc": ["https://1351057110.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://staging-v3.skalenodes.com/v1/staging-fast-active-bellatrix"],
  "shortName": "chaos-tenet",
  "slip44": 1,
  "slug": "chaos-skale-testnet",
  "testnet": true,
  "title": "Chaos Testnet"
};

var c1380012617 = {
  "chain": "Rari",
  "chainId": 1380012617,
  "explorers": [],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmdAX6818vZ3bAsPRv1DZGrc7qc8XTrgCnRLWrMecixhXb/RARI%20Chain%20Logomark%20Color.png",
    "width": 512,
    "height": 512,
    "format": "png"
  },
  "infoURL": "https://rari-mainnet.caldera.dev/",
  "name": "Rari Mainnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1380012617,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://rari.calderabridge.xyz/"
    }]
  },
  "redFlags": [],
  "rpc": ["https://1380012617.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.rpc.rarichain.org/http"],
  "shortName": "rari",
  "slug": "rari",
  "testnet": false
};

var c1380996178 = {
  "chain": "RPTR",
  "chainId": 1380996178,
  "explorers": [{
    "name": "RaptorChain Explorer",
    "url": "https://explorer.raptorchain.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmQuvmiN6vM6Rqzqe1pMzDf8iZXqTtSeqCgGe5k5AyksDU",
      "width": 200,
      "height": 200,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [{
    "name": "EIP155"
  }],
  "icon": {
    "url": "ipfs://QmQuvmiN6vM6Rqzqe1pMzDf8iZXqTtSeqCgGe5k5AyksDU",
    "width": 200,
    "height": 200,
    "format": "png"
  },
  "infoURL": "https://raptorchain.io",
  "name": "RaptorChain",
  "nativeCurrency": {
    "name": "Raptor",
    "symbol": "RPTR",
    "decimals": 18
  },
  "networkId": 1380996178,
  "rpc": ["https://1380996178.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.raptorchain.io/web3"],
  "shortName": "rptr",
  "slug": "raptorchain",
  "testnet": false
};

var c1444673419 = {
  "chain": "juicy-low-small-testnet",
  "chainId": 1444673419,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://juicy-low-small-testnet.explorer.testnet.skalenodes.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://www.sfuelstation.com/"],
  "icon": {
    "url": "ipfs://bafkreiezcwowhm6xjrkt44cmiu6ml36rhrxx3amcg3cfkcntv2vgcvgbre",
    "width": 600,
    "height": 600,
    "format": "png"
  },
  "infoURL": "https://europahub.network/",
  "name": "SKALE Europa Hub Testnet",
  "nativeCurrency": {
    "name": "sFUEL",
    "symbol": "sFUEL",
    "decimals": 18
  },
  "networkId": 1444673419,
  "rpc": ["https://1444673419.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.skalenodes.com/v1/juicy-low-small-testnet"],
  "shortName": "europa-testnet",
  "slip44": 1,
  "slug": "skale-europa-hub-testnet",
  "testnet": true,
  "title": "SKALE Europa Hub Testnet"
};

var c1482601649 = {
  "chain": "green-giddy-denebola",
  "chainId": 1482601649,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://green-giddy-denebola.explorer.mainnet.skalenodes.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://sfuel.skale.network/"],
  "icon": {
    "url": "ipfs://bafybeic5eexvd34wfy4kuebcyu73qpkv3x57s54ebzjyhyjsmeuni5jwcm",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "infoURL": "https://nebulachain.io/",
  "name": "SKALE Nebula Hub",
  "nativeCurrency": {
    "name": "sFUEL",
    "symbol": "sFUEL",
    "decimals": 18
  },
  "networkId": 1482601649,
  "rpc": ["https://1482601649.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.skalenodes.com/v1/green-giddy-denebola", "wss://mainnet-proxy.skalenodes.com/v1/ws/green-giddy-denebola"],
  "shortName": "nebula-mainnet",
  "slug": "skale-nebula-hub",
  "testnet": false
};

var c1517929550 = {
  "chain": "staging-aware-chief-gianfar",
  "chainId": 1517929550,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://staging-aware-chief-gianfar.explorer.staging-v3.skalenodes.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://sfuel.dirtroad.dev/staging"],
  "icon": {
    "url": "ipfs://bafkreiagrt5dhgltg2kmw7hf24kslstr5h42e745luuxwp2wbg24gm6zza",
    "width": 500,
    "height": 500,
    "format": "png"
  },
  "name": "Deprecated SKALE Titan Hub Testnet",
  "nativeCurrency": {
    "name": "sFUEL",
    "symbol": "sFUEL",
    "decimals": 18
  },
  "networkId": 1517929550,
  "rpc": ["https://1517929550.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://staging-v3.skalenodes.com/v1/staging-aware-chief-gianfar", "wss://staging-v3.skalenodes.com/v1/ws/staging-aware-chief-gianfar"],
  "shortName": "deprecated-titan-testnet",
  "slip44": 1,
  "slug": "deprecated-skale-titan-hub-testnet",
  "status": "deprecated",
  "testnet": true
};

var c1564830818 = {
  "chain": "honorable-steel-rasalhague",
  "chainId": 1564830818,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://honorable-steel-rasalhague.explorer.mainnet.skalenodes.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://sfuel.dirtroad.dev"],
  "icon": {
    "url": "ipfs://bafybeigyayzxvt7vosat4rtrbmhhnldgx57w2pfbutuniax7h6kswzi42m",
    "width": 1637,
    "height": 1636,
    "format": "png"
  },
  "infoURL": "https://calypsohub.network/",
  "name": "SKALE Calypso Hub",
  "nativeCurrency": {
    "name": "sFUEL",
    "symbol": "sFUEL",
    "decimals": 18
  },
  "networkId": 1564830818,
  "rpc": ["https://1564830818.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.skalenodes.com/v1/honorable-steel-rasalhague"],
  "shortName": "calypso-mainnet",
  "slug": "skale-calypso-hub",
  "testnet": false
};

var c1666600000 = {
  "chain": "Harmony",
  "chainId": 1666600000,
  "ens": {
    "registry": "0x4cd2563118e57b19179d8dc033f2b0c5b5d69ff5"
  },
  "explorers": [{
    "name": "Harmony Block Explorer",
    "url": "https://explorer.harmony.one",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://www.harmony.one/",
  "name": "Harmony Mainnet Shard 0",
  "nativeCurrency": {
    "name": "ONE",
    "symbol": "ONE",
    "decimals": 18
  },
  "networkId": 1666600000,
  "rpc": ["https://1666600000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.harmony.one", "https://a.api.s0.t.hmny.io", "https://api.s0.t.hmny.io", "https://rpc.ankr.com/harmony", "https://harmony.api.onfinality.io/public", "https://1rpc.io/one", "https://harmony-0.drpc.org", "wss://harmony-0.drpc.org"],
  "shortName": "hmy-s0",
  "slip44": 1023,
  "slug": "harmony-shard-0",
  "testnet": false
};

var c1666600001 = {
  "chain": "Harmony",
  "chainId": 1666600001,
  "explorers": [{
    "name": "Harmony Block Explorer",
    "url": "https://explorer.harmony.one/blocks/shard/1",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.harmony.one/",
  "name": "Harmony Mainnet Shard 1",
  "nativeCurrency": {
    "name": "ONE",
    "symbol": "ONE",
    "decimals": 18
  },
  "networkId": 1666600001,
  "rpc": ["https://1666600001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.s1.t.hmny.io", "https://harmony-1.drpc.org", "wss://harmony-1.drpc.org"],
  "shortName": "hmy-s1",
  "slip44": 1023,
  "slug": "harmony-shard-1",
  "testnet": false
};

var c1666600002 = {
  "chain": "Harmony",
  "chainId": 1666600002,
  "explorers": [{
    "name": "Harmony Block Explorer",
    "url": "https://explorer.harmony.one/blocks/shard/2",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.harmony.one/",
  "name": "Harmony Mainnet Shard 2",
  "nativeCurrency": {
    "name": "ONE",
    "symbol": "ONE",
    "decimals": 18
  },
  "networkId": 1666600002,
  "rpc": ["https://1666600002.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.s2.t.hmny.io"],
  "shortName": "hmy-s2",
  "slip44": 1023,
  "slug": "harmony-shard-2",
  "status": "deprecated",
  "testnet": false
};

var c1666600003 = {
  "chain": "Harmony",
  "chainId": 1666600003,
  "explorers": [{
    "name": "Harmony Block Explorer",
    "url": "https://explorer.harmony.one/blocks/shard/3",
    "standard": "none"
  }],
  "faucets": [],
  "infoURL": "https://www.harmony.one/",
  "name": "Harmony Mainnet Shard 3",
  "nativeCurrency": {
    "name": "ONE",
    "symbol": "ONE",
    "decimals": 18
  },
  "networkId": 1666600003,
  "rpc": ["https://1666600003.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.s3.t.hmny.io"],
  "shortName": "hmy-s3",
  "slip44": 1023,
  "slug": "harmony-shard-3",
  "status": "deprecated",
  "testnet": false
};

var c1666700000 = {
  "chain": "Harmony",
  "chainId": 1666700000,
  "explorers": [{
    "name": "Harmony Testnet Block Explorer",
    "url": "https://explorer.testnet.harmony.one",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.pops.one"],
  "infoURL": "https://www.harmony.one/",
  "name": "Harmony Testnet Shard 0",
  "nativeCurrency": {
    "name": "ONE",
    "symbol": "ONE",
    "decimals": 18
  },
  "networkId": 1666700000,
  "rpc": ["https://1666700000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.s0.b.hmny.io"],
  "shortName": "hmy-b-s0",
  "slug": "harmony-testnet-shard-0",
  "testnet": true
};

var c1666700001 = {
  "chain": "Harmony",
  "chainId": 1666700001,
  "explorers": [{
    "name": "Harmony Block Explorer",
    "url": "https://explorer.testnet.harmony.one",
    "standard": "none"
  }],
  "faucets": ["https://faucet.pops.one"],
  "infoURL": "https://www.harmony.one/",
  "name": "Harmony Testnet Shard 1",
  "nativeCurrency": {
    "name": "ONE",
    "symbol": "ONE",
    "decimals": 18
  },
  "networkId": 1666700001,
  "rpc": ["https://1666700001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.s1.b.hmny.io"],
  "shortName": "hmy-b-s1",
  "slug": "harmony-testnet-shard-1",
  "testnet": true
};

var c1666900000 = {
  "chain": "Harmony",
  "chainId": 1666900000,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.harmony.one/",
  "name": "Harmony Devnet Shard 0",
  "nativeCurrency": {
    "name": "ONE",
    "symbol": "ONE",
    "decimals": 18
  },
  "networkId": 1666900000,
  "rpc": ["https://1666900000.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.s0.ps.hmny.io"],
  "shortName": "hmy-ps-s0",
  "slug": "harmony-devnet-shard-0",
  "testnet": false
};

var c1666900001 = {
  "chain": "Harmony",
  "chainId": 1666900001,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.harmony.one/",
  "name": "Harmony Devnet Shard 1",
  "nativeCurrency": {
    "name": "ONE",
    "symbol": "ONE",
    "decimals": 18
  },
  "networkId": 1666900001,
  "rpc": ["https://1666900001.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://api.s1.ps.hmny.io"],
  "shortName": "hmy-ps-s1",
  "slug": "harmony-devnet-shard-1",
  "testnet": false
};

var c1918988905 = {
  "chain": "RARI-T",
  "chainId": 1918988905,
  "explorers": [],
  "faucets": [],
  "features": [],
  "infoURL": "https://rarichain.org/",
  "name": "RARIchain Testnet",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 1918988905,
  "redFlags": [],
  "rpc": ["https://1918988905.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet.rpc.rarichain.org/http"],
  "shortName": "eth",
  "slug": "rarichain-testnet",
  "testnet": true
};

var c2021121117 = {
  "chain": "HOP",
  "chainId": 2021121117,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://www.DataHopper.com",
  "name": "DataHopper",
  "nativeCurrency": {
    "name": "DataHoppers",
    "symbol": "HOP",
    "decimals": 18
  },
  "networkId": 2021121117,
  "rpc": ["https://2021121117.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://23.92.21.121:8545"],
  "shortName": "hop",
  "slug": "datahopper",
  "testnet": false
};

var c2046399126 = {
  "chain": "europa",
  "chainId": 2046399126,
  "explorers": [{
    "name": "Blockscout",
    "url": "https://elated-tan-skat.explorer.mainnet.skalenodes.com",
    "standard": "EIP3091"
  }],
  "faucets": ["https://ruby.exchange/faucet.html", "https://sfuel.mylilius.com/"],
  "icon": {
    "url": "ipfs://bafkreiezcwowhm6xjrkt44cmiu6ml36rhrxx3amcg3cfkcntv2vgcvgbre",
    "width": 600,
    "height": 600,
    "format": "png"
  },
  "infoURL": "https://europahub.network/",
  "name": "SKALE Europa Hub",
  "nativeCurrency": {
    "name": "sFUEL",
    "symbol": "sFUEL",
    "decimals": 18
  },
  "networkId": 2046399126,
  "parent": {
    "type": "L2",
    "chain": "eip155-1",
    "bridges": [{
      "url": "https://ruby.exchange/bridge.html"
    }]
  },
  "rpc": ["https://2046399126.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.skalenodes.com/v1/elated-tan-skat", "wss://mainnet.skalenodes.com/v1/elated-tan-skat"],
  "shortName": "europa",
  "slug": "skale-europa-hub",
  "testnet": false
};

var c2863311531 = {
  "chain": "Ancient8",
  "chainId": 2863311531,
  "explorers": [{
    "name": "a8scan-testnet",
    "url": "https://testnet.a8scan.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreievnqg3xjokaty4kfbxxbrzm5v5y7exbaaia2txrh4sfgrqsalfym",
    "width": 128,
    "height": 128,
    "format": "png"
  },
  "infoURL": "https://ancient8.gg/",
  "name": "Ancient8 Testnet (deprecated)",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 2863311531,
  "rpc": ["https://2863311531.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc-testnet.ancient8.gg"],
  "shortName": "a8old",
  "slip44": 1,
  "slug": "ancient8-testnet-deprecated",
  "status": "deprecated",
  "testnet": true
};

var c3125659152 = {
  "chain": "PIRL",
  "chainId": 3125659152,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://pirl.io",
  "name": "Pirl",
  "nativeCurrency": {
    "name": "Pirl Ether",
    "symbol": "PIRL",
    "decimals": 18
  },
  "networkId": 3125659152,
  "rpc": ["https://3125659152.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://wallrpc.pirl.io"],
  "shortName": "pirl",
  "slip44": 164,
  "slug": "pirl",
  "testnet": false
};

var c4216137055 = {
  "chain": "OLT",
  "chainId": 4216137055,
  "explorers": [{
    "name": "OneLedger Block Explorer",
    "url": "https://frankenstein-explorer.oneledger.network",
    "standard": "EIP3091"
  }],
  "faucets": ["https://frankenstein-faucet.oneledger.network"],
  "icon": {
    "url": "ipfs://QmRhqq4Gp8G9w27ND3LeFW49o5PxcxrbJsqHbpBFtzEMfC",
    "width": 225,
    "height": 225,
    "format": "png"
  },
  "infoURL": "https://oneledger.io",
  "name": "OneLedger Testnet Frankenstein",
  "nativeCurrency": {
    "name": "OLT",
    "symbol": "OLT",
    "decimals": 18
  },
  "networkId": 4216137055,
  "rpc": ["https://4216137055.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://frankenstein-rpc.oneledger.network"],
  "shortName": "frankenstein",
  "slip44": 1,
  "slug": "oneledger-testnet-frankenstein",
  "testnet": true
};

var c11297108099 = {
  "chain": "Palm",
  "chainId": 11297108099,
  "explorers": [{
    "name": "Chainlens",
    "url": "https://testnet.palm.chainlens.com",
    "standard": "EIP3091"
  }, {
    "name": "Dora",
    "url": "https://www.ondora.xyz/network/palm-testnet",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreihifvvbq6xzviygveivayogqiotdtpjvilu27bgqobduqemzeq7o4",
    "width": 72,
    "height": 72,
    "format": "svg"
  },
  "infoURL": "https://palm.network",
  "name": "Palm Testnet",
  "nativeCurrency": {
    "name": "PALM",
    "symbol": "PALM",
    "decimals": 18
  },
  "networkId": 11297108099,
  "rpc": ["https://11297108099.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://palm-testnet.infura.io/v3/${INFURA_API_KEY}", "https://palm-testnet.public.blastapi.io"],
  "shortName": "tpalm",
  "slip44": 1,
  "slug": "palm-testnet",
  "testnet": true
};

var c11297108109 = {
  "chain": "Palm",
  "chainId": 11297108109,
  "explorers": [{
    "name": "Chainlens",
    "url": "https://palm.chainlens.com",
    "standard": "EIP3091"
  }, {
    "name": "Dora",
    "url": "https://www.ondora.xyz/network/palm",
    "standard": "none"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreihifvvbq6xzviygveivayogqiotdtpjvilu27bgqobduqemzeq7o4",
    "width": 72,
    "height": 72,
    "format": "svg"
  },
  "infoURL": "https://palm.network",
  "name": "Palm",
  "nativeCurrency": {
    "name": "PALM",
    "symbol": "PALM",
    "decimals": 18
  },
  "networkId": 11297108109,
  "rpc": ["https://11297108109.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://palm-mainnet.infura.io/v3/${INFURA_API_KEY}", "https://palm-mainnet.public.blastapi.io"],
  "shortName": "palm",
  "slug": "palm",
  "testnet": false
};

var c28872323069 = {
  "chain": "ETH",
  "chainId": 28872323069,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://bafkreihdfuzytq2og65n3d3b2kzfvk6yywvqdlorrt6h76q4baz5phcvju",
    "width": 256,
    "height": 256,
    "format": "png"
  },
  "infoURL": "https://gitswarm.com/",
  "name": "GitSwarm Test Network",
  "nativeCurrency": {
    "name": "GitSwarm Ether",
    "symbol": "GS-ETH",
    "decimals": 18
  },
  "networkId": 28872323069,
  "rpc": ["https://28872323069.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://gitswarm.com:2096"],
  "shortName": "GS-ETH",
  "slip44": 1,
  "slug": "gitswarm-test-network",
  "status": "incubating",
  "testnet": true,
  "title": "GitSwarm Test Network"
};

var c37714555429 = {
  "chain": "Xai Sepolia",
  "chainId": 37714555429,
  "explorers": [{
    "name": "blockscout",
    "url": "https://testnet-explorer-v2.xai-chain.net/",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmZKFekbHxDkB8gFmmmjWz89SLhwg38GkALmAKo3gn753N/2024-01-10%2012.50.15.jpg",
    "width": 512,
    "height": 512,
    "format": "jpg"
  },
  "infoURL": "https://xai.games",
  "name": "Xai Sepolia",
  "nativeCurrency": {
    "name": "sXAI",
    "symbol": "sXAI",
    "decimals": 18
  },
  "networkId": 37714555429,
  "parent": {
    "type": "L3",
    "chain": "eip155-1",
    "bridges": []
  },
  "redFlags": [],
  "rpc": ["https://37714555429.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://testnet-v2.xai-chain.net/rpc"],
  "shortName": "xai-sepolia",
  "slug": "xai-sepolia",
  "testnet": true
};

var c47279324479 = {
  "chain": "Xai Goerli Orbit Testnet",
  "chainId": 47279324479,
  "explorers": [],
  "faucets": [],
  "features": [],
  "infoURL": "https://xai.games/",
  "name": "Xai Goerli Orbit",
  "nativeCurrency": {
    "name": "Xai Goerli Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 47279324479,
  "redFlags": [],
  "rpc": [],
  "shortName": "xai-goerli",
  "slug": "xai-goerli-orbit",
  "status": "deprecated",
  "testnet": true
};

var c88153591557 = {
  "chain": "ETH",
  "chainId": 88153591557,
  "explorers": [{
    "name": "blockscout",
    "url": "https://arb-blueberry.gelatoscout.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmYtUimyqHkkFxYdbXXRbUqNg2VLPUg6Uu2C2nmFWowiZM",
      "width": 551,
      "height": 540,
      "format": "png"
    }
  }],
  "faucets": [],
  "features": [],
  "icon": {
    "url": "ipfs://QmQXw4QEDR4AbUwX9scH7aGhiSDhQRxu6LCQoUkgsYgGyK/Gelato%20brand%20mark.png",
    "width": 300,
    "height": 300,
    "format": "png"
  },
  "infoURL": "https://raas.gelato.network/rollups/details/public/arb-blueberry",
  "name": "Arbitrum Blueberry",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 88153591557,
  "parent": {
    "type": "L2",
    "chain": "eip155-421614",
    "bridges": [{
      "url": "https://bridge.gelato.network/bridge/arb-blueberry"
    }]
  },
  "redFlags": [],
  "rpc": ["https://88153591557.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.arb-blueberry.gelato.digital", "wss://ws.arb-blueberry.gelato.digital"],
  "shortName": "arb-blueberry",
  "slip44": 60,
  "slug": "arbitrum-blueberry",
  "status": "active",
  "testnet": true,
  "title": "Arbitrum Blueberry"
};

var c107107114116 = {
  "chain": "ETH",
  "chainId": 107107114116,
  "explorers": [],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmNTZ9nEomAXK6bLxUbMfTS1TvrsN22HU1zTtxHUpMkUhz",
    "width": 1000,
    "height": 1000,
    "format": "png"
  },
  "infoURL": "https://kakarot.org",
  "name": "Kakarot Sepolia",
  "nativeCurrency": {
    "name": "Ether",
    "symbol": "ETH",
    "decimals": 18
  },
  "networkId": 107107114116,
  "parent": {
    "type": "L2",
    "chain": "eip155-11155111",
    "bridges": []
  },
  "rpc": [],
  "shortName": "kkrt-sepolia",
  "slug": "kakarot-sepolia",
  "testnet": false
};

var c111222333444 = {
  "chain": "Alphabet Network",
  "chainId": 111222333444,
  "explorers": [{
    "name": "Alphabet Explorer",
    "url": "https://scan.alphabetnetwork.org",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmfTeudwVJcu7jzySBcpD9H5ZVK66nPJKRnicxend1bxfq",
    "width": 500,
    "height": 500,
    "format": "svg"
  },
  "infoURL": "https://alphabetnetwork.org",
  "name": "Alphabet Mainnet",
  "nativeCurrency": {
    "name": "ALT",
    "symbol": "ALT",
    "decimals": 18
  },
  "networkId": 111222333444,
  "rpc": ["https://111222333444.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://londonpublic.alphabetnetwork.org", "wss://londonpublic.alphabetnetwork.org/ws/", "https://main-rpc.com", "wss://main-rpc.com/ws/"],
  "shortName": "alphabet",
  "slug": "alphabet",
  "testnet": false
};

var c197710212030 = {
  "chain": "Ntity",
  "chainId": 197710212030,
  "explorers": [{
    "name": "Ntity Blockscout",
    "url": "https://blockscout.ntity.io",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmSW2YhCvMpnwtPGTJAuEK2QgyWfFjmnwcrapUg6kqFsPf",
      "width": 711,
      "height": 715,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmSW2YhCvMpnwtPGTJAuEK2QgyWfFjmnwcrapUg6kqFsPf",
    "width": 711,
    "height": 715,
    "format": "svg"
  },
  "infoURL": "https://ntity.io",
  "name": "Ntity Mainnet",
  "nativeCurrency": {
    "name": "Ntity",
    "symbol": "NTT",
    "decimals": 18
  },
  "networkId": 197710212030,
  "rpc": ["https://197710212030.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://rpc.ntity.io"],
  "shortName": "ntt",
  "slug": "ntity",
  "testnet": false
};

var c197710212031 = {
  "chain": "Ntity",
  "chainId": 197710212031,
  "explorers": [{
    "name": "Ntity Haradev Blockscout",
    "url": "https://blockscout.haradev.com",
    "standard": "EIP3091",
    "icon": {
      "url": "ipfs://QmSW2YhCvMpnwtPGTJAuEK2QgyWfFjmnwcrapUg6kqFsPf",
      "width": 711,
      "height": 715,
      "format": "svg"
    }
  }],
  "faucets": [],
  "icon": {
    "url": "ipfs://QmSW2YhCvMpnwtPGTJAuEK2QgyWfFjmnwcrapUg6kqFsPf",
    "width": 711,
    "height": 715,
    "format": "svg"
  },
  "infoURL": "https://ntity.io",
  "name": "Haradev Testnet",
  "nativeCurrency": {
    "name": "Ntity Haradev",
    "symbol": "NTTH",
    "decimals": 18
  },
  "networkId": 197710212031,
  "rpc": ["https://197710212031.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://blockchain.haradev.com"],
  "shortName": "ntt-haradev",
  "slip44": 1,
  "slug": "haradev-testnet",
  "testnet": true
};

var c383414847825 = {
  "chain": "ZENIQ",
  "chainId": 383414847825,
  "explorers": [{
    "name": "zeniq-smart-chain-explorer",
    "url": "https://smart.zeniq.net",
    "standard": "EIP3091"
  }],
  "faucets": ["https://faucet.zeniq.net/"],
  "infoURL": "https://www.zeniq.dev/",
  "name": "Zeniq",
  "nativeCurrency": {
    "name": "Zeniq",
    "symbol": "ZENIQ",
    "decimals": 18
  },
  "networkId": 383414847825,
  "rpc": ["https://383414847825.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://smart.zeniq.network:9545"],
  "shortName": "zeniq",
  "slug": "zeniq",
  "testnet": false
};

var c666301171999 = {
  "chain": "IPDC",
  "chainId": 666301171999,
  "explorers": [{
    "name": "ipdcscan",
    "url": "https://scan.ipdc.io",
    "standard": "EIP3091"
  }],
  "faucets": [],
  "infoURL": "https://ipdc.io",
  "name": "PDC Mainnet",
  "nativeCurrency": {
    "name": "PDC",
    "symbol": "PDC",
    "decimals": 18
  },
  "networkId": 666301171999,
  "rpc": ["https://666301171999.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://mainnet.ipdc.io/"],
  "shortName": "ipdc",
  "slug": "pdc",
  "testnet": false
};

var c6022140761023 = {
  "chain": "ETH",
  "chainId": 6022140761023,
  "explorers": [],
  "faucets": [],
  "infoURL": "https://github.com/Jdubedition/molereum",
  "name": "Molereum Network",
  "nativeCurrency": {
    "name": "Molereum Ether",
    "symbol": "MOLE",
    "decimals": 18
  },
  "networkId": 6022140761023,
  "rpc": ["https://6022140761023.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://molereum.jdubedition.com"],
  "shortName": "mole",
  "slug": "molereum-network",
  "testnet": false
};

var c868455272153094 = {
  "chain": "GWT",
  "chainId": 868455272153094,
  "explorers": [{
    "name": "GWScan Block Explorer",
    "url": "https://v1.aggron.gwscan.com",
    "standard": "none"
  }],
  "faucets": ["https://homura.github.io/light-godwoken"],
  "infoURL": "https://www.nervos.org",
  "name": "Godwoken Testnet (V1)",
  "nativeCurrency": {
    "name": "CKB",
    "symbol": "CKB",
    "decimals": 8
  },
  "networkId": 868455272153094,
  "rpc": ["https://868455272153094.rpc.thirdweb.com/${THIRDWEB_API_KEY}", "https://godwoken-testnet-web3-v1-rpc.ckbapp.dev"],
  "shortName": "gw-testnet-v1-deprecated",
  "slip44": 1,
  "slug": "godwoken-testnet-v1-gw-testnet-v1-deprecated",
  "status": "deprecated",
  "testnet": true
};

const defaultOptions = {
  mode: "http"
};

/**
 * Construct the list of RPC URLs given a specific chain config. Format any RPC URLs
 * with necessary API keys.
 *
 * @param chain - The chain config to assemble RPC URLs from
 * @param options - Options to configure the RPC URLs
 * @returns The list of RPC URLs for the chain
 */
function getChainRPCs(chain, options) {
  const {
    thirdwebApiKey,
    alchemyApiKey,
    infuraApiKey,
    mode
  } = {
    ...defaultOptions,
    ...options
  };
  const processedRPCs = [];
  chain.rpc.forEach(rpc => {
    // exclude RPC if mode mismatch
    if (mode === "http" && !rpc.startsWith("http")) {
      return;
    }
    if (mode === "ws" && !rpc.startsWith("ws")) {
      return;
    }

    // Replace API_KEY placeholder with value
    if (thirdwebApiKey && rpc.includes("${THIRDWEB_API_KEY}")) {
      processedRPCs.push(rpc.replace("${THIRDWEB_API_KEY}", thirdwebApiKey));
    } else if (infuraApiKey && rpc.includes("${INFURA_API_KEY}")) {
      processedRPCs.push(rpc.replace("${INFURA_API_KEY}", infuraApiKey));
    } else if (alchemyApiKey && rpc.includes("${ALCHEMY_API_KEY}")) {
      processedRPCs.push(rpc.replace("${ALCHEMY_API_KEY}", alchemyApiKey));
    }

    // exclude RPCs with unknown placeholder
    else if (rpc.includes("${")) {
      return;
    }

    // add as is
    else {
      processedRPCs.push(rpc);
    }
  });
  if (processedRPCs.length === 0) {
    throw new Error(`No RPC available for chainId "${chain.chainId}" with mode ${mode}`);
  }
  return processedRPCs;
}

/**
 * Construct the list of RPC URLs given a specific chain config. Format any RPC URLs
 * with necessary clientId/secretKey and returns the first valid one.
 *
 * @param chain - The chain config to assemble RPC URLs from
 * @param clientId - The client id to use for the RPC URL
 * @returns The first valid RPC URL for the chain
 */
function getValidChainRPCs(chain, clientId) {
  let mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "http";
  const processedRPCs = [];
  chain.rpc.forEach(rpc => {
    // exclude RPC if mode mismatch
    if (mode === "http" && !rpc.startsWith("http")) {
      return;
    }
    if (mode === "ws" && !rpc.startsWith("ws")) {
      return;
    }

    // Replace API_KEY placeholder with value
    if (rpc.includes("${THIRDWEB_API_KEY}")) {
      if (clientId) {
        processedRPCs.push(rpc.replace("${THIRDWEB_API_KEY}", clientId) + (typeof globalThis !== "undefined" && "APP_BUNDLE_ID" in globalThis && !!globalThis.APP_BUNDLE_ID ?
        // @ts-ignore
        `/?bundleId=${globalThis.APP_BUNDLE_ID}` : ""));
      } else {
        // if no client id, let it through with empty string
        // if secretKey is present, it will be used in header
        // if none are passed, will have reduced access
        processedRPCs.push(rpc.replace("${THIRDWEB_API_KEY}", ""));
      }
    }

    // exclude RPCs with unknown placeholder
    else if (rpc.includes("${")) {
      return;
    }

    // add as is
    else {
      processedRPCs.push(rpc);
    }
  });
  if (processedRPCs.length === 0) {
    throw new Error(`No RPC available for chainId "${chain.chainId}" with mode ${mode}`);
  }
  return processedRPCs;
}

/**
 * Get the highest priority RPC URL for a specific chain
 *
 * @param chain - The chain config to get the RPC URL for
 * @param options - Options to configure the RPC URL
 * @returns The RPC URL for the chain
 *
 * @internal
 */
function getChainRPC(chain, options) {
  return getChainRPCs(chain, options)[0];
}
function minimizeChain(chain) {
  const [firstRpc] = chain.rpc;
  return {
    name: chain.name,
    chain: chain.chain,
    rpc: [firstRpc],
    nativeCurrency: chain.nativeCurrency,
    shortName: chain.shortName,
    chainId: chain.chainId,
    testnet: chain.testnet,
    slug: chain.slug,
    icon: chain.icon
  };
}
function configureChain(chain, chainConfig) {
  let additionalRPCs = [];
  if (chainConfig?.rpc) {
    if (typeof chainConfig.rpc === "string") {
      additionalRPCs = [chainConfig.rpc];
    } else {
      additionalRPCs = chainConfig.rpc;
    }
  }
  // prepend additional RPCs to the chain's RPCs
  return {
    ...chain,
    rpc: [...additionalRPCs, ...chain.rpc]
  };
}

/**
 *
 * use the clientId and return a new chain object with updated RPCs
 */
function updateChainRPCs(chain, clientId) {
  try {
    return {
      ...chain,
      rpc: getValidChainRPCs(chain, clientId)
    };
  } catch (error) {
    return chain;
  }
}

// cache of chainId -> Chain
const chainCache = {};
// cache of slug -> chainId
const slugToChainId = {};
async function fetchChain(chainIdOrSlug) {
  if (typeof chainIdOrSlug === "string" && chainIdOrSlug in slugToChainId) {
    return chainCache[slugToChainId[chainIdOrSlug]];
  } else if (typeof chainIdOrSlug === "number" && chainIdOrSlug in chainCache) {
    return chainCache[chainIdOrSlug];
  }
  const res = await fetch(`https://api.thirdweb.com/v1/chains/${chainIdOrSlug}`);
  if (!res.ok) {
    console.debug("[chains] fetchChain() failed", res.status, res.statusText);
    return null;
  }
  try {
    const json = await res.json();
    if (json.error) {
      console.debug("[chains] fetchChain() error", json.error);
      return null;
    }
    const chain = json.data;
    // store the chain in chainCache
    chainCache[chain.chainId] = chain;
    // store the slug<->chainId in slugToChainId
    slugToChainId[chain.slug] = chain.chainId;
    return json.data;
  } catch (err) {
    console.debug("[chains] fetchChain() failed", err);
    return null;
  }
}
const fetchChainsCache = {};
async function fetchChains(options) {
  // cache key is based on limit and offset (options)
  const cacheKey = `l:${options?.limit ?? 0}o:${options?.offset ?? 0}`;
  if (cacheKey in fetchChainsCache) {
    return fetchChainsCache[cacheKey];
  }
  const url = new URL(`https://api.thirdweb.com/v1/chains`);
  if (options?.limit && options.limit >= 1) {
    url.searchParams.append("limit", options.limit.toString());
  }
  if (options?.offset && options.offset >= 1) {
    url.searchParams.append("offset", options.offset.toString());
  }
  const res = await fetch(url);
  if (!res.ok) {
    console.debug("[chains] fetchChain() failed", res.status, res.statusText);
    return null;
  }
  try {
    const json = await res.json();
    if (json.error) {
      console.debug("[chains] fetchChain() error", json.error);
      return null;
    }
    fetchChainsCache[cacheKey] = json.data;
    return json.data;
  } catch (err) {
    console.debug("[chains] fetchChain() failed", err);
    return null;
  }
}

/**
 *
 * @param chainId - the chainId of the chain to resolve
 * @returns A Promise that resolves to the Chain object
 * @throws if the chainId is not found
 */
async function getChainByChainIdAsync(chainId) {
  const chain = await fetchChain(chainId);
  if (!chain) {
    throw new Error(`Chain with chainId "${chainId}" not found`);
  }
  return chain;
}

/**
 *
 * @param slug - the slug of the chain to resolve
 * @returns A Promise that resolves to the Chain object
 * @throws if the slug is not found
 */
async function getChainBySlugAsync(slug) {
  const chain = await fetchChain(slug);
  if (!chain) {
    throw new Error(`Chain with slug "${slug}" not found`);
  }
  return chain;
}

const defaultChains = [c1, c11155111, c8453, c84532, c137, c80001, c42161, c421614, c10, c11155420, c56, c97, c250, c4002, c43114, c43113, c1337];

/**
 * @deprecated use `fetchChains()` instead
 */
// @ts-expect-error - TODO: fix this later
const allChains = [c1, c2, c3, c4, c5, c6, c7, c8, c9, c10, c11, c12, c13, c14, c15, c16, c17, c18, c19, c20, c21, c22, c23, c24, c25, c26, c27, c28, c29, c30, c31, c32, c33, c34, c35, c36, c37, c38, c39, c40, c41, c42, c43, c44, c45, c46, c47, c48, c49, c50, c51, c52, c53, c54, c55, c56, c57, c58, c59, c60, c61, c62, c63, c64, c65, c66, c67, c68, c69, c70, c71, c72, c73, c74, c75, c76, c77, c78, c79, c80, c81, c82, c83, c84, c85, c86, c87, c88, c89, c90, c91, c92, c93, c94, c95, c96, c97, c98, c99, c100, c101, c102, c103, c104, c105, c106, c107, c108, c109, c110, c111, c112, c113, c114, c115, c116, c117, c118, c119, c120, c121, c122, c123, c124, c125, c126, c127, c128, c129, c131, c134, c135, c136, c137, c138, c139, c141, c142, c144, c145, c148, c150, c151, c152, c153, c154, c155, c156, c157, c158, c159, c160, c161, c162, c163, c165, c166, c167, c168, c169, c170, c172, c180, c186, c188, c189, c191, c193, c195, c196, c197, c198, c199, c200, c201, c204, c206, c207, c208, c210, c211, c212, c214, c217, c218, c220, c222, c224, c225, c226, c230, c234, c236, c238, c242, c246, c248, c250, c252, c255, c256, c258, c259, c262, c266, c267, c268, c269, c271, c274, c279, c280, c282, c288, c291, c295, c296, c297, c298, c300, c301, c303, c305, c307, c308, c309, c311, c313, c314, c321, c322, c323, c324, c333, c335, c336, c338, c361, c363, c364, c365, c369, c371, c380, c381, c385, c395, c397, c398, c399, c400, c401, c408, c411, c416, c418, c420, c422, c424, c427, c428, c434, c443, c444, c456, c462, c463, c499, c500, c501, c510, c512, c513, c516, c520, c529, c530, c534, c537, c542, c555, c558, c568, c570, c571, c588, c592, c595, c596, c597, c599, c600, c601, c612, c614, c634, c646, c647, c648, c653, c654, c666, c667, c668, c669, c686, c700, c707, c708, c710, c713, c719, c721, c727, c730, c740, c741, c742, c747, c766, c776, c777, c786, c787, c788, c789, c799, c800, c803, c808, c810, c813, c814, c818, c820, c821, c822, c831, c841, c842, c859, c868, c876, c877, c880, c881, c882, c888, c898, c900, c901, c902, c903, c909, c910, c911, c917, c919, c927, c940, c941, c942, c943, c956, c957, c963, c970, c971, c972, c977, c980, c985, c987, c989, c990, c997, c998, c999, c1000, c1001, c1003, c1004, c1007, c1008, c1009, c1010, c1012, c1022, c1023, c1024, c1028, c1030, c1031, c1038, c1039, c1071, c1072, c1073, c1079, c1080, c1088, c1089, c1099, c1100, c1101, c1107, c1108, c1111, c1112, c1113, c1115, c1116, c1117, c1123, c1130, c1131, c1133, c1138, c1139, c1140, c1149, c1170, c1177, c1197, c1201, c1202, c1213, c1214, c1220, c1224, c1229, c1230, c1231, c1234, c1243, c1244, c1246, c1248, c1252, c1280, c1284, c1285, c1286, c1287, c1288, c1291, c1294, c1297, c1311, c1314, c1319, c1320, c1337, c1338, c1339, c1343, c1353, c1369, c1379, c1388, c1392, c1402, c1422, c1433, c1440, c1442, c1452, c1453, c1455, c1490, c1501, c1506, c1507, c1515, c1559, c1582, c1614, c1617, c1618, c1620, c1657, c1662, c1663, c1686, c1687, c1688, c1701, c1707, c1708, c1717, c1718, c1729, c1773, c1777, c1804, c1807, c1818, c1819, c1821, c1838, c1856, c1875, c1881, c1890, c1891, c1898, c1904, c1907, c1908, c1909, c1911, c1912, c1945, c1951, c1953, c1954, c1961, c1962, c1967, c1969, c1970, c1971, c1972, c1975, c1984, c1985, c1986, c1987, c1992, c1994, c1995, c1998, c2000, c2001, c2002, c2008, c2009, c2016, c2018, c2019, c2020, c2021, c2022, c2023, c2024, c2025, c2031, c2032, c2035, c2037, c2038, c2043, c2044, c2047, c2048, c2049, c2077, c2088, c2089, c2100, c2101, c2109, c2121, c2122, c2124, c2137, c2138, c2151, c2152, c2153, c2154, c2199, c2202, c2203, c2213, c2221, c2222, c2223, c2241, c2300, c2306, c2309, c2323, c2330, c2331, c2332, c2340, c2342, c2357, c2358, c2399, c2400, c2410, c2415, c2425, c2442, c2458, c2468, c2484, c2511, c2522, c2525, c2559, c2569, c2606, c2611, c2612, c2613, c2625, c2662, c2710, c2718, c2730, c2731, c2828, c2888, c2907, c2911, c2941, c2999, c3000, c3001, c3003, c3011, c3031, c3036, c3068, c3084, c3100, c3102, c3141, c3269, c3270, c3306, c3331, c3333, c3334, c3400, c3434, c3454, c3500, c3501, c3601, c3602, c3636, c3637, c3639, c3666, c3690, c3693, c3698, c3699, c3701, c3737, c3776, c3797, c3799, c3839, c3885, c3888, c3889, c3912, c3939, c3966, c3967, c3993, c3999, c4000, c4001, c4002, c4003, c4051, c4061, c4062, c4078, c4090, c4096, c4099, c4102, c4139, c4141, c4145, c4157, c4181, c4200, c4201, c4202, c4242, c4243, c4328, c4337, c4400, c4444, c4460, c4544, c4653, c4689, c4690, c4759, c4777, c4893, c4905, c4918, c4919, c4999, c5000, c5001, c5002, c5003, c5005, c5039, c5042, c5051, c5100, c5101, c5102, c5103, c5104, c5105, c5106, c5165, c5169, c5177, c5197, c5234, c5290, c5315, c5317, c5353, c5439, c5522, c5551, c5553, c5555, c5611, c5615, c5616, c5678, c5700, c5729, c5758, c5777, c5810, c5851, c5869, c6000, c6065, c6066, c6102, c6118, c6119, c6363, c6502, c6552, c6565, c6626, c6660, c6661, c6666, c6688, c6701, c6779, c6789, c6969, c6999, c7000, c7001, c7007, c7027, c7070, c7100, c7118, c7158, c7171, c7207, c7317, c7326, c7331, c7332, c7341, c7484, c7507, c7518, c7575, c7576, c7640, c7668, c7672, c7700, c7701, c7771, c7777, c7778, c7798, c7860, c7865, c7872, c7878, c7887, c7895, c7909, c7979, c8000, c8001, c8029, c8054, c8080, c8081, c8082, c8086, c8087, c8098, c8131, c8132, c8133, c8134, c8135, c8136, c8154, c8181, c8192, c8194, c8217, c8272, c8285, c8387, c8453, c8654, c8655, c8668, c8723, c8724, c8726, c8727, c8738, c8768, c8822, c8848, c8866, c8880, c8881, c8882, c8883, c8888, c8889, c8890, c8898, c8899, c8989, c8995, c9000, c9001, c9007, c9008, c9012, c9024, c9025, c9100, c9170, c9223, c9294, c9339, c9393, c9395, c9527, c9528, c9559, c9700, c9728, c9768, c9779, c9790, c9792, c9818, c9819, c9872, c9888, c9898, c9911, c9977, c9980, c9990, c9996, c9997, c9998, c9999, c10000, c10001, c10024, c10050, c10081, c10086, c10101, c10200, c10201, c10242, c10243, c10248, c10395, c10507, c10508, c10671, c10823, c10946, c10947, c11110, c11111, c11115, c11119, c11198, c11221, c11227, c11235, c11437, c11501, c11503, c11516, c11612, c11625, c11888, c11891, c12001, c12009, c12020, c12035, c12051, c12052, c12123, c12306, c12321, c12345, c12553, c12715, c12781, c12890, c13000, c13308, c13337, c13371, c13381, c13396, c13473, c13812, c13838, c14000, c14324, c14333, c14853, c15003, c15056, c15104, c15535, c15551, c15555, c15557, c16000, c16001, c16507, c16688, c16718, c16888, c17000, c17001, c17026, c17171, c17172, c17180, c17186, c17217, c17511, c17777, c18000, c18105, c18109, c18122, c18159, c18181, c18231, c18233, c18303, c18686, c18889, c18898, c19011, c19112, c19224, c19527, c19683, c19845, c20001, c20139, c20141, c20519, c20729, c20736, c20765, c20948, c21004, c21133, c21337, c21758, c21816, c21912, c22023, c22040, c22222, c22324, c22662, c22776, c22886, c22985, c23006, c23118, c23294, c23295, c23444, c23812, c23888, c23934, c24070, c24347, c24484, c24538, c24545, c24668, c24734, c24867, c25186, c25839, c25888, c25925, c26026, c26031, c26600, c26863, c27827, c28106, c28528, c28982, c29112, c29442, c29548, c29645, c29830, c30067, c30103, c30226, c30266, c30891, c30915, c31102, c31223, c31224, c31337, c31414, c31415, c31646, c32001, c32277, c32517, c32520, c32659, c32769, c32990, c33101, c33210, c33333, c33385, c33448, c33469, c33909, c34295, c34443, c35011, c35395, c35439, c35441, c35443, c35730, c36530, c36695, c36746, c36908, c37195, c37375, c37767, c38085, c38400, c38401, c39098, c39142, c39747, c39797, c39815, c40542, c40798, c40868, c41077, c41425, c41500, c41604, c41799, c42069, c42161, c42170, c42220, c42261, c42262, c42355, c42451, c42766, c42801, c42840, c42888, c43110, c43111, c43113, c43114, c43125, c43288, c43851, c44444, c44445, c44787, c44808, c44850, c45000, c45454, c45510, c45544, c46092, c46688, c47805, c48137, c48267, c48702, c49049, c49053, c49088, c49321, c49797, c50001, c50005, c50006, c50021, c50059, c50528, c51161, c51178, c51277, c51712, c51740, c52014, c52146, c52150, c53123, c53277, c53383, c53935, c54211, c54321, c54356, c54414, c54763, c55004, c55555, c55556, c56288, c56400, c56525, c56570, c56789, c56797, c56914, c57000, c57021, c57522, c57973, c58008, c58064, c59069, c59140, c59141, c59144, c59185, c59944, c59971, c60000, c60001, c60002, c60103, c60834, c60841, c61205, c61258, c61406, c61514, c61551, c61800, c61803, c61916, c62049, c62278, c62320, c62621, c63000, c63001, c63079, c63367, c63891, c64165, c64273, c64361, c65044, c65300, c65450, c65842, c66042, c66063, c66904, c66988, c67390, c67451, c67588, c68007, c68295, c68770, c68976, c69399, c69420, c69740, c69743, c70000, c70001, c70002, c70038, c70103, c70341, c70466, c70700, c71111, c71169, c71393, c71401, c71402, c72605, c72709, c72778, c72877, c72992, c73114, c73115, c73677, c73799, c73927, c74356, c74738, c75000, c75817, c76950, c77001, c77238, c77552, c77612, c77777, c78110, c78170, c78281, c78430, c78431, c78432, c78600, c78933, c79338, c79879, c80001, c80002, c80085, c80096, c80182, c80375, c80719, c81041, c81079, c81341, c81342, c81343, c81351, c81352, c81353, c81361, c81362, c81363, c81457, c81573, c81720, c82368, c82459, c82552, c82807, c83414, c83862, c83872, c83900, c84531, c84532, c84623, c84886, c85023, c85449, c85678, c86663, c87460, c87815, c88002, c88018, c88817, c88819, c88880, c88882, c88883, c88888, c89283, c89327, c90210, c91002, c91003, c91041, c91120, c91132, c91558, c91715, c91735, c92001, c92496, c92780, c92850, c92978, c93017, c93572, c93625, c93694, c94158, c94565, c94918, c95395, c96552, c96809, c96970, c97288, c97622, c98540, c98557, c99099, c99132, c99181, c99308, c99733, c99947, c99998, c99999, c100000, c100001, c100002, c100003, c100004, c100005, c100006, c100007, c100008, c100009, c100010, c100100, c101010, c102031, c103090, c103454, c105105, c108801, c110000, c110001, c110002, c110003, c110004, c110005, c110006, c110007, c110008, c111000, c111111, c111188, c112358, c119139, c123456, c128123, c131419, c132902, c141221, c142857, c151221, c167004, c167008, c167009, c188710, c188881, c200101, c200202, c200625, c200810, c200901, c201018, c201030, c201804, c202020, c202212, c202401, c202624, c204005, c205205, c210425, c210815, c220315, c221230, c221231, c222555, c222666, c224168, c224422, c224433, c230315, c234560, c234666, c246529, c246785, c247253, c256256, c266256, c271271, c281121, c282828, c313313, c314159, c323213, c330844, c331769, c331771, c332323, c333313, c333331, c333333, c333666, c333777, c333888, c333999, c355113, c363636, c373737, c381931, c381932, c404040, c420420, c420666, c420692, c421611, c421613, c421614, c424242, c431140, c431188, c432201, c432204, c444444, c444900, c471100, c473861, c474142, c512512, c513100, c534351, c534352, c534353, c534354, c534849, c535037, c555666, c622277, c641230, c651940, c660279, c660868, c666666, c666888, c686868, c696969, c710420, c713715, c743111, c751230, c761412, c764984, c776877, c800001, c808080, c810180, c810182, c827431, c846000, c855456, c879151, c888888, c894538, c900000, c910000, c912559, c914031, c920000, c920001, c923018, c928010, c929038, c933326, c946751, c950375, c951083, c955081, c955305, c961256, c978993, c988207, c991424, c993535, c999511, c1100789, c1127469, c1261120, c1313114, c1313500, c1337702, c1337802, c1337803, c1440002, c1731313, c2021398, c2099156, c2125031, c2203181, c2206132, c2611555, c3132023, c3141592, c3441005, c3441006, c4000003, c4281033, c5151706, c5167003, c5167004, c5201420, c5555555, c5555558, c6038361, c7225878, c7355310, c7668378, c7762959, c7777777, c8007736, c8080808, c8794598, c8888881, c8888888, c9322252, c9322253, c10067275, c10101010, c11155111, c11155420, c13371337, c14288640, c16658437, c18289463, c20180427, c20180430, c20181205, c20201022, c20240324, c20482050, c22052002, c27082017, c27082022, c28122024, c28945486, c29032022, c31415926, c35855456, c37084624, c43214913, c61717561, c65010000, c65010001, c65010002, c65100000, c65100001, c65100002, c68840142, c77787778, c88888888, c94204209, c99415706, c123420111, c161221135, c168587773, c192837465, c222000222, c245022926, c245022934, c245022940, c278611351, c311752642, c333000333, c344106930, c356256156, c476158412, c486217935, c503129905, c666666666, c888888888, c889910245, c974399131, c999999999, c1020352220, c1122334455, c1146703430, c1273227453, c1313161554, c1313161555, c1313161556, c1313161560, c1350216234, c1351057110, c1380012617, c1380996178, c1444673419, c1482601649, c1517929550, c1564830818, c1666600000, c1666600001, c1666600002, c1666600003, c1666700000, c1666700001, c1666900000, c1666900001, c1918988905, c2021121117, c2046399126, c2863311531, c3125659152, c4216137055, c11297108099, c11297108109, c28872323069, c37714555429, c47279324479, c88153591557, c107107114116, c111222333444, c197710212030, c197710212031, c383414847825, c666301171999, c6022140761023, c868455272153094];
let _chainsById;
let _chainIdsBySlug;
function getChainsById() {
  if (_chainsById) {
    return _chainsById;
  }
  _chainsById = {};
  allChains.forEach(chain => {
    _chainsById[chain.chainId] = chain;
  });
  return _chainsById;
}
function getChainIdsBySlug() {
  if (_chainIdsBySlug) {
    return _chainIdsBySlug;
  }
  _chainIdsBySlug = {};
  allChains.forEach(chain => {
    _chainIdsBySlug[chain.slug] = chain.chainId;
  });
  return _chainIdsBySlug;
}
function isValidChainId(chainId) {
  const chainsById = getChainsById();
  return chainId in chainsById;
}
function isValidChainSlug(slug) {
  const chainIdsBySlug = getChainIdsBySlug();
  return slug in chainIdsBySlug;
}

/**
 * @deprecated use `getChainByChainIdAsync()` instead
 */
function getChainByChainId(chainId) {
  if (isValidChainId(chainId)) {
    const chainsById = getChainsById();
    return chainsById[chainId];
  }
  throw new Error(`Chain with chainId "${chainId}" not found`);
}

/**
 * @deprecated use `getChainBySlugAsync()` instead
 */
function getChainBySlug(slug) {
  if (isValidChainSlug(slug)) {
    const chainIdsBySlug = getChainIdsBySlug();
    const chainsById = getChainsById();
    return chainsById[chainIdsBySlug[slug]];
  }
  throw new Error(`Chain with slug "${slug}" not found`);
}

export { c595 as AcalaMandalaTestnetTc9, c787 as AcalaNetwork, c597 as AcalaNetworkTestnet, c7576 as AdilChainV2, c123456 as AdilDevnet, c7575 as AdilTestnet, c84886 as AerieNetwork, c788 as AerochainTestnet, c9990 as AgungNetwork, c1319 as Aia, c1320 as AiaTestnet, c168 as AiozNetwork, c4102 as AiozNetworkTestnet, c16718 as Airdao, c22040 as AirdaoTestnet, c200625 as Akroma, c201018 as Alaya, c201030 as AlayaDevTestnet, c2089 as Algol, c651940 as All, c21133 as AllAboutHealthy, c8738 as AlphNetwork, c111222333444 as Alphabet, c2088 as Altair, c2330 as Altcoinchain, c420692 as AlteriumL2Testnet, c9997 as AltlayerTestnet, c4000003 as AltlayerZeroGasNetwork, c3797 as Alveychain, c25839 as AlveychainTestnet, c1314 as Alyx, c135 as AlyxChainTestnet, c8134 as Amana, c81342 as AmanaMixnet, c81343 as AmanaPrivnet, c81341 as AmanaTestnet, c880 as AmbrosChain, c180 as AmeChain, c78430 as AmplifySubnet, c1388 as Amstar, c1138 as AmstarTestnet, c888888888 as Ancient8, c28122024 as Ancient8Testnet, c2863311531 as Ancient8TestnetDeprecated, c14288640 as Anduschain, c2202 as Antofy, c23006 as AntofyTestnet, c1701 as AnytypeEvmChain, c2662 as Apex, c3993 as ApexTestnet, c61717561 as Aquachain, c42161 as Arbitrum, c88153591557 as ArbitrumBlueberry, c421613 as ArbitrumGoerli, c42170 as ArbitrumNova, c200 as ArbitrumOnXdai, c421611 as ArbitrumRinkeby, c421614 as ArbitrumSepolia, c1243 as Arc, c1244 as ArcTestnet, c118 as ArcologyTestnet, c5616 as ArcturusChainTestnet, c5615 as ArcturusTestneet, c7895 as ArdeniumAthena, c463 as AreonNetwork, c462 as AreonNetworkTestnet, c2309 as Arevia, c160 as ArmoniaEvaChain, c161 as ArmoniaEvaChainTestnet, c10242 as Arthera, c10243 as ArtheraTestnet, c246529 as ArtisSigma1, c246785 as ArtisTestnetTau1, c456 as ArzioChain, c592 as Astar, c3776 as AstarZkevm, c6038361 as AstarZkyoto, c11110 as Astra, c11115 as AstraTestnet, c912559 as AstriaEvmDusknet, c1971 as Atelier, c12020 as Aternos, c1620 as Atheios, c43110 as Athereum, c2340 as AtletaTestnet, c167 as AtoshiTestnet, c1313161554 as Aurora, c1313161556 as AuroraBetanet, c1313161555 as AuroraTestnet, c205205 as AuroriaTestnet, c45000 as AutobahnNetwork, c65010001 as AutonityBakerlooBaradaTestnet, c65010002 as AutonityBakerlooSumidaTestnet, c65010000 as AutonityBakerlooThamesTestnet, c65100001 as AutonityPiccadillyBaradaTestnet, c65100002 as AutonityPiccadillySumidaTestnet, c65100000 as AutonityPiccadillyThamesTestnet, c28945486 as AuxiliumNetwork, c43114 as Avalanche, c43113 as AvalancheFuji, c33333 as Aves, c333331 as AvesTestnet, c634 as Avocado, c61800 as AxelchainDevNet, c5106 as AzraTestnet, c1123 as B2HabitatTestnet, c1113 as B2HubHabitatTestnet, c5165 as Bahamut, c876 as BandaiNamcoResearchVerse, c8453 as Base, c84531 as BaseGoerli, c84532 as BaseSepoliaTestnet, c1515 as BeagleMessagingChain, c4337 as Beam, c13337 as BeamTestnet, c535037 as BeanecoSmartchain, c641230 as BearNetworkChain, c751230 as BearNetworkChainTestnet, c818 as BeoneChain, c80085 as BerachainArtio, c2022 as BeresheetBereevmTestnet, c9012 as Berylbit, c90210 as BeverlyHills, c11501 as Bevm, c1501 as BevmCanary, c11503 as BevmTestnet, c22985 as BeyondSepolia, c59185 as BeyondchainTestnet, c3068 as Bifrost, c49088 as BifrostTestnet, c2137 as Bigshortbets, c56 as Binance, c97 as BinanceTestnet, c198 as Bitchain, c1907 as Bitcichain, c1908 as BitcichainTestnet, c8086 as BitcoinChain, c2203 as BitcoinEvm, c355113 as BitfinityNetworkTestnet, c32520 as Bitgert, c188710 as BiticaChain, c4099 as Bitindi, c4096 as BitindiTestnet, c96 as BitkubChain, c25925 as BitkubChainTestnet, c200901 as Bitlayer, c200810 as BitlayerTestnet, c210 as Bitnet, c7171 as Bitrock, c7771 as BitrockTestnet, c3690 as Bittex, c199 as BittorrentChain, c1028 as BittorrentChainTestnet, c2999 as Bityuan, c808080 as BizSmartChainTestnet, c4999 as BlackfortExchangeNetwork, c4777 as BlackfortExchangeNetworkTestnet, c238 as Blast, c81457 as BlastBlastmainnet, c168587773 as BlastSepoliaTestnet, c23888 as BlastTestnet, c12321 as BlgTestnet, c1343 as BlitzSubnet, c10101 as BlockchainGenesis, c707 as BlockchainStation, c708 as BlockchainStationTestnet, c8272 as BlocktonBlockchain, c879151 as Blocx, c333313 as BloomGenesis, c323213 as BloomGenesisTestnet, c8995 as Bloxberg, c727 as Blucrates, c1108 as Blxq, c1107 as BlxqTestnet, c188 as Bmc, c189 as BmcTestnet, c43288 as BobaAvax, c56288 as BobaBnb, c97288 as BobaBnbOld, c9728 as BobaBnbTestnet, c288 as BobaNetwork, c2888 as BobaNetworkGoerliTestnet, c28 as BobaNetworkRinkebyTestnet, c1297 as BobabaseTestnet, c1294 as Bobabeam, c4328 as BobafujiTestnet, c301 as Bobaopera, c4051 as BobaoperaTestnet, c2300 as BombChain, c2399 as BombChainTestnet, c1898 as BonNetwork, c77001 as Borachain, c99308 as BorneGamingTestnet, c2151 as Bosagora, c3637 as Botanix, c3636 as BotanixTestnet, c6000 as BouncebitTestnet, c434 as Boyaa, c279 as BpxBlockchain, c12123 as BrcChain, c108801 as Brochain, c1039 as Bronos, c1038 as BronosTestnet, c21912 as Bsl, c7007 as BstChain, c1657 as Btachain, c963 as Btc20SmartChain, c19845 as BtcixNetwork, c1582 as BubsTestnet, c2125031 as BubsTestnetBubs, c78431 as BulletinSubnet, c21004 as C4ei, c72778 as CagaCryptoAnkaraTestnet, c820 as Callisto, c20729 as CallistoTestnet, c821 as CallistoTestnetDeprecated, c95 as Camdl, c395 as CamdlTestnet, c20001 as Camelark, c500 as CaminoCChain, c534 as Candle, c7700 as Canto, c7701 as CantoTesnet, c740 as CantoTestnet, c3003 as Canxium, c9790 as CarbonEvm, c9792 as CarbonEvmTestnet, c6102 as CascadiaTestnet, c2032 as Catalyst, c1618 as CatecoinChain, c42220 as Celo, c44787 as CeloAlfajoresTestnet, c62320 as CeloBaklavaTestnet, c21337 as CennznetAzalea, c3001 as CennznetNikau, c3000 as CennznetRata, c2031 as Centrifuge, c30103 as CeriumTestnet, c5555 as ChainVerse, c1351057110 as ChaosSkaleTestnet, c5104 as CharmverseTestnet, c777 as Cheapeth, c831 as CheckdotBlockchainDevnet, c88888 as ChilizChain, c88880 as ChilizScovilleTestnet, c1353 as CicChain, c1252 as CicChainTestnet, c31223 as Cloudtx, c31224 as CloudtxTestnet, c33210 as CloudverseSubnet, c2009 as Cloudwalk, c2008 as CloudwalkTestnet, c1023 as CloverTestnet, c1024 as ClvParachain, c256256 as Cmp, c512512 as CmpTestnet, c9223 as Codefin, c2828 as CohanSTestnet1, c57522 as CohanTest, c70466 as CohanTest3, c36695 as CohanYoloTestnet, c112 as Coinbit, c52 as CoinexSmartChain, c53 as CoinexSmartChainTestnet, c501 as ColumbusTestNetwork, c9980 as Combo, c91715 as ComboTestnet, c6779 as Compverse, c188881 as CondorTestNetwork, c69420 as Condrieu, c78432 as ConduitSubnet, c224433 as ConetHolesky, c224422 as ConetSeboliaTestnet, c1030 as ConfluxEspace, c71 as ConfluxEspaceTestnet, c38400 as Connectormanager, c38401 as ConnectormanagerRobin, c371 as ConstaTestnet, c5103 as CoordinapeTestnet, c1116 as CoreBlockchain, c1115 as CoreBlockchainTestnet, c67588 as CosmicChain, c323 as Cosvm, c44 as CrabNetwork, c4400 as CreditSmartChain, c13308 as CreditSmartChainCredit, c102031 as CreditcoinTestnet, c25 as Cronos, c338 as CronosTestnet, c282 as CronosZkevmTestnet, c3737 as Crossbell, c4157 as CrossfiTestnet, c193 as CryptoEmergency, c10823 as Cryptocoinpay, c103090 as Crystaleum, c1455 as CtexScanBlockchain, c1818 as CubeChain, c1819 as CubeChainTestnet, c827431 as Curve, c1146703430 as Cyberdecknet, c85449 as Cybertrust, c6661 as Cybria, c6666 as CybriaTestnet, c1951 as DChain, c46 as DarwiniaNetwork, c43 as DarwiniaPangolinTestnet, c45 as DarwiniaPangoroTestnet, c2021121117 as Datahopper, c142 as DaxChain, c67 as DbchainTestnet, c136 as Deamchain, c236 as DeamchainTestnet, c116 as Debank, c20240324 as DebankSepoliaTestnet, c2021398 as DebankTestnet, c115 as DebankTestnetDeprecated, c30915 as DeboardSTestnet, c3306 as DebounceSubnetTestnet, c910 as DecentraboneLayer1Testnet, c19224 as DecentraconnectSocial, c124 as DecentralizedWeb, c75 as DecimalSmartChain, c202020 as DecimalSmartChainTestnet, c45510 as Deelance, c222555 as Deepl, c222666 as DeeplTestnet, c138 as DefiOracleMeta, c2138 as DefiOracleMetaTestnet, c1130 as DefichainEvmNetwork, c1131 as DefichainEvmNetworkTestnet, c1133 as DefimetachainChangiTestnet, c666666666 as DegenChain, c113 as Dehvo, c9393 as DelaSepoliaTestnet, c100100 as DeprecatedChi, c2357 as DeprecatedKromaSepolia, c344106930 as DeprecatedSkaleCalypsoHubTestnet, c476158412 as DeprecatedSkaleEuropaHubTestnet, c503129905 as DeprecatedSkaleNebulaHubTestnet, c1517929550 as DeprecatedSkaleTitanHubTestnet, c432204 as DexalotSubnet, c432201 as DexalotSubnetTestnet, c1954 as DexillaTestnet, c877 as DexitNetwork, c53935 as DfkChain, c335 as DfkChainTest, c6363 as DigitSoulSmartChain, c363636 as DigitSoulSmartChain2, c15 as DiodePrenet, c13 as DiodeTestnetStaging, c513100 as Dischain, c68770 as Dm2Verse, c855456 as Dodao, c1117 as Dogcoin, c9339 as DogcoinTestnet, c2000 as Dogechain, c568 as DogechainTestnet, c9888 as Dogelayer, c1248 as Dogether, c53277 as Doid, c56797 as DoidTestnet, c61916 as DokenSuperChain, c1717 as DoricNetwork, c7979 as DosChain, c1311 as DosFujiSubnet, c3939 as DosTesnet, c512 as DoubleAChain, c513 as DoubleAChainTestnet, c2611555 as DpuChain, c3912 as DracNetwork, c8387 as DraconesFinancialServices, c72709 as DragonTestnet, c78281 as DragonflyHexapod, c3269 as DubxcoinNetwork, c3270 as DubxcoinTestnet, c36 as Dxchain, c72 as DxchainTestnet, c1100 as Dymension, c3966 as Dyno, c3967 as DynoTestnet, c8087 as EDollar, c2306 as EbroNetwork, c17172 as EclipseSubnet, c555666 as EclipsechainTestnet, c2100 as Ecoball, c2101 as EcoballTestnetEspuma, c63000 as Ecredits, c63001 as EcreditsTestnet, c988207 as EcroxChain, c1995 as EdexaTestnet, c2021 as EdgewareEdgeevm, c5439 as Egochain, c271 as Egoncoin, c271271 as EgoncoinTestnet, c612 as Eiob, c1994 as Ekta, c22 as ElaDidSidechain, c23 as ElaDidSidechainTestnet, c20 as ElastosSmartChain, c21 as ElastosSmartChainTestnet, c1967 as Eleanor, c52014 as Electroneum, c5201420 as ElectroneumTestnet, c990 as Eliberty, c99099 as ElibertyTestnet, c2731 as ElizabethTestnet, c7027 as EllaTheHeart, c64 as Ellaism, c955305 as EluvioContentFabric, c2907 as EluxChain, c1339 as Elysium, c1338 as ElysiumTestnet, c4544 as EmoneyNetworkTestnet, c3693 as EmpireNetwork, c648 as EnduranceSmartChain, c39797 as Energi, c49797 as EnergiTestnet, c246 as EnergyWebChain, c73799 as EnergyWebVoltaTestnet, c131 as EngramTestnet, c48 as EnnothemProterozoic, c49 as EnnothemTestnetPioneer, c1214 as Enterchain, c119 as Enuls, c120 as EnulsTestnet, c59 as EosEvmLegacy, c17777 as EosEvmNetwork, c15557 as EosEvmNetworkTestnet, c5197 as Eraswap, c9911 as Espento, c1 as Ethereum, c61 as EthereumClassic, c1617 as EthereumInscription, c1987 as Ethergem, c101 as Etherinc, c128123 as EtherlinkTestnet, c111 as EtherliteChain, c31102 as EthersocialNetwork, c1313114 as EthoProtocol, c61803 as Etica, c131419 as EtndChainS, c1008 as Eurus, c1984 as EurusTestnet, c2213 as Evanesco, c1201 as EvanescoTestnet, c9001 as Evmos, c9000 as EvmosTestnet, c9395 as Evoke, c31414 as EvokeTestnet, c14324 as EvolveTestnet, c1010 as EvriceNetwork, c22052002 as Excelon, c27082022 as ExcoincialChain, c27082017 as ExcoincialChainVoltaTestnet, c2109 as ExosamaNetwork, c2 as ExpanseNetwork, c65044 as Exr0314Testnet, c1229 as ExzoNetwork, c2612 as EzchainCChain, c2613 as EzchainCChainTestnet, c530 as FXCoreNetwork, c127 as Factory127, c868 as FantasiaChain, c250 as Fantom, c64165 as FantomSonicBuildersTestnet, c4002 as FantomTestnet, c4090 as FastexChainBahamutOasisTestnet, c424242 as FastexChainTestnet, c26026 as FerrumTestnet, c12306 as Fibonacci, c314 as Filecoin, c3141592 as FilecoinButterflyTestnet, c314159 as FilecoinCalibrationTestnet, c3141 as FilecoinHyperspaceTestnet, c31415926 as FilecoinLocalTestnet, c31415 as FilecoinWallabyTestnet, c191 as Filefilego, c2152 as Findora, c2154 as FindoraForge, c2153 as FindoraTestnet, c529 as Firechain, c5290 as FirechainOld, c814 as FirechainZkevm, c3885 as FirechainZkevmGhostrider, c78110 as FirenzeTestNetwork, c29032022 as Flachain, c220 as Flag, c1220 as FlagTestnet, c8135 as Flana, c81352 as FlanaMixnet, c81353 as FlanaPrivnet, c81351 as FlanaTestnet, c14 as Flare, c114 as FlareTestnetCoston2, c747 as Flowevm, c646 as FlowevmPreviewnet, c73 as Fncy, c923018 as FncyTestnet, c132902 as FormTestnet, c35395 as Found1423, c18105 as FoundTest, c431188 as FoundationTestnet, c77238 as FoundryChainTestnet, c6565 as FoxTestnetNetwork, c68840142 as FrameTestnet, c252 as Fraxtal, c2522 as FraxtalTestnet, c211 as FreightTrustNetwork, c44444 as Frenchain, c18000 as FrontierOfDreamsTestnet, c21758 as Fst0116Multi, c94158 as Fst1222V1, c78933 as Fst1222V2, c308 as FurtheonNetwork, c122 as Fuse, c123 as FuseSparknet, c32659 as Fusion, c46688 as FusionTestnet, c17171 as G8chain, c18181 as G8chainTestnet, c696969 as GaladrielDevnet, c5777 as Ganache, c90 as GarizonStage0, c91 as GarizonStage1, c92 as GarizonStage2, c93 as GarizonStage3, c900 as GarizonTestnetStage0, c901 as GarizonTestnetStage1, c902 as GarizonTestnetStage2, c903 as GarizonTestnetStage3, c86 as Gatechain, c85 as GatechainTestnet, c486217935 as GatherDevnetNetwork, c192837465 as GatherNetwork, c356256156 as GatherTestnetNetwork, c1777 as Gauss, c516 as GearZeroNetwork, c266256 as GearZeroNetworkTestnet, c80 as Genechain, c9100 as GenesisCoin, c29 as GenesisL1, c26 as GenesisL1Testnet, c16507 as Genesys, c59971 as GenesysCode, c428 as GesoVerse, c42801 as GesotenVerseTestnet, c8989 as GiantMammoth, c1452 as GilTestnet, c1881 as GitshockCartenzTestnet, c28872323069 as GitswarmTestNetwork, c101010 as GlobalTrustNetwork, c4893 as GlobelChain, c100 as Gnosis, c10200 as GnosisChiadoTestnet, c60 as Gochain, c31337 as GochainTestnet, c71402 as Godwoken, c71401 as GodwokenTestnetV1, c868455272153094 as GodwokenTestnetV1GwTestnetV1Deprecated, c5 as Goerli, c4653 as GoldChain, c6789 as GoldSmartChain, c79879 as GoldSmartChainTestnet, c20948 as Goldfever, c42355 as Goldxchain, c22324 as GoldxchainTestnet, c10024 as GonChain, c33 as Gooddata, c32 as GooddataTestnet, c614 as GraphlinqBlockchain, c72992 as GrokChain, c1000 as Gton, c50021 as GtonTestnet, c71111 as Guapcoinx, c49321 as GunzTestnet, c803 as Haic, c1280 as Halo, c25888 as HammerChain, c8794598 as Hapchain, c373737 as HapchainTestnet, c54211 as HaqqChainTestnet, c11235 as HaqqNetwork, c197710212031 as HaradevTestnet, c1666900000 as HarmonyDevnetShard0, c1666900001 as HarmonyDevnetShard1, c1666600000 as HarmonyShard0, c1666600001 as HarmonyShard1, c1666600002 as HarmonyShard2, c1666600003 as HarmonyShard3, c1666700000 as HarmonyTestnetShard0, c1666700001 as HarmonyTestnetShard1, c11119 as Hashbit, c230315 as HashkeyChainTestnet, c810 as Haven1Testnet, c234666 as HaymoTestnet, c7878 as HazlorTestnet, c295 as Hedera, c298 as HederaLocalnet, c297 as HederaPreviewnet, c296 as HederaTestnet, c8668 as HelaOfficialRuntime, c666888 as HelaOfficialRuntimeTestnet, c7118 as HelpTheHomeless, c43111 as HemiNetwork, c743111 as HemiSepolia, c26600 as HertzNetwork, c269 as HighPerformanceBlockchain, c710 as Highbury, c5729 as HikaNetworkTestnet, c80096 as Hizoco, c8080808 as Hokum, c20482050 as HokumTestnet, c17000 as Holesky, c19011 as HomeVerse, c70 as HooSmartChain, c170 as HooSmartChainTestnet, c7332 as HorizenEon, c1663 as HorizenGobiTestnet, c4444 as Htmlcoin, c1992 as HubbleExchange, c1273227453 as HumanProtocol, c5234 as Humanode, c14853 as HumanodeTestnet5Israfel, c1089 as HumansAi, c4139 as HumansAiTestnet, c128 as HuobiEcoChain, c256 as HuobiEcoChainTestnet, c2468 as HybridChainNetwork, c2458 as HybridChainNetworkTestnet, c1224 as HybridTestnet, c2911 as Hychain, c29112 as HychainTestnet, c400 as HyperonchainTestnet, c881 as Hypr, c882 as HyprTestnet, c622277 as Hypra, c73115 as IcbNetwork, c73114 as IcbTestnet, c3639 as IchainNetwork, c142857 as Icplaza, c74 as Idchain, c134 as IexecSidechain, c3100 as Immu3Evm, c13371 as ImmutableZkevm, c15003 as ImmutableZkevmDevnet, c13473 as ImmutableZkevmTestnet, c9819 as Imperium, c9818 as ImperiumTestnet, c5555555 as Imversed, c5555558 as ImversedTestnet, c2525 as Inevm, c68007 as InfraTestnet, c129 as InnovatorChain, c54414 as InnovoMarketsTestnet, c18289463 as Iolite, c1197 as IoraChain, c8822 as IotaEvm, c4689 as IotexNetwork, c4690 as IotexNetworkTestnet, c1122334455 as IposNetwork, c6688 as Irishub, c16688 as IrishubTestnet, c16888 as IvarChainTestnet, c35011 as J2oTaro, c72605 as JambonSDevnet, c4905 as JambonSTestnet, c30891 as JambonSTestnetJambon_s_testnet, c53383 as JambonSTestnetJambon_s_testnet53383, c54356 as JambonSTestnetJambon_s_testnet54356, c66988 as JanusTestnet, c81 as JapanOpenChain, c10081 as JapanOpenChainTestnet, c202624 as Jellie, c3501 as JfinChain, c8899 as JibchainL1, c11227 as JiritsuTestnet, c70038 as JohnSTestnet, c20765 as Jono11Subnet, c955081 as Jono12Subnet, c1392 as Joseon, c3666 as Jouleverse, c35855456 as JoysDigital, c99415706 as JoysDigitalTestnet, c1009 as Jumbochain, c668 as Juncachain, c669 as JuncachainTestnet, c2718 as KLaos, c104 as KaibaLightningChainTestnet, c61406 as Kaichain, c107107114116 as KakarotSepolia, c1379 as KalarChain, c654 as Kalichain, c653 as KalichainTestnet, c3888 as Kalychain, c3889 as KalychainTestnet, c222000222 as Kanazawa, c2410 as Karak, c2511 as KarakGoerli, c8054 as KarakSepolia, c24 as Kardiachain, c686 as KaruraNetwork, c596 as KaruraNetworkTestnet, c2222 as Kava, c2221 as KavaTestnet, c321 as Kcc, c322 as KccTestnet, c420420 as Kekchain, c420666 as KekchainKektest, c1804 as Kerleano, c1337802 as Kiln, c2425 as KingOfLegendsDevnet, c7887 as Kinto, c42888 as KintoTestnet, c1337702 as Kintsugi, c2037 as KiwiSubnet, c23812 as KjcohanTestnet, c56914 as Kk1223, c8217 as KlaytnCypress, c1001 as KlaytnTestnetBaobab, c44808 as KlcohanTestnet, c7331 as Klyntar, c17217 as Konet, c2559 as Kortho, c8285 as Korthotest, c6 as KottiTestnet, c2241 as KrestNetwork, c255 as Kroma, c2358 as KromaSepolia, c1998 as KyotoTestnet, c225 as Lachain, c274 as LachainLachain, c226 as LachainTestnet, c92001 as LambdaTestnet, c764984 as Lamina1Testnet, c667 as LaosArrakis, c9898 as LarissaChain, c172 as LatamBlockchainResilTestnet, c6660 as LatestChainTestnet, c418 as Latestnet, c17186 as LazyCrimsonCoral, c1891 as LightlinkPegasusTestnet, c1890 as LightlinkPhoenix, c163 as Lightstreams, c162 as LightstreamsTestnet, c59144 as Linea, c59141 as LineaSepolia, c59140 as LineaTestnet, c84 as LinqtoDevnet, c1662 as Liquichain, c25186 as Liquidlayer, c93572 as LiquidlayerTestnet, c385 as Lisinski, c4202 as LiskSepoliaTestnet, c50001 as LiveplexOracleevm, c1440 as LivingAssets, c1337 as Localhost, c15551 as Loopnetwork, c5151706 as LootChain, c730 as LovelyNetwork, c307 as LovelyNetworkTestnet, c800 as LucidBlockchain, c998 as LuckyNetwork, c1688 as Ludan, c42 as Lukso, c4201 as LuksoTestnet, c51178 as LumozTestnetAlpha, c721 as LycanChain, c957 as LyraChain, c2121 as MTest11032, c786 as MaalChain, c7860 as MaalchainTestnet, c19527 as MagnetNetwork, c43214913 as Maistestsubnet, c8898 as Mammoth, c169 as MantaPacific, c3441006 as MantaPacificSepoliaTestnet, c3441005 as MantaPacificTestnet, c96970 as MantisTestnetHexapod, c5000 as Mantle, c5003 as MantleSepoliaTestnet, c5001 as MantleTestnet, c22776 as MapProtocol, c212 as MapoMakalu, c431140 as MarkrGo, c8848 as MaroBlockchain, c220315 as Mas, c3454 as Masa, c13396 as MasaNetwork, c103454 as MasaTestnet, c1139 as Mathchain, c1140 as MathchainTestnet, c898 as MaxiChainTestnet, c10201 as Maxxchain, c29548 as MchVerse, c8029 as MdglTestnet, c333000333 as Meld, c985 as MemoSmartChain, c1909 as MerkleScan, c4200 as Merlin, c600 as MeshnyanTestnet, c571 as Metachain, c1453 as MetachainIstanbul, c112358 as MetachainOne, c91120 as MetadapEnterprise, c119139 as MetadapEnterpriseTestnet, c11 as Metadium, c12 as MetadiumTestnet, c16000 as Metadot, c16001 as MetadotTestnet, c381931 as MetalCChain, c381932 as MetalTahoeCChain, c2122 as Metaplayerone, c2124 as MetaplayeroneDubaiTestnet, c53123 as Metasky, c82 as Meter, c83 as MeterTestnet, c1088 as MetisAndromeda, c599 as MetisGoerliTestnet, c588 as MetisStardustTestnet, c7518 as MeverseChain, c4759 as MeverseChainTestnet, c28106 as MezzanineTestnet, c761412 as MiexsSmartchain, c12001 as MikiasSTestnet, c2002 as MilkomedaA1, c200202 as MilkomedaA1Testnet, c2001 as MilkomedaC1, c200101 as MilkomedaC1Testnet, c9322253 as Milvine, c9996 as MindSmartChain, c9977 as MindSmartChainTestnet, c1687 as MintSepoliaTestnet, c1686 as MintTestnet, c1080 as Mintara, c1079 as MintaraTestnet, c24734 as MintmeComCoin, c76 as Mix, c73927 as MixinVirtualMachine, c8136 as Mizana, c81362 as MizanaMixnet, c81363 as MizanaPrivnet, c81361 as MizanaTestnet, c1099 as Moac, c201 as MoacTestnet, c34443 as Mode, c919 as ModeTestnet, c776877 as Modularium, c6022140761023 as MolereumNetwork, c1287 as MoonbaseAlpha, c1284 as Moonbeam, c5167004 as MoonchainGenevaTestnet, c1285 as Moonriver, c1288 as Moonrock, c1286 as MoonrockOld, c2199 as MoonsamaNetwork, c62 as MordenTestnet, c63 as MordorTestnet, c2710 as MorphTestnet, c2049 as MovoSmartChain, c63079 as Mt11212, c62621 as Multivac, c80001 as Mumbai, c956 as MunodeTestnet, c7762959 as Musicoin, c4078 as Muster, c5167003 as MxcWannseeZkevmTestnet, c18686 as MxcZkevmMoonchain, c78170 as MxsGamesTestnet, c9999 as MyownTestnet, c201804 as MythicalChain, c5551 as Nahmii, c4061 as Nahmii3, c4062 as Nahmii3Testnet, c5553 as NahmiiTestnet, c399 as Nativ3, c333333 as Nativ3Testnet, c22222 as Nautilus, c88002 as NautilusProteusTestnet, c91002 as NautilusTritionChain, c397 as Near, c398 as NearTestnet, c107 as NebulaTestnet, c245022934 as NeonEvm, c245022926 as NeonEvmDevnet, c245022940 as NeonEvmTestnet, c259 as Neonlink, c9559 as NeonlinkTestnet, c977 as NepalBlockchainNetwork, c1100789 as NetmindChainTestnet, c266 as Neura, c268 as NeuraDevnet, c267 as NeuraTestnet, c313 as Neurochain, c303 as NeurochainTestnet, c197 as NeutrinosTestnet, c91132 as NewWillSTestnet, c1012 as Newton, c1007 as NewtonTestnet, c9025 as NexaBlock, c9024 as NexaTestnetBlock, c4242 as Nexi, c4243 as NexiV2, c85023 as NishiogikuboSubnet, c5051 as NollieSkatechainTestnet, c81041 as Nordek, c87 as NovaNetwork, c197710212030 as Ntity, c10507 as Numbers, c10508 as NumbersTestnet, c7100 as Nume, c42262 as OasisEmerald, c42261 as OasisEmeraldTestnet, c23294 as OasisSapphire, c23295 as OasisSapphireTestnet, c26863 as Oasischain, c248 as Oasys, c660868 as OcashTestnet, c800001 as Octaspace, c156 as OeblockTestnet, c39815 as Oho, c65 as OkexchainTestnet, c66 as Okxchain, c1246 as OmPlatform, c311 as Omax, c21816 as Omchain, c408 as Omega, c166 as Omni, c165 as OmniTestnet, c2342 as OmniaChain, c5042 as Omochi, c311752642 as Oneledger, c4216137055 as OneledgerTestnetFrankenstein, c5039 as OnigiriTestSubnet, c58 as Ontology, c5851 as OntologyTestnet, c1975 as OnusChain, c1945 as OnusChainTestnet, c333777 as OoneChainDevnet, c333666 as OoneChainTestnet, c970 as Oort, c972 as OortAscraeus, c9700 as OortDev, c971 as OortHuygens, c123420111 as OpCelestiaRasberry, c11155420 as OpSepoliaTestnet, c8882 as OpalTestnetByUnique, c204 as Opbnb, c5611 as OpbnbTestnet, c474142 as Openchain, c776 as OpenchainTestnet, c7798 as OpenexLongTestnet, c54 as Openpiece, c141 as OpenpieceTestnet, c7355310 as Openvessel, c23118 as OpsideTestnet, c10 as Optimism, c28528 as OptimismBedrockGoerliAlphaTestnet, c420 as OptimismGoerli, c69 as OptimismKovan, c62049 as OptopiaTestnet, c537 as Optrust, c5317 as OptrustTestnet, c41500 as OpulentXBeta, c987 as OrangeTestnet, c291 as Orderly, c4460 as OrderlySepoliaTestnet, c7778 as OreniumProtocol, c8890 as OreniumTestnetProtocol, c1170 as OriginTestnet, c2043 as OrigintrailParachain, c3031 as OrlandoChain, c126 as Oychain, c125 as OychainTestnet, c4000 as OzoneChain, c401 as OzoneChainTestnet, c20736 as P12Chain, c1718 as PaletteChain, c17180 as PaletteChainTestnet, c11297108109 as Palm, c11297108099 as PalmTestnet, c3601 as Pandoproject, c3602 as PandoprojectTestnet, c3400 as ParibuNet, c3500 as ParibuNetTestnet, c1773 as Partychain, c789 as Patex, c471100 as PatexSepoliaTestnet, c542 as PawchainTestnet, c6701 as Paxb, c666301171999 as Pdc, c6502 as Peerpay, c42069 as Pegglecoin, c20201022 as PegoNetwork, c13371337 as PepchainChurchill, c411 as PepeChain, c9779 as Pepenetwork, c4001 as PeperiumChainTestnet, c222 as Permission, c424 as PgnPublicGoodsNetwork, c2035 as PhalaNetwork, c4181 as PhiNetworkV1, c144 as PhiNetworkV2, c13381 as Phoenix, c30067 as PieceTestnet, c3125659152 as Pirl, c6626 as PixieChain, c666 as PixieChainTestnet, c7070 as Planq, c210425 as Platon, c2206132 as PlatonDevTestnet2, c2203181 as PlatonDevTestnetDeprecated, c3011 as Playa3ullGames, c12781 as PlaydappTestnet, c2099156 as PlianMain, c8007736 as PlianSubchain1, c16658437 as PlianTestnetMain, c10067275 as PlianTestnetSubchain1, c242 as Plinga, c161221135 as PlumeTestnet, c99 as PoaNetworkCore, c77 as PoaNetworkSokol, c2606 as Pocrnet, c333999 as Polis, c333888 as PolisTestnet, c137 as Polygon, c80002 as PolygonAmoyTestnet, c94204209 as PolygonBlackberry, c11891 as PolygonSupernetArianee, c1101 as PolygonZkevm, c2442 as PolygonZkevmCardonaTestnet, c1442 as PolygonZkevmTestnet, c1402 as PolygonZkevmTestnetOld, c1422 as PolygonZkevmTestnetPreAuditUpgraded, c71393 as PolyjuiceTestnet, c6999 as Polysmartchain, c331771 as Pop, c1213 as Popcateum, c909 as PortalFantasyChain, c808 as PortalFantasyChainTest, c920000 as PosichainDevnetShard0, c920001 as PosichainDevnetShard1, c900000 as PosichainShard0, c910000 as PosichainTestnetShard0, c1313161560 as Powergold, c78 as Primuschain, c88883 as ProjOrcTestnetAlpha, c234560 as ProjectOrc, c18159 as ProofOfMemes, c70700 as ProofOfPlayApex, c331769 as ProofofpepeTestnet, c234 as ProtojumboTestnet, c110 as ProtonTestnet, c1031 as ProxyNetworkTestnet, c17511 as Pst11724, c889910245 as PtcescanTestnet, c2020 as Publicmint, c2018 as PublicmintDevnet, c2019 as PublicmintTestnet, c369 as Pulsechain, c940 as PulsechainTestnet, c941 as PulsechainTestnetV2b, c942 as PulsechainTestnetV3, c943 as PulsechainTestnetV4, c157 as PuppynetShibarium, c35441 as Q, c83414 as QIm2402132, c35443 as QTestnet, c22662 as Qa50307Testnet, c9872 as Qauser0507Testnet, c36746 as Qauser1213Testnet, c66904 as Qauser1335Testnet, c87460 as Qauser1360Testnet, c70341 as Qauser1957Testnet, c96809 as Qauser2368Testnet, c54763 as Qauser3051Testnet, c1962 as Qauser3295Testnet, c66063 as Qauser3324Testnet, c77552 as Qauser3673Testnet, c7909 as Qauser3870Testnet, c43125 as Qauser3950Testnet, c20519 as Qauser4113Testnet, c65842 as Qauser4143Testnet, c39747 as Qauser41testnet, c80719 as Qauser4301Testnet, c52146 as Qauser4359Testnet, c32517 as Qauser4536Testnet, c24867 as Qauser45Testnet, c65300 as Qauser46Testnet, c92978 as Qauser4903Testnet, c24668 as Qauser4994Testnet, c7872 as Qauser4Testnet, c9294 as Qauser4TestnetQauser4_testnet, c18898 as Qauser4TestnetQauser4_testnet18898, c56525 as Qauser4TestnetQauser4_testnet56525, c71169 as Qauser4TestnetQauser4_testnet71169, c72877 as Qauser4TestnetQauser4_testnet72877, c51740 as Qauser4testnet, c56570 as Qauser4testnetQauser4testnet, c7317 as Qauser5017Testnet, c40868 as Qauser5110Testnet, c57973 as Qauser5524Testnet, c49053 as Qauser5759Testnet, c67451 as Qauser6097Testnet, c61205 as Qauser6116Testnet, c29830 as Qauser6165Testnet, c29645 as Qauser6355Testnet, c45544 as Qauser6609Testnet, c99733 as Qauser6779Testnet, c86663 as Qauser7218Testnet, c18109 as Qauser7737Testnet, c7507 as Qauser7740Testnet, c61258 as Qauser7821Testnet, c26031 as Qauser7894Testnet, c59944 as Qauser7920Testnet, c64361 as Qauser8734Testnet, c24545 as Qauser9167Testnet, c73677 as Qauser9318Testnet, c31646 as Qauser9492Testnet, c50528 as Qauser9606Testnet, c48137 as Qauser9608Testnet, c99181 as Qauser9727Testnet, c9528 as Qeasyweb3Testnet, c69399 as Qi0103i1, c61514 as Qi011624i1, c50059 as Qi0122i1Testnet, c83900 as Qi0122i1TestnetQi0122i1_testnet, c85678 as Qi0122i1TestnetQi0122i1_testnet85678, c97622 as Qi0130i1, c48267 as Qi0130i2, c7640 as Qi0205i1, c82552 as Qi0209i2, c58064 as Qi0209i3, c46092 as Qi0213i1, c99132 as Qi0222i1, c93625 as Qi0222i2, c38085 as Qi0227i1, c52150 as Qi0304i1Testnet, c11198 as Qi0304i2Testnet, c89327 as Qi0304i3Testnet, c19112 as Qi0304s1Testnet, c1614 as Qi0305i1Testnet, c24070 as Qi0315i2Testnet, c44850 as Qi0318i1Testnet, c91041 as Qi0318i1TestnetQi0318i1_testnet, c96552 as Qi032924Testnet, c51277 as Qi0344s1Testne, c66042 as Qi0408i1Testnet, c68976 as Qi0408s1Testnet, c33448 as Qi0408s2Testnet, c332323 as Qi0408s3devTestnet, c62278 as Qi1121i1, c76950 as Qi1204i2, c17026 as Qi1204i3, c4145 as Qi1212i2, c92850 as Qi1212i3, c98540 as Qi1212i5, c51161 as Qi1212i6, c40542 as Qi1212i8, c42451 as Qi1220s1, c91735 as Qi1228i2, c39098 as Qi20240108, c15535 as QiM11271, c12035 as QiM11272, c80182 as QiM12051, c10671 as QiM12131, c11625 as QiM202402121, c81079 as QiM21343243, c35439 as QiM2401122, c84623 as QiM2401221, c7207 as QiM2401222, c93694 as QiM2401291, c15056 as QiM2402052, c92780 as QiM2402053, c15104 as QiM2402054, c29442 as QiM2402055, c87815 as QiM2402056, c37375 as QiM2402057, c32277 as QiM2402058, c60834 as QiM2402059, c88018 as QiM2402131, c34295 as QiM2402132, c24538 as QiM2402133, c99947 as QiM2402141, c23444 as QiM2402272, c7326 as QiM2403051Testnet, c57021 as Qim2403061, c81573 as Qis0311Testnet, c93017 as Qis0313Testnet, c89283 as Qis0326Testnet, c813 as QitmeerNetwork, c8132 as QitmeerNetworkMixnet, c8133 as QitmeerNetworkPrivnet, c8131 as QitmeerNetworkTestnet, c766 as Ql1, c7668378 as Ql1Testnet, c80375 as Qr0103y1s, c40798 as Qr0109y1p, c82368 as Qr0116s1, c68295 as Qr0116y1s, c79338 as Qr0122i1Testnet, c20139 as Qr0129i1, c98557 as Qr0201i1, c41425 as Qr0205i1, c951083 as Qr0205y1s, c950375 as Qr0209y1s, c991424 as Qr0213y1s, c946751 as Qr0214y1p, c929038 as Qr0215y1mp, c999511 as Qr0227t1ts, c61551 as Qr0304t1tsTestnet, c8154 as Qr0318sgcp, c978993 as Qr0318t1tsTestnet, c933326 as Qr0326t2tsTestnet, c961256 as Qr0326t4tsTestnet, c10050 as Qr0327s1dTestnet, c914031 as Qr0408t1tsTestnet, c928010 as Qr0408t2tsTestnet, c993535 as Qr1120y1, c35730 as Qr1129i1, c36908 as Qr1205s1, c10946 as QuadransBlockchain, c10947 as QuadransBlockchainTestnet, c81720 as QuantumChain, c12890 as QuantumChainTestnet, c44445 as QuantumNetwork, c8888888 as Quarix, c8888881 as QuarixTestnet, c20181205 as Quarkblockchain, c110000 as QuarkchainDevnetRoot, c110001 as QuarkchainDevnetShard0, c110002 as QuarkchainDevnetShard1, c110003 as QuarkchainDevnetShard2, c110004 as QuarkchainDevnetShard3, c110005 as QuarkchainDevnetShard4, c110006 as QuarkchainDevnetShard5, c110007 as QuarkchainDevnetShard6, c110008 as QuarkchainDevnetShard7, c100000 as QuarkchainRoot, c100001 as QuarkchainShard0, c100002 as QuarkchainShard1, c100003 as QuarkchainShard2, c100004 as QuarkchainShard3, c100005 as QuarkchainShard4, c100006 as QuarkchainShard5, c100007 as QuarkchainShard6, c100008 as QuarkchainShard7, c8881 as QuartzByUnique, c2077 as Quokkacoin, c7484 as RabaNetwork, c1807 as RabbitAnalogTestnetChain, c2025 as RangersProtocol, c9527 as RangersProtocolTestnetRobin, c1380996178 as Raptorchain, c1380012617 as Rari, c1918988905 as RarichainTestnet, c278611351 as RazorSkaleChain, c111188 as ReAl, c121 as Realchain, c41077 as Really, c64273 as ReallyReally, c221230 as Reapchain, c221231 as ReapchainTestnet, c151 as RedbellyNetwork, c152 as RedbellyNetworkDevnet, c153 as RedbellyNetworkTestnet, c154 as RedbellyNetworkTge, c1972 as Redecoin, c2611 as RedlightChain, c17001 as RedstoneHoleskyTestnet, c33909 as Reg1116test, c5810 as RegTnet, c55555 as ReiChain, c55556 as ReiChainTestnet, c47805 as ReiNetwork, c63367 as Resft11624, c75000 as Resincoin, c1729 as ReyaNetwork, c1433 as RikezaNetwork, c12715 as RikezaNetworkTestnet, c917 as RiniaTestnet, c9170 as RiniaTestnetOld, c4 as Rinkeby, c7777 as RiseOfTheWarbotsTestnet, c158 as Roburna, c159 as RoburnaTestnet, c570 as Rollux, c57000 as RolluxTestnet, c30 as Rootstock, c31 as RootstockTestnet, c3 as Ropsten, c12553 as Rss3Vsl, c2331 as Rss3VslSepoliaTestnet, c1821 as RubySmartChain, c1912 as RubySmartChainTestnet, c822 as RunicChainTestnet, c499 as Rupaya, c799 as RupayaTestnet, c74356 as STestnet1524, c7225878 as Saakuru, c247253 as SaakuruTestnet, c3132023 as SaharaaiNetwork, c313313 as SaharaaiTestnet, c1022 as Sakura, c94918 as SampleTestnet, c11888 as SantimentIntelligenceNetwork, c8883 as SapphireByUnique, c51712 as Sardis, c11612 as SardisTestnet, c12009 as Satoshichain, c5758 as SatoshichainTestnet, c1985 as Satoshie, c1986 as SatoshieTestnet, c1911 as Scalind, c60841 as ScgK, c69743 as ScgKScgK, c65450 as Scolcoin, c6552 as ScolcoinWeichainTestnet, c742 as ScriptTestnet, c534352 as Scroll, c534353 as ScrollAlphaTestnet, c534354 as ScrollPreAlphaTestnet, c534351 as ScrollSepoliaTestnet, c34 as Securechain, c3434 as SecurechainTestnet, c186 as Seele, c713715 as SeiDevnet, c1961 as SelendraNetwork, c1953 as SelendraNetworkTestnet, c3699 as Senjepowers, c3698 as SenjepowersTestnet, c11155111 as Sepolia, c58008 as SepoliaPgnPublicGoodsNetwork, c258 as Setheum, c75817 as Sft1824, c8080 as ShardeumLiberty1X, c8081 as ShardeumLiberty2X, c8082 as ShardeumSphinx1X, c20141 as ShelbySTestnet, c91558 as ShelbySTestnet118, c1506 as Sherpax, c1507 as SherpaxTestnet, c27 as Shibachain, c109 as Shibarium, c719 as ShibariumBeta, c336 as Shiden, c9008 as ShidoBlock, c9007 as ShidoTestnetBlock, c148 as Shimmerevm, c1073 as ShimmerevmTestnet, c1071 as ShimmerevmTestnetDeprecated, c1072 as ShimmerevmTestnetDeprecated1072, c214 as Shinarium, c534849 as ShinariumBeta, c11221 as ShineChain, c2044 as ShrapnelSubnet, c2038 as ShrapnelTestnet, c7341 as Shyft, c11437 as ShyftTestnet, c111111 as SiberiumNetwork, c111000 as SiberiumTestNetwork, c5102 as SicTestnet, c12052 as SingularityZero, c12051 as SingularityZeroTestnet, c67390 as Siriusnet, c217 as SiriusnetV2, c98 as SixProtocol, c150 as SixProtocolTestnet, c10086 as Sjatsh, c1564830818 as SkaleCalypsoHub, c974399131 as SkaleCalypsoHubTestnet, c2046399126 as SkaleEuropaHub, c1444673419 as SkaleEuropaHubTestnet, c1482601649 as SkaleNebulaHub, c37084624 as SkaleNebulaHubTestnet, c1350216234 as SkaleTitanHub, c1020352220 as SkaleTitanHubTestnet, c10000 as SmartBitcoinCash, c10001 as SmartBitcoinCashTestnet, c1177 as SmartHostTeknolojiTestnet, c5169 as SmartLayerNetwork, c82459 as SmartLayerNetworkTestnet, c18122 as SmartTradeNetworks, c20180430 as Smartmesh, c281121 as SocialSmartChain, c2332 as SomaNetwork, c2323 as SomaNetworkTestnet, c19 as SongbirdCanaryNetwork, c16 as SongbirdTestnetCoston, c145 as SoraaiTestnet, c68 as Soterone, c218 as SoteroneOld, c10101010 as Soverun, c88882 as SpicyChain, c1904 as SportsChainNetwork, c13000 as Sps, c14000 as SpsTestnet, c7865 as St0207, c23934 as St1116V7Regression, c19683 as St1207V1, c83862 as St1212V1, c59069 as St1212V2, c39142 as StFound10524, c20180427 as StabilityTestnet, c700 as StarSocialTestnet, c210815 as StavaxTestnet, c1234 as StepNetwork, c12345 as StepTestnet, c8726 as Storagechain, c8727 as StoragechainTestnet, c105105 as Stratis, c2048 as Stratos, c2047 as StratosTestnet, c8098 as StreamuxBlockchain, c208 as Structx, c1970 as SuperSmartChain, c1969 as SuperSmartChainTestnet, c5105 as SuperloyaltyTestnet, c8866 as Superlumio, c262 as SurBlockchainNetwork, c13812 as Susono, c45454 as SwampsL2, c2024 as SwanSaturnTestnet, c230 as Swapdex, c94 as Swissdlt, c1291 as SwisstronikTestnet, c416 as SxNetwork, c647 as SxNetworkTestnet, c1149 as SymplexiaSmartChain, c444 as SynapseChainTestnet, c510 as SyndicateChain, c5101 as SyndicateFrameChain, c5100 as SyndicateTestnet, c444444 as SyndrL3Sepolia, c57 as Syscoin, c5700 as SyscoinTanenbaumTestnet, c94565 as T0117, c88888888 as TEAMBlockchain, c1004 as TEkta, c224168 as TafEcoChain, c167004 as TaikoAlpha2Testnet, c167009 as TaikoHeklaL2, c167008 as TaikoKatlaL2, c3799 as TangleTestnet, c5678 as TanssiEvmContainerchain, c558 as TaoNetwork, c911 as Taproot, c841 as Taraxa, c842 as TaraxaTestnet, c22023 as Taycan, c2023 as TaycanTestnet, c1707 as Tbsi, c1708 as TbsiTestnet, c35 as TbwgChain, c2400 as TcgVerse, c2569 as Techpay, c1003 as TectumEmissionToken, c8000 as Teleport, c8001 as TeleportTestnet, c40 as TelosEvm, c41 as TelosEvmTestnet, c443 as TenTestnet, c1559 as Tenet, c155 as TenetTestnet, c11516 as Tenzro, c1856 as Teslafunds, c28982 as Testnet, c8181 as TestnetBeoneChain, c7158 as TestnetFirsttest, c41604 as TestnetTestnet, c48702 as TestnetTestnet48702, c74738 as TestnetTestnet74738, c92496 as TestnetTestnet92496, c95395 as TestnetTestnet95395, c56400 as TestnetZeroone, c7 as Thaichain, c17 as Thaichain20Thaifi, c37195 as Thari, c7668 as TheRootNetwork, c7672 as TheRootNetworkPorciniTestnet, c361 as Theta, c364 as ThetaAmberTestnet, c363 as ThetaSapphireTestnet, c365 as ThetaTestnet, c70000 as ThinkiumChain0, c70001 as ThinkiumChain1, c70103 as ThinkiumChain103, c70002 as ThinkiumChain2, c60000 as ThinkiumTestnetChain0, c60001 as ThinkiumTestnetChain1, c60103 as ThinkiumTestnetChain103, c60002 as ThinkiumTestnetChain2, c894538 as ThirdwebTestSubnet, c108 as Thundercore, c18 as ThundercoreTestnet, c710420 as Tiltyard, c1127469 as TiltyardSubnet, c404040 as Tipboxcoin, c4141 as TipboxcoinTestnet, c55004 as Titan, c18889 as TitanTkxTestnet, c5177 as TlchainNetwork, c8768 as TmyChain, c37767 as Tnet0115, c30266 as Tnet0206, c24347 as Tnet0227, c63891 as Tnetv2, c8654 as TokiNetwork, c8655 as TokiTestnet, c6969 as TombChain, c8723 as ToolGlobal, c8724 as ToolGlobalTestnet, c989 as Top, c980 as TopEvm, c77777 as Toronet, c54321 as ToronetTestnet, c8192 as Torus, c8194 as TorusTestnet, c3839 as TraderlandsSepolia, c1838 as TraderlandsTestnet, c5002 as TreasurenetAlpha, c5005 as TreasurenetTestnet, c6066 as Tres, c6065 as TresTestnet, c5353 as TritaniumTestnet, c15555 as TrustEvmTestnet, c330844 as TtcoinSmartChain, c1731313 as TurkeyDemoDev, c39 as U2uSolaris, c99999 as UbSmartChain, c99998 as UbSmartChainTestnet, c8 as Ubiq, c9 as UbiqNetworkTestnet, c473861 as UltraPro, c1231 as Ultron, c1230 as UltronTestnet, c2484 as UnicornUltraNebulasTestnet, c8880 as Unique, c88819 as UnitZeroStagenet, c88817 as UnitZeroTestnet, c18233 as Unreal, c18231 as UnrealOld, c117 as Uptick, c6119 as Uptn, c6118 as UptnTestnet, c5315 as UzmiNetwork, c38 as Valorbit, c78600 as Vanguard, c2223 as Vchain, c100009 as Vechain, c100010 as VechainTestnet, c555 as Vela1Chain, c106 as VelasEvm, c56789 as VeloLabs, c4919 as Venidium, c4918 as VenidiumTestnet, c77612 as VentionSmartChain, c741 as VentionSmartChainTestnet, c5522 as VexEvmTestnet, c88 as Viction, c89 as VictionTestnet, c601 as VineTestnet, c207 as VinuchainNetwork, c206 as VinuchainTestnet, c422 as Viridis, c224 as ViridisTestnet, c888888 as Vision, c666666 as VisionVpioneerTestChain, c1490 as Vitruveo, c14333 as VitruveoTestnet, c713 as Vrcscan, c3102 as VultureEvmBeta, c8889 as VyvoSmartChain, c32001 as W3gamezHoleskyTestnet, c11111 as Wagmi, c888 as Wanchain, c105 as Web3gamesDevnet, c102 as Web3gamesTestnet, c333 as Web3q, c3334 as Web3qGalileo, c3333 as Web3qTestnet, c24484 as Webchain, c444900 as WeelinkTestnet, c5869 as WegochainRubidium, c1111 as Wemix30, c1112 as Wemix30Testnet, c1875 as Whitechain, c2625 as WhitechainTestnet, c41799 as WillSNewTestnet, c36530 as WillSSuperSubnet, c3036 as WillSTestnet, c22886 as WillSTestnetWill_s_testnet, c30226 as WillSTestnetWill_s_testnet30226, c42840 as WillSTestnetWill_s_testnet42840, c69740 as WillSTestnetWill_s_testnet69740, c49049 as WireshapeFloripaTestnet, c686868 as WonNetwork, c139 as Woopchain, c1202 as WorldTradeTechnicalChain, c103 as Worldland, c10395 as WorldlandTestnet, c91003 as WorldsAppchain, c4281033 as WorldsCaldera, c309 as WyzthTestnet, c196 as X1, c202212 as X1Devnet, c4003 as X1Fastnet, c204005 as X1Network, c195 as X1Testnet, c660279 as Xai, c47279324479 as XaiGoerliOrbit, c37714555429 as XaiSepolia, c8888 as Xanachain, c151221 as Xantus, c141221 as XantusTestnet, c9322252 as Xcap, c51 as XdcApothemNetwork, c50 as XdcNetwork, c2941 as XenonChainTestnet, c1313500 as Xerom, c3084 as XlNetworkTestnet, c2415 as Xodex, c37 as Xpla, c47 as XplaTestnet, c3701 as XplaTestnetXplatest, c2730 as XrSepolia, c1440002 as XrpLedgerEvmDevnetSidechain, c520 as XtSmartChain, c13838 as XtraderlandsSubnetTesnet, c927 as YidarkChain, c202401 as YmtechBesuTestnet, c50005 as YooldoVerse, c50006 as YooldoVerseTestnet, c3999 as Yuanchain, c2016 as ZMainnet, c9768 as ZTestnet, c1369 as Zafirium, c3331 as ZcoreTestnet, c83872 as Zedxion, c427 as ZeethChain, c859 as ZeethChainDev, c383414847825 as Zeniq, c79 as Zenith, c27827 as Zeroone, c18303 as ZerooneTestnet, c7000 as Zetachain, c7001 as ZetachainAthens3Testnet, c82807 as ZfirstAvacloudSubnetThirdweb, c1337803 as Zhejiang, c282828 as ZillionSepoliaTestnet, c33469 as Zilliqa2EvmDevnet, c32769 as ZilliqaEvm, c33385 as ZilliqaEvmDevnet, c32990 as ZilliqaEvmIsolatedServer, c33101 as ZilliqaEvmTestnet, c381 as Zkamoeba, c380 as ZkamoebaTestnet, c1261120 as Zkatana, c42766 as Zkfair, c43851 as ZkfairTestnet, c810180 as ZklinkNova, c810182 as ZklinkNovaGoerliTestnet, c305 as Zksats, c324 as Zksync, c280 as ZksyncEraGoerliTestnetDeprecated, c300 as ZksyncSepoliaTestnet, c7777777 as Zora, c999999999 as ZoraSepoliaTestnet, c999 as ZoraTestnet, c9998 as Ztc, c55 as Zyx, c77787778 as _0xhashTestnet, c10248 as _0xtade, c846000 as _4goodnetwork, c997 as _5irechainThunder, allChains, configureChain, defaultChains, fetchChain, fetchChains, getChainByChainId, getChainByChainIdAsync, getChainBySlug, getChainBySlugAsync, getChainIdsBySlug, getChainRPC, getChainRPCs, getValidChainRPCs, minimizeChain, updateChainRPCs };
